import './assets/@global-configuration.css';
var Zg = Object.defineProperty;
var ex = (t, s, n) => s in t ? Zg(t, s, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[s] = n;
var gs = (t, s, n) => ex(t, typeof s != "symbol" ? s + "" : s, n);
import { j as e, d as it, a as tx, t as sx, b as nx, c as ax, r as rx, i as lt, R as ct, _ as ox, f as fm, p as ta, J as rn, e as Aa, g as hm, h as ix, k as lx, l as xo, m as cx } from "./@vendor-BxhYAQFM.js";
import dx, { useRef as de, useMemo as Q, useState as v, useEffect as J, Fragment as Nr, useCallback as gm, createContext as jc, useContext as Oc, Children as px, Component as ux, lazy as xm } from "react";
import { logExceptionToSentry as ka, CDMaterialResourceQuery as tn, TippyCustomized as Dt, TippyTheme as Mt, getAlphabetIcon as sa, ResourceVersionType as mt, ResourceKindType as ie, ROUTES as Ws, URLS as se, CIPipelineNodeType as mx, Button as j, ComponentSizeType as O, ButtonVariantType as w, ButtonStyleType as B, Tooltip as Ie, prefixZeroIfSingleDigit as Eo, API_TOKEN_PREFIX as Rc, DefaultUserKey as _x, stringComparatorBySortOrder as Ce, UserIdentifier as so, noop as Be, post as we, get as le, sanitizeApprovalConfigData as hi, showError as V, ApprovalRuntimeStateType as Em, Icon as W, ToastManager as Z, ToastVariantType as ee, FilterConditionType as Vs, put as Bt, trash as Js, DynamicDataTableRowDataType as ut, DEVTRON_AI_URL as Vl, useAsync as ne, TagsContainer as fx, validateTagKeyValue as hx, validateTagValue as gx, DTSwitch as Gn, InfoBlock as Ot, RJSFForm as la, HIDE_SUBMIT_BUTTON_UI_SCHEMA as Fa, PromoetheusConfigCard as xx, MarkDown as Cm, InfoBlockVariant as Wr, useMainContext as Is, useAnimationControls as Ex, isNullOrUndefined as Ht, motion as gi, Textarea as vn, SidePanelTab as Cx, GenericEmptyState as _e, Checkbox as $e, TriggerTypeMap as Jo, API_STATUS_CODES as Ns, DEPLOYMENT_WINDOW_TYPE as Zt, getUrlWithSearchParams as ye, getIsRequestAborted as Pe, ACTION_STATE as Pc, WorkflowNodeType as Ia, MODAL_TYPE as bm, FREQUENCY_ENUM as he, PRIVACY_POLICY_LINK as bx, EULA_LINK as Nx, DeploymentNodeType as Sa, STRATEGY_TYPE_TO_TITLE_MAP as Mn, useStateFilters as vs, ErrorScreenManager as Xe, SegmentedBarChart as Ra, SortableTableHeaderCell as Ne, AnimatedDeployButton as Tx, SelectPicker as Ve, SelectPickerVariantType as cn, getSelectPickerOptionByValue as wc, ServerErrors as Ua, ApiQueuingWithBatch as Tr, SourceTypeMap as Yl, VisibleModal2 as wi, stopPropagation as Le, CustomInput as yt, Drawer as $t, ConsequenceAction as Es, ZERO_TIME_STRING as fs, ManualApprovalType as is, parseRuntimeParams as Ix, parseDevtronLicenseData as vx, createResourceRequestBody as Dc, ALL_NAMESPACE_OPTION as Co, createNewResource as Nm, Progressing as Je, SearchBar as Wt, RadioGroup as ds, RadioGroupItem as Ze, GenericFilterEmptyState as qt, InfoIconTippy as ca, WorkflowOptionsModal as Ax, getAppsInfoForEnv as Sx, StatusType as Tm, CHECKBOX_VALUE as Fe, commonSelectStyles as qr, usePrompt as Di, VisibleModal as cs, ImageType as bs, DEFAULT_ROUTE_PROMPT_MESSAGE as Nn, EnvironmentSelector as yx, ConditionalWrap as An, PromiseAllStatusType as Mi, SortingOrder as Ut, APIResponseHandler as Ke, SegmentedControl as Qs, AnimatePresence as Im, ButtonComponentType as Re, BulkEditVersion as Lx, GenericSectionErrorState as ps, UserStatus as ce, UserStatusDto as Hl, DATE_TIME_FORMATS as Ir, getFormattedUTCTimeForExport as jx, UserTypeToFetchType as Wn, PolicyKindType as X, useQuery as Ox, useQueryClient as Rx, useMutation as Px, patch as na, PatchOperationType as Fn, getUserAndApiTokenOptions as vm, Backdrop as Mc, ConfirmationModal as zt, ConfirmationModalVariantType as Ct, useUrlFilters as _t, handleUTCTime as wx, getPolicyApiUrl as ks, SelectAllGroupedResourceIdentifiers as fn, useGetResourceKindsOptions as Am, validateDescription as dn, FilterChips as Ga, abortPreviousRequests as es, TOOLTIP_CONTENTS as vr, ERROR_STATUS_CODE as da, useBulkSelection as It, BulkSelectionEvents as st, ActionMenu as ki, BulkSelection as bo, DraggableWrapper as No, DraggablePositionVariant as To, DraggableButton as Fi, FilterSelectPicker as Ps, getParentPluginList as Sm, BulkSelectionProvider as Ui, SelectAllDialogStatus as Io, FeatureTitleWithInfo as kc, TabGroup as Ar, NestedBreadCrumb as Gi, validateName as Tn, highlightSearchText as aa, getDefaultDateFromTimeToLive as sn, DateTimePicker as tr, validateDateAndTime as Kl, getUniqueId as Yt, ACCESS_TYPE_MAP as ym, ActionTypes as Dx, BUILD_INFRA_TEXT as Mx, DEFAULT_PROFILE_NAME as ft, capitalizeFirstLetter as Ft, BUILD_INFRA_DEFAULT_PLATFORM_NAME as ht, BuildInfraLocators as ue, BUILD_INFRA_LOCATOR_LABEL_MAP as _r, BuildInfraToleranceOperatorType as fr, BuildInfraToleranceEffectType as cr, BuildInfraConfigTypes as bt, BUILD_INFRA_LOCATOR_MARKER_MAP as Lm, BUILD_INFRA_LOCATOR_CONFIG_TYPES_MAP as pa, INFRA_CONFIG_NOT_SUPPORTED_BY_BUILD_X as kx, parsePlatformConfigIntoValue as On, ConfigMapSecretReadyOnly as jm, INFRA_CONFIG_TO_CM_SECRET_COMPONENT_TYPE_MAP as Bi, CM_SECRET_STATE as Om, getParsedValueForUseK8sDriver as Fx, BuildInfraProfileVariants as Pa, INFRA_CONFIG_CONTAINING_SUB_VALUES as Ux, getDoesInfraConfigContainsSubValue as Gx, getBuildInfraProfileEndpoint as ra, createBuildInfraProfileService as Bx, BuildInfraProfileNameField as $x, BuildInfraProfileDescriptionField as Vx, BUILD_INFRA_LATEST_API_VERSION as Yx, getCommonSelectStyle as Rm, SELECT_ALL_ACROSS_PAGES_LOCATOR as us, NodeSelectorHeaderType as wn, ToleranceHeaderType as Jt, DEFAULT_TOLERANCE_OPERATOR as Hx, DEFAULT_TOLERANCE_EFFECT as Kx, BuildInfraProfileInputActionType as Ys, getBuildInfraInheritActionFromLocator as Wx, BUILD_INFRA_SUB_VALUES_INHERIT_ACTIONS as qx, useBuildInfraUtilityContext as zx, useForm as Pm, getConfigMapSecretFormValidations as Xx, DynamicDataTable as $i, NUMERIC_BUILD_INFRA_FORM_FIELD_CONFIGURATION_MAP as Jx, BuildInfraFormAction as Qx, CollapsibleList as Fc, getBuildInfraProfilePayload as Zx, TARGET_PLATFORM_ERROR_FIELDS_MAP as eE, UnsavedChanges as tE, deepEqual as sE, checkIfPathIsMatching as nE, BuildInfraProfileAdditionalErrorKeysType as aE, UnsavedChangesDialog as rE, FloatingVariablesSuggestions as oE, CMSecretComponentType as sp, CM_SECRET_COMPONENT_TYPE_TO_INFRA_CONFIG_MAP as iE, CM_SECRET_COMPONENT_TYPE_TO_LOCATOR_MAP as lE, preventDefault as wm, useBuildInfraForm as Dm, Pagination as vo, BuildInfraDescriptor as Uc, useSearchString as Gc, DeleteConfirmationModal as Sr, getBuildxDriverTypeFromUseK8sDriver as cE, ImageWithFallback as Bc, YAMLStringify as gt, getResourceApiUrl as Ba, DocLink as $a, TagDetails as dE, RegistryCredentialsType as sr, MODES as Ts, doesJSONConformToSchema07 as pE, validateYAML as uE, getGuiSchemaFromChartName as mE, getApplicationManagementBreadcrumb as $c, BreadcrumbText as Ao, YAMLtoJSON as _E, useBreadcrumb as yr, BreadCrumb as Lr, convertDeploymentChartListToChartType as fE, CodeEditor as Gt, DEVTRON_DEPLOYMENT_CHART_NAMES as hE, getInvalidTippyContent as Mm, InvalidTippyTypeEnum as np, WEEK_DAYS_ENUM as ya, getOrdinal as gE, getTimeStampAMPMSuffix as Uo, arrowUnicode as Ka, DEFAULT_TIME_OPTIONS as ap, MONTHLY_DATE_OPTIONS as rp, TimePickerSelect as Wa, MonthlySelect as op, UserListSortableKeys as xE, DEFAULT_BASE_PAGE_SIZE as km, ButtonWithLoader as Vi, sortCallback as EE, ErrorScreenNotAuthorized as Fm, GenericInfoCard as Go, GenericInfoCardBorderVariant as Vc, validateDisplayName as CE, ModalSidebarPanel as bE, getTemplateAPIRoute as Yc, GetTemplateAPIRouteType as Hc, EditableTextArea as NE, MAX_DESCRIPTION_LENGTH as ip, MESSAGES as TE, GenericDescription as IE, AppSelectorNoOptionsMessage as vE, AppSelectorDropdownIndicator as AE, ValueContainerWithLoadingShimmer as SE, APP_SELECTOR_STYLES as lp, PageHeader as Yi, DOCUMENTATION as Kc, DEFAULT_SECRET_PLACEHOLDER as xi, GitOpsAuthModeType as qa, getEmptyArrayOfLength as yE, getUserAndApiTokenOption as LE, getIsManualApprovalConfigured as jE, not as OE, ClipboardButton as Hi, copyToClipboard as Um, requiredField as Ln, ChartVersionAndTypeSelector as RE, getPluginsDetail as Gm, ApplyPolicyToStage as Pn, PluginImageContainer as Wc, DEFAULT_PLUGIN_LIST_FILTERS as PE, PluginListContainer as wE, DEFAULT_PLUGIN_DATA_STORE as DE, getUpdatedPluginStore as ME, DetectBottom as kE, LoadingIndicator as FE, ScopedVariablesFileViewType as dr, ConfigurationType as Bo, CONFIGURATION_TYPE_OPTIONS as Bm, KeyValueTable as UE, validateUniqueKeys as GE, numberComparatorBySortOrder as no, URLProtocolType as cp, validateProtocols as $o, AppThemeType as qc, PopupMenu as pr, getInferredTypeFromValueType as nr, convertJSONPointerToJSONPath as on, conformPathToPointers as BE, getRandomColor as $E, getRedirectionProps as VE, IframeContainer as YE, getGitCommitInfo as HE, GitCommitInfoGeneric as KE, ResourceRecommenderHeaderType as rt, getGroupVersionFromApiVersion as hr, GVK_FILTER_KIND_QUERY_PARAM_KEY as dp, GVK_FILTER_API_VERSION_QUERY_PARAM_KEY as pp, BulkOperations as So, cordonNodeCapacity as WE, drainNodeCapacity as qE, deleteNodeCapacity as zE, deleteResource as $m, NodeDrainOptions as XE, ForceDeleteOption as JE, DELETE_NODE_MODAL_MESSAGING as QE, DRAIN_NODE_MODAL_MESSAGING as Vm, CORDON_NODE_MODAL_MESSAGING as Wl, URL_FILTER_KEYS as ZE, getCookie as Ym, TOKEN_COOKIE_NAME as Hm, ClusterStatusType as eC, handleAnalyticsEvent as zc, Badge as Km, Nodes as ao, NumbersCount as tC, getInfrastructureManagementBreadcrumb as sC, VirtualizedList as Wm, getResourceGroupListRaw as up, getK8sResourceList as Ki, getK8sResourceListPayload as nC, UNSAVED_CHANGES_PROMPT_MESSAGE as aC, getClusterListRaw as rC, SCHEMA_07_VALIDATOR as oC, getIframeWithDefaultAttributes as qm, validateIframe as iC, getSanitizedIframe as lC, InstallationClusterStatus as Zs, getHandleOpenURL as cC, StatusComponent as zm, getComponentSpecificThemeClass as dC, ServerError as pC, TOAST_ACCESS_DENIED as mp, TableSignalEnum as _p, K8S_EMPTY_GROUP as uC, RESOURCE_BROWSER_ROUTES as mC, ResourceBrowserActionMenuEnum as _C, Table as fC, FiltersTypeEnum as hC, PaginationEnum as gC, LARGE_PAGE_SIZE_OPTIONS as fp, usePopover as xC, Popover as EC, ExportToCsv as CC, getTimeDifference as bC, Collapse as NC, useUserEmail as yo, ModuleNameMap as Xm, getIsMaterialInfoAvailable as Jm, ImageCard as Qm, ImageCardAccordion as Zm, FilterStates as as, EXCLUDED_IMAGE_TOOLTIP as za, ExcludedImageNode as TC, useGetUserRoles as e_, Reload as IC, genericCDMaterialsService as zr, CDMaterialServiceEnum as Xr, getDefaultConfig as Xc, getIsApprovalPolicyConfigured as ql, AddCDButton as hp, AddCDPositions as gp, handleAddCD as vC, TARGET_IDS as AC, ApprovalConfigDataKindType as Xn, sanitizeUserApprovalMetadata as SC, BASE_CONFIGURATION_ENV_ID as yC, DraftState as ro, useRegisterShortcut as LC, getConfirmationLabel as jC, hasHashiOrAWS as OC, CompareFromApprovalOptionsValuesType as zl, DTApplicationMetricsFormField as Xl, InvalidYAMLTippyWrapper as t_, getSchemaPathToUpdatePathMap as RC, GUIViewError as xp, joinObjects as Ei, buildObjectFromPath as Jc, getNullValueFromType as PC, flatMapOfJSONPaths as oo, recursivelyRemoveSymbolFromArraysInObject as s_, UNCHANGED_ARRAY_ELEMENT_SYMBOL as n_, applyCompareDiffOnUneditedDocument as wC, DEFAULT_LOCKED_KEYS_CONFIG as DC, DryRunEditorMode as Qo, ProtectConfigTabsType as Zo, ConfigToolbarPopupNodeType as hl, OverrideMergeStrategyType as MC, EMPTY_STATE_STATUS as a_, LoadingCard as kC, getSecurityModalSidebarId as FC, getSidebarData as UC, TreeView as GC, getSecurityModalSidebarChildFromId as BC, getSortedVulnerabilities as $C, DATE_TIME_FORMAT_STRING as VC, getTotalVulnerabilityCount as YC, parseGetResourceScanDetailsResponse as HC, ActivityIndicator as r_, ModuleStatus as KC, STAGE_TYPE as WC, isImageActiveOnEnvironment as qC, useDownload as o_, triggerCDNode as zC, getSecurityScan as XC, SecurityDetailsCards as JC, AppType as ei, K8sResourcePayloadAppType as Vo, LicenseStatus as Ep, getTTLInHumanReadableFormat as QC, LicenseInfoDialogType as Jn, ALLOW_ACTION_OUTSIDE_FOCUS_TRAP as ZC, OPEN_NEW_TICKET as eb, CONTACT_SUPPORT_LINK as i_, useTheme as tb, DevtronLicenseCard as sb, InstallationFingerprintInfo as nb, AboutDevtronBody as ab, DevtronProgressing as rb, ActivateLicenseDialog as ob, RefVariableType as Hs, VariableTypeFormat as En, PATTERNS as ib, SystemVariableIcon as lb, PluginType as Cp, IO_VARIABLES_VALUE_COLUMN_BOOL_OPTIONS as cb, IO_VARIABLES_VALUE_COLUMN_DATE_OPTIONS as db, getGlobalVariables as pb, FileConfigTippy as ub, getGoLangFormattedDateWithTimezone as mb, getStageTitle as Jl, updateUserPreferences as _b, ViewIsPipelineRBACConfiguredRadioTabs as Jr, getUserPreferences as fb } from "@devtron-labs/devtron-fe-common-lib";
import { ReactComponent as l_ } from "./assets/ic-exit-fullscreen.d20ef1b5.svg";
import { ReactComponent as c_ } from "./assets/ic-fullscreen.5e3d1964.svg";
import hb from "./assets/no-approved-images@2x.68e1cd3c.png";
import Ci from "./assets/no-artifact.fd2d84d9.webp";
import { ReactComponent as jr } from "./assets/ic-mechanical-operation.201add3a.svg";
import { ReactComponent as gr } from "./assets/ic-caret-left-small.eec57a21.svg";
import { ReactComponent as As } from "./assets/ic-close-large.7ae624ef.svg";
import { ReactComponent as qs } from "./assets/ic-check.73991ac2.svg";
import { ReactComponent as Va } from "./assets/ic-warning.ddd476e3.svg";
import { ReactComponent as Lo } from "./assets/ic-arrow-clockwise.80fd562b.svg";
import gb, { ReactComponent as vt } from "./assets/ic-close.40c46877.svg";
import { ReactComponent as Ms } from "./assets/ic-arrow-right.f942ee03.svg";
import { ReactComponent as Qc } from "./assets/ic-deploy-color.db04cea8.svg";
import { ReactComponent as xb } from "./assets/ic-hibernate-circle.f251f326.svg";
import { ReactComponent as Eb } from "./assets/ic-copy.0c429146.svg";
import { ReactComponent as bp } from "./assets/ic-env.9381cd8d.svg";
import { Link as wt, useHistory as Te, Prompt as jo, useParams as Ue, Switch as Vt, Route as ge, Redirect as ms, generatePath as Kt, useLocation as Ss, useRouteMatch as Wi } from "react-router-dom";
import { ReactComponent as Cb } from "./assets/ic-error.b0bbe394.svg";
import { ReactComponent as Zc } from "./assets/ic-medium-warning.410e7036.svg";
import { ReactComponent as d_ } from "./assets/ic-success.d61bac19.svg";
import { ReactComponent as bb } from "./assets/configuration-approval.b6cbf12c.svg";
import { ReactComponent as Nb } from "./assets/deployment-approval.025fae27.svg";
import { ReactComponent as ts } from "./assets/ic-delete-interactive.63fabf04.svg";
import { ReactComponent as Xt } from "./assets/ic-add.b1e7fd27.svg";
import { ReactComponent as Fs } from "./assets/ic-pencil.4b680b92.svg";
import p_ from "./assets/empty-person-with-pencil.974cc2fa.png";
import { ReactComponent as u_ } from "./assets/ic-caret-down.c459567f.svg";
import { ReactComponent as Tb } from "./assets/info-filled.6403bc82.svg";
import { ReactComponent as Ib } from "./assets/ic-user-status.a4df7cb5.svg";
import { ReactComponent as vb } from "./assets/build-infra-feature-description.cafd8402.svg";
import { ReactComponent as qi } from "./assets/ic-info-filled-new.28815384.svg";
import { ReactComponent as zi } from "./assets/ic-expand.94b0747c.svg";
import { ReactComponent as Ab } from "./assets/ic-file-code.80000c9b.svg";
import { ReactComponent as m_ } from "./assets/ic-file-text.5f928a8f.svg";
import { ReactComponent as bi } from "./assets/ic-link.87517174.svg";
import { ReactComponent as Sb } from "./assets/ic-link-broken.90e7b5c8.svg";
import { ReactComponent as ed } from "./assets/ic-world.23932d2f.svg";
import { ReactComponent as yb } from "./assets/ic-chipset.54af8ed9.svg";
import { ReactComponent as td } from "./assets/ic-visibility-on.c2c19305.svg";
import { ReactComponent as Lb } from "./assets/ic-medium-computer-chip.d4a0b0e8.svg";
import { ReactComponent as ua } from "./assets/ic-cross.54cad648.svg";
import sd, { components as nd } from "react-select";
import { ReactComponent as jb } from "./assets/ic-arrows-clockwise.424f0538.svg";
import { ReactComponent as Ob } from "./assets/ic-clear.020a0822.svg";
import { ReactComponent as __ } from "./assets/ic-medium-swap.64cd9a1a.svg";
import { ReactComponent as f_ } from "./assets/ic-medium-clean-brush.263acd35.svg";
import { ReactComponent as Rb } from "./assets/ic-devtron.a598b67f.svg";
import { ReactComponent as ad } from "./assets/ic-search.d31b1c9d.svg";
import { ReactComponent as h_ } from "./assets/ic-error-exclamation.f20b7033.svg";
import { ReactComponent as Pb } from "./assets/ic-tag.34388acc.svg";
import { ReactComponent as Ya } from "./assets/ic-help-outline.bd39bc26.svg";
import { ReactComponent as Np } from "./assets/inject-tag.2d765245.svg";
import { ReactComponent as wb } from "./assets/ic-arrow-counter-clockwise.e020e189.svg";
import Tp from "./assets/gui-preview-empty-state.46600513.png";
import { m as io, h as rd } from "./@moment-hdGw1hqW.js";
import { ReactComponent as Db } from "./assets/ic-alert-triangle.2ec06597.svg";
import Mb from "./assets/blackout-selection-window.41b95094.webp";
import kb from "./assets/maintenance-selection-window.392d804e.webp";
import { ReactComponent as Fb } from "./assets/ic-blackout-window.721874f5.svg";
import { ReactComponent as Oo } from "./assets/ic-gear.1d95843c.svg";
import { ReactComponent as Ub } from "./assets/ic-maintenance-window.5c0e183d.svg";
import { ReactComponent as Gb } from "./assets/ic-road-block.22ecc3f9.svg";
import { ReactComponent as Or } from "./assets/ic-info-outline.a2baf25b.svg";
import { ReactComponent as Bb } from "./assets/ic-chevron-down.c06b8238.svg";
import $b from "./assets/no-deployment-window.801c60c4.png";
import { ReactComponent as Vb } from "./assets/ic-deployment-window-blueprint.94df9c8d.svg";
import { ReactComponent as od } from "./assets/ic-devtron-app.fda22992.svg";
import { ReactComponent as id } from "./assets/ic-app-template.6ba10343.svg";
import { ReactComponent as Yb } from "./assets/ic-stamp-open.88860f97.svg";
import { ReactComponent as Xi } from "./assets/ic-users.5166c3cf.svg";
import { ReactComponent as ld } from "./assets/ic-timer.aa8f9398.svg";
import { ReactComponent as cd } from "./assets/ic-help.a75a7835.svg";
import { ReactComponent as Hb } from "./assets/ic-like.e042e09e.svg";
import { ReactComponent as Kb } from "./assets/ic-checks.9005997e.svg";
import { ReactComponent as g_ } from "./assets/ic-contract.e8987751.svg";
import { ReactComponent as Wb } from "./assets/image-promotion-blueprint.0435c154.svg";
import { ReactComponent as x_ } from "./assets/ic-info-filled.c412513b.svg";
import { ReactComponent as E_ } from "./assets/ic-file-lock.108cc3cd.svg";
import C_ from "./assets/configure-lock.6fdd2217.png";
import { ReactComponent as qb } from "./assets/lock-deployment-configuration.f6064e5f.svg";
import { ReactComponent as zb } from "./assets/ic-exclamation-box.24f5e3b7.svg";
import Xb from "./assets/plugin-policy-null-state.aaceca35.png";
import { ReactComponent as Jb } from "./assets/plugins-policy.2c8fd9a1.svg";
import { ReactComponent as Qb } from "./assets/ic-build-color.ac847ffd.svg";
import Zb from "./assets/no-offending-pipeline.9861878e.svg";
import { ReactComponent as eN } from "./assets/ic-allowed-with-warning.2a899039.svg";
import { ReactComponent as tN } from "./assets/ic-block-with-timer.a81202ea.svg";
import { ReactComponent as b_ } from "./assets/ic-prohibit.7027aa97.svg";
import { ReactComponent as sN } from "./assets/ic-file-badge.08d5bbea.svg";
import { ReactComponent as nN } from "./assets/ic-stamp-grey.a9af0fca.svg";
import aN from "./assets/person-on-rocket.f16cb83a.png";
import { ReactComponent as rN } from "./assets/ic-plain-filter.c0d83391.svg";
import { ReactComponent as oN } from "./assets/ic-info-filled-dark-bg.dad3b01a.svg";
import N_ from "./assets/group-similar.d1527089.png";
import { ReactComponent as Ni } from "./assets/ic-note.9de2ccc4.svg";
import { ReactComponent as iN } from "./assets/ic-add-circle.56a4f577.svg";
import Ql from "./assets/empty-folder.4570c4ae.webp";
import lN from "./assets/filter.b510db2f.png";
import { ReactComponent as cN } from "./assets/ic-sort-down.bc1cb8fa.svg";
import zs from "yaml";
import dN from "./assets/no-data-in-cloud.741541cd.webp";
import { ReactComponent as pN } from "./assets/ic-cloud.fb41a2cb.svg";
import { ReactComponent as T_ } from "./assets/ic-menu-dots.398f5cfa.svg";
import { ReactComponent as dd } from "./assets/ic-rocket.7be5910f.svg";
import { ReactComponent as Ti } from "./assets/ic-arrows-left-right.67c9617c.svg";
import { ReactComponent as uN } from "./assets/ic-select-cluster.5097f7a8.svg";
import { ReactComponent as mN } from "./assets/ic-exclamation.726da8b3.svg";
import { ReactComponent as _N } from "./assets/ic-dots-three-drag.befc4b4b.svg";
import { ReactComponent as fN } from "./assets/ic-grid-arrange.7b944ecd.svg";
import { ReactComponent as hN } from "./assets/monitoring-dashboard-empty-state.5fe7126d.svg";
import { ReactComponent as I_ } from "./assets/ic-lego-block.fbc1e062.svg";
import { ReactComponent as gN } from "./assets/ic-medium-upgrade.593bfd59.svg";
import { ReactComponent as xN } from "./assets/ic-error-prometheus.e11e05ff.svg";
import { ReactComponent as Ip } from "./assets/ic-person-writing.8e3a72c1.svg";
import { ReactComponent as EN } from "./assets/ic-clean-brush.260fd8ea.svg";
import { ReactComponent as CN } from "./assets/ic-pause.3b22cdeb.svg";
import { ReactComponent as bN } from "./assets/ic-play-outline.f1ff1196.svg";
import { ReactComponent as v_ } from "./assets/ic-medium-arrows-clockwise.444b2d18.svg";
import { ReactComponent as NN } from "./assets/ic-check-encircle.273a9a7f.svg";
import { ReactComponent as TN } from "./assets/ic-close-circle.e74bff5a.svg";
import { ReactComponent as A_ } from "./assets/ic-restore.e1ff823a.svg";
import S_ from "./assets/no-pending-action@2x.d2fb3b54.png";
import { ReactComponent as IN } from "./assets/ic-filter.72e53c00.svg";
import { ReactComponent as Zl } from "./assets/ic-promote-deployment.6aef61e3.svg";
import { ReactComponent as lo } from "./assets/ic-stamp.526499d2.svg";
import vN from "./assets/no-comments.5b278181.png";
import { ReactComponent as AN } from "./assets/ic-ses.c028e25f.svg";
import { ReactComponent as SN } from "./assets/ic-smtp.dce6a753.svg";
import { ReactComponent as vp } from "./assets/ic-checks-dashed-circle.2a95dda8.svg";
import { ReactComponent as yN } from "./assets/ic-help-filled.c5b6b8a9.svg";
import { ReactComponent as LN } from "./assets/ic-comment.768c0c0d.svg";
import { ReactComponent as jN } from "./assets/ic-comment-dot.8b3d7f8b.svg";
import { ReactComponent as ON } from "./assets/ic-clear-square.e60de021.svg";
import { ReactComponent as RN } from "./assets/ic-clock-counterclockwise.f22571a3.svg";
import { ReactComponent as PN } from "./assets/ic-more-options.367c039a.svg";
import { ReactComponent as wN } from "./assets/ic-visibility-off.52ef8139.svg";
import { ReactComponent as DN } from "./assets/ic-config-synced.de9693a4.svg";
import { ReactComponent as Ii } from "./assets/ic-out-of-sync.9a449d68.svg";
import { ReactComponent as MN } from "./assets/progressingShimmer.5f04c6d4.svg";
import { ReactComponent as kN } from "./assets/ic-bug.d056e059.svg";
import { ReactComponent as FN } from "./assets/ic-medium-swap-bg.e137495c.svg";
import { ReactComponent as y_ } from "./assets/ic-abort.5bbe3614.svg";
import { ReactComponent as L_ } from "./assets/ic-arrow-line-down.f554943b.svg";
import { ReactComponent as UN } from "./assets/ic-errorInfo.9fcb3d32.svg";
import GN from "./assets/active-latest.33674f1e.webp";
import { ReactComponent as BN } from "./assets/ic-filter-noapply.7beac020.svg";
import { ReactComponent as $N } from "./assets/ic-key-bulb.341bed4d.svg";
import { ReactComponent as VN } from "./assets/ic-empty-scan-disabled.a11e3997.svg";
import { ReactComponent as YN } from "./assets/ic-lines.9576a3b7.svg";
import { ReactComponent as HN } from "./assets/ic-maintenance.e5614017.svg";
import { ReactComponent as KN } from "./assets/ic-cd-stage.02f6fa9e.svg";
import { ReactComponent as WN } from "./assets/ic-calender-once.6309fa4f.svg";
import { ReactComponent as qN } from "./assets/ic-calender-recurring.ae17e560.svg";
import { ReactComponent as zN } from "./assets/info-filled-gray.fa1cf144.svg";
import { ReactComponent as XN } from "./assets/ic-arrow-square-out.5ad40e74.svg";
import { ReactComponent as JN } from "./assets/illustration-page-blocked.b4c20189.svg";
import { ReactComponent as QN } from "./assets/ic-arrow-backward.edab524e.svg";
var Ae = /* @__PURE__ */ ((t) => (t.REQUEST = "request", t.PENDING = "pending", t))(Ae || {}), ls = /* @__PURE__ */ ((t) => (t.BULK_DEPLOY = "bulk-deploy", t.IMAGE_PROMOTION = "image-promotion", t))(ls || {});
const qe = {
  NOT_CONFIGURED_EMPTY_STATE: {
    TITLE: "Image promotion is not configured",
    SUB_TITLE: "Please configure image promotion for this workflow to promote images."
  },
  REFRESH_LABEL: "Refresh Materials",
  SHOW_SEARCH_BAR: "Show search bar",
  SEARCH_IMAGE_TAG_PLACEHOLDER: "Search image tag",
  ENVIRONMENT_SELECTOR_LABEL: {
    [Ae.REQUEST]: {
      FROM_NO_ENVIRONMENT: "Show images from",
      FROM_ENVIRONMENT: "Show images passed from"
    },
    [Ae.PENDING]: "Show requests"
  },
  ENVIRONMENT_SELECTOR_GROUP_LABEL: {
    [ls.BULK_DEPLOY]: {
      [Ae.REQUEST]: "Image available at"
    },
    [ls.IMAGE_PROMOTION]: {
      [Ae.REQUEST]: "Passed from environments",
      [Ae.PENDING]: "Promotion requests for"
    }
  },
  ENVIRONMENT_SELECTOR_SHUTTER_LABEL: {
    [Ae.PENDING]: "All pending for me",
    [Ae.REQUEST]: {
      WEBHOOK: "External CI",
      CI: "CI Pipeline",
      LINKED_CI: "Linked CI",
      LINKED_CD: "Sync with Env",
      JOB_CI: "Job Pipeline"
    }
  },
  ENVIRONMENT_SELECTOR_SHUTTER_VALUE: {
    [Ae.REQUEST]: "Image source for workflow",
    [Ae.PENDING]: "All pending for me"
  },
  ENVIRONMENT_SELECTOR_SHUTTER_DESCRIPTION: {
    [Ae.REQUEST]: "Image source for workflow",
    [Ae.PENDING]: ""
  },
  ENVIRONMENT_SELECTOR_PLACEHOLDER: "Select environment",
  EMPTY_STATES: {
    [Ae.REQUEST]: {
      SOURCE: {
        TITLE: "No Image Available",
        SUBTITLE: "No images have been built/received from the connected CI Pipeline."
      },
      ENV: {
        TITLE: "No Image Available",
        getTitle: (t) => `No image available at '${t}'`,
        getSubtitle: (t, s) => {
          switch (s) {
            case ls.IMAGE_PROMOTION:
              return `No images have successfully passed all deployment stages for '${t}'`;
            case ls.BULK_DEPLOY:
              return "Images passed from the previous stage are available at a given stage";
            default:
              return ka(`Invalid type ${s} found for use image list type`), "No images available";
          }
        }
      }
    },
    [Ae.PENDING]: {
      SELF: {
        TITLE: "No image promotion requests pending for you",
        SUBTITLE: "You can view environment specific image promotion requests by switching context from the above dropdown."
      },
      ENV: {
        getTitle: (t) => `No image promotion requests pending for '${t}'`,
        SUBTITLE: "Images which are requested to be promoted to this environment will be available here."
      }
    },
    NO_ARTIFACT_SEARCH: {
      TITLE: "No artifacts Found",
      SUBTITLE: "We could not find any artifact matching given criteria"
    }
  },
  VIEW_OTHER_REQUESTS: "View other requests…",
  CLEAR_FILTERS: "Clear filters",
  NOT_AUTHORIZED: "You are not authorized to view this page"
}, kr = 20, ec = 0, ma = (t) => Array.from(t.entries()).reduce((s, [n, a]) => (s[n] = a, s), {}), ZN = (t, s, n) => n === ls.BULK_DEPLOY ? "" : t === Ae.PENDING ? qe.ENVIRONMENT_SELECTOR_LABEL[Ae.PENDING] : s ? qe.ENVIRONMENT_SELECTOR_LABEL[Ae.REQUEST].FROM_ENVIRONMENT : qe.ENVIRONMENT_SELECTOR_LABEL[Ae.REQUEST].FROM_NO_ENVIRONMENT, eT = (t, s, n, a) => {
  const o = Object.keys(t.environments).map((c) => ({
    value: c,
    label: c
  })).sort((c, d) => c.label.localeCompare(d.label)), i = {
    label: qe.ENVIRONMENT_SELECTOR_GROUP_LABEL[a][s],
    options: o
  };
  return [{
    label: "",
    options: [
      {
        label: s === Ae.PENDING ? qe.ENVIRONMENT_SELECTOR_SHUTTER_LABEL[Ae.PENDING] : n,
        value: qe.ENVIRONMENT_SELECTOR_SHUTTER_VALUE[s],
        description: qe.ENVIRONMENT_SELECTOR_SHUTTER_DESCRIPTION[s]
      }
    ]
  }, i];
}, j_ = (t) => {
  switch (t) {
    case tn.WEBHOOK:
      return qe.ENVIRONMENT_SELECTOR_SHUTTER_LABEL[Ae.REQUEST].WEBHOOK;
    case tn.LINKED_CI:
      return qe.ENVIRONMENT_SELECTOR_SHUTTER_LABEL[Ae.REQUEST].LINKED_CI;
    case tn.LINKED_CD:
      return qe.ENVIRONMENT_SELECTOR_SHUTTER_LABEL[Ae.REQUEST].LINKED_CD;
    case tn.CI_JOB:
      return qe.ENVIRONMENT_SELECTOR_SHUTTER_LABEL[Ae.REQUEST].JOB_CI;
    default:
      return qe.ENVIRONMENT_SELECTOR_SHUTTER_LABEL[Ae.REQUEST].CI;
  }
}, tT = (t, s, n) => t === Ae.PENDING || !n || !s ? null : j_(n.type), sT = (t, s) => !t || !s ? null : t.nodes.find((n) => n.environmentName === s) ?? null, me = {
  HEADER: "Promote image in workflow",
  CLOSE_MODAL_LABEL: "Close image promotion modal",
  TABS_TEXT: {
    [Ae.PENDING]: "Approval Pending",
    [Ae.REQUEST]: "Select Image"
  },
  NOTIFICATION_INFO: {
    CONFIGURED: {
      TEXT: "Approvers will be notified."
    },
    NOT_CONFIGURED: {
      TOOLTIP_HEADING: "Email sender is not configured",
      TOOLTIP_CONTENT: "Configure SES or SMTP to notify approvers. When configured, all users having 'Image promotion approver' role will be notified via email.",
      LINK_TEXT: "Configure SES/SMTP",
      TEXT: "to notify approvers. When configured, all users having 'Image promotion approver' role will be notified via email."
    },
    SUCCESS_TEXT: "Approvers will be notified."
  },
  REQUEST_PROMOTION_HEADINGS: {
    REQUEST: "Select target environment",
    RESPONSE: "Image promotion status"
  },
  REQUEST_PROMOTION_CTA: {
    OPEN_OVERLAY: "Promote to...",
    REQUEST: "Promote image",
    RESPONSE: "Close"
  },
  CLOSE_IMAGE_PROMOTION_OVERLAY: "Close image promotion overlay",
  SEARCH_ENVIRONMENT_PLACEHOLDER: "Search environment",
  PROHIBITED_ENVIRONMENT_LIST_HEADING: "Cannot be promoted to environments",
  IMAGE_PROMOTION_OVERLAY_RESPONSE_HEADINGS: ["ENVIRONMENT", "STATUS"],
  CTA: {
    SECURITY_ISSUES_FOUND: "Security Issues Found",
    SELECT: "SELECT",
    CANCEL_REQUEST: "Cancel Request",
    APPROVED_BY_YOU: "Approved by you",
    APPROVE_FOR: "Approve for...",
    AWAITING_APPROVAL: "Awaiting approval"
  },
  REQUEST_IN_PROGRESS: "Request in progress",
  NO_SELECTED_IMAGE: "No image is selected",
  NO_ENVIRONMENT_SELECTED: "No environment is selected",
  APPROVAL_REQUESTED_BY: "Approval requested by",
  SELF_ACTION: "You",
  CANCEL: "Cancel",
  CANCEL_CONFIRMATION: "Are you sure you want to cancel the request?",
  YES: "Yes",
  NO: "No",
  APPROVED_BY: "Approved by",
  NO_APPROVAL: "This image has not received any approval.",
  CANCEL_TOAST: "Request has been cancelled",
  CANCEL_REQUEST_OVERLAY: {
    HEADING: "Cancel Request",
    INFO_TEXT: "Are you sure you want to cancel the request? A new approval request would need to be raised if you want to promote this image."
  },
  APPROVE_ARTIFACT_HEADING: "Approve image promotion for",
  getApprovalSuccessMessage: (t) => t.length === 1 ? `Image approved for promotion to '${t[0]}'` : "Image approved for promotion to selected environment(s)",
  APPROVE: "Approve",
  REQUEST_PROMOTION_EMPTY_SEARCH: {
    TITLE: "No results",
    SUB_TITLE: "We could not find any matching results",
    BUTTON_TEXT: "Clear"
  }
};
var ti = /* @__PURE__ */ ((t) => (t.SUCCESS = "SUCCESS", t.ERROR = "ERROR", t.INFO = "INFO", t.PENDING = "PENDING", t))(ti || {}), Ro = /* @__PURE__ */ ((t) => (t.PROMOTE = "PROMOTE", t.CANCEL = "CANCEL", t.APPROVE = "APPROVE", t))(Ro || {});
const nT = (t) => {
  const s = Object.keys(t);
  return s.length === 1 && t[s[0]].promotionPossible ? {
    [s[0]]: t[s[0]]
  } : {};
}, aT = (t) => {
  const s = Object.keys(t);
  return s.length === 1 && t[s[0]].approvalAllowed ? {
    [s[0]]: t[s[0]]
  } : {};
}, rT = (t) => {
  const s = "icon-dim-16 dc__no-shrink mt-2";
  switch (t) {
    case ti.SUCCESS:
      return /* @__PURE__ */ e.jsx(d_, { className: s });
    case ti.PENDING:
      return /* @__PURE__ */ e.jsx(lo, { className: `${s} scv-5` });
    case ti.INFO:
      return /* @__PURE__ */ e.jsx(x_, { className: s });
    default:
      return /* @__PURE__ */ e.jsx(UN, { className: s });
  }
}, oT = (t, s) => s === tn.ENVIRONMENT ? t : j_(s), iT = (t, s) => t ? me.REQUEST_IN_PROGRESS : s ? null : me.NO_SELECTED_IMAGE, lT = (t, s) => {
  const n = {
    eligibleEnvironmentsNames: [],
    inEligibleEnvironmentsNames: []
  };
  return s?.reduce((a, r) => (t[r].promotionPossible ? a.eligibleEnvironmentsNames.push(r) : a.inEligibleEnvironmentsNames.push(r), a), n) ?? n;
}, O_ = (t, s) => t ? me.REQUEST_IN_PROGRESS : s === 0 ? me.NO_ENVIRONMENT_SELECTED : null, cT = ({
  environment: t,
  ciSource: s,
  imagePromotionTab: n
}) => n === Ae.PENDING || !s ? {
  sourceType: tn.PROMOTION_APPROVAL_PENDING_NODE,
  ...t ? { sourceName: t } : {}
} : t ? {
  sourceName: t,
  sourceType: tn.ENVIRONMENT
} : {
  sourceName: s.name,
  sourceType: s.type
}, dT = ({
  imagePromotionTab: t,
  environment: s,
  ciSource: n
}) => t === Ae.PENDING ? {
  resource: tn.PROMOTION_APPROVAL_PENDING_NODE,
  ...s ? { resourceName: s } : {}
} : s ? {
  resource: tn.ENVIRONMENT,
  resourceName: s
} : {
  resource: n.type,
  resourceName: n.name,
  resourceId: n.id
}, Fr = {
  HEADING: "Promoted image",
  ELIGIBLE_DUE_TO_POLICY: "Eligible due to policy",
  PROMOTED_BY: "Promoted by",
  APPROVED_BY: "Approved by",
  getInfoText: (t, s) => `Image was promoted to '${t}' from '${s}'.`
}, pT = ({
  promotedTo: t,
  promotedFrom: s,
  promotedBy: n,
  approvedBy: a,
  promotionPolicyName: r
}) => /* @__PURE__ */ e.jsxs("div", { className: "p-12 flexbox-col dc__gap-12 h-200 dc__overflow-auto", children: [
  /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-9 fs-13 fw-4 lh-20", children: Fr.getInfoText(t, s) }),
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
    /* @__PURE__ */ e.jsx("h2", { className: "m-0 cn-9 fs-13 fw-6 lh-20", children: Fr.ELIGIBLE_DUE_TO_POLICY }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
      /* @__PURE__ */ e.jsx(g_, { className: "icon-dim-20 dc__no-shrink" }),
      /* @__PURE__ */ e.jsx("p", { className: "cn-9 dc__ellipsis-right fs-13 fw-4 lh-20 m-0", children: r })
    ] })
  ] }),
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
    /* @__PURE__ */ e.jsx("h2", { className: "m-0 cn-9 fs-13 fw-6 lh-20", children: Fr.PROMOTED_BY }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
      sa(n, "dc__no-shrink m-0-imp"),
      /* @__PURE__ */ e.jsx("p", { className: "cn-9 dc__ellipsis-right fs-13 fw-4 lh-20 m-0", children: n })
    ] })
  ] }),
  a?.length > 0 && /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
    /* @__PURE__ */ e.jsx("h2", { className: "m-0 cn-9 fs-13 fw-6 lh-20", children: Fr.APPROVED_BY }),
    a.map((o) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__align-items-center", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__ellipsis-right", children: [
        sa(o, "dc__no-shrink m-0-imp"),
        /* @__PURE__ */ e.jsx("p", { className: "cn-9 dc__ellipsis-right fs-13 fw-4 lh-20 m-0", children: o })
      ] }),
      /* @__PURE__ */ e.jsx(qs, { className: "icon-dim-16 scg-5 dc__no-shrink" })
    ] }, o))
  ] })
] }), uT = ({
  promotedTo: t,
  promotedFrom: s,
  promotedFromType: n,
  promotedBy: a,
  approvedBy: r,
  promotionPolicyName: o,
  showBackgroundColor: i
}) => {
  const l = oT(s, n);
  return /* @__PURE__ */ e.jsx(
    Dt,
    {
      theme: Mt.white,
      className: "w-300 h-100",
      placement: "top-start",
      additionalContent: /* @__PURE__ */ e.jsx(
        pT,
        {
          promotedTo: t,
          promotedFrom: l,
          promotedBy: a,
          approvedBy: r,
          promotionPolicyName: o
        }
      ),
      Icon: Zl,
      heading: Fr.HEADING,
      showCloseButton: !0,
      trigger: "click",
      interactive: !0,
      children: /* @__PURE__ */ e.jsxs(
        "button",
        {
          className: `${i ? "bcy-1 ey-2 bw-1 pl-6" : "dc__no-background dc__no-border dc__hover-color-b500 pl-0"} cn-9 flexbox br-4 pt-2 pb-2 pr-6 dc__gap-6 dc__align-items-center dc__outline-none-imp dc__tab-focus`,
          type: "button",
          "data-testid": `image-promotion-info-chip-${s}-${a}`,
          children: [
            /* @__PURE__ */ e.jsx(Zl, { className: "icon-dim-16 dc__no-shrink" }),
            /* @__PURE__ */ e.jsx("span", { className: "m-0 fs-13 fw-4 lh-20", children: l })
          ]
        }
      )
    }
  );
};
var In = /* @__PURE__ */ ((t) => (t.Config = "Config", t.Image = "Image", t))(In || {}), Pt = /* @__PURE__ */ ((t) => (t.SUBMIT = "SUBMIT", t.APPROVE = "APPROVE", t.CANCEL = "CANCEL", t))(Pt || {}), Us = /* @__PURE__ */ ((t) => (t.ELIGIBLE = "ELIGIBLE", t.ALL = "ALL", t))(Us || {});
const $ = {
  TAGS: "global-tag",
  filter: "filter",
  BLOCKED_STATE: "block-state",
  CLUSTER: "cluster",
  CLUSTER_CATEGORIES: "cluster/categories",
  virtual_cluster: "cluster/virtual",
  virtual_env: "env/virtual",
  CONFIG_DRAFTS: "draft",
  CONFIG_DRAFTS_VERSION: "draft/version",
  CONFIG_DRAFTS_COMMENTS: "draft/version/comments",
  CONFIG_PROTECT: "protect/v2",
  CURRENCY: "currency",
  APP_OTHER_ENVIRONMENT_MIN: "app/other-env/min",
  APP_ARTIFACT_PROMOTE: "app/artifact/promotion-request",
  APP_ARTIFACT_PROMOTE_ENV_LIST: "app/artifact/promotion-request/env/list",
  APP_ARTIFACT_PROMOTE_ENV_APPROVAL_META_DATA: "app/artifact/promotion-request/env/approval-metadata",
  APP_CI_PIPELINE_RUNTIME_PARAMS: "app/ci-pipeline/runtime-params",
  APP_APP_WF_LIST_COMPONENTS: "app/app-wf/list-components",
  APP_IMAGE_TAGGING_LIST: "app/image-tagging/list",
  APP_WORKFLOW_CLONE: "app/workflow/clone",
  APPLIED_PROFILE_POLICY: `global/policy/${mt.alpha1}/selectors/config`,
  APPLIED_PROFILE_POLICY_FILTERS_LIST: `global/policy/${mt.alpha1}/selectors/filter/list`,
  POLICY_EXCEPTION: (t) => `global/policy/${t}/${mt.alpha1}/exceptions`,
  NOTIFIER: "notification",
  ENVIRONMENT_LIST_MIN: "env/autocomplete",
  DIGEST_POLICY: "digest-policy",
  DEPLOYMENT_TEMPLATE: "chartref/autocomplete/chart",
  DEPLOYMENT_WINDOW_PROFILE_LIST: "deployment-window/profile/list",
  CREATE_DEPLOYMENT_WINDOW_PROFILE: "deployment-window/profile",
  VALIDATE_DEPLOYMENT_WINDOW_PROFILE: "deployment-window/validate",
  DEPLOYMENT_WINDOW_APP_ENV_LIST: "global/policy/deployment-window/app-env/list",
  DEPLOYMENT_WINDOW_BULK_APPLY: "global/policy/deployment-window/bulk/apply",
  ARTIFACT_PROMOTION_POLICY_LIST: "artifact-promotion/policy",
  ARTIFACT_PROMOTION_APP_ENV_LIST: "global/policy/artifact-promotion/app-env/list",
  ARTIFACT_PROMOTION_BULK_APPLY: "global/policy/artifact-promotion/bulk/apply",
  NOTIFIER_CHANNEL_CONFIG_APPROVE: "notification/channel/config/approve",
  NOTIFIER_CHANNEL_DEPLOYMENT_APPROVE: "notification/channel/deployment/approve",
  NOTIFIER_CHANNEL_IMAGE_PROMOTION_APPROVE: "notification/channel/image-promotion/approve",
  INFRA_CONFIG_IDENTIFIER_APPLICATIONS_APPLY: "infra-config/identifier/application/apply",
  INFRA_CONFIG_IDENTIFIER: "infra-config/identifier",
  INFRA_CONFIG_LIST_MIN_PLATFORMS: "infra-config/list/min/platforms",
  USER_STATUS_BULK_UPDATE: "user/status",
  USER_GROUP: "user-group",
  LOCK_CONFIG_SPECIFIC_CRITERIA_OPTIONS: "app/app-env/list",
  FILTERS_CRITERIA_META_DATA: "filters/criteria/metadata",
  DEPLOYMENT_WINDOW_OVERVIEW: "deployment-window/overview",
  DEPLOYMENT_WINDOW_STATE: "deployment-window/state",
  DEPLOYMENT_WINDOW_STATE_APP_GROUP: "deployment-window/state/appgroup",
  RESOURCE: "resource",
  RESOURCE_CLONE: "resource/clone",
  RESOURCE_LIST: "resource/list",
  RESOURCE_DEPENDENCIES: "resource/dependencies",
  RESOURCE_DEPENDENCIES_OFFENDING: "resource/dependencies/offending",
  RESOURCE_SUMMARY: "resource/summary",
  RESOURCE_TASKS_INFO: "resource/task/info",
  RESOURCE_TASKS_EXECUTE: "resource/task/execute",
  RESOURCE_DEPENDENCIES_CONFIG_OPTIONS: "resource/dependencies/config-options",
  RESOURCE_DEPENDENCIES_OPTIONS: "resource/dependencies/options",
  K8S_POD: "k8s/pod/",
  K8S_DOWNLOAD_POD_CONTENT: "k8s/download-pod-content",
  K8S_RESOURCE: "k8s/resource",
  K8S_RESOURCE_RECOMMENDATION_SYNC: "k8s/resource/recommendation/sync",
  K8S_RESOURCE_RECOMMENDATION_LIST: "k8s/resource/recommendation/list",
  K8S_RESOURCE_RECOMMENDED: "k8s/resource/recommended",
  RECOMMENDATION_DETAILS: "recommendation/details",
  WATCHER: "scoop/k8s/watcher",
  INTERCEPTED_CHANGES: "scoop/k8s/intercept-events",
  INTERCEPTED_CHANGES_DETAIL: "scoop/intercept-event",
  JOB_PIPELINE_LIST: "job/ci-pipeline/autocomplete",
  GLOBAL_VARIABLES: "global/variables",
  GLOBAL_VARIABLES_SUMMARY: "global/variables/summary",
  GLOBAL_VARIABLES_FILTER: "global/variables/filter",
  SYSTEM_NETWORK_CONTROLLER_CONFIG: "system-network-controller/config",
  SYSTEM_NETWORK_CONTROLLER_INFO: "system-network-controller/info",
  LOCK_CONFIG_API_ROUTE: "config/lock",
  GLOBAL_CONFIG_DEPLOYMENT_CHART_RESOURCE_DETAIL: "deployment/template/resource-detail",
  GLOBAL_CONFIG_DEPLOYMENT_CHART_RESOURCE: "deployment/template/resource",
  K8S_RESOURCE_SECURITY: "k8s/resource/security",
  OFFENDING: "offending",
  PLUGIN_POLICY_OFFENDING_DEVTRON_APP_LIST: `offending/${ie.devtronApplication}/list`,
  API_LIST_SUFFIX: "list",
  API_BULK_SUFFIX: "bulk",
  MIN: "min",
  DRIFT_MANAGED_RESOURCE: "drift/managed-resource",
  DRIFT_MANAGED_RESOURCES: "drift/managed-resources",
  SWITCH_TRAFFIC: "app/switch-traffic",
  INTELLIGENCE: "intelligence",
  PANELS: "panels",
  PANEL: "panel",
  CLUSTER_PRE_UPGRADE_CHECK: "cluster/pre-upgrade-check",
  CLUSTER_PANEL_TEMPLATE: "cluster/panel-template",
  CLUSTER_K8S_VERSIONS_LIST: "cluster/k8s-versions-list",
  PIPELINE_DEPLOYMENT_APPROVAL_CONFIG: "policy/deployment-approval/pipeline",
  POLICY_CONSEQUENCES: "app/policy-consequences",
  CONFIG_OPERATIONS: "config/operations",
  CI_PIPELINE_SWITCH: "app/ci-pipeline/switch",
  APP_ENV_MIN: "app/app-env/min",
  RESOURCE_TEMPLATE_OPTIONS: `${Ws.RESOURCE_TEMPLATE}/options`,
  APP_HIBERNATION_PATCH: "app/hibernation-patch",
  USER: "user/v2",
  LICENSE_DATA_DETAILS: "license/data/details",
  LICENSE_DATA: "license/data",
  INFRASTRUCTURE_CHART_METADATA: "infrastructure/chart/metadata",
  INFRASTRUCTURE: "infrastructure",
  CHART_CATEGORY_LIST: "chart-category/list",
  RECOMMENDED_CHARTS_STATUS: "app-store/deployment/installed-app/recommended-charts/status",
  CD_PIPELINE_TRIGGER_FEASIBILITY: "app/cd-pipeline/:appId/trigger/feasibility",
  ENV: "env",
  APP_METADATA: "app-metadata",
  CD_PIPELINE_STRATEGIES: "app/cd-pipeline/strategies",
  APP_STRATEGY: "app/strategy",
  APP_STRATEGY_ROLLOUT: "app/strategy/rollout/promote",
  BULK_EDIT_V2: "batch/v1beta2/application",
  COST_CUSTOM_VIEW: "cost/custom-view",
  COST_BREAKDOWN: "cost/breakdown",
  COST_SUMMARY: "cost/summary",
  COST_TREND: "cost/trend",
  K8S_CAPACITY_CLUSTER_IDENTIFY: "k8s/capacity/cluster/identify",
  APPROVAL_POLICY: "overview/approval-policy",
  UPGRADE_COMPATIBILITY: "overview/infra/cluster-upgrade",
  CLUSTER_NAMESPACES: "cluster/namespaces",
  ENV_LIST_BY_RESOURCE: "env/list-by-resource",
  // Data Protection Management
  OVERVIEW_GLANCE_METRICS: "overview/cluster-backup/glance-metrics",
  OVERVIEW_BACKUP_AND_RESTORE_SUMMARY: "overview/cluster-backup/restore-summary",
  OVERVIEW_BACKUP_SUCCESS_RATE: "overview/cluster-backup/backup-success-rate",
  STORAGE_LOCATION_LIST: "cluster-backup/storage-location/list",
  STORAGE_LOCATION_LIST_MIN: "cluster-backup/storage-location/list/min",
  VOLUME_SNAPSHOT_LIST: "cluster-backup/snapshot-location/list",
  CLUSTER_BACKUP_SNAPSHOT_LOCATION: "cluster-backup/snapshot-location",
  CLUSTER_BACKUP_STORAGE_LOCATION: "cluster-backup/storage-location",
  STORAGE_CLUSTER_LIST: "cluster-backup/storage-location/:id/resource-identifiers",
  VOLUME_SNAPSHOT_CLUSTER_LIST: "cluster-backup/snapshot-location/:id/resource-identifiers",
  CLUSTER_BACKUP_RESTORE_LIST: "cluster-backup/restore/list",
  CLUSTER_BACKUP_RESTORE: "cluster-backup/restore",
  SCHEDULE_LIST_MIN: "cluster-backup/schedule/list/min",
  BACKUP_LIST_MIN: "cluster-backup/backup/list/min",
  VOLUME_SNAPSHOT_LIST_MIN: "cluster-backup/snapshot-location/list/min",
  CONFIG_MAP_LIST_MIN: "cluster-backup/cluster/:clusterId/config-maps",
  BACKUP_LIST: "cluster-backup/backup/list",
  BACKUP_CREATE: "cluster-backup/backup",
  BACKUP_DETAIL: "cluster-backup/backup/:id",
  SCHEDULE_LIST: "cluster-backup/schedule/list",
  CLUSTER_BACKUP_SCHEDULE: "cluster-backup/schedule",
  SCHEDULE_DETAIL: "cluster-backup/schedule/:id",
  SCHEDULE_PAUSE: "cluster-backup/schedule/:id/pause",
  SCHEDULE_UNPAUSE: "cluster-backup/schedule/:id/unpause",
  BACKUP_LOGS: "cluster-backup/backup/logs/:id",
  // Security Enablement
  SCAN_WORKFLOW_LIST: "security/scan/security-enablement/workflows",
  SCAN_UPDATE_SCANNING: "security/scan/update-scanning"
}, Bn = `${se.APPLICATION_MANAGEMENT}/policies`, Ur = `${Bn}/deployment-window`, Vn = `${Bn}/approval-policy`, Yn = `${Bn}/plugin-policy`, mT = `${Bn}/pull-image-digest`, si = `${Bn}/tag-policy`, ni = `${Bn}/filter-conditions`, ha = `${Bn}/image-promotion`, Hn = `${Bn}/lock-deployment-configuration`, Ee = {
  DETAILS: "details",
  APP_STORE_HELM: "app-store/helm",
  MANIFEST_DOWNLOAD: "manifest/download",
  GLOBAL_CONFIG_CLUSTER: `${se.GLOBAL_CONFIG}/cluster-env`,
  TAG_LIST: si,
  TAG_CREATE: `${si}/create`,
  TAG_EDIT: `${si}/edit`,
  FILTER_CONDITIONS: ni,
  FILTER_CONDITIONS_ADD: `${ni}/add`,
  FILTER_CONDITIONS_EDIT: `${ni}/edit`,
  AUTH_USERS: `${se.GLOBAL_CONFIG}/auth/users`,
  AUTH_API_TOKEN_EDIT: `${se.GLOBAL_CONFIG}/auth/api-token/edit/:apiTokenId`,
  NOTIFIER_CONFIG: `${se.APPLICATION_MANAGEMENT_CONFIGURATIONS_NOTIFICATIONS}/configurations`,
  CI_PIPELINE_PATCH: "app/ci-pipeline/patch",
  PERMISSION_GROUPS: `${se.GLOBAL_CONFIG}/auth/groups`,
  APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA: se.APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA,
  APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA_PROFILES: se.APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA_PROFILES,
  APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA_PROFILE_CREATE: `${se.APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA}/profiles/create`,
  APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA_PROFILE_EDIT: `${se.APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA}/profiles/edit`,
  APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA_APPLICATIONS: `${se.APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA}/applications`,
  DEPLOYMENT_WINDOW_WINDOWS: `${Ur}/list`,
  DEPLOYMENT_WINDOW_APPLY_TO: `${Ur}/apply-to`,
  DEPLOYMENT_WINDOW_CREATE: `${Ur}/window/create`,
  DEPLOYMENT_WINDOW_EDIT: `${Ur}/window/edit`,
  POD_RESTART: "pod-restart",
  DEPLOYMENT_SOURCE: "/deployment-source",
  WATCHERS: "watchers",
  INTERCEPTED_CHANGES: "intercepted-changes",
  WORKFLOW_EDITOR: "edit/workflow",
  CI_PIPELINE: "ci-pipeline",
  BUILD: "build",
  GLOBAL_CONFIG_AUTH_USER_PERMISSION: `${se.GLOBAL_CONFIG}/auth/users`,
  OVERVIEW: "overview",
  NETWORK_STATUS_CONTROLLER_CREATE: `${se.NETWORK_STATUS_INTERFACE}/controller/create`,
  NETWORK_STATUS_CONTROLLER_EDIT: `${se.NETWORK_STATUS_INTERFACE}/controller/edit`,
  NETWORK_STATUS_CONTROLLER_DETAILS: `${se.NETWORK_STATUS_INTERFACE}/controller/details`,
  NETWORK_STATUS_CUSTOMIZE_COLUMNS: `${se.NETWORK_STATUS_INTERFACE}/customize-columns`,
  K8S_RESOURCES: "k8s-resources",
  GLOBAL_CONFIG_MANAGE_CATEGORIES: `${se.GLOBAL_CONFIG}/cluster-env/manage-categories`,
  CREATE_ENV: "/create/environment",
  CONNECT_CLUSTER: "/create/cluster/connect-cluster"
}, Y = {
  RELEASES: `${se.SOFTWARE_RELEASE_MANAGEMENT}/releases`,
  RELEASE_CREATE: `${se.SOFTWARE_RELEASE_MANAGEMENT}/releases/create`,
  RELEASE_EDIT: `${se.SOFTWARE_RELEASE_MANAGEMENT}/releases/edit/:releaseId`,
  RELEASE_DETAIL: `${se.SOFTWARE_RELEASE_MANAGEMENT}/releases/detail/:releaseTrack/:releaseVersion`,
  RELEASE_DETAIL_OVERVIEW: `${se.SOFTWARE_RELEASE_MANAGEMENT}/releases/detail/:releaseTrack/:releaseVersion/overview`,
  RELEASE_DETAIL_REQUIREMENTS: `${se.SOFTWARE_RELEASE_MANAGEMENT}/releases/detail/:releaseTrack/:releaseVersion/requirements/:appName?`,
  RELEASE_DETAIL_REQUIREMENTS_DEPLOYMENT_SOURCE: `${se.SOFTWARE_RELEASE_MANAGEMENT}/releases/detail/:releaseTrack/:releaseVersion/requirements/:appName?/deployment-source`,
  RELEASE_DETAIL_ROLLOUT_RELEASE: `${se.SOFTWARE_RELEASE_MANAGEMENT}/releases/detail/:releaseTrack/:releaseVersion/rollout-release`,
  RELEASE_DETAIL_HISTORY: `${se.SOFTWARE_RELEASE_MANAGEMENT}/releases/detail/:releaseTrack/:releaseVersion/rollout-history/:appId?/:envId?/:pipelineId?/:triggerId?`,
  RELEASE_DETAIL_CONFIGURATIONS: `${se.SOFTWARE_RELEASE_MANAGEMENT}/releases/detail/:releaseTrack/:releaseVersion/configurations/:appId?/:envId?`,
  RELEASE_TRACK_ADD_EDIT: `${se.SOFTWARE_RELEASE_MANAGEMENT}/releases/track/:id`,
  RELEASE_RELEASE_CREATE_TRACK_ADD_EDIT: `${se.SOFTWARE_RELEASE_MANAGEMENT}/releases/create/track/:id`,
  RELEASE_RELEASE_EDIT_TRACK_ADD_EDIT: `${se.SOFTWARE_RELEASE_MANAGEMENT}/releases/edit/:releaseId/track/:id`,
  RELEASE_TRACK_DETAIL: `${se.SOFTWARE_RELEASE_MANAGEMENT}/releases/track/detail/:trackName`,
  TENANTS: `${se.SOFTWARE_RELEASE_MANAGEMENT}/tenants`,
  TENANT_CREATE: `${se.SOFTWARE_RELEASE_MANAGEMENT}/tenants/create`,
  TENANT_EDIT: `${se.SOFTWARE_RELEASE_MANAGEMENT}/tenants/edit/:tenantId`,
  TENANT_DETAIL: `${se.SOFTWARE_RELEASE_MANAGEMENT}/tenants/detail/:tenantId`,
  TENANT_DETAIL_OVERVIEW: `${se.SOFTWARE_RELEASE_MANAGEMENT}/tenants/detail/:tenantId/overview`,
  TENANT_DETAIL_INSTALLATIONS: `${se.SOFTWARE_RELEASE_MANAGEMENT}/tenants/detail/:tenantId/installations/:installationId?`,
  TENANT_DETAIL_INSTALLATION_MAP_ENVIRONMENT: `${se.SOFTWARE_RELEASE_MANAGEMENT}/tenants/detail/:tenantId/installations/:installationId/map-environment`,
  NETWORK_STATUS_CONTROLLER_EDIT: `${Ee.NETWORK_STATUS_CONTROLLER_EDIT}/:controllerId`,
  NETWORK_STATUS_CONTROLLER_DETAILS: `${Ee.NETWORK_STATUS_CONTROLLER_DETAILS}/:controllerId`,
  APPLICATION_MANAGEMENT_POLICIES: Bn,
  APPLICATION_MANAGEMENT_POLICIES_DEPLOYMENT_WINDOW: Ur,
  APPLICATION_MANAGEMENT_POLICIES_APPROVAL_POLICY: Vn,
  APPLICATION_MANAGEMENT_POLICIES_PLUGIN_POLICY: Yn,
  APPLICATION_MANAGEMENT_POLICIES_PULL_IMAGE_DIGEST: mT,
  APPLICATION_MANAGEMENT_POLICIES_TAG_POLICY: si,
  APPLICATION_MANAGEMENT_POLICIES_FILTER_CONDITIONS: ni,
  APPLICATION_MANAGEMENT_POLICIES_IMAGE_PROMOTION: ha,
  APPLICATION_MANAGEMENT_POLICIES_LOCK_DEPLOYMENT_CONFIGURATION: Hn,
  LOCK_DEPLOYMENT_CONFIGURATION: Hn,
  LOCK_CONFIGURATION_PROFILE_LIST: `${Hn}/profiles`,
  LOCK_CONFIGURATION_PROFILE_CREATE: `${Hn}/profiles/create`,
  LOCK_CONFIGURATION_PROFILE_EDIT: `${Hn}/profiles/edit/:profileName`,
  LOCK_CONFIGURATION_APPLIED_PROFILE_LIST: `${Hn}/applied-profiles`,
  LOCK_CONFIGURATION_APPLIED_PROFILE_CREATE: `${Hn}/applied-profiles/create`,
  LOCK_CONFIGURATION_APPLIED_PROFILE_EDIT: `${Hn}/applied-profiles/edit/:appliedProfileId`,
  IMAGE_PROMOTION_PROFILE_LIST: `${ha}/profiles`,
  IMAGE_PROMOTION_PROFILE_CREATE: `${ha}/profiles/create`,
  IMAGE_PROMOTION_PROFILE_EDIT: `${ha}/profiles/edit/:profileName`,
  IMAGE_PROMOTION_APPLIED_PROFILE_LIST: `${ha}/applied-profiles`,
  IMAGE_PROMOTION_APPLIED_PROFILE_CREATE: `${ha}/applied-profiles/create`,
  IMAGE_PROMOTION_APPLIED_PROFILE_EDIT: `${ha}/applied-profiles/edit/:appliedProfileId`,
  PLUGIN_POLICY_PROFILE_LIST: `${Yn}/profiles`,
  PLUGIN_POLICY_PROFILE_LIST_OFFENDING_PIPELINES: `${Yn}/profiles/offending-pipelines/:profileName`,
  PLUGIN_POLICY_PROFILE_CREATE: `${Yn}/profiles/create`,
  PLUGIN_POLICY_PROFILE_EDIT: `${Yn}/profiles/edit/:profileName`,
  PLUGIN_POLICY_APPLIED_PROFILE_LIST: `${Yn}/applied-profiles`,
  PLUGIN_POLICY_APPLIED_PROFILE_CREATE: `${Yn}/applied-profiles/create`,
  PLUGIN_POLICY_APPLIED_PROFILE_EDIT: `${Yn}/applied-profiles/edit/:appliedProfileId`,
  APPROVAL_POLICY_LIST: `${Vn}/policy`,
  APPROVAL_POLICY_CREATE: `${Vn}/policy/create`,
  APPROVAL_POLICY_EDIT: `${Vn}/policy/edit/:policyName`,
  APPROVAL_POLICY_APPLIED_POLICY_LIST: `${Vn}/applied-policy`,
  APPROVAL_POLICY_APPLIED_POLICY_CREATE: `${Vn}/applied-policy/create`,
  APPROVAL_POLICY_APPLIED_POLICY_EDIT: `${Vn}/applied-policy/edit/:appliedProfileId`,
  APPROVAL_POLICY_EXCEPTION: `${Vn}/exceptions`,
  APPLICATION_MANAGEMENT_CONFIGURATIONS_DEPLOYMENT_CHARTS_EDIT: `${se.APPLICATION_MANAGEMENT_CONFIGURATIONS_DEPLOYMENT_CHARTS}/:name/:resourceType`
};
var _T = /* @__PURE__ */ ((t) => (t.create = "create", t.edit = "edit", t))(_T || {});
const Qk = {
  FILTER_CONDITION: {
    title: "Filter Conditions",
    description: "Configure filter conditions to allow or block events (eg. images) for deployment pipelines.",
    docLink: "GLOBAL_CONFIG_FILTER_CONDITION"
  },
  PULL_IMAGE_DIGEST: {
    title: "Pull Image Digest",
    description: "Image digest values are used to create immutable addresses for container images. If opted, images will be pulled using its digest from the container registry, ensuring both the uniqueness and integrity of the image in the environment.",
    docLink: "GLOBAL_CONFIG_PULL_IMAGE_DIGEST"
  },
  TAGS: {
    title: "Tags",
    description: "Manage tags for your organization.",
    docLink: "GLOBAL_CONFIG_TAGS"
  }
};
var fT = /* @__PURE__ */ ((t) => (t.Cluster = "cluster", t))(fT || {});
const hT = {
  title: "Sync with Environment",
  subtitle: "Mirrors code deployed on another environment in this application. ",
  dataTestId: "open-linked-cd-modal",
  type: mx.LINKED_CD,
  icons: [{ name: "ic-deploy-sync", color: null }]
}, Xa = {
  DEVTRON_APPLICATION: "devtron-application",
  CD_PIPELINE: "cd-pipeline",
  HELM_APPLICATION: "helm-application",
  APPLICATION: "application",
  JOB: "job",
  CLUSTER: "cluster"
}, Zk = {
  [Xa.DEVTRON_APPLICATION]: "Devtron Application",
  [Xa.CD_PIPELINE]: "CD Pipeline",
  [Xa.HELM_APPLICATION]: "Helm Application",
  [Xa.APPLICATION]: "Application",
  [Xa.JOB]: "Job",
  [Xa.CLUSTER]: "Cluster"
}, Ji = "Please resolve the form errors before saving", Ap = {
  TWELVE_HOURS_FORMAT: "ddd, DD MMM YYYY, hh:mm A",
  TWELVE_HOURS_FORMAT_WITHOUT_WEEKDAY: "DD MMM YYYY, hh:mm A",
  TWELVE_HOURS_EXPORT_FORMAT: "DD-MMM-YYYY hh.mm A",
  DATE_FORMAT: "DD MMM YYYY",
  DATE_FORMAT_WITH_WEEKDAY: "ddd, DD MMM YYYY"
};
var xa = /* @__PURE__ */ ((t) => (t.APPLICATIONS = "applications", t.ENVIRONMENTS = "environments", t.POLICY_NAMES = "policyNames", t))(xa || {});
const eF = !0, La = {
  [In.Config]: {
    title: "Configuration approver",
    noUsersFound: "No users found with configuration approver permission.",
    notEligibleUser: "User does not have 'Configuration approver' permission",
    usersWithPermission: "All users having ‘Configuration approver’ permission for this application and environment can approve.",
    cancelRequestTitle: "Discard Draft",
    cancelRequestInfo: "Are you sure you want to discard this draft? Any changes made to the draft will be lost."
  },
  [In.Image]: {
    title: "Image approver",
    noUsersFound: "No users found with image approver permission.",
    notEligibleUser: "User does not have 'Image approver' permission",
    usersWithPermission: "All users having ‘Image approver’ permission for this application and environment can approve.",
    cancelRequestTitle: "Cancel request",
    cancelRequestInfo: "Are you sure you want to cancel the request? "
  }
}, Sp = "https://preview.devtron.ai", R_ = ({
  handleDiscardDraft: t,
  handleClearPopupNode: s,
  isDraftDeleting: n,
  placement: a = "bottom-end",
  approvalType: r,
  children: o
}) => {
  const { cancelRequestTitle: i, cancelRequestInfo: l } = La[r], c = () => /* @__PURE__ */ e.jsx("div", { className: "mxh-250 br-4 bg__primary flexbox-col", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col p-12 dc__gap-20", children: [
    /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-20 cn-9", children: l }),
    /* @__PURE__ */ e.jsx("div", { className: "w-100 flexbox dc__content-end", children: /* @__PURE__ */ e.jsx(
      j,
      {
        text: i,
        size: O.small,
        variant: w.primary,
        style: B.negative,
        onClick: t,
        dataTestId: "discard-draft-config-button",
        isLoading: n
      }
    ) })
  ] }) });
  return /* @__PURE__ */ e.jsx(
    Dt,
    {
      theme: Mt.white,
      heading: i,
      className: "w-300 h-100",
      iconClass: "scv-5",
      showCloseButton: !0,
      interactive: !0,
      visible: !0,
      onClose: s,
      additionalContent: c(),
      placement: a,
      children: o
    }
  );
}, gT = "app/cd-pipeline/approve", pd = {
  submit: 0,
  approve: 1,
  cancel: 2
}, yp = {
  [Pt.SUBMIT]: "Image approval request submitted",
  [Pt.APPROVE]: "Image approved",
  [`${Pt.APPROVE}_AUTO_CD`]: "Image has been approved.",
  [Pt.CANCEL]: "Image approval request cancelled"
}, nn = {
  heading: "Approval for deployment to",
  tab: {
    first: "Request approval",
    second: "Approval pending"
  },
  approverInfoMsg: "‘Approver’ role can be provided to users via",
  noApproverInfoMsg: "No users have ‘Approver’ permission for this application and environment. ‘Approver’ role can be provided to users via",
  permissions: "User Permissions.",
  approverGroups: {
    user: "Users",
    token: "API Tokens"
  },
  specificUsersHeading: "Specific users",
  anyBelowUsers: "Any below users"
}, xT = "Connect with super admin user to approve the changes", P_ = "No eligible changes found", ET = "Changes in an array cannot be done, since there are changes to some locked keys.", Os = {
  imageBuilderTippy: "You triggered the build pipeline for this image. The builder of an image cannot approve it.",
  approvedByYou: "Approved by you",
  awaiting: "Awaiting approval",
  requestApproval: {
    heading: "Notify users for approvals",
    infoText: "Request approval for deploying this image. All users having ‘Approver’ permission for this application and environment can approve.",
    label: "Request approval"
  },
  cancelRequest: {
    heading: "Cancel approval request",
    infoText: "Are you sure you want to cancel approval request for this image? A new approval request would need to be raised if you want to deploy this image.",
    label: "Cancel request"
  },
  approveRequest: {
    heading: "Approve image",
    infoText: "Are you sure you want to approve deploying this image to",
    label: "Approve"
  },
  vulnerability: {
    found: "Security vulnerability found",
    notFound: "No vulnerabilities Found",
    notScanned: "Image was not scanned",
    scanDisabled: "Scan is Disabled",
    scanned: "Scanned on"
  },
  sourceInfo: {
    hide: "Hide Source Info",
    show: "Show Source Info"
  }
}, w_ = {
  [Pt.SUBMIT]: "Submit request",
  [Pt.APPROVE]: "Approve request",
  [Pt.CANCEL]: "Cancel request"
}, Lp = {
  requestedBy: "Approval requested by",
  cancelRequest: "Are you sure you want to cancel the request?",
  noApprovals: "This image has not received any approvals.",
  deploymentBy: "Deployment initiated by"
}, Rs = {
  noImage: {
    title: "No image available",
    subTitle: "Trigger build pipeline and find the image here",
    cdAutoMode: (t) => `Deployment to ${t} is set to Automatic. Deployment of an image is initiated as soon as it receives the required number of approvals.`,
    cdSubtitle: "Images will be available here for deployment after approval.",
    rollbackSubtitle: "Approved images which have been previously deployed will be available here for rollback.",
    label: "View images for approval"
  },
  noApprovedImages: {
    title: "No approved images",
    subTitle: "Trigger build pipeline and find the image here",
    label: "View images for approval"
  },
  noPendingImages: {
    title: "No images are pending for approval",
    subTitle: "Images for which approval is requested will be available here. All users having ‘Approver’ permission for this application and environment can approve.",
    label: "View images for approval"
  },
  noEligibleImages: {
    title: "No eligible image found",
    subTitle: (t) => `Latest ${t} images are not passing the filter conditions`
  }
}, CT = "installed", jp = {
  strokeSolid: "var(--N400)",
  arrowColor: "var(--N600)"
}, Yo = {
  notConfiguredTitle: "Email sender is not configured",
  notConfiguredInfo: "Configure SES or SMTP to notify specific people for approval requests",
  noDefaultStateTitle: "No default email configuration found",
  noDefaultStateInfo: "The default SES or SMTP configuration is used to send notifications. Set an email configuration as default to notify specific people for approval requests."
}, Op = "approval-state";
var Me = /* @__PURE__ */ ((t) => (t.APPROVAL = "approval", t.PENDING = "pending", t))(Me || {});
const Rp = (t) => !t && t !== 0, D_ = ({ requiredApprovalCount: t, currentApprovalCount: s }) => /* @__PURE__ */ e.jsx(Ie, { alwaysShowTippyOnHover: Rp(s), content: "Approvals required", children: /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-4 br-10 bcn-1 px-6", children: [
  /* @__PURE__ */ e.jsx(lo, { className: "dc__no-shrink icon-dim-12 scn-7 dc__no-shrink" }),
  /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-12 fw-6 lh-20", children: Rp(s) ? Eo(t) : `${s}/${t}` })
] }) }), bT = (t) => {
  const {
    eligibleApprovers: { anyUsers: s, specificUsers: n, userGroups: a }
  } = t;
  return s.approverList.length + n.approverList.length + a.flatMap(({ approverList: o }) => o).length;
}, NT = (t) => t ? /* @__PURE__ */ e.jsx(qs, { className: "icon-dim-16 scg-5 dc__no-shrink" }) : /* @__PURE__ */ e.jsx(Ie, { alwaysShowTippyOnHover: !0, content: "Approval pending", children: /* @__PURE__ */ e.jsx("div", { className: "icon-dim-16 dc__no-shrink", children: /* @__PURE__ */ e.jsx(ld, { className: "icon-dim-16 scn-6 dc__no-shrink" }) }) }), vi = (t) => t.filter(
  (s) => !s.startsWith(Rc) && s !== _x.admin
), qn = (t, s) => t.filter(({ identifier: n }) => !n.startsWith(Rc) && n !== s).map(({ identifier: n }) => n), ud = ({
  showApprovalCountBadge: t = !0,
  showUserApprovalStatus: s = !0,
  approvalConfigData: n,
  approvalType: a
}) => {
  const r = de(null), o = Q(
    () => n.userGroupsApprovedInfo.userGroups.reduce(
      (d, { approverList: p }) => d + p.length,
      n.anyUserApprovedInfo.approverList.length + n.specificUsersApprovedInfo.approverList.length
    ),
    [n]
  ), i = () => {
    r.current.scrollIntoView({ behavior: "smooth", block: "end" });
  }, l = (d, p, m = 0) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
    /* @__PURE__ */ e.jsx(Ie, { content: d, children: /* @__PURE__ */ e.jsx("h4", { className: "m-0 dc__truncate cn-7 fs-12 fw-6 lh-20 dc__uppercase flex-grow-1", children: d }) }),
    t && /* @__PURE__ */ e.jsx(
      D_,
      {
        currentApprovalCount: m,
        requiredApprovalCount: p
      }
    )
  ] }), c = (d, p, m) => {
    const u = d.sort((f, _) => f.hasApproved !== _.hasApproved ? f.hasApproved ? -1 : 1 : Ce(f.identifier, _.identifier));
    return u.length > 0 ? u.map(({ identifier: f, hasApproved: _, canApprove: h }) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__align-items-center", children: [
      /* @__PURE__ */ e.jsx(
        so,
        {
          rootClassName: `flex-grow-1 ${h ? "" : "dc__disabled"}`,
          tooltipContent: h ? null : La[a].notEligibleUser,
          identifier: f
        }
      ),
      s && NT(_)
    ] }, `${p}-${f}-user`)) : /* @__PURE__ */ e.jsx("span", { className: "lh-20 cn-7 fs-13", children: m });
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-4", children: [
        /* @__PURE__ */ e.jsx("h3", { className: "m-0 fs-13 fw-6 lh-20 cn-9", children: "Approvers" }),
        /* @__PURE__ */ e.jsx(
          j,
          {
            dataTestId: "help-icon",
            ariaLabel: "Help info",
            icon: /* @__PURE__ */ e.jsx(Ya, {}),
            showAriaLabelInTippy: !1,
            variant: w.borderLess,
            style: B.neutral,
            size: O.xs,
            onClick: i
          }
        )
      ] }),
      n.requiredCount > 0 || o > 0 ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16", children: [
        (n.specificUsersApprovedInfo.requiredCount > 0 || n.specificUsersApprovedInfo.approverList.length > 0) && /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
          l(
            nn.specificUsersHeading,
            n.specificUsersApprovedInfo.requiredCount,
            n.specificUsersApprovedInfo.currentCount
          ),
          c(
            n.specificUsersApprovedInfo.approverList,
            "specific",
            "No specific users"
          )
        ] }),
        n.userGroupsApprovedInfo.userGroups.map(
          ({ groupIdentifier: d, groupName: p, requiredCount: m, currentCount: u, approverList: f }) => m > 0 || f.length > 0 ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
            l(p, m, u),
            c(
              f,
              `user-group-${d}`,
              "No users in this group"
            )
          ] }, `${d}-user-group`) : null
        ),
        (n.anyUserApprovedInfo.requiredCount > 0 || n.anyUserApprovedInfo.approverList.length > 0) && /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
          l(
            nn.anyBelowUsers,
            n.anyUserApprovedInfo.requiredCount,
            n.anyUserApprovedInfo.currentCount
          ),
          c(
            n.anyUserApprovedInfo.approverList,
            "any",
            La[a].noUsersFound
          )
        ] })
      ] }) : /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-13 cn-7 lh-20 fw-4", children: "No approvals required" })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "px-12 py-8 flex top left dc__gap-8 bcv-1 ev-2 br-4 bw-1", ref: r, children: [
      /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("h5", { className: "fs-13 fw-6 lh-20 cn-9 m-0", children: "Approvers" }),
        /* @__PURE__ */ e.jsxs("p", { className: "m-0 fs-13 fw-4 lh-20 cn-9", children: [
          "Users with ",
          /* @__PURE__ */ e.jsxs("span", { className: "dc__lowercase", children: [
            "‘",
            La[a].title,
            "’"
          ] }),
          " permission & meeting the",
          /* @__PURE__ */ e.jsx(wt, { to: Y.APPROVAL_POLICY_APPLIED_POLICY_LIST, target: "_blank", children: " applied approval policy " }),
          "criteria for this pipeline/scope."
        ] })
      ] }),
      /* @__PURE__ */ e.jsx(yN, { className: "dc__no-shrink icon-dim-20" })
    ] })
  ] });
}, TT = ({
  requestedUserId: t,
  userApprovalMetadata: s,
  isLoading: n,
  triggeredBy: a,
  handleCancelRequest: r,
  approvalType: o
}) => {
  const { requestedUserData: i, approvalConfigData: l } = s ?? {}, c = i?.userId && i.userId === t;
  return /* @__PURE__ */ e.jsx("div", { className: "h-100 dc__overflow-hidden", children: /* @__PURE__ */ e.jsxs("div", { className: "p-12 flexbox-col dc__gap-12 h-100 mxh-250 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
      /* @__PURE__ */ e.jsx("h5", { className: "fs-13 fw-6 lh-20 m-0", children: Lp.requestedBy }),
      /* @__PURE__ */ e.jsxs("span", { className: "flex left fs-13 fw-4 dc__content-space dc__gap-4", children: [
        /* @__PURE__ */ e.jsx(so, { identifier: i?.userEmail ?? "" }),
        c && /* @__PURE__ */ e.jsx(
          j,
          {
            text: "Cancel",
            isLoading: n,
            dataTestId: "cancel-approval-request",
            onClick: r,
            variant: w.text,
            style: B.negative
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "dc__border-top-n1" }),
    /* @__PURE__ */ e.jsx(ud, { approvalConfigData: l, approvalType: o }),
    !!a && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx("div", { className: "dc__border-top-n1" }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
        /* @__PURE__ */ e.jsx("h5", { className: "fs-13 fw-6 lh-20 m-0", children: Lp.deploymentBy }),
        /* @__PURE__ */ e.jsx(so, { identifier: a })
      ] })
    ] })
  ] }) });
}, md = ({
  children: t,
  placement: s,
  requestedUserId: n,
  userApprovalMetadata: a,
  cancelRequest: r,
  isLoading: o,
  showCount: i = !0,
  showOnlyCountInButton: l = !1,
  approvalType: c,
  ...d
}) => {
  const [p, m] = v(!1), { requiredCount: u } = a.approvalConfigData, f = Math.min(a.approvalConfigData.currentCount, u), _ = `${i ? `${f ?? 0}/${u ?? 0}` : ""}`, h = () => {
    m((E) => !E);
  }, x = (E) => {
    r(E, Pt.CANCEL);
  }, g = () => (
    // Added div since Button already has a Tooltip inside
    /* @__PURE__ */ e.jsx("div", { children: t || /* @__PURE__ */ e.jsx(
      j,
      {
        startIcon: /* @__PURE__ */ e.jsx(vp, {}),
        text: `${_}${l ? "" : " Approvals"}`,
        variant: w.borderLess,
        style: B.neutral,
        dataTestId: "num-of-approvals-check",
        size: O.xs,
        onClick: Be
      }
    ) })
  );
  return p ? /* @__PURE__ */ e.jsx(
    R_,
    {
      handleDiscardDraft: x,
      handleClearPopupNode: h,
      isDraftDeleting: o,
      placement: s,
      approvalType: c,
      children: g()
    }
  ) : /* @__PURE__ */ e.jsx(
    Dt,
    {
      theme: Mt.white,
      className: "w-300 h-100",
      placement: s,
      Icon: vp,
      iconClass: "scv-5",
      heading: `${_} Approvals`,
      additionalContent: /* @__PURE__ */ e.jsx(
        TT,
        {
          ...d,
          requestedUserId: n,
          userApprovalMetadata: a,
          isLoading: o,
          handleCancelRequest: h,
          approvalType: c
        }
      ),
      showCloseButton: !0,
      trigger: "click",
      interactive: !0,
      children: g()
    }
  );
}, _d = (t) => we(gT, t), IT = async (t) => {
  try {
    const { result: s } = await le(
      `${$.PIPELINE_DEPLOYMENT_APPROVAL_CONFIG}/${t}`
    );
    return hi(s?.config);
  } catch (s) {
    throw V(s), s;
  }
}, M_ = ({
  matId: t,
  appId: s,
  pipelineId: n,
  requestedUserId: a,
  userApprovalMetadata: r,
  showCount: o,
  triggeredBy: i,
  reloadMaterials: l,
  hideApprovalCheckIcon: c = !1,
  showInfoIcon: d = !1,
  isExceptionUser: p = !1
}) => {
  const [m, u] = v(!1), { currentCount: f } = r.approvalConfigData, _ = r.approvalRuntimeState === Em.approved, h = p && !_, x = (g, E) => (C) => {
    C.stopPropagation(), u(!0);
    const b = {
      appId: s,
      actionType: pd.cancel,
      pipelineId: +n,
      artifactId: +g,
      approvalRequestId: +E
    };
    _d(b).then(() => {
      Z.showToast({
        variant: ee.success,
        description: "Image approval expired"
      }), l?.();
    }).catch((N) => {
      V(N);
    }).finally(() => {
      u(!1);
    });
  };
  return /* @__PURE__ */ e.jsx(
    md,
    {
      requestedUserId: a,
      userApprovalMetadata: r,
      cancelRequest: x(t, r?.approvalRequestId),
      isLoading: m,
      triggeredBy: i,
      showCount: h,
      approvalType: In.Image,
      children: !h && /* @__PURE__ */ e.jsxs("div", { className: "flex left cursor dc__hover-color-b500 dc__gap-6", children: [
        !c && /* @__PURE__ */ e.jsx(W, { name: "ic-checks", color: "N600" }),
        /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4", children: `${o ? f : ""} Approved` }),
        d && /* @__PURE__ */ e.jsx(Or, { className: "icon-dim-16" })
      ] })
    }
  );
}, tF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: M_
}, Symbol.toStringTag, { value: "Module" }));
var vT = /* @__PURE__ */ ((t) => (t.DEFINE = "Define Filter condition", t.SCOPE = "Apply to", t.REVIEW = "Filter condition", t))(vT || {}), k_ = /* @__PURE__ */ ((t) => (t[t.DEPLOYMENT = 0] = "DEPLOYMENT", t[t.BUILD = 1] = "BUILD", t))(k_ || {}), ur = /* @__PURE__ */ ((t) => (t.SUCCESS = "success", t.ERROR = "error", t.HOLD = "hold", t))(ur || {}), tc = /* @__PURE__ */ ((t) => (t.PASS_CONDITION = "Use CEL expression to define pass condition", t.FAIL_CONDITION = "Use CEL expression to define fail condition", t))(tc || {}), AT = /* @__PURE__ */ ((t) => (t.AllFutureProject = "-1", t.AllFutureProdCluster = "-2", t.AllFutureNonProdCluster = "-1", t.ClusterGlobalLabel = "-3", t.ProjectGlobalLabel = "-2", t))(AT || {}), ST = /* @__PURE__ */ ((t) => (t.NAME = "name", t.MIN_CONDITIONS = "minConditions", t.SUBMIT = "submit", t))(ST || {});
const sF = ["FILTER NAME", "DESCRIPTION", "CONDITION TYPE"], nF = {
  name: "",
  description: "",
  targetObject: k_.DEPLOYMENT,
  conditions: [],
  qualifierSelector: {
    applicationSelectors: [],
    environmentSelectors: []
  }
}, aF = {
  name: null,
  passCondition: null,
  failCondition: null,
  minScopes: null,
  minConditions: null
}, rF = {
  name: "",
  passCondition: null,
  failCondition: null,
  minScopes: null,
  minConditions: ""
}, oF = {
  AllFuture: "all-future",
  AllExisting: "all-existing",
  AllProd: "all-prod",
  AllNonProd: "all-non-prod"
}, iF = "Configure filter conditions to allow or block events (eg. images) for deployment pipelines.", yT = "Matching images will be allowed for deployment. Other images will be excluded.", LT = "Matching images will be excluded for deployment. If an image matches both pass and fail conditions, it will be excluded.", jT = "Use CEL expression (Common Expression Language) language for specifying rules/filters.", OT = `Example: 
containerImageTag.startsWith('prod')||containerImageTag.contains('hotfix')`, lF = {
  SAVED: "Successfully created filter",
  UPDATED: "Successfully updated filter"
}, RT = "View Configured Filters", PT = [
  {
    label: "Pass conditions",
    value: String(Vs.PASS),
    tooltipProps: {
      content: yT
    }
  },
  {
    label: "Fail conditions",
    value: String(Vs.FAIL),
    tooltipProps: {
      content: LT
    }
  }
], gl = {
  BULK_CD: "Filters configured for this app and environment",
  CD: "Filters configured for"
}, cF = "Search", dF = {
  COMMIT: "Image built from commit",
  EXTERNAL: "Image fetched using external service"
};
function wT({ name: t, expression: s }) {
  const n = Q(() => s.split(`
`), [s]);
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__align-self-stretch bg__primary dc__border dc__top-radius-4", children: [
    /* @__PURE__ */ e.jsx("div", { className: "flexbox pt-8 pb-8 pl-16 pr-16 dc__align-items-center dc__align-self-stretch dc__gap-10 dc__border-bottom", children: /* @__PURE__ */ e.jsxs("p", { className: "fw-4 m-0", children: [
      "Filter ",
      /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 m-0", children: t })
    ] }) }),
    /* @__PURE__ */ e.jsx("pre", { className: "flexbox-col p-8 fs-12 dc__align-start m-0 mh-150 mxh-210 dc__overflow-auto read-only-expression bg__primary dc__no-border", children: n.map((a, r) => (
      // line can be repetitive, so we need to use index as key
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ e.jsx("span", { children: a }, r)
    )) })
  ] });
}
const pF = (t) => le(`${$.TAGS}${t ? `?id=${t}` : ""}`), uF = (t, s) => {
  const n = { tags: t };
  return s ? Bt($.TAGS, n) : we($.TAGS, n);
}, mF = (t) => Js($.TAGS, { ids: t }), DT = (t) => le(`${$.TAGS}/${$.filter}?projectId=${t}`), Pp = (t) => ({
  data: {
    ...!!t?.length ? {
      tagKey: {
        value: "",
        type: ut.SELECT_TEXT,
        props: {
          placeholder: "Eg. owner-name",
          options: t.map((n) => ({ label: n, value: n }))
        }
      }
    } : {
      tagKey: {
        value: "",
        type: ut.TEXT,
        props: { placeholder: "Eg. owner-name" }
      }
    },
    tagValue: {
      value: "",
      type: ut.TEXT,
      props: {
        placeholder: "Enter value"
      }
    }
  },
  id: (Date.now() * Math.random()).toString(16),
  customState: {
    propagateTag: !1
  }
}), MT = (t) => ({
  value: t,
  type: ut.TEXT,
  props: {
    placeholder: "Enter value"
  }
}), kT = (t, s) => ({
  value: t,
  type: ut.DROPDOWN,
  props: {
    options: s.map((n) => ({ label: n, value: n })),
    placeholder: "Select an option"
  }
}), FT = (t, s) => ({
  value: t,
  type: ut.SELECT_TEXT,
  props: {
    options: s.map((n) => ({ label: n, value: n })),
    placeholder: "Select an option"
  }
}), F_ = (t, s) => !s || !s.choices ? MT(t) : s.blockCustomValue ? kT(t, s.choices) : FT(t, s.choices), UT = (t, s) => {
  const n = s?.get(t.key), a = {
    data: {
      tagKey: {
        value: t.key,
        disabled: t.isMandatory,
        required: t.isMandatory,
        type: ut.TEXT,
        ...t.description ? { tooltip: { content: t.description } } : {},
        props: {}
      },
      tagValue: F_(n?.value || "", t.valueConstraint)
    },
    id: (Date.now() * Math.random()).toString(16),
    customState: {
      propagateTag: t.propagate || n?.propagate,
      disablePropagateButton: t.key === Vl ? !0 : t.isMandatory && t.propagate,
      isCreatedWithoutProject: !1
    },
    disableDelete: t.isMandatory
  };
  return n && s.delete(t.key), a;
}, GT = (t) => t.reduce((s, n) => (s[n.key] = n.description, s), {}), BT = (t, s) => {
  const n = GT(s);
  return Array.from(t, ([a, r]) => {
    const { value: o, propagate: i, isCreatedWithoutProject: l } = r;
    return {
      data: {
        tagKey: {
          value: a,
          type: ut.TEXT,
          props: {},
          ...n[a] ? {
            tooltip: {
              content: n[a]
            }
          } : {}
        },
        tagValue: {
          value: o,
          type: ut.TEXT,
          props: {}
        }
      },
      customState: {
        propagateTag: i,
        isCreatedWithoutProject: l
      },
      id: (Date.now() * Math.random()).toString(16)
    };
  });
}, $T = (t) => {
  const s = /* @__PURE__ */ new Map();
  return t.forEach((n) => {
    s.set(n.data.tagKey.value, {
      value: n.data.tagValue.value,
      propagate: n.customState.propagateTag || !1,
      isCreatedWithoutProject: !0
    });
  }), s;
}, _F = ({
  appType: t,
  tags: s,
  setTags: n,
  isCreateApp: a = !1,
  projectId: r,
  hidePropagateTags: o,
  configuredTagsMap: i,
  tagsError: l,
  setTagErrors: c
}) => {
  const [, d] = ne(
    () => DT(r),
    [r],
    !!r
  ), p = Q(
    () => $T(s.filter((h) => h.customState.isCreatedWithoutProject)),
    [s]
  ), {
    mandatoryTags: m,
    suggestedTags: u,
    suggestedTagsChoices: f
  } = Q(
    () => d?.result.reduce(
      (h, x) => (x.isMandatory ? h.mandatoryTags.push(x) : (h.suggestedTags.push(x), h.suggestedTagsChoices.push(x.key)), h),
      { mandatoryTags: [], suggestedTags: [], suggestedTagsChoices: [] }
    ) ?? { mandatoryTags: [], suggestedTags: [], suggestedTagsChoices: [] },
    [d]
  );
  J(() => {
    n([
      ...m.map(
        (h) => UT(h, i ?? p)
      ),
      ...i || p ? BT(i ?? p, u) : [],
      Pp(f)
    ]);
  }, [m]);
  const _ = (h, x, g) => {
    const E = structuredClone(l);
    E[h.id] || (E[h.id] = {
      tagKey: { isValid: !0, errorMessages: [] },
      tagValue: { isValid: !0, errorMessages: [] }
    }), x === "tagKey" ? E[h.id].tagKey = hx(g) : E[h.id].tagValue = gx(g, h.data.tagKey.value);
    const C = s.map((b) => {
      if (b.id === h.id && x === "tagKey" && f.some((I) => g === I)) {
        const I = u.find((T) => T.key === g);
        return {
          ...b,
          data: {
            tagKey: {
              ...b.data.tagKey,
              value: g
            },
            tagValue: F_("", I.valueConstraint)
          },
          customState: {
            ...b.customState,
            propagateTag: g === Vl ? !1 : I.propagate
          }
        };
      }
      return b.id === h.id ? {
        ...b,
        data: {
          ...b.data,
          [x]: {
            ...b.data[x],
            value: g
          }
        },
        customState: {
          ...b.customState,
          ...r ? {} : { isCreatedWithoutProject: !0 },
          propagateTag: x === "tagKey" && g === Vl ? !1 : b.customState.propagateTag
        }
      } : b;
    });
    c(E), n(C);
  };
  return /* @__PURE__ */ e.jsx(
    fx,
    {
      appType: t,
      rows: s,
      setRows: n,
      isCreateApp: a,
      ...r ? {
        getEmptyRow: () => Pp(f)
      } : {},
      onRowEdit: _,
      tagsError: l,
      setTagErrors: c,
      hidePropagateTags: o
    }
  );
}, fF = ({
  prometheusConfig: t,
  handleOnChange: s,
  costModuleEnabled: n,
  toggleCostModule: a,
  onPrometheusAuthTypeChange: r,
  isGrafanaModuleInstalled: o,
  costModuleConfig: i,
  handleCostConfigChange: l,
  config: c,
  costModuleSchema: d
}) => {
  const { installationStatus: p, installationError: m } = i || {}, f = o ? p === "Installing" ? "Cost module installation is in progress. Please wait..." : p === "Upgrading" ? "Cost module upgrade is in progress. Please wait..." : "" : "Please install Grafana module to enable cost tracking", _ = (x) => {
    l(x.formData);
  }, h = () => p === "Failed" ? {
    variant: "error",
    heading: "Cost agent unavailable",
    description: m
  } : p === "Installing" || p === "Upgrading" ? {
    variant: "neutral",
    heading: "Cost agent is being installed",
    customIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-circle-loader", size: 18, color: "N700" })
  } : p === "Success" ? {
    variant: "success",
    heading: "Cost agent active",
    description: "The agent is installed and working as expected"
  } : null;
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__gap-20 p-20 cluster-cost-config", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
      /* @__PURE__ */ e.jsx("span", { className: "fs-16 fw-6 lh-1-5 cn-9", children: "Cost Visiblity" }),
      /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-1-5 cn-7", children: "Get insights into your infrastructure spending and cost optimization opportunity for this cluster" })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "divider__secondary--horizontal" }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16 bg__primary p-20 br-8 border__secondary", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-16", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
          /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-1-5 cn-9", children: "Enable cost tracking" }),
          /* @__PURE__ */ e.jsx("span", { className: "fs-12 fw-4 lh-1-5 cn-7", children: "Infrastructure cost tracking for this cluster with deep insights" })
        ] }),
        /* @__PURE__ */ e.jsx(
          Gn,
          {
            name: "toggle-cost-tracking",
            ariaLabel: "Toggle cost tracking",
            isChecked: n,
            onChange: a,
            isDisabled: !!f,
            tooltipContent: f
          }
        )
      ] }),
      n && /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16", children: [
        h() && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(Ot, { ...h() }),
          /* @__PURE__ */ e.jsx("div", { className: "divider divider--n1" })
        ] }),
        /* @__PURE__ */ e.jsx(
          la,
          {
            className: "w-100",
            schema: d,
            formData: c,
            onChange: _,
            experimental_defaultFormStateBehavior: {
              emptyObjectFields: "skipDefaults"
            },
            liveValidate: !0,
            uiSchema: Fa
          }
        )
      ] })
    ] }),
    n && /* @__PURE__ */ e.jsx(
      xx,
      {
        prometheusConfig: t,
        handleOnChange: s,
        onPrometheusAuthTypeChange: r
      }
    )
  ] });
}, VT = ({ aiResponse: t, onRetryClick: s, isAIThinking: n }) => {
  const { content: a, error: r } = t ?? {}, o = !!r && r.message?.search("abort|aborted") > -1;
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16 dc__align-start w-100", children: [
    n && !a && /* @__PURE__ */ e.jsx("span", { children: "AI is thinking..." }),
    a && /* @__PURE__ */ e.jsx(
      Cm,
      {
        markdown: a,
        className: "fs-13 fw-4 lh-20 cn-9 m-0 dc__no-border dc__word-break dc__text-wrap dc__open-sans p-0-imp dc__overflow-hidden w-100"
      }
    ),
    t.viewableItem,
    o && /* @__PURE__ */ e.jsx("div", { className: "pr-20 w-100", children: /* @__PURE__ */ e.jsx(
      Ot,
      {
        heading: "Prompt was aborted",
        variant: Wr.NEUTRAL,
        layout: "column",
        buttonProps: {
          dataTestId: "ai-chat__retry",
          onClick: s,
          text: "Retry",
          variant: w.text,
          startIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-arrow-clockwise", color: null })
        }
      }
    ) }),
    r && !o && !a && /* @__PURE__ */ e.jsx("div", { className: "pr-20 w-100", children: /* @__PURE__ */ e.jsx(
      Ot,
      {
        heading: "Failed to respond",
        description: "Something seems to have gone wrong",
        variant: Wr.ERROR,
        layout: "column",
        buttonProps: {
          dataTestId: "ai-chat__retry",
          onClick: s,
          text: "Retry",
          variant: w.text,
          startIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-arrow-clockwise", color: null })
        }
      }
    ) })
  ] });
};
let xl = 0;
const wp = [
  (t) => `Thank you for your message: "${t}". I'm an AI assistant here to help you with DevOps and Kubernetes-related questions. I can assist with deployment strategies, troubleshooting, configuration management, and best practices. How can I help you optimize your development workflow today?`,
  (t) => `I understand you're asking about: "${t}". Based on your query, I can provide insights on containerization, CI/CD pipelines, monitoring, and infrastructure management. Let me break down the key concepts and provide actionable recommendations for your specific use case.`,
  (t) => `Your question about "${t}" is interesting! I specialize in helping teams streamline their deployment processes, manage cloud-native applications, and implement effective DevOps practices. Here are some targeted suggestions and solutions that might address your current challenges.`,
  (t) => `Regarding "${t}" - I can help you navigate complex deployment scenarios, optimize resource utilization, and implement robust monitoring solutions. Let me share some proven strategies and tools that have worked well for similar situations in production environments.`
], YT = async (t) => {
  const s = wp[xl], n = s(t.message);
  return xl = (xl + 1) % wp.length, new ReadableStream({
    start(r) {
      let o = 0;
      const i = 5, l = () => {
        if (o < n.length) {
          const c = n.slice(o, o + i);
          r.enqueue(c), o += i, setTimeout(l, 100);
        } else
          r.close();
      };
      setTimeout(l, 200);
    }
  }).getReader();
}, HT = () => (
  // TODO: return your service function
  async (t) => (
    // Implement your service logic here
    // For now, using the mock service
    YT(t)
  )
), KT = (t, s) => {
  const { setTempAppWindowConfig: n } = s ?? {}, a = /* @__PURE__ */ new Date();
  return {
    content: t,
    viewableItem: /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: `viewable-item-${a.toString()}`,
        onClick: () => {
          n?.({
            open: !0,
            title: "Viewable Item",
            component: /* @__PURE__ */ e.jsxs("div", { children: [
              "This is a viewable item opened at ",
              a.toString()
            ] })
          });
        },
        text: "Read Report"
      }
    ),
    time: a
  };
}, WT = async ({ updateAIResponse: t, reader: s, additionalData: n }) => {
  let a = "";
  for (; ; ) {
    const { done: r, value: o } = await s.read();
    if (r) {
      t({ done: !0 });
      break;
    }
    try {
      a += o;
      const i = KT(a, n);
      if (!i)
        throw new Error("Parsed message is null");
      t({ message: i });
    } catch (i) {
      throw console.error("Error parsing message:", i), i;
    }
  }
}, qT = () => /* @__PURE__ */ e.jsx("div", { className: "enable-svg-animation--infinite flex", children: /* @__PURE__ */ e.jsx(W, { name: "ic-devtron-ai", color: null, size: 48 }) }), U_ = ({ setActiveSessionId: t, activeSessionId: s }) => {
  const { aiAgentContext: n, setTempAppWindowConfig: a } = Is(), { context: r, path: o } = n ?? { context: {}, path: "" }, [i, l] = v(""), [c, d] = v([]), [p, m] = v(!1), u = Ex(), f = de(null), _ = de(null), h = de({
    scrollWasTriggeredProgrammatically: !1,
    userHasControlOnScroll: !1
  });
  J(() => {
  }, [s]);
  const x = de(new AbortController()), g = Q(() => (t(""), HT()), []), E = (y) => {
    y?.addEventListener("keydown", (M) => {
      M.key === "Enter" && !M.shiftKey && (f.current?.click(), M.preventDefault());
    });
  }, C = Q(() => {
    let y = c.length;
    return async (M) => {
      h.current.userHasControlOnScroll = !1, x.current.abort(), x.current = new AbortController();
      try {
        d((U) => [
          ...U,
          {
            userMessage: { content: M, time: /* @__PURE__ */ new Date() },
            aiResponse: {
              isAIResponseLoading: !0,
              content: "",
              time: /* @__PURE__ */ new Date()
            }
          }
        ]), m(!0);
        const P = await g({
          message: M,
          abortControllerRef: x,
          context: r
        });
        await WT({
          reader: P,
          updateAIResponse: ({ done: U, message: G }) => {
            d((H) => {
              const oe = [...H];
              return Ht(U) && (oe[y].aiResponse = G), oe;
            });
          },
          additionalData: { setTempAppWindowConfig: a }
        }), m(!1);
      } catch (P) {
        d((U) => {
          const G = [...U];
          return G[y].aiResponse = {
            ...G[y].aiResponse ?? {
              content: "",
              time: /* @__PURE__ */ new Date()
            },
            error: P
          }, G;
        }), m(!1);
      }
      y += 1;
    };
  }, [o, r, g]), b = async () => {
    l(""), await C(i);
  }, N = () => {
    x.current.abort();
  }, I = (y) => {
    l(y.target.value);
  }, T = (y) => {
    y && y.dataset.first === "true" && (h.current.userHasControlOnScroll || (h.current.scrollWasTriggeredProgrammatically = !0, _.current.scrollTo({ top: y.offsetTop - 16, behavior: "smooth" })), y.dataset.first = "false");
  }, A = (y) => async () => {
    await C(y);
  }, S = () => {
    if (h.current.scrollWasTriggeredProgrammatically) {
      h.current.userHasControlOnScroll = !1, h.current.scrollWasTriggeredProgrammatically = !1, u.start({
        scale: 0
      }).catch(Be);
      return;
    }
    const y = _.current.scrollHeight - _.current.scrollTop - _.current.clientHeight;
    h.current.userHasControlOnScroll = y > 2, u.start({
      scale: y > 32 ? 1 : 0
    }).catch(Be);
  }, L = () => {
    _.current.scrollTo({
      top: _.current.scrollHeight - _.current.clientHeight + 1,
      behavior: "smooth"
    });
  }, R = () => c.length === 0 ? /* @__PURE__ */ e.jsx(
    _e,
    {
      title: "Devtron Ask",
      subTitle: "AI assistant for Devtron insights and debugging help",
      SvgImage: qT,
      styles: { gap: "16px" }
    }
  ) : c.map((y, M) => {
    const { userMessage: P, aiResponse: U } = y, { content: G } = P, H = M === c.length - 1;
    return (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ e.jsxs(Nr, { children: [
        /* @__PURE__ */ e.jsx(
          "div",
          {
            ref: H ? T : null,
            className: "border__secondary-translucent dc__white-space-pre-wrap bg__tertiary fs-13 lh-1-5 cn-9 py-8 px-12 br-12 ml-20 dc__align-self-end",
            "data-first": "true",
            children: P.content
          },
          `${JSON.stringify(U ?? {})}`
        ),
        U && /* @__PURE__ */ e.jsx(
          VT,
          {
            isAIThinking: p,
            aiResponse: U,
            onRetryClick: A(G)
          }
        )
      ] }, M)
    );
  });
  return /* @__PURE__ */ e.jsxs("div", { className: "ai-chat flexbox-col bg__primary flex-grow-1 dc__overflow-hidden dc__open-sans", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-hidden dc__position-rel", children: [
      /* @__PURE__ */ e.jsx(
        "div",
        {
          onScroll: S,
          ref: _,
          className: "flex-grow-1 flexbox-col dc__gap-16 p-16 ai-chat__conversations",
          children: R()
        }
      ),
      /* @__PURE__ */ e.jsx(
        gi.div,
        {
          initial: { scale: 0 },
          animate: u,
          className: "flex dc__position-abs dc__bottom-12 bg__primary br-8 dc__overflow-hidden shadow__card--20 border__primary-translucent",
          style: { left: "calc(50% - 16px)" },
          children: /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: "ai-chat__scroll-to-bottom",
              icon: /* @__PURE__ */ e.jsx(W, { name: "ic-arrow-right", color: null, rotateBy: 90 }),
              size: O.medium,
              variant: w.borderLess,
              style: B.neutral,
              onClick: L,
              ariaLabel: "Scroll to bottom",
              showAriaLabelInTippy: !1
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col ml-12 mb-12 mr-12 br-6 border__primary shadow__card--10 bg__secondary", children: [
      /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1 py-9 px-7", children: /* @__PURE__ */ e.jsx(
        vn,
        {
          textareaRef: E,
          size: O.small,
          name: "ai-chat__input",
          onChange: I,
          fullWidth: !0,
          autoFocus: !0,
          value: i,
          placeholder: "Ask Devtron...",
          disableResize: !0,
          borderConfig: { top: !1, right: !1, bottom: !1, left: !1 },
          newlineOnShiftEnter: !0
        },
        c.length
      ) }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-6 p-12 dc__align-items-center", children: [
        p ? /* @__PURE__ */ e.jsx("span", { className: "fs-12 dc__open-sans lh-1-5 cn-6 dc__truncate", children: "AI is thinking" }) : /* @__PURE__ */ e.jsx("div", {}),
        p && !i ? /* @__PURE__ */ e.jsx(
          j,
          {
            icon: /* @__PURE__ */ e.jsx(W, { name: "ic-stop-fill", color: null }),
            dataTestId: "ai-chat__cancel",
            size: O.small,
            ariaLabel: "Cancel current prompt",
            onClick: N,
            showAriaLabelInTippy: !1,
            style: B.neutral,
            variant: w.secondary
          },
          "cancel-prompt"
        ) : /* @__PURE__ */ e.jsx(
          j,
          {
            ref: f,
            icon: /* @__PURE__ */ e.jsx(W, { name: "ic-arrow-right", color: null, rotateBy: 270 }),
            dataTestId: "ai-chat__send",
            size: O.small,
            ariaLabel: "Send prompt",
            onClick: b,
            disabled: !i,
            showAriaLabelInTippy: !1
          },
          "send-prompt"
        )
      ] })
    ] })
  ] });
}, zT = ({ lastActiveSessionId: t }) => {
  const [s, n] = v(t);
  return /* @__PURE__ */ e.jsxs("div", { className: "dc__grid flex-grow-1", style: { gridTemplateColumns: "250px 1fr" }, children: [
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col border__primary--right", children: "User chat history is listed here" }),
    /* @__PURE__ */ e.jsx("div", { className: "dc__align-items-center flexbox-col", children: /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__mxw-800 w-100 flex-grow-1", children: /* @__PURE__ */ e.jsx(U_, { setActiveSessionId: Be, activeSessionId: s }) }) })
  ] });
}, hF = ({ SidePanelHeaderActions: t }) => {
  const { setTempAppWindowConfig: s, setSidePanelConfig: n, sidePanelConfig: a } = Is(), [r, o] = v(""), i = () => {
    s({
      open: !0,
      title: "Ask Devtron",
      component: /* @__PURE__ */ e.jsx(zT, { lastActiveSessionId: r }),
      customCloseConfig: {
        icon: /* @__PURE__ */ e.jsx(l_, {}),
        beforeClose: () => {
          n({
            state: Cx.ASK_DEVTRON,
            docLink: null,
            aiSessionId: r
          });
        }
      }
    }), setTimeout(() => {
      n({
        state: "closed",
        docLink: null,
        reinitialize: !1
      });
    }, 0);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(t, { children: /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "ai-chat__header-action",
        onClick: i,
        icon: /* @__PURE__ */ e.jsx(c_, {}),
        size: O.xs,
        variant: w.borderLess,
        ariaLabel: "Expand Ask Devtron",
        showAriaLabelInTippy: !1,
        style: B.neutral
      }
    ) }),
    /* @__PURE__ */ e.jsx(U_, { activeSessionId: a.aiSessionId ?? "", setActiveSessionId: o })
  ] });
}, gF = (t) => /* @__PURE__ */ e.jsx(
  $e,
  {
    ...t,
    rootClassName: "mb-0 flex top dc_max-width__max-content",
    "data-testid": "ask-value-at-runtime-checkbox",
    children: /* @__PURE__ */ e.jsx(
      Ie,
      {
        alwaysShowTippyOnHover: !0,
        className: "w-200",
        placement: "bottom-start",
        content: /* @__PURE__ */ e.jsxs("div", { className: "fs-12 lh-18 flexbox-col dc__gap-2", children: [
          /* @__PURE__ */ e.jsx("p", { className: "m-0 fw-6", children: "Ask value at runtime" }),
          /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "Value can be provided at runtime. Entered value will be pre-filled as default" })
        ] }),
        children: /* @__PURE__ */ e.jsx("div", { className: "dc__border-dashed--n3-bottom fs-13 cn-9 lh-20", children: "Ask value at runtime" })
      }
    )
  }
);
function XT({
  consumedImagePresent: t,
  triggerType: s,
  isRollbackTrigger: n,
  envName: a,
  viewAllImages: r,
  className: o
}) {
  const i = () => (
    // eslint-disable-next-line react/button-has-type
    /* @__PURE__ */ e.jsx("button", { className: "cta ghosted flex h-36", "data-selected-tab": "0", onClick: r, children: t ? Rs.noImage.label : Rs.noApprovedImages.label })
  ), l = () => s === Jo.automatic ? Rs.noImage.cdAutoMode(a) : n ? Rs.noImage.rollbackSubtitle : Rs.noImage.cdSubtitle;
  return /* @__PURE__ */ e.jsx(
    _e,
    {
      classname: o ?? "",
      image: s === Jo.automatic ? Ci : hb,
      title: s === Jo.automatic ? Rs.noImage.title : Rs.noApprovedImages.title,
      subTitle: l(),
      isButtonAvailable: !0,
      renderButton: i
    }
  );
}
const xF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: XT
}, Symbol.toStringTag, { value: "Module" })), JT = (t, s) => {
  for (let n = s - 1; n >= 0; n--) {
    const r = t[n]?.setWeight;
    if (r)
      return r;
  }
  return 0;
}, QT = (t) => {
  const { setWeight: s } = t;
  if (!Ht(s))
    return {
      message: `Rollout to ${t.setWeight}% users`,
      iconName: "ic-users",
      isFullRollout: t.setWeight === 100
    };
  if (t.pause)
    return {
      message: typeof t.pause.duration == "string" ? `Pause for ${t.pause.duration}` : "Pause indefinitely",
      iconName: "ic-timer"
    };
  if ("analysis" in t)
    return { message: "Run analysis", iconName: "ic-magnifying-glass" };
  if ("experiment" in t)
    return { message: "Run experiment", iconName: "ic-flask" };
  if (t.plugin)
    return { message: `Execute ${t.plugin.name} plugin`, iconName: "ic-lego" };
  if (t.setCanaryScale) {
    const { replicas: a, weight: r, matchTrafficWeight: o } = t.setCanaryScale, i = [];
    return a && i.push(`${a} replicas`), r && i.push(`${r} weight`), Ht(o) || i.push(`matchTrafficWeight: ${o}`), {
      message: `Set canary scale to ${i.join(" and ")}`,
      iconName: "ic-cube"
    };
  }
  const n = t.setHeaderRoute || t.setMirrorRoute;
  return n ? {
    message: `Set ${t.setHeaderRoute ? "header" : "mirror"} route${n.name ? ` - ${n.name}` : ""}`,
    iconName: "ic-cube"
  } : { message: "", iconName: "ic-cube" };
}, G_ = (t, s, n) => {
  if (!t || !t.length)
    return { currentRolloutWeight: 0, parsedSteps: [], currentSetWeight: 0 };
  const a = t.map(QT), r = n === "Healthy" ? 100 : JT(t, s), o = t[s]?.setWeight ?? 0;
  return { currentRolloutWeight: r, parsedSteps: a, currentSetWeight: o };
}, ZT = (t, s) => t < s ? "G500" : t === s ? "O500" : "N900", sc = (t) => t == Ns.NOT_FOUND, B_ = (t, s, n) => {
  if (t === "Healthy")
    return { rolloutStatus: "Rollout Complete", nextAction: null };
  const a = "No action required";
  return t === "Progressing" ? n ? {
    rolloutStatus: "Promoting",
    nextAction: null
  } : {
    rolloutStatus: "In Progress",
    nextAction: a
  } : s ? { rolloutStatus: "In Progress", nextAction: a } : { rolloutStatus: "Awaiting traffic swap", nextAction: "Swap Traffic" };
}, eI = ({
  phase: t,
  autoPromotionEnabled: s,
  promoteFull: n,
  renderRollbackButton: a,
  handleOpenSwapTrafficDialog: r
}) => {
  const { rolloutStatus: o } = B_(t, s, n), i = {
    title: "Blue Green Strategy",
    iconName: "ic-strategy-blue-green-color",
    status: o
  };
  return t === "Healthy" ? {
    ...i,
    renderActionButton: a
  } : t === "Progressing" ? {
    ...i,
    currentSetWeight: 100,
    currentRolloutWeight: 0,
    ...n ? { renderActionButton: a } : {
      actionButtonConfig: {
        text: "Skip & promote full",
        onClick: r
      }
    }
  } : {
    ...i,
    actionButtonConfig: {
      text: s ? "Skip & promote full" : "Swap traffic",
      onClick: r
    },
    ...s ? {
      currentSetWeight: 100,
      currentRolloutWeight: 0
    } : {}
  };
}, EF = "deployment-window-status", CF = {
  HIBERNATE: "Hibernate",
  RESTORE: "Restore",
  DEPLOY: "Deployment",
  RESOURCE: "Resource deletion",
  RESTART: "Restart workloads",
  PIPELINE: "Pipeline deletion",
  UNHIBERNATE: "Unhibernate"
}, tI = {
  [Zt.BLACKOUT]: "Blackout window is active",
  [Zt.MAINTENANCE]: "Outside maintenance window"
};
async function sI(t, s, n) {
  try {
    return await le(
      ye($.DEPLOYMENT_WINDOW_STATE, {
        appId: t,
        envIds: s
      }),
      { abortControllerRef: n }
    );
  } catch (a) {
    return !Pe(a) && a.code !== 400 && V(a), { code: 400, result: { profiles: [] }, status: "error" };
  }
}
const nI = async (t, s, n, a) => {
  try {
    const { result: r } = await le(
      ye(
        n === bm.OVERVIEW ? $.DEPLOYMENT_WINDOW_OVERVIEW : $.DEPLOYMENT_WINDOW_STATE,
        {
          appId: t,
          envIds: s ?? a
        }
      )
    );
    return r ?? { profiles: [] };
  } catch (r) {
    return r.code !== 400 && V(r), null;
  }
}, bF = (t, s) => {
  let n = !1;
  return t.result?.environmentStateMap?.[s]?.userActionState && (n = t.result.environmentStateMap[s].userActionState !== Pc.ALLOWED), n;
}, aI = (t, s) => s === Zt.MAINTENANCE && !t || s === Zt.BLACKOUT && t ? tI[s] : "", rI = (t, s) => {
  let n = "", a = "", r = "", o = !1, i = Pc.ALLOWED, l = [], c = "";
  if (t?.environmentStateMap?.[s]) {
    i = t.environmentStateMap[s].userActionState || "", l = t.environmentStateMap[s].excludedUserEmails ?? [];
    const { appliedProfile: d } = t.environmentStateMap[s];
    d && (n = d.deploymentWindowProfile.name ?? "", a = d.calculatedTimestamp ?? "", r = d.deploymentWindowProfile.type ?? "", o = d.isActive ?? !1, c = aI(
      d.isActive,
      d.deploymentWindowProfile.type
    ));
  }
  return {
    name: n,
    calculatedTimestamp: a,
    type: r,
    isActive: o,
    userActionState: i,
    excludedUserEmails: l,
    warningMessage: c
  };
}, NF = async (t, s) => {
  const n = await sI(t, s);
  return rI(n?.result, s);
};
async function $_(t) {
  return we($.DEPLOYMENT_WINDOW_STATE_APP_GROUP, t);
}
async function TF(t, s, n) {
  const a = {};
  try {
    const { result: r } = await $_(t);
    r.appData && r.appData.forEach((o) => {
      t.forEach((i) => {
        const { appliedProfile: l } = o.deploymentProfileList.environmentStateMap[i.envId];
        l && l.deploymentWindowProfile.type && (s(!1), a[o.appId] = {
          type: l.deploymentWindowProfile.type,
          excludedUserEmails: o.deploymentProfileList.environmentStateMap[n].excludedUserEmails,
          userActionState: o.deploymentProfileList.environmentStateMap[n].userActionState,
          isActive: l.isActive
        });
      });
    });
  } catch (r) {
    V(r);
  }
  return a;
}
async function IF(t) {
  try {
    const s = [];
    t.forEach((r) => {
      r.nodes.forEach((o) => {
        o.type === Ia.CD && s.push({ appId: r.appId, envId: o.environmentId });
      });
    });
    const { result: n } = await $_(s), a = {};
    n.appData && (n.appData.forEach((r) => {
      a[r.appId] = r.deploymentProfileList.environmentStateMap;
    }), t.forEach((r) => {
      const o = a[r.appId];
      o && r.nodes.forEach((i) => {
        (i.type === Ia.PRE_CD || i.type === Ia.CD || i.type === Ia.POST_CD) && o[i.environmentId]?.userActionState && (i.isDeploymentBlocked = o[i.environmentId].userActionState !== Pc.ALLOWED);
      });
    }));
  } catch (s) {
    V(s);
  }
  return t;
}
const vF = {
  propagateTippy: {
    title: "Propagate tags to K8s resources",
    infoLine1: {
      preIconText: "Click on the",
      postIconText: "icon to propagate tags as"
    },
    infoLine2: "labels to Kubernetes resources."
  },
  injectTagInfoModal: {
    title: "Inject tags to Kubernetes resources",
    description: {
      para1: "You can choose to inject a tag to Kubernetes resources.",
      para2: "When such a tag is applied on an application, it will be injected as label to Kubernetes resources of the application.",
      para3: "TIP: Use tags to check consolidated billing for all resources in an application via Kubernetes cost monitoring tools like kubecost."
    },
    buttonText: "Got it"
  }
}, AF = {
  title: "Tags",
  description: {
    para1: "Enhance your application's metadata with tags!",
    para2: "Tags will appear as suggestions when adding tags.",
    para3: "Enforce tagging of applications in a project by making a tag mandatory for the project."
  }
}, SF = "Not mandatory", yF = {
  TITLE: "is an isolated environment",
  SUBTITLE: "Deployments to this environment generate a helm chart package. The packaged helm chart contains all the necessary configuration and metadata to deploy the application to any Kubernetes cluster"
}, oI = {
  generateHelmManifest: "Last helm package",
  isolatedEnvTippy: "Isolated environments enable you to generate helm chart packages that can be installed on clusters which are not connected to Devtron.",
  generateHelmChartPackage: "Generated helm chart package",
  isolatedEnvironment: "Isolated environment",
  pushGeneratedHelmPackage: "Where do you want to push generated helm package?"
}, LF = {
  addKubernetesCluster: "Add Kubernetes Cluster",
  subTitleAddK8s: "Add a managed or on-premise Kubernetes cluster",
  addIsolatedCluter: "Add Isolated Cluster",
  subTitleAddIsolated: "Use an isolated cluster to make and organise isolated deployments.",
  clusterNameInputName: "cluster_name",
  clusterNameInputLabel: "Cluster Name",
  clusterNameInputPlaceholder: "Cluster name",
  deleteButtonLabel: "Delete",
  cancelButtonLabel: "Cancel",
  isolatedClusterInfoMessage: "An isolated cluster is not connected to the cloud and can be used to make and organise isolated deployments. The isolated cluster can contain isolated environments which can eventually be used to make isolated deployments. Eg. You can deploy to an isolated environment which points to a git/chart repository. Deploying to a isolated environment will push the manifest to the repository. This manifest can be used to deploy to a Kubernetes cluster via third party tools or manually.",
  deploymentToIsolatedEnvironment: "Deploying to a isolated environment generates a helm chart package that can be used to deploy in clusters which are not connected to Devtron."
}, jF = {
  NO_ARTIFACTS_TITLE: "No artifacts generated",
  NO_ARTIFACT_SUBTITLE: "No artifacts were generated as the pipeline failed.",
  PIPELINE_PROGRESS_TITLE: "Pipeline is in progress",
  PIPELINE_PROGRESS_SUBTITLE: "Generated artifact(s) will be available here after the pipeline is executed."
}, OF = {
  DESCRIPTION: "Scoped variable is a key-value pair. Value can be scoped and can be used dynamically across devtron.",
  SCOPES: ["Application + Environment", "Application", "Environment", "Cluster", "Global"]
}, RF = `apiVersion: devtron.ai/v1beta1
kind: Variable
spec:
  # Name of the variable, must be unique
- name: KAFKA 
  #Provide a short description for this variable in max 120 characters. This description will be shown in UI while using the variable.
  shortDescription: Enter a short description here
  # Mention notes that tell more about this variable. This will not be shown in UI while using the variable. No char limit.
  notes: Enter any notes for additional details 
  # Optional property. Accepts Boolean Value, default value false. Values for sensitive variables are not shown in UI while using the variable
  isSensitive: false 
  # List of values for this variable
  values: 
      #Global category can be used to define variables which are common across all applications
    - category: Global 
      value: Global 
      #Cluster category can be used to define variables which are common across all environments of a particular cluster
    - category: Cluster 
      value: Cluster-8080
      selectors:
        attributeSelectors:
          # ClusterName is required for cluster category
          ClusterName: prod-cluster
      #Application category can be used to define variables which are common across all workflows of a particular applications 
    - category: Application 
      value: Application-8080
      selectors:
        attributeSelectors:
          # ApplicationName is required for application category
          ApplicationName: dev-test-1 
      #Env category can be used to define variables which are common across all applications deployed on a particular environment
    - category: Env
      value: Prod-Env
      selectors:
        attributeSelectors:
          #EnvName is required for env category
          EnvName: dev-test-1 
      #ApplicationEnv category can be used to define variables which are scoped for a particular environment of an application
    - category: ApplicationEnv 
      value: Application-8080
      selectors:
        attributeSelectors:
          # ApplicationName is required for applicationEnv category
          ApplicationName: dev-test
          # EnvName is required for applicationEnv category 
          EnvName: virtual-env-1`, PF = {
  FETCHING_NOTIFICATION_DETAILS: "We are fetching the details...",
  HOLD_ON: "Hold on!",
  SOMETHING_WENT_WRONG: "Something went wrong",
  REQUEST_COULD_NOT_BE_PROCESSED: "Your request could not be processed. Please try again.",
  UNAUTHORIZED: "Not authorized",
  UNAUTHORIZED_MESSAGE: "You must have approver permission to perform this action.",
  UNABLE_TO_PROCESS: "Unable to process approval"
};
it.extend(tx);
it.extend(sx);
it.extend(nx);
it.extend(ax);
it.extend(rx);
const wF = () => /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__align-start fs-11 fw-4 mt-6", children: [
  /* @__PURE__ */ e.jsx(zN, { className: "icon-dim-16" }),
  /* @__PURE__ */ e.jsx("div", { className: "ml-4 cn-7", children: oI.isolatedEnvironment })
] }), ar = (t, s, n) => {
  const a = (/* @__PURE__ */ new Date()).getTimezoneOffset() * 60 * 1e3, r = it.utc(t).tz(s).utcOffset() * 60 * 1e3, o = a + r;
  return new Date(new Date(t).getTime() + (n ? o : -o));
}, DF = "helm packages", fd = () => {
  const t = it().utcOffset();
  return it().utcOffset(t).format("Z");
}, hd = () => Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone ?? "", MF = ({ appId: t, envId: s, modalType: n, filteredEnvIds: a }) => {
  const [r, o] = v(!0), [i, l] = v({}), [c, d] = v(), [p, m] = v({}), [u, f] = v([]), _ = () => {
    const h = {};
    o(!0), nI(t, s, n, a).then((x) => {
      if (Object.keys(x || {}).length === 0) return;
      const g = [];
      x.profiles?.forEach((C) => {
        let b;
        const N = structuredClone(C);
        h[C.envId] ? b = h[C.envId] : b = {
          blackoutWindows: [],
          maintenanceWindows: []
        }, N.deploymentWindowProfile.deploymentWindowList = C.deploymentWindowProfile.deploymentWindowList.map((I) => {
          const T = {
            ...I,
            ...I.frequency === he.FIXED ? {
              timeFrom: ar(
                I.timeFrom,
                C.deploymentWindowProfile.timeZone,
                !0
              ).toISOString(),
              timeTo: ar(
                I.timeTo,
                C.deploymentWindowProfile.timeZone,
                !0
              ).toISOString()
            } : null
          };
          return g.push({
            ...T,
            name: C.deploymentWindowProfile.name,
            type: C.deploymentWindowProfile.type,
            id: C.deploymentWindowProfile.id
          }), T;
        }), C.deploymentWindowProfile.type === Zt.BLACKOUT ? b.blackoutWindows.push(N) : b.maintenanceWindows.push(N), h[N.envId] = b;
      });
      let E = g;
      g.length > 3 && (E = g.slice(0, 4)), f(E), l(h), s && (d(x.environmentStateMap[+s]?.appliedProfile), m(x.environmentStateMap));
    }).catch((x) => {
      V(x);
    }).finally(() => {
      o(!1);
    });
  };
  return J(() => {
    _();
  }, [a, s]), { environmentProfileDetails: i, loading: r, appliedProfile: c, reloadData: _, environmentStateMap: p, statusCardStack: u };
}, Dp = (t) => t >= 10 ? t : `0${t}`, Mp = (t) => {
  const s = it().toDate(), n = it(t).diff(s), a = parseInt(`${n / 1e3}`, 10), r = parseInt(`${a / 60}`, 10), o = parseInt(`${r / 60}`, 10), i = it.duration(n).seconds(), l = it.duration(n).minutes(), c = it.duration(n).hours(), d = it.duration(n).days(), p = `${Dp(i)}s`, m = `${Dp(l)}m`, u = `${c + d * 24}h`;
  return a < 1 ? "" : r < 1 ? `${p}` : o < 1 ? `${m}:${p}` : `${u}:${m}:${p}`;
}, iI = (t, s, n) => {
  const a = `${s ? "scy-7" : "scg-5"} ${n === bm.OVERVIEW ? "icon-dim-12" : "icon-dim-16"}`;
  return t === he.FIXED || t === "" ? /* @__PURE__ */ e.jsx(WN, { className: a }) : /* @__PURE__ */ e.jsx(qN, { className: a });
}, lI = (t) => t.cdWorkflowType ? `?runner=${t.cdWorkflowType}` : t.isHelmApp ? "" : `?runner=${Sa.CD}`, cI = (t) => `${t.isHelmApp ? Ee.APP_STORE_HELM : se.APPLICATION_MANAGEMENT_APP}/${Ee.MANIFEST_DOWNLOAD}/${t.appId}/${t.envId}${t.workflowId ? `/${t.workflowId}` : ""}${lI(t)}`, kF = () => /* @__PURE__ */ e.jsxs("div", { className: "border-top__secondary flex dc__gap-4 p-12 cn-7", children: [
  /* @__PURE__ */ e.jsx("p", { className: "m-0 lh-18", children: "By logging in, you agree to our " }),
  /* @__PURE__ */ e.jsx(
    "a",
    {
      href: window.location.origin === Sp ? bx : Nx,
      target: "blank",
      rel: "noreferrer",
      className: "anchor lh-18",
      children: window.location.origin === Sp ? "Privacy Policy" : "User License"
    }
  )
] }), dI = async ({
  appId: t,
  envId: s,
  helmPackageName: n,
  cdWorkflowType: a,
  handleDownload: r,
  appName: o
}) => {
  const i = {
    appId: t,
    envId: s,
    appName: o || n || "helm-package",
    ...a ? { cdWorkflowType: a } : {}
  }, l = cI(i);
  return r({
    downloadUrl: l,
    fileName: i.appName.endsWith(".gz") ? i.appName : `${i.appName}.gz`,
    downloadSuccessToastContent: "Manifest Downloaded Successfully"
  });
}, V_ = async (t) => {
  const { result: s } = await we($.CD_PIPELINE_STRATEGIES, { pipelineIds: t });
  return (s ?? []).map(({ pipelineId: n, strategies: a, error: r }) => ({
    pipelineId: n,
    strategies: a ?? [],
    error: r
  }));
}, co = {
  DEFAULT: "ic-gear",
  "BLUE-GREEN": "ic-strategy-blue-green-color",
  CANARY: "ic-strategy-canary-color",
  RECREATE: "ic-strategy-recreate-color",
  ROLLING: "ic-strategy-rolling-color",
  ROLLINGUPDATE: "ic-rocket-gear",
  ONDELETE: "ic-rocket-gear"
}, El = {
  DEFAULT: "ic-gear",
  "BLUE-GREEN": "ic-strategy-blue-green",
  CANARY: "ic-strategy-canary",
  RECREATE: "ic-strategy-recreate",
  ROLLING: "ic-strategy-rolling",
  ROLLINGUPDATE: "ic-rocket-gear",
  ONDELETE: "ic-rocket-gear"
}, pI = ({
  hasError: t,
  bulkDeploymentStrategy: s,
  currentDeploymentStrategy: n
}) => n === "DEFAULT" ? "Deployment will be triggered using strategy defined in chart" : t ? "Could not fetch strategies for current pipeline, please reload" : n ? `Deployment will be triggered using ${Mn[n] ?? n} strategy` : `${Mn[s] ?? s} strategy is not configured. Deployment will be skipped.`, uI = (t) => t.reduce((s, n) => (s[n.pipelineId] = {
  strategies: n.strategies.map(({ deploymentTemplate: a }) => a) ?? [],
  error: n.error
}, s), {}), mI = ({
  strategies: t,
  selectedValue: s,
  handleUpdateStrategy: n,
  error: a,
  reloadOptions: r
}) => {
  if (!t?.length)
    return /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-6", children: [
      /* @__PURE__ */ e.jsx(W, { name: "ic-info-filled", color: "B500" }),
      /* @__PURE__ */ e.jsx("span", { children: "Strategy not found" })
    ] });
  const o = t.map((l) => ({
    value: l,
    label: Mn[l] ?? l,
    startIcon: /* @__PURE__ */ e.jsx(W, { name: co[l] ?? "ic-rocket-gear", color: null })
  })), i = ({ value: l }) => {
    n(l);
  };
  return /* @__PURE__ */ e.jsx(
    Ve,
    {
      inputId: "select-strategy-for-app",
      options: o,
      variant: cn.COMPACT,
      placeholder: "Select strategy",
      icon: /* @__PURE__ */ e.jsx(W, { name: "ic-gear", color: null }),
      size: O.medium,
      showSelectedOptionIcon: !0,
      onChange: i,
      value: wc(o, s, null),
      ...a ? {
        optionListError: new Ua({ code: a.code, errors: [a] }),
        reloadOptionList: r
      } : {}
    }
  );
}, FF = ({
  appList: t,
  envName: s,
  onClickDeploy: n,
  bulkDeploymentStrategy: a,
  pipelineIdVsStrategyMap: r,
  setPipelineIdVsStrategyMap: o
}) => {
  const [i, l, c, d] = ne(
    () => V_(t.map((C) => C.pipelineId))
  ), { sortBy: p, sortOrder: m, handleSorting: u } = vs({}), f = de(t), _ = Q(() => {
    if (!p)
      return f.current;
    const C = [...t].sort((b, N) => p === "appName" ? Ce(b.appName, N.appName, m) : Ce(
      r[b.pipelineId] ?? "",
      r[N.pipelineId] ?? "",
      m
    ));
    return f.current = C, C;
  }, [p, m]), h = Q(
    () => uI(l ?? []),
    [l]
  );
  if (J(() => {
    if (l) {
      const C = {};
      l.forEach(({ pipelineId: b, strategies: N, error: I }) => {
        !!N.find(
          (A) => A.deploymentTemplate === a
        ) ? C[b] = a : sc(I?.code) && (C[b] = "DEFAULT");
      }), o(C), u("deploymentStrategy");
    }
  }, [l]), i)
    return /* @__PURE__ */ e.jsx(
      _e,
      {
        SvgImage: jr,
        title: `Checking deployment feasibility for ${t.length} Applications on '${s}'`,
        subTitle: "It might take some time depending upon the number of applications"
      }
    );
  if (c)
    return /* @__PURE__ */ e.jsx(Xe, { code: c.code, reload: d });
  const x = (C) => () => u(C), g = (C) => (b) => {
    const N = {
      ...r,
      [C]: b
    };
    o(N), u(null);
  }, E = t.filter(
    ({ pipelineId: C }) => !!r[C] || sc(h[C]?.error?.code)
  ).length;
  return /* @__PURE__ */ e.jsxs("div", { className: "bg__primary dc__overflow-auto dc__content-space flexbox-col flex-grow-1 h-100", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1 mh-0 dc__overflow-auto pb-16", children: [
      /* @__PURE__ */ e.jsx("div", { className: "p-20", children: /* @__PURE__ */ e.jsxs("div", { className: "br-8 border__primary shadow__card--20", children: [
        /* @__PURE__ */ e.jsx(
          Ra,
          {
            entities: [
              { color: "var(--G500)", label: "Feasible", value: E },
              {
                color: "var(--R500)",
                label: "Not feasible",
                value: t.length - E
              }
            ],
            labelClassName: "fs-13 fw-4 lh-20 cn-9",
            countClassName: "fs-13 fw-6 lh-20 cn-9",
            showAnimationOnBar: !0,
            rootClassName: "p-16 border__secondary--bottom"
          }
        ),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-6 px-16 py-8", children: [
          /* @__PURE__ */ e.jsx(W, { name: "ic-info-outline", color: null, size: 20 }),
          /* @__PURE__ */ e.jsxs("span", { children: [
            "Deployment will be triggered for ",
            E,
            " applications"
          ] })
        ] })
      ] }) }),
      /* @__PURE__ */ e.jsxs("div", { className: "feasibility-row border__secondary--bottom py-8 px-20 fs-12 lh-20 cn-7 dc__position-sticky dc__top-0 bg__primary dc__zi-1", children: [
        /* @__PURE__ */ e.jsx(
          Ne,
          {
            title: "APPLICATION",
            isSorted: p === "appName",
            sortOrder: m,
            isSortable: !0,
            triggerSorting: x("appName"),
            disabled: !1
          }
        ),
        /* @__PURE__ */ e.jsx(
          Ne,
          {
            title: "DEPLOYMENT STRATEGY",
            isSorted: p === "deploymentStrategy",
            sortOrder: m,
            isSortable: !0,
            triggerSorting: x("deploymentStrategy"),
            disabled: !1
          }
        ),
        /* @__PURE__ */ e.jsx(
          Ne,
          {
            title: "MESSAGE",
            isSorted: !1,
            sortOrder: null,
            isSortable: !1,
            triggerSorting: Be,
            disabled: !1
          }
        )
      ] }),
      _.map(({ appName: C, pipelineId: b }) => {
        const N = h[b], I = r[b], T = I === "DEFAULT";
        return /* @__PURE__ */ e.jsxs("div", { className: "feasibility-row py-8 px-20 fs-13 fw-4 cn-9 lh-20", children: [
          /* @__PURE__ */ e.jsx("span", { children: C }),
          T ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-6", children: [
            /* @__PURE__ */ e.jsx(W, { name: "ic-info-filled", color: "B500", size: 20 }),
            "Strategy not found"
          ] }) : /* @__PURE__ */ e.jsx("div", { className: "dc__mxw-fit-content", children: /* @__PURE__ */ e.jsx(
            mI,
            {
              selectedValue: I,
              strategies: N?.strategies,
              error: N?.error,
              reloadOptions: d,
              handleUpdateStrategy: g(b)
            }
          ) }),
          /* @__PURE__ */ e.jsx("span", { children: pI({
            hasError: !!N?.error,
            currentDeploymentStrategy: I,
            bulkDeploymentStrategy: a
          }) })
        ] }, C);
      })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "flex dc__align-items-center dc__content-end px-20 py-16 border__secondary--top", children: /* @__PURE__ */ e.jsx(
      Tx,
      {
        dataTestId: "cd-trigger-deploy-button",
        text: "Deploy",
        onButtonClick: n,
        startIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-rocket-launch", color: null }),
        disabled: !E
      }
    ) })
  ] });
};
var ot = /* @__PURE__ */ ((t) => (t.FAIL = "Fail", t.SUCCESS = "Success", t.PROGRESSING = "Progressing", t))(ot || {});
const Y_ = (t) => {
  switch (t) {
    case ot.FAIL:
      return /* @__PURE__ */ e.jsx(W, { name: "ic-close-large", color: "R500" });
    case ot.SUCCESS:
      return /* @__PURE__ */ e.jsx(W, { name: "ic-check", color: "G500" });
    default:
      return /* @__PURE__ */ e.jsx(W, { name: "ic-circle-loader", color: "N300" });
  }
}, _I = (t) => {
  switch (t) {
    case ot.FAIL:
      return "Failed";
    case ot.SUCCESS:
      return "Succeeded";
    default:
      return "Progressing";
  }
};
var xs = /* @__PURE__ */ ((t) => (t.CI_BUILD = "CI_BUILD", t.LINKED_CI = "LINKED", t.EXTERNAL_CI = "EXTERNAL", t.CI_JOB = "CI_JOB", t.LINKED_CD = "LINKED_CD", t))(xs || {}), ns = /* @__PURE__ */ ((t) => (t.SELECT_ENV = "SelectEnv", t.FEASIBILITY = "Feasibility", t.SWITCH = "Switch", t))(ns || {});
const fI = (t) => {
  const s = +t.id;
  return t.type === Ia.WEBHOOK ? { pipelineType: xs.EXTERNAL_CI, pipelineId: s } : t.isJobCI ? { pipelineType: xs.CI_JOB, pipelineId: s } : t.isLinkedCD ? { pipelineType: xs.LINKED_CD, pipelineId: s } : t.isLinkedCI ? { pipelineType: xs.LINKED_CI, pipelineId: s } : { pipelineType: xs.CI_BUILD, pipelineId: s };
}, H_ = (t) => t.flatMap((s) => s.nodes.map((n) => ({ ...n, appName: s.name, appId: s.appId }))).filter((s) => s.type === Ia.CI || s.type === Ia.WEBHOOK), hI = (t, s) => {
  const n = new Map(s.map((a) => [+a.id, a.appName]));
  return t.map(({ sourcePipelineId: a, status: r, statusDetails: o }) => ({
    pipelineId: a,
    appName: n.get(a),
    status: r,
    statusDetails: o
  }));
}, K_ = async ({
  dryRun: t = !1,
  destinationPipelineData: s,
  ciNodes: n
}) => {
  const a = {
    dryRun: t
  }, r = ye($.CI_PIPELINE_SWITCH, a), o = {
    sourcePipelines: n.map(fI),
    destinationPipelineData: s
  }, i = await we(r, o);
  return hI(i.result, n);
}, gI = () => /* @__PURE__ */ e.jsx(
  _e,
  {
    title: "Checking feasibility...",
    subTitle: "It might take some time depending upon the number of applications",
    SvgImage: jr
  }
), W_ = ({ changeCIFeasibility: t, isDryRun: s }) => {
  const n = (a) => {
    switch (a) {
      case ot.FAIL:
        return s ? "Cannot change" : "Failed to change";
      case ot.SUCCESS:
        return s ? "Can change" : "Changed";
      default:
        return "Progressing";
    }
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "px-20 py-20 flexbox-col flex-grow-1 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "dc__grid dc__gap-16 feasibility-modal-columns fs-12 fw-6 lh-18 cn-7 py-8", children: [
      /* @__PURE__ */ e.jsx("span", { children: "APPLICATION" }),
      /* @__PURE__ */ e.jsx("span", { children: s ? "FEASIBILITY" : "CHANGE SOURCE STATUS" }),
      /* @__PURE__ */ e.jsx("span", { children: "MESSAGE" })
    ] }),
    t.map((a) => /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "dc__grid dc__gap-16 feasibility-modal-columns fs-13 fw-4 lh-20 cn-9 py-8",
        children: [
          /* @__PURE__ */ e.jsx("span", { className: "dc__ellipsis-right", children: a.appName }),
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__h-fit-content dc__gap-6", children: [
            Y_(a.status),
            /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-20 cn-9", children: n(a.status) })
          ] }),
          /* @__PURE__ */ e.jsx("span", { children: a.statusDetails })
        ]
      },
      `${a.appName}=${a.pipelineId}`
    ))
  ] });
}, q_ = ({
  ciNodes: t,
  envName: s,
  setCINodes: n,
  handleTriggerSwitchPipelines: a
}) => {
  const [r, o, i, l] = ne(
    () => K_({
      dryRun: !0,
      ciNodes: t,
      destinationPipelineData: {
        pipelineType: s ? xs.LINKED_CD : xs.CI_BUILD,
        ...s ? {
          customConfigurations: {
            linkedCdEnvironment: s
          }
        } : {}
      }
    })
  ), c = new Map(
    o?.map((f) => [f.pipelineId, f.status === ot.SUCCESS])
  ), d = () => {
    n(t.filter((f) => c.get(+f.id))), a();
  }, p = o?.filter(
    (f) => f.status === ot.SUCCESS
  ).length, m = o?.length;
  return r ? /* @__PURE__ */ e.jsx(gI, {}) : i ? /* @__PURE__ */ e.jsx(Xe, { code: i.code, reload: l }) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsx(W_, { isDryRun: !0, changeCIFeasibility: o }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox px-20 py-16 dc__content-space dc__border-top", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8", children: [
        p === m ? /* @__PURE__ */ e.jsx(qs, { className: "icon-dim-20 scg-5 dc__no-shrink" }) : /* @__PURE__ */ e.jsx(Va, { className: "icon-dim-20 dc__no-shrink" }),
        /* @__PURE__ */ e.jsxs("span", { className: "fs-13 fw-4 lh-20 cn-9", children: [
          p,
          "/",
          m,
          " selected applications ",
          s ? `can be synced with ${s}` : "image source can be changed to build pipeline"
        ] })
      ] }),
      /* @__PURE__ */ e.jsx(
        j,
        {
          dataTestId: "change-ci-create-build-pipeline",
          text: s ? "Change image source" : "Create build pipeline",
          size: O.medium,
          disabled: !p,
          onClick: d
        }
      )
    ] })
  ] });
}, kp = 20, z_ = ({
  ciNodes: t,
  setCINodes: s,
  pipelineType: n,
  customConfigurations: a,
  handleCloseChangeCIModal: r
}) => {
  const [o, i] = v(!1), [l, c] = v(
    t.reduce(
      (g, E) => ({
        ...g,
        [E.id]: { appName: E.appName, status: ot.PROGRESSING, statusDetails: "" }
      }),
      {}
    )
  ), d = async () => {
    const { FORCE_SECURITY_SCANNING: g, RECOMMEND_SECURITY_SCANNING: E, DEFAULT_CI_TRIGGER_TYPE_MANUAL: C } = window._env_, b = {};
    i(!0);
    const N = [];
    for (let I = 0; I < t.length; I += kp)
      N.push(async () => {
        const T = t.slice(I, I + kp);
        try {
          (await K_({
            dryRun: !1,
            ciNodes: T,
            destinationPipelineData: {
              pipelineType: n,
              customConfigurations: {
                ...a,
                isManual: C ?? !1,
                scanEnabled: (E || g) ?? !1
              }
            }
          })).forEach((S) => {
            b[S.pipelineId] = {
              appName: S.appName,
              status: S.status,
              statusDetails: S.statusDetails,
              pipelineId: S.pipelineId
            };
          });
        } catch (A) {
          T.forEach((S) => {
            b[+S.id] = {
              ...l[+S.id],
              status: ot.FAIL,
              statusDetails: A?.errors?.[0].userMessage || ""
            };
          });
        } finally {
          c({ ...l, ...b });
        }
      });
    await Tr(N, !1, N.length), i(!1);
  };
  J(() => {
    d();
  }, [t]);
  const p = () => {
    const g = t.filter(
      (C) => l[+C.id]?.status === ot.FAIL
    ), E = g.reduce(
      (C, b) => ({
        ...C,
        [b.id]: { appName: b.appName, status: ot.PROGRESSING, statusDetails: "" }
      }),
      {}
    );
    s(g), c(E);
  }, m = Object.values(l), u = (g) => m.filter((E) => E.status === g).length, f = u(ot.FAIL), _ = u(ot.SUCCESS), h = u(ot.PROGRESSING), x = [
    {
      color: "var(--G500)",
      label: "Success",
      value: _
    },
    {
      color: "var(--Y500)",
      label: "Progressing",
      value: h
    },
    {
      color: "var(--R500)",
      label: "Failed",
      value: f
    }
  ];
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16 flex-grow-1 mh-0", children: [
      /* @__PURE__ */ e.jsx("div", { className: "px-20 pt-16", children: /* @__PURE__ */ e.jsxs("div", { className: "dc__border br-8 shadow__card--20", children: [
        /* @__PURE__ */ e.jsx(
          Ra,
          {
            entities: x,
            rootClassName: "fs-13 dc__border-bottom-n1 p-16"
          }
        ),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 py-8 px-16 dc__align-items-center", children: [
          /* @__PURE__ */ e.jsx(
            W,
            {
              name: o ? "ic-circle-loader" : "ic-info-outline",
              size: 20,
              color: "Y500"
            }
          ),
          /* @__PURE__ */ e.jsx("span", { children: o ? "Progressing" : `Image source changed for ${_} environment(s)` })
        ] })
      ] }) }),
      /* @__PURE__ */ e.jsx(W_, { changeCIFeasibility: m, isDryRun: !1 })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox px-20 py-16 dc__gap-16 dc__border-top", children: [
      /* @__PURE__ */ e.jsx(
        j,
        {
          dataTestId: "close-change-ci-bulk",
          text: "Close",
          style: B.neutral,
          variant: w.secondary,
          size: O.medium,
          onClick: r,
          disabled: o
        }
      ),
      !!f && !o && /* @__PURE__ */ e.jsx(
        j,
        {
          dataTestId: "retry-change-ci-bulk",
          text: "Retry failed",
          startIcon: /* @__PURE__ */ e.jsx(Lo, {}),
          size: O.medium,
          onClick: p
        }
      )
    ] })
  ] });
}, Fp = {
  BranchFixed: "Branch fixed",
  BranchRegex: "Branch regex"
}, X_ = [
  {
    label: Fp.BranchFixed,
    value: Yl.BranchFixed
  },
  {
    label: Fp.BranchRegex,
    value: Yl.BranchRegex
  }
], xI = ({
  sourceType: t,
  branchName: s,
  handleBranchNameChange: n,
  handleChangeSourceType: a,
  handleCloseGitSourceModal: r,
  handleCreatePipeline: o
}) => {
  const i = (l) => {
    l.key === "Enter" && (Le(l), o());
  };
  return /* @__PURE__ */ e.jsx(wi, { close: r, children: /* @__PURE__ */ e.jsxs("div", { className: "w-600 bg__primary flexbox-col br-8 dc__m-auto mt-40", onClick: Le, children: [
    /* @__PURE__ */ e.jsxs("div", { className: "dc__border-bottom px-20 py-16 flexbox dc__content-space", children: [
      /* @__PURE__ */ e.jsx("span", { className: "fs-16 fw-6 lh-24 cn-9", children: "Create build pipeline" }),
      /* @__PURE__ */ e.jsx(
        j,
        {
          dataTestId: "close-change-ci",
          ariaLabel: "close-change-ci",
          icon: /* @__PURE__ */ e.jsx(vt, {}),
          size: O.small,
          showAriaLabelInTippy: !1,
          variant: w.borderLess,
          style: B.negativeGrey,
          onClick: r
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8 p-20 h-250", children: [
      /* @__PURE__ */ e.jsx("span", { className: "fs-14 fw-6 lh-20 cn-9", children: "Select code source" }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-16", children: [
        /* @__PURE__ */ e.jsx("div", { className: "w-50", children: /* @__PURE__ */ e.jsx(
          Ve,
          {
            inputId: "select-branch-source-type",
            label: "Source type",
            required: !0,
            options: X_,
            value: t,
            onChange: a,
            size: O.large
          }
        ) }),
        /* @__PURE__ */ e.jsx("div", { className: "w-50", children: /* @__PURE__ */ e.jsx(
          yt,
          {
            autoFocus: !0,
            name: "change-ci-source",
            label: "Branch",
            required: !0,
            value: s,
            onChange: n,
            placeholder: `${t.label}`,
            onKeyDown: i
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__content-end py-16 px-20 dc__gap-12", children: [
      /* @__PURE__ */ e.jsx(
        j,
        {
          dataTestId: "cancel-change-source",
          text: "Cancel",
          variant: w.secondary,
          style: B.neutral,
          onClick: r
        }
      ),
      /* @__PURE__ */ e.jsx(
        j,
        {
          dataTestId: "cancel-change-source",
          text: "Create pipeline",
          onClick: o,
          disabled: !s
        }
      )
    ] })
  ] }) });
}, EI = ({ selectedWorkflows: t, handleCloseChangeCIModal: s }) => {
  const [n, a] = v(H_(t)), [r, o] = v(ns.FEASIBILITY), [i, l] = v(!1), [c, d] = v(X_[0]), [p, m] = v(""), u = () => {
    l(!0);
  }, f = () => {
    l(!1);
  }, _ = (b) => {
    d(b);
  }, h = (b) => {
    m(b.target.value);
  }, x = () => {
    p && (l(!1), o(ns.SWITCH));
  }, g = () => s(!0), E = () => {
    if (r === ns.SWITCH) {
      g();
      return;
    }
    s();
  }, C = () => r === ns.FEASIBILITY ? /* @__PURE__ */ e.jsx(
    q_,
    {
      ciNodes: n,
      setCINodes: a,
      handleTriggerSwitchPipelines: u
    }
  ) : /* @__PURE__ */ e.jsx(
    z_,
    {
      pipelineType: xs.CI_BUILD,
      ciNodes: n,
      customConfigurations: {
        ciMaterialSource: {
          type: c.value,
          ...c.value === Yl.BranchFixed ? {
            value: p
          } : {
            regex: p
          }
        }
      },
      setCINodes: a,
      handleCloseChangeCIModal: g
    }
  );
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx($t, { position: "right", onClose: E, onEscape: E, children: /* @__PURE__ */ e.jsxs("div", { className: "w-800 h-100 bg__primary flexbox-col", onClick: Le, children: [
      /* @__PURE__ */ e.jsxs("div", { className: "dc__border-bottom py-12 px-16 flexbox dc__content-space", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-4", children: [
          /* @__PURE__ */ e.jsx("span", { className: "fs-16 lh-24 fw-4 cn-9", children: "Change Image Source" }),
          /* @__PURE__ */ e.jsx(gr, { className: "icon-dim-20 dc__flip-180" }),
          /* @__PURE__ */ e.jsx("span", { className: "fs-16 fw-6 lh-24 cn-9", children: "build pipeline" }),
          r === ns.SWITCH && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx(gr, { className: "icon-dim-20 dc__flip-180" }),
            /* @__PURE__ */ e.jsx("span", { className: "fs-16 fw-6 lh-24 cn-9", children: "Status" })
          ] })
        ] }),
        /* @__PURE__ */ e.jsx(
          j,
          {
            dataTestId: "close-change-ci",
            ariaLabel: "close change ci modal",
            icon: /* @__PURE__ */ e.jsx(As, {}),
            size: O.xs,
            showAriaLabelInTippy: !1,
            variant: w.borderLess,
            style: B.negativeGrey,
            onClick: E
          }
        )
      ] }),
      C()
    ] }) }),
    i && /* @__PURE__ */ e.jsx(
      xI,
      {
        sourceType: c,
        branchName: p,
        handleBranchNameChange: h,
        handleChangeSourceType: _,
        handleCreatePipeline: x,
        handleCloseGitSourceModal: f
      }
    )
  ] });
}, UF = "Sync with Environment", GF = ["IMAGE SOURCE", "DEPLOY TO ENVIRONMENT"], BF = "Search environment", CI = "Keep deployments in sync with another environment by making images from the desired environment available for deployment.", bI = "Sync with Environment", $F = "Deployment pipeline created", VF = {
  DEPLOY_TO: "Deploy to...",
  CREATE_PIPELINE: "Create Pipeline",
  UPDATE_PIPELINE: "Update Pipeline",
  DELETE_PIPELINE: "Delete Pipeline"
}, YF = {
  IMAGE_SOURCE: "image-source",
  DEPLOY_TO: "deploy-to"
}, HF = {
  NO_SEARCH_ENV: {
    TITLE: "No environments found",
    SUBTITLE: "Try changing the search query"
  }
}, KF = {
  CREATION: "Pipeline created successfully",
  NO_SOURCE_SELECTED: "Please select an image source",
  SUCCESS_DELETE: "Pipeline deleted successfully"
}, WF = {
  LOADING_REQUEST: "Request in progress",
  SELECT_SOURCE: "Select an image source",
  ADD_NEW_DEPLOYMENT_PIPELINE: "Add deployment pipeline",
  CANT_ADD_DEPLOYMENT_PIPELINE: "Cannot add new workflow or deployment pipelines when environment filter is applied.",
  DISABLED_RADIO: {
    SELECTED: "Image source cannot belong to the same workflow",
    CYCLIC: "This environment cannot be used as image source as it is using another environment as image source",
    PRESENT: "Deployment pipeline already exists for this environment"
  }
}, qF = "0", NI = (t) => {
  const s = t?.action ?? Es.ALLOW_FOREVER;
  return s === Es.ALLOW_UNTIL_TIME ? {
    action: s,
    metadataField: t?.metadataField !== fs ? t?.metadataField : ""
  } : {
    action: s
  };
}, gd = (t) => ({
  requiredCount: t?.requiredCount ?? 0,
  type: t?.type ?? is.notConfigured,
  specificUsers: {
    identifiers: t?.specificUsers?.identifiers ?? [],
    requiredCount: t?.specificUsers?.identifiers?.length ?? 0
  },
  userGroups: (t?.userGroups ?? []).map((s) => ({
    identifier: s.identifier,
    requiredCount: s.requiredCount ?? 0
  }))
}), J_ = (t) => {
  if (!t?.result?.[0] || t.result[0]?.error) {
    const s = t?.result?.[0]?.error || "Something went wrong while fetching creation status";
    throw new Ua({
      code: Ns.BAD_REQUEST,
      errors: [
        {
          code: Ns.BAD_REQUEST,
          internalMessage: s,
          userMessage: s
        }
      ]
    });
  }
}, zF = async (t, s = !1) => {
  try {
    const { result: n } = await le(
      ye($.APP_CI_PIPELINE_RUNTIME_PARAMS, { pipelineId: t })
    );
    return Ix(n);
  } catch (n) {
    throw s && V(n), n;
  }
}, Q_ = async () => {
  const { result: t } = await le($.FILTERS_CRITERIA_META_DATA);
  return t;
}, XF = async (t) => {
  try {
    const { result: s } = await le(
      ye($.APP_IMAGE_TAGGING_LIST, { appName: t })
    );
    return s ? s.sort((n, a) => n.localeCompare(a)) : [];
  } catch (s) {
    throw V(s), s;
  }
}, TI = async (t) => {
  try {
    const s = ye($.APP_ENV_MIN, { appId: t }), { result: n } = await le(s), a = n.reduce(
      (r, { environmentId: o, environmentName: i, appId: l, appName: c, isProd: d, isVirtualEnvironment: p }) => r[o] ? (r[o].appList.push({ appId: l, appName: c }), r) : (r[o] = {
        environmentId: o,
        environmentName: i,
        isProd: d,
        isVirtualEnvironment: p,
        appList: [{ appId: l, appName: c }]
      }, r),
      {}
    );
    return Object.values(a);
  } catch (s) {
    throw V(s), s;
  }
}, Z_ = async () => {
  const { result: t } = await le($.LICENSE_DATA_DETAILS);
  return vx(t);
}, Qi = async ({
  name: t,
  namespace: s,
  clusterId: n,
  gvk: a,
  abortControllerRef: r,
  isResourceRecommender: o = !1,
  signal: i
}) => {
  const l = Dc({
    clusterId: n,
    group: a.Group,
    version: a.Version,
    kind: a.Kind,
    name: t,
    namespace: s
  });
  return (await we(
    o ? $.K8S_RESOURCE_RECOMMENDED : Ws.K8S_RESOURCE,
    l,
    { abortControllerRef: r, signal: i }
  ))?.result;
}, Zi = ({ name: t, namespace: s, clusterId: n, gvk: a, manifest: r }, o) => {
  const i = Dc({
    clusterId: n,
    group: a.Group,
    version: a.Version,
    kind: a.Kind,
    name: t,
    namespace: s || Co.value,
    updatedManifest: JSON.stringify(zs.parse(r))
  });
  return Bt(Ws.K8S_RESOURCE, i, { abortControllerRef: o });
}, xd = async ({ clusterId: t, manifest: s }, n) => {
  const r = await Nm({
    clusterId: t,
    manifest: s
  }, n);
  return J_(r), r.result;
}, JF = async (t) => {
  const { result: s } = await le(Ws.USER_LIST_MIN, { signal: t });
  return s.sort((n, a) => Ce(n.emailId, a.emailId));
}, II = ({ appIds: t, selectedEnv: s, setSelectedEnv: n, handleCheckFeasibility: a }) => {
  const { searchKey: r, handleSearch: o, clearFilters: i } = vs(), [l, c, d, p] = ne(() => TI(t)), m = (_) => {
    n(_.target.value);
  }, u = () => {
    const _ = r.toLowerCase(), h = c?.filter((x) => x.environmentName.includes(_)) ?? [];
    return h.length ? h.map((x) => {
      const { environmentName: g, environmentId: E, isProd: C } = x;
      return /* @__PURE__ */ e.jsx(Ze, { value: g, children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-6", children: [
        /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-20 cn-9", children: g }),
        C && /* @__PURE__ */ e.jsx("span", { className: "fs-10 fw-6 cn-7 lh-12 p-4 dc__border br-4 bcn-50", children: "PROD" })
      ] }) }, E);
    }) : /* @__PURE__ */ e.jsx(qt, { handleClearFilters: i });
  };
  return l ? /* @__PURE__ */ e.jsx(Je, {}) : d ? /* @__PURE__ */ e.jsx(Xe, { code: d.code, reload: p }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "py-12 px-20 dc__gap-12 flexbox dc__align-items-center", children: [
      /* @__PURE__ */ e.jsx(Qc, { className: "icon-dim-20" }),
      /* @__PURE__ */ e.jsx("span", { className: "fs-12 fw-6 lh-20 cn-7", children: "IMAGE SOURCE" })
    ] }),
    /* @__PURE__ */ e.jsx(
      Wt,
      {
        initialSearchText: r,
        containerClassName: "px-12 py-8",
        handleSearchChange: o
      }
    ),
    c?.length ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(
        ds,
        {
          className: "dc__overflow-auto flexbox-imp flexbox-col flex-grow-1 sync-with-cd-list dc__inline-radio-group dc__no-border-imp",
          name: "app-group-sync-cd",
          value: s,
          onChange: m,
          children: u()
        }
      ),
      /* @__PURE__ */ e.jsx("div", { className: "flexbox px-20 py-16 flex-justify-end dc__border-top", children: /* @__PURE__ */ e.jsx(
        j,
        {
          dataTestId: "change-ci-sync-cd-feasibility",
          text: "Next",
          endIcon: /* @__PURE__ */ e.jsx(Ms, {}),
          size: O.medium,
          disabled: !s,
          onClick: a
        }
      ) })
    ] }) : /* @__PURE__ */ e.jsx(_e, { title: "No environments" })
  ] });
}, vI = ({ selectedWorkflows: t, handleCloseChangeCIModal: s }) => {
  const [n, a] = v(H_(t)), [r, o] = v(ns.SELECT_ENV), [i, l] = v(null), c = () => {
    o(ns.SELECT_ENV);
  }, d = () => {
    o(ns.FEASIBILITY);
  }, p = () => {
    o(ns.SWITCH);
  }, m = () => s(!0), u = () => {
    if (r === ns.SWITCH) {
      m();
      return;
    }
    s();
  }, f = () => {
    switch (r) {
      case ns.SELECT_ENV:
        return /* @__PURE__ */ e.jsx(
          II,
          {
            appIds: n.map((_) => _.appId),
            handleCheckFeasibility: d,
            selectedEnv: i,
            setSelectedEnv: l
          }
        );
      case ns.FEASIBILITY:
        return /* @__PURE__ */ e.jsx(
          q_,
          {
            ciNodes: n,
            setCINodes: a,
            envName: i,
            handleTriggerSwitchPipelines: p
          }
        );
      default:
        return /* @__PURE__ */ e.jsx(
          z_,
          {
            pipelineType: xs.LINKED_CD,
            ciNodes: n,
            setCINodes: a,
            customConfigurations: {
              linkedCdEnvironment: i
            },
            handleCloseChangeCIModal: m
          }
        );
    }
  };
  return /* @__PURE__ */ e.jsx($t, { position: "right", onClose: u, onEscape: u, children: /* @__PURE__ */ e.jsxs("div", { className: "w-800 h-100 bg__primary flexbox-col", onClick: Le, children: [
    /* @__PURE__ */ e.jsxs("div", { className: "dc__border-bottom py-12 px-16 flexbox dc__content-space", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-12", children: [
        r === ns.FEASIBILITY && /* @__PURE__ */ e.jsx(
          j,
          {
            ariaLabel: "sync-cd-back",
            dataTestId: "sync-cd-back",
            icon: /* @__PURE__ */ e.jsx(Ms, { className: "dc__flip-180" }),
            variant: w.secondary,
            style: B.neutral,
            size: O.xs,
            showAriaLabelInTippy: !1,
            onClick: c
          }
        ),
        /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-4", children: [
          /* @__PURE__ */ e.jsx("span", { className: "fs-16 lh-24 fw-4 cn-9", children: "Change Image Source" }),
          /* @__PURE__ */ e.jsx(gr, { className: "icon-dim-20 dc__flip-180" }),
          /* @__PURE__ */ e.jsx("span", { className: "fs-16 fw-6 lh-24 cn-9", children: `Sync with ${r === ns.SWITCH ? i : "environment"}` }),
          /* @__PURE__ */ e.jsx(
            ca,
            {
              heading: bI,
              infoText: CI,
              iconClassName: "icon-dim-20"
            }
          ),
          r === ns.SWITCH && /* @__PURE__ */ e.jsx("span", { className: "fs-16 fw-6 lh-24 cn-9", children: "Status" })
        ] })
      ] }),
      /* @__PURE__ */ e.jsx(
        j,
        {
          dataTestId: "close-change-ci",
          ariaLabel: "close-change-ci",
          icon: /* @__PURE__ */ e.jsx(As, {}),
          size: O.xs,
          showAriaLabelInTippy: !1,
          variant: w.borderLess,
          style: B.negativeGrey,
          onClick: u
        }
      )
    ] }),
    f()
  ] }) });
}, QF = ({ selectedWorkflows: t, handleCloseChangeImageSource: s }) => {
  const [n, a] = v(!1), [r, o] = v(null), i = () => {
    a(!0);
  }, l = () => {
    a(!1);
  }, c = () => {
    a(!1), o(xs.CI_BUILD);
  }, d = (m) => {
    o(null), m && s();
  }, p = () => {
    a(!1), o(xs.LINKED_CD);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "change-ci-bulk",
        text: "Change image source",
        onClick: i,
        size: O.medium,
        style: B.neutral,
        variant: w.secondary
      }
    ),
    /* @__PURE__ */ e.jsx(
      Ax,
      {
        open: n,
        onClose: l,
        showLinkedCDSource: !0,
        addCIPipeline: c,
        addLinkedCD: p,
        addWebhookCD: Be,
        linkedCDSourceVariant: hT,
        changeCIPayload: null,
        resetChangeCIPayload: Be,
        isAppGroup: !0,
        isTemplateView: !1
      }
    ),
    r === xs.CI_BUILD && /* @__PURE__ */ e.jsx(
      EI,
      {
        selectedWorkflows: t,
        handleCloseChangeCIModal: d
      }
    ),
    r === xs.LINKED_CD && /* @__PURE__ */ e.jsx(
      vI,
      {
        selectedWorkflows: t,
        handleCloseChangeCIModal: d
      }
    )
  ] });
}, ZF = ({
  envId: t,
  envName: s,
  appIds: n,
  isDeploymentLoading: a,
  skipHibernated: r,
  setSkipHibernated: o
}) => {
  const [i, l, c, d] = ne(
    () => Sx({ envId: t, appIds: n }),
    []
  ), p = l?.apps.filter((_) => _.appStatus === Tm.HIBERNATING) ?? [], m = p.length;
  if (i)
    return /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-8 py-6", children: [
      /* @__PURE__ */ e.jsx(W, { name: "ic-circle-loader", size: 20, color: null }),
      /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-20", children: "Checking hibernated applications" })
    ] });
  if (!c && l && !m)
    return /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-8 py-6", children: [
      /* @__PURE__ */ e.jsx(W, { name: "ic-info-outline", size: 20, color: null }),
      /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-20", children: "None of the selected apps are hibernated" })
    ] });
  const u = () => /* @__PURE__ */ e.jsxs("div", { className: "fs-13 lh-20 cn-9 fw-4 p-12 mxh-200 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-20 fw-4 dc__word-break", children: `Hibernated applications deployed on ${s}:` }),
    /* @__PURE__ */ e.jsx("ol", { className: "p-0 mb-0 ml-16 mt-20", children: p.map(({ appId: _, appName: h }) => /* @__PURE__ */ e.jsx("li", { children: h }, `${_}-${h}`)) })
  ] }), f = () => {
    o((_) => !_);
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-8", children: [
    /* @__PURE__ */ e.jsx(
      $e,
      {
        dataTestId: "skip-hibernated-deployment",
        isChecked: r,
        value: Fe.CHECKED,
        onChange: f,
        rootClassName: "m-0",
        disabled: a,
        children: /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-20", children: "Do not deploy hibernated applications" })
      }
    ),
    c ? /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "reload-hibernated-apps",
        text: "View applications",
        variant: w.text,
        onClick: d
      }
    ) : /* @__PURE__ */ e.jsx(
      Dt,
      {
        heading: "Hibernated Applications",
        Icon: xb,
        showCloseButton: !0,
        theme: Mt.white,
        trigger: "click",
        additionalContent: u(),
        className: "w-300",
        interactive: !0,
        children: /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
          j,
          {
            dataTestId: "view-hibernated-apps",
            text: `View ${m} ${m === 1 ? "application" : "applications"}`,
            variant: w.text
          }
        ) })
      }
    )
  ] });
}, Rt = {
  CLONE_PIPELINE_BUTTON: "Clone pipeline config",
  CANCEL: "Cancel",
  CLOSE_MODAL: "Close modal",
  SOURCE_ENVIRONMENT_TITLE: "Clone pipeline configuration from source environment",
  TARGET_ENVIRONMENT_SELECTOR_LABEL: "Create deployment pipeline to target environment",
  TARGET_ENVIRONMENT_SELECTOR_PLACEHOLDER: "Select target environment",
  WORKFLOW_TYPE_SELECTION_HEADING: "Create deployment pipeline in",
  NEW_WORKFLOW_TITLE: "New workflow",
  NEW_WORKFLOW_INFO: "Creates deployment pipeline in a new workflow. Image source will be same as the source environment.",
  SOURCE_WORKFLOW_TITLE: "Workflow as source environment",
  SOURCE_WORKFLOW_INFO: "Creates deployment pipeline in source environment's workflow.",
  CLONE_LOADING_SUBTITLE: "It might take some time depending upon the number of applications",
  STATUS_TABLE_HEADER: {
    APPLICATION: "Application",
    SOURCE: "Source Environment",
    TARGET: "Target Environment",
    STATUS: "Clone status"
  },
  RETRY_FAILED: "Retry failed",
  DEFAULT_ERROR_MESSAGE: "Failed to clone pipeline config"
};
var oa = /* @__PURE__ */ ((t) => (t.SUCCESS = "SUCCESS", t.FAILED = "FAILED", t.SKIPPED = "SKIPPED", t))(oa || {}), _n = /* @__PURE__ */ ((t) => (t.NEW_WORKFLOW = "NEW_WORKFLOW", t.SAME_WORKFLOW = "SAME_WORKFLOW", t))(_n || {}), Kn = /* @__PURE__ */ ((t) => (t.APP_NAME = "appName", t.CLONE_STATUS = "status", t))(Kn || {});
const AI = (t) => `Clone the pipeline configuration of '${t}' pipeline and generate a deployment pipeline of target environment for selected application(s).`, SI = (t) => t ? null : "Target environment is required to clone pipeline configuration.", yI = (t) => `Clone pipeline config for ${Array.isArray(t) ? `${t.length} applications` : `'${t.application}'`}`, LI = (t) => t === _n.NEW_WORKFLOW ? "Clone in new workflow" : "Clone in source workflow", jI = (t) => `Initiating cloning of '${t}' for selected application(s)`, OI = (t) => t ? "Cloning in process" : "Clone Status", RI = (t) => `Go to application group '${t}'`, PI = {
  ...qr,
  control: (t, s) => ({
    ...qr.control(t, s),
    width: "480px"
  })
}, wI = (t) => {
  switch (t) {
    case oa.SKIPPED:
      return /* @__PURE__ */ e.jsx(Zc, { className: "dc__no-shrink icon-dim-16 mt-2" });
    case oa.SUCCESS:
      return /* @__PURE__ */ e.jsx(d_, { className: "dc__no-shrink icon-dim-16 mt-2" });
    default:
      return /* @__PURE__ */ e.jsx(Cb, { className: "dc__no-shrink icon-dim-16 mt-2" });
  }
}, DI = (t) => {
  switch (t) {
    case oa.SKIPPED:
      return /* @__PURE__ */ e.jsx("span", { className: "cy-7 fs-13 fw-4 lh-20", children: "Skipped" });
    case oa.SUCCESS:
      return /* @__PURE__ */ e.jsx("span", { className: "cg-7 fs-13 fw-4 lh-20", children: "Clone successful" });
    default:
      return /* @__PURE__ */ e.jsx("span", { className: "cr-7 fs-13 fw-4 lh-20", children: "Failed" });
  }
}, eU = ({ onClick: t, sourceEnvironmentName: s, disabled: n }) => /* @__PURE__ */ e.jsx(
  lt,
  {
    className: "default-tt w-250",
    arrow: !1,
    content: AI(s),
    placement: "top",
    children: /* @__PURE__ */ e.jsxs(
      "button",
      {
        type: "button",
        className: "dc__transparent w-100 py-6 px-8 flexbox dc__align-items-center dc__gap-8 dc__hover-n50 dc__truncate cn-9 fs-13 lh-20",
        onClick: t,
        "data-testid": "clone-environment",
        disabled: n,
        children: [
          /* @__PURE__ */ e.jsx(Eb, { className: "dc__no-shrink dc__no-svg-fill icon-dim-16 scn-7" }),
          Rt.CLONE_PIPELINE_BUTTON
        ]
      }
    )
  }
), MI = ({
  isLoading: t,
  handleClonePipeline: s,
  handleCloseClonePipelineModal: n,
  sourceEnvironmentName: a,
  statusList: r,
  targetEnvironmentName: o,
  targetEnvironmentId: i
}) => {
  const l = Te(), { sortOrder: c, sortBy: d, handleSorting: p } = vs({
    initialSortKey: Kn.APP_NAME
  });
  Di({ shouldPrompt: t });
  const m = Q(() => d === Kn.APP_NAME ? r.sort((b, N) => Ce(b.application, N.application, c)) : d === Kn.CLONE_STATUS ? r.sort((b, N) => Ce(b.status, N.status, c)) : r, [r, c, d]), u = Q(
    () => r.filter((b) => b.status === oa.FAILED),
    [r]
  ), f = async () => {
    const b = u.map((N) => N.application);
    await s(b);
  }, _ = () => {
    p(Kn.APP_NAME);
  }, h = () => {
    p(Kn.CLONE_STATUS);
  }, x = () => {
    t || n();
  }, g = () => {
    l.push(`${se.APPLICATION_MANAGEMENT_APPLICATION_GROUP}/${i}/${Ee.OVERVIEW}`);
  }, E = () => t ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      _e,
      {
        classname: "dc__text-center",
        title: jI(a),
        subTitle: Rt.CLONE_LOADING_SUBTITLE,
        SvgImage: jr,
        imageType: bs.Large,
        children: /* @__PURE__ */ e.jsx(Ot, { description: Nn, variant: "warning" })
      }
    ),
    /* @__PURE__ */ e.jsx(jo, { message: Nn, when: !0 })
  ] }) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col h-100 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-16 clone-pipeline-response-modal--row-wrapper dc__align-items-center dc__uppercase bg__primary dc__position-sticky dc__top-0 dc__zi-1 dc__border-bottom-n1 fs-12 fw-6 lh-20 px-20 py-8", children: [
      /* @__PURE__ */ e.jsx(
        Ne,
        {
          isSorted: d === Kn.APP_NAME,
          sortOrder: c,
          title: Rt.STATUS_TABLE_HEADER.APPLICATION,
          triggerSorting: _,
          disabled: !1
        }
      ),
      /* @__PURE__ */ e.jsx(
        Ne,
        {
          title: Rt.STATUS_TABLE_HEADER.SOURCE,
          isSortable: !1
        }
      ),
      /* @__PURE__ */ e.jsx(
        Ne,
        {
          title: Rt.STATUS_TABLE_HEADER.TARGET,
          isSortable: !1
        }
      ),
      /* @__PURE__ */ e.jsx(
        Ne,
        {
          isSorted: d === Kn.CLONE_STATUS,
          sortOrder: c,
          title: Rt.STATUS_TABLE_HEADER.STATUS,
          triggerSorting: h,
          disabled: !1
        }
      )
    ] }),
    m.map((b) => /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "dc__odd-child--sibling-bcn-50 display-grid dc__column-gap-16 clone-pipeline-response-modal--row-wrapper dc__align-start px-20 py-8",
        children: [
          /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20 dc__break-word", children: b.application }),
          /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20 dc__break-word", children: a }),
          /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20 dc__break-word", children: o }),
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4", children: [
            wI(b.status),
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
              DI(b.status),
              /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-7 fs-12 fw-4 lh-18 dc__break-word", children: b.message })
            ] })
          ] })
        ]
      },
      b.application
    ))
  ] }), C = !t;
  return /* @__PURE__ */ e.jsx(cs, { className: "", onEscape: x, close: x, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "bg__primary dc__position-fixed dc__right-0 dc__top-0 h-100 flexbox-col dc__content-space w-1024",
      onClick: Le,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__content-space h-100 dc__overflow-auto", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "px-20 py-12 flexbox dc__content-space dc__align-items-center dc__border-bottom", children: [
            /* @__PURE__ */ e.jsx("h2", { className: "dc__truncate cn-9 fs-16 fw-6 lh-24 m-0", children: OI(t) }),
            /* @__PURE__ */ e.jsx(
              "button",
              {
                type: "button",
                className: `p-0 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus h-20 w-20 dc__tab-focus ${t ? "dc__disabled" : ""}`,
                onClick: x,
                "data-testid": "close-clone-pipeline-response-modal",
                "aria-label": Rt.CLOSE_MODAL,
                children: /* @__PURE__ */ e.jsx(As, { className: "dc__no-shrink icon-dim-20" })
              }
            )
          ] }),
          E()
        ] }),
        C && /* @__PURE__ */ e.jsxs("div", { className: "py-16 px-20 flexbox dc__content-end dc__align-items-center dc__gap-16 dc__border-top dc__no-shrink", children: [
          /* @__PURE__ */ e.jsxs(
            "button",
            {
              type: "button",
              className: `cta ${u.length > 0 ? "secondary" : ""} flex dc__no-text-transform dc__gap-8`,
              onClick: g,
              "data-testid": "open-target-environment-overview",
              children: [
                /* @__PURE__ */ e.jsx("span", { className: "dc__truncate dc__mxw-300", children: RI(o) }),
                /* @__PURE__ */ e.jsx(
                  Ms,
                  {
                    className: `dc__no-shrink icon-dim-16 ${u.length > 0 ? "scb-5" : "scn-0"}`
                  }
                )
              ]
            }
          ),
          u.length > 0 && /* @__PURE__ */ e.jsxs(
            "button",
            {
              type: "button",
              className: "cta flex h-36 dc__no-text-transform dc__no-svg-fill dc__gap-8",
              onClick: f,
              "data-testid": "retry-failed-requests",
              children: [
                /* @__PURE__ */ e.jsx(Lo, { className: "dc__no-shrink icon-dim-16" }),
                Rt.RETRY_FAILED
              ]
            }
          )
        ] })
      ]
    }
  ) });
}, kI = async ({
  sourceEnvironmentName: t,
  targetEnvironmentName: s,
  appName: n,
  clonedPipelineWorkflowType: a
}) => {
  try {
    const r = {
      appName: n,
      targetEnvironmentName: s,
      sourceEnvironmentName: t,
      ...a === _n.SAME_WORKFLOW && {
        cloneEnvInSameWorkflow: !0
      }
    }, o = await we($.APP_WORKFLOW_CLONE, r);
    return o?.result ? {
      status: o.result.status,
      message: o.result.message
    } : {
      status: oa.FAILED,
      message: Rt.DEFAULT_ERROR_MESSAGE
    };
  } catch (r) {
    return {
      status: oa.FAILED,
      message: r?.errors?.[0]?.userMessage || Rt.DEFAULT_ERROR_MESSAGE
    };
  }
}, tU = ({
  sourceEnvironmentName: t,
  selectedAppDetailsList: s,
  handleCloseClonePipelineModal: n
}) => {
  const [a, r] = v(null), [o, i] = v(!1), [l, c] = v(_n.NEW_WORKFLOW), [d, p] = v(!1), [m, u] = v([]), f = !Array.isArray(s), _ = async (N) => {
    i(!0), p(!0);
    const I = [];
    N.forEach((S) => {
      I.push(
        () => kI({
          appName: S,
          sourceEnvironmentName: t,
          targetEnvironmentName: a.label,
          clonedPipelineWorkflowType: l
        })
      );
    });
    const T = await Tr(I), A = [];
    T.forEach((S, L) => {
      S.status === Mi.FULFILLED && A.push({
        application: N[L],
        status: S.value.status,
        message: S.value.message
      });
    }), p(!1), u(A);
  }, h = async () => {
    const N = (f ? [s] : s).map((I) => I.application);
    await _(N);
  }, x = (N) => {
    r(N);
  }, g = (N) => {
    c(N.target.value);
  }, E = gm(
    (N) => N.map((I) => ({
      ...I,
      options: I.options.filter((T) => T.label !== t)
    })).filter((I) => I.options.length > 0),
    [t]
  ), C = SI(a), b = (N) => /* @__PURE__ */ e.jsx(lt, { arrow: !1, content: C, className: "default-tt w-200", children: /* @__PURE__ */ e.jsx("div", { children: N }) });
  return o ? /* @__PURE__ */ e.jsx(
    MI,
    {
      isLoading: d,
      handleClonePipeline: _,
      handleCloseClonePipelineModal: n,
      sourceEnvironmentName: t,
      statusList: m,
      targetEnvironmentName: a.label,
      targetEnvironmentId: +a.value
    }
  ) : /* @__PURE__ */ e.jsx(cs, { className: "", onEscape: n, close: n, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "bg__primary dc__position-fixed dc__right-0 dc__top-0 h-100 flexbox-col dc__content-space w-600",
      onClick: Le,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__content-space h-100 dc__overflow-auto", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space px-20 py-12 dc__align-items-center dc__border-bottom", children: [
            /* @__PURE__ */ e.jsx("h2", { className: "dc__truncate cn-9 fs-16 fw-6 lh-24 m-0", children: yI(s) }),
            /* @__PURE__ */ e.jsx(
              "button",
              {
                type: "button",
                className: "p-0 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus h-20 w-20 dc__tab-focus",
                onClick: n,
                "data-testid": "close-clone-pipeline-modal",
                "aria-label": Rt.CLOSE_MODAL,
                children: /* @__PURE__ */ e.jsx(As, { className: "dc__no-shrink icon-dim-20" })
              }
            )
          ] }),
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-20 h-100 dc__overflow-auto py-20 px-16", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
              /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
                /* @__PURE__ */ e.jsx("div", { className: "flex dc__no-shrink dc__border-radius-50-per eb-5 bw-1 icon-dim-20", children: /* @__PURE__ */ e.jsx(bp, { className: "dc__no-shrink icon-dim-12" }) }),
                /* @__PURE__ */ e.jsxs("p", { className: "m-0 cn-9 fs-13 fw-4 lh-20 dc__truncate", children: [
                  Rt.SOURCE_ENVIRONMENT_TITLE,
                  " ",
                  /* @__PURE__ */ e.jsxs("span", { className: "fw-6", children: [
                    "'",
                    t,
                    "'"
                  ] })
                ] })
              ] }),
              /* @__PURE__ */ e.jsx("div", { className: "h-24 w-10 dc__border-right--b5" }),
              /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__align-start", children: [
                /* @__PURE__ */ e.jsx("div", { className: "flex dc__no-shrink dc__border-radius-50-per eb-5 bw-1 icon-dim-20 bcb-5", children: /* @__PURE__ */ e.jsx(bp, { className: "dc__no-shrink icon-dim-12 ic-env-white" }) }),
                /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__align-start dc__gap-4", children: [
                  /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-9 fs-13 fw-4 lh-20", children: Rt.TARGET_ENVIRONMENT_SELECTOR_LABEL }),
                  /* @__PURE__ */ e.jsx(
                    yx,
                    {
                      isMulti: !1,
                      handleEnvironmentChange: x,
                      selectedEnvironmentsMap: a ? { [a.label]: !0 } : {},
                      processOptions: E,
                      styles: PI,
                      autoFocus: !0,
                      placeholder: Rt.TARGET_ENVIRONMENT_SELECTOR_PLACEHOLDER
                    }
                  )
                ] })
              ] })
            ] }),
            /* @__PURE__ */ e.jsx("div", { className: "w-100 en-1 bw-1" }),
            /* @__PURE__ */ e.jsxs("section", { className: "flexbox-col dc__gap-12", children: [
              /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-13 fw-6 lh-20", children: Rt.WORKFLOW_TYPE_SELECTION_HEADING }),
              /* @__PURE__ */ e.jsxs(
                ds,
                {
                  className: "radio-group-no-border clone-pipeline-modal--radio-group",
                  value: l,
                  name: "clone-source-workflow-type",
                  onChange: g,
                  children: [
                    /* @__PURE__ */ e.jsx(
                      Ze,
                      {
                        dataTestId: `${_n.NEW_WORKFLOW}-radio-item`,
                        value: _n.NEW_WORKFLOW,
                        children: /* @__PURE__ */ e.jsxs(
                          "span",
                          {
                            className: `cn-9 fs-13 lh-20 ${l === _n.NEW_WORKFLOW ? "fw-6" : "fw-4"}`,
                            children: [
                              Rt.NEW_WORKFLOW_TITLE,
                              /* @__PURE__ */ e.jsx("br", {}),
                              /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-12 fw-4 lh-18", children: Rt.NEW_WORKFLOW_INFO })
                            ]
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ e.jsx(
                      Ze,
                      {
                        dataTestId: `${_n.SAME_WORKFLOW}-radio-item`,
                        value: _n.SAME_WORKFLOW,
                        children: /* @__PURE__ */ e.jsxs(
                          "span",
                          {
                            className: `cn-9 fs-13 lh-20 ${l === _n.SAME_WORKFLOW ? "fw-6" : "fw-4"}`,
                            children: [
                              Rt.SOURCE_WORKFLOW_TITLE,
                              /* @__PURE__ */ e.jsx("br", {}),
                              /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-12 fw-4 lh-18", children: Rt.SOURCE_WORKFLOW_INFO })
                            ]
                          }
                        )
                      }
                    )
                  ]
                }
              )
            ] })
          ] })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox px-20 py-16 dc__content-end dc__align-items-end dc__no-shrink dc__gap-12 dc__border-top", children: [
          /* @__PURE__ */ e.jsx(
            "button",
            {
              type: "button",
              className: "cta cancel flex h-36",
              onClick: n,
              "data-testid": "cancel-clone-pipeline",
              children: Rt.CANCEL
            }
          ),
          /* @__PURE__ */ e.jsx(An, { condition: !!C, wrap: b, children: /* @__PURE__ */ e.jsx(
            "button",
            {
              type: "button",
              className: "flex cta h-36 dc__no-text-transform",
              onClick: h,
              "data-testid": "clone-pipeline-cta",
              disabled: !!C,
              children: LI(l)
            }
          ) })
        ] })
      ]
    }
  ) });
};
var kn = /* @__PURE__ */ ((t) => (t.APPLICATION = "APPLICATION", t.ROLLOUT_STATUS = "ROLLOUT_STATUS", t.NEXT_ACTION = "NEXT_ACTION", t))(kn || {}), Qe = /* @__PURE__ */ ((t) => (t.ALL_APPLICATIONS = "ALL-APPLICATIONS", t.CANARY = "CANARY", t.BLUE_GREEN = "BLUE-GREEN", t.NOT_ELIGIBLE = "NOT-ELIGIBLE", t))(Qe || {});
const nc = [
  {
    value: Qe.ALL_APPLICATIONS,
    label: "All Applications"
  },
  {
    value: Qe.CANARY,
    label: "Canary"
  },
  {
    value: Qe.BLUE_GREEN,
    label: "Blue-Green"
  },
  {
    value: Qe.NOT_ELIGIBLE,
    label: "Not Eligible"
  }
], FI = {
  [kn.APPLICATION]: "Application",
  [kn.ROLLOUT_STATUS]: "Rollout Status",
  [kn.NEXT_ACTION]: "Next Action"
}, Up = {
  [kn.APPLICATION]: "application",
  [kn.ROLLOUT_STATUS]: "rolloutStatus",
  [kn.NEXT_ACTION]: "nextAction"
}, Ho = "Not eligible for further action", UI = 5, Ed = async ({
  appId: t,
  appIds: s,
  envId: n,
  options: a
}) => {
  const r = ye($.APP_STRATEGY, {
    appIds: s ?? t,
    envId: n,
    fetchStatus: !0
  }), { result: o } = await le(r, a);
  return o.map(
    ({
      currentPodHash: i,
      currentStepIndex: l,
      phase: c,
      rolloutIdentifier: d,
      steps: p,
      strategy: m,
      appId: u,
      envId: f,
      error: _,
      autoPromotionEnabled: h,
      promoteFull: x
    }) => {
      const g = (p ?? []).map((E) => E.pause?.duration && typeof E.pause.duration == "number" ? {
        ...E,
        // sanitize duration with seconds
        pause: { duration: `${E.pause.duration}s` }
      } : E);
      return g.find((E) => E.setWeight === 100) || g.push({ setWeight: 100 }), {
        currentPodHash: i ?? "",
        currentStepIndex: l ?? 0,
        phase: c,
        rolloutIdentifier: {
          name: d?.name || ""
        },
        steps: g,
        strategy: m,
        appId: u,
        envId: f,
        error: _,
        autoPromotionEnabled: h ?? !1,
        promoteFull: x ?? !1
      };
    }
  );
}, ef = (t, s) => we($.APP_STRATEGY_ROLLOUT, t, s), sU = ({
  onClick: t,
  disabled: s
}) => ({
  label: "Manage Traffic",
  iconName: "ic-traffic-signal",
  onClick: t,
  disabled: s
}), GI = async ({
  appInfoList: t,
  envId: s,
  abortControllerRef: n
}) => (await Ed({
  appIds: t.map(({ appId: r }) => r).join(","),
  envId: s,
  options: { abortControllerRef: n }
})).reduce((r, o) => (r[o.appId] = o, r), {}), ac = ({
  steps: t,
  currentStepIndex: s,
  phase: n,
  autoPromotionEnabled: a,
  promoteFull: r,
  strategy: o,
  error: i
}) => {
  if (i)
    return {
      rolloutStatus: i.userMessage ?? "-",
      strategyIcon: "ic-error",
      nextAction: Ho,
      notEligible: !0
    };
  const l = co[o] ?? "ic-rocket-gear";
  switch (o) {
    case "CANARY": {
      const { parsedSteps: c } = G_(t, s, n), d = c[s], p = d.message;
      if (d.isFullRollout)
        return {
          rolloutStatus: p,
          strategyIcon: l,
          nextAction: Ho,
          notEligible: !0
        };
      const m = c[s + 1].message;
      return {
        rolloutStatus: p,
        strategyIcon: l,
        nextAction: m,
        notEligible: !1
      };
    }
    case "BLUE-GREEN": {
      const { rolloutStatus: c, nextAction: d } = B_(
        n,
        a,
        r
      );
      return {
        rolloutStatus: c,
        strategyIcon: l,
        nextAction: d ?? Ho,
        notEligible: !d
      };
    }
    default:
      return {
        rolloutStatus: "Not applicable",
        strategyIcon: l,
        nextAction: Ho,
        notEligible: !0
      };
  }
}, tf = (t, s) => t.flatMap((n) => {
  const a = s[n.appId];
  return a ? {
    ...n,
    environmentId: a.envId,
    strategy: a.strategy,
    currentPodHash: a.currentPodHash,
    currentStepIndex: a.currentStepIndex,
    rolloutIdentifier: a.rolloutIdentifier,
    phase: a.phase,
    autoPromotionEnabled: a.autoPromotionEnabled,
    ...ac(a)
  } : [];
}), BI = (t, s) => tf(t, s).reduce((n, a) => (n[a.appId] = a, n), {}), rc = (t, s, n = !1) => t.filter(
  ({ strategy: a, notEligible: r }) => (!n || !r) && a === s
), sf = (t) => t.filter(({ notEligible: s }) => s), $I = (t) => nc.filter(({ value: s }) => {
  switch (s) {
    case Qe.BLUE_GREEN:
    case Qe.CANARY:
      return t.some(({ strategy: n }) => n === s);
    case Qe.NOT_ELIGIBLE:
      return t.some(({ notEligible: n }) => n);
    default:
      return !0;
  }
}), VI = ({
  appsFilter: t,
  appsDetail: s
}) => {
  switch (t) {
    case Qe.CANARY:
    case Qe.BLUE_GREEN:
      return rc(s, t);
    case Qe.NOT_ELIGIBLE:
      return sf(s);
    default:
      return s;
  }
}, YI = (t) => {
  const s = Object.entries(t).map(([, n]) => n);
  return {
    [Qe.ALL_APPLICATIONS]: s.length,
    [Qe.CANARY]: rc(s, "CANARY", !0).length,
    [Qe.BLUE_GREEN]: rc(s, "BLUE-GREEN", !0).length,
    [Qe.NOT_ELIGIBLE]: sf(s).length
  };
}, Gp = (t, s, n, a) => {
  const r = (Array.isArray(t) ? t : Object.values(t)).map(
    (o) => {
      if (!o.notEligible) {
        if (n === "CANARY" && o.strategy === "CANARY")
          return {
            ...o,
            nextAction: s === "promoteFull" ? "Rollout to 100% users" : ac(a[o.appId]).nextAction
          };
        if (n === "BLUE-GREEN" && o.strategy === "BLUE-GREEN" && o.phase !== "Progressing" && !o.autoPromotionEnabled)
          return {
            ...o,
            nextAction: s === "promoteFull" ? "Skip & Promote Full" : ac(a[o.appId]).nextAction
          };
      }
      return o;
    }
  );
  return Array.isArray(t) ? r : r.reduce((o, i) => (o[i.appId] = i, o), {});
}, Bp = (t) => (Array.isArray(t) ? t : Object.values(t)).some(
  (s) => !s.notEligible && s.strategy === "BLUE-GREEN" && s.phase !== "Progressing" && !s.autoPromotionEnabled
), HI = (t, s, n, a) => {
  if (!n)
    return 0;
  const r = +!!a[t.appId], o = +!!a[s.appId], i = Number(t.notEligible), l = Number(s.notEligible);
  return r !== o ? n === Ut.ASC ? o - r : r - o : i !== l ? i - l : 0;
}, KI = (t) => Object.fromEntries(
  Object.entries(t).filter(([, s]) => !s.notEligible).map(
    ([
      s,
      {
        appId: n,
        environmentId: a,
        application: r,
        nextAction: o,
        currentPodHash: i,
        currentStepIndex: l,
        rolloutIdentifier: c,
        strategy: d,
        strategyIcon: p
      }
    ]) => {
      const m = {
        appId: n,
        envId: a,
        nextAction: o,
        appName: r,
        currentPodHash: i,
        currentStepIndex: l,
        rolloutName: c.name,
        status: ot.PROGRESSING,
        strategy: d,
        strategyIcon: p,
        errorMsg: ""
      };
      return [s, m];
    }
  )
), WI = (t, s, n) => {
  switch (t) {
    case ot.FAIL:
      return n;
    case ot.SUCCESS:
      return s;
    case ot.PROGRESSING:
    default:
      return "";
  }
}, qI = (t) => ({
  successCount: t.filter(({ status: s }) => s === ot.SUCCESS).length,
  failCount: t.filter(({ status: s }) => s === ot.FAIL).length,
  progressingCount: t.filter(({ status: s }) => s === ot.PROGRESSING).length
}), zI = ({
  selectedAppsDetail: t,
  canaryPromoteAction: s,
  blueGreenPromoteAction: n,
  handleClose: a
}) => {
  const r = de(new AbortController()), [o, i] = v(
    KI(t)
  ), { sortBy: l, sortOrder: c, handleSorting: d } = vs({ initialSortKey: "appName" }), p = Object.values(o), { successCount: m, failCount: u, progressingCount: f } = Q(() => qI(p), [p]), _ = !!f, h = [
    { color: "var(--G500)", label: "Succeeded", value: m },
    {
      color: "var(--R500)",
      label: "Failed",
      value: u
    },
    {
      color: "var(--N300)",
      label: "Pending",
      value: f
    }
  ], x = (N) => () => {
    d(N);
  }, g = async (N) => {
    const I = (N ?? p).map((T) => {
      const { appId: A, envId: S, currentPodHash: L, currentStepIndex: R, rolloutName: y, strategy: M } = T;
      return async () => {
        try {
          await ef(
            {
              appId: A,
              envId: S,
              // only expecting CANARY & BLUE-GREEN
              promoteAction: M === "CANARY" ? s : n,
              currentPodHash: L,
              currentStepIndex: R,
              rolloutName: y
            },
            { signal: r.current.signal }
          ), i((P) => ({
            ...P,
            [A]: { ...T, status: ot.SUCCESS, errorMsg: "" }
          }));
        } catch (P) {
          const U = P.errors[0];
          i((G) => ({
            ...G,
            [A]: {
              ...T,
              status: ot.FAIL,
              errorMsg: U.userMessage || U.internalMessage || ""
            }
          }));
        }
      };
    });
    await Tr(I, !1, UI);
  }, E = () => {
    r.current.abort();
  };
  J(() => (g(), E), []);
  const C = async () => {
    const N = p.filter(({ status: y }) => y === ot.FAIL), { envId: I } = p[0], T = N.map(({ appId: y }) => y).join(), S = (await Ed({ appIds: T, envId: I })).reduce((y, M) => (y[M.appId] = M, y), {}), L = Object.fromEntries(
      N.map((y) => {
        const { currentPodHash: M, currentStepIndex: P } = S[y.appId];
        return [
          y.appId,
          { ...y, status: ot.PROGRESSING, errorMsg: "", currentPodHash: M, currentStepIndex: P }
        ];
      })
    );
    i(L);
    const R = Object.values(L);
    await g(R);
  }, b = Q(
    () => Object.values(o).sort((N, I) => l === "appName" ? Ce(N.appName, I.appName, c) : l === "rolloutStrategy" ? Ce(N.strategy, I.strategy, c) : Ce(N.status, I.status, c)),
    [l, c, o]
  );
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1 flexbox-col dc__overflow-auto", children: [
      /* @__PURE__ */ e.jsx("div", { className: "p-20", children: /* @__PURE__ */ e.jsxs("div", { className: "br-8 border__primary shadow__card--20", children: [
        /* @__PURE__ */ e.jsx(
          Ra,
          {
            entities: h,
            labelClassName: "fs-13 fw-4 lh-20 cn-9",
            countClassName: "fs-13 fw-6 lh-20 cn-9",
            showAnimationOnBar: !0,
            rootClassName: "p-16 border__secondary--bottom"
          }
        ),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-6 px-16 py-8", children: [
          /* @__PURE__ */ e.jsx(
            W,
            {
              name: _ ? "ic-circle-loader" : "ic-info-outline",
              color: _ ? "O500" : null,
              size: 20
            }
          ),
          /* @__PURE__ */ e.jsx("span", { children: _ ? "Increasing rollout to next step" : `Rollout increased for ${m} deployments` })
        ] })
      ] }) }),
      /* @__PURE__ */ e.jsxs("div", { className: "rollout-status-row fs-12 lh-20 cn-7 px-20 py-8 border__secondary--bottom", children: [
        /* @__PURE__ */ e.jsx(
          Ne,
          {
            title: "APPLICATION",
            isSorted: l === "appName",
            sortOrder: c,
            isSortable: !0,
            triggerSorting: x("appName"),
            disabled: !1
          }
        ),
        /* @__PURE__ */ e.jsx(
          Ne,
          {
            title: "ROLLOUT STRATEGY",
            isSorted: l === "rolloutStrategy",
            sortOrder: c,
            isSortable: !0,
            triggerSorting: x("rolloutStrategy"),
            disabled: !1
          }
        ),
        /* @__PURE__ */ e.jsx(
          Ne,
          {
            title: "STATUS",
            isSorted: l === "status",
            sortOrder: c,
            isSortable: !0,
            triggerSorting: x("status"),
            disabled: !1
          }
        ),
        /* @__PURE__ */ e.jsx(
          Ne,
          {
            title: "MESSAGE",
            isSorted: !1,
            sortOrder: c,
            isSortable: !1,
            triggerSorting: Be,
            disabled: !1
          }
        )
      ] }),
      b.map(({ appName: N, strategyIcon: I, strategy: T, status: A, nextAction: S, errorMsg: L }) => /* @__PURE__ */ e.jsxs("div", { className: "rollout-status-row fs-13 fw-4 lh-20 cn-9 px-20 py-8", children: [
        /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: N }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-6", children: [
          /* @__PURE__ */ e.jsx(W, { name: I, size: 20, color: null }),
          /* @__PURE__ */ e.jsx("span", { className: "dc__first-letter-capitalize", children: T })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__h-fit-content dc__gap-6", children: [
          Y_(A),
          /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-20 cn-9", children: _I(A) })
        ] }),
        /* @__PURE__ */ e.jsx("span", { children: WI(A, S, L) })
      ] }, N))
    ] }),
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: `flexbox ${_ ? "dc__content-end" : "dc__content-space"} px-20 py-16 border__secondary--top`,
        children: [
          !_ && /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: "close-manage-traffic",
              text: "Close",
              variant: w.secondary,
              style: B.neutral,
              size: O.large,
              onClick: a
            }
          ),
          /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: _ ? "abort-bulk-rollout" : "retry-failed-rollout",
              text: _ ? "Abort" : "Retry Failed",
              startIcon: /* @__PURE__ */ e.jsx(W, { name: _ ? "ic-aborted" : "ic-arrow-clockwise", color: null }),
              size: O.large,
              ..._ ? { style: B.neutral, variant: w.secondary } : {},
              disabled: !_ && !u,
              onClick: _ ? E : C
            }
          )
        ]
      }
    )
  ] });
}, Cl = ({
  variant: t = "primary",
  children: s,
  count: n,
  title: a,
  icon: r,
  isFilterActive: o = !1,
  onFilterToggle: i
}) => {
  if (!n)
    return null;
  const l = t === "error", c = () => i(!o);
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `manage-traffic-filter-card dc__visible-hover dc__visible-hover--parent br-6 flexbox-col ${l ? "er-2" : "border__primary"} ${l ? "bcr-50" : "bg__primary"}`,
      children: [
        /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: `manage-traffic-filter-card__title-container flex left dc__gap-12 px-12 pt-8 pb-7 ${l ? "error" : "border__secondary--bottom"}`,
            children: [
              /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1 flexbox dc__align-items-center dc__gap-8 mt-4", children: [
                /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-14 lh-20 fw-6 cn-9", children: n < 10 ? `0${n}` : n }),
                /* @__PURE__ */ e.jsx("span", { className: "manage-traffic-filter-card__count-divider divider__primary-translucent" }),
                /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-6", children: [
                  /* @__PURE__ */ e.jsx(W, { name: l ? "ic-error" : r, color: null }),
                  /* @__PURE__ */ e.jsx(Ie, { content: l ? "Not eligible for further action" : a, children: /* @__PURE__ */ e.jsx("p", { className: `m-0 fs-13 lh-20 dc__truncate ${l ? "cr-5" : "cn-9"}`, children: l ? "Not eligible for further action" : a }) })
                ] })
              ] }),
              /* @__PURE__ */ e.jsx("div", { className: `${o ? "dc__visible" : "dc__visible-hover--child"}`, children: /* @__PURE__ */ e.jsx(
                j,
                {
                  icon: /* @__PURE__ */ e.jsx(W, { name: o ? "ic-filter-applied" : "ic-filter", color: null }),
                  dataTestId: `manage-traffic-filter-card-${a}-button`,
                  ariaLabel: `manage-traffic-filter-card-${a}-button`,
                  variant: w.borderLess,
                  style: B.neutral,
                  size: O.xs,
                  showAriaLabelInTippy: !1,
                  onClick: c
                }
              ) })
            ]
          }
        ),
        s
      ]
    }
  );
}, XI = ({
  appsFilterCount: t,
  appsFilter: s,
  handleAppsFilterChange: n,
  canaryPromoteAction: a,
  blueGreenPromoteAction: r,
  handlePromoteActionChange: o,
  handleRemoveNotEligibleSelections: i,
  handleShowInitiateRollout: l,
  handleSortSelected: c,
  isSwapTrafficEnabled: d
}) => {
  const p = !!(t[Qe.CANARY] || t[Qe.BLUE_GREEN]), m = !!t[Qe.NOT_ELIGIBLE], u = (f) => (_) => {
    n(
      _ ? nc.find(({ value: h }) => h === f) : nc[0]
    ), _ && c(Ut.ASC);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1 p-16 flexbox-col dc__gap-20", children: [
      p && /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
        /* @__PURE__ */ e.jsx("h3", { className: "m-0 fs-13 lh-20 fw-6 cn-9", children: "Eligible Rollouts" }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
          /* @__PURE__ */ e.jsx(
            Cl,
            {
              variant: "primary",
              count: t[Qe.CANARY],
              title: "Canary Strategy",
              icon: co.CANARY,
              isFilterActive: s === Qe.CANARY,
              onFilterToggle: u(Qe.CANARY),
              children: /* @__PURE__ */ e.jsxs(
                ds,
                {
                  name: "manage-traffic-canary-promote-action-radio",
                  className: "promote-action-radio",
                  value: a,
                  onChange: o("CANARY"),
                  children: [
                    /* @__PURE__ */ e.jsx(Ze, { value: "promoteToNext", children: "Rollout to Next Step" }),
                    /* @__PURE__ */ e.jsx(Ze, { value: "promoteFull", children: "Full Rollout" })
                  ]
                }
              )
            }
          ),
          /* @__PURE__ */ e.jsx(
            Cl,
            {
              variant: "primary",
              count: t[Qe.BLUE_GREEN],
              title: "Blue-Green Strategy",
              icon: co["BLUE-GREEN"],
              isFilterActive: s === Qe.BLUE_GREEN,
              onFilterToggle: u(Qe.BLUE_GREEN),
              children: /* @__PURE__ */ e.jsxs(
                ds,
                {
                  name: "manage-traffic-blue-green-promote-action-radio",
                  className: "promote-action-radio",
                  value: r,
                  onChange: o("BLUE-GREEN"),
                  children: [
                    /* @__PURE__ */ e.jsx(Ze, { value: "promoteToNext", disabled: !d, children: "Swap Traffic" }),
                    /* @__PURE__ */ e.jsx(Ze, { value: "promoteFull", children: "Skip & Promote Full" })
                  ]
                }
              )
            }
          )
        ] })
      ] }),
      m && /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
        /* @__PURE__ */ e.jsx("h3", { className: "m-0 fs-13 lh-20 fw-6 cn-9", children: "Non-eligible Rollouts" }),
        /* @__PURE__ */ e.jsx(
          Cl,
          {
            variant: "error",
            count: t[Qe.NOT_ELIGIBLE],
            isFilterActive: s === Qe.NOT_ELIGIBLE,
            onFilterToggle: u(Qe.NOT_ELIGIBLE),
            children: /* @__PURE__ */ e.jsx("div", { className: "p-12", children: /* @__PURE__ */ e.jsx(
              j,
              {
                dataTestId: "manage-traffic-initiate-rollout-button",
                variant: w.text,
                size: O.medium,
                text: "Remove not eligible selections",
                onClick: i
              }
            ) })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "p-16", children: /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "manage-traffic-initiate-rollout-button",
        size: O.medium,
        text: "Initiate Eligible Rollouts",
        onClick: l,
        fullWidth: !0,
        disabled: !p,
        showTooltip: !p,
        tooltipProps: {
          content: "No eligible rollouts"
        }
      }
    ) })
  ] });
}, JI = ({
  envId: t,
  appInfoList: s,
  initialSelectedAppList: n
}) => {
  const [a, r] = v(Qe.ALL_APPLICATIONS), [o, i] = v([]), [l, c] = v({}), [d, p] = v(null), [m, u] = v("promoteToNext"), [f, _] = v("promoteToNext"), [h, x] = v(!1), g = de(new AbortController());
  J(
    () => () => {
      g.current.abort();
    },
    []
  );
  const { handleSorting: E, sortBy: C, sortOrder: b } = vs({
    initialSortKey: kn.APPLICATION
  }), [
    N,
    I,
    T,
    A
  ] = ne(() => GI({ appInfoList: s, envId: t, abortControllerRef: g })), S = Q(
    () => VI({ appsDetail: o, appsFilter: a }),
    [o, a]
  ), { appsFilterCount: L, isSwapTrafficEnabled: R } = Q(
    () => ({
      appsFilterCount: YI(l),
      isSwapTrafficEnabled: Bp(l)
    }),
    [l]
  ), y = ({ value: k }) => {
    r(k);
  }, M = (k, D) => {
    i(
      Gp(
        o,
        D,
        k,
        I
      )
    ), c(
      Gp(
        l,
        D,
        k,
        I
      )
    );
  }, P = (k) => (D) => {
    const F = D.target.value;
    k === "CANARY" ? (ct.event({
      category: "App Group Manage Traffic",
      action: F === "promoteToNext" ? "APP_GROUP_MANAGE_TRAFFIC_NEXT_CLICKED" : "APP_GROUP_MANAGE_TRAFFIC_FULL_CLICKED"
    }), u(F)) : k === "BLUE-GREEN" && _(F), M(k, F);
  }, U = (k) => {
    const { checked: D } = k.target;
    c((F) => {
      let q = { ...F };
      const be = Object.fromEntries(S.map((fe) => [fe.appId, fe]));
      return a === Qe.ALL_APPLICATIONS ? q = D ? be : {} : D ? q = {
        ...l,
        ...be
      } : Object.keys(be).forEach((fe) => {
        delete q[fe];
      }), q;
    }), p(null);
  }, G = (k) => () => {
    c((D) => {
      const F = { ...D };
      return F[k.appId] ? delete F[k.appId] : F[k.appId] = k, F;
    }), p(null);
  }, H = () => {
    const k = Object.fromEntries(
      Object.entries(l).filter(([, D]) => !D.notEligible)
    );
    c(k), p(null);
  }, oe = (k) => () => {
    p(null), E(k);
  }, ae = (k) => {
    const D = k ?? (d === Ut.ASC ? Ut.DESC : Ut.ASC);
    E(null), p(D), i(
      (F) => [...F].sort((q, be) => HI(q, be, D, l))
    );
  }, re = () => {
    x(!0);
  };
  return J(() => {
    C && i(
      (k) => [...k].sort(
        (D, F) => Ce(
          D[Up[C]],
          F[Up[C]],
          b
        )
      )
    );
  }, [C, b]), J(() => {
    if (!N && I) {
      const k = tf(s, I);
      i(k), c(
        BI(n, I)
      ), _(Bp(k) ? "promoteToNext" : "promoteFull");
    }
  }, [I, N]), {
    appsFilter: a,
    appsFilterSegments: $I(o),
    filteredAppsDetail: S,
    selectedAppsDetail: l,
    appsFilterCount: L,
    handleAppsFilterChange: y,
    handleBulkCheckboxChange: U,
    handleRowCheckboxChange: G,
    handleRemoveNotEligibleSelections: H,
    canaryPromoteAction: m,
    isSwapTrafficEnabled: R,
    blueGreenPromoteAction: f,
    handlePromoteActionChange: P,
    sortBy: C,
    sortOrder: b,
    handleTableSorting: oe,
    sortSelectedSortOrder: d,
    handleSortSelected: ae,
    isLoading: N,
    err: T,
    reload: A,
    showInitiateRollout: h,
    handleShowInitiateRollout: re
  };
}, QI = () => /* @__PURE__ */ e.jsx(
  _e,
  {
    title: "Checking current rollout status",
    subTitle: "It might take some time depending upon the number of applications",
    SvgImage: jr
  }
), nU = ({
  envId: t,
  envName: s,
  appInfoList: n = [],
  initialSelectedAppList: a = [],
  onClose: r
}) => {
  const {
    appsFilter: o,
    appsFilterSegments: i,
    filteredAppsDetail: l,
    selectedAppsDetail: c,
    appsFilterCount: d,
    handleAppsFilterChange: p,
    handleBulkCheckboxChange: m,
    handleRowCheckboxChange: u,
    handleRemoveNotEligibleSelections: f,
    canaryPromoteAction: _,
    isSwapTrafficEnabled: h,
    blueGreenPromoteAction: x,
    handlePromoteActionChange: g,
    sortBy: E,
    sortOrder: C,
    handleTableSorting: b,
    sortSelectedSortOrder: N,
    handleSortSelected: I,
    isLoading: T,
    err: A,
    reload: S,
    showInitiateRollout: L,
    handleShowInitiateRollout: R
  } = JI({ appInfoList: n, envId: t, initialSelectedAppList: a }), y = Q(() => Object.keys(c).length, [c]), M = Q(
    () => y && l.every(({ appId: G }) => !!c[G]),
    [l, y]
  ), P = Q(
    () => !M && l.some(({ appId: G }) => !!c[G]),
    [l, y, M]
  ), U = () => I();
  return /* @__PURE__ */ e.jsx($t, { position: "right", width: "100%", minWidth: "1024px", maxWidth: "1024px", onEscape: r, children: /* @__PURE__ */ e.jsxs("div", { className: "bg__primary h-100 flexbox-col", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space dc__gap-12 px-20 pt-12 pb-11 border__primary--bottom", children: [
      /* @__PURE__ */ e.jsx("h2", { className: "m-0 fs-16 lh-24 fw-6 cn-9", children: `Manage traffic for applications on '${s}'` }),
      /* @__PURE__ */ e.jsx(
        j,
        {
          icon: /* @__PURE__ */ e.jsx(W, { name: "ic-close-large", color: null }),
          dataTestId: "manage-traffic-close-button",
          ariaLabel: "manage-traffic-close-button",
          variant: w.borderLess,
          style: B.negativeGrey,
          size: O.xs,
          showAriaLabelInTippy: !1,
          onClick: r
        }
      )
    ] }),
    L ? /* @__PURE__ */ e.jsx(
      zI,
      {
        handleClose: r,
        selectedAppsDetail: c,
        canaryPromoteAction: _,
        blueGreenPromoteAction: x
      }
    ) : /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1 flexbox-col dc__overflow-hidden", children: /* @__PURE__ */ e.jsx(
      Ke,
      {
        isLoading: T,
        customLoader: /* @__PURE__ */ e.jsx(QI, {}),
        error: A,
        errorScreenManagerProps: {
          code: A?.code,
          reload: S
        },
        children: /* @__PURE__ */ e.jsxs(
          gi.div,
          {
            className: "manage-traffic-container dc__grid flex-grow-1 dc__overflow-hidden",
            animate: {
              gridTemplateColumns: `1fr ${y > 0 ? "300px" : "0px"}`
            },
            transition: { duration: 0.2 },
            children: [
              /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-hidden", children: [
                /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space px-16 py-10", children: [
                  /* @__PURE__ */ e.jsx(
                    Qs,
                    {
                      name: "manage-traffic-apps-filter",
                      segments: i,
                      value: o,
                      onChange: p
                    }
                  ),
                  y > 0 && /* @__PURE__ */ e.jsx(
                    j,
                    {
                      dataTestId: "manage-traffic-sort-selected-button",
                      startIcon: /* @__PURE__ */ e.jsx(
                        W,
                        {
                          name: N && (N === Ut.ASC ? "ic-sort-ascending" : "ic-sort-descending") || "ic-sortable",
                          color: null
                        }
                      ),
                      variant: w.borderLess,
                      style: B.neutral,
                      size: O.medium,
                      text: "Sort Selected",
                      onClick: U
                    }
                  )
                ] }),
                /* @__PURE__ */ e.jsxs("div", { className: "manage-traffic-table flex-grow-1 dc__overflow-auto px-12 pb-16", children: [
                  /* @__PURE__ */ e.jsxs("div", { className: "manage-traffic-table__row bg__primary no-hover px-8 pt-8 pb-7 border__secondary--bottom dc__position-sticky dc__top-0 dc__zi-1", children: [
                    /* @__PURE__ */ e.jsx(
                      $e,
                      {
                        rootClassName: "m-0 pt-4 pb-3",
                        isChecked: M || P,
                        value: P ? "INTERMEDIATE" : "CHECKED",
                        onChange: m
                      }
                    ),
                    Object.values(kn).map((G) => /* @__PURE__ */ e.jsx("div", { className: "manage-traffic-table__cell", children: /* @__PURE__ */ e.jsx(
                      Ne,
                      {
                        title: FI[G],
                        isSortable: !0,
                        disabled: !1,
                        isSorted: E === G,
                        sortOrder: C,
                        triggerSorting: b(G)
                      }
                    ) }, G))
                  ] }),
                  l.map((G) => {
                    const {
                      appId: H,
                      notEligible: oe,
                      application: ae,
                      strategy: re,
                      strategyIcon: k,
                      rolloutStatus: D,
                      nextAction: F
                    } = G, q = !!c[H];
                    return /* @__PURE__ */ e.jsxs(
                      "div",
                      {
                        role: "checkbox",
                        "aria-checked": q,
                        tabIndex: 0,
                        className: `manage-traffic-table__row cursor p-8 br-4 ${q ? "is-selected no-hover" : ""} ${oe ? "not-eligible" : ""}`,
                        onClick: u(G),
                        children: [
                          /* @__PURE__ */ e.jsx(
                            $e,
                            {
                              rootClassName: "m-0 pt-4 pb-3",
                              isChecked: q,
                              value: "CHECKED",
                              onChange: u(G),
                              error: oe
                            }
                          ),
                          /* @__PURE__ */ e.jsx(Ie, { content: ae, children: /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-13 lh-20 fw-4 cn-9 dc__truncate", children: ae }) }),
                          /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8", children: [
                            /* @__PURE__ */ e.jsx(
                              W,
                              {
                                name: k,
                                color: null,
                                tooltipProps: {
                                  alwaysShowTippyOnHover: !!Mn[re],
                                  content: `${Mn[re]} Strategy`
                                }
                              }
                            ),
                            /* @__PURE__ */ e.jsx(Ie, { content: D, children: /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-13 lh-20 fw-4 cn-9 dc__truncate", children: D }) })
                          ] }),
                          /* @__PURE__ */ e.jsx(Ie, { content: F, children: /* @__PURE__ */ e.jsx(
                            "p",
                            {
                              className: `m-0 fs-13 lh-20 fw-4 dc__truncate ${oe ? "cr-5" : "cn-9"}`,
                              children: F
                            }
                          ) })
                        ]
                      },
                      H
                    );
                  })
                ] })
              ] }),
              /* @__PURE__ */ e.jsx(Im, { children: y && /* @__PURE__ */ e.jsx(
                gi.div,
                {
                  className: "bg__modal--secondary border__secondary--left flexbox-col",
                  initial: { x: 300, opacity: 0 },
                  animate: { x: 0, opacity: 1 },
                  exit: { x: 300, opacity: 0 },
                  transition: { duration: 0.2 },
                  children: /* @__PURE__ */ e.jsx(
                    XI,
                    {
                      appsFilterCount: d,
                      appsFilter: o,
                      handleAppsFilterChange: p,
                      canaryPromoteAction: _,
                      blueGreenPromoteAction: x,
                      handlePromoteActionChange: g,
                      handleRemoveNotEligibleSelections: f,
                      handleShowInitiateRollout: R,
                      handleSortSelected: I,
                      isSwapTrafficEnabled: h
                    }
                  )
                }
              ) })
            ]
          }
        )
      }
    ) })
  ] }) });
}, aU = ({ to: t, onClick: s }) => /* @__PURE__ */ e.jsx(
  j,
  {
    dataTestId: "app-group-manage-traffic-button",
    startIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-traffic-signal", color: null }),
    variant: w.secondary,
    size: O.medium,
    text: "Manage Traffic",
    onClick: s,
    component: Re.link,
    linkProps: { to: t }
  }
), rU = [
  {
    label: "v1beta2/application",
    value: Lx.v2
  }
], ZI = "http://json-schema.org/draft-04/schema#", ev = "Bulk Edit Application batch/v1beta2 Schema", tv = "object", sv = "Input Script for bulk edit", nv = { apiVersion: { type: "string", enum: ["batch/v1beta1", "batch/v1beta2"], description: "API version of the bulk edit schema" } }, oU = {
  $schema: ZI,
  title: ev,
  type: tv,
  description: sv,
  properties: nv
}, iU = () => ox(`${$.BULK_EDIT_V2}/config`), lU = (t) => fm(`${$.BULK_EDIT_V2}`, t), cU = (t) => fm(`${$.BULK_EDIT_V2}/dryrun`, t), av = async () => ({
  category: (await le($.CHART_CATEGORY_LIST)).result?.category ?? []
}), dU = ({ selectedCategories: t, handleUpdateCategoryFilter: s }) => {
  const [n, a, r, o] = ne(av, []), i = (c) => {
    if (t.find((m) => m === c)) {
      const m = t.filter((u) => u !== c);
      s(m);
      return;
    }
    const p = [...t, c];
    s(p);
  };
  if (a?.category?.length <= 0)
    return null;
  const l = () => {
    if (n)
      return /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("span", { className: "w-180 shimmer" }),
        /* @__PURE__ */ e.jsx("span", { className: "w-180 shimmer" }),
        /* @__PURE__ */ e.jsx("span", { className: "w-180 shimmer" })
      ] });
    if (r)
      return /* @__PURE__ */ e.jsx(ps, { title: "Could not load categories", subTitle: "", reload: o });
    const c = (d) => () => i(d);
    return /* @__PURE__ */ e.jsx(e.Fragment, { children: a.category.map((d) => {
      const p = d.id.toString(), m = !!t.find((u) => u === p);
      return /* @__PURE__ */ e.jsx("div", { className: "dc__hover-n50", children: /* @__PURE__ */ e.jsx(
        $e,
        {
          isChecked: m,
          value: Fe.CHECKED,
          onChange: c(p),
          dataTestId: `chart-store-category-${d.name}-checkbox`,
          rootClassName: "mb-0 py-6 ml-8",
          children: /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-20 dc__truncate", children: d.name })
        }
      ) }, `${d.name}-${d.id}`);
    }) });
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("hr", { className: "mt-8 mb-8" }),
    /* @__PURE__ */ e.jsx("span", { className: "fs-12 lh-20 cn-6 fw-6 px-8 py-8", children: "CATEGORY" }),
    l()
  ] });
};
var et = /* @__PURE__ */ ((t) => (t.global = "Global", t.match = "Criteria", t.specific = "Specific", t))(et || {}), z = /* @__PURE__ */ ((t) => (t.baseDeploymentTemplate = "base-deployment-template", t.baseConfiguration = "base-configuration", t.branchFixed = "branch", t.branchRegex = "branch-regex", t))(z || {}), tt = /* @__PURE__ */ ((t) => (t.deploymentApproval = "approval/deployment", t.configurationApproval = "approval/configuration", t))(tt || {}), Cn = /* @__PURE__ */ ((t) => (t.configMapConfiguration = "configuration/config-map", t.configSecretConfiguration = "configuration/config-secret", t.deploymentTemplateConfiguration = "configuration/deployment-template", t))(Cn || {}), xr = /* @__PURE__ */ ((t) => (t.add = "add", t.remove = "remove", t))(xr || {}), hn = /* @__PURE__ */ ((t) => (t.default = "default", t.add = "add", t.remove = "remove", t.white = "white", t))(hn || {});
const nf = "status", $p = ({ userStatus: t, text: s, captionText: n }) => /* @__PURE__ */ e.jsxs("span", { className: "dc__ellipsis-right flex dc__content-start dc__gap-4 fw-6 ml-2", children: [
  /* @__PURE__ */ e.jsx("span", { className: "dc__no-shrink mw-16 flex", children: ln(t) }),
  n ? /* @__PURE__ */ e.jsxs("span", { className: "flexbox-col dc__ellipsis-right", children: [
    /* @__PURE__ */ e.jsx("span", { className: "dc__ellipsis-right lh-16 fs-11", children: n }),
    /* @__PURE__ */ e.jsx("span", { className: "dc__ellipsis-right lh-20 fs-13", children: s })
  ] }) : /* @__PURE__ */ e.jsx("span", { className: "dc__ellipsis-right lh-20 fs-13", children: s })
] }), pU = (t) => {
  const s = Object.values(ce).reduce((n, a) => (n[a] = !0, n), {});
  return t.getAll(nf).filter((n) => s[n]);
};
function ln(t) {
  switch (t) {
    case ce.inactive:
      return /* @__PURE__ */ e.jsx("span", { className: "dc__inline-block icon-dim-8-imp dc__border-radius-50-per bcr-5" });
    case ce.temporary:
      return /* @__PURE__ */ e.jsx(ld, { className: "icon-dim-20 scy-5" });
    case ce.active:
    default:
      return /* @__PURE__ */ e.jsx("span", { className: "dc__inline-block icon-dim-8-imp dc__border-radius-50-per bcg-5" });
  }
}
function rv(t, s) {
  return t === Hl.inactive ? ce.inactive : s ? ce.temporary : ce.active;
}
function ov(t) {
  switch (t) {
    case ce.inactive:
      return Hl.inactive;
    case ce.temporary:
    case ce.active:
    default:
      return Hl.active;
  }
}
const af = (t, s) => ({
  userStatus: ov(t),
  ...t === ce.temporary && s ? {
    timeoutWindowExpression: new Date(s).toISOString()
  } : {}
}), uU = (t, s) => {
  const { userStatus: n, ...a } = af(t, s);
  return {
    ...a,
    status: n
  };
}, mU = (t, s) => t === ce.temporary ? {
  status: ce.inactive,
  timeToLive: ""
} : {
  status: t,
  timeToLive: s
}, _U = () => ({
  userStatus: ce.active,
  timeToLive: ""
}), fU = () => ({
  status: ce.active,
  timeToLive: ""
}), iv = (t) => t === fs || !t ? "" : it(t).format(Ir.TWELVE_HOURS_FORMAT_WITHOUT_WEEKDAY), hU = (t) => t === ce.inactive;
function oc(t, s) {
  switch (t) {
    case ce.inactive:
      return "Inactive";
    case ce.temporary:
      return `Active until ${s}`;
    case ce.active:
    default:
      return "Active";
  }
}
function gU(t, s) {
  const n = rv(t, s);
  switch (n) {
    case ce.inactive:
    case ce.active:
      return oc(n, s);
    case ce.temporary:
      return `Active until ${jx(s)}`;
    default:
      throw new Error(`Unknown user status: ${t}`);
  }
}
function lv(t) {
  switch (t) {
    case ce.inactive:
      return "Activate until...";
    case ce.temporary:
      return "Change timeout";
    case ce.active:
    default:
      return "Keep active until...";
  }
}
const cv = (t) => (t ?? []).map(({ name: s, userGroupId: n }) => ({
  label: s,
  value: n
})), dv = (t) => (t ?? []).reduce((s, { userGroupId: n }) => (s[n] = !0, s), {}), xU = () => ({
  title: "Select users to include in export (.csv)",
  options: [
    {
      label: "Current users",
      description: "Includes active and inactive",
      value: Wn.excludeDelete
    },
    {
      label: "Deleted users",
      value: Wn.onlyDeleted
    }
  ]
}), EU = (t) => t[Wn.onlyDeleted] && t[Wn.excludeDelete] ? Wn.includeDeleted : t[Wn.onlyDeleted] ? Wn.onlyDeleted : Wn.excludeDelete, Ko = 4, Rr = {
  [X.lockConfiguration]: {
    NULL_STATE_TITLE: "Apply lock profiles to deployment templates",
    NULL_STATE_SUBTITLE: "Apply lock profiles to specific deployment templates or deployment templates matching certain criteria (eg. Project, Application, Cluster or Environment)",
    RADIO_GROUP_LABEL: "Apply selected profiles to deployment templates of",
    GLOBAL_CRITERION_TITLE: "Global (All deployment templates)",
    MATCH_CRITERION_TITLE: "All deployment templates matching:",
    SPECIFIC_CRITERION_TITLE: "Specific deployment templates",
    GLOBAL_CRITERION_NULL_STATE_TITLE: "Apply profiles to all deployment templates",
    GLOBAL_CRITERION_NULL_STATE_SUB_TITLE: "Selected profiles will be applied to all existing and future deployment templates across all applications",
    MATCH_CRITERION_NULL_STATE_TITLE: "Select criteria to apply profiles to all matching deployment templates",
    MATCH_CRITERION_SELECTIONS_VIEW_TITLE: "Apply selected profiles to all existing and future deployment templates matching",
    SPECIFIC_CRITERION_NO_CRITERION_SELECTIONS_TITLE: "Select filters to view deployment templates",
    SPECIFIC_CRITERION_NO_CRITERION_SELECTIONS_SUB_TITLE: "Filter deployment templates by application, environment or cluster and apply profiles to specific deployment templates",
    SPECIFIC_CRITERION_OPTIONS_NULL_STATE_TITLE: "No deployment templates available for the current filter(s)",
    SPECIFIC_CRITERION_OPTIONS_NULL_STATE_SUB_TITLE: "Available deployment templates will be shown here for selection",
    SPECIFIC_CRITERION_NO_SELECTIONS_SUB_TITLE: "Selected deployment templates will be shown here for review"
  },
  [X.imagePromotion]: {
    NULL_STATE_TITLE: "Apply promotion profiles to deployment pipelines",
    NULL_STATE_SUBTITLE: "Apply promotion profiles to specific deployment pipelines or deployment pipelines matching certain criteria (eg. Project, Application, Cluster or Environment)",
    RADIO_GROUP_LABEL: "Apply selected profiles to deployment pipelines of",
    GLOBAL_CRITERION_TITLE: "Global (All deployment pipelines)",
    MATCH_CRITERION_TITLE: "All deployment pipelines matching:",
    SPECIFIC_CRITERION_TITLE: "Specific deployment pipelines",
    GLOBAL_CRITERION_NULL_STATE_TITLE: "Apply profiles to all deployment pipelines",
    GLOBAL_CRITERION_NULL_STATE_SUB_TITLE: "Selected profiles will be applied to all existing and future deployment pipelines across all applications",
    MATCH_CRITERION_NULL_STATE_TITLE: "Select criteria to apply profiles to all matching deployment pipelines",
    MATCH_CRITERION_SELECTIONS_VIEW_TITLE: "Apply selected profiles to all existing and future deployment pipelines matching",
    SPECIFIC_CRITERION_NO_CRITERION_SELECTIONS_TITLE: "Select filters to view deployment pipelines",
    SPECIFIC_CRITERION_NO_CRITERION_SELECTIONS_SUB_TITLE: "Filter deployment pipelines by application, environment or cluster and apply profiles to specific deployment pipelines",
    SPECIFIC_CRITERION_OPTIONS_NULL_STATE_TITLE: "No deployment pipelines available for the current filter(s)",
    SPECIFIC_CRITERION_OPTIONS_NULL_STATE_SUB_TITLE: "Available deployment pipelines will be shown here for selection",
    SPECIFIC_CRITERION_NO_SELECTIONS_SUB_TITLE: "Selected deployment pipelines will be shown here for review"
  },
  [X.plugins]: {
    NULL_STATE_TITLE: "Apply plugin profiles to pipelines",
    NULL_STATE_SUBTITLE: "Apply plugin profiles to pipelines matching certain criteria (eg. Project, Application, Cluster or Environment)",
    RADIO_GROUP_LABEL: "Apply selected policies to all pipelines",
    GLOBAL_CRITERION_TITLE: "Global",
    MATCH_CRITERION_TITLE: "All pipelines matching:",
    SPECIFIC_CRITERION_TITLE: "Specific pipelines",
    GLOBAL_CRITERION_NULL_STATE_TITLE: "Apply profiles to all pipelines",
    GLOBAL_CRITERION_NULL_STATE_SUB_TITLE: "Selected profiles will be applied to all existing and future pipelines across all applications",
    MATCH_CRITERION_NULL_STATE_TITLE: "Select criteria to apply profiles to all matching pipelines",
    MATCH_CRITERION_SELECTIONS_VIEW_TITLE: "Apply selected profiles to all existing and future pipelines matching",
    SPECIFIC_CRITERION_NO_CRITERION_SELECTIONS_TITLE: "Select filters to view pipelines",
    SPECIFIC_CRITERION_NO_CRITERION_SELECTIONS_SUB_TITLE: "Filter pipelines by application, environment or cluster and apply profiles to specific deployment pipelines",
    SPECIFIC_CRITERION_OPTIONS_NULL_STATE_TITLE: "No pipelines available for the current filter(s)",
    SPECIFIC_CRITERION_OPTIONS_NULL_STATE_SUB_TITLE: "Available pipelines will be shown here for selection",
    SPECIFIC_CRITERION_NO_SELECTIONS_SUB_TITLE: "Selected pipelines will be shown here for review"
  },
  [X.approval]: {
    NULL_STATE_TITLE: "Apply approval policy to pipelines",
    NULL_STATE_SUBTITLE: "Apply approval policy to pipelines matching certain criteria (eg. Project, Application, Cluster or Environment)",
    RADIO_GROUP_LABEL: "Apply to",
    GLOBAL_CRITERION_TITLE: "Global",
    MATCH_CRITERION_TITLE: "By match criteria",
    SPECIFIC_CRITERION_TITLE: "Specific criteria",
    GLOBAL_CRITERION_NULL_STATE_TITLE: "Apply policies to all pipelines",
    GLOBAL_CRITERION_NULL_STATE_SUB_TITLE: "Selected policies will be applied to all existing and future pipelines across all applications",
    MATCH_CRITERION_NULL_STATE_TITLE: "Select criteria to apply policies to all matching pipelines",
    MATCH_CRITERION_SELECTIONS_VIEW_TITLE: "Apply selected policies to all existing and future pipelines matching",
    SPECIFIC_CRITERION_NO_CRITERION_SELECTIONS_TITLE: "Select filters to view pipelines",
    SPECIFIC_CRITERION_NO_CRITERION_SELECTIONS_SUB_TITLE: "Filter pipelines by application, environment or cluster and apply policies to specific pipelines",
    SPECIFIC_CRITERION_OPTIONS_NULL_STATE_TITLE: "No pipelines available for the current filter(s)",
    SPECIFIC_CRITERION_OPTIONS_NULL_STATE_SUB_TITLE: "Available pipelines will be shown here for selection",
    SPECIFIC_CRITERION_NO_SELECTIONS_SUB_TITLE: "Selected pipelines will be shown here for review"
  }
}, ic = {
  [X.lockConfiguration]: {
    title: "Lock Deployment Configuration",
    link: Y.LOCK_CONFIGURATION_APPLIED_PROFILE_LIST
  },
  [X.imagePromotion]: {
    title: "Image Promotion Policy",
    link: Y.IMAGE_PROMOTION_APPLIED_PROFILE_LIST
  },
  [X.plugins]: {
    title: "Plugin Policy",
    link: Y.PLUGIN_POLICY_APPLIED_PROFILE_LIST
  },
  [X.approval]: {
    title: "Approval Policy",
    link: Y.APPROVAL_POLICY_APPLIED_POLICY_LIST
  }
}, Ds = {
  [z.baseDeploymentTemplate]: "Base deployment template",
  [z.baseConfiguration]: "Base configuration",
  [z.branchFixed]: "Branch fixed",
  [z.branchRegex]: "Branch regex"
}, pv = {
  [X.lockConfiguration]: Y.LOCK_CONFIGURATION_PROFILE_CREATE,
  [X.imagePromotion]: Y.IMAGE_PROMOTION_PROFILE_CREATE,
  [X.plugins]: Y.PLUGIN_POLICY_PROFILE_CREATE,
  [X.approval]: Y.APPROVAL_POLICY_CREATE
}, uv = {
  [hn.remove]: "bcr-1",
  [hn.add]: "bcg-1",
  [hn.white]: "bg__primary",
  [hn.default]: "bg__secondary"
}, Qn = {
  [X.lockConfiguration]: {
    [z.baseDeploymentTemplate]: !0,
    [z.baseConfiguration]: !1,
    [z.branchFixed]: !1,
    [z.branchRegex]: !1
  },
  [X.imagePromotion]: {
    [z.baseDeploymentTemplate]: !1,
    [z.baseConfiguration]: !1,
    [z.branchFixed]: !1,
    [z.branchRegex]: !1
  },
  [X.plugins]: {
    [z.baseDeploymentTemplate]: !1,
    [z.baseConfiguration]: !1,
    [z.branchFixed]: !0,
    [z.branchRegex]: !0
  },
  [X.approval]: {
    [z.baseDeploymentTemplate]: !1,
    [z.baseConfiguration]: !0,
    [z.branchFixed]: !1,
    [z.branchRegex]: !1
  }
}, bl = {
  [ie.devtronApplication]: "identifier",
  [ie.project]: "identifier",
  [ie.cluster]: "identifier",
  [ie.environment]: "identifier",
  [z.baseDeploymentTemplate]: "identifier",
  [z.baseConfiguration]: "identifier",
  [z.branchFixed]: z.branchFixed,
  [z.branchRegex]: z.branchRegex
}, gn = {
  [ie.devtronApplication]: ie.devtronApplication,
  [ie.project]: ie.project,
  [ie.cluster]: ie.cluster,
  [ie.environment]: ie.environment,
  [z.baseDeploymentTemplate]: z.baseDeploymentTemplate,
  [z.baseConfiguration]: z.baseConfiguration,
  [z.branchFixed]: ie.ciPipeline,
  [z.branchRegex]: ie.ciPipeline
}, mv = {
  [X.lockConfiguration]: !1,
  [X.imagePromotion]: !1,
  [X.plugins]: !0,
  [X.approval]: !1
}, Un = {
  [X.lockConfiguration]: !1,
  [X.imagePromotion]: !1,
  [X.plugins]: !1,
  [X.approval]: !0
}, rf = {
  [X.lockConfiguration]: Y.LOCK_CONFIGURATION_APPLIED_PROFILE_CREATE,
  [X.imagePromotion]: Y.IMAGE_PROMOTION_APPLIED_PROFILE_CREATE,
  [X.plugins]: Y.PLUGIN_POLICY_APPLIED_PROFILE_CREATE,
  [X.approval]: Y.APPROVAL_POLICY_APPLIED_POLICY_CREATE
}, pn = {
  [tt.deploymentApproval]: "Deployments",
  [tt.configurationApproval]: "Configuration change"
}, el = {
  [Cn.deploymentTemplateConfiguration]: "Deployment template",
  [Cn.configMapConfiguration]: "ConfigMaps",
  [Cn.configSecretConfiguration]: "Secrets"
}, _v = {
  [X.lockConfiguration]: null,
  [X.imagePromotion]: null,
  [X.plugins]: null,
  [X.approval]: [
    {
      label: `${pn[tt.deploymentApproval]} approval`,
      value: tt.deploymentApproval
    },
    {
      label: `${pn[tt.configurationApproval]} approval`,
      value: tt.configurationApproval
    }
  ]
}, Cd = {
  [X.lockConfiguration]: null,
  [X.imagePromotion]: null,
  [X.plugins]: null,
  [X.approval]: {
    [tt.deploymentApproval]: [],
    [tt.configurationApproval]: [
      {
        identifier: Cn.deploymentTemplateConfiguration
      },
      {
        identifier: Cn.configMapConfiguration
      },
      {
        identifier: Cn.configSecretConfiguration
      }
    ]
  }
}, Vp = structuredClone(
  Un
), fv = [
  {
    label: "Configuration Change",
    value: tt.configurationApproval
  },
  {
    label: "Deployment",
    value: tt.deploymentApproval
  }
], Yp = [
  {
    label: "Active",
    value: ce.active,
    startIcon: ln(ce.active)
  },
  {
    label: "Inactive",
    value: ce.inactive,
    startIcon: ln(ce.inactive)
  }
], hv = {
  [tt.configurationApproval]: "If enabled, the configuration change approval policy will not apply to super admins",
  [tt.deploymentApproval]: "If enabled, the deployment approval policy will not apply to super admins"
}, gv = {
  [tt.configurationApproval]: "The configuration change approval policy will not apply to users or groups added here",
  [tt.deploymentApproval]: "The deployment approval policy will not apply to users or groups added here"
}, xv = (t) => ({
  name: t?.name,
  description: t?.description ?? "",
  userGroupId: t?.identifier,
  usersCount: t?.usersCount ?? 0,
  identifier: t?.identifier ?? ""
}), Ev = (t) => t ? t.map(xv).sort((s, n) => Ce(s.name, n.name)) : [], CU = (t) => t.map(({ userGroupId: s }) => ({
  identifier: s
})), of = (t) => {
  const { status: s, timeToLive: n } = t, a = {
    ..."userIds" in t ? {
      userIds: t.userIds
    } : {
      listingRequest: t.filterConfig
    },
    ...af(s, n)
  };
  return Bt($.USER_STATUS_BULK_UPDATE, a);
}, bd = async () => {
  try {
    const { result: t } = await le($.USER_GROUP);
    return Ev(t);
  } catch (t) {
    throw V(t), t;
  }
}, Cv = ({ policyKind: t }) => Ox({
  queryKey: [t],
  queryFn: ({ signal: s }) => le($.POLICY_EXCEPTION(t), { signal: s }),
  select: ({ result: s }) => s.reduce(
    (n, a) => {
      const r = a.applicableTo?.type ? a.applicableTo.type : null;
      return r && (n.groupByApplicableTo[r] = {
        applicableTo: a.applicableTo,
        specificUsers: a.specificUsers ?? [],
        userGroups: a.userGroups ?? [],
        enabledAtSuperAdminLevel: a.enabledAtSuperAdminLevel ?? !1,
        policyRevision: a.policyRevision ?? null
      }), n.list.push(a), n;
    },
    { list: [], groupByApplicableTo: {} }
  )
}), Nd = () => {
  const t = Rx();
  return Px({
    mutationFn: ({ payload: s, policyKind: n }) => na($.POLICY_EXCEPTION(n), s),
    onSuccess: (s, { policyKind: n }) => t.invalidateQueries({ queryKey: [n] })
  });
};
var Zn = /* @__PURE__ */ ((t) => (t.SpecificUsers = "specificUsers", t.UserGroups = "userGroups", t.EnabledAtSuperAdminLevel = "enabledAtSuperAdminLevel", t))(Zn || {});
const bv = (t) => (t ?? []).map(({ name: s, identifier: n, usersCount: a }) => ({
  label: s,
  value: n,
  description: `Users in group: ${Eo(a)}`
})), Nv = ({ identifier: t, path: s }) => [
  {
    op: Fn.remove,
    path: s,
    value: [t]
  }
], Tv = (t, s) => {
  const n = [];
  return n.push({
    op: Fn.replace,
    path: Zn.SpecificUsers,
    value: t.map(({ value: a }) => a)
  }), n.push({
    op: Fn.replace,
    path: Zn.UserGroups,
    value: s.map(({ value: a }) => a)
  }), n;
}, Iv = (t) => [
  {
    op: Fn.replace,
    path: Zn.EnabledAtSuperAdminLevel,
    value: t
  }
], vv = (t, s) => {
  const n = new Map((t ?? []).map(({ identifier: a }) => [a, !0]));
  return (s ?? []).reduce((a, { options: r }) => {
    const o = (r ?? []).filter(({ value: i }) => n.get(i) ?? !1);
    return [...a, ...o];
  }, []);
}, Av = (t, s) => {
  const n = new Map(
    (t ?? []).map(({ identifier: a }) => [a, !0])
  );
  return (s ?? []).filter(({ value: a }) => n.get(a) ?? !1);
}, Sv = (t) => ({
  policyApplicableTo: t.get("policyApplicableTo") || tt.configurationApproval
}), yv = ({
  policyKind: t,
  applicableTo: s,
  showModal: n,
  users: a,
  userGroups: r,
  policyRevision: o,
  closeModal: i
}) => {
  const [l, c] = v([]), [d, p] = v([]), [m, u, f, _] = ne(
    () => vm(),
    [],
    n
  ), [h, x, g, E] = ne(
    () => bd(),
    [],
    n
  ), { mutate: C, isLoading: b } = Nd(), N = !!(a.length || r.length), I = Q(() => bv(x), [x]);
  J(() => {
    c(vv(a, u)), p(Av(r, I));
  }, [a, r, u, I]);
  const T = (L) => c(L), A = (L) => p(L), S = () => {
    C(
      {
        policyKind: t,
        payload: {
          applicableTo: s,
          query: Tv(l, d),
          policyRevision: o
        }
      },
      {
        onSuccess: () => {
          Z.showToast({
            variant: ee.success,
            description: "Exceptions updated"
          }), i();
        }
      }
    );
  };
  return /* @__PURE__ */ e.jsx(Im, { children: n && // TODO: Create a generic modal component (with animations and other handlings) and replace with it.
  /* @__PURE__ */ e.jsx(Mc, { onEscape: i, children: /* @__PURE__ */ e.jsxs(
    gi.div,
    {
      className: "shadow__modal flexbox-col bg__primary border__secondary br-8 dc__m-auto mt-40 w-600",
      exit: { y: 100, opacity: 0, scale: 0.75, transition: { duration: 0.35 } },
      initial: { y: 100, opacity: 0, scale: 0.75 },
      animate: { y: 0, opacity: 1, scale: 1 },
      onClick: Le,
      children: [
        /* @__PURE__ */ e.jsxs("header", { className: "px-20 pt-16 pb-15 flex dc__content-space border__secondary--bottom", children: [
          /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-16 lh-24 fw-6 cn-9", children: `${N ? "Edit" : "Add"} Exceptions for ${pn[s.type]}` }),
          /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: "add-user-groups-modal-close",
              ariaLabel: "add-user-groups-modal-close",
              showAriaLabelInTippy: !1,
              icon: /* @__PURE__ */ e.jsx(W, { name: "ic-close-large", color: null }),
              variant: w.borderLess,
              style: B.negativeGrey,
              size: O.xs,
              onClick: i
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs("main", { className: "flex-grow-1 p-20 flexbox-col dc__gap-14 h-250", children: [
          /* @__PURE__ */ e.jsx(
            Ve,
            {
              inputId: "exception-users-dropdown",
              isMulti: !0,
              label: "Add users",
              helperText: "Users must have necessary permissions.",
              placeholder: "Select users",
              fullWidth: !0,
              options: u ?? [],
              value: l,
              onChange: T,
              isLoading: m,
              isDisabled: m,
              optionListError: f,
              reloadOptionList: _
            }
          ),
          !!I.length && /* @__PURE__ */ e.jsx(
            Ve,
            {
              inputId: "exception-user-groups-dropdown",
              isMulti: !0,
              label: "Add user groups",
              helperText: "Users in the selected group must have necessary permissions.",
              placeholder: "Select user groups",
              fullWidth: !0,
              options: I,
              value: d,
              onChange: A,
              isLoading: h,
              isDisabled: h,
              optionListError: g,
              reloadOptionList: E
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs("footer", { className: "px-20 pt-15 pb-16 flex right dc__gap-12 border__secondary--top", children: [
          /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: "add-user-groups-modal-cancel",
              variant: w.secondary,
              style: B.neutral,
              onClick: i,
              text: "Cancel"
            }
          ),
          /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: "add-user-groups-modal-save",
              onClick: S,
              text: "Save",
              isLoading: b
            }
          )
        ] })
      ]
    }
  ) }) });
}, Lv = ({
  policyKind: t,
  applicableTo: s,
  users: n,
  userGroups: a,
  showExceptionStatus: r = !1,
  policyRevision: o
}) => {
  const [i, l] = v(null), [c, d] = v(!1), { sortBy: p, sortOrder: m, handleSorting: u } = vs({
    initialSortKey: "user/userGroup"
  }), { mutate: f, isLoading: _ } = Nd(), h = Q(() => {
    const T = n.map(({ identifier: A }) => ({
      identifier: A,
      path: Zn.SpecificUsers
    }));
    return T.push(
      ...a.map(({ identifier: A }) => ({
        identifier: A,
        path: Zn.UserGroups
      }))
    ), T.sort(
      (A, S) => p === "user/userGroup" ? Ce(A.identifier, S.identifier, m) : 0
    );
  }, [n, a, p, m]), x = !!h.length, g = () => u("user/userGroup"), E = () => l(null), C = () => d(!1), b = () => d(!0), N = (T) => () => l(T), I = () => {
    f(
      {
        policyKind: t,
        payload: {
          applicableTo: s,
          query: Nv(i),
          policyRevision: o
        }
      },
      {
        onSuccess: () => {
          Z.showToast({
            variant: ee.success,
            description: "Exception deleted"
          }), E();
        }
      }
    );
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "bg__primary border__secondary br-8", children: [
      /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: `flex dc__content-space px-16 ${x ? "pt-12 pb-11 border__secondary--bottom" : "py-12"}`,
          children: [
            /* @__PURE__ */ e.jsxs("div", { children: [
              /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-13 lh-20 fw-6 cn-9", children: "Specific Users / User Groups" }),
              /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-12 lh-20 cn-7", children: gv[s.type] })
            ] }),
            /* @__PURE__ */ e.jsx(
              j,
              {
                dataTestId: "approval-policy-exception-add-user-user-groups",
                variant: w.borderLess,
                startIcon: /* @__PURE__ */ e.jsx(W, { name: x ? "ic-pencil" : "ic-add", color: null }),
                text: x ? "Edit" : "Add",
                onClick: b,
                size: O.medium
              }
            )
          ]
        }
      ),
      x && /* @__PURE__ */ e.jsxs("div", { className: "policy-exception__user-list-table pb-8", children: [
        /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: `policy-exception__user-list-table-header px-16 py-8 fw-6 ${r ? "" : "no-exception-status"}`,
            children: [
              /* @__PURE__ */ e.jsx("span", {}),
              /* @__PURE__ */ e.jsx(
                Ne,
                {
                  title: "User / User Group",
                  disabled: !1,
                  isSortable: !0,
                  isSorted: p === "user/userGroup",
                  sortOrder: m,
                  triggerSorting: g
                }
              ),
              r && /* @__PURE__ */ e.jsx(Ne, { title: "Exception status", isSortable: !1 }),
              /* @__PURE__ */ e.jsx("span", {})
            ]
          }
        ),
        h.map((T) => /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: `policy-exception__user-list-table-row px-16 py-4 dc__hover-n50 ${r ? "" : "no-exception-status"}`,
            children: [
              /* @__PURE__ */ e.jsx(
                so,
                {
                  identifier: T.identifier,
                  isUserGroup: T.path === Zn.UserGroups
                }
              ),
              r && /* @__PURE__ */ e.jsx(
                Ve,
                {
                  inputId: "exception-status-dropdown",
                  variant: cn.COMPACT,
                  options: Yp,
                  value: Yp[0],
                  placeholder: "Select exception status"
                }
              ),
              /* @__PURE__ */ e.jsx(
                j,
                {
                  dataTestId: "approval-policy-exception-delete-user-user-groups",
                  ariaLabel: "approval-policy-exception-delete-user-user-groups",
                  showAriaLabelInTippy: !1,
                  variant: w.borderLess,
                  style: B.negativeGrey,
                  icon: /* @__PURE__ */ e.jsx(W, { name: "ic-delete", color: null }),
                  size: O.small,
                  onClick: N(T)
                }
              )
            ]
          },
          `${T.path}-${T.identifier}`
        ))
      ] })
    ] }),
    !!i && /* @__PURE__ */ e.jsx(
      zt,
      {
        variant: Ct.delete,
        title: `Remove '${i.identifier}' as exception`,
        subtitle: /* @__PURE__ */ e.jsxs("p", { className: "m-0 fs-13 lh-20 cn-8", children: [
          `${i.path === Zn.SpecificUsers ? "User" : `Users in '${i.identifier}'`} will require approval for performing '${pn[s.type]}' action.`,
          /* @__PURE__ */ e.jsx("br", {}),
          "Are you sure?"
        ] }),
        buttonConfig: {
          secondaryButtonConfig: {
            text: "Cancel",
            onClick: E,
            disabled: _
          },
          primaryButtonConfig: {
            text: "Delete",
            onClick: I,
            isLoading: _,
            disabled: _
          }
        },
        handleClose: E
      }
    ),
    /* @__PURE__ */ e.jsx(
      yv,
      {
        policyKind: t,
        applicableTo: s,
        users: n,
        userGroups: a,
        policyRevision: o,
        showModal: c,
        closeModal: C
      }
    )
  ] });
}, jv = ({
  policyKind: t,
  applicableTo: s,
  enabledForSuperAdmin: n,
  policyRevision: a
}) => {
  const [r, o] = v(n);
  J(() => {
    r !== n && o(n);
  }, [n]);
  const { mutate: i, isLoading: l } = Nd(), c = () => {
    const d = !r;
    o(d), i(
      {
        policyKind: t,
        payload: {
          applicableTo: s,
          query: Iv(d),
          policyRevision: a
        }
      },
      {
        onError: () => {
          o(r);
        }
      }
    );
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "py-12 px-16 bg__primary flex dc__content-space border__secondary br-8", children: [
    /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-13 lh-20 fw-6 cn-9", children: "Super admins" }),
      /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-12 lh-20 cn-7", children: hv[s.type] })
    ] }),
    /* @__PURE__ */ e.jsx(
      Gn,
      {
        name: "approval-policy-exception-super-admin-toggle",
        ariaLabel: "Super admin exception toggle",
        isChecked: r,
        onChange: c,
        isLoading: l
      }
    )
  ] });
}, Ov = ({ policyKind: t }) => {
  const { policyApplicableTo: s, updateSearchParams: n } = _t({
    parseSearchParams: Sv
  });
  J(() => {
    ct.event({
      category: "GLOBAL_EXCEPTION_POLICY_ACCESSED",
      action: "GLOBAL_EXCEPTION_POLICY_ACCESSED"
    });
  }, []);
  const {
    isLoading: a,
    data: r,
    error: o,
    refetch: i
  } = Cv({ policyKind: t }), l = Q(() => r ? Vp[t] ? r.groupByApplicableTo[s] : r.list[0] : null, [r, s]), c = (p) => {
    n({ policyApplicableTo: p.value }), p.value === tt.configurationApproval ? ct.event({
      category: "GLOBAL_EXCEPTION_POLICY_CONFIG_CHANGE_ACCESSED",
      action: "GLOBAL_EXCEPTION_POLICY_CONFIG_CHANGE_ACCESSED"
    }) : p.value === tt.deploymentApproval && ct.event({
      category: "GLOBAL_EXCEPTION_POLICY_DEPLOYMENT_ACCESSED",
      action: "GLOBAL_EXCEPTION_POLICY_DEPLOYMENT_ACCESSED"
    });
  }, d = () => a ? /* @__PURE__ */ e.jsx(Je, { pageLoader: !0 }) : o ? /* @__PURE__ */ e.jsx(
    Xe,
    {
      code: o.code,
      reload: i,
      redirectURL: Y.APPROVAL_POLICY_LIST
    }
  ) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 w-800", children: [
    Vp[t] && /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
      Qs,
      {
        name: "approval-policy-exception-applicable-to-radio-group",
        segments: fv,
        value: s,
        onChange: c
      }
    ) }),
    /* @__PURE__ */ e.jsxs(Nr, { children: [
      /* @__PURE__ */ e.jsx(
        jv,
        {
          policyKind: t,
          applicableTo: l.applicableTo,
          enabledForSuperAdmin: l.enabledAtSuperAdminLevel,
          policyRevision: l.policyRevision
        }
      ),
      /* @__PURE__ */ e.jsx(
        Lv,
        {
          policyKind: t,
          applicableTo: l.applicableTo,
          users: l.specificUsers,
          userGroups: l.userGroups,
          policyRevision: l.policyRevision
        }
      )
    ] }, s)
  ] });
  return /* @__PURE__ */ e.jsx("div", { className: "policy-exception flex-grow-1 px-20 py-16 bg__secondary dc__overflow-auto", children: d() });
};
var Qt = /* @__PURE__ */ ((t) => (t.ciPlugin = "CI_PLUGIN", t.cdPlugin = "CD_PLUGIN", t))(Qt || {}), lf = /* @__PURE__ */ ((t) => (t.all = "ALL", t))(lf || {});
const cf = {
  [Qt.ciPlugin]: /* @__PURE__ */ e.jsx(Qb, { className: "w-100 h-100" }),
  [Qt.cdPlugin]: /* @__PURE__ */ e.jsx(Qc, { className: "w-100 h-100" })
}, Td = ({
  policyKind: t,
  profileType: s
}) => {
  switch (t) {
    case X.plugins:
      return cf[s] ?? null;
    case X.imagePromotion:
      return /* @__PURE__ */ e.jsx(sN, { className: "w-100 h-100 scn-6" });
    case X.lockConfiguration:
      return /* @__PURE__ */ e.jsx(E_, { className: "w-100 h-100 scn-6" });
    case X.approval:
      return /* @__PURE__ */ e.jsx(nN, { className: "w-100 h-100 scn-6" });
    default:
      return null;
  }
}, Pr = ({
  queryParams: t,
  suffix: s
}) => ye(`${$.APPLIED_PROFILE_POLICY}${s ? `/${s}` : ""}`, t), df = (t) => t === X.imagePromotion, ai = (t, s) => ({
  label: t.name,
  value: t,
  ...t.type ? {
    startIcon: /* @__PURE__ */ e.jsx(Td, { policyKind: s, profileType: t.type })
  } : {}
}), pf = (t) => Object.values(z).includes(t), tl = (t) => (t ?? []).reduce(
  (s, n) => (s[n.kind] || (s[n.kind] = []), s[n.kind].push(n.identifier), s),
  {
    [ie.devtronApplication]: [],
    [ie.project]: [],
    [ie.cluster]: [],
    [ie.environment]: [],
    [z.baseDeploymentTemplate]: [],
    [z.baseConfiguration]: [],
    [z.branchFixed]: [],
    [z.branchRegex]: []
  }
), sl = ({
  primaryResourceIdentifier: t,
  targetIdentifier: s
}) => `${t}/${s}`, Rv = (t) => {
  if (t.selector.category === et.specific) {
    const s = t.selector.matches?.find(
      (o) => o.kind === ie.devtronApplication
    ), n = t.selector.matches?.find(
      (o) => o.kind === ie.environment || pf(o.kind)
    ), a = s && "identifiers" in s && s.identifiers ? s.identifiers?.[0] : "";
    let r = "";
    return n && ("identifiers" in n && n.identifiers ? r = n.identifiers?.[0] ?? "" : r = Ds[n.kind] ?? ""), {
      primaryResource: s,
      primaryResourceIdentifier: a,
      target: n,
      targetIdentifier: r
    };
  }
  throw new Error(
    `Expected category: ${et.specific}, got: ${t.selector.category}`
  );
}, uf = (t) => {
  const s = {
    id: t?.selector?.identifier,
    profiles: (t?.policies?.identifierDetails ?? []).map(({ identifier: n, type: a }) => ({
      name: n,
      type: a
    })).sort((n, a) => Ce(n.name, a.name)),
    applicableTo: {
      type: t?.applicableTo?.type ?? null,
      values: (t?.applicableTo?.values ?? []).map((n) => ({
        identifier: n.identifier
      }))
    }
  };
  switch (t?.selector?.category) {
    case et.specific: {
      const { primaryResource: n, primaryResourceIdentifier: a, target: r, targetIdentifier: o } = Rv(t);
      return {
        ...s,
        criterionType: t.selector.category,
        selectionCriterion: {
          selectionKey: sl({
            primaryResourceIdentifier: a,
            targetIdentifier: o
          }),
          primaryResourceKind: n?.kind,
          primaryResourceIdentifier: a,
          targetKind: r?.kind,
          targetIdentifier: o
        }
      };
    }
    case et.match:
      return {
        ...s,
        criterionType: t.selector.category,
        selectionCriterion: t.selector?.matches?.flatMap(
          (n) => (
            // Note: attributes can have multiple values so creating a new object for each of the value
            "attributes" in n && n.attributes ? n.attributes.flatMap(
              ({ key: a, values: r }) => r?.map((o) => {
                const i = a === "identifier" ? n.kind : a;
                return {
                  resourceKind: gn[i],
                  kind: i,
                  identifier: o ?? ""
                };
              }) ?? []
            ) : {
              resourceKind: gn[n.kind],
              kind: n.kind,
              identifier: Ds[n.kind] ?? ""
            }
          )
        ) ?? [],
        note: {
          value: t.selector?.note?.value ?? "",
          updatedBy: t.selector?.note?.updatedBy?.name ?? "",
          updatedOn: wx(t.selector?.note?.updatedOn, !0)
        }
      };
    case et.global:
    default:
      return {
        ...s,
        criterionType: et.global
      };
  }
}, mf = (t) => ({
  globalScopeList: t.filter(
    (s) => s.criterionType === et.global
  ),
  matchingScopeList: t.filter(
    (s) => s.criterionType === et.match
  ),
  specificScopeList: t.filter(
    (s) => s.criterionType === et.specific
  )
}), Pv = (t) => {
  if (!t?.dataList)
    return {
      globalScopeList: [],
      matchingScopeList: [],
      specificScopeList: []
    };
  const s = t.dataList.map(
    (n) => uf(n)
  );
  return mf(s);
}, Id = (t) => t === z.baseDeploymentTemplate || t === z.baseConfiguration, vd = (t) => t.type === tt.configurationApproval, wv = (t, {
  criterionSelections: s,
  applicableTo: n
}, a) => {
  if (!t)
    return [];
  const r = tl(s), o = Qn[a][z.baseDeploymentTemplate], i = Qn[a][z.baseConfiguration] && vd(n), l = o && !!r[z.baseDeploymentTemplate].length || i && !!r[z.baseConfiguration].length, c = !!r[ie.environment].length || !!r[ie.cluster].length;
  return t.flatMap((d) => [
    ...c ? [] : [
      ...o ? [
        {
          kind: z.baseDeploymentTemplate,
          identifier: Ds[z.baseDeploymentTemplate]
        }
      ] : [],
      ...i ? [
        {
          kind: z.baseConfiguration,
          identifier: Ds[z.baseConfiguration]
        }
      ] : []
    ],
    ...l ? [] : d.relatedObjects ?? []
  ].map((m) => {
    const u = d.identifier, f = m.identifier;
    return {
      selectionKey: sl({
        primaryResourceIdentifier: u,
        targetIdentifier: f
      }),
      primaryResourceKind: d.kind,
      primaryResourceIdentifier: u,
      targetKind: m.kind,
      targetIdentifier: f
    };
  }));
}, Dv = ({
  criterionSelections: t,
  profileCriterion: s,
  profiles: n,
  specificSelections: a,
  policyKind: r,
  appliedProfileId: o,
  note: i,
  applicableTo: l
}) => {
  const c = {
    policies: {
      type: r,
      identifiers: n.map(({ name: p }) => p)
    },
    applicableTo: l
  }, d = o ?? 0;
  switch (s) {
    case et.specific:
      return {
        ...c,
        selectors: a.map((p) => ({
          category: s,
          identifier: d,
          matches: [
            {
              kind: p.primaryResourceKind,
              attributes: [
                {
                  key: bl[p.primaryResourceKind],
                  values: [p.primaryResourceIdentifier]
                }
              ]
            },
            // There is no identifier in base deployment specific selection cases
            Id(p.targetKind) ? {
              kind: p.targetKind
            } : {
              kind: p.targetKind,
              attributes: [
                {
                  key: bl[p.targetKind],
                  values: [p.targetIdentifier]
                }
              ]
            }
          ]
        }))
      };
    case et.match:
      return {
        ...c,
        selectors: [
          {
            identifier: d,
            category: s,
            matches: t.map((p) => ({
              kind: p.resourceKind,
              attributes: [
                {
                  key: bl[p.kind],
                  values: [p.identifier]
                }
              ]
            })),
            note: {
              value: i.value,
              updatedBy: null,
              updatedOn: null
            }
          }
        ]
      };
    case et.global:
    default:
      return {
        ...c,
        selectors: [
          {
            identifier: d,
            category: s
          }
        ]
      };
  }
}, Mv = (t) => {
  const s = tl(t);
  return {
    filterCriteria: Object.keys(s).filter(
      (n) => !Id(n) && s[n].length > 0
    ).map(
      (n) => `${n}|identifier|${s[n]}`
    )
  };
}, kv = ({
  profilesToAdd: t,
  profilesToRemove: s,
  appliedProfileIds: n,
  policyKind: a
}) => ({
  policiesToAdd: t.length ? {
    type: a,
    identifiers: t
  } : null,
  policiesToRemove: s.length ? {
    type: a,
    identifiers: s
  } : null,
  selectors: n
}), Fv = (t, s) => {
  const { application: n, cluster: a, environment: r, profile: o, project: i, branchFix: l, branchRegex: c, plugin: d, applicableTo: p } = t, m = i.map(
    (b) => `${ie.project}|identifier|${b}`
  ), u = n.map(
    (b) => `${ie.devtronApplication}|identifier|${b}`
  ), f = a.map(
    (b) => `${ie.cluster}|identifier|${b}`
  ), _ = r.map(
    (b) => `${ie.environment}|identifier|${b}`
  ), h = o.map(
    (b) => `policy/${s}|identifier|${b}`
  ), x = l.map(
    (b) => `${gn[z.branchFixed]}|${z.branchFixed}|${b}`
  ), g = c.map(
    (b) => `${gn[z.branchRegex]}|${z.branchRegex}|${b}`
  ), E = s === X.plugins ? d.map(
    (b) => `plugin-parent|identifier|${b}`
  ) : [], C = Un[s] ? p.map(
    (b) => `applicableTo|identifier|${b}`
  ) : [];
  return {
    filterCriteria: [
      ...m,
      ...u,
      ...f,
      ..._,
      ...h,
      ...x,
      ...g,
      ...E,
      ...C
    ]
  };
}, Uv = (t) => t ? t.map((s) => ({
  name: s.identifier,
  type: s?.spec?.def?.type ?? null
})).sort((s, n) => Ce(s.name, n.name)) : [], Gv = async ({ policyKind: t, filterConfig: s }, n) => {
  try {
    const a = Fv(s, t), { result: r } = await we(
      Pr({
        suffix: $.API_LIST_SUFFIX,
        queryParams: {
          kind: t
        }
      }),
      a,
      {
        signal: n
      }
    );
    return Pv(r);
  } catch (a) {
    throw Pe(a) || V(a), a;
  }
}, Bv = async ({
  policyKind: t,
  id: s
}) => {
  try {
    const { result: n } = await le(
      Pr({
        queryParams: {
          kind: t,
          identifier: s
        }
      })
    );
    return uf(n);
  } catch (n) {
    throw V(n), n;
  }
}, Ad = async ({
  policyKind: t
}) => {
  try {
    const s = ks({
      kind: t,
      version: mt.alpha1,
      suffix: $.API_LIST_SUFFIX
    }), {
      result: n
    } = await le(
      ye(s, {
        // Use non-lite mode for custom icons
        lite: !mv[t]
      })
    );
    return Uv(n?.dataList);
  } catch (s) {
    throw V(s), s;
  }
}, $v = async (t) => {
  const s = Pr({
    queryParams: {
      // Kind is not required
      kind: null
    }
  });
  return Js(s, {
    identifiers: t
  });
}, Vv = (t) => {
  const s = Pr({
    queryParams: {
      // Kind is not required
      kind: null
    }
  }), n = Dv(t);
  return t.isEditMode ? Bt(s, n) : we(s, n);
}, Yv = async ({
  applicableTo: t,
  id: s,
  policyKind: n,
  updatedProfiles: a
}) => {
  const r = Pr({
    queryParams: {
      // Kind is not required
      kind: null
    }
  });
  return na(r, {
    policies: {
      type: n,
      identifiers: a
    },
    applicableTo: t,
    selector: s
  });
}, _f = async (t) => {
  const s = Pr({
    queryParams: {
      // Kind is not required
      kind: null
    },
    suffix: $.API_BULK_SUFFIX
  }), n = kv(t);
  return na(s, n);
}, Hv = async ({
  criterionSelections: t,
  applicableTo: s
}, n, a) => {
  try {
    if (!t?.length)
      return [];
    const r = Mv(t), o = ye($.LOCK_CONFIG_SPECIFIC_CRITERIA_OPTIONS, r), { result: i } = await le(o, {
      signal: n
    });
    return wv(
      i,
      {
        criterionSelections: t,
        applicableTo: s
      },
      a
    );
  } catch (r) {
    throw Pe(r) || V(r), r;
  }
}, Kv = async ({
  policyKind: t
}) => {
  const { result: s } = await le(
    ye($.APPLIED_PROFILE_POLICY_FILTERS_LIST, {
      kind: t,
      selector: [
        `${gn[z.branchFixed]}|${z.branchFixed}`,
        `${gn[z.branchRegex]}|${z.branchRegex}`
      ]
    })
  );
  if (!s)
    return [];
  const n = s.find(
    (r) => r.kind === gn[z.branchFixed]
  )?.attributes ?? [], a = s.find(
    (r) => r.kind === gn[z.branchRegex]
  )?.attributes ?? [];
  return [
    {
      label: Ds[z.branchFixed],
      options: (n.find((r) => r.key === z.branchFixed)?.values ?? []).map((r) => ({
        label: r,
        value: r,
        kind: z.branchFixed
      }))
    },
    {
      label: Ds[z.branchRegex],
      options: (a.find((r) => r.key === z.branchRegex)?.values ?? []).map((r) => ({
        label: r,
        value: r,
        kind: z.branchRegex
      }))
    }
  ];
}, ff = ({
  policyKind: t,
  isEditMode: s,
  applicableTo: n,
  handleApplicableToTypeUpdate: a,
  handleApplicableToValuesChange: r
}) => {
  const o = _v[t], i = o.find((m) => m.value === n.type), l = Cd[t][n.type] ?? [], c = n.values.reduce(
    (m, { identifier: u }) => (m[u] = !0, m),
    {
      [Cn.deploymentTemplateConfiguration]: !1,
      [Cn.configMapConfiguration]: !1,
      [Cn.configSecretConfiguration]: !1
    }
  ), d = (m) => {
    a(m.value);
  }, p = (m) => () => {
    r(
      c[m] ? n.values.filter(({ identifier: u }) => u !== m) : [
        ...n.values,
        {
          identifier: m
        }
      ]
    );
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flex column left dc__gap-4", children: [
    s && n.type ? /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8 cn-9 fs-13 fw-6 lh-20", children: [
      /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "Use selected policy for approval of" }),
      /* @__PURE__ */ e.jsx("p", { className: "cb-5 m-0", children: pn[n.type] })
    ] }) : /* @__PURE__ */ e.jsx(
      Ve,
      {
        inputId: "applicable-to-type-selector",
        options: o,
        value: i,
        onChange: d,
        size: O.large,
        label: "Use selected policy for",
        placeholder: "Select scope",
        isDisabled: s,
        required: !0,
        fullWidth: !0
      }
    ),
    l.length > 0 && /* @__PURE__ */ e.jsx("div", { className: "flex left dc__gap-16", children: l.map(({ identifier: m }) => /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8 py-4", children: [
      /* @__PURE__ */ e.jsx(
        $e,
        {
          value: Fe.CHECKED,
          isChecked: c[m],
          rootClassName: "mb-0 w-20 h-20",
          onChange: p(m),
          id: `applicable-to-${m}`
        }
      ),
      /* @__PURE__ */ e.jsx("label", { htmlFor: `applicable-to-${m}`, className: "mb-0 fs-13 cn-9 fw-4 lh-20", children: el[m] })
    ] }, m)) })
  ] });
}, Sd = ({ handleChange: t, selectedProfiles: s, policyKind: n, error: a = null, label: r }) => {
  const o = df(n), i = r ?? o ? "Select profile to apply" : "Select profiles to apply", [l, c, d, p] = ne(
    () => Ad({ policyKind: n }),
    [n]
  ), m = c?.map((_) => ai(_, n)) ?? [], u = s?.map((_) => ai(_, n)) ?? [], f = (_) => {
    t(_ ? [ai(_.value, n)] : []);
  };
  return /* @__PURE__ */ e.jsx(
    Ve,
    {
      error: a,
      required: !0,
      placeholder: "Search profile",
      isSearchable: !0,
      isClearable: !0,
      isDisabled: l,
      isLoading: l,
      value: u[0] ?? null,
      options: m,
      label: i,
      size: O.large,
      optionListError: d,
      reloadOptionList: p,
      menuListFooterConfig: {
        type: "button",
        buttonProps: {
          variant: w.borderLess,
          text: "Create profile",
          startIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-add", color: null }),
          dataTestId: "create-new-profile",
          linkProps: {
            to: pv[n]
          },
          component: Re.link
        }
      },
      ...o ? {
        inputId: "single-profile-selection",
        value: u[0] ?? null,
        onChange: f
      } : {
        inputId: "profile-selection",
        isMulti: !0,
        value: u,
        onChange: t
      },
      getOptionValue: (_) => `${_.value.name}`,
      menuPosition: "absolute"
    }
  );
};
var at = /* @__PURE__ */ ((t) => (t.updateProfiles = "updateProfiles", t.updateApplicableToType = "updateApplicableToType", t.updateApplicableToValues = "updateApplicableToValues", t.updateProfileCriterion = "updateProfileCriterion", t.updateSelectionCriterionKind = "updateSelectionCriterionKind", t.updateCriterionSelections = "updateCriterionSelections", t.selectSpecificSelection = "selectSpecificSelection", t.deselectSpecificSelection = "deselectSpecificSelection", t.bulkSelectSpecificSelections = "bulkSelectSpecificSelections", t.bulkDeselectSpecificSelections = "bulkDeselectSpecificSelections", t.openSelectMenu = "openSelectMenu", t.closeSelectMenu = "closeSelectMenu", t.updateNote = "updateNote", t))(at || {}), Gr = /* @__PURE__ */ ((t) => (t.updateSelections = "updateSelections", t.allSelections = "allSelections", t))(Gr || {}), Ta = /* @__PURE__ */ ((t) => (t.application = "application", t.scopeEnvironment = "scopeEnvironment", t))(Ta || {});
const hf = {
  [ie.devtronApplication]: "App",
  [ie.project]: "Project",
  [ie.cluster]: "Cluster",
  [ie.environment]: "Env",
  [z.baseDeploymentTemplate]: "is",
  [z.baseConfiguration]: "is",
  [z.branchFixed]: "Branch fixed",
  [z.branchRegex]: "Branch regex"
}, Wv = {
  updateSelections: "Add/Remove Selections",
  allSelections: "All Selected"
}, qv = Array.from(Array(3).keys()).map((t) => ({
  selectionKey: sl({
    primaryResourceIdentifier: `app-${t}`,
    targetIdentifier: `env-${t}`
  }),
  primaryResourceKind: ie.devtronApplication,
  primaryResourceIdentifier: `app-${t}`,
  targetIdentifier: `env-${t}`,
  targetKind: ie.environment
})), po = {
  [fn.allExistingAndFutureNonProdEnvironments]: "All non-prod environments",
  [fn.allExistingAndFutureProdEnvironments]: "All prod environments"
}, nl = (t, s) => po[s] || s, gf = (t) => t?.map(({ identifier: s, kind: n }) => ({
  // Use the label for all identifiers based on a group if applicable
  label: nl(n, s),
  value: s,
  selectionCriterionKind: n
})) ?? [], xf = ({
  filterNonResourceOptions: t = !1,
  criterionSelections: s = [],
  policyKind: n,
  applicableTo: a
}) => {
  const r = gf(s).reduce(
    (c, d) => (c[d.selectionCriterionKind] || (c[d.selectionCriterionKind] = !0), c),
    {
      [ie.project]: !1,
      [ie.devtronApplication]: !1,
      [ie.cluster]: !1,
      [ie.environment]: !1,
      [z.baseDeploymentTemplate]: !1,
      [z.baseConfiguration]: !1,
      [z.branchFixed]: !1,
      [z.branchRegex]: !1
    }
  ), o = r[z.baseDeploymentTemplate] || r[z.baseConfiguration], i = r[ie.cluster] || r[ie.environment];
  return [
    {
      label: "Project",
      value: ie.project
    },
    {
      label: "Application",
      value: ie.devtronApplication
    },
    {
      label: "Cluster",
      value: ie.cluster,
      disabled: o,
      tippyContent: `Cluster filter cannot be applied in combination with ${r[z.baseDeploymentTemplate] ? "Base deployment template" : "Base configuration"}`
    },
    {
      label: "Environment",
      value: ie.environment,
      disabled: o,
      tippyContent: `Environment filter cannot be applied in combination with ${r[z.baseDeploymentTemplate] ? "Base deployment template" : "Base configuration"}`
    },
    {
      label: Ds[z.baseDeploymentTemplate],
      value: z.baseDeploymentTemplate,
      disabled: i,
      tippyContent: "Base deployment template filter cannot be applied in combination with Cluster or Environment filters",
      isForbidden: t || !Qn[n][z.baseDeploymentTemplate]
    },
    {
      label: Ds[z.baseConfiguration],
      value: z.baseConfiguration,
      disabled: i,
      tippyContent: "Base configuration filter cannot be applied in combination with Cluster or Environment filters",
      isForbidden: !vd(a) || t || !Qn[n][z.baseConfiguration]
    },
    {
      label: Ds[z.branchFixed],
      value: z.branchFixed,
      isForbidden: !Qn[n][z.branchFixed]
    },
    {
      label: Ds[z.branchRegex],
      value: z.branchRegex,
      isForbidden: !Qn[n][z.branchRegex]
    }
  ].filter((c) => !c.isForbidden);
}, Ef = (t) => hf[t] ?? "", lc = (t) => t.reduce(
  (s, n) => (s[n.selectionKey] = n, s),
  {}
), zv = (t, s) => {
  switch (s) {
    case ie.devtronApplication:
      return t[s].flatMap(({ appList: n }) => n).sort((n, a) => Ce(n.name, a.name)).map((n) => ({
        selectionCriterionKind: s,
        label: n.name,
        value: n.name
      }));
    case ie.project:
    case ie.cluster:
      return t[s].map((n) => ({
        selectionCriterionKind: s,
        label: n.name,
        value: n.name
      }));
    case ie.environment:
      {
        const n = t[s].flatMap(({ envList: a }) => a).sort((a, r) => Ce(a.name, r.name)).map((a) => ({
          selectionCriterionKind: s,
          label: a.name,
          value: a.name
        }));
        if (n.length)
          return [
            {
              selectionCriterionKind: s,
              label: po[fn.allExistingAndFutureProdEnvironments],
              value: fn.allExistingAndFutureProdEnvironments
            },
            {
              selectionCriterionKind: s,
              label: po[fn.allExistingAndFutureNonProdEnvironments],
              value: fn.allExistingAndFutureNonProdEnvironments
            },
            ...n
          ];
      }
      return [];
    default:
      return [];
  }
}, Xv = ({ selectionCriterionKind: t, value: s, label: n }) => `${t}/${s}/${n}`, Jv = () => /* @__PURE__ */ e.jsx("div", { className: "flexbox-col w-100", children: new Array(3).fill(void 0).map(() => /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center dc__gap-8 px-8 py-6", children: /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading br-2 h-20 w-50" }) })) }), Cf = jc(null), Qv = ({
  initialFormData: t,
  children: s,
  isEditMode: n,
  policyKind: a
}) => {
  const [r, o] = v({
    profiles: [],
    applicableTo: {
      type: null,
      values: []
    },
    profileCriterion: a === X.plugins ? et.match : et.specific,
    selectionCriterionKind: null,
    criterionSelections: [],
    specificSelections: [],
    isSelectMenuOpen: !1,
    note: {
      value: "",
      updatedOn: "",
      updatedBy: ""
    }
  }), [i, l] = v({
    profiles: ""
  }), c = t?.id ?? 0;
  J(() => {
    t && (o({
      profiles: t.profiles,
      applicableTo: t.applicableTo ?? {
        type: null,
        values: []
      },
      profileCriterion: t.criterionType,
      selectionCriterionKind: null,
      // Edit mode is only for match criterion type
      criterionSelections: t.criterionType === et.match ? t.selectionCriterion : [],
      // Specific selections are only for create mode
      specificSelections: [],
      isSelectMenuOpen: !1,
      note: t.note
    }), l({
      profiles: t.profiles.length === 0 ? "" : null
    }));
  }, [t]);
  const d = (m, u) => {
    switch (m) {
      case at.updateProfiles: {
        const f = u;
        o((_) => ({
          ..._,
          profiles: f
        })), l((_) => ({
          ..._,
          profiles: f.length === 0 ? "This is a required field" : null
        }));
        return;
      }
      case at.updateApplicableToType: {
        const f = u;
        o((_) => ({
          ..._,
          applicableTo: {
            type: f,
            values: structuredClone(
              Cd[a][f]
            )
          },
          // On change of type clear the specific/criterion selections to ensure any wrong data is not persistent
          specificSelections: [],
          criterionSelections: []
        }));
        return;
      }
      case at.updateApplicableToValues: {
        const f = u;
        o((_) => ({
          ..._,
          applicableTo: {
            ..._.applicableTo,
            values: f
          }
        }));
        return;
      }
      case at.updateProfileCriterion:
        o((f) => ({
          ...f,
          profileCriterion: u,
          selectionCriterionKind: null
        }));
        return;
      case at.updateCriterionSelections:
        o((f) => ({
          ...f,
          criterionSelections: u
        }));
        return;
      case at.updateSelectionCriterionKind: {
        const f = u, _ = Id(f);
        o((h) => ({
          ...h,
          isSelectMenuOpen: !_,
          // For base specific target type directly add the option to the criterion selections,
          // For others, open the menu with the criterion kind selected
          ..._ ? {
            criterionSelections: [
              ...h.criterionSelections,
              {
                resourceKind: gn[f],
                identifier: Ds[f],
                kind: f
              }
            ],
            isSelectMenuOpen: !1,
            selectionCriterionKind: null
          } : {
            isSelectMenuOpen: !0,
            selectionCriterionKind: u
          }
        }));
        return;
      }
      case at.openSelectMenu:
        o((f) => ({
          ...f,
          isSelectMenuOpen: !0
        }));
        return;
      case at.closeSelectMenu:
        o((f) => ({
          ...f,
          isSelectMenuOpen: !1,
          selectionCriterionKind: null
        }));
        return;
      case at.selectSpecificSelection: {
        const f = structuredClone(r.specificSelections);
        o((_) => ({
          ..._,
          specificSelections: [...f, u]
        }));
        return;
      }
      case at.deselectSpecificSelection:
        o((f) => ({
          ...f,
          specificSelections: f.specificSelections.filter(
            (_) => _.selectionKey !== u.selectionKey
          )
        }));
        return;
      case at.bulkSelectSpecificSelections:
        o((f) => {
          const _ = lc([
            ...f.specificSelections,
            ...u
          ]);
          return {
            ...f,
            specificSelections: Object.values(_)
          };
        });
        return;
      case at.bulkDeselectSpecificSelections:
        o((f) => {
          const _ = lc(u);
          return {
            ...f,
            specificSelections: f.specificSelections.filter(
              (h) => !_[h.selectionKey]
            )
          };
        });
        return;
      case at.updateNote:
        o((f) => ({
          ...f,
          note: {
            ...f.note,
            value: u?.trim() || ""
          }
        }));
        return;
      default:
        throw new Error(`Unsupported action: ${m}`);
    }
  }, p = Q(
    () => ({
      isEditMode: n,
      policyKind: a,
      formState: r,
      handleFormStateUpdate: d,
      appliedProfileId: c,
      errorState: i
    }),
    [r, n, a, c, i]
  );
  return /* @__PURE__ */ e.jsx(Cf.Provider, { value: p, children: s });
}, un = () => {
  const t = Oc(Cf);
  if (!t)
    throw new Error("Wrap with AppliedProfileDetailProvider");
  return t;
}, Zv = () => {
  const { formState: t, handleFormStateUpdate: s, isEditMode: n, policyKind: a } = un(), { SPECIFIC_CRITERION_TITLE: r, GLOBAL_CRITERION_TITLE: o, RADIO_GROUP_LABEL: i } = Rr[a], l = (c) => {
    s(
      at.updateProfileCriterion,
      c.target.value
    );
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8 dc__inline-radio-group", children: [
    /* @__PURE__ */ e.jsx("p", { className: "fs-13 fw-6 lh-20 cn-9 m-0", children: i }),
    /* @__PURE__ */ e.jsxs(
      ds,
      {
        name: "profile-criterion",
        value: t.profileCriterion,
        disabled: !1,
        onChange: l,
        className: "radio-group-no-border",
        children: [
          a !== X.plugins && /* @__PURE__ */ e.jsx(Ze, { value: et.specific, disabled: n, children: r }),
          /* @__PURE__ */ e.jsx(Ze, { value: et.match, disabled: n, children: "By match criteria" }),
          /* @__PURE__ */ e.jsx(Ze, { value: et.global, disabled: n, children: o })
        ]
      }
    )
  ] });
}, eA = ({
  handleSelectionCriterionSelect: t
}) => {
  const s = de(), { formState: n, handleFormStateUpdate: a, policyKind: r } = un(), o = Q(
    () => n.selectionCriterionKind && !pf(n.selectionCriterionKind) ? [n.selectionCriterionKind] : [],
    [n.selectionCriterionKind]
  ), { isResourcesOptionsLoading: i, refetchResourcesOptions: l, resourcesOptionsError: c, resourcesOptionsMap: d } = Am({
    resourcesToFetch: o
  }), p = xf({
    filterNonResourceOptions: !0,
    criterionSelections: n.criterionSelections,
    applicableTo: n.applicableTo,
    policyKind: r
  }), m = n.profileCriterion === et.match, u = Q(
    () => zv(d, n.selectionCriterionKind),
    [JSON.stringify(d), n.selectionCriterionKind]
  ), f = gf(n.criterionSelections), _ = n.selectionCriterionKind === z.branchFixed || n.selectionCriterionKind === z.branchRegex;
  J(() => {
    if (s.current) {
      if (n.isSelectMenuOpen || n.selectionCriterionKind) {
        s.current.focus();
        return;
      }
      s.current.onMenuClose();
    }
  }, [n.isSelectMenuOpen, n.selectionCriterionKind, i]);
  const h = () => {
    a(at.openSelectMenu, null);
  }, x = () => {
    a(at.closeSelectMenu, null);
  }, g = (I) => {
    const T = I.map(
      (A) => ({
        resourceKind: gn[A.selectionCriterionKind],
        kind: A.selectionCriterionKind,
        identifier: A.value
      })
    );
    a(
      at.updateCriterionSelections,
      T
    );
  }, E = (I) => {
    g([
      ...structuredClone(f),
      {
        label: I,
        value: I,
        selectionCriterionKind: n.selectionCriterionKind
      }
    ]);
  }, C = () => i ? /* @__PURE__ */ e.jsx(Jv, {}) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: "py-4 px-8 bg__menu--secondary fs-12 fw-6 lh-20 cn-9", children: m ? "Match" : "Filter by" }),
    /* @__PURE__ */ e.jsx("div", { children: p.map((I) => /* @__PURE__ */ e.jsx(Nr, { children: /* @__PURE__ */ e.jsx(
      Ie,
      {
        alwaysShowTippyOnHover: I.disabled,
        content: I.tippyContent,
        children: /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
          "button",
          {
            className: `dc__transparent dc__truncate dc__hover-n50 fs-13 fw-4 lh-20 cn-9 px-8 py-6 w-100 dc__align-left ${I.disabled ? "dc__disabled" : ""}`,
            type: "button",
            onClick: t(I.value),
            disabled: I.disabled,
            children: I.label
          }
        ) })
      }
    ) }, I.value)) })
  ] }), b = () => _ ? {
    type: "text",
    value: n.selectionCriterionKind === z.branchRegex ? "Enter branch regex pattern" : "Enter branch name"
  } : null, N = (I, T) => (
    // Show the selection criterion prefix in the control
    T.context === "value" ? `${hf[I.selectionCriterionKind]}: ${I.label}` : null
  );
  return /* @__PURE__ */ e.jsx(
    Ve,
    {
      selectRef: s,
      onMenuOpen: h,
      onMenuClose: x,
      menuIsOpen: n.isSelectMenuOpen,
      onBlur: x,
      options: u,
      isMulti: !0,
      placeholder: m ? "Select match criteria using a combination of project, application, cluster or environment" : "Filter by Project, Application, Cluster or Environment",
      required: !0,
      inputId: "profile-criterion-selector",
      isSearchable: !!n.selectionCriterionKind,
      isClearable: !0,
      value: f,
      onChange: g,
      getOptionValue: Xv,
      optionListError: c,
      reloadOptionList: l,
      renderCustomOptions: C,
      shouldRenderCustomOptions: i || !n.selectionCriterionKind,
      icon: /* @__PURE__ */ e.jsx(rN, {}),
      menuPosition: "absolute",
      isCreatable: _,
      shouldShowNoOptionsMessage: !_,
      menuListFooterConfig: b(),
      onCreateOption: E,
      formatOptionLabel: N
    }
  );
}, tA = () => {
  const [t, s] = v(!1), [n, a] = v(""), { formState: r, handleFormStateUpdate: o } = un();
  J(() => {
    a(r.note.value);
  }, [r.note.value]);
  const i = () => {
    s(!0);
  }, l = () => {
    s(!1);
  }, c = () => {
    const p = dn(n);
    if (!p.isValid) {
      Z.showToast({
        variant: ee.error,
        description: p.message
      });
      return;
    }
    o(
      at.updateNote,
      n
    ), l();
  }, d = (p) => {
    a(p.target.value);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      "button",
      {
        type: "button",
        className: "dc__transparent p-0 flex left dc__gap-4 fs-13 fw-6 lh-20 cb-5",
        onClick: i,
        children: r.note.value ? /* @__PURE__ */ e.jsxs("div", { className: "p-7 flex left dc__gap-4 dc__border-n1 br-4 bg__secondary", children: [
          /* @__PURE__ */ e.jsx(Ni, { className: "icon-dim-20 dc__no-shrink scb-5" }),
          /* @__PURE__ */ e.jsx(Ie, { content: r.note.value, children: /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-20 cn-9 dc__truncate", children: r.note.value }) })
        ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(Ni, { className: "icon-dim-16 dc__no-shrink scb-5" }),
          /* @__PURE__ */ e.jsx("span", { children: "Leave a note" })
        ] })
      }
    ),
    t && /* @__PURE__ */ e.jsx(wi, { className: "visible-modal__body", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__content-space dc__m-auto mt-40 br-8 bg__primary w-400 mxh-400", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space px-20 py-12 dc__border-bottom", children: [
          /* @__PURE__ */ e.jsx("h2", { className: "m-0 fs-16 fw-6 lh-24 cn-9", children: "Note" }),
          /* @__PURE__ */ e.jsx(
            j,
            {
              icon: /* @__PURE__ */ e.jsx(vt, {}),
              dataTestId: "close-modal",
              showAriaLabelInTippy: !1,
              onClick: l,
              ariaLabel: "Close modal",
              variant: w.borderLess,
              style: B.negativeGrey,
              size: O.xs
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1", children: [
          /* @__PURE__ */ e.jsx(
            Ot,
            {
              description: "Notes help team members understand the purpose and context of applied configuration profiles.",
              borderConfig: { top: !1, left: !1, right: !1 },
              borderRadiusConfig: { top: !1, left: !1, right: !1, bottom: !1 }
            }
          ),
          /* @__PURE__ */ e.jsx("div", { className: "p-16", children: /* @__PURE__ */ e.jsx(
            vn,
            {
              name: "note",
              onChange: d,
              placeholder: "Leave a note",
              value: n
            }
          ) })
        ] })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "px-20 py-16 flex dc__gap-12 dc__content-end", children: [
        /* @__PURE__ */ e.jsx(
          j,
          {
            text: "Cancel",
            dataTestId: "cancel-note",
            onClick: l,
            variant: w.secondary,
            style: B.neutral
          }
        ),
        /* @__PURE__ */ e.jsx(j, { text: "Done", dataTestId: "save-note", onClick: c })
      ] })
    ] }) })
  ] });
}, sA = () => {
  const { formState: t, policyKind: s } = un(), n = Q(
    () => tl(t.criterionSelections),
    [t.criterionSelections]
  ), { MATCH_CRITERION_NULL_STATE_TITLE: a, MATCH_CRITERION_SELECTIONS_VIEW_TITLE: r } = Rr[s];
  return t.criterionSelections.length ? /* @__PURE__ */ e.jsxs("section", { className: "flex column flex-grow-1 dc__gap-16 p-24", children: [
    /* @__PURE__ */ e.jsx(oN, { className: "icon-dim-24 dc__no-shrink circle-fill-b5" }),
    /* @__PURE__ */ e.jsx("p", { className: "w-300 fs-13 fw-4 lh-20 cn-9 m-0 dc__text-center", children: r }),
    /* @__PURE__ */ e.jsxs("div", { className: "flex column dc__gap-16 dc__mxw-80-per", children: [
      /* @__PURE__ */ e.jsx(
        Ga,
        {
          filterConfig: n,
          getFormattedLabel: Ef,
          getFormattedValue: nl,
          showClearAndRemove: !1,
          className: "dc__content-center"
        }
      ),
      /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom-n1 w-100px" }),
      /* @__PURE__ */ e.jsx(tA, {})
    ] })
  ] }) : /* @__PURE__ */ e.jsx(
    _e,
    {
      image: N_,
      title: a,
      subTitle: "You can use combinations of criteria, eg. Application ‘frontend-service’ and Cluster ‘production-cluster’",
      classname: "flex-grow-1"
    }
  );
}, nA = ({ handleSelectionCriterionSelect: t }) => {
  const { formState: s, policyKind: n } = un(), a = xf({
    criterionSelections: s.criterionSelections,
    applicableTo: s.applicableTo,
    policyKind: n
  });
  return /* @__PURE__ */ e.jsxs("aside", { className: "w-220 dc__no-shrink flexbox-col dc__gap-8 dc__border-left h-100 pb-10", children: [
    /* @__PURE__ */ e.jsx("h4", { className: "m-0 px-20 py-8 fs-13 fw-6 lh-20 cn-9 dc__border-bottom", children: s.profileCriterion === et.match ? "Add match criteria" : "Filter by" }),
    /* @__PURE__ */ e.jsx("div", { className: "pl-12", children: a.map((r) => /* @__PURE__ */ e.jsx(
      Ie,
      {
        alwaysShowTippyOnHover: r.disabled,
        content: r.tippyContent,
        children: /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs(
          "button",
          {
            type: "button",
            className: `dc__transparent dc__hover-n50 px-8 py-6 flex left dc__gap-8 br-4 w-100 ${r.disabled ? "dc__disabled" : ""}`,
            onClick: t(r.value),
            disabled: r.disabled,
            children: [
              /* @__PURE__ */ e.jsx(iN, { className: "icon-dim-16 dc__no-shrink" }),
              /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-20 cn-9 dc__truncate", children: r.label })
            ]
          },
          r.value
        ) })
      }
    )) })
  ] });
}, aA = ({
  selectionsData: t = [],
  isLoading: s,
  error: n,
  refetchSelectionsData: a,
  isUpdateSelectionsTabSelected: r,
  sortingConfig: { sortBy: o, sortOrder: i, handleSorting: l }
}) => {
  const { formState: c, handleFormStateUpdate: d } = un(), p = Q(() => t?.length ? o === Ta.scopeEnvironment ? t.sort(
    (E, C) => Ce(E.targetIdentifier, C.targetIdentifier, i)
  ) : t.sort(
    (E, C) => Ce(E.primaryResourceIdentifier, C.primaryResourceIdentifier, i)
  ) : [], [t, o, i]), { selectedMap: m, selectAllOptionsCheckboxState: u } = Q(() => {
    const E = lc(c.specificSelections);
    let C = null;
    return p?.length && (p.every((b) => E[b.selectionKey]) ? C = Fe.CHECKED : p.some((b) => E[b.selectionKey]) && (C = Fe.INTERMEDIATE)), {
      selectedMap: E,
      selectAllOptionsCheckboxState: C
    };
  }, [c.specificSelections, p]), f = (E) => () => {
    if (m[E.selectionKey]) {
      d(
        at.deselectSpecificSelection,
        E
      );
      return;
    }
    d(at.selectSpecificSelection, E);
  }, _ = () => {
    if (u) {
      d(
        at.bulkDeselectSpecificSelections,
        p
      );
      return;
    }
    d(
      at.bulkSelectSpecificSelections,
      p
    );
  }, h = () => {
    l(Ta.application);
  }, x = () => {
    l(Ta.scopeEnvironment);
  }, g = () => s ? /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }) : /* @__PURE__ */ e.jsx(
    $e,
    {
      isChecked: u === Fe.CHECKED || u === Fe.INTERMEDIATE,
      onChange: _,
      rootClassName: "mb-0",
      value: u,
      disabled: p.length === 0
    }
  );
  return /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-16 applied-profiles__specific-table-row applied-profiles__specific-table-row--header dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center dc__uppercase bg__primary px-20 show-shimmer-loading", children: [
      r ? g() : /* @__PURE__ */ e.jsx("span", {}),
      /* @__PURE__ */ e.jsx(
        Ne,
        {
          isSorted: o === Ta.application,
          sortOrder: i,
          title: "Application",
          triggerSorting: h,
          disabled: s
        }
      ),
      /* @__PURE__ */ e.jsx(
        Ne,
        {
          isSorted: o === Ta.scopeEnvironment,
          sortOrder: i,
          title: "Scope / Environment",
          triggerSorting: x,
          disabled: s
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(
      Ke,
      {
        isLoading: !1,
        error: n,
        errorScreenManagerProps: {
          code: n?.code,
          reload: a
        },
        children: /* @__PURE__ */ e.jsx("div", { children: s ? qv.map((E) => /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: "display-grid dc__column-gap-16 applied-profiles__specific-table-row dc__align-items-center fs-13 fw-4 lh-20 cn-9 px-20 show-shimmer-loading",
            children: [
              /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
              /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
              /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" })
            ]
          },
          E.selectionKey
        )) : p.map((E) => /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: "display-grid dc__column-gap-16 applied-profiles__specific-table-row dc__align-items-center fs-13 fw-4 lh-20 cn-9 px-20 dc__border-bottom-n1 dc__hover-n50 dc__visible-hover dc__visible-hover--parent",
            children: [
              r ? /* @__PURE__ */ e.jsx(
                $e,
                {
                  isChecked: !!m[E.selectionKey],
                  onChange: f(E),
                  rootClassName: "mb-0",
                  value: Fe.CHECKED
                }
              ) : /* @__PURE__ */ e.jsxs("div", { className: "flex", children: [
                /* @__PURE__ */ e.jsx(qs, { className: "icon-dim-20 scn-6 dc__no-shrink dc__visible-hover--hide-child" }),
                /* @__PURE__ */ e.jsx("div", { className: "dc__visible-hover--child", children: /* @__PURE__ */ e.jsx(
                  j,
                  {
                    dataTestId: `remove-selection-${E.selectionKey}`,
                    icon: /* @__PURE__ */ e.jsx(As, {}),
                    variant: w.borderLess,
                    style: B.negative,
                    ariaLabel: "Remove selection",
                    size: O.xs,
                    onClick: f(E)
                  }
                ) })
              ] }),
              /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: E.primaryResourceIdentifier }),
              /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: E.targetIdentifier })
            ]
          },
          E.selectionKey
        )) })
      }
    )
  ] });
}, rA = () => {
  const t = de(new AbortController()), [s, n] = v(
    Gr.updateSelections
  ), a = s === Gr.updateSelections, { sortBy: r, sortOrder: o, handleSorting: i } = vs({
    initialSortKey: Ta.application
  }), { formState: l, policyKind: c } = un(), [d, p, m, u] = ne(
    () => es(
      () => Hv(
        {
          criterionSelections: l.criterionSelections,
          applicableTo: l.applicableTo
        },
        t.current.signal,
        c
      ),
      t
    ),
    [l.criterionSelections]
  ), f = d || Pe(m), {
    SPECIFIC_CRITERION_NO_CRITERION_SELECTIONS_TITLE: _,
    SPECIFIC_CRITERION_NO_CRITERION_SELECTIONS_SUB_TITLE: h,
    SPECIFIC_CRITERION_OPTIONS_NULL_STATE_TITLE: x,
    SPECIFIC_CRITERION_OPTIONS_NULL_STATE_SUB_TITLE: g,
    SPECIFIC_CRITERION_NO_SELECTIONS_SUB_TITLE: E
  } = Rr[c];
  if (!l.criterionSelections.length && !l.specificSelections.length)
    return /* @__PURE__ */ e.jsx(
      _e,
      {
        image: lN,
        title: _,
        subTitle: h,
        classname: "flex-grow-1"
      }
    );
  const C = (N) => () => {
    n(N);
  }, b = () => !f && !m && a && !p?.length ? /* @__PURE__ */ e.jsx(
    _e,
    {
      image: Ql,
      title: x,
      subTitle: g,
      classname: "flex-grow-1"
    }
  ) : !a && !l.specificSelections.length ? /* @__PURE__ */ e.jsx(
    _e,
    {
      image: Ql,
      title: "No selections yet!",
      subTitle: E,
      classname: "flex-grow-1"
    }
  ) : /* @__PURE__ */ e.jsx(
    aA,
    {
      ...a ? {
        selectionsData: p,
        isLoading: f,
        error: m,
        refetchSelectionsData: u
      } : {
        selectionsData: l.specificSelections,
        isLoading: !1,
        error: null,
        refetchSelectionsData: Be
      },
      sortingConfig: {
        sortBy: r,
        sortOrder: o,
        handleSorting: i
      },
      isUpdateSelectionsTabSelected: a
    }
  );
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1", children: [
    /* @__PURE__ */ e.jsx("div", { className: "flex left px-16 pt-8 dc__gap-16 dc__border-bottom dc__position-sticky dc__top-0 bg__primary dc__zi-4", children: Object.values(Gr).map((N) => {
      const I = N === s;
      return /* @__PURE__ */ e.jsxs(
        "button",
        {
          className: `dc__tab-focus dc__transparent fs-13 lh-20 pt-0 pl-0 pr-0 flex left dc__gap-6 h-100 mb-neg-c ${I ? "cb-5 fw-6 dc__border-bottom-2--b5 pb-6" : "cn-9 fw-4 dc__hover-color-b500 mb-0 pb-7"}`,
          onClick: C(N),
          type: "button",
          children: [
            /* @__PURE__ */ e.jsx("span", { children: Wv[N] }),
            N === Gr.allSelections && /* @__PURE__ */ e.jsx(
              "span",
              {
                className: `fs-12 fw-6 lh-16 dc__no-shrink flex br-12 ${I ? "cn-0 bcb-5 px-5 py-c" : "cn-9 bg__primary dc__border--n9 px-4"}`,
                children: l.specificSelections.length
              }
            )
          ]
        },
        N
      );
    }) }),
    b()
  ] });
}, oA = () => {
  const { formState: t, handleFormStateUpdate: s } = un(), n = (a) => () => {
    s(
      at.updateSelectionCriterionKind,
      a
    );
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(eA, { handleSelectionCriterionSelect: n }),
    /* @__PURE__ */ e.jsxs("div", { className: "flex top left flex-grow-1", children: [
      /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 h-100", children: t.profileCriterion === et.match ? /* @__PURE__ */ e.jsx(sA, {}) : /* @__PURE__ */ e.jsx(rA, {}) }),
      /* @__PURE__ */ e.jsx(nA, { handleSelectionCriterionSelect: n })
    ] })
  ] });
}, iA = () => {
  const { formState: t, handleFormStateUpdate: s, policyKind: n, errorState: a, isEditMode: r } = un(), { GLOBAL_CRITERION_NULL_STATE_TITLE: o, GLOBAL_CRITERION_NULL_STATE_SUB_TITLE: i } = Rr[n], l = (p) => {
    s(
      at.updateProfiles,
      p.map(({ value: m }) => ({
        name: m.name,
        type: m.type
      }))
    );
  }, c = (p) => {
    s(
      at.updateApplicableToType,
      p
    );
  }, d = (p) => {
    s(
      at.updateApplicableToValues,
      p
    );
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__gap-16 px-20", children: [
    /* @__PURE__ */ e.jsx(
      Sd,
      {
        handleChange: l,
        selectedProfiles: t.profiles,
        policyKind: n,
        error: a.profiles
      }
    ),
    /* @__PURE__ */ e.jsx("div", { className: "dc__border-top-n1" }),
    Un[n] && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(
        ff,
        {
          policyKind: n,
          isEditMode: r,
          applicableTo: t.applicableTo,
          handleApplicableToTypeUpdate: c,
          handleApplicableToValuesChange: d
        }
      ),
      /* @__PURE__ */ e.jsx("div", { className: "dc__border-top-n1" })
    ] }),
    (!Un[n] || !!t.applicableTo.type) && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(Zv, {}),
      t.profileCriterion === et.global ? /* @__PURE__ */ e.jsx(
        _e,
        {
          image: aN,
          title: o,
          subTitle: i,
          classname: "flex-grow-1"
        }
      ) : /* @__PURE__ */ e.jsx(oA, {})
    ] })
  ] });
}, lA = ({ redirectToAppliedProfileList: t }) => {
  const [s, n] = v(!1), { formState: a, appliedProfileId: r, policyKind: o, isEditMode: i, errorState: l } = un(), c = !Ht(l.profiles), d = () => {
    if (c)
      return {
        isValid: !1,
        message: "Please resolve all form errors"
      };
    if (Un[o]) {
      if (!a.applicableTo.type)
        return {
          isValid: !1,
          message: "Please specify the policy scope"
        };
      if (vd(a.applicableTo) && a.applicableTo.values.length === 0)
        return {
          isValid: !1,
          message: "Please specify at least one target for policy scope"
        };
    }
    if (a.profileCriterion === et.match) {
      if (!a.criterionSelections.length)
        return {
          isValid: !1,
          message: "Please select a match criteria"
        };
    } else if (a.profileCriterion === et.specific && !a.specificSelections.length)
      return {
        isValid: !1,
        message: "Please select specific criteria"
      };
    return {
      isValid: !0
    };
  }, p = async () => {
    const { isValid: m, message: u } = d();
    if (!m) {
      Z.showToast({
        variant: ee.error,
        title: "Selection required",
        description: u
      });
      return;
    }
    try {
      n(!0), await Vv({
        appliedProfileId: r,
        criterionSelections: a.criterionSelections,
        policyKind: o,
        profileCriterion: a.profileCriterion,
        profiles: a.profiles,
        selectionCriterionKind: a.selectionCriterionKind,
        specificSelections: a.specificSelections,
        note: a.note,
        isEditMode: i,
        applicableTo: a.applicableTo
      }), n(!1), Z.showToast({
        variant: ee.success,
        description: "Updated successfully"
      }), t();
    } catch (f) {
      n(!1), V(f);
    }
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__border-top-n1 px-20 py-16 dc__gap-12 dc__no-shrink", children: [
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "plugin-profile__save",
        onClick: p,
        isLoading: s,
        disabled: s || c,
        showTooltip: c,
        tooltipProps: {
          content: vr.INVALID_INPUT
        },
        size: O.medium,
        text: "Save Changes"
      }
    ),
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "cancel-apply-profile",
        onClick: t,
        disabled: s,
        variant: w.secondary,
        style: B.neutral,
        size: O.medium,
        text: "Cancel"
      }
    )
  ] });
}, yd = ({ idsToDelete: t, handleClose: s, handleSuccess: n }) => {
  const [a, r] = v(!1), o = async () => {
    r(!0);
    try {
      await $v(t), Z.showToast({
        variant: ee.success,
        description: "Selected scope and applied profiles deleted successfully"
      }), r(!1), s(), n();
    } catch (i) {
      V(i), r(!1);
    }
  };
  return /* @__PURE__ */ e.jsx(
    zt,
    {
      variant: Ct.delete,
      title: "Delete selected scope(s) and applied profiles",
      subtitle: "This will delete the selected scope(s) and all profiles applied to it. Deployment pipelines may still be inheriting profiles from higher scopes (eg. Global, Cluster, Application etc.).",
      buttonConfig: {
        secondaryButtonConfig: {
          onClick: s,
          text: "Cancel"
        },
        primaryButtonConfig: {
          isLoading: a,
          onClick: o,
          text: "Delete"
        }
      },
      handleClose: s,
      confirmationConfig: {
        identifier: "delete-profile-input",
        confirmationKeyword: "delete"
      }
    }
  );
}, cA = ({
  redirectToAppliedProfileList: t
}) => {
  const [s, n] = v(!1), { policyKind: a, isEditMode: r, appliedProfileId: o } = un(), i = () => {
    n(!0);
  }, l = () => {
    n(!1);
  }, c = ic[a];
  return /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space px-20 pt-16", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex left fs-16 lh-32 fw-6 dc__gap-4", children: [
      /* @__PURE__ */ e.jsx(wt, { to: c.link ?? "#", className: "anchor", children: c.title }),
      /* @__PURE__ */ e.jsx("span", { className: "fs-16 fw-4 cn-5", children: "/" }),
      /* @__PURE__ */ e.jsx("span", { className: "cn-9 dc__truncate", children: "Apply Profile" })
    ] }),
    r && /* @__PURE__ */ e.jsx(
      j,
      {
        text: "Delete",
        dataTestId: "delete-applied-policy",
        onClick: i,
        variant: w.secondary,
        style: B.negative,
        size: O.medium,
        startIcon: /* @__PURE__ */ e.jsx(ts, {})
      }
    ),
    s && /* @__PURE__ */ e.jsx(
      yd,
      {
        idsToDelete: [o],
        handleClose: l,
        handleSuccess: t
      }
    )
  ] });
}, ia = ({ redirectToAppliedProfileList: t, policyKind: s }) => {
  const { appliedProfileId: n } = Ue(), a = !!n, [r, o, i, l] = ne(
    () => Bv({ policyKind: s, id: +n }),
    [s, n],
    a
  ), c = () => r || i ? null : a && o?.criterionType && o.criterionType !== et.match ? /* @__PURE__ */ e.jsx(
    Xe,
    {
      code: da.NOT_FOUND,
      redirectURL: ic[s].link
    }
  ) : /* @__PURE__ */ e.jsx(
    Qv,
    {
      initialFormData: o,
      isEditMode: a,
      policyKind: s,
      children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto dc__content-space", children: [
        /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__mxw-1200 dc__gap-24", children: [
          /* @__PURE__ */ e.jsx(cA, { redirectToAppliedProfileList: t }),
          /* @__PURE__ */ e.jsx(iA, {})
        ] }) }),
        /* @__PURE__ */ e.jsx(lA, { redirectToAppliedProfileList: t })
      ] })
    }
  );
  return /* @__PURE__ */ e.jsx(
    Ke,
    {
      isLoading: r,
      progressingProps: {
        pageLoader: !0
      },
      error: i,
      errorScreenManagerProps: {
        code: i?.code,
        reload: l,
        redirectURL: ic[s].link
      },
      children: c()
    }
  );
};
var Oe = /* @__PURE__ */ ((t) => (t.project = "project", t.application = "application", t.environment = "environment", t.profile = "profile", t.cluster = "cluster", t.branchFixed = "branchFix", t.branchRegex = "branchRegex", t.plugin = "plugin", t.applicableTo = "applicableTo", t))(Oe || {}), zn = /* @__PURE__ */ ((t) => (t.application = "application", t.scopeEnvironment = "scopeEnvironment", t))(zn || {});
const dA = Array.from(
  Array(3).keys()
).map((t) => ({
  id: t,
  profiles: [],
  criterionType: et.specific,
  selectionCriterion: {
    primaryResourceKind: ie.devtronApplication,
    primaryResourceIdentifier: `app-${t}`,
    selectionKey: sl({
      primaryResourceIdentifier: `app-${t}`,
      targetIdentifier: `env-${t}`
    }),
    targetIdentifier: `env-${t}`,
    targetKind: ie.environment
  },
  applicableTo: {
    type: tt.deploymentApproval,
    values: []
  }
}));
var Ai = /* @__PURE__ */ ((t) => (t.addProfiles = "Add", t.removeProfiles = "Remove", t))(Ai || {});
const pA = {
  [Oe.branchFixed]: Ds[z.branchFixed],
  [Oe.branchRegex]: Ds[z.branchRegex]
}, Si = {
  [X.lockConfiguration]: null,
  [X.imagePromotion]: null,
  [X.plugins]: null,
  [X.approval]: "Approval for"
}, uA = {
  [X.lockConfiguration]: null,
  [X.imagePromotion]: null,
  [X.plugins]: null,
  [X.approval]: [
    {
      label: pn[tt.deploymentApproval],
      value: tt.deploymentApproval
    },
    {
      label: pn[tt.configurationApproval],
      options: Cd[X.approval][tt.configurationApproval].map(({ identifier: t }) => ({
        label: el[t],
        value: t
      }))
    }
  ]
};
var Ea = /* @__PURE__ */ ((t) => (t.manageProfile = "manage-profile", t.editMatchCriteria = "edit-match-criteria", t.delete = "delete", t))(Ea || {});
const mA = () => /* @__PURE__ */ e.jsx(e.Fragment, { children: dA.map((t) => /* @__PURE__ */ e.jsxs(
  "div",
  {
    className: "display-grid dc__column-gap-16 applied-profiles-list__table-row applied-profiles-list__table-row--specific dc__align-items-center fs-13 fw-4 lh-24 cn-9 py-10 px-16 show-shimmer-loading",
    children: [
      /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
      /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
      /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
      /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" })
    ]
  },
  t.id
)) }), ri = ({
  showIcon: t,
  policyKind: s,
  label: n,
  toggleProfileIconType: a,
  handleToggleProfile: r,
  bgColorVariant: o = hn.default,
  profileType: i
}) => {
  const l = a === xr.add, c = () => {
    r(a);
  };
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `dc__mxw-100 ${uv[o]} dc__border br-4 py-1 px-6 flex left dc__gap-6`,
      children: [
        t && /* @__PURE__ */ e.jsx("span", { className: "icon-dim-16 dc__no-shrink", children: /* @__PURE__ */ e.jsx(Td, { policyKind: s, profileType: i }) }),
        /* @__PURE__ */ e.jsx(Ie, { content: n, showOnTruncate: !!t, children: /* @__PURE__ */ e.jsx(
          "span",
          {
            className: `dc__truncate fs-12 fw-4 lh-20 cn-9 ${l ? "dc__strike-through" : ""}`,
            children: n
          }
        ) }),
        !!a && /* @__PURE__ */ e.jsx(
          "button",
          {
            className: "dc__transparent p-0 flex",
            type: "button",
            "aria-label": `Toggle ${n} profile`,
            onClick: c,
            children: a === xr.remove ? /* @__PURE__ */ e.jsx(vt, { className: "icon-dim-12 dc__no-shrink fcn-6" }) : /* @__PURE__ */ e.jsx(Lo, { className: "icon-dim-12 dc__no-shrink scn-6" })
          }
        )
      ]
    }
  );
}, bf = ({
  profiles: t,
  policyKind: s,
  openManageProfilesModal: n,
  keyPrefix: a,
  addedProfilesMap: r,
  removedProfilesMap: o,
  showAllProfiles: i = !1
}) => {
  const l = t?.length ?? 0, c = t.map((_) => _.name), d = !i && l > Ko, p = Object.values(r).filter(
    (_) => !o[_.name] && !c.includes(_.name)
  ), m = d ? t.slice(0, Ko) : t, u = d ? t.slice(Ko) : [], f = (_) => {
    (_.key === "Enter" || _.key === " ") && (_.preventDefault(), n());
  };
  return !l && !p.length ? /* @__PURE__ */ e.jsx("div", { children: "-" }) : /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "flexbox dc__align-self-start dc__gap-8 flex-wrap",
      onClick: n,
      role: "button",
      tabIndex: 0,
      onKeyDown: f,
      children: [
        m.map((_) => /* @__PURE__ */ e.jsx(
          ri,
          {
            showIcon: !0,
            policyKind: s,
            label: _.name,
            profileType: _.type,
            bgColorVariant: o[_.name] ? hn.remove : hn.default
          },
          `${a}-${_.name}`
        )),
        p.map((_) => /* @__PURE__ */ e.jsx(
          ri,
          {
            showIcon: !0,
            policyKind: s,
            label: _.name,
            profileType: _.type,
            bgColorVariant: hn.add
          },
          `${a}-${_.name}`
        )),
        d && /* @__PURE__ */ e.jsx(Ie, { content: u.join(", "), alwaysShowTippyOnHover: !0, children: /* @__PURE__ */ e.jsx(
          ri,
          {
            showIcon: !1,
            profileType: null,
            label: `+${l - Ko} more`,
            policyKind: s
          }
        ) })
      ]
    }
  );
}, Nf = ({ applicableTo: t }) => {
  const s = t.values.map(({ identifier: n }) => el[n]).join(", ");
  return /* @__PURE__ */ e.jsx("span", { children: t.type ? /* @__PURE__ */ e.jsxs("span", { className: "flex left top column", children: [
    /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: pn[t.type] }),
    s && /* @__PURE__ */ e.jsx(Ie, { content: s, children: /* @__PURE__ */ e.jsx("span", { className: "fs-12 fw-4 lh-16 cn-7 dc__truncate", children: s }) })
  ] }) : "-" });
}, _a = () => {
  const t = It(), { isBulkSelectionApplied: s, selectedIdentifiers: n, handleBulkSelection: a } = t;
  return {
    ...t,
    updateSingleSelection: (i) => () => {
      const { id: l } = i;
      if (s) {
        a({
          action: st.CLEAR_IDENTIFIERS_AFTER_ACROSS_SELECTION,
          data: {
            identifierIds: [l]
          }
        });
        return;
      }
      a(
        n[l] ? {
          action: st.CLEAR_IDENTIFIERS,
          data: {
            identifierIds: [l]
          }
        } : {
          action: st.SELECT_IDENTIFIER,
          data: {
            identifierObject: {
              ...n,
              [l]: i
            }
          }
        }
      );
    },
    clearAllSelections: () => {
      a({
        action: st.CLEAR_ALL_SELECTIONS
      });
    }
  };
}, Tf = ({
  id: t,
  redirectToEditMatchCriterion: s,
  openManageProfilesModal: n,
  showEditProfileButton: a = !1,
  refetchAppliedProfiles: r
}) => {
  const [o, i] = v(!1), { clearAllSelections: l } = _a(), c = () => {
    i(!0);
  }, d = () => {
    i(!1);
  }, p = () => {
    s(t);
  }, m = () => {
    l(), r();
  }, u = (f) => {
    switch (f.id) {
      case Ea.manageProfile:
        n();
        break;
      case Ea.editMatchCriteria:
        p();
        break;
      case Ea.delete:
        c();
        break;
    }
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      ki,
      {
        id: "applied-profile-action-menu",
        onClick: u,
        options: [
          {
            items: [
              {
                id: Ea.manageProfile,
                label: "Manage policy",
                startIcon: { name: "ic-file-edit" }
              },
              ...a ? [
                {
                  id: Ea.editMatchCriteria,
                  label: "Edit match criteria",
                  startIcon: { name: "ic-pencil" }
                }
              ] : [],
              {
                id: Ea.delete,
                label: "Delete",
                startIcon: { name: "ic-delete" },
                type: "negative"
              }
            ]
          }
        ],
        buttonProps: {
          dataTestId: "applied-profile-action-menu-button",
          icon: /* @__PURE__ */ e.jsx(W, { name: "ic-more-vertical", color: null }),
          variant: w.borderLess,
          ariaLabel: "Open action menu",
          style: B.neutral,
          size: O.xs
        }
      }
    ),
    o && /* @__PURE__ */ e.jsx(
      yd,
      {
        handleClose: d,
        handleSuccess: m,
        idsToDelete: [t]
      }
    )
  ] });
}, _A = ({ note: t }) => /* @__PURE__ */ e.jsxs("div", { className: "h-100 mxh-210 dc__overflow-auto dc__align-left flexbox-col dc__gap-8 cn-9 fw-4 lh-20 p-12", children: [
  /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "fs-13 fw-6", children: [
      "Note by ",
      t.updatedBy
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "fs-12 lh-18", children: [
      "Last updated ",
      t.updatedOn
    ] })
  ] }),
  /* @__PURE__ */ e.jsx("div", { className: "fs-13 pl-8 dc__border-left bw-2", children: t.value })
] }), fA = ({
  globalAndMatchCriterionList: t,
  policyKind: s,
  redirectToEditMatchCriterion: n,
  refetchAppliedProfiles: a,
  handleOpenManageProfilesModal: r,
  showActions: o,
  addedProfilesMap: i,
  removedProfilesMap: l,
  showAllProfiles: c
}) => {
  const { isBulkSelectionApplied: d, selectedIdentifiers: p, updateSingleSelection: m } = _a();
  if (!t?.length)
    return null;
  const u = Un[s], { GLOBAL_CRITERION_TITLE: f, MATCH_CRITERION_TITLE: _ } = Rr[s];
  return /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: `display-grid dc__column-gap-16 applied-profiles-list__table-row ${u ? "applied-profiles-list__table-row--with-applicable-to" : ""} ${o ? "" : "applied-profiles-list__table-row--hide-actions"} applied-profiles-list__table-row--header dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center dc__uppercase bg__primary px-16 dc__top-0 dc__position-sticky dc__zi-4`,
        children: [
          o && /* @__PURE__ */ e.jsx(bo, { showPagination: !1 }),
          /* @__PURE__ */ e.jsx(Ne, { title: "Scope / Match Criteria", isSortable: !1 }),
          u && /* @__PURE__ */ e.jsx(
            Ne,
            {
              title: Si[s],
              isSortable: !1
            }
          ),
          /* @__PURE__ */ e.jsx(Ne, { title: "Applied profiles", isSortable: !1 })
        ]
      }
    ),
    /* @__PURE__ */ e.jsx("div", { children: t.map((h) => {
      const x = d || !!p[h.id] || !1, g = () => r({
        id: h.id,
        profiles: h.profiles,
        applicableTo: h.applicableTo
      });
      return /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: `display-grid dc__column-gap-16 applied-profiles-list__table-row ${u ? "applied-profiles-list__table-row--with-applicable-to" : ""} ${o ? "" : "applied-profiles-list__table-row--hide-actions"} fs-13 fw-4 lh-24 cn-9 py-10 px-16 dc__border-bottom-n1 dc__hover-n50 dc__visible-hover dc__visible-hover--parent ${x && o ? "bcb-50" : ""}`,
          children: [
            o && /* @__PURE__ */ e.jsx(
              $e,
              {
                isChecked: x,
                onChange: m(h),
                rootClassName: "mb-0 w-24 h-24",
                value: Fe.CHECKED
              }
            ),
            h.criterionType === et.global ? /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: f }) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6", children: [
              /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-4", children: [
                /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: _ }),
                h.note.value && /* @__PURE__ */ e.jsx(
                  Dt,
                  {
                    theme: Mt.white,
                    className: "default-tt w-400 h-100",
                    placement: "bottom-start",
                    Icon: Ni,
                    iconClass: "scb-5 dc__no-shrink",
                    additionalContent: /* @__PURE__ */ e.jsx(_A, { note: h.note }),
                    heading: "Note",
                    showCloseButton: !0,
                    trigger: "click",
                    interactive: !0,
                    children: /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
                      j,
                      {
                        icon: /* @__PURE__ */ e.jsx(Ni, {}),
                        variant: w.borderLess,
                        style: B.neutral,
                        dataTestId: `note-${h.id}`,
                        ariaLabel: "View note",
                        size: O.xs
                      }
                    ) })
                  }
                )
              ] }),
              h.selectionCriterion.length ? /* @__PURE__ */ e.jsx(
                Ga,
                {
                  filterConfig: tl(h.selectionCriterion),
                  getFormattedLabel: Ef,
                  getFormattedValue: nl,
                  showClearAndRemove: !1,
                  className: "p-0 max-w-100"
                }
              ) : /* @__PURE__ */ e.jsx("span", { children: "-" })
            ] }),
            u && /* @__PURE__ */ e.jsx(Nf, { applicableTo: h.applicableTo }),
            /* @__PURE__ */ e.jsx(
              bf,
              {
                profiles: h.profiles,
                policyKind: s,
                openManageProfilesModal: o ? g : null,
                keyPrefix: h.id,
                addedProfilesMap: i,
                removedProfilesMap: l,
                showAllProfiles: c
              }
            ),
            o && /* @__PURE__ */ e.jsx(
              Tf,
              {
                id: h.id,
                refetchAppliedProfiles: a,
                openManageProfilesModal: g,
                ...h.criterionType === et.match && {
                  showEditProfileButton: !0,
                  redirectToEditMatchCriterion: n
                }
              }
            )
          ]
        },
        h.id
      );
    }) })
  ] });
}, hA = ({
  specificCriterionList: t,
  policyKind: s,
  sortingConfig: { sortBy: n, sortOrder: a, handleSorting: r },
  handleOpenManageProfilesModal: o,
  refetchAppliedProfiles: i,
  showBulkSelectionCheckbox: l,
  showActions: c,
  addedProfilesMap: d,
  removedProfilesMap: p,
  showAllProfiles: m
}) => {
  const { isBulkSelectionApplied: u, selectedIdentifiers: f, updateSingleSelection: _ } = _a(), h = Un[s], x = Q(() => t?.length ? n === zn.scopeEnvironment ? t.sort(
    (C, b) => Ce(
      C.selectionCriterion.targetIdentifier,
      b.selectionCriterion.targetIdentifier,
      a
    )
  ) : t.sort(
    (C, b) => Ce(
      C.selectionCriterion.primaryResourceIdentifier,
      b.selectionCriterion.primaryResourceIdentifier,
      a
    )
  ) : [], [t, n, a]);
  if (!t?.length)
    return null;
  const g = () => {
    r(zn.application);
  }, E = () => {
    r(zn.scopeEnvironment);
  };
  return /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: `display-grid dc__column-gap-16 applied-profiles-list__table-row applied-profiles-list__table-row--specific ${h ? "applied-profiles-list__table-row--with-applicable-to" : ""} ${c ? "" : "applied-profiles-list__table-row--hide-actions"} applied-profiles-list__table-row--header dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center dc__uppercase bg__primary px-16 dc__top-0 dc__position-sticky dc__zi-4`,
        children: [
          c && (l ? /* @__PURE__ */ e.jsx(bo, { showPagination: !1 }) : /* @__PURE__ */ e.jsx("span", {})),
          /* @__PURE__ */ e.jsx(
            Ne,
            {
              isSorted: n === zn.application,
              sortOrder: a,
              title: "Application",
              triggerSorting: g,
              disabled: !1
            }
          ),
          /* @__PURE__ */ e.jsx(
            Ne,
            {
              isSorted: n === zn.scopeEnvironment,
              sortOrder: a,
              title: "Scope / Environment",
              triggerSorting: E,
              disabled: !1
            }
          ),
          h && /* @__PURE__ */ e.jsx(
            Ne,
            {
              title: Si[s],
              isSortable: !1
            }
          ),
          /* @__PURE__ */ e.jsx(Ne, { title: "Applied Profiles", isSortable: !1 })
        ]
      }
    ),
    /* @__PURE__ */ e.jsx("div", { children: x.map((C) => {
      const b = u || !!f[C.id] || !1, N = () => {
        o({
          id: C.id,
          profiles: C.profiles,
          applicableTo: C.applicableTo
        });
      };
      return /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: `display-grid dc__column-gap-16 applied-profiles-list__table-row ${h ? "applied-profiles-list__table-row--with-applicable-to" : ""} ${c ? "" : "applied-profiles-list__table-row--hide-actions"} applied-profiles-list__table-row--specific fs-13 fw-4 lh-24 cn-9 py-10 px-16 dc__border-bottom-n1 dc__hover-n50 ${b && c ? "bcb-50" : ""}`,
          children: [
            c && /* @__PURE__ */ e.jsx(
              $e,
              {
                isChecked: b,
                onChange: _(C),
                rootClassName: "mb-0 w-24 h-24",
                value: Fe.CHECKED
              }
            ),
            /* @__PURE__ */ e.jsx(Ie, { content: C.selectionCriterion.primaryResourceIdentifier, children: /* @__PURE__ */ e.jsx("span", { className: "dc__truncate dc__w-fit-content", children: C.selectionCriterion.primaryResourceIdentifier }) }),
            /* @__PURE__ */ e.jsx(Ie, { content: C.selectionCriterion.targetIdentifier, children: /* @__PURE__ */ e.jsx("span", { className: "dc__truncate dc__w-fit-content", children: C.selectionCriterion.targetIdentifier }) }),
            h && /* @__PURE__ */ e.jsx(Nf, { applicableTo: C.applicableTo }),
            /* @__PURE__ */ e.jsx(
              bf,
              {
                profiles: C.profiles,
                policyKind: s,
                openManageProfilesModal: c ? N : null,
                keyPrefix: C.id,
                addedProfilesMap: d,
                removedProfilesMap: p,
                showAllProfiles: m
              }
            ),
            c && /* @__PURE__ */ e.jsx(
              Tf,
              {
                id: C.id,
                refetchAppliedProfiles: i,
                openManageProfilesModal: N
              }
            )
          ]
        },
        C.id
      );
    }) })
  ] });
}, If = ({
  policyKind: t,
  redirectToEditMatchCriterion: s,
  handleOpenManageProfilesModal: n,
  refetchAppliedProfiles: a,
  sortingConfig: r,
  appliedProfilesGroupedByCriterion: o,
  showActions: i = !0,
  addedProfilesMap: l,
  removedProfilesMap: c,
  showAllProfiles: d
}) => {
  const {
    globalScopeList: p = [],
    matchingScopeList: m = [],
    specificScopeList: u = []
  } = o ?? {}, f = [...p, ...m];
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      fA,
      {
        globalAndMatchCriterionList: f,
        policyKind: t,
        redirectToEditMatchCriterion: s,
        handleOpenManageProfilesModal: n,
        refetchAppliedProfiles: a,
        showActions: i,
        addedProfilesMap: l,
        removedProfilesMap: c,
        showAllProfiles: d
      }
    ),
    /* @__PURE__ */ e.jsx(
      hA,
      {
        specificCriterionList: u,
        policyKind: t,
        sortingConfig: r,
        handleOpenManageProfilesModal: n,
        refetchAppliedProfiles: a,
        showBulkSelectionCheckbox: f.length === 0,
        showActions: i,
        addedProfilesMap: l,
        removedProfilesMap: c,
        showAllProfiles: d
      }
    )
  ] });
}, gA = () => {
  const [t, s] = v(!1), [n, a] = v({}), [r, o] = v({}), { selectedIdentifiers: i } = _a(), { sortBy: l, sortOrder: c, handleSorting: d } = vs({
    initialSortKey: zn.application
  }), p = Q(
    () => ({
      sortBy: l,
      sortOrder: c,
      handleSorting: d
    }),
    [l, c]
  ), { uniqueProfilesInSelectedIdentifiers: m, noOfSelectedIdentifiers: u, appliedProfilesGroupedByCriterion: f } = Q(() => {
    const C = Object.values(i), N = C.flatMap((T) => T.profiles).reduce((T, A) => (T[A.name] || (T[A.name] = A), T), {});
    return {
      uniqueProfilesInSelectedIdentifiers: Object.values(N),
      noOfSelectedIdentifiers: C.length,
      appliedProfilesGroupedByCriterion: mf(C)
    };
  }, [i]), { profilesToAdd: _, profilesToRemove: h } = Q(
    () => ({
      profilesToAdd: Object.values(n),
      profilesToRemove: Object.values(r)
    }),
    [n, r]
  );
  return {
    sortingConfig: p,
    showReviewChanges: t,
    toggleReviewChanges: () => {
      s((C) => !C);
    },
    profilesToAdd: _,
    profilesMapToAdd: n,
    handleAddProfile: (C) => {
      const b = C.reduce((N, I) => (N[I.value.name] = I.value, N), {});
      a(b);
    },
    profilesToRemove: h,
    profilesMapToRemove: r,
    handleToggleProfile: (C) => (b) => {
      if (b === xr.remove) {
        o((I) => ({
          ...I,
          [C.name]: C
        }));
        return;
      }
      const N = structuredClone(r);
      delete N[C.name], o(N);
    },
    uniqueProfilesInSelectedIdentifiers: m,
    noOfSelectedIdentifiers: u,
    appliedProfilesGroupedByCriterion: f
  };
}, yn = (t) => t.map((s) => s.trim()).filter((s) => !!s), xA = (t) => ({
  [Oe.project]: yn(
    t.getAll(Oe.project)
  ),
  [Oe.application]: yn(
    t.getAll(Oe.application)
  ),
  [Oe.cluster]: yn(
    t.getAll(Oe.cluster)
  ),
  [Oe.environment]: yn(
    t.getAll(Oe.environment)
  ),
  [Oe.profile]: yn(
    t.getAll(Oe.profile)
  ),
  [Oe.branchFixed]: yn(
    t.getAll(Oe.branchFixed)
  ),
  [Oe.branchRegex]: yn(
    t.getAll(Oe.branchRegex)
  ),
  [Oe.plugin]: yn(t.getAll(Oe.plugin)),
  [Oe.applicableTo]: yn(
    t.getAll(Oe.applicableTo)
  )
}), rr = (t) => ({
  label: t.name,
  value: t.name
}), EA = (t) => ({
  [ie.devtronApplication]: t[ie.devtronApplication].map((s) => ({
    label: s.projectName,
    options: s.appList.map(rr)
  })),
  [ie.cluster]: t[ie.cluster].map(rr),
  [ie.environment]: [
    {
      label: po[fn.allExistingAndFutureProdEnvironments],
      value: fn.allExistingAndFutureProdEnvironments
    },
    {
      label: po[fn.allExistingAndFutureNonProdEnvironments],
      value: fn.allExistingAndFutureNonProdEnvironments
    },
    ...t[ie.environment].map((s) => ({
      label: s.clusterName,
      options: s.envList.map(rr)
    }))
  ],
  [ie.project]: t[ie.project].map(rr)
}), CA = ({
  globalScopeList: t,
  matchingScopeList: s,
  specificScopeList: n
}) => [...t, ...s, ...n].reduce((a, r) => (a[r.id] = r, a), {}), bA = ({
  isAddProfilesTabSelected: t
}) => ({
  [X.lockConfiguration]: {
    title: "Manage lock profiles",
    profileSelectorLabel: t ? "Add Lock Profiles" : "Remove Lock Profiles"
  },
  [X.imagePromotion]: {
    title: "Manage image promotion profiles",
    profileSelectorLabel: t ? "Add Image Promotion Profiles" : "Remove Image Promotion Profiles"
  },
  [X.plugins]: {
    title: "Manage plugin profiles",
    profileSelectorLabel: t ? "Add Plugin Profiles" : "Remove Plugin Profiles"
  },
  [X.approval]: {
    title: "Manage approval policy",
    profileSelectorLabel: t ? "Add Approval Policy" : "Remove Approval Policy"
  }
}), NA = Object.values(
  Ai
).map((t) => ({ label: t, value: t })), TA = ({
  handleClose: t,
  policyKind: s,
  handleSuccess: n
}) => {
  const [a, r] = v(
    Ai.addProfiles
  ), [o, i] = v(!1), { selectedIdentifiers: l, clearAllSelections: c } = _a(), {
    sortingConfig: d,
    showReviewChanges: p,
    toggleReviewChanges: m,
    profilesToAdd: u,
    profilesMapToAdd: f,
    handleAddProfile: _,
    profilesToRemove: h,
    profilesMapToRemove: x,
    handleToggleProfile: g,
    uniqueProfilesInSelectedIdentifiers: E,
    noOfSelectedIdentifiers: C,
    appliedProfilesGroupedByCriterion: b
  } = gA(), N = a === Ai.addProfiles, { title: I, profileSelectorLabel: T } = bA({ isAddProfilesTabSelected: N })[s], A = (L) => {
    L.value !== a && r(L.value);
  }, S = async () => {
    if (u.length === 0 && h.length === 0) {
      Z.showToast({
        variant: ee.warn,
        title: "No profile(s) have been changed",
        description: "Add or remove at least one profile to save changes"
      });
      return;
    }
    i(!0);
    try {
      const L = {
        profilesToAdd: u.map(({ name: R }) => R),
        profilesToRemove: h.map(({ name: R }) => R),
        appliedProfileIds: Object.values(l).map(({ id: R }) => R),
        policyKind: s
      };
      await _f(L), i(!1), Z.showToast({
        variant: ee.success,
        description: "Profile(s) updated successfully"
      }), c(), n(), t();
    } catch (L) {
      i(!1), V(L);
    }
  };
  return /* @__PURE__ */ e.jsx($t, { position: "right", width: "1024px", onEscape: t, children: /* @__PURE__ */ e.jsxs("div", { className: "bg__primary h-100 flexbox-col show-shimmer-loading", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
      /* @__PURE__ */ e.jsx("div", { className: "dc__position-sticky dc__top-0 bg__primary dc__zi-20", children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-justify dc__border-bottom pt-10 pr-20 pb-10 pl-20", children: [
        /* @__PURE__ */ e.jsx("h2", { className: "fs-16 fw-6 lh-24 m-0 dc__ellipsis-right", children: I }),
        /* @__PURE__ */ e.jsx(
          j,
          {
            icon: /* @__PURE__ */ e.jsx(ua, {}),
            onClick: t,
            disabled: o,
            dataTestId: "close-modal",
            showAriaLabelInTippy: !1,
            ariaLabel: "Close modal",
            size: O.medium,
            variant: w.borderLess,
            style: B.negativeGrey
          }
        )
      ] }) }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 px-20 py-16 dc__gap-16", children: [
        /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
          Qs,
          {
            segments: NA,
            value: a,
            onChange: A,
            name: "manage-profile-tabs"
          }
        ) }),
        /* @__PURE__ */ e.jsx("div", { children: N ? /* @__PURE__ */ e.jsx(
          Sd,
          {
            handleChange: _,
            policyKind: s,
            error: null,
            label: T,
            selectedProfiles: u
          }
        ) : /* @__PURE__ */ e.jsxs("div", { children: [
          /* @__PURE__ */ e.jsx("label", { className: "form__label dc__required-field", htmlFor: "profile-selection", children: T }),
          /* @__PURE__ */ e.jsx("div", { className: "dc__border flex left flex-wrap br-4 bg__secondary dc__gap-8 p-8", children: E.length === 0 ? /* @__PURE__ */ e.jsx("div", { className: "flex dc__align-center cn-7 w-100 fs-12 lh-18", children: "Nothing to remove. No profiles are configured for selection(s)" }) : E.map((L) => /* @__PURE__ */ e.jsx(
            ri,
            {
              policyKind: s,
              label: L.name,
              profileType: L.type,
              showIcon: !0,
              handleToggleProfile: g(L),
              toggleProfileIconType: x[L.name] ? xr.add : xr.remove,
              bgColorVariant: hn.white
            },
            L.name
          )) })
        ] }) }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__gap-16", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-12", children: [
            /* @__PURE__ */ e.jsxs("p", { className: "cn-9 fs-13 fw-6 lh-20 m-0", children: [
              "Applying changes to ",
              C,
              " selection(s)"
            ] }),
            /* @__PURE__ */ e.jsx(
              j,
              {
                dataTestId: "toggle-review-changes",
                text: p ? "Hide Changes" : "Review Changes",
                onClick: m,
                variant: w.text
              }
            )
          ] }),
          p && // Added div to ensure the gap is not applied to both the listing
          /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
            If,
            {
              handleOpenManageProfilesModal: Be,
              policyKind: s,
              refetchAppliedProfiles: Be,
              sortingConfig: d,
              redirectToEditMatchCriterion: Be,
              appliedProfilesGroupedByCriterion: b,
              showActions: !1,
              addedProfilesMap: f,
              removedProfilesMap: x,
              showAllProfiles: !0
            }
          ) })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "px-20 py-16 flex dc__content-end dc__gap-12 dc__border-top", children: [
      /* @__PURE__ */ e.jsx(
        j,
        {
          dataTestId: "close-modal",
          text: "Cancel",
          disabled: o,
          onClick: t,
          variant: w.secondary,
          style: B.neutral
        }
      ),
      /* @__PURE__ */ e.jsx(
        j,
        {
          dataTestId: "save-changes",
          text: "Save Changes",
          disabled: o,
          onClick: S,
          isLoading: o
        }
      )
    ] })
  ] }) });
}, IA = ({
  selectedProfileName: t,
  handleClose: s,
  policyKind: n,
  handleSuccess: a
}) => {
  const [r, o] = v(!1), { clearAllSelections: i, selectedIdentifiers: l } = _a(), c = async () => {
    o(!0);
    const d = Object.values(l), m = {
      profilesToRemove: [
        ...new Set(
          d.flatMap((u) => u.profiles).filter((u) => u.name !== t)
        )
      ].map(({ name: u }) => u),
      profilesToAdd: [t],
      appliedProfileIds: d.map(({ id: u }) => u),
      policyKind: n
    };
    try {
      await _f(m), o(!1), Z.showToast({
        variant: ee.success,
        description: `Updated ${t} in the selected combination(s)`
      }), i(), a(), s();
    } catch (u) {
      o(!1), V(u);
    }
  };
  return /* @__PURE__ */ e.jsx(
    zt,
    {
      variant: Ct.custom,
      Icon: /* @__PURE__ */ e.jsx(__, {}),
      title: `Change profile to ${t}`,
      subtitle: `${t} will be applied to selected environments in respective applications.`,
      handleClose: s,
      buttonConfig: {
        secondaryButtonConfig: {
          text: "Cancel",
          onClick: s,
          disabled: r
        },
        primaryButtonConfig: {
          text: "Change",
          onClick: c,
          isLoading: r
        }
      },
      children: /* @__PURE__ */ e.jsx("p", { className: "fs-13 cn-7 lh-20 mt-22 mb-0-imp", children: "Are you sure?" })
    }
  );
}, vA = ({ policyKind: t, handleSuccess: s }) => {
  const [n, a] = v(null), [r, o] = ne(() => Ad({ policyKind: t }), [t]), i = o?.map((d) => ai(d, t)) ?? [], l = () => {
    a(null);
  }, c = (d) => {
    a(d?.value.name ?? null);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      Ve,
      {
        inputId: "bulk-single-profile-select",
        classNamePrefix: "bulk-single-profile-select",
        name: "bulk-single-profile-select",
        required: !0,
        placeholder: "Change profile",
        isSearchable: !0,
        isDisabled: r,
        isLoading: r,
        value: null,
        options: i,
        onChange: c,
        menuPosition: null,
        menuSize: O.large
      }
    ),
    !!n && /* @__PURE__ */ e.jsx(
      IA,
      {
        handleClose: l,
        handleSuccess: s,
        selectedProfileName: n,
        policyKind: t
      }
    )
  ] });
}, AA = ({
  parentRef: t,
  refetchAppliedProfiles: s,
  policyKind: n
}) => {
  const [a, r] = v(!1), [o, i] = v(!1), { clearAllSelections: l, selectedIdentifiers: c } = _a(), d = Object.keys(c).map(Number), p = d.length;
  if (p === 0)
    return null;
  const m = () => {
    r((_) => !_);
  }, u = () => {
    i((_) => !_);
  }, f = () => {
    l(), s();
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      No,
      {
        dragSelector: ".drag-selector",
        positionVariant: To.PARENT_BOTTOM_CENTER,
        parentRef: t,
        zIndex: "calc(var(--modal-index) - 1)",
        children: /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-8 pt-12 pb-12 pr-12 pl-8 bulk-selection-widget br-8", children: [
          /* @__PURE__ */ e.jsx(Fi, { dragClassName: "drag-selector" }),
          /* @__PURE__ */ e.jsxs("div", { className: "fs-13 lh-20 fw-6 flex dc__gap-12", children: [
            /* @__PURE__ */ e.jsx("span", { className: "flex dc__gap-2 bcb-5 cn-0 br-4 pr-6 pl-6", children: p }),
            /* @__PURE__ */ e.jsx("span", { className: "cn-9", children: "Selected" })
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "dc__divider h-16" }),
          /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-4", children: [
            df(n) ? /* @__PURE__ */ e.jsx(vA, { handleSuccess: s, policyKind: n }) : /* @__PURE__ */ e.jsx(
              j,
              {
                text: "Manage Profiles",
                dataTestId: "manage-profiles",
                size: O.small,
                onClick: u
              }
            ),
            /* @__PURE__ */ e.jsx(
              j,
              {
                dataTestId: "delete-selected-applied-profiles",
                ariaLabel: "Delete selected applied profile(s)",
                icon: /* @__PURE__ */ e.jsx(ts, {}),
                size: O.small,
                variant: w.borderLess,
                style: B.negativeGrey,
                onClick: m
              }
            )
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "dc__divider h-16" }),
          /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: "clear-all-selections",
              ariaLabel: "Clear all selection(s)",
              icon: /* @__PURE__ */ e.jsx(vt, {}),
              size: O.small,
              variant: w.borderLess,
              style: B.negativeGrey,
              onClick: l
            }
          )
        ] })
      }
    ),
    a && /* @__PURE__ */ e.jsx(
      yd,
      {
        handleClose: m,
        handleSuccess: f,
        idsToDelete: d
      }
    ),
    o && /* @__PURE__ */ e.jsx(
      TA,
      {
        handleClose: u,
        policyKind: n,
        handleSuccess: s
      }
    )
  ] });
}, SA = ({
  updateSearchParams: t,
  policyKind: s,
  selectedFixedBranches: n,
  selectedBranchRegex: a
}) => {
  const [r, o, i, l] = ne(
    () => Kv({
      policyKind: s
    })
  ), { selectedFixedBranchMap: c, selectedBranchRegexMap: d } = Q(
    () => ({
      selectedFixedBranchMap: n.reduce((f, _) => (f[_] = !0, f), {}),
      selectedBranchRegexMap: a.reduce((f, _) => (f[_] = !0, f), {})
    }),
    [n, a]
  ), p = (o ?? []).flatMap(({ options: f }) => f).filter((f) => {
    switch (f.kind) {
      case z.branchFixed:
        return c[f.value];
      case z.branchRegex:
        return d[f.value];
      default:
        return !1;
    }
  }), m = (f) => {
    t({
      [Oe.branchFixed]: f.filter(({ kind: _ }) => _ === z.branchFixed).map(({ value: _ }) => _),
      [Oe.branchRegex]: f.filter(({ kind: _ }) => _ === z.branchRegex).map(({ value: _ }) => _)
    });
  }, u = (f) => `${f.kind}/${f.value}`;
  return /* @__PURE__ */ e.jsx(
    Ps,
    {
      placeholder: "Branch",
      options: o ?? [],
      isDisabled: r,
      isLoading: r,
      inputId: "branch-filter",
      appliedFilterOptions: p,
      handleApplyFilter: m,
      optionListError: i,
      reloadOptionList: l,
      getOptionValue: u
    }
  );
}, yA = ({
  handleApplyFilter: t,
  selectedPluginIdentifiers: s,
  pluginOptions: n,
  isListLoading: a,
  pluginListError: r,
  refetchPluginList: o
}) => {
  const i = Q(
    () => s.reduce((c, d) => (c[d] = !0, c), {}),
    [s]
  ), l = n.filter((c) => i[c.value]);
  return /* @__PURE__ */ e.jsx(
    Ps,
    {
      placeholder: "Plugin",
      options: n,
      isDisabled: a,
      isLoading: a,
      inputId: "plugin-filter",
      appliedFilterOptions: l,
      handleApplyFilter: t,
      optionListError: r,
      reloadOptionList: o
    }
  );
}, LA = [
  ie.environment,
  ie.cluster,
  ie.devtronApplication,
  ie.project
], jA = ({ policyKind: t, filterConfig: s, updateSearchParams: n, clearFilters: a }) => {
  const r = Qn[t][z.branchFixed] || Qn[t][z.branchRegex], { isResourcesOptionsLoading: o, resourcesOptionsMap: i } = Am({
    resourcesToFetch: LA
  }), [l, c] = ne(() => Ad({ policyKind: t })), [d, p, m, u] = ne(
    () => Sm({
      type: "ALL"
    }),
    [t],
    t === X.plugins
  ), { pluginOptions: f, pluginIdentifierToNameMap: _ } = Q(() => {
    const N = p?.result ?? [];
    return {
      pluginOptions: N.map((I) => ({
        label: I.name,
        value: I.pluginIdentifier
      })),
      pluginIdentifierToNameMap: N.reduce((I, T) => (I[T.pluginIdentifier] = T.name, I), {})
    };
  }, [p]), h = EA(i), x = (c ?? []).map(
    (N) => rr({
      name: N.name
    })
  ), g = (N) => (I) => {
    n({
      [N]: I.map(({ value: T }) => T)
    });
  }, E = (N) => N.map(
    (I) => rr({
      name: I
    })
  ), C = (N, I) => {
    switch (N) {
      case Oe.plugin:
        return _[I] ?? I;
      case Oe.applicableTo:
        return pn[I] ?? el[I] ?? I;
      default:
        return nl(N, I);
    }
  }, b = (N) => pA[N] ?? (N === Oe.applicableTo ? Si[t] : null);
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 p-16 dc__zi-5", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8 flex-wrap", children: [
      t === X.plugins && /* @__PURE__ */ e.jsx(
        yA,
        {
          handleApplyFilter: g(Oe.plugin),
          isListLoading: d,
          pluginListError: m,
          pluginOptions: f,
          refetchPluginList: u,
          selectedPluginIdentifiers: s[Oe.plugin]
        }
      ),
      /* @__PURE__ */ e.jsx(
        Ps,
        {
          placeholder: "Project",
          options: h[ie.project],
          isDisabled: o,
          isLoading: o,
          inputId: "project-filter",
          appliedFilterOptions: E(s[Oe.project]),
          handleApplyFilter: g(Oe.project)
        }
      ),
      /* @__PURE__ */ e.jsx(
        Ps,
        {
          placeholder: "Application",
          options: h[ie.devtronApplication],
          isDisabled: o,
          isLoading: o,
          inputId: "app-filter",
          appliedFilterOptions: E(
            s[Oe.application]
          ),
          handleApplyFilter: g(Oe.application)
        }
      ),
      /* @__PURE__ */ e.jsx(
        Ps,
        {
          placeholder: "Cluster",
          options: h[ie.cluster],
          isDisabled: o,
          isLoading: o,
          inputId: "cluster-filter",
          appliedFilterOptions: E(s[Oe.cluster]),
          handleApplyFilter: g(Oe.cluster)
        }
      ),
      /* @__PURE__ */ e.jsx(
        Ps,
        {
          placeholder: "Environment",
          options: h[ie.environment],
          isDisabled: o,
          isLoading: o,
          inputId: "environment-filter",
          appliedFilterOptions: E(
            s[Oe.environment]
          ),
          handleApplyFilter: g(Oe.environment)
        }
      ),
      /* @__PURE__ */ e.jsx(
        Ps,
        {
          placeholder: "Profile",
          options: x,
          isDisabled: l,
          isLoading: l,
          inputId: "profile-filter",
          appliedFilterOptions: E(s[Oe.profile]),
          handleApplyFilter: g(Oe.profile)
        }
      ),
      Un[t] && /* @__PURE__ */ e.jsx(
        Ps,
        {
          placeholder: Si[t],
          options: uA[t],
          isDisabled: !1,
          isLoading: !1,
          inputId: "applicable-to-filter",
          appliedFilterOptions: E(
            s[Oe.applicableTo]
          ),
          handleApplyFilter: g(Oe.applicableTo)
        }
      ),
      r && /* @__PURE__ */ e.jsx(
        SA,
        {
          policyKind: t,
          selectedFixedBranches: s[Oe.branchFixed],
          selectedBranchRegex: s[Oe.branchRegex],
          updateSearchParams: n
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(
      Ga,
      {
        className: "p-0",
        filterConfig: s,
        getFormattedValue: C,
        getFormattedLabel: b,
        clearFilters: a,
        onRemoveFilter: n
      }
    )
  ] });
}, OA = ({
  handleClose: t,
  id: s,
  profiles: n,
  handleSuccess: a,
  policyKind: r,
  applicableTo: o
}) => {
  const [i, l] = v(!1), [c, d] = v(n), [p, m] = v(o), [u, f] = v(
    c.length === 0 ? "" : null
  ), { clearAllSelections: _ } = _a(), h = !Ht(u), x = Un[r];
  J(() => {
    m(o), d(n), f(c.length === 0 ? "" : null);
  }, [n, o]);
  const g = (b) => {
    m((N) => ({
      ...N,
      values: b
    }));
  }, E = async () => {
    if (h) {
      Z.showToast({
        variant: ee.error,
        description: "Please resolve all form errors"
      });
      return;
    }
    if (x && p.type !== tt.deploymentApproval && p.values.length === 0) {
      Z.showToast({
        variant: ee.error,
        description: "Please specify at least one target for policy scope"
      });
      return;
    }
    try {
      l(!0);
      const b = {
        id: s,
        policyKind: r,
        applicableTo: p,
        updatedProfiles: [...new Set(c.map((N) => N.name))]
      };
      await Yv(b), l(!1), Z.showToast({
        variant: ee.success,
        description: "Profile(s) updated successfully"
      }), _(), a(), t();
    } catch (b) {
      l(!1), V(b);
    }
  }, C = (b) => {
    f(b.length === 0 ? "This is a required field" : null), d(b.map(({ value: N }) => N));
  };
  return /* @__PURE__ */ e.jsx(wi, { className: "visible-modal__body", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__content-space dc__m-auto mt-40 br-8 bg__primary w-600 mh-400 mxh-400", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space px-20 py-12 dc__border-bottom", children: [
        /* @__PURE__ */ e.jsx("h2", { className: "m-0 fs-16 fw-6 lh-24 cn-9", children: "Manage applied profiles" }),
        /* @__PURE__ */ e.jsx(
          j,
          {
            icon: /* @__PURE__ */ e.jsx(vt, {}),
            onClick: t,
            disabled: i,
            dataTestId: "close-modal",
            showAriaLabelInTippy: !1,
            ariaLabel: "Close modal",
            size: O.xs,
            variant: w.borderLess,
            style: B.negativeGrey
          }
        )
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 p-20 dc__gap-16", children: [
        /* @__PURE__ */ e.jsx(
          Sd,
          {
            handleChange: C,
            selectedProfiles: c,
            policyKind: r,
            error: u
          }
        ),
        x && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("div", { className: "dc__border-top-n1" }),
          /* @__PURE__ */ e.jsx(
            ff,
            {
              policyKind: r,
              isEditMode: !0,
              applicableTo: p,
              handleApplicableToTypeUpdate: null,
              handleApplicableToValuesChange: g
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "px-20 py-16 flex dc__gap-12 dc__content-end", children: [
      /* @__PURE__ */ e.jsx(
        j,
        {
          text: "Cancel",
          disabled: i,
          onClick: t,
          dataTestId: "cancel-changes",
          variant: w.secondary,
          style: B.neutral
        }
      ),
      /* @__PURE__ */ e.jsx(
        j,
        {
          text: "Save Changes",
          disabled: i || h,
          onClick: E,
          isLoading: i,
          showTooltip: h,
          tooltipProps: {
            content: vr.INVALID_INPUT
          },
          dataTestId: "save-changes"
        }
      )
    ] })
  ] }) });
}, RA = () => Io.OPEN, al = ({ policyKind: t, redirectToEditMatchCriterion: s }) => {
  const n = de(new AbortController()), a = de(null), [r, o] = v(null), {
    sortBy: i,
    sortOrder: l,
    handleSorting: c,
    clearFilters: d,
    project: p,
    application: m,
    cluster: u,
    environment: f,
    profile: _,
    branchFix: h,
    branchRegex: x,
    plugin: g,
    applicableTo: E,
    updateSearchParams: C
  } = _t({
    initialSortKey: zn.application,
    parseSearchParams: xA
  }), b = Q(
    () => ({
      project: p,
      application: m,
      cluster: u,
      environment: f,
      profile: _,
      branchFix: h,
      branchRegex: x,
      plugin: g,
      applicableTo: E
    }),
    [
      JSON.stringify(p),
      JSON.stringify(m),
      JSON.stringify(u),
      JSON.stringify(f),
      JSON.stringify(_),
      JSON.stringify(h),
      JSON.stringify(x),
      JSON.stringify(g),
      JSON.stringify(E)
    ]
  ), N = !!(m.length || u.length || f.length || _.length || p.length || g.length || h.length || x.length || E.length), [I, T, A, S] = ne(
    () => es(
      () => Gv(
        { policyKind: t, filterConfig: b },
        n.current.signal
      ),
      n
    ),
    [t, b]
  ), L = I || Pe(A), {
    globalScopeList: R = [],
    matchingScopeList: y = [],
    specificScopeList: M = []
  } = T ?? {}, P = !R.length && !y.length && !M.length, U = Q(
    () => CA({
      globalScopeList: R,
      matchingScopeList: y,
      specificScopeList: M
    }),
    [T]
  ), { NULL_STATE_TITLE: G, NULL_STATE_SUBTITLE: H } = Rr[t], oe = (D) => {
    o(D);
  }, ae = () => {
    o(null);
  }, re = () => /* @__PURE__ */ e.jsx(
    j,
    {
      text: "Apply Profile",
      dataTestId: "apply-profile-create",
      component: Re.link,
      linkProps: {
        to: rf[t]
      }
    }
  ), k = () => L || A ? null : P ? N ? /* @__PURE__ */ e.jsx(qt, { classname: "flex-grow-1", handleClearFilters: d }) : /* @__PURE__ */ e.jsx(
    _e,
    {
      image: C_,
      title: G,
      subTitle: H,
      classname: "flex-grow-1",
      isButtonAvailable: !0,
      renderButton: re
    }
  ) : /* @__PURE__ */ e.jsxs("section", { className: "flexbox-col flex-grow-1", children: [
    /* @__PURE__ */ e.jsx(
      If,
      {
        appliedProfilesGroupedByCriterion: T,
        policyKind: t,
        redirectToEditMatchCriterion: s,
        handleOpenManageProfilesModal: oe,
        refetchAppliedProfiles: S,
        sortingConfig: {
          sortBy: i,
          sortOrder: l,
          handleSorting: c
        },
        showActions: !0,
        addedProfilesMap: {},
        removedProfilesMap: {}
      }
    ),
    !!r && /* @__PURE__ */ e.jsx(
      OA,
      {
        handleClose: ae,
        handleSuccess: S,
        policyKind: t,
        ...r
      }
    )
  ] });
  return /* @__PURE__ */ e.jsx(
    Ui,
    {
      identifiers: U,
      getSelectAllDialogStatus: RA,
      children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", ref: a, children: [
        /* @__PURE__ */ e.jsx(
          AA,
          {
            parentRef: a,
            refetchAppliedProfiles: S,
            policyKind: t
          }
        ),
        !(P && !N || A) && /* @__PURE__ */ e.jsx(
          jA,
          {
            policyKind: t,
            filterConfig: b,
            updateSearchParams: C,
            clearFilters: d
          }
        ),
        /* @__PURE__ */ e.jsx(
          Ke,
          {
            isLoading: L,
            customLoader: /* @__PURE__ */ e.jsx(mA, {}),
            error: A,
            errorScreenManagerProps: {
              code: A?.code,
              reload: S
            },
            children: k()
          }
        )
      ] })
    }
  );
}, PA = ({
  appliedProfileListingLink: t,
  exceptionLink: s,
  profileListingLink: n
}) => [
  {
    id: "profile-list-tab",
    label: "Profiles",
    tabType: "navLink",
    props: {
      to: n
    }
  },
  {
    id: "applied-profile-list-tab",
    label: "Applied Profiles",
    tabType: "navLink",
    props: {
      to: t
    }
  },
  ...s ? [
    {
      id: "exception-tab",
      label: "Exceptions",
      tabType: "navLink",
      props: {
        to: s
      }
    }
  ] : []
], rl = ({
  featureTitleWithInfoProps: { tabsConfig: t, ...s },
  createAppliedProfileLink: n,
  createProfileLink: a,
  profileListingLink: r,
  appliedProfileListingLink: o,
  exceptionLink: i
}) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8 pt-16 px-20 bg__primary dc__border-bottom", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space dc__gap-12 flex-grow-1", children: [
    /* @__PURE__ */ e.jsx(
      kc,
      {
        ...Array.isArray(t) ? {
          title: s.title,
          tabsConfig: t
        } : {
          ...s
        },
        showInfoIcon: !0
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8 dc__no-shrink", children: [
      /* @__PURE__ */ e.jsx(
        j,
        {
          text: "Create Profile",
          variant: w.secondary,
          component: Re.link,
          size: O.small,
          linkProps: {
            to: a
          },
          dataTestId: "create-profile",
          startIcon: /* @__PURE__ */ e.jsx(Xt, {})
        }
      ),
      /* @__PURE__ */ e.jsx(
        j,
        {
          text: "Apply Profile",
          component: Re.link,
          size: O.small,
          linkProps: {
            to: n
          },
          dataTestId: "apply-profile"
        }
      )
    ] })
  ] }),
  /* @__PURE__ */ e.jsx(
    Ar,
    {
      hideTopPadding: !0,
      tabs: PA({ profileListingLink: r, appliedProfileListingLink: o, exceptionLink: i })
    }
  )
] }), wA = () => /* @__PURE__ */ e.jsxs("div", { className: "fs-13 fw-4 lh-20 cn-9", children: [
  /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "If deployment approval policy is applied, it requires approval to deploy any image. Only users with 'Image Approver' permission meeting policy criteria can approve." }),
  /* @__PURE__ */ e.jsx("p", { className: "mt-20 mb-0", children: "How to create policy!" }),
  /* @__PURE__ */ e.jsxs("ol", { className: "mb-0 pl-20 fw-6", children: [
    /* @__PURE__ */ e.jsxs("li", { children: [
      /* @__PURE__ */ e.jsx("span", { children: "Create a approval policy" }),
      " ",
      /* @__PURE__ */ e.jsx("span", { className: "fw-4", children: "with approval details" })
    ] }),
    /* @__PURE__ */ e.jsxs("li", { children: [
      /* @__PURE__ */ e.jsx("span", { children: "Use policy for deployment approval." }),
      " ",
      /* @__PURE__ */ e.jsx("span", { className: "fw-4", children: "Apply it to desired deployment pipelines" })
    ] })
  ] })
] }), DA = () => /* @__PURE__ */ e.jsxs("div", { className: "fs-13 fw-4 lh-20 cn-9", children: [
  /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "If configuration change approval policy is applied, it requires approval to change configuration of deployment template, ConfigMaps, Secrets. Only users with 'Configuration change Approver' permission meeting policy criteria can approve." }),
  /* @__PURE__ */ e.jsx("p", { className: "mt-20 mb-0", children: "How to create policy!" }),
  /* @__PURE__ */ e.jsxs("ol", { className: "mb-0 pl-20 fw-6", children: [
    /* @__PURE__ */ e.jsxs("li", { children: [
      /* @__PURE__ */ e.jsx("span", { children: "Create a approval policy" }),
      " ",
      /* @__PURE__ */ e.jsx("span", { className: "fw-4", children: "with approval details" })
    ] }),
    /* @__PURE__ */ e.jsxs("li", { children: [
      /* @__PURE__ */ e.jsx("span", { children: "Use policy for configuration change approval." }),
      " ",
      /* @__PURE__ */ e.jsx("span", { className: "fw-4", children: "Apply it to desired deployment pipelines" })
    ] })
  ] })
] }), MA = {
  title: "Approval Policy",
  tabsConfig: [
    {
      id: tt.deploymentApproval,
      SVGImage: Nb,
      docLink: "GLOBAL_CONFIG_APPROVAL_POLICY",
      title: pn[tt.deploymentApproval],
      renderDescriptionContent: wA
    },
    {
      id: tt.configurationApproval,
      SVGImage: bb,
      docLink: "GLOBAL_CONFIG_APPROVAL_POLICY",
      title: pn[tt.configurationApproval],
      renderDescriptionContent: DA
    }
  ]
}, Ld = () => /* @__PURE__ */ e.jsx(
  rl,
  {
    featureTitleWithInfoProps: MA,
    createProfileLink: Y.APPROVAL_POLICY_CREATE,
    profileListingLink: Y.APPROVAL_POLICY_LIST,
    createAppliedProfileLink: Y.APPROVAL_POLICY_APPLIED_POLICY_CREATE,
    appliedProfileListingLink: Y.APPROVAL_POLICY_APPLIED_POLICY_LIST,
    exceptionLink: Y.APPROVAL_POLICY_EXCEPTION
  }
), kA = () => {
  const { push: t } = Te(), s = () => {
    t(Y.APPROVAL_POLICY_APPLIED_POLICY_LIST);
  }, n = (a) => {
    const r = Kt(Y.APPROVAL_POLICY_APPLIED_POLICY_EDIT, {
      appliedProfileId: a
    });
    t(r);
  };
  return /* @__PURE__ */ e.jsxs(Vt, { children: [
    /* @__PURE__ */ e.jsx(ge, { path: Y.APPROVAL_POLICY_APPLIED_POLICY_CREATE, children: /* @__PURE__ */ e.jsx(
      ia,
      {
        redirectToAppliedProfileList: s,
        policyKind: X.approval
      }
    ) }),
    /* @__PURE__ */ e.jsx(ge, { path: Y.APPROVAL_POLICY_APPLIED_POLICY_EDIT, children: ({ match: a }) => /* @__PURE__ */ e.jsx(
      ia,
      {
        redirectToAppliedProfileList: s,
        policyKind: X.approval
      },
      `applied-policy-detail-${a.params.appliedProfileId}`
    ) }),
    /* @__PURE__ */ e.jsxs(ge, { path: Y.APPROVAL_POLICY_APPLIED_POLICY_LIST, children: [
      /* @__PURE__ */ e.jsx(Ld, {}),
      /* @__PURE__ */ e.jsx(
        al,
        {
          policyKind: X.approval,
          redirectToEditMatchCriterion: n
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(ms, { to: Y.APPROVAL_POLICY_APPLIED_POLICY_LIST })
  ] });
}, jd = (t) => {
  Z.showToast({
    variant: ee.success,
    title: "Policy Saved",
    description: "Policy is saved. Apply policy to criteria matching pipelines",
    buttonProps: {
      text: "Apply policy to pipelines",
      dataTestId: "redirect-apply-profile",
      component: Re.link,
      linkProps: {
        to: rf[t]
      }
    }
  });
}, vf = (t) => ({
  name: t?.identifier,
  description: t?.description ?? "",
  approvalConfig: gd(t?.spec?.def)
}), FA = ({
  name: t,
  description: s,
  approvalConfig: n
}) => ({
  identifier: t,
  description: s,
  spec: {
    def: n.type === is.any ? {
      requiredCount: n.requiredCount,
      type: n.type,
      specificUsers: null,
      userGroups: null
    } : {
      requiredCount: null,
      type: n.type,
      specificUsers: {
        identifiers: n.specificUsers.identifiers,
        // Required count for specific users is read only
        requiredCount: null
      },
      userGroups: n.userGroups.filter(
        ({ requiredCount: a, identifier: r }) => !!r && a > 0
      )
    }
  }
}), UA = async () => {
  try {
    const t = ks({
      kind: X.approval,
      version: mt.alpha1,
      suffix: $.API_LIST_SUFFIX,
      queryParams: {
        lite: !1
      }
    }), { result: s } = await le(t);
    return s?.dataList?.length ? s.dataList.map((n) => vf(n)) : [];
  } catch (t) {
    throw V(t), t;
  }
}, GA = async (t) => {
  try {
    const s = ks({
      kind: X.approval,
      version: mt.alpha1,
      queryParams: {
        identifier: t
      }
    }), { result: n } = await le(s);
    return vf(n);
  } catch (s) {
    throw V(s), s;
  }
}, BA = async (t) => {
  try {
    return await Js(
      ks({
        kind: X.approval,
        version: mt.alpha1,
        queryParams: {
          identifier: t
        }
      })
    ), Z.showToast({
      variant: ee.success,
      description: `Approval policy '${t}' deleted successfully`
    }), !0;
  } catch (s) {
    return V(s), !1;
  }
}, $A = async ({ formState: t, policyName: s }) => {
  const n = FA(t);
  try {
    return await (s ? Bt : we)(
      ks({
        kind: X.approval,
        version: mt.alpha1,
        queryParams: {
          identifier: s
        }
      }),
      n
    ), jd(X.approval), !0;
  } catch (a) {
    return V(a), !1;
  }
}, Af = ({ name: t, handleClose: s, handleSuccess: n }) => {
  const [a, r] = v(!1), o = async () => {
    r(!0), await BA(t) && (s(), n()), r(!1);
  };
  return /* @__PURE__ */ e.jsx(
    zt,
    {
      variant: Ct.delete,
      title: `Delete approval policy '${t}'`,
      subtitle: "Deleting this policy will no longer enforce approvals.",
      buttonConfig: {
        secondaryButtonConfig: {
          text: "Cancel",
          onClick: s,
          disabled: a
        },
        primaryButtonConfig: {
          text: "Delete",
          onClick: o,
          isLoading: a
        }
      },
      confirmationConfig: {
        identifier: "delete-policy",
        confirmationKeyword: t
      },
      handleClose: s
    }
  );
}, VA = {
  name: "",
  description: "",
  approvalConfig: {
    type: is.any,
    requiredCount: 1,
    specificUsers: {
      identifiers: [],
      requiredCount: 0
    },
    userGroups: []
  }
}, YA = ({ formErrors: t, formState: s, policyName: n }) => {
  const [a, r] = v(!1), { push: o } = Te(), i = Object.values(t).some((d) => !Ht(d)), l = () => {
    o(Y.APPROVAL_POLICY_LIST);
  }, c = async () => {
    let d;
    if (i && (d = Ji), d) {
      Z.showToast({
        variant: ee.error,
        title: "Cannot Save",
        description: d
      });
      return;
    }
    if (r(!0), await $A({ formState: s, policyName: n })) {
      l();
      return;
    }
    r(!1);
  };
  return /* @__PURE__ */ e.jsxs("footer", { className: "flexbox left dc__border-top-n1 px-20 py-16 dc__gap-12 dc__no-shrink", children: [
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "approval-policy__save",
        onClick: c,
        isLoading: a,
        disabled: i || a,
        showTooltip: i,
        tooltipProps: {
          content: vr.INVALID_INPUT
        },
        text: "Save Changes"
      }
    ),
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "approval-policy__cancel",
        onClick: l,
        disabled: a,
        variant: w.secondary,
        style: B.neutral,
        text: "Cancel"
      }
    )
  ] });
};
var Ca = /* @__PURE__ */ ((t) => (t.updateName = "updateName", t.updateDescription = "updateDescription", t.updateApprovalConfig = "updateApprovalConfig", t))(Ca || {});
const HA = (t) => ({
  name: t ? null : "",
  description: null,
  approvalConfig: null
}), Hp = () => {
  const { policyName: t } = Ue(), { replace: s } = Te(), n = !!t, [a, r] = v(
    structuredClone(VA)
  ), [o, i] = v(
    HA(n)
  ), [l, c, d, p] = ne(
    () => GA(t),
    [t],
    n
  ), [m, u] = v(!1);
  J(() => {
    if (c) {
      const { name: E, description: C, approvalConfig: b } = c;
      r({
        name: E,
        description: C,
        approvalConfig: b
      });
    }
  }, [c]);
  const f = ({ action: E, value: C }) => {
    const b = structuredClone(a), N = structuredClone(o);
    switch (E) {
      case Ca.updateName:
        b.name = C, N.name = Tn(C).message;
        break;
      case Ca.updateDescription:
        b.description = C, N.description = dn(C).message;
        break;
      case Ca.updateApprovalConfig:
        b.approvalConfig = C, N.approvalConfig = n0(C).message;
        break;
      default:
        throw new Error(`Unsupported action: ${E}`);
    }
    r(b), i(N);
  }, _ = (E) => (C) => {
    f({
      action: E,
      value: C.target.value
    });
  }, h = () => {
    u((E) => !E);
  }, x = () => {
    s(Y.APPROVAL_POLICY_LIST);
  }, g = (E) => f({
    action: Ca.updateApprovalConfig,
    value: E
  });
  return /* @__PURE__ */ e.jsx(
    Ke,
    {
      isLoading: l,
      progressingProps: {
        pageLoader: !0
      },
      error: d,
      errorScreenManagerProps: {
        code: d?.code,
        reload: p,
        redirectURL: Y.APPROVAL_POLICY_LIST
      },
      children: !l && !d && /* @__PURE__ */ e.jsxs("main", { className: "bg__primary flexbox-col flex-grow-1 dc__overflow-hidden", children: [
        /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16 py-16 px-20 dc__no-shrink dc__mxw-960", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space", children: [
            /* @__PURE__ */ e.jsx(
              Gi,
              {
                redirectUrl: Y.APPROVAL_POLICY_LIST,
                linkText: "Approval Policy",
                profileName: t,
                nestedBreadCrumbsText: "Policies"
              }
            ),
            n && /* @__PURE__ */ e.jsx(
              j,
              {
                startIcon: /* @__PURE__ */ e.jsx(ts, {}),
                text: "Delete",
                onClick: h,
                dataTestId: `delete-profile-${t}`,
                size: O.medium,
                variant: w.secondary,
                style: B.negative
              }
            )
          ] }),
          /* @__PURE__ */ e.jsxs("section", { className: "flexbox-col dc__gap-16", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12", children: [
              /* @__PURE__ */ e.jsx("div", { className: "w-250", children: /* @__PURE__ */ e.jsx(
                yt,
                {
                  name: "approval-policy-name",
                  required: !0,
                  placeholder: "Enter policy name",
                  label: "Name",
                  value: a.name,
                  onChange: _(Ca.updateName),
                  error: o.name,
                  autoFocus: !0
                }
              ) }),
              /* @__PURE__ */ e.jsx(
                yt,
                {
                  name: "approval-policy-description",
                  fullWidth: !0,
                  label: "Description",
                  placeholder: "Enter description",
                  value: a.description,
                  onChange: _(Ca.updateDescription),
                  error: o.description
                }
              )
            ] }),
            /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom-n1 w-100" }),
            /* @__PURE__ */ e.jsx(
              bh,
              {
                showSpecificApprovals: !0,
                hideIcon: !0,
                hideManualApprovalToggle: !0,
                labelText: "Require approvals of",
                userApprovalConfig: a.approvalConfig,
                userApprovalConfigErrorObj: {
                  isValid: !o.approvalConfig,
                  message: o.approvalConfig
                },
                handleUpdateUserApprovalConfig: g
              }
            )
          ] })
        ] }) }),
        /* @__PURE__ */ e.jsx(YA, { formState: a, formErrors: o, policyName: t }),
        m && /* @__PURE__ */ e.jsx(
          Af,
          {
            name: t,
            handleClose: h,
            handleSuccess: x
          }
        )
      ] })
    }
  );
}, KA = ({ approvalConfig: t }) => {
  if (t.type === is.any)
    return /* @__PURE__ */ e.jsxs("span", { className: "dc__truncate", children: [
      t.requiredCount,
      " any approver(s)"
    ] });
  const s = t.specificUsers.requiredCount + t.userGroups.reduce((n, a) => n + a.requiredCount, 0);
  return /* @__PURE__ */ e.jsxs("span", { className: "dc__truncate", children: [
    s,
    " specific approver(s)"
  ] });
}, WA = Array.from(Array(3).keys()).map((t) => ({
  name: `policy-${t}`,
  description: "",
  approvalConfig: gd(null)
}));
var cc = /* @__PURE__ */ ((t) => (t.policyName = "policyName", t))(cc || {});
const qA = () => {
  const [t, s] = v(null), { searchKey: n, handleSearch: a, sortOrder: r, handleSorting: o, clearFilters: i } = _t({
    initialSortKey: cc.policyName
  }), [l, c, d, p] = ne(
    () => UA()
  ), m = !!n, u = Q(() => {
    if (c?.length) {
      const E = n.toLowerCase();
      return c.filter(({ name: C }) => !n || C.toLowerCase().includes(E)).sort((C, b) => Ce(C.name, b.name, r));
    }
    return [];
  }, [c, r, n]), f = () => {
    o(cc.policyName);
  }, _ = (E) => () => {
    s(E);
  }, h = () => {
    s(null);
  }, x = () => /* @__PURE__ */ e.jsx(
    j,
    {
      component: Re.link,
      linkProps: { to: Y.APPROVAL_POLICY_CREATE },
      text: "Create Policy",
      startIcon: /* @__PURE__ */ e.jsx(Xt, {}),
      size: O.medium,
      dataTestId: "create-policy"
    }
  ), g = () => d ? null : !l && !m && !c.length ? /* @__PURE__ */ e.jsx(
    _e,
    {
      image: p_,
      title: "Create Approval policy",
      subTitle: "Create approval policy and apply to events such deployments & configuration change (Deployment template, configMaps, Secrets)",
      isButtonAvailable: !0,
      renderButton: x,
      classname: "flex-grow-1",
      imageType: bs.Large
    }
  ) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsx("div", { className: "py-16 px-20 flex dc__content-space dc__gap-8 dc__zi-2", children: /* @__PURE__ */ e.jsx(
      Wt,
      {
        inputProps: {
          placeholder: "Search policy",
          autoFocus: !0
        },
        initialSearchText: n,
        handleEnter: a
      }
    ) }),
    u.length || l ? /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-16 approval-profiles-list__table-row approval-profiles-list__table-row--header dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center dc__uppercase bg__primary px-20 dc__position-sticky dc__top-0 dc__zi-1", children: [
        /* @__PURE__ */ e.jsx("span", {}),
        /* @__PURE__ */ e.jsx(
          Ne,
          {
            isSorted: !0,
            sortOrder: r,
            triggerSorting: f,
            title: "Policy Name",
            disabled: l
          }
        ),
        /* @__PURE__ */ e.jsx(Ne, { title: "Description", isSortable: !1 }),
        /* @__PURE__ */ e.jsx(Ne, { title: "Approvers", isSortable: !1 }),
        /* @__PURE__ */ e.jsx("span", {})
      ] }),
      /* @__PURE__ */ e.jsx("div", { children: l ? WA.map(({ name: E }) => /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: "display-grid dc__column-gap-16 approval-profiles-list__table-row fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-20 dc__border-bottom-n1 show-shimmer-loading",
          children: [
            /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
            /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
            /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
            /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
            /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" })
          ]
        },
        E
      )) : u.map(({ name: E, description: C, approvalConfig: b }) => {
        const N = Kt(Y.APPROVAL_POLICY_EDIT, {
          policyName: E
        });
        return /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: "display-grid dc__column-gap-16 approval-profiles-list__table-row fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-20 dc__border-bottom-n1 dc__hover-n50 dc__visible-hover dc__visible-hover--parent",
            children: [
              /* @__PURE__ */ e.jsx("div", { className: "icon-dim-16 dc__no-shrink", children: /* @__PURE__ */ e.jsx(
                Td,
                {
                  policyKind: X.approval,
                  profileType: null
                }
              ) }),
              /* @__PURE__ */ e.jsx(Ie, { content: E, placement: "top", children: /* @__PURE__ */ e.jsx(
                wt,
                {
                  to: N,
                  className: "anchor dc__w-fit-content dc__truncate",
                  dangerouslySetInnerHTML: {
                    __html: ta.sanitize(
                      aa({
                        searchText: n,
                        text: E,
                        highlightClasses: "bcy-2"
                      })
                    )
                  }
                }
              ) }),
              /* @__PURE__ */ e.jsx(Ie, { content: C, children: /* @__PURE__ */ e.jsx("span", { className: "dc__w-fit-content dc__truncate", children: C || "-" }) }),
              /* @__PURE__ */ e.jsx(KA, { approvalConfig: b }),
              /* @__PURE__ */ e.jsx("div", { className: "dc__visible-hover--child", children: /* @__PURE__ */ e.jsxs("div", { className: "flex right dc__gap-8 dc__no-shrink", children: [
                /* @__PURE__ */ e.jsx(
                  j,
                  {
                    icon: /* @__PURE__ */ e.jsx(Fs, {}),
                    component: Re.link,
                    linkProps: {
                      to: N
                    },
                    dataTestId: `edit-${E}`,
                    ariaLabel: "Edit",
                    variant: w.borderLess,
                    style: B.neutral,
                    size: O.xs
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  j,
                  {
                    icon: /* @__PURE__ */ e.jsx(ts, {}),
                    dataTestId: `delete-${E}`,
                    ariaLabel: "Delete",
                    variant: w.borderLess,
                    style: B.negativeGrey,
                    size: O.xs,
                    onClick: _(E)
                  }
                )
              ] }) })
            ]
          },
          E
        );
      }) })
    ] }) : /* @__PURE__ */ e.jsx(qt, { handleClearFilters: i }),
    !!t && /* @__PURE__ */ e.jsx(
      Af,
      {
        name: t,
        handleSuccess: p,
        handleClose: h
      }
    )
  ] });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Ld, {}),
    /* @__PURE__ */ e.jsx(
      Ke,
      {
        isLoading: !1,
        error: d,
        errorScreenManagerProps: {
          reload: p,
          code: d?.code
        },
        children: g()
      }
    )
  ] });
}, zA = () => /* @__PURE__ */ e.jsxs(Vt, { children: [
  /* @__PURE__ */ e.jsx(ge, { path: Y.APPROVAL_POLICY_CREATE, children: /* @__PURE__ */ e.jsx(Hp, {}) }),
  /* @__PURE__ */ e.jsx(ge, { path: Y.APPROVAL_POLICY_EDIT, children: ({ match: t }) => /* @__PURE__ */ e.jsx(Hp, {}, `approval-policy-detail-${t.params.policyName}`) }),
  /* @__PURE__ */ e.jsx(ge, { path: Y.APPROVAL_POLICY_LIST, children: /* @__PURE__ */ e.jsx(qA, {}) }),
  /* @__PURE__ */ e.jsx(ms, { to: Y.APPROVAL_POLICY_LIST })
] }), bU = () => {
  const { isSuperAdmin: t } = Is();
  return t ? /* @__PURE__ */ e.jsx("div", { className: "flexbox-col h-100 dc__overflow-hidden bg__primary", children: /* @__PURE__ */ e.jsxs(Vt, { children: [
    /* @__PURE__ */ e.jsx(ge, { path: Y.APPROVAL_POLICY_LIST, children: /* @__PURE__ */ e.jsx(zA, {}) }),
    /* @__PURE__ */ e.jsx(ge, { path: Y.APPROVAL_POLICY_APPLIED_POLICY_LIST, children: /* @__PURE__ */ e.jsx(kA, {}) }),
    /* @__PURE__ */ e.jsxs(ge, { path: Y.APPROVAL_POLICY_EXCEPTION, children: [
      /* @__PURE__ */ e.jsx(Ld, {}),
      /* @__PURE__ */ e.jsx(Ov, { policyKind: X.approval })
    ] }),
    /* @__PURE__ */ e.jsx(ms, { to: Y.APPROVAL_POLICY_LIST })
  ] }) }) : /* @__PURE__ */ e.jsx(Xe, { code: da.PERMISSION_DENIED });
}, dc = ({ userStatus: t }) => /* @__PURE__ */ e.jsx(Ib, { className: `icon-dim-48 user-status-icon--${t}` }), XA = (t, s, n, a) => {
  switch (t) {
    case ce.active:
      return {
        icon: /* @__PURE__ */ e.jsx(dc, { userStatus: t }),
        title: n ? `Activate ${a} user account(s)` : `Activate ${s}’s account`,
        subTitle: "The account(s) will be activated and they will be able to login to Devtron. Are you sure?",
        buttonConfig: {
          text: n ? "Activate User(s)" : "Activate User",
          style: B.positive
        }
      };
    case ce.inactive:
      return {
        icon: /* @__PURE__ */ e.jsx(dc, { userStatus: t }),
        title: n ? `Deactivate ${a} user account(s)` : `Deactivate ${s}’s account`,
        subTitle: "The account(s) will be deactivated and they will not be able to login to Devtron. Are you sure?",
        buttonConfig: {
          text: n ? "Deactivate User(s)" : "Deactivate User",
          style: B.negative
        }
      };
    default:
      throw new Error(`Unsupported type:${t}`);
  }
}, Sf = ({
  handleCancel: t,
  handleSave: s,
  isLoading: n,
  userEmail: a,
  newUserStatus: r,
  isMulti: o = !1,
  selectedUsersCount: i
}) => {
  const { icon: l, title: c, subTitle: d, buttonConfig: p } = XA(r, a, o, i), m = () => {
    s();
  };
  return /* @__PURE__ */ e.jsx(
    zt,
    {
      variant: Ct.custom,
      Icon: l,
      title: c,
      subtitle: d,
      handleClose: t,
      buttonConfig: {
        secondaryButtonConfig: {
          text: "Cancel",
          onClick: t,
          disabled: n
        },
        primaryButtonConfig: {
          text: p.text,
          onClick: m,
          style: p.style,
          isLoading: n
        }
      }
    }
  );
};
var Br = /* @__PURE__ */ ((t) => (t.activateUser = "activate-user", t.keepUserActive = "keep-user-active", t))(Br || {});
const Kp = hd(), JA = fd(), Od = ({
  handleCancel: t,
  handleSave: s,
  isLoading: n,
  userEmail: a,
  currentUserStatus: r,
  timeToLive: o,
  isMulti: i = !1,
  selectedUsersCount: l,
  buttonText: c = "Activate temporarily",
  buttonStyle: d = B.warning
}) => {
  const p = !i && r === ce.inactive ? Br.activateUser : Br.keepUserActive, u = i ? `Keep ${l} user account(s) active until` : a ? p === Br.activateUser ? `Activate ${a}’s account until` : `Keep ${a}’s account active until` : p === Br.activateUser ? "Activate account until" : "Keep account active until", [f, _] = v(sn(o)), [h, x] = v("");
  J(() => {
    _(sn(o));
  }, [o]);
  const g = (C) => {
    h && x(""), _(C);
  }, E = () => {
    x("");
    const { isValid: C, message: b } = Kl(f);
    C ? s(f.toISOString()) : x(b);
  };
  return /* @__PURE__ */ e.jsx(
    zt,
    {
      variant: Ct.custom,
      Icon: /* @__PURE__ */ e.jsx(dc, { userStatus: ce.temporary }),
      title: u,
      handleClose: t,
      buttonConfig: {
        secondaryButtonConfig: {
          text: "Cancel",
          onClick: t,
          disabled: n
        },
        primaryButtonConfig: {
          text: c,
          isLoading: n,
          onClick: E,
          style: d
        }
      },
      children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 w-100", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4 w-100", children: [
          /* @__PURE__ */ e.jsx(
            tr,
            {
              date: f,
              onChange: g,
              disabled: n,
              error: h,
              label: "Set date & time",
              required: !0,
              id: "user-temporary-access"
            }
          ),
          Kp && /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-4 cn-7 fs-11 lh-16 fw-4", children: [
            /* @__PURE__ */ e.jsx(Tb, { className: "icon-dim-16 dc__no-shrink info-icon-n5" }),
            "Browser time zone: ",
            Kp,
            " (GMT ",
            JA,
            ")"
          ] })
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "dc__border-top" }),
        /* @__PURE__ */ e.jsx("p", { className: "cn-8 fs-13 lh-20 fw-4 m-0", children: "The account(s) will be deactivated after the specified duration and they will not be able to login to Devtron. Are you sure?" })
      ] })
    }
  );
}, QA = [
  {
    label: "Activate",
    value: ce.active,
    startIcon: ln(ce.active)
  },
  {
    label: "Inactivate",
    value: ce.inactive,
    startIcon: ln(ce.inactive)
  },
  {
    label: "Keep active until...",
    value: ce.temporary,
    startIcon: ln(ce.temporary)
  }
], NU = ({
  selectedUsersCount: t,
  filterConfig: s,
  disabled: n,
  refetchUserPermissionList: a
}) => {
  const [r, o] = v(!1), [i, l] = v(null), {
    selectedIdentifiers: c,
    isBulkSelectionApplied: d,
    handleBulkSelection: p
  } = It(), m = !!i, u = (x) => {
    l(x.value);
  }, f = () => {
    l(null);
  }, _ = async (x) => {
    o(!0);
    const g = Object.keys(c).map(Number), E = {
      ...d ? {
        filterConfig: {
          searchKey: s.searchKey,
          status: s.status
        }
      } : {
        userIds: g
      },
      status: i,
      timeToLive: x
    };
    try {
      await of(E), Z.showToast({
        variant: ee.success,
        description: "Status updated for selected user(s)"
      }), p({
        action: st.CLEAR_ALL_SELECTIONS
      }), a(), f();
    } catch (C) {
      V(C);
    } finally {
      o(!1);
    }
  }, h = () => {
    switch (i) {
      case ce.temporary:
        return /* @__PURE__ */ e.jsx(
          Od,
          {
            isLoading: r,
            handleCancel: f,
            handleSave: _,
            isMulti: !0,
            selectedUsersCount: t
          }
        );
      case ce.inactive:
      case ce.active:
        return /* @__PURE__ */ e.jsx(
          Sf,
          {
            isLoading: r,
            handleCancel: f,
            handleSave: _,
            isMulti: !0,
            selectedUsersCount: t,
            newUserStatus: i
          }
        );
      default:
        return null;
    }
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "dc__zi-4", children: [
    /* @__PURE__ */ e.jsx(
      Ve,
      {
        inputId: "bulk-status-update-dropdown",
        placeholder: "Change status",
        value: null,
        options: QA,
        onChange: u,
        isDisabled: n,
        menuPosition: "absolute"
      }
    ),
    m && h()
  ] });
}, ZA = (t) => /* @__PURE__ */ e.jsx(
  lt,
  {
    className: "default-tt w-200",
    arrow: !1,
    placement: "top",
    content: "Permission status cannot be changed when user status is set to Inactive.",
    children: /* @__PURE__ */ e.jsx("div", { children: t })
  }
), yf = ({
  userStatus: t,
  timeToLive: s,
  handleChange: n,
  onMenuClose: a,
  onMenuOpen: r,
  disabled: o,
  breakLinesForTemporaryAccess: i = !1,
  showTooltipWhenDisabled: l = !1,
  isBorderLess: c = !1,
  size: d,
  label: p
}) => {
  const m = i && t === ce.temporary, { selectOptions: u, selectedOption: f } = Q(() => {
    const _ = [
      {
        label: t === ce.active ? "Active" : "Activate",
        value: ce.active,
        startIcon: ln(ce.active)
      },
      {
        label: t === ce.inactive ? "Inactive" : "Inactivate",
        value: ce.inactive,
        startIcon: ln(ce.inactive)
      },
      {
        label: m ? s : lv(t),
        value: ce.temporary,
        startIcon: ln(ce.temporary)
      }
    ], h = _.find((x) => x.value === t);
    return {
      selectOptions: _,
      selectedOption: h
    };
  }, [t]);
  return /* @__PURE__ */ e.jsx(An, { condition: l && o, wrap: ZA, children: /* @__PURE__ */ e.jsx("div", { className: "w-100", children: /* @__PURE__ */ e.jsx(
    Ve,
    {
      inputId: "user-status-dropdown",
      options: u,
      placeholder: "Select user status",
      onChange: n,
      value: f,
      menuPosition: "fixed",
      onMenuClose: a,
      onMenuOpen: r,
      isDisabled: o,
      shouldMenuAlignRight: !0,
      variant: c ? cn.COMPACT : cn.DEFAULT,
      size: d,
      label: p
    }
  ) }) });
}, TU = ({
  userStatus: t,
  timeToLive: s,
  userEmail: n,
  userId: a,
  refetchUserPermissionList: r,
  isReadOnly: o
}) => {
  const [i, l] = v(null), [c, d] = v(!1), [p, m] = v(!1), u = !!i, f = (C) => {
    (C.value !== t || t === ce.temporary) && l(C.value);
  }, _ = () => {
    l(null);
  }, h = async (C) => {
    d(!0);
    try {
      await of({
        userIds: [a],
        status: i,
        timeToLive: C
      }), Z.showToast({
        variant: ee.success,
        description: "User status updated"
      }), r(), d(!1), _();
    } catch (b) {
      d(!1), V(b);
    }
  }, x = () => {
    switch (i) {
      case ce.temporary:
        return /* @__PURE__ */ e.jsx(
          Od,
          {
            isLoading: c,
            userEmail: n,
            handleCancel: _,
            handleSave: h,
            currentUserStatus: t,
            timeToLive: s
          }
        );
      case ce.inactive:
      case ce.active:
        return /* @__PURE__ */ e.jsx(
          Sf,
          {
            isLoading: c,
            userEmail: n,
            handleCancel: _,
            handleSave: h,
            newUserStatus: i
          }
        );
      default:
        return null;
    }
  }, g = () => {
    m(!1);
  }, E = () => {
    m(!0);
  };
  return o ? /* @__PURE__ */ e.jsx($p, { userStatus: t, text: oc(t, s) }) : /* @__PURE__ */ e.jsxs("div", { children: [
    !p && /* @__PURE__ */ e.jsx("div", { className: "dc__visible-hover--hide-child", children: /* @__PURE__ */ e.jsx($p, { userStatus: t, text: oc(t, s) }) }),
    /* @__PURE__ */ e.jsxs("div", { className: p ? "" : "dc__visible-hover--child", children: [
      /* @__PURE__ */ e.jsx("div", { className: "w-200", children: /* @__PURE__ */ e.jsx(
        yf,
        {
          userStatus: t,
          timeToLive: s,
          handleChange: f,
          onMenuClose: g,
          onMenuOpen: E,
          isBorderLess: !0
        }
      ) }),
      u && x()
    ] })
  ] });
}, Lf = {
  [ce.active]: "Active (No timeout)",
  [ce.temporary]: "Active (Has timeout)",
  [ce.inactive]: "Inactive"
}, Wp = Object.entries(Lf).map(
  ([t, s]) => ({
    label: s,
    value: t
  })
), IU = ({ value: t = [], onChange: s }) => {
  const n = Q(() => {
    const r = t.reduce(
      (o, i) => (o[i] = !0, o),
      {
        [ce.active]: null,
        [ce.inactive]: null,
        [ce.temporary]: null
      }
    );
    return Wp.filter((o) => r[o.value]);
  }, [t]), a = (r) => {
    s(r.map((o) => o.value));
  };
  return /* @__PURE__ */ e.jsx(
    Ps,
    {
      inputId: "user-status-filter",
      isLoading: !1,
      isDisabled: !1,
      placeholder: "Status",
      appliedFilterOptions: n,
      handleApplyFilter: a,
      options: Wp
    }
  );
}, eS = [
  {
    status: ce.active,
    heading: "Active : ",
    info: "User can login to Devtron."
  },
  {
    status: ce.inactive,
    heading: "Inactive : ",
    info: "User cannot login to Devtron."
  },
  {
    status: ce.temporary,
    heading: "Active until : ",
    info: "User account will be inactivated after the specified date & time."
  }
], tS = () => /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-4 pl-12 pb-12 pr-12 fs-13 fw-4 lh-20 cn-9", children: eS.map(({ status: t, heading: s, info: n }) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4", children: [
  /* @__PURE__ */ e.jsx("div", { className: "flex dc__no-shrink mw-20 mxh-20", children: ln(t) }),
  /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsx("span", { className: "fw-6", children: s }),
    /* @__PURE__ */ e.jsx("span", { children: n })
  ] })
] }, t)) }), vU = () => (
  // The left padding accounts for the space occupied by the status icon
  /* @__PURE__ */ e.jsxs("span", { className: "flex dc__content-start dc__gap-4 pl-22 dc__uppercase", children: [
    "Status",
    /* @__PURE__ */ e.jsx(
      ca,
      {
        infoText: "Status allows you to manage if a user can or cannot access Devtron.",
        heading: "Status",
        additionalContent: /* @__PURE__ */ e.jsx(tS, {}),
        iconClassName: "dc__no-shrink icon-dim-16 fcn-6"
      }
    )
  ] })
), AU = ({ userGroups: t }) => {
  const s = t.map(({ name: n }) => n).join(", ");
  return t.length > 0 ? /* @__PURE__ */ e.jsx(
    Ie,
    {
      wordBreak: !0,
      interactive: !0,
      className: "mxh-250 dc__overflow-auto",
      content: /* @__PURE__ */ e.jsxs("div", { className: "fs-12 lh-18", children: [
        /* @__PURE__ */ e.jsx("p", { className: "fw-6 m-0", children: "User Groups" }),
        /* @__PURE__ */ e.jsx("div", { children: t.map(({ name: n }) => /* @__PURE__ */ e.jsx("p", { className: "m-0", children: n }, n)) })
      ] }),
      children: /* @__PURE__ */ e.jsx("div", { className: "dc__truncate", children: s })
    }
  ) : /* @__PURE__ */ e.jsx("div", { children: "-" });
}, SU = ({ selectedUserGroups: t, handleUserGroupChange: s }) => {
  const [n, a] = ne(() => bd()), { selectedUserGroupOptions: r, userGroupOptions: o } = Q(() => {
    const l = cv(a), c = dv(t);
    return {
      userGroupOptions: l,
      selectedUserGroupOptions: l.filter(({ value: d }) => c[d])
    };
  }, [t, a]), i = (l) => {
    s(
      l.map(({ label: c, value: d }) => ({
        name: c,
        userGroupId: d
      }))
    );
  };
  return /* @__PURE__ */ e.jsx(
    Ve,
    {
      isMulti: !0,
      inputId: "user-group-selector",
      options: o,
      size: O.large,
      placeholder: "Select user group",
      label: "Assign user groups",
      isDisabled: n,
      isLoading: n,
      onChange: i,
      value: r
    }
  );
}, yU = ({ filterConfig: t, clearFilters: s, onRemoveFilter: n }) => {
  const a = (r, o) => r === nf ? Lf[o] : null;
  return /* @__PURE__ */ e.jsx("div", { className: "pr-20 pl-20", children: /* @__PURE__ */ e.jsx(
    Ga,
    {
      filterConfig: t,
      clearFilters: s,
      onRemoveFilter: n,
      getFormattedValue: a
    }
  ) });
};
var jf = /* @__PURE__ */ ((t) => (t.CONFIG_APPROVER = "configApprover", t.ARTIFACT_PROMOTER = "artifactPromoter", t.TERMINAL_EXEC = "terminalExec", t))(jf || {});
const uo = Object.values(jf).reduce(
  (t, s) => (t[s] = !0, t),
  {}
), LU = "The manager role is deprecated and will be removed soon. Going forward, We recommend to use the Access manager role.", Of = "deploymentApprover", sS = {
  label: "Deployment approver",
  value: Of,
  // Additional role allowed for devtron apps only and not received as a role from BE
  description: "Can approve deployment requests for the selected applications and environment combination",
  roleType: "additionalRoles"
}, qp = ({ isForDialog: t = !1 }) => /* @__PURE__ */ e.jsxs("div", { children: [
  /* @__PURE__ */ e.jsx("span", { className: t ? "fs-13 lh-20 cn-8 fw-4" : "", children: "Enabling this, will allow user to" }),
  /* @__PURE__ */ e.jsxs("ul", { className: `pl-20 m-0 ${t ? "fs-13 lh-20 cn-8 fw-6" : ""}`, children: [
    /* @__PURE__ */ e.jsx("li", { children: "Manage access for all roles, including super admins" }),
    /* @__PURE__ */ e.jsx("li", { children: "Manage access across all projects & environments" })
  ] })
] }), jU = ({ allowManageAllAccess: t, setAllowManageAllAccess: s }) => {
  const [n, a] = v(!1), r = () => {
    if (t) {
      s(!1);
      return;
    }
    s(!0), a(!0);
  }, o = () => {
    s(!1), a(!1);
  }, i = () => {
    a(!1);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-8 fs-13 lh-20 fw-4 dc__underline-dotted", children: [
      /* @__PURE__ */ e.jsx(Ie, { content: /* @__PURE__ */ e.jsx(qp, {}), alwaysShowTippyOnHover: !0, children: /* @__PURE__ */ e.jsx("span", { children: "Can manage access for all roles" }) }),
      /* @__PURE__ */ e.jsx(
        Gn,
        {
          name: "manage-access-for-all-roles",
          ariaLabel: "Toggle manage access for all roles",
          isChecked: t,
          onChange: r,
          size: O.small
        }
      )
    ] }),
    n && /* @__PURE__ */ e.jsx(
      zt,
      {
        variant: Ct.warning,
        title: "Can manage access for all roles",
        subtitle: /* @__PURE__ */ e.jsx(qp, { isForDialog: !0 }),
        buttonConfig: {
          secondaryButtonConfig: {
            text: "Cancel",
            onClick: o
          },
          primaryButtonConfig: {
            text: "Confirm",
            onClick: i
          }
        },
        handleClose: o,
        children: /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-20 cn-8 fw-4", children: "Are you sure?" })
      }
    )
  ] });
}, OU = () => /* @__PURE__ */ e.jsx("span", { className: "bcy-1 cy-7 px-6 py-2 br-4", children: "Deprecated" }), RU = ({ selected: t, onChange: s }) => {
  const n = de(Yt()), a = (r) => {
    r.preventDefault(), s();
  };
  return /* @__PURE__ */ e.jsx(
    Gn,
    {
      name: n.current,
      dataTestId: "toggle-enable-role",
      ariaLabel: "Toggle Role Section",
      isChecked: t,
      onChange: a,
      size: O.small
    }
  );
}, PU = (t, s, n) => [
  // filter roles according to access and expected roles from BE
  ...t.filter((a) => a.accessType === s && uo[a.roleName]).map((a) => ({
    label: a.roleDisplayName,
    value: a.roleName,
    description: a.roleDescription,
    roleType: "additionalRoles"
  })),
  // append deployment approver role as not received from BE
  ...n && s === ym.DEVTRON_APPS ? [sS] : []
], wU = (t) => t.filter((s) => s.accessType === ym.DEVTRON_APPS && s.roleName !== Dx.MANAGER).sort((s, n) => {
  const a = !!uo[s.roleName], r = !!uo[n.roleName];
  return a === r ? 0 : a ? 1 : -1;
}).map((s) => ({
  label: s.roleDisplayName,
  value: s.roleName,
  description: s.roleDescription,
  roleType: "accessManagerRoles"
})), DU = (t, s, n) => {
  const a = t.split(","), r = a.find((l) => !uo[l]) || "", o = /* @__PURE__ */ new Set(
    [
      ...n ? ["deploymentApprover"] : [],
      // add deploymentApprover in user roles
      ...a.filter((l) => !!uo[l])
    ]
    // filter additional roles from action string
  ), i = new Set(s ? s.split(",") : []);
  return {
    baseRole: r,
    additionalRoles: o,
    accessManagerRoles: i
  };
}, MU = ({ baseRole: t, additionalRoles: s }) => {
  const n = Array.from(s).filter((a) => a !== Of);
  return [t, ...n].filter(Boolean).join(",");
}, kU = ({
  userStatus: t,
  timeToLive: s,
  userEmail: n,
  handleChange: a,
  disabled: r,
  showDropdownBorder: o = !0,
  breakLinesForTemporaryAccess: i = !1,
  dropdownClassName: l,
  showTooltipWhenDisabled: c,
  size: d = O.large,
  label: p
}) => {
  const [m, u] = v(!1), [f, _] = v(!1), h = s && !f, x = (N) => {
    const { value: I } = N;
    I === ce.temporary ? u(!0) : a(I, "");
  }, g = () => {
    u(!1);
  }, E = (N) => {
    a(ce.temporary, iv(N)), g();
  }, C = () => {
    _(!0);
  }, b = () => {
    _(!1);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "dc__visible-hover dc__visible-hover--parent w-100", children: [
      /* @__PURE__ */ e.jsx("div", { className: "dc__visible-hover--hide-child", children: h ? /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: `flex left dc__gap-6 en-2 bw-1 px-8 py-5 bg__secondary cursor br-4 ${d === O.large ? "h-36" : ""}`,
          children: [
            /* @__PURE__ */ e.jsx("span", { className: "dc__no-shrink mw-16 flex", children: ln(t) }),
            /* @__PURE__ */ e.jsx("span", { className: "dc__truncate fs-13 lh-20", children: s }),
            /* @__PURE__ */ e.jsx(u_, { className: "icon-dim-16 scn-6 dc__no-shrink" })
          ]
        }
      ) : null }),
      /* @__PURE__ */ e.jsx(
        "div",
        {
          className: `${h ? "dc__visible-hover dc__visible-hover--child" : "dc__visible"}`,
          children: /* @__PURE__ */ e.jsx(
            yf,
            {
              userStatus: t,
              timeToLive: s,
              handleChange: x,
              onMenuClose: b,
              onMenuOpen: C,
              disabled: r,
              withBorder: o,
              breakLinesForTemporaryAccess: i,
              className: l,
              showTooltipWhenDisabled: c,
              size: d,
              label: p
            }
          )
        }
      )
    ] }),
    m && /* @__PURE__ */ e.jsx(
      Od,
      {
        isLoading: !1,
        userEmail: n,
        handleCancel: g,
        handleSave: E,
        currentUserStatus: t,
        timeToLive: s,
        buttonText: "Done",
        buttonStyle: B.default
      }
    )
  ] });
}, nS = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-20 lh-20", children: [
  /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-9 fs-13 fw-4", children: "Configure build infra profile to ensure your build processes have appropriate computing resources (CPU, memory, target node) for each target platform (linux/arm64, windows/amd64 etc)." }),
  /* @__PURE__ */ e.jsxs("ul", { className: "px-20 m-0", children: [
    /* @__PURE__ */ e.jsxs("li", { children: [
      /* @__PURE__ */ e.jsx("span", { children: "Create a build infra profile" }),
      /* @__PURE__ */ e.jsx("span", { children: " with parameters like CPU, memory, build timeout, node selectors and tolerations to optimize build performance. " })
    ] }),
    /* @__PURE__ */ e.jsxs("li", { children: [
      /* @__PURE__ */ e.jsx("span", { children: "Attach the profile" }),
      /* @__PURE__ */ e.jsx("span", { children: " to your applications based on their specific build requirements " })
    ] })
  ] })
] }), Rf = () => /* @__PURE__ */ e.jsx(
  kc,
  {
    title: Mx.HEADING,
    showInfoIcon: !0,
    SVGImage: vb,
    docLink: "GLOBAL_CONFIG_BUILD_INFRA",
    renderDescriptionContent: nS
  }
);
var pc = /* @__PURE__ */ ((t) => (t.INHERITING_GLOBAL_PROFILE = "INHERITING_GLOBAL_PROFILE", t.OVERRIDDEN = "OVERRIDDEN", t.PARTIALLY_INHERITING = "PARTIALLY_INHERITING", t))(pc || {}), Gs = /* @__PURE__ */ ((t) => (t.TABULAR = "tabular", t.LIST = "list", t.ACCORDION = "accordion", t))(Gs || {}), Nt = /* @__PURE__ */ ((t) => (t.REQUEST = "Request", t.LIMIT = "Limit", t.TIME = "Time", t.KEY = "Key", t.VALUE = "Value", t.OPERATOR = "Operator", t.EFFECTS = "Effects", t.CM = "ConfigMaps", t.CS = "Secrets", t))(Nt || {}), jt = /* @__PURE__ */ ((t) => (t.INHERITING_PROFILE = "inheritingProfile", t.OVERRIDDEN = "overridden", t.INHERITING_DEFAULT_PLATFORM = "inheritingDefaultPlatform", t.PARTIAL_INHERITING = "partialInheriting", t))(jt || {}), Er = /* @__PURE__ */ ((t) => (t.PROFILES = "Profiles", t.APPLICATIONS = "Applications", t))(Er || {}), Cr = /* @__PURE__ */ ((t) => (t.PROFILE = "profile", t.PLATFORM = "profile/platform", t))(Cr || {});
const Cs = {
  BUILD_INFRA_INFO_TITLE: "Manage build infra configurations for similar applications using profiles",
  BUILD_INFRA_INFO_DESCRIPTION: "Streamline your build process by managing infrastructure configurations like CPU, Memory, and Build timeout using profiles. Tailor settings for similar applications, ensuring optimal build efficiency and cost-effectiveness.",
  CLEAR_FILTERS: "Clear Filters",
  EDIT_PROFILE_CONTAINER_LABEL: "Select configurations to set a custom value",
  DEFAULT_PROFILE_CONTAINER_LABEL: {
    title: "Manage default infra configurations for applications",
    subtitle: "You can also override configurations for specific applications.",
    navText: "Go to Applications"
  },
  CREATE_PROFILE_TIPPY: {
    infoText: "Create a build infra profile with parameters like CPU, memory, build timeout, node selectors and tolerations to optimize build performance.",
    additionalContentText: "Attach the profile to your applications based on their specific build requirements."
  },
  EDIT_PROFILE_TIPPY: {
    infoText: "Edit the build infra profile with parameters like CPU, memory, build timeout, node selectors and tolerations to optimize build performance.",
    additionalContentText: "Attach the profile to your applications based on their specific build requirements."
  },
  DELETE_PROFILE: {
    DELETE_PROFILE_BUTTON: "Delete",
    CONFIRMATION_TEXT: "Are you sure?",
    getDeleteDialogDescription: (t) => `'${t}' profile will be removed. Applications using this profile will start using ${ft} profile.`
  },
  SELECT_PROFILE_PROVIDER_ERROR: "useSelectProfileContext must be used within SelectProfileProvider",
  getInvalidLocatorMessage: (t) => `Invalid locator: ${t}`,
  BREADCRUMB_TITLES: {
    PROFILES: "Profiles",
    CREATE_PROFILE: "Create"
  },
  TARGET_PLATFORM_FILTER_TEXT: {
    DEFAULT_PLATFORM_LABEL: `${Ft(ht)} configuration`,
    PLATFORM_GROUP_HEADING: "Platform specific"
  }
}, ol = [
  {
    key: ue.CPU,
    name: "CPU (Req - Limit)"
  },
  {
    key: ue.MEMORY,
    name: "Memory (Req - Limit)"
  },
  {
    key: ue.BUILD_TIMEOUT,
    name: "Build Timeout"
  },
  {
    key: ue.NODE_SELECTOR,
    name: "Node selector"
  },
  {
    key: ue.TOLERANCE,
    name: "Toleration"
  },
  {
    key: ue.CONFIG_MAP,
    name: "ConfigMaps"
  },
  {
    key: ue.SECRET,
    name: "Secrets"
  }
], Pf = {
  [ue.NODE_SELECTOR]: !0,
  [ue.TOLERANCE]: !0,
  [ue.CONFIG_MAP]: !0,
  [ue.SECRET]: !0
}, Mr = (t) => {
  const s = Lm[t];
  return s ? /* @__PURE__ */ e.jsx(s, { className: "scn-6 icon-dim-16 dc__no-shrink mt-2" }) : null;
}, Rd = {
  [ue.CPU]: {
    title: "CPU",
    marker: Mr(ue.CPU),
    variant: Gs.LIST,
    headings: [
      {
        title: Nt.REQUEST,
        gridColumnClass: "80px"
      },
      {
        title: Nt.LIMIT,
        gridColumnClass: "80px"
      }
    ]
  },
  [ue.MEMORY]: {
    title: "Memory",
    marker: Mr(ue.MEMORY),
    variant: Gs.LIST,
    // In List format we will render only one heading in row so that value will be auto
    headings: [
      {
        title: Nt.REQUEST,
        gridColumnClass: "80px"
      },
      {
        title: Nt.LIMIT,
        gridColumnClass: "80px"
      }
    ]
  },
  [ue.BUILD_TIMEOUT]: {
    title: "Build timeout",
    marker: Mr(ue.BUILD_TIMEOUT),
    variant: Gs.LIST,
    headings: [
      {
        title: Nt.TIME,
        gridColumnClass: "80px"
      }
    ]
  },
  [ue.NODE_SELECTOR]: {
    title: "Node selector",
    marker: Mr(ue.NODE_SELECTOR),
    variant: Gs.TABULAR,
    headings: [
      {
        title: Nt.KEY,
        gridColumnClass: "138px"
      },
      {
        title: Nt.VALUE,
        gridColumnClass: "auto"
      }
    ]
  },
  [ue.TOLERANCE]: {
    title: "Toleration",
    marker: Mr(ue.TOLERANCE),
    variant: Gs.TABULAR,
    headings: [
      {
        title: Nt.KEY,
        gridColumnClass: "138px"
      },
      {
        title: Nt.OPERATOR,
        gridColumnClass: "138px"
      },
      {
        title: Nt.VALUE,
        gridColumnClass: "138px"
      },
      {
        title: Nt.EFFECTS,
        gridColumnClass: "auto"
      }
    ]
  },
  [ue.CONFIG_MAP]: {
    title: _r[ue.CONFIG_MAP],
    variant: Gs.ACCORDION
  },
  [ue.SECRET]: {
    title: _r[ue.SECRET],
    variant: Gs.ACCORDION
  }
}, aS = {
  [fr.EQUALS]: "Equals",
  [fr.EXISTS]: "Exists"
}, rS = {
  [cr.NO_SCHEDULE]: "No Schedule",
  [cr.PREFER_NO_SCHEDULE]: "Prefer No Schedule",
  [cr.NO_EXECUTE]: "No Execute"
}, Ks = {
  PROFILE_NAME: "Profile Name",
  APPLICATION_NAME: "Application Name",
  NO_PROFILE_EMPTY_STATE: {
    title: "No profile found",
    subTitle: "There seems to be some issue while fetching profiles."
  },
  CREATE_PROFILE_BUTTON: "Create Profile",
  SEARCH_PROFILE_PLACEHOLDER: "Search profile",
  EDIT_DEFAULT_PROFILE_TEXT: "Edit default profile",
  CUSTOM_PROFILE_TEXT: "Overridden",
  getImpactingAppsText: (t) => `${t} applications`,
  getEditProfileAriaLabel: (t) => `Edit ${t}`,
  getProfileEditTextButtonAriaLabel: (t) => `Edit ${t} profile`,
  getDeleteProfileAriaLabel: (t) => `Delete ${t}`,
  getDeleteProfileSuccessToast: (t) => `'${t}' profile is deleted`
}, ja = {
  getProfileEditTestId: (t) => `profile-edit-${t}`,
  getProfileImpactTestId: (t) => `profile-impact-${t}`,
  getProfileDeleteTestId: (t) => `profile-delete-${t}`,
  getEditProfileTextButtonTestId: (t) => `edit-profile-${t}`,
  CLEAR_FILTERS_TEST_ID: "clear-filters",
  CREATE_PROFILE_TEST_ID: "create-profile",
  EDIT_DEFAULT_PROFILE_TEST_ID: "edit-default-profile"
}, oS = {
  [Er.PROFILES]: `${Ee.APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA}`,
  [Er.APPLICATIONS]: `${Ee.APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA_APPLICATIONS}`
}, wf = "build-infra-select", Ha = Object.values(ue), Df = {
  [ue.CPU]: {
    request: bt.CPU_REQUEST,
    limit: bt.CPU_LIMIT
  },
  [ue.MEMORY]: {
    request: bt.MEMORY_REQUEST,
    limit: bt.MEMORY_LIMIT
  }
}, Mf = ue.CPU, iS = ({ tabName: t, currentTab: s }) => {
  const n = Te(), a = t === s, r = () => {
    a || (ct.event({
      category: "global-config-build-infra",
      action: `global-build-infra-${t}-list-view`
    }), n.push(oS[t]));
  };
  return /* @__PURE__ */ e.jsx(
    "button",
    {
      className: `mr-16 dc__tab-focus pr-0 pl-0 pt-0 flexbox dc__align-items-center dc__no-border dc__no-background h-100 mb-neg-1 ${a ? "cb-5 fs-13 fw-6 dc__border-bottom-2--b5" : "cn-9 fs-13 fw-4 dc__hover-color-b500 mb-0"}`,
      onClick: r,
      type: "button",
      children: t
    }
  );
}, kf = ({ currentTab: t }) => {
  const s = Object.values(Er);
  return /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-end w-100 h-28", children: s.map((n) => /* @__PURE__ */ e.jsx(iS, { tabName: n, currentTab: t }, n)) });
};
var mo = /* @__PURE__ */ ((t) => (t.CREATE = "create", t.EDIT = "edit", t))(mo || {}), yi = /* @__PURE__ */ ((t) => (t.TARGET_PLATFORM_FORM_TYPE = "targetPlatformFormType", t.TARGET_PLATFORM = "targetPlatform", t.CONFIGURATION_TYPE = "configurationType", t))(yi || {});
const Nl = (t, s) => /* @__PURE__ */ e.jsxs("span", { className: "cn-9 fs-13 fw-4 lh-20 dc__mxw-200 dc__ellipsis-right dc__width-min-content", children: [
  t,
  !!s && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    " ",
    /* @__PURE__ */ e.jsx("span", { className: "cn-6", children: "—" }),
    " ",
    s
  ] })
] }), ga = (t) => /* @__PURE__ */ e.jsx(Ie, { content: t, interactive: !0, children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20 dc__truncate", children: t }) }), bn = (t, s) => {
  const n = pa[t];
  return s === ht || n?.every((a) => !kx[a]);
}, Po = (t) => {
  switch (t) {
    case jt.INHERITING_DEFAULT_PLATFORM:
      return `Inheriting ${ht}`;
    case jt.INHERITING_PROFILE:
      return `Inheriting ${ft}`;
    case jt.PARTIAL_INHERITING:
      return "Partially Inheriting";
    default:
      return "Overridden";
  }
}, Ff = (t, s, n) => bn(s, n) ? t.isOverridden ? t.canOverride ? "Overridden" : "Created" : `Inheriting ${ft}` : Po(jt.INHERITING_DEFAULT_PLATFORM), Uf = (t, s, n) => {
  switch (s) {
    case ue.BUILD_TIMEOUT: {
      const a = On(t[bt.BUILD_TIMEOUT]);
      return [{
        [Nt.TIME]: {
          data: ga(a ? `${a.value} ${a.unit}` : "--"),
          id: Yt()
        }
      }];
    }
    case ue.CPU:
    case ue.MEMORY: {
      const a = Df[s], r = On(t[a.request]), o = On(t[a.limit]);
      return [{
        [Nt.REQUEST]: {
          data: ga(r ? `${r.value} ${r.unit}` : "--"),
          id: Yt()
        },
        [Nt.LIMIT]: {
          data: ga(o ? `${o.value} ${o.unit}` : "--"),
          id: Yt()
        }
      }];
    }
    case ue.NODE_SELECTOR: {
      const a = On(t[bt.NODE_SELECTOR]);
      return a.key !== bt.NODE_SELECTOR ? [] : a.value.map((r) => ({
        [Nt.KEY]: {
          data: ga(r.key || "--"),
          id: Yt()
        },
        [Nt.VALUE]: {
          data: ga(r.value || "--"),
          id: Yt()
        }
      }));
    }
    case ue.TOLERANCE: {
      const a = On(t[bt.TOLERANCE]);
      return a.key !== bt.TOLERANCE ? [] : a.value.map((r) => ({
        [Nt.KEY]: {
          data: ga(r.key || "--"),
          id: Yt()
        },
        [Nt.OPERATOR]: {
          data: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: r.operator ? aS[r.operator] : "--" }),
          id: Yt()
        },
        [Nt.VALUE]: {
          data: ga(r.value || "--"),
          id: Yt()
        },
        [Nt.EFFECTS]: {
          data: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: r.effect ? rS[r.effect] : "--" }),
          id: Yt()
        }
      }));
    }
    case ue.CONFIG_MAP:
    case ue.SECRET: {
      const a = s === ue.CONFIG_MAP ? Nt.CM : Nt.CS, o = pa[s].find((c) => t[c]);
      if (!o)
        return [
          {
            [a]: {
              id: Yt(),
              data: "No data found"
            }
          }
        ];
      const i = On(
        t[o]
      );
      return [
        {
          [a]: {
            id: Yt(),
            data: /* @__PURE__ */ e.jsxs("div", { className: "dc__grid build-infra__configuration-details-block dc__column-gap-12", children: [
              /* @__PURE__ */ e.jsx("div", { className: "flex dc__no-shrink w-20", children: /* @__PURE__ */ e.jsx("div", { className: "bcn-1 h-100 w-1" }) }),
              /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-16", children: i?.value?.length ? i.value.map((c) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
                /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-6 dc__align-items-center", children: [
                  /* @__PURE__ */ e.jsx(Ab, { className: "icon-dim-16 dc__no-shrink" }),
                  /* @__PURE__ */ e.jsx(Ie, { content: c.useFormProps.name, children: /* @__PURE__ */ e.jsx("h5", { className: "m-0 cn-7 fs-13 fw-6 lh-20 dc__truncate", children: c.useFormProps.name }) }),
                  /* @__PURE__ */ e.jsxs("span", { className: "cn-7 fs-13 fw-4 lh-20", children: [
                    "(",
                    Ff(
                      c,
                      s,
                      n
                    ),
                    ")"
                  ] })
                ] }),
                /* @__PURE__ */ e.jsx(
                  jm,
                  {
                    componentType: Bi[o],
                    isJob: !0,
                    configMapSecretData: c.initialResponse,
                    cmSecretStateLabel: Om.BASE,
                    areScopeVariablesResolving: !1,
                    fallbackMergeStrategy: null,
                    displayKeys: !0,
                    containerClassName: "h-100 flexbox-col dc__gap-4",
                    hideCodeEditor: !0,
                    isBorderLess: !0
                  }
                )
              ] }, c.id)) : "No data available" })
            ] })
          }
        }
      ];
    }
    default:
      return null;
  }
}, lS = ({
  configState: t,
  isSupportedByBuildX: s
}) => s ? t === pc.PARTIALLY_INHERITING ? jt.PARTIAL_INHERITING : t === pc.INHERITING_GLOBAL_PROFILE ? jt.INHERITING_PROFILE : jt.OVERRIDDEN : jt.INHERITING_DEFAULT_PLATFORM, cS = ({
  locator: t,
  configTypeMap: s,
  configState: n,
  targetPlatform: a,
  defaultConfigTypeMap: r
}) => {
  const o = pa[t], i = bn(t, a), l = i ? s : r, c = o?.find((u) => l[u]), d = l[c];
  if (!d)
    return ka(new Error(`Null data value received for ${t} in 'getPresentationalConfigDataMap'`)), {
      profileName: "",
      inheritingStatusType: jt.OVERRIDDEN,
      valueInfoText: Nl("--")
    };
  const { profileName: p } = d, m = {
    profileName: p,
    inheritingStatusType: lS({
      configState: n || d.configState,
      isSupportedByBuildX: i
    })
  };
  switch (t) {
    case ue.BUILD_TIMEOUT: {
      if (d.key !== bt.BUILD_TIMEOUT)
        return null;
      const u = On(d);
      return {
        ...m,
        valueInfoText: Nl(u ? `${u.value} ${u.unit}` : "--")
      };
    }
    case ue.CPU:
    case ue.MEMORY: {
      const u = Df[t], f = l[u.request], _ = l[u.limit], h = f.key !== bt.CPU_REQUEST && f.key !== bt.MEMORY_REQUEST, x = _.key !== bt.CPU_LIMIT && _.key !== bt.MEMORY_LIMIT;
      if (h || x)
        return null;
      const g = On(f), E = On(_);
      return {
        ...m,
        valueInfoText: Nl(
          g ? `${g.value} ${g.unit}` : "--",
          E ? `${E.value} ${E.unit}` : "--"
        )
      };
    }
    case ue.TOLERANCE:
    case ue.NODE_SELECTOR:
    case ue.CONFIG_MAP:
    case ue.SECRET:
      return {
        ...m,
        valueInfoText: Eo(d.count || 0)
      };
    default:
      throw new Error(Cs.getInvalidLocatorMessage(t));
  }
}, Gf = ({
  configurationList: t
}) => (t || []).reduce(
  (s, n) => (s[n.key] = structuredClone(n), s),
  {}
), dS = ({
  configurationList: t,
  platformName: s,
  defaultConfigurationMap: n
}) => {
  const a = Gf({ configurationList: t });
  return Ha.reduce((r, o) => (r[o] = cS({
    locator: o,
    configTypeMap: a,
    targetPlatform: s,
    defaultConfigTypeMap: n
  }), r), {});
}, Bf = (t) => {
  const s = t?.name || "--", n = Gf({
    configurationList: t?.configurations?.[ht] || []
  }), a = Object.entries(t?.configurations || {}).reduce((r, [o, i]) => (r[o] = dS({
    configurationList: i,
    platformName: o,
    defaultConfigurationMap: n
  }), r), {});
  return {
    id: t?.id,
    name: s,
    useK8sDriver: Fx(t?.buildxDriverType),
    type: t?.type || Pa.NORMAL,
    appCount: t?.appCount || 0,
    platformToConfigurationsMap: a
  };
}, pS = (t) => {
  const s = Bf(t.profile);
  return {
    id: t.id,
    name: t.name,
    profile: s
  };
}, $f = (t, s) => !!pa[t]?.every(
  (n) => !s?.[n]?.active
), uS = (t, s) => !!pa[t]?.every((n) => !s[n]), Vf = (t) => /* @__PURE__ */ e.jsx(ed, { className: `scn-6 dc__no-shrink ${t}` }), wo = (t, s) => t ? Vf(s) : /* @__PURE__ */ e.jsx(m_, { className: `dc__no-shrink scn-6 ${s}` }), Yf = (t, s) => {
  const n = "icon-dim-12 dc__no-shrink";
  if (t === jt.INHERITING_DEFAULT_PLATFORM)
    return /* @__PURE__ */ e.jsx(bi, { className: `${n} fcn-6` });
  if (s)
    return Vf(n);
  switch (t) {
    case jt.PARTIAL_INHERITING:
    case jt.INHERITING_PROFILE:
      return /* @__PURE__ */ e.jsx(bi, { className: `${n} fcn-6` });
    default:
      return /* @__PURE__ */ e.jsx(Sb, { className: `${n} scn-6` });
  }
}, mS = (t) => ({
  targetPlatform: t.get("targetPlatform")?.toLowerCase() || ht
}), Pd = (t, s) => Ha.reduce(
  (n, a) => {
    if (!bn(a, t))
      return n[a] = {
        inheritingStatusType: jt.INHERITING_DEFAULT_PLATFORM
      }, n;
    const o = pa[a];
    if (o.some(
      (c) => Ux[c]
    )) {
      const c = o.some(
        (p) => s[p].value?.some(
          (m) => m.isOverridden
        )
      ), d = o.every(
        (p) => s[p].value?.every(
          (m) => m.isOverridden
        )
      );
      return n[a] = {
        // eslint-disable-next-line no-nested-ternary
        inheritingStatusType: c ? jt.PARTIAL_INHERITING : d ? jt.OVERRIDDEN : jt.INHERITING_PROFILE
      }, n;
    }
    const l = !$f(a, s);
    return n[a] = {
      inheritingStatusType: l ? jt.OVERRIDDEN : jt.INHERITING_PROFILE
    }, n;
  },
  {}
), uc = (t) => pa[t].find(Gx), _S = (t, s) => pa[t].find((a) => !!s[a]), Hf = ({
  sourcePlatform: t,
  doesPlatformExistsInGlobalProfile: s,
  targetPlatform: n
}) => t || s ? n : ht, fS = (t, s) => t === ht || s, hS = (t) => {
  const s = t.get(yi.CONFIGURATION_TYPE);
  return {
    configurationType: Ha.includes(s) ? s : Mf
  };
}, gS = async ({
  abortControllerRef: t
}) => {
  try {
    const { result: s } = await le(
      `${ra()}/${$.API_LIST_SUFFIX}`,
      { abortControllerRef: t }
    );
    return s.profiles?.map(Bf).sort((n, a) => n.name === ft ? -1 : a.name === ft ? 1 : Ce(n.name, a.name)) ?? [];
  } catch (s) {
    throw Pe(s) || V(s), s;
  }
}, xS = async (t) => {
  try {
    const s = { name: t };
    return await Js(ye(ra(), s));
  } catch (s) {
    throw V(s), s;
  }
}, ES = async ({
  abortControllerRef: t
}) => {
  try {
    const { result: s } = await le(
      `${ra()}/${$.API_LIST_SUFFIX}/${$.MIN}`,
      { abortControllerRef: t }
    );
    return s;
  } catch (s) {
    throw Pe(s) || V(s), s;
  }
}, Kf = async () => {
  const { result: t } = await le($.INFRA_CONFIG_LIST_MIN_PLATFORMS);
  return t?.platforms?.filter((s) => s !== ht).sort(Ce) || [];
}, CS = ({ savedProfileName: t, name: s, description: n }) => na(ra(), {
  profileName: t,
  queries: [
    {
      op: Fn.replace,
      path: Cr.PROFILE,
      value: {
        profileName: s,
        profileDescription: n
      }
    }
  ]
}), bS = async ({ name: t, description: s }) => Bx({
  name: t,
  description: s,
  type: Pa.NORMAL,
  configurations: {
    [ht]: []
  }
}), Wf = ({
  name: t,
  description: s,
  isEditView: n,
  handleCloseModal: a,
  handleReloadData: r
}) => {
  const o = Te(), [i, l] = v(!1), [c, d] = v({
    name: t || "",
    description: s || ""
  }), [p, m] = v({
    name: n ? null : "",
    description: null
  }), u = Object.keys(p).some(
    (x) => !Ht(p[x])
  ), f = async () => {
    if (u) {
      Z.showToast({
        variant: ee.error,
        description: "Please resolve all the errors before saving"
      });
      return;
    }
    try {
      if (l(!0), n) {
        await CS({
          savedProfileName: t,
          name: c.name,
          description: c.description
        });
        const x = t !== c.name;
        o.push(`${Ee.APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA_PROFILE_EDIT}/${c.name}`), x || r();
      } else
        await bS({
          name: c.name,
          description: c.description
        }), r();
      Z.showToast({
        variant: ee.success,
        description: `Profile is ${n ? "updated" : "created"}`
      }), a();
    } catch (x) {
      V(x);
    } finally {
      l(!1);
    }
  }, _ = (x) => {
    const { value: g } = x.target;
    d((C) => ({
      ...C,
      name: g
    }));
    const E = Tn(g).message || (g === ft ? `${ft} is reserved` : null);
    m((C) => ({
      ...C,
      name: E
    }));
  }, h = (x) => {
    const { value: g } = x.target;
    d((E) => ({
      ...E,
      description: g
    })), m((E) => ({
      ...E,
      description: dn(g).message
    }));
  };
  return /* @__PURE__ */ e.jsx($t, { position: "top", onEscape: a, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "flexbox-col h-100 dc__overflow-auto w-600 bg__primary br-4 mt-40 dc__m-auto",
      onClick: Le,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__border-bottom-n1 px-20 py-16 dc__content-space", children: [
          /* @__PURE__ */ e.jsx("h2", { className: "m-0 cn-9 fs-16 fw-6 lh-24", children: n ? `Edit ${t}` : "Create new profile" }),
          /* @__PURE__ */ e.jsx(
            j,
            {
              icon: /* @__PURE__ */ e.jsx(vt, {}),
              onClick: a,
              size: O.xs,
              ariaLabel: "Close Modal",
              dataTestId: "close-modal-btn-in-header",
              showAriaLabelInTippy: !1,
              variant: w.borderLess,
              style: B.negativeGrey
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 p-20 w-100", children: [
          /* @__PURE__ */ e.jsx(
            $x,
            {
              currentValue: c.name,
              error: p.name,
              onChange: _
            }
          ),
          /* @__PURE__ */ e.jsx(
            Vx,
            {
              currentValue: c.description,
              error: p.description,
              onChange: h
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "w-100 py-16 px-20 flexbox dc__content-end dc__gap-12 dc__border-top-n1", children: [
          /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: "close-modal-btn-in-footer",
              text: "Cancel",
              onClick: a,
              size: O.large,
              variant: w.secondary,
              style: B.neutral
            }
          ),
          /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: "save-profile-btn",
              text: n ? "Save" : "Create",
              isLoading: i,
              disabled: u,
              size: O.large,
              onClick: f
            }
          )
        ] })
      ]
    }
  ) });
}, wd = ({ size: t = O.small, handleSuccess: s }) => {
  const [n, a] = v(!1), r = () => {
    ct.event({
      category: "global-config__build-infra",
      action: "global-build-infra__create-profile-button-clicked"
    }), a(!0);
  }, o = () => {
    a(!1);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: ja.CREATE_PROFILE_TEST_ID,
        startIcon: /* @__PURE__ */ e.jsx(Xt, {}),
        text: Ks.CREATE_PROFILE_BUTTON,
        size: t,
        onClick: r
      }
    ),
    n && /* @__PURE__ */ e.jsx(
      Wf,
      {
        handleCloseModal: o,
        handleReloadData: s
      }
    )
  ] });
}, qf = jc({
  loadingProfiles: !0,
  profileOptions: [],
  currentProfile: null,
  setCurrentProfile: Be,
  reloadProfileOptions: Be
}), il = () => {
  const t = Oc(qf);
  if (!t)
    throw new Error(Cs.SELECT_PROFILE_PROVIDER_ERROR);
  return t;
}, NS = ({ children: t }) => {
  const s = de(new AbortController()), [n, a, r, o] = ne(
    () => ES({ abortControllerRef: s })
  ), [i, l] = v(null), c = Q(() => a ? a.filter((p) => p !== i).map((p) => ({
    label: p,
    value: p,
    startIcon: wo(p === ft, "icon-dim-12")
  })) : [], [a, i]), d = Q(
    () => ({
      loadingProfiles: n || Pe(r),
      reloadProfileOptions: o,
      currentProfile: i,
      setCurrentProfile: l,
      profileOptions: c
    }),
    [n, o, i, l, c]
  );
  return /* @__PURE__ */ e.jsx(qf.Provider, { value: d, children: t });
}, ke = {
  PROFILE_FILTER_PLACEHOLDER: "Profile",
  SEARCH_APPLICATIONS_PLACEHOLDER: "Search application",
  NO_OVERRIDDEN_APPLICATIONS: {
    title: "No applications are overridden",
    subTitle: "Create a profile with desired build infra configurations and apply them to applications individually or in bulk"
  },
  NO_APPLICATIONS_CREATED: {
    title: "No applications found",
    subTitle: "Please create an application to apply build infra configurations."
  },
  CLEAR_APPLICATIONS_SEARCH_LABEL: "Clear search",
  CLEAR_SELECTIONS_WARNING: "Selections on other pages are cleared",
  SELECTED_COUNT_SUFFIX: "Selected",
  CLEAR_BULK_SELECTION: "Clear bulk selection",
  BULK_CONFIRMATION_WARNING: "Are you sure to change?",
  BULK_CONFIRMATION_CANCEL: "Cancel",
  BULK_CONFIRMATION_APPLY: "Change",
  getBulkConfirmationTitle: (t) => `Change Profile to '${t}'`,
  getBulkConfirmationSubTitle: (t, s) => `${s || "Selected application(s)"} will start using '${t}' profile.`,
  CHANGE_PROFILE_SELECT_PLACEHOLDER: "Change Profile",
  CLEAR_CONFIRMATION_DIALOG_TOAST: "All previous selections are cleared",
  CLEAR_CONFIRMATION_TITLE: {
    SELECT_ALL: "Previous selection will be cleared",
    CLEAR_ALL: "Selections across all pages will be cleared"
  },
  CLEAR_CONFIRMATION_SUB_TITLE: {
    SELECT_ALL: "Selecting all items across pages will clear previous selections.",
    CLEAR_ALL: "Searching or applying a filter will clear selections across all pages."
  },
  CLEAR_CONFIRMATION_CANCEL: "Cancel",
  CLEAR_CONFIRMATION_APPLY: {
    SELECT_ALL: "Clear previous & select",
    CLEAR_ALL: "Clear selections & continue"
  },
  CLEAR_CONFIRMATION_ERROR: "Invalid action",
  BULK_SELECT_MENU_LIST_TITLE: "Profiles",
  BULK_SELECT_MENU_LIST_CREATE_PROFILE: "Create Profile",
  BULK_SELECT_MENU_LIST_REFRESH_LABEL: "Refresh Profiles",
  CLEAR_SELECTION_LABEL: "Clear Selection",
  getBulkApplySuccessToast: (t, s) => `Profile is changed to '${s}' profile for '${t}' applications`,
  getApplicationProfileChangeToast: (t, s) => `Profile is changed to '${s}' for '${t}' application`
}, wa = {
  SEARCH_APPLICATIONS: "application-search-bar",
  CLEAR_SEARCH_APPLICATIONS: "clear-application-search",
  CLEAR_BULK_SELECTION: "clear-bulk-selection",
  SELECTED_APPLICATIONS_COUNT: "selected-applications-count",
  BULK_SELECT_MENU_LIST_CREATE_PROFILE: "create-profile",
  BULK_SELECT_MENU_LIST_REFRESH: "refresh-profiles",
  CLEAR_SELECTION_INDICATOR: "clear-selection-indicator"
}, Dd = "Mixed", zf = 20, TS = 0, ll = {
  SELECTOR_CLASS_NAME: "build-infra"
}, Tl = [
  { value: 20, selected: !0 },
  { value: 40, selected: !1 },
  { value: 50, selected: !1 }
], IS = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__align-items-center h-100 w-100 p-8 dc__gap-8", children: [
  /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100 h-20" }),
  /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100 h-20" }),
  /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100 h-20" }),
  /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100 h-20" })
] }), vS = (t) => {
  const { loadingProfiles: s, reloadProfileOptions: n, currentProfile: a } = il();
  return /* @__PURE__ */ e.jsx(nd.MenuList, { ...t, children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col mxh-250", children: [
    /* @__PURE__ */ e.jsxs("div", { children: [
      a === Dd && /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8 pt-6 pb-6 pl-8 pr-8 bcb-1", children: [
        /* @__PURE__ */ e.jsx("div", { className: "flex", children: /* @__PURE__ */ e.jsx(qs, { className: "icon-dim-16 scb-5" }) }),
        /* @__PURE__ */ e.jsx("span", { className: "m-0 cb-5 fs-13 fw-6 lh-20 dc__ellipsis-right", children: a })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center pt-4 pb-4 pl-8 pr-8 dc__gap-12 bcn-1 dc__content-space", children: [
        /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-12 fw-6 lh-20 flex-grow-1", children: ke.BULK_SELECT_MENU_LIST_TITLE }),
        !s && /* @__PURE__ */ e.jsx(
          "button",
          {
            type: "button",
            onClick: n,
            className: "dc__no-border dc__outline-none-imp p-0 flex",
            "aria-label": ke.BULK_SELECT_MENU_LIST_REFRESH_LABEL,
            "data-testid": wa.BULK_SELECT_MENU_LIST_REFRESH,
            children: /* @__PURE__ */ e.jsx(jb, { className: "icon-dim-16" })
          }
        )
      ] }),
      s ? /* @__PURE__ */ e.jsx(IS, {}) : (
        // eslint-disable-next-line react/destructuring-assignment
        /* @__PURE__ */ e.jsx("div", { className: "pt-4 pb-4 dc__overflow-auto", children: t.children })
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center pt-4 dc__no-top-radius dc__border-top-n1--important dc__react-select__bottom bg__primary", children: /* @__PURE__ */ e.jsxs(
      wt,
      {
        className: "flexbox dc__align-items-center cursor dc__gap-8 cb-5 fs-13 fw-4 dc__no-decor pr-8 pl-8 pb-6 pt-6 dc__gap-8 bg__primary w-100 dc__no-border dc__outline-none-imp dc__hover-n50",
        target: "_blank",
        rel: "noopener noreferrer",
        to: Ee.APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA_PROFILE_CREATE,
        children: [
          /* @__PURE__ */ e.jsx(Xt, { className: "icon-dim-16 fcb-5" }),
          ke.BULK_SELECT_MENU_LIST_CREATE_PROFILE
        ]
      }
    ) })
  ] }) });
};
var Et = /* @__PURE__ */ ((t) => (t.SELECT_ALL = "SELECT_ALL", t.CLEAR_ALL = "CLEAR_ALL", t.APPLY = "APPLY", t))(Et || {});
const AS = ({
  profileName: t,
  rootClassName: s = "",
  iconClass: n,
  fontSizeClass: a
}) => /* @__PURE__ */ e.jsxs("div", { className: s, children: [
  wo(t === ft, `${n || "icon-dim-12"} dc__no-shrink`),
  /* @__PURE__ */ e.jsx(Ie, { content: t, children: /* @__PURE__ */ e.jsx("p", { className: `m-0 ${a || "fs-12"} dc__truncate`, children: t }) })
] }), SS = () => Rm({
  control: (t, s) => ({
    ...t,
    padding: "5px 8x 5px 8px",
    color: "var(--N700)",
    borderRadius: "4px",
    background: "var(--bg-primary)",
    border: "1px solid var(--N200)",
    height: "28px",
    minHeight: "28px",
    cursor: s.isDisabled ? "not-allowed !important" : "pointer",
    opacity: s.isDisabled ? 0.5 : 1,
    maxWidth: "142px"
  }),
  option: (t, s) => ({
    ...t,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    cursor: "pointer",
    ...s.isFocused ? {
      backgroundColor: "var(--bg-secondary)"
    } : {},
    ...s.isSelected && {
      backgroundColor: "var(--B100)",
      fontWeight: 600,
      color: "var(--B500)"
    },
    "&:active": {
      backgroundColor: "var(--bg-secondary)"
    }
  })
}), yS = () => Rm({
  menuPortal: (t) => ({
    ...t,
    zIndex: 9999
  }),
  control: () => ({
    border: "none",
    minHeight: "20px",
    display: "grid",
    gridTemplateColumns: "auto 20px",
    justifyContent: "flex-start",
    gap: "4px",
    alignItems: "center",
    cursor: "pointer"
  }),
  valueContainer: (t) => ({
    ...t,
    padding: 0,
    margin: 0,
    color: "var(--N700)",
    fontSize: "12px",
    fontWeight: "400"
  }),
  option: (t, s) => ({
    ...t,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    cursor: "pointer",
    ...s.isFocused ? {
      backgroundColor: "var(--bg-secondary)"
    } : {},
    ...s.isSelected && {
      backgroundColor: "var(--B100)",
      fontWeight: 600,
      color: "var(--B500)"
    },
    "&:active": {
      backgroundColor: "var(--bg-secondary)"
    }
  }),
  singleValue: (t) => ({
    ...t,
    padding: 0,
    margin: 0,
    color: "var(--N700)",
    fontSize: "12px",
    fontWeight: "400"
  }),
  input: (t) => ({
    ...t,
    padding: 0,
    margin: 0
  }),
  dropdownIndicator: (t, s) => ({
    ...t,
    transition: "all .2s ease",
    transform: s.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
    padding: 0
  })
}), LS = (t) => {
  const {
    data: { label: s },
    isSelected: n
  } = t;
  return /* @__PURE__ */ e.jsx(nd.Option, { ...t, children: /* @__PURE__ */ e.jsx("div", { className: "w-100", children: /* @__PURE__ */ e.jsx(
    AS,
    {
      profileName: s,
      iconClass: "icon-dim-16",
      fontSizeClass: "fs-13",
      rootClassName: `flexbox dc__align-items-center dc__gap-8 ${n ? "fw-6 cb-5 scb-5" : "cn-7 fw-4"}`
    }
  ) }) });
}, jS = (t) => {
  const {
    selectProps: { placeholder: s, inputValue: n },
    children: a
  } = t;
  return /* @__PURE__ */ e.jsxs(nd.ValueContainer, { ...t, children: [
    !n && /* @__PURE__ */ e.jsx("span", { className: "pl-10 dc__position-abs flex", children: s }),
    dx.cloneElement(a[1])
  ] });
}, zp = (t, s) => {
  if (!t)
    return s;
  const n = Number(t);
  return Number.isNaN(n) ? s : n;
}, OS = (t) => {
  const { profileName: s, search: n, offset: a, size: r, targetPlatform: o } = t, i = zp(r, zf), l = Tl.find((c) => c.value === i) ? [...Tl] : [{ value: i, selected: !0 }, ...Tl];
  return {
    // Adding '' since not pushing it in history even if '', and it avoids undefined
    profileName: s ?? "",
    targetPlatform: o?.toLowerCase() || ht,
    search: n ?? "",
    pageSizeOptions: l,
    offset: zp(a, TS),
    size: i,
    isContentFiltered: !!n || !!s
  };
}, RS = (t) => t === Dd ? null : t, PS = () => `${$.INFRA_CONFIG_IDENTIFIER}/${Yx}`, Xf = ({
  selectStyles: t,
  // In case of single select we will not send state rather we will send the single selected identifier
  selectedIdentifiers: s,
  setCurrentSelectDropdownId: n,
  currentIdentifierId: a,
  currentIdentifierName: r,
  isMenuPositionFixed: o,
  setShowSelectionDialog: i,
  currentProfileName: l,
  loadingIdentifierResponse: c,
  parentClassName: d = ""
}) => {
  const { profileOptions: p, setCurrentProfile: m, currentProfile: u } = il(), f = Object.keys(s), _ = () => {
    if (n?.(a), s[us]) {
      m(null);
      return;
    }
    const b = s[f[0]].profile.name;
    if (f.some(
      (I) => s[I].profile.name !== b
    )) {
      m(Dd);
      return;
    }
    m(b);
  }, h = () => {
    m(null), n?.(null);
  }, x = (b) => {
    i({
      profileName: b.label,
      type: Et.APPLY,
      identifierName: r
    });
  }, g = l || RS(u), E = g ? { label: g, value: g } : null, C = E ? [E, ...p] : p;
  return /* @__PURE__ */ e.jsx(
    sd,
    {
      options: C,
      placeholder: ke.CHANGE_PROFILE_SELECT_PLACEHOLDER,
      value: E,
      menuPosition: o ? "fixed" : null,
      menuPlacement: "auto",
      components: {
        IndicatorSeparator: null,
        MenuList: vS,
        Option: LS,
        // Showing Custom ValueContainer to show the placeholder in case of currentProfileName is not present
        ...l ? {} : { ValueContainer: jS }
      },
      styles: t(),
      className: `mw-140 ${d}`,
      classNamePrefix: wf,
      onMenuOpen: _,
      onMenuClose: h,
      onChange: x,
      isDisabled: c
    }
  );
}, wS = ({
  totalSelectedCount: t,
  setShowSelectionDialog: s,
  loadingIdentifierResponse: n
}) => {
  const { handleBulkSelection: a, selectedIdentifiers: r } = It(), o = () => {
    a({
      action: st.CLEAR_ALL_SELECTIONS
    });
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8", children: [
      /* @__PURE__ */ e.jsx(Fi, { dragClassName: ll.SELECTOR_CLASS_NAME }),
      /* @__PURE__ */ e.jsx(
        "span",
        {
          className: "pt-0 pb-0 pl-6 pr-6 br-4 bcb-5 m-0 cn-0",
          "data-testid": wa.SELECTED_APPLICATIONS_COUNT,
          children: t
        }
      ),
      /* @__PURE__ */ e.jsx("strong", { className: "m-0 cn-9 fs-13 fw-6 lh-20", children: ke.SELECTED_COUNT_SUFFIX })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "h-20 dc__border-left" }),
    /* @__PURE__ */ e.jsx(
      Xf,
      {
        selectStyles: SS,
        selectedIdentifiers: r,
        setShowSelectionDialog: s,
        loadingIdentifierResponse: n,
        parentClassName: "h-28"
      }
    ),
    /* @__PURE__ */ e.jsx("div", { className: "h-20 dc__border-left" }),
    /* @__PURE__ */ e.jsx(
      "button",
      {
        type: "button",
        className: "dc__no-background flex dc__no-border dc__outline-none-imp dc__tab-focus scn-6",
        "aria-label": ke.CLEAR_BULK_SELECTION,
        "data-testid": wa.CLEAR_BULK_SELECTION,
        onClick: o,
        children: /* @__PURE__ */ e.jsx(ua, { className: "icon-dim-16" })
      }
    )
  ] });
}, DS = ({
  showSelectionDialog: t,
  setShowSelectionDialog: s,
  totalIdentifierCount: n,
  parentRef: a,
  loadingIdentifierResponse: r
}) => {
  const { selectedIdentifiers: o } = It(), i = Object.keys(o).length, l = o[us] ? n : i;
  return i === 0 || t ? null : (
    // TODO: Check combinations to minimize z-index
    /* @__PURE__ */ e.jsx(
      No,
      {
        zIndex: 15,
        positionVariant: To.PARENT_BOTTOM_CENTER,
        dragSelector: `.${ll.SELECTOR_CLASS_NAME}`,
        parentRef: a,
        children: /* @__PURE__ */ e.jsx("div", { className: "h-56 br-8 pt-12 pr-12 pb-12 pl-8 dc__gap-12 flexbox dc__align-items-center bulk-selection-widget", children: /* @__PURE__ */ e.jsx(
          wS,
          {
            totalSelectedCount: l,
            setShowSelectionDialog: s,
            loadingIdentifierResponse: r
          }
        ) })
      }
    )
  );
}, MS = async ({
  offset: t,
  size: s,
  profileName: n,
  search: a,
  abortControllerRef: r
}) => {
  try {
    const o = ye(
      `${PS()}/${$.API_LIST_SUFFIX}`,
      {
        offset: t,
        size: s,
        profileName: n,
        search: a
      }
    ), { result: i } = await le(o, { abortControllerRef: r }), { identifiers: l, totalIdentifierCount: c, isAnyIdentifierOverridden: d, globalPlatforms: p } = i ?? {};
    return {
      identifiers: l?.map((u) => pS(u)) ?? [],
      totalIdentifierCount: c,
      isAnyIdentifierOverridden: d,
      globalPlatformsMap: p?.reduce((u, f) => (u[f] = f, u), {}) || {}
    };
  } catch (o) {
    throw Pe(o) || V(o), o;
  }
}, kS = ({
  selectedIdentifiers: t,
  currentIdentifierName: s
}) => t[us] ? null : s ? [s] : Object.values(t).map((n) => n.name), FS = ({
  search: t,
  profileName: s,
  selectedIdentifiers: n,
  currentIdentifierName: a,
  updateToProfile: r
}) => n[us] ? {
  identifiersFilter: {
    search: t,
    profileName: s
  },
  identifiers: null,
  updateToProfile: r
} : {
  identifiersFilter: null,
  identifiers: kS({
    selectedIdentifiers: n,
    currentIdentifierName: a
  }),
  updateToProfile: r
}, US = async ({
  search: t,
  profileName: s,
  selectedIdentifiers: n,
  currentIdentifierName: a,
  updateToProfile: r
}) => {
  try {
    const o = FS({
      search: t,
      profileName: s,
      selectedIdentifiers: n,
      currentIdentifierName: a,
      updateToProfile: r
    });
    return await we($.INFRA_CONFIG_IDENTIFIER_APPLICATIONS_APPLY, o);
  } catch (o) {
    throw V(o), o;
  }
}, GS = ({
  setShowSelectionDialog: t,
  updateToProfile: s,
  handlePageReload: n,
  search: a,
  profileName: r,
  currentIdentifierName: o,
  totalIdentifierCount: i
}) => {
  const { selectedIdentifiers: l } = It(), [c, d] = v(!1), p = async () => {
    try {
      if (d(!0), await US({
        search: a,
        profileName: r,
        selectedIdentifiers: l,
        currentIdentifierName: o,
        updateToProfile: s
      }), o)
        Z.showToast({
          variant: ee.success,
          description: ke.getApplicationProfileChangeToast(
            o,
            s
          )
        });
      else {
        const u = l[us] ? i : Object.keys(l).length;
        Z.showToast({
          variant: ee.success,
          description: ke.getBulkApplySuccessToast(
            u,
            s
          )
        });
      }
      d(!1), t(null), n();
    } catch {
      d(!1);
    }
  }, m = () => {
    t(null);
  };
  return /* @__PURE__ */ e.jsx(
    zt,
    {
      variant: Ct.custom,
      Icon: /* @__PURE__ */ e.jsx(__, {}),
      title: ke.getBulkConfirmationTitle(s),
      handleClose: m,
      buttonConfig: {
        secondaryButtonConfig: {
          text: ke.BULK_CONFIRMATION_CANCEL,
          onClick: m,
          disabled: c
        },
        primaryButtonConfig: {
          text: ke.BULK_CONFIRMATION_APPLY,
          onClick: p,
          isLoading: c
        }
      },
      children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-20", children: [
        /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-9 fs-14 fw-4", children: ke.getBulkConfirmationSubTitle(
          s,
          o
        ) }),
        /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-9 fs-14 fw-4", children: ke.BULK_CONFIRMATION_WARNING })
      ] })
    }
  );
}, BS = ({
  handleFilters: t,
  profileName: s,
  identifierName: n,
  setShowSelectionDialog: a,
  originalProfileName: r,
  originalSearch: o,
  setProfileNameState: i,
  setSearchState: l,
  type: c
}) => {
  const { handleBulkSelection: d } = It(), p = () => {
    a(null), i(r), l(o);
  }, m = () => {
    if (Z.showToast({
      variant: ee.info,
      description: ke.CLEAR_CONFIRMATION_DIALOG_TOAST
    }), a(null), c === Et.CLEAR_ALL) {
      d({
        action: st.CLEAR_ALL_SELECTIONS
      }), t({ searchText: n, selectedProfileName: s });
      return;
    }
    d({
      action: st.CLEAR_SELECTIONS_AND_SELECT_ALL_ACROSS_PAGES
    });
  };
  return c !== Et.CLEAR_ALL && c !== Et.SELECT_ALL ? (Z.showToast({
    variant: ee.error,
    description: ke.CLEAR_CONFIRMATION_ERROR
  }), null) : /* @__PURE__ */ e.jsx(
    zt,
    {
      variant: Ct.custom,
      Icon: /* @__PURE__ */ e.jsx(f_, {}),
      title: c === Et.CLEAR_ALL ? ke.CLEAR_CONFIRMATION_TITLE.CLEAR_ALL : ke.CLEAR_CONFIRMATION_TITLE.SELECT_ALL,
      subtitle: c === Et.CLEAR_ALL ? ke.CLEAR_CONFIRMATION_SUB_TITLE.CLEAR_ALL : ke.CLEAR_CONFIRMATION_SUB_TITLE.SELECT_ALL,
      handleClose: p,
      buttonConfig: {
        secondaryButtonConfig: {
          text: ke.CLEAR_CONFIRMATION_CANCEL,
          onClick: p
        },
        primaryButtonConfig: {
          text: c === Et.CLEAR_ALL ? ke.CLEAR_CONFIRMATION_APPLY.CLEAR_ALL : ke.CLEAR_CONFIRMATION_APPLY.SELECT_ALL,
          onClick: m
        }
      }
    }
  );
}, $S = [
  {
    label: "KEY",
    key: wn.KEY,
    width: "200px"
  },
  {
    label: "VALUE",
    key: wn.VALUE,
    width: "1fr"
  }
], VS = [
  {
    label: "KEY",
    key: Jt.KEY,
    width: "200px"
  },
  {
    label: "OPERATOR",
    key: Jt.OPERATOR,
    width: "120px"
  },
  {
    label: "VALUE",
    key: Jt.VALUE,
    width: "248px"
  },
  {
    label: "EFFECT",
    key: Jt.EFFECT,
    width: "1fr"
  }
], YS = [
  {
    label: "Exists",
    value: fr.EXISTS
  },
  {
    label: "Equals",
    value: fr.EQUALS
  }
], HS = [
  {
    label: "NoExecute",
    value: cr.NO_EXECUTE
  },
  {
    label: "NoSchedule",
    value: cr.NO_SCHEDULE
  },
  {
    label: "PreferNoSchedule",
    value: cr.PREFER_NO_SCHEDULE
  }
], KS = Object.values(wn), WS = Object.values(Jt), qS = (t) => {
  const s = t.get(
    yi.TARGET_PLATFORM_FORM_TYPE
  );
  return {
    targetPlatformFormType: Object.values(mo).includes(s) ? s : null,
    targetPlatform: t.get(yi.TARGET_PLATFORM)?.toLowerCase() || "",
    ...hS(t)
  };
}, zS = (t, s = !1) => ({
  data: {
    [wn.KEY]: {
      value: t?.key || "",
      type: ut.TEXT,
      props: {
        placeholder: "Key",
        autoFocus: s
      }
    },
    [wn.VALUE]: {
      value: t?.value || "",
      type: ut.TEXT,
      props: {
        placeholder: "Enter value or variable"
      }
    }
  },
  id: t?.id || Yt()
}), XS = (t, s = !1) => ({
  data: {
    [Jt.KEY]: {
      value: t?.key || "",
      type: ut.TEXT,
      props: {
        placeholder: "Key",
        autoFocus: s
      }
    },
    [Jt.VALUE]: {
      value: t?.value || "",
      type: ut.TEXT,
      props: {
        placeholder: t?.operator === fr.EXISTS ? "Value not applicable" : "Enter value or variable"
      },
      disabled: t?.operator === fr.EXISTS
    },
    [Jt.OPERATOR]: {
      value: t?.operator || Hx,
      type: ut.DROPDOWN,
      props: {
        isClearable: !1,
        options: YS
      }
    },
    [Jt.EFFECT]: {
      value: t?.effect || Kx,
      type: ut.DROPDOWN,
      props: {
        isClearable: !1,
        options: HS,
        shouldMenuAlignRight: !0
      }
    }
  },
  id: t?.id || Yt()
}), JS = (t) => Object.keys(t || {}).sort((s, n) => s === ht ? -1 : n === ht ? 1 : Ce(s, n)), QS = (t) => `Use '${t}'`, Xp = ({
  isInheriting: t,
  configurationType: s,
  handleProfileInputChange: n,
  infraConfigWithSubValue: a,
  targetPlatform: r,
  selectedSubValueId: o
}) => {
  const i = () => {
    const l = Wx(s, t);
    if (qx[l]) {
      n({
        action: l,
        data: {
          targetPlatform: r,
          id: o,
          componentType: Bi[a]
        }
      });
      return;
    }
    n({
      action: l,
      data: {
        targetPlatform: r
      }
    });
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__align-items-center", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4", children: [
      /* @__PURE__ */ e.jsx(
        ca,
        {
          heading: `Inherit from ${ft} profile`,
          infoText: `${_r[s]} will be inherited from selected target platform of ${ft} profile.`,
          additionalContent: /* @__PURE__ */ e.jsxs("p", { className: "m-0 fs-13 fw-4 lh-20 pb-12 px-12", children: [
            "If the target platform is not defined in ",
            ft,
            "  profile, ",
            s,
            " configuration will be inherited from  ",
            ht,
            " configuration of ",
            ft,
            " profile."
          ] })
        }
      ),
      /* @__PURE__ */ e.jsx("span", { children: "Inherit" })
    ] }),
    /* @__PURE__ */ e.jsx(
      Gn,
      {
        name: `inherit-${s}-toggle`,
        ariaLabel: `Inherit ${s} toggle`,
        isChecked: t,
        onChange: i,
        shape: "square",
        variant: "theme",
        iconName: "ic-world-globe"
      }
    )
  ] });
}, ZS = ({
  configurationType: t,
  selectedSubValueId: s,
  targetPlatform: n,
  isGlobalProfile: a,
  handleProfileInputChange: r,
  handleClearSelectedSubValue: o,
  platformConfig: i
}) => {
  if (!bn(t, n))
    return null;
  const c = uc(t), d = () => {
    c && (r({
      action: Ys.DELETE_CM_CS_ITEM,
      data: {
        targetPlatform: n,
        id: s,
        componentType: Bi[c]
      }
    }), o());
  };
  if (c) {
    const p = i[c].value.find(
      (m) => m.id === s
    );
    return p ? p.canOverride ? /* @__PURE__ */ e.jsx(
      Xp,
      {
        isInheriting: !p.isOverridden,
        configurationType: t,
        handleProfileInputChange: r,
        infraConfigWithSubValue: c,
        targetPlatform: n,
        selectedSubValueId: s
      }
    ) : /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: `delete-${t}-sub-value`,
        ariaLabel: `Delete ${t} item`,
        size: O.xs,
        icon: /* @__PURE__ */ e.jsx(ts, {}),
        variant: w.borderLess,
        style: B.negative,
        onClick: d,
        showAriaLabelInTippy: !1
      }
    ) : null;
  }
  if (!a) {
    const p = i && $f(t, i);
    return /* @__PURE__ */ e.jsx(
      Xp,
      {
        isInheriting: p,
        configurationType: t,
        handleProfileInputChange: r,
        infraConfigWithSubValue: null,
        targetPlatform: n,
        selectedSubValueId: s
      }
    );
  }
  return null;
}, ey = ({ configurationType: t }) => /* @__PURE__ */ e.jsx(
  Ot,
  {
    heading: "Editing is not allowed",
    description: `${Rd[t]?.title || "Configuration"} for target platforms are inherited from the ${ht} configuration of respective profiles and cannot be modified.`
  }
), ty = ({
  componentType: t,
  value: s,
  handleProfileInputChange: n,
  targetPlatform: a,
  hasError: r
}) => {
  const { BuildInfraCMCSForm: o } = zx(), i = Pm({
    validations: Xx,
    initialValues: s.useFormProps,
    validationMode: "all",
    shouldValidateOnMount: r
  });
  return J(() => {
    n({
      action: Ys.SYNC_CM_CS_ITEM,
      data: {
        targetPlatform: a,
        id: s.id,
        componentType: t,
        hasError: Object.keys(i.getErrorsFromFormData(i.data) || {}).length > 0,
        value: i.data
      }
    });
  }, [i.data]), /* @__PURE__ */ e.jsx(o, { parsedData: s, useFormProps: i, componentType: t });
}, Wo = {
  [ue.NODE_SELECTOR]: {
    HEADING: "No node-selectors added",
    SUB_HEADING: "Node selectors will be applied to pods running the build process.",
    INHERITING_TEXT: `This configuration is inherited from the ${ft} profile.`,
    CTA_TEXT: "Add Node Selector"
  },
  [ue.TOLERANCE]: {
    HEADING: "No tolerations added",
    SUB_HEADING: "Tolerations will be applied to pods running the build process.",
    INHERITING_TEXT: `This configuration is inherited from the ${ft} profile.`,
    CTA_TEXT: "Add toleration"
  }
}, Jf = ({ isInheriting: t, handleAddItem: s, locator: n }) => /* @__PURE__ */ e.jsxs("div", { className: "bg__secondary br-4 p-20 flex column dc__gap-12 dc__border-dashed dc__align-center", children: [
  /* @__PURE__ */ e.jsx(qi, { className: "icon-dim-24 dc__no-shrink" }),
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
    /* @__PURE__ */ e.jsx("h6", { className: "m-0 cn-9 fs-13 fw-6 lh-20", children: Wo[n].HEADING }),
    /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-13 fw-4 lh-20", children: t ? Wo[n].INHERITING_TEXT : Wo[n].SUB_HEADING })
  ] }),
  !t && /* @__PURE__ */ e.jsx(
    j,
    {
      dataTestId: "add-item-button",
      text: Wo[n].CTA_TEXT,
      startIcon: /* @__PURE__ */ e.jsx(Xt, {}),
      variant: w.text,
      onClick: s,
      size: O.small
    }
  )
] }), sy = ({
  handleProfileInputChange: t,
  nodeSelectors: s,
  targetPlatform: n,
  isInheriting: a,
  profileInputErrors: r,
  isDisabled: o
}) => {
  const i = s.map(
    (m, u) => zS(m, u === 0 && !a && !!n)
  ), l = s.reduce(
    (m, u) => (m[u.id] = KS.reduce((f, _) => {
      const h = r[bt.NODE_SELECTOR]?.[u.id]?.[_];
      return f[_] = {
        isValid: !h,
        errorMessages: h?.length ? h : null
      }, f;
    }, {}), m),
    {}
  ), c = () => {
    t({
      action: Ys.ADD_NODE_SELECTOR_ITEM,
      data: {
        targetPlatform: n
      }
    });
  }, d = (m) => {
    t({
      action: Ys.DELETE_NODE_SELECTOR_ITEM,
      data: {
        targetPlatform: n,
        id: m.id
      }
    });
  }, p = (m, u, f) => {
    t({
      action: Ys.EDIT_NODE_SELECTOR_ITEM,
      data: {
        targetPlatform: n,
        id: m.id,
        key: u === wn.KEY ? f : m.data[wn.KEY].value,
        value: u === wn.VALUE ? f : m.data[wn.VALUE].value
      }
    });
  };
  return s.length ? /* @__PURE__ */ e.jsx(
    $i,
    {
      readOnly: o || a,
      headers: $S,
      rows: i,
      onRowAdd: c,
      onRowEdit: p,
      onRowDelete: d,
      cellError: l
    }
  ) : /* @__PURE__ */ e.jsx(
    Jf,
    {
      isInheriting: a,
      handleAddItem: c,
      locator: ue.NODE_SELECTOR
    }
  );
}, ny = ({
  handleProfileInputChange: t,
  targetPlatform: s,
  toleranceList: n,
  isInheriting: a,
  profileInputErrors: r,
  isDisabled: o
}) => {
  const i = n.map(
    (m, u) => XS(m, u === 0 && !a && !!s)
  ), l = n.reduce((m, u) => (m[u.id] = WS.reduce((f, _) => {
    const h = r[bt.TOLERANCE]?.[u.id]?.[_];
    return f[_] = {
      isValid: !h,
      errorMessages: h?.length ? h : null
    }, f;
  }, {}), m), {}), c = () => {
    t({
      action: Ys.ADD_TOLERANCE_ITEM,
      data: {
        targetPlatform: s
      }
    });
  }, d = (m) => {
    t({
      action: Ys.DELETE_TOLERANCE_ITEM,
      data: {
        targetPlatform: s,
        id: m.id
      }
    });
  }, p = (m, u, f) => {
    t({
      action: Ys.EDIT_TOLERANCE_ITEM,
      data: {
        targetPlatform: s,
        id: m.id,
        key: u === Jt.KEY ? f : m.data[Jt.KEY].value,
        value: u === Jt.VALUE ? f : m.data[Jt.VALUE].value,
        operator: u === Jt.OPERATOR ? f : m.data[Jt.OPERATOR].value,
        effect: u === Jt.EFFECT ? f : m.data[Jt.EFFECT].value
      }
    });
  };
  return n.length ? /* @__PURE__ */ e.jsx(
    $i,
    {
      readOnly: o || a,
      headers: VS,
      rows: i,
      onRowAdd: c,
      onRowEdit: p,
      onRowDelete: d,
      cellError: l
    }
  ) : /* @__PURE__ */ e.jsx(
    Jf,
    {
      handleAddItem: c,
      isInheriting: a,
      locator: ue.TOLERANCE
    }
  );
}, ay = ({
  handleProfileInputChange: t,
  configurationType: s,
  targetPlatform: n,
  profileInputErrors: a,
  appliedConfig: r,
  isSelectedConfigurationSupportedByPlatform: o,
  selectedSubValueId: i,
  isGlobalProfile: l,
  profileResponse: c
}) => {
  switch (s) {
    case ue.CPU:
    case ue.MEMORY:
    case ue.BUILD_TIMEOUT: {
      const d = Jx[s];
      return /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__gap-12", children: d.actions.map((p, m) => /* @__PURE__ */ e.jsx(
        Qx,
        {
          actionType: p.actionType,
          label: p.label,
          placeholder: p.placeholder,
          error: a[p.actionType],
          isRequired: l,
          profileUnitsMap: c.configurationUnits[p.actionType],
          handleProfileInputChange: t,
          currentUnitName: r[p.actionType].unit,
          currentValue: r[p.actionType].value,
          targetPlatform: n,
          isDisabled: !r[p.actionType].active || !o,
          autoFocus: m === 0 && !!n
        },
        p.actionType
      )) });
    }
    case ue.NODE_SELECTOR:
      return /* @__PURE__ */ e.jsx(
        sy,
        {
          handleProfileInputChange: t,
          nodeSelectors: r[bt.NODE_SELECTOR].value,
          targetPlatform: n,
          isInheriting: !r[bt.NODE_SELECTOR].active,
          profileInputErrors: a,
          isDisabled: !o
        }
      );
    case ue.TOLERANCE:
      return /* @__PURE__ */ e.jsx(
        ny,
        {
          handleProfileInputChange: t,
          targetPlatform: n,
          toleranceList: r[bt.TOLERANCE].value,
          isInheriting: !r[bt.TOLERANCE].active,
          profileInputErrors: a,
          isDisabled: !o
        }
      );
    case ue.CONFIG_MAP:
    case ue.SECRET: {
      const d = _S(s, r), p = r[s].value.find(
        (u) => u.id === i
      );
      if (!p)
        return /* @__PURE__ */ e.jsx(_e, { title: `No ${_r[s]} available` });
      const m = Bi[d];
      return !o || !p.isOverridden ? /* @__PURE__ */ e.jsx(
        jm,
        {
          componentType: m,
          isJob: !0,
          configMapSecretData: p.initialResponse,
          cmSecretStateLabel: Om.BASE,
          areScopeVariablesResolving: !1,
          fallbackMergeStrategy: null,
          containerClassName: "bg__primary h-100 flexbox-col dc__gap-12 dc__overflow-auto"
        }
      ) : /* @__PURE__ */ e.jsx(
        ty,
        {
          componentType: m,
          value: p,
          handleProfileInputChange: t,
          targetPlatform: n,
          hasError: a[d]?.[i]
        },
        i
      );
    }
    default:
      return null;
  }
}, ry = ({
  locator: t,
  targetPlatform: s,
  value: n,
  handleCreateItem: a,
  selectedItemId: r,
  handleSelectItem: o,
  selectedConfigurationType: i,
  errorMap: l
}) => {
  const [c, d] = v(!0), p = () => {
    d((g) => !g);
  }, m = (g) => g.useFormProps.name ? Ff(g, t, s) : null, u = (g) => () => {
    o(g, t);
  }, f = n?.map((g) => {
    const E = r === g.id && i === t;
    return {
      title: g.useFormProps.name || "Unnamed",
      subtitle: m(g),
      isActive: E,
      onClick: u(g.id),
      id: g.id,
      iconConfig: l?.[g.id] && !E ? {
        Icon: Va,
        props: {
          className: "icon-dim-16 alert-icon-r5-imp dc__no-svg-stroke mt-2"
        }
      } : null
    };
  }) || [], _ = _r[t], h = bn(t, s), x = [
    {
      header: `${_} (${Eo(n?.length || 0)})`,
      id: t,
      headerIconConfig: h ? {
        Icon: Xt,
        props: {
          className: "fcn-6"
        },
        btnProps: {
          onClick: a
        }
      } : null,
      items: f,
      noItemsText: `No ${_}`,
      isExpanded: c
    }
  ];
  return /* @__PURE__ */ e.jsx(Fc, { config: x, tabType: "button", onCollapseBtnClick: p });
}, oy = ({
  isGlobalProfile: t,
  configurationType: s,
  currentLocator: n,
  profileInputErrors: a,
  targetPlatform: r,
  currentPlatformConfig: o,
  isButton: i,
  handleButtonClick: l
}) => {
  const c = Ss(), d = new URLSearchParams(c.search), p = Pd(r, o), m = (E) => ye("", {
    ...Object.fromEntries(d.entries()),
    configurationType: E
  }), u = s === n, f = Lm[n], _ = p[n].inheritingStatusType, h = () => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
      f && /* @__PURE__ */ e.jsx(f, { className: "icon-dim-16 dc__no-shrink mt-2" }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
        /* @__PURE__ */ e.jsx("h6", { className: `m-0 fs-13 fw-4 lh-20 dc__align-left ${u ? "cb-5" : "cn-9"}`, children: Rd[n]?.title }),
        !t && /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-12 fw-4 lh-18 dc__align-left dc__truncate", children: Po(_) })
      ] })
    ] }),
    !uS(n, a) && !u && /* @__PURE__ */ e.jsx(Va, { className: "icon-dim-16 alert-icon-r5-imp dc__no-svg-stroke mt-2" })
  ] }), x = `target-platform-${n}`, g = `py-6 px-8 flexbox dc__gap-4 dc__content-space br-4 ${u ? "bcb-1 scb-5" : "scn-6 bg__primary dc__hover-n50"}`;
  return i ? /* @__PURE__ */ e.jsx(
    "button",
    {
      className: `${g} dc__transparent`,
      type: "button",
      onClick: l,
      "data-testid": x,
      children: h()
    },
    x
  ) : /* @__PURE__ */ e.jsx(
    wt,
    {
      "data-testid": x,
      className: `anchor ${g}`,
      to: {
        search: m(n)
      },
      children: h()
    },
    x
  );
}, iy = async ({
  profileInput: t,
  targetPlatform: s,
  isEditView: n,
  profileName: a
}) => {
  try {
    const {
      configurations: { [s]: r }
    } = Zx(t, !0);
    if (n) {
      const o = {
        profileName: a,
        platformName: s,
        queries: [
          {
            op: Fn.replace,
            path: Cr.PLATFORM,
            value: {
              platformName: s,
              configurations: r
            }
          }
        ]
      };
      await na(
        ra(),
        o
      );
    } else {
      const o = {
        profileName: a,
        queries: [
          {
            op: Fn.add,
            path: Cr.PLATFORM,
            value: {
              platformName: s,
              configurations: r
            }
          }
        ]
      };
      await na(
        ra(),
        o
      );
    }
    Z.showToast({
      variant: ee.success,
      description: `Target platform ${n ? "updated" : "added"} successfully`
    });
  } catch (r) {
    throw V(r), r;
  }
}, ly = ({
  savedProfileName: t,
  profileInput: s,
  isPlatformCreationMode: n,
  profileInputErrors: a,
  handleCancel: r,
  handleClose: o,
  handleSuccess: i,
  targetPlatform: l,
  areChangesPresent: c
}) => {
  const [d, p] = v(!1), m = Object.keys(eE).some(
    (f) => !Ht(a[f])
  ), u = async () => {
    p(!0);
    try {
      await iy({
        profileName: t,
        targetPlatform: l,
        profileInput: s,
        isEditView: !n
      }), i(), o(), p(!1);
    } catch {
      p(!1);
    }
  };
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `px-20 py-16 flexbox dc__gap-12 w-100 ${c ? "dc__content-space" : "dc__content-end"} dc__align-items-center dc__no-shrink dc__border-top`,
      children: [
        c && /* @__PURE__ */ e.jsx(tE, {}),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12", children: [
          /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: "cancel-target-platform-changes",
              text: "Cancel",
              style: B.neutral,
              variant: w.secondary,
              size: O.large,
              onClick: r
            }
          ),
          /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: "save-target-platform-changes",
              text: "Save",
              size: O.large,
              onClick: u,
              isLoading: d,
              disabled: m || d,
              showTooltip: m,
              tooltipProps: {
                content: "Please resolve the errors before saving the changes"
              }
            }
          )
        ] })
      ]
    }
  );
}, Jp = (t) => {
  t?.forEach((s) => {
    delete s?.useFormProps?.yamlMode;
  });
}, Qp = (t) => {
  if (!t?.configurations)
    return t;
  const s = structuredClone(t);
  return Object.values(s.configurations).forEach((n) => {
    const a = n[bt.CONFIG_MAP]?.value, r = n[bt.SECRET]?.value;
    Jp(a), Jp(r);
  }), s;
}, Qf = ({
  configurationType: t,
  targetPlatform: s,
  handleClose: n,
  savedProfileName: a,
  profileInput: r,
  handleProfileInputChange: o,
  handleUpdateTargetPlatformParams: i,
  profileInputErrors: l,
  profileResponse: c,
  handleUpdateConfigurationType: d,
  handleSuccess: p,
  showSidebarLinkAsButton: m,
  isPlatformCreationMode: u,
  allTargetPlatformList: f,
  isLoadingAllTargetPlatformList: _,
  allTargetPlatformListError: h,
  reloadAllTargetPlatformList: x
}) => {
  const [g, E] = v(null), [C, b] = v(!1), N = de(structuredClone(r)), I = de(structuredClone(r)), T = Ss(), A = Q(
    () => !sE(
      Qp(r),
      Qp(u ? I.current : c?.profile)
    ),
    [r, c]
  ), S = (D) => {
    I.current = structuredClone(D);
  };
  Di({
    shouldPrompt: A
  }), J(() => {
    if (u) {
      if (r.configurations[s]) {
        Z.showToast({
          variant: ee.warn,
          description: "Target platform already exists"
        }), n();
        return;
      }
      o({
        action: Ys.ADD_TARGET_PLATFORM,
        data: {
          targetPlatform: s || "",
          handleCaptureSnapshot: S
        }
      });
      return;
    }
    r.configurations[s] || (Z.showToast({
      variant: ee.warn,
      description: "Target platform not found"
    }), n());
  }, [u]), J(() => {
    const D = uc(t);
    if (D && !g) {
      const F = bn(
        t,
        s
      ), be = r.configurations[F ? s : ht][D]?.value?.[0]?.id;
      be && E(be);
    }
  }, [g]);
  const L = () => {
    b(!1);
  }, R = () => {
    if (A && !C) {
      b(!0);
      return;
    }
    o({
      action: Ys.RESTORE_PROFILE_CONFIG_SNAPSHOT,
      data: {
        configSnapshot: N.current.configurations
      }
    }), n();
  }, y = (D) => {
    const F = (D || "").toLowerCase();
    i(F), o({
      action: Ys.RENAME_TARGET_PLATFORM,
      data: {
        originalPlatformName: s,
        newPlatformName: F,
        configSnapshot: N.current.configurations
      }
    });
  }, M = (D) => {
    y(D?.value || "");
  }, P = (f || [])?.map((D) => ({
    label: D,
    value: D
  })).filter((D) => !r.configurations[D.value]), U = (D, F) => {
    d(F), E(D);
  }, G = (D) => () => {
    d(D);
  }, H = (D) => {
    const F = Yt(), q = iE[D], be = lE[D];
    o({
      action: Ys.ADD_CM_CS_ITEM,
      data: {
        targetPlatform: s,
        id: F,
        infraConfigType: q
      }
    }), U(F, be);
  }, oe = (D) => {
    switch (D) {
      case bt.CONFIG_MAP:
        return () => H(sp.ConfigMap);
      case bt.SECRET:
        return () => H(sp.Secret);
      default:
        return Be;
    }
  }, ae = a === ft, re = bn(
    t,
    s
  );
  if (!r.configurations[s])
    return null;
  const k = () => {
    E(null);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(jo, { when: A, message: nE(T.pathname) }),
    /* @__PURE__ */ e.jsx(
      $t,
      {
        position: "right",
        width: "1000px",
        onClose: C ? Be : R,
        onEscape: C ? Be : R,
        children: /* @__PURE__ */ e.jsxs("div", { onClick: Le, className: "h-100 bg__primary flexbox-col", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__align-items-center py-12 px-20 dc__border-bottom", children: [
            /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center", children: /* @__PURE__ */ e.jsxs("h3", { className: "m-0 cn-9 fs-16 fw-6 lh-24", children: [
              /* @__PURE__ */ e.jsx("span", { className: "fw-4", children: a ? `${a} profile` : "New Profile" }),
              " ",
              /* @__PURE__ */ e.jsx("span", { children: "/" }),
              " ",
              u ? "New target platform" : s
            ] }) }),
            /* @__PURE__ */ e.jsx(
              j,
              {
                icon: /* @__PURE__ */ e.jsx(vt, {}),
                onClick: R,
                size: O.xs,
                ariaLabel: "Close target platform form",
                dataTestId: "close-target-platform-form",
                showAriaLabelInTippy: !1,
                variant: w.borderLess,
                style: B.negativeGrey
              }
            )
          ] }),
          /* @__PURE__ */ e.jsxs("div", { className: "dc__overflow-auto h-100 dc__grid infra-form-target-platform__container", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "p-12 flexbox-col dc__gap-12 dc__border-right-n1 dc__overflow-auto", children: [
              u && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                /* @__PURE__ */ e.jsx(
                  Ve,
                  {
                    inputId: "create-target-platform-form__select-platform",
                    label: "Select a target platform",
                    placeholder: "Enter",
                    options: P,
                    isLoading: _,
                    optionListError: h,
                    reloadOptionList: x,
                    onChange: M,
                    error: l[aE.TARGET_PLATFORM],
                    value: s ? {
                      label: s,
                      value: s
                    } : null,
                    onCreateOption: y,
                    isCreatable: !0,
                    isClearable: !0,
                    autoFocus: !0,
                    required: !0,
                    menuListFooterConfig: {
                      type: "text",
                      value: "Type to add a new platform"
                    },
                    formatCreateLabel: QS
                  }
                ),
                /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom-n1" })
              ] }),
              /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
                /* @__PURE__ */ e.jsx("h5", { className: "m-0 cn-7 fs-13 fw-6 lh-20", children: "Define Resources" }),
                /* @__PURE__ */ e.jsx("div", { className: "flexbox-col", children: Ha.map((D) => {
                  const F = bn(
                    D,
                    s
                  ), q = uc(D);
                  if (q) {
                    const be = r.configurations[F ? s : ht];
                    return /* @__PURE__ */ e.jsx(
                      ry,
                      {
                        locator: D,
                        targetPlatform: s,
                        value: be[q].value,
                        handleCreateItem: oe(q),
                        handleSelectItem: U,
                        selectedItemId: g,
                        selectedConfigurationType: t,
                        errorMap: l[q]
                      },
                      D
                    );
                  }
                  return /* @__PURE__ */ e.jsx(
                    oy,
                    {
                      isGlobalProfile: ae,
                      configurationType: t,
                      currentLocator: D,
                      profileInputErrors: l,
                      targetPlatform: s,
                      currentPlatformConfig: r.configurations[s],
                      isButton: m,
                      handleButtonClick: G(D)
                    },
                    D
                  );
                }) })
              ] })
            ] }),
            /* @__PURE__ */ e.jsxs("div", { className: "px-16 flexbox-col flex-grow-1 dc__overflow-auto", children: [
              /* @__PURE__ */ e.jsxs("div", { className: "py-12 flexbox dc__content-space", children: [
                /* @__PURE__ */ e.jsx("h4", { className: "m-0 cn-9 fs-13 fw-6 lh-20", children: _r[t] }),
                /* @__PURE__ */ e.jsx(
                  ZS,
                  {
                    configurationType: t,
                    selectedSubValueId: g,
                    targetPlatform: s,
                    isGlobalProfile: ae,
                    handleProfileInputChange: o,
                    handleClearSelectedSubValue: k,
                    platformConfig: r.configurations[s]
                  }
                )
              ] }),
              /* @__PURE__ */ e.jsxs(
                "div",
                {
                  className: `flexbox-col flex-grow-1 dc__overflow-auto dc__gap-16 ${t === ue.NODE_SELECTOR || t === ue.TOLERANCE ? "pb-8" : ""}`,
                  children: [
                    !re && /* @__PURE__ */ e.jsx(ey, { configurationType: t }),
                    /* @__PURE__ */ e.jsx(
                      ay,
                      {
                        handleProfileInputChange: o,
                        configurationType: t,
                        targetPlatform: s,
                        profileInputErrors: l,
                        appliedConfig: r.configurations[re ? s : ht],
                        isSelectedConfigurationSupportedByPlatform: re,
                        selectedSubValueId: g,
                        isGlobalProfile: ae,
                        profileResponse: c
                      }
                    )
                  ]
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ e.jsx(
            ly,
            {
              savedProfileName: a,
              profileInput: r,
              isPlatformCreationMode: u,
              profileInputErrors: l,
              handleCancel: R,
              handleClose: n,
              handleSuccess: p,
              targetPlatform: s,
              areChangesPresent: A
            }
          )
        ] })
      }
    ),
    C && /* @__PURE__ */ e.jsx(rE, { handleClose: L, handleProceed: R }),
    window._env_.ENABLE_SCOPED_VARIABLES && (t === ue.CONFIG_MAP || t === ue.SECRET) && /* @__PURE__ */ e.jsx("div", { className: "flexbox", children: /* @__PURE__ */ e.jsx("div", { className: "infra-form-target-platform__scoped-variables-widget", children: /* @__PURE__ */ e.jsx(oE, { zIndex: 21, showValueOnHover: !1, isTemplateView: !1 }) }) })
  ] });
}, Md = ({
  ariaLabel: t,
  configurationType: s,
  targetPlatform: n,
  isOpacityHoverChild: a,
  savedProfileName: r,
  isFormView: o,
  handleEdit: i
}) => {
  const l = Te(), c = () => {
    let d = {};
    o && (d = {
      targetPlatformFormType: mo.EDIT,
      targetPlatform: n,
      configurationType: s
    }, l.push({
      search: ye("", d)
    })), i?.(s);
  };
  return /* @__PURE__ */ e.jsx(
    j,
    {
      ariaLabel: t || `Edit ${r} profile's ${n} platform`,
      dataTestId: `edit-${r}-${n}-platform`,
      icon: /* @__PURE__ */ e.jsx(Fs, {}),
      onClick: c,
      variant: w.borderLess,
      style: B.neutral,
      size: O.xs,
      isOpacityHoverChild: a,
      showAriaLabelInTippy: !!t
    }
  );
}, cy = ({ children: t, title: s }) => {
  const [n, a] = v(!1), r = (o) => {
    Le(o), wm(o), a((i) => !i);
  };
  return /* @__PURE__ */ e.jsxs("details", { className: "flexbox-col dc__gap-8", open: n, onToggle: r, children: [
    /* @__PURE__ */ e.jsx("summary", { className: "cursor flex-grow-1", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12 dc__align-items-start", children: [
      /* @__PURE__ */ e.jsx(
        zi,
        {
          className: `icon-dim-20 dc__no-shrink fcn-7 dc__transition--transform ${n ? "" : "dc__flip-90--neg"}`
        }
      ),
      s
    ] }) }),
    t
  ] });
}, dy = (t, s, n, a) => {
  switch (t) {
    case Gs.LIST:
      return /* @__PURE__ */ e.jsx("div", { className: "flexbox-col", children: s.map((r) => /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: "dc__grid",
          style: { gridTemplateColumns: `${r.gridColumnClass} auto` },
          children: [
            /* @__PURE__ */ e.jsx("h5", { className: "m-0 cn-7 fs-13 fw-4 lh-20", children: r.title }),
            n.find((o) => o[r.title])?.[r.title]?.data
          ]
        },
        r.title
      )) });
    case Gs.TABULAR: {
      if (!n?.length)
        return /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Not configured" });
      const r = s.map((o) => o.gridColumnClass).join(" ");
      return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
        /* @__PURE__ */ e.jsx("div", { className: "dc__grid pb-4 dc__column-gap-8", style: { gridTemplateColumns: r }, children: s.map((o) => /* @__PURE__ */ e.jsx(Ne, { isSortable: !1, title: o.title }, o.title)) }),
        n.map((o, i) => /* @__PURE__ */ e.jsx(
          "div",
          {
            className: "dc__grid py-4 dc__column-gap-8",
            style: { gridTemplateColumns: r },
            children: s.map((l) => {
              const c = o[l.title];
              return c ? /* @__PURE__ */ e.jsx(Nr, { children: c.data }, c.id) : null;
            })
          },
          `row-item-${i}`
        ))
      ] });
    }
    case Gs.ACCORDION: {
      if (!n?.length)
        return /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Not configured" });
      const r = Object.keys(n[0])[0];
      return /* @__PURE__ */ e.jsx(cy, { title: a, children: n[0][r].data });
    }
    default:
      return null;
  }
}, Zf = ({
  locatorToInheritingStatusMap: t,
  savedProfileName: s,
  targetPlatform: n,
  valuesUIConfigurationMap: a,
  scrollTo: r,
  rootClassName: o,
  isFormView: i,
  canEdit: l,
  handleEdit: c
}) => {
  const d = de({}), [p, m] = v(!1);
  J(() => {
    const _ = d.current[r];
    if (!r || !_)
      return () => {
      };
    _.scrollIntoView({ behavior: "smooth", block: "start" }), m(!0);
    const h = setTimeout(() => {
      m(!1);
    }, 2e3);
    return () => {
      clearTimeout(h);
    };
  }, [r]);
  const u = (_) => (h) => {
    d.current[_] = h;
  }, f = (_, h, x, g) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space flex-grow-1", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-6", children: [
      /* @__PURE__ */ e.jsx(Ie, { content: h, children: /* @__PURE__ */ e.jsx("h4", { className: "m-0 cn-9 fs-13 fw-6 lh-20 dc__truncate", children: h }) }),
      !_ && (s !== ft || x === jt.INHERITING_DEFAULT_PLATFORM) && /* @__PURE__ */ e.jsxs("span", { className: "cn-7 fs-13 fw-4 lh-20", children: [
        "(",
        Po(x),
        ")"
      ] })
    ] }),
    l && /* @__PURE__ */ e.jsx(
      Md,
      {
        ariaLabel: `Edit ${h}`,
        configurationType: g,
        targetPlatform: n,
        savedProfileName: s,
        isOpacityHoverChild: !0,
        isFormView: i,
        handleEdit: c
      }
    )
  ] });
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: Ha.map((_) => {
    const h = Rd[_];
    if (!h)
      return null;
    const { inheritingStatusType: x } = t[_], { marker: g, headings: E, title: C, variant: b } = h, N = b === Gs.ACCORDION;
    return /* @__PURE__ */ e.jsxs(
      "div",
      {
        ref: u(_),
        className: `${N ? "" : "dc__grid build-infra__configuration-details-block"} ${r === _ && p ? "bcy-50" : ""} py-12 dc__column-gap-12 dc__opacity-hover dc__opacity-hover--parent ${o || ""}`,
        children: [
          g,
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
            !N && f(N, C, x, _),
            /* @__PURE__ */ e.jsx("div", { className: "flexbox-col", children: dy(
              b,
              E,
              a[_],
              f(N, C, x, _)
            ) })
          ] })
        ]
      },
      _
    );
  }) });
}, eh = ({
  profileName: t,
  identifierName: s,
  handleClose: n,
  targetPlatform: a,
  scrollTo: r,
  canEdit: o,
  handleReloadData: i
}) => {
  const {
    isLoading: l,
    profileResponse: c,
    reloadRequest: d,
    responseError: p,
    profileInput: m,
    profileInputErrors: u,
    handleProfileInputChange: f
  } = Dm({
    name: t,
    editProfile: !0,
    handleSuccessRedirection: i,
    canConfigureUseK8sDriver: !0
  }), [_, h] = v(null), x = (b) => {
    h(b);
  }, g = (b) => {
    h(b || Mf);
  }, E = () => {
    h(null), n();
  }, C = () => {
    const b = c?.profile?.configurations;
    if (!b)
      return /* @__PURE__ */ e.jsx(_e, { title: "Given profile's configurations does not exist" });
    const N = b[a], I = b[ht], T = Pd(
      a,
      N
    ), A = Ha.reduce(
      (S, L) => {
        const R = bn(L, a);
        return S[L] = Uf(
          R ? N : I,
          L,
          a
        ), S;
      },
      {}
    );
    return /* @__PURE__ */ e.jsx(
      Zf,
      {
        locatorToInheritingStatusMap: T,
        targetPlatform: a,
        savedProfileName: t,
        valuesUIConfigurationMap: A,
        scrollTo: r,
        canEdit: o,
        rootClassName: "px-20",
        isFormView: !1,
        handleEdit: g
      }
    );
  };
  return o && _ ? /* @__PURE__ */ e.jsx(
    Qf,
    {
      configurationType: _,
      targetPlatform: a,
      handleClose: E,
      savedProfileName: t,
      profileInput: m,
      handleProfileInputChange: f,
      profileInputErrors: u,
      profileResponse: c,
      handleUpdateConfigurationType: x,
      handleSuccess: i,
      isPlatformCreationMode: !1,
      showSidebarLinkAsButton: !0
    }
  ) : /* @__PURE__ */ e.jsx($t, { onClose: n, onEscape: n, position: "right", width: "800px", children: /* @__PURE__ */ e.jsxs("div", { className: "h-100 bg__primary flexbox-col", onClick: Le, children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__align-items-center py-12 px-20 dc__border-bottom", children: [
        /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center dc__gap-8", children: /* @__PURE__ */ e.jsxs("h3", { className: "m-0 cn-9 fs-16 fw-6 lh-24 dc__truncate", children: [
          /* @__PURE__ */ e.jsx("span", { className: "fw-4", children: s || t }),
          " ",
          /* @__PURE__ */ e.jsx("span", { children: "/" }),
          " ",
          /* @__PURE__ */ e.jsxs("span", { children: [
            a,
            " ",
            a === ht ? "configuration" : ""
          ] })
        ] }) }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
          o && /* @__PURE__ */ e.jsx(
            Md,
            {
              configurationType: null,
              targetPlatform: a,
              savedProfileName: t,
              isFormView: !1,
              handleEdit: g
            }
          ),
          /* @__PURE__ */ e.jsx(
            j,
            {
              icon: /* @__PURE__ */ e.jsx(vt, {}),
              onClick: n,
              ariaLabel: "Close configuration details modal",
              dataTestId: "close-configuration-details-modal",
              showAriaLabelInTippy: !1,
              variant: w.borderLess,
              style: B.negativeGrey,
              size: O.xs
            }
          )
        ] })
      ] }),
      !o && /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-20 px-20 py-8 bcb-1 dc__border-bottom--b2", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 flex-grow-1", children: [
          /* @__PURE__ */ e.jsx(qi, { className: "icon-dim-20 dc__no-shrink" }),
          /* @__PURE__ */ e.jsxs("span", { className: "dc__word-break cn-9 fs-13 fw-4 lh-20", children: [
            "Build infra profile '",
            t,
            "' is applied on this application"
          ] })
        ] }),
        /* @__PURE__ */ e.jsx(
          j,
          {
            dataTestId: "view-profile-button",
            component: Re.link,
            variant: w.text,
            size: O.medium,
            text: "Go to profile",
            endIcon: /* @__PURE__ */ e.jsx(Ms, {}),
            linkProps: {
              to: `${Ee.APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA_PROFILE_EDIT}/${t}`
            }
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "dc__overflow-auto h-100", children: /* @__PURE__ */ e.jsx(
      Ke,
      {
        isLoading: l,
        progressingProps: {
          pageLoader: !0
        },
        error: p,
        errorScreenManagerProps: {
          code: p?.code,
          reload: d,
          redirectURL: Ee.APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA
        },
        children: C()
      }
    ) }),
    /* @__PURE__ */ e.jsx("div", { className: "px-20 py-16 flexbox w-100 dc__content-end dc__align-items-center dc__no-shrink dc__border-top", children: /* @__PURE__ */ e.jsx(
      j,
      {
        text: "Okay",
        onClick: n,
        dataTestId: "close-configuration-details-modal-footer-button"
      }
    ) })
  ] }) });
}, th = ({
  targetPlatform: t,
  profileName: s,
  handleShowDefaultPlatformDetails: n,
  useK8sDriver: a,
  doesPlatformExistInDefaultProfile: r
}) => /* @__PURE__ */ e.jsxs("div", { className: "pr-8 py-8 flexbox-col", children: [
  /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: a ? `No configurations set for '${t}' in '${s}' profile.` : `K8s driver is not enabled for '${s}' profile` }),
  a && /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4", children: [
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "show-default-config-details",
        text: `${r ? t : ht} configuration of '${ft}' profile`,
        onClick: n,
        variant: w.text,
        size: O.xs
      }
    ),
    /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-12 fw-4", children: "will be used as fallback." })
  ] })
] }), py = ({
  identifier: t,
  currentSelectDropdownId: s,
  setCurrentSelectDropdownId: n,
  setShowSelectionDialog: a,
  targetPlatform: r,
  globalPlatformsMap: o
}) => {
  const { selectedIdentifiers: i, handleBulkSelection: l } = It(), [c, d] = v(!1), [p, m] = v(!1), [u, f] = v(null), _ = !!(i[t.id] || i[us]), h = {
    [t.id]: t
  }, x = t.profile.platformToConfigurationsMap[r], g = s && s === t.id, E = () => {
    if (i[us]) {
      l({
        action: st.CLEAR_IDENTIFIERS_AFTER_ACROSS_SELECTION,
        data: {
          identifierIds: [t.id]
        }
      });
      return;
    }
    l({
      action: i[t.id] ? st.CLEAR_IDENTIFIERS : st.SELECT_IDENTIFIER,
      data: {
        // In case we are clearing
        identifierIds: [t.id],
        // In case of selecting
        identifierObject: h
      }
    });
  }, C = (T) => () => {
    f(T), m(!0);
  }, b = () => {
    f(null), m(!1);
  }, N = () => {
    d(!0);
  }, I = () => {
    d(!1);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: `flexbox dc_width-max-content dc__hover-n50 dc__border-bottom-n1 mw-100p ${_ ? "bc-b50--imp" : ""} dc__visible-hover dc__visible-hover--parent infra-list-container`,
        onMouseEnter: N,
        onMouseLeave: I,
        children: [
          /* @__PURE__ */ e.jsxs(
            "div",
            {
              className: `w-240 flexbox dc__align-start dc__gap-8 pt-8 pb-8 pl-20 pr-20 dc__border-right-n1 infra-list-item-bg dc__no-shrink dc__position-sticky dc__left-0 ${_ ? "bc-b50--imp" : ""} ${g ? "dc__zi-5" : "dc__zi-4"}`,
              children: [
                /* @__PURE__ */ e.jsxs("div", { className: "flexbox w-40 dc__no-shrink", children: [
                  !_ && /* @__PURE__ */ e.jsx("div", { className: "dc__visible-hover--hide-child", children: /* @__PURE__ */ e.jsx(Rb, { className: "icon-dim-20 fcb-5" }) }),
                  /* @__PURE__ */ e.jsx(
                    $e,
                    {
                      isChecked: _,
                      onChange: E,
                      rootClassName: `icon-dim-20 ${_ ? "" : "dc__visible-hover--child"}`,
                      dataTestId: `activate-${t.name}`,
                      tabIndex: 0,
                      value: Fe.CHECKED
                    }
                  )
                ] }),
                /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4 dc__mxw-160", children: [
                  /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-9 dc__ellipsis-right fs-13 fw-6 lh-20", children: t.name }),
                  /* @__PURE__ */ e.jsx("div", { className: "flexbox dc_gap-4", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4 dc__align-items-center w-100", children: [
                    wo(t.profile.name === ft, "icon-dim-12"),
                    c || g ? /* @__PURE__ */ e.jsx("div", { className: `${g ? "" : "dc__visible-hover--child"}`, children: /* @__PURE__ */ e.jsx(
                      Xf,
                      {
                        currentProfileName: t.profile.name,
                        selectStyles: yS,
                        selectedIdentifiers: h,
                        setCurrentSelectDropdownId: n,
                        currentIdentifierId: t.id,
                        currentIdentifierName: t.name,
                        setShowSelectionDialog: a,
                        isMenuPositionFixed: !0
                      }
                    ) }) : (
                      // Giving a fallback with same class in case of state delay
                      /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-7 fs-12 fw-4 dc__visible-hover--child dc__ellipsis-right", children: t.profile.name })
                    ),
                    !g && /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-7 fs-12 fw-4 dc__visible-hover--hide-child dc__ellipsis-right", children: t.profile.name })
                  ] }) })
                ] })
              ]
            }
          ),
          /* @__PURE__ */ e.jsx(
            "div",
            {
              className: `flexbox dc__align-items-center pl-16 pr-16 dc__gap-16 flex-grow-1 infra-list-item-bg ${_ ? "bc-b50--imp" : ""}`,
              children: x ? ol.map(({ key: T }) => {
                const { valueInfoText: A, inheritingStatusType: S, profileName: L } = x[T];
                return /* @__PURE__ */ e.jsxs("div", { className: "m-0 flexbox-col dc__gap-4 w-200 dc__no-shrink", children: [
                  Pf[T] ? /* @__PURE__ */ e.jsx(
                    j,
                    {
                      dataTestId: `open-${T}-more-info-modal`,
                      onClick: C(T),
                      text: A,
                      variant: w.text,
                      style: B.neutral
                    }
                  ) : A,
                  /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4 dc__align-items-center fw-4 cn-7", children: [
                    Yf(
                      S,
                      t.profile.name === ft
                    ),
                    S === jt.OVERRIDDEN ? L : Po(S)
                  ] })
                ] }, T);
              }) : /* @__PURE__ */ e.jsx(
                th,
                {
                  targetPlatform: r,
                  profileName: t.profile.name,
                  handleShowDefaultPlatformDetails: C(null),
                  useK8sDriver: t.profile.useK8sDriver,
                  doesPlatformExistInDefaultProfile: !!o[r]
                }
              )
            }
          )
        ]
      }
    ),
    p && /* @__PURE__ */ e.jsx(
      eh,
      {
        handleClose: b,
        targetPlatform: Hf({
          sourcePlatform: x,
          targetPlatform: r,
          doesPlatformExistsInGlobalProfile: !!o[r]
        }),
        profileName: x ? t.profile.name : ft,
        scrollTo: u,
        identifierName: t.name,
        canEdit: !1
      }
    )
  ] });
}, uy = ({
  identifiers: t,
  showPagination: s,
  setShowSelectionDialog: n,
  targetPlatform: a,
  globalPlatformsMap: r
}) => {
  const o = Te(), [i, l] = v(null), c = () => {
    o.push({
      search: ""
    });
  };
  return t?.length ? /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: /* @__PURE__ */ e.jsxs("div", { className: "mw-100p dc_width-max-content", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox cn-7 fs-12 fw-6 lh-20 bg__primary dc__uppercase dc_width-max-content mw-100p dc__border-top-n1 dc__border-bottom-n1 dc__position-sticky dc__top-0 dc__zi-5", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "w-240 flexbox dc__align-start dc__gap-8 pt-8 pb-8 pl-20 pr-20 dc__border-right-n1 dc__no-shrink dc__position-sticky dc__zi-4 dc__left-0 bg__primary", children: [
        /* @__PURE__ */ e.jsx(bo, { showPagination: s }),
        /* @__PURE__ */ e.jsx("p", { className: "m-0 flex", children: Ks.APPLICATION_NAME })
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center pl-16 pr-16 dc__gap-16 flex-grow-1", children: ol.map((d) => /* @__PURE__ */ e.jsx("p", { className: "m-0 flexbox dc__align-items-center w-200 dc__no-shrink", children: d.name }, d.key)) })
    ] }),
    t.map((d) => /* @__PURE__ */ e.jsx(
      py,
      {
        identifier: d,
        currentSelectDropdownId: i,
        setCurrentSelectDropdownId: l,
        setShowSelectionDialog: n,
        targetPlatform: a,
        globalPlatformsMap: r
      },
      d.id
    ))
  ] }) }) : /* @__PURE__ */ e.jsx(qt, { handleClearFilters: c, classname: "h-100" });
}, my = ({
  searchParams: t,
  size: s,
  pageSizeOptions: n,
  offset: a,
  totalIdentifierCount: r,
  showPagination: o,
  identifiers: i,
  setShowSelectionDialog: l,
  noApplicationCreated: c,
  identifierError: d,
  loadingIdentifierResponse: p,
  handlePageReload: m,
  targetPlatform: u,
  globalPlatformsMap: f
}) => {
  const _ = Te(), h = (g) => {
    const E = {
      ...t,
      offset: String((g - 1) * s)
    };
    g === 1 && delete E.offset, _.push({
      search: new URLSearchParams(E).toString()
    });
  }, x = (g) => {
    const E = {
      ...t,
      size: String(g)
    };
    g === zf && delete E.size, delete E.offset, _.push({
      search: new URLSearchParams(E).toString()
    });
  };
  return /* @__PURE__ */ e.jsx(
    Ke,
    {
      isLoading: p,
      progressingProps: {
        pageLoader: !0
      },
      error: d,
      reloadProps: {
        reload: m
      },
      children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1", children: [
        c ? /* @__PURE__ */ e.jsx(
          _e,
          {
            title: ke.NO_APPLICATIONS_CREATED.title,
            subTitle: ke.NO_APPLICATIONS_CREATED.subTitle
          }
        ) : /* @__PURE__ */ e.jsx(
          uy,
          {
            identifiers: i,
            showPagination: o,
            setShowSelectionDialog: l,
            targetPlatform: u,
            globalPlatformsMap: f
          }
        ),
        o && /* @__PURE__ */ e.jsx(
          vo,
          {
            size: r,
            pageSize: s,
            offset: a,
            changePage: h,
            changePageSize: x,
            rootClassName: "flexbox dc__content-space bg__primary pl pr m-0 dc__align-items-center",
            pageSizeOptions: n
          }
        )
      ] })
    }
  );
}, sh = ({
  currentPlatformName: t = ht,
  handlePlatformChange: s
}) => {
  const n = Te(), a = Ss(), [r, o, i, l] = ne(Kf), c = [
    {
      label: Cs.TARGET_PLATFORM_FILTER_TEXT.DEFAULT_PLATFORM_LABEL,
      value: ht
    },
    {
      label: Cs.TARGET_PLATFORM_FILTER_TEXT.PLATFORM_GROUP_HEADING,
      options: (o || []).map((p) => ({
        label: p,
        value: p
      }))
    }
  ], d = (p) => {
    if (ct.event({
      category: "global-config-build-infra",
      action: "global-build-infra-applied-platform-filter"
    }), s) {
      s(p.value);
      return;
    }
    const m = new URLSearchParams(a.search);
    n.push({
      search: ye("", {
        ...Object.fromEntries(m.entries()),
        targetPlatform: p.value
      })
    });
  };
  return /* @__PURE__ */ e.jsx(
    Ve,
    {
      inputId: "build-infra__target-platform-filter",
      icon: /* @__PURE__ */ e.jsx(td, {}),
      isLoading: r,
      optionListError: i,
      reloadOptionList: l,
      options: c,
      onChange: d,
      value: {
        label: t === ht ? Cs.TARGET_PLATFORM_FILTER_TEXT.DEFAULT_PLATFORM_LABEL : t,
        value: t
      },
      shouldMenuAlignRight: !0,
      menuPosition: "absolute"
    }
  );
}, _y = ({
  searchText: t,
  searchApplied: s,
  handleSubmit: n,
  handleChange: a
}) => {
  const r = () => {
    a(""), s && n("");
  }, o = (l) => {
    l.key === "Enter" && (l.preventDefault(), n(l.currentTarget.value));
  }, i = (l) => {
    a(l.currentTarget.value.trim());
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox flex-grow-1 pt-8 pb-8 pl-10 pr-10 dc__gap-8 dc__align-self-stretch dc__align-items-center bg__secondary dc__border dc__border-radius-4-imp focus-within-border-b5 dc__hover-border-n300 dc__mxw-250 h-32", children: [
    /* @__PURE__ */ e.jsx(ad, { className: "icon-dim-18" }),
    /* @__PURE__ */ e.jsx(
      "input",
      {
        type: "text",
        className: "flex-grow-1 dc__no-border dc__outline-none-imp bg__secondary lh-20 fs-13 cn-9 fw-4 p-0 placeholder-cn5",
        placeholder: ke.SEARCH_APPLICATIONS_PLACEHOLDER,
        value: t,
        onKeyDown: o,
        onChange: i,
        "data-testid": wa.SEARCH_APPLICATIONS
      }
    ),
    t && /* @__PURE__ */ e.jsx(
      "button",
      {
        type: "button",
        className: "dc__outline-none-imp dc__no-border p-0 bg__secondary flex icon-dim-18",
        onClick: r,
        "data-testid": wa.CLEAR_SEARCH_APPLICATIONS,
        "aria-label": ke.CLEAR_APPLICATIONS_SEARCH_LABEL,
        children: /* @__PURE__ */ e.jsx(Ob, { className: "icon-dim-16" })
      }
    )
  ] });
}, fy = ({
  handleFilters: t,
  setSearchState: s,
  searchState: n,
  setProfileNameState: a,
  profileNameState: r,
  setShowSelectionDialog: o,
  appliedSearchText: i,
  appliedProfileName: l,
  targetPlatform: c
}) => {
  const { selectedIdentifiers: d } = It(), { loadingProfiles: p, profileOptions: m } = il(), u = (g, E) => {
    if (d[us]) {
      setTimeout(() => {
        o({
          type: Et.CLEAR_ALL,
          identifierName: g,
          profileName: E
        });
      }, 100);
      return;
    }
    t({ searchText: g, selectedProfileName: E });
  }, f = (g) => {
    s(g), u(g, l), g && ct.event({
      category: "global-config-build-infra",
      action: "global-build-infra-searched-application"
    });
  }, _ = (g) => {
    const E = g?.value;
    E && ct.event({
      category: "global-config-build-infra",
      action: "global-build-infra-applied-profile-filter"
    }), a(E), u(i, E);
  }, h = l ? {
    label: l,
    value: l,
    startIcon: wo(l === ft, "icon-dim-12")
  } : null, x = m.find((g) => g.value === r) ?? h;
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space px-20 dc__zi-6", children: [
    /* @__PURE__ */ e.jsx(
      _y,
      {
        searchText: n,
        searchApplied: !!i,
        handleSubmit: f,
        handleChange: s
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12", children: [
      /* @__PURE__ */ e.jsx("div", { className: "w-200", children: /* @__PURE__ */ e.jsx(
        Ve,
        {
          inputId: "profile-filter-selector",
          options: m,
          placeholder: ke.PROFILE_FILTER_PLACEHOLDER,
          value: x,
          onChange: _,
          classNamePrefix: wf,
          isClearable: !0,
          isLoading: p,
          shouldMenuAlignRight: !0
        }
      ) }),
      /* @__PURE__ */ e.jsx("div", { className: "dc__mxw-300", children: /* @__PURE__ */ e.jsx(sh, { currentPlatformName: c }) })
    ] })
  ] });
}, hy = () => /* @__PURE__ */ e.jsx("div", { className: "pl pr bg__primary", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4 w-100 dc__border-dashed--n3 br-4 p-16", children: [
  /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-14 fw-6 lh-20", children: ke.NO_OVERRIDDEN_APPLICATIONS.title }),
  /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-7 fs-13 fw-4 lh-20", children: ke.NO_OVERRIDDEN_APPLICATIONS.subTitle })
] }) }), gy = ({
  searchParams: t,
  size: s,
  offset: n,
  profileName: a,
  search: r,
  isContentFiltered: o,
  pageSizeOptions: i,
  loadingIdentifierResponse: l,
  identifierResponse: c,
  identifierError: d,
  reloadIdentifiers: p,
  showSelectionDialog: m,
  setShowSelectionDialog: u,
  targetPlatform: f
}) => {
  const _ = Te(), h = de(null), { reloadProfileOptions: x } = il(), { handleBulkSelection: g } = It(), [E, C] = v(r), [b, N] = v(a);
  J(() => {
    C(r);
  }, [r]), J(() => {
    N(a);
  }, [a]);
  const I = ({ searchText: R, selectedProfileName: y }) => {
    const M = {
      ...t,
      search: R,
      profileName: y
    };
    delete M.offset, R || delete M.search, y || delete M.profileName, _.push({
      search: new URLSearchParams(M).toString()
    });
  }, T = () => {
    _.push({
      search: ""
    }), g({
      action: st.CLEAR_ALL_SELECTIONS
    }), x(), !o && !t.size && !t.offset && p();
  }, A = !o && c?.totalIdentifierCount === 0, S = !!c?.identifiers?.length && c.identifiers.length < c.totalIdentifierCount, L = d && !Pe(d);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "h-100 flexbox-col", ref: h, children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col pt pl pr dc__gap-8 dc__border-bottom", children: [
        /* @__PURE__ */ e.jsx(Uc, { tooltipNode: /* @__PURE__ */ e.jsx(Rf, {}), children: /* @__PURE__ */ e.jsx(wd, { size: O.medium, handleSuccess: x }) }),
        /* @__PURE__ */ e.jsx(kf, { currentTab: Er.APPLICATIONS })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-auto dc__gap-16 flex-grow-1 h-100 pt", children: [
        !L && c && !c?.isAnyIdentifierOverridden && /* @__PURE__ */ e.jsx(hy, {}),
        !L && /* @__PURE__ */ e.jsx(
          fy,
          {
            handleFilters: I,
            setSearchState: C,
            searchState: E,
            setProfileNameState: N,
            profileNameState: b,
            setShowSelectionDialog: u,
            appliedSearchText: r,
            appliedProfileName: a,
            targetPlatform: f
          }
        ),
        /* @__PURE__ */ e.jsx(
          my,
          {
            searchParams: t,
            size: s,
            pageSizeOptions: i,
            offset: n,
            totalIdentifierCount: c?.totalIdentifierCount,
            showPagination: S,
            identifiers: c?.identifiers,
            setShowSelectionDialog: u,
            noApplicationCreated: A,
            identifierError: d,
            loadingIdentifierResponse: l,
            handlePageReload: T,
            targetPlatform: f,
            globalPlatformsMap: c?.globalPlatformsMap
          }
        )
      ] }),
      /* @__PURE__ */ e.jsx(
        DS,
        {
          showSelectionDialog: m,
          setShowSelectionDialog: u,
          totalIdentifierCount: c?.totalIdentifierCount,
          parentRef: h,
          loadingIdentifierResponse: l
        }
      )
    ] }),
    m?.type === Et.APPLY && /* @__PURE__ */ e.jsx(
      GS,
      {
        setShowSelectionDialog: u,
        updateToProfile: m.profileName,
        currentIdentifierName: m.identifierName,
        handlePageReload: T,
        search: r,
        profileName: a,
        totalIdentifierCount: c?.totalIdentifierCount
      }
    ),
    (m?.type === Et.CLEAR_ALL || m?.type === Et.SELECT_ALL) && /* @__PURE__ */ e.jsx(
      BS,
      {
        setShowSelectionDialog: u,
        type: m.type,
        profileName: m.profileName,
        identifierName: m.identifierName,
        handleFilters: I,
        originalProfileName: a,
        originalSearch: r,
        setProfileNameState: N,
        setSearchState: C
      }
    )
  ] });
}, xy = () => {
  const t = de(new AbortController()), { searchParams: s } = Gc(), { profileName: n, search: a, offset: r, size: o, pageSizeOptions: i, isContentFiltered: l, targetPlatform: c } = Q(
    () => OS(s),
    [
      s.size,
      s.offset,
      s.profileName,
      s.search,
      s.targetPlatform
    ]
  ), [d, p, m, u] = ne(
    () => es(
      () => MS({
        offset: r,
        size: o,
        profileName: n,
        search: a,
        abortControllerRef: t
      }),
      t
    ),
    [n, a, r, o],
    !0,
    {
      resetOnChange: !1
    }
  ), f = Q(() => p?.identifiers ? p.identifiers.reduce((g, E) => (g[E.id] = E, g), {}) : {}, [p]), [_, h] = v(null), x = () => (h({
    type: Et.SELECT_ALL
  }), Io.OPEN);
  return /* @__PURE__ */ e.jsx(
    Ui,
    {
      identifiers: f,
      getSelectAllDialogStatus: x,
      children: /* @__PURE__ */ e.jsx(
        gy,
        {
          searchParams: s,
          size: o,
          offset: r,
          profileName: n,
          search: a,
          targetPlatform: c,
          isContentFiltered: l,
          pageSizeOptions: i,
          loadingIdentifierResponse: d || Pe(m),
          identifierResponse: p,
          identifierError: m,
          reloadIdentifiers: u,
          showSelectionDialog: _,
          setShowSelectionDialog: h
        }
      )
    }
  );
}, nh = ({ profileName: t, useDeleteIcon: s, handleDeleteSuccess: n = Be }) => {
  const a = Te(), [r, o] = v(!1), i = () => {
    o(!1);
  }, l = () => {
    ct.event({
      category: "global-config-build-infra",
      action: "global-build-infra__delete-profile-button-clicked"
    }), o(!0);
  }, c = async () => {
    await xS(t), n(), a.push(Ee.APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    s ? /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: ja.getProfileDeleteTestId(t),
        ariaLabel: Ks.getDeleteProfileAriaLabel(t),
        icon: /* @__PURE__ */ e.jsx(ts, {}),
        onClick: l,
        size: O.xs,
        variant: w.borderLess,
        style: B.negativeGrey,
        showTooltip: !0,
        tooltipProps: {
          content: "Delete"
        }
      }
    ) : /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: ja.getProfileDeleteTestId(t),
        variant: w.secondary,
        style: B.negative,
        size: O.medium,
        onClick: l,
        text: Cs.DELETE_PROFILE.DELETE_PROFILE_BUTTON
      }
    ),
    r && /* @__PURE__ */ e.jsx(
      Sr,
      {
        title: t,
        component: "profile",
        subtitle: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("p", { className: "fs-13 lh-20 cn-7 m-0", children: Cs.DELETE_PROFILE.getDeleteDialogDescription(t) }),
          /* @__PURE__ */ e.jsx("p", { className: "fs-13 lh-20 cn-7 m-0", children: Cs.DELETE_PROFILE.CONFIRMATION_TEXT })
        ] }),
        closeConfirmationModal: i,
        onDelete: c,
        successToastMessage: Ks.getDeleteProfileSuccessToast(t)
      }
    )
  ] });
}, Ey = ({
  heading: t,
  onHeadingClick: s,
  profileType: n,
  inheritingStatusType: a,
  headingTestId: r
}) => /* @__PURE__ */ e.jsxs("div", { className: "m-0 flexbox-col dc__gap-4 w-200 dc__no-shrink", children: [
  s ? /* @__PURE__ */ e.jsx(
    j,
    {
      dataTestId: r,
      onClick: s,
      variant: w.text,
      style: B.neutral,
      size: O.medium,
      text: t
    }
  ) : /* @__PURE__ */ e.jsx("div", { "data-testid": r, children: t }),
  n !== Pa.GLOBAL && /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4 dc__align-items-center", children: [
    Yf(a, !1),
    /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-7 fs-12 fw-4 dc__truncate", children: Po(a) })
  ] })
] }), Cy = ({
  profile: t,
  searchText: s,
  reloadProfiles: n,
  targetPlatform: a,
  globalProfile: r
}) => {
  const o = Te(), [i, l] = v(!1), [c, d] = v(null), p = () => {
    o.push(
      `${Ee.APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA_APPLICATIONS}?profileName=${t.name}`
    );
  }, m = () => {
    o.push(`${Ee.APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA_PROFILE_EDIT}/${t.name}`);
  }, u = (g) => () => {
    l(!0), d(g);
  }, f = () => {
    l(!1), d(null);
  }, _ = t.platformToConfigurationsMap[a], h = t.type === Pa.GLOBAL, x = Ks.getImpactingAppsText(t.appCount);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc_width-max-content mw-100p dc__border-bottom-n1 bg__primary dc__hover-n50 infra-list-container dc__opacity-hover dc__opacity-hover--parent", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "w-240 flexbox dc__align-start dc__gap-12 pt-8 pb-8 pl-20 pr-20 dc__border-right-n1 dc__no-shrink dc__position-sticky dc__zi-4 dc__left-0 infra-list-item-bg", children: [
        wo(h, "icon-dim-20"),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
          /* @__PURE__ */ e.jsx(
            "button",
            {
              type: "button",
              className: "dc__no-background dc__no-border dc__outline-none-imp dc__tab-focus w-100 p-0",
              onClick: m,
              "aria-label": Ks.getEditProfileAriaLabel(t.name),
              "data-testid": ja.getEditProfileTextButtonTestId(t.name),
              children: /* @__PURE__ */ e.jsx(
                "p",
                {
                  className: "m-0 profile-list-button-text cn-9 dc__ellipsis-right fs-13 fw-6 lh-20 dc__ellipsis-right dc__mxw-160 dc__width-min-content",
                  dangerouslySetInnerHTML: {
                    __html: ta.sanitize(
                      aa({
                        searchText: s,
                        text: t.name,
                        highlightClasses: "bcy-2"
                      })
                    )
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__gap-4", children: /* @__PURE__ */ e.jsx(
            "button",
            {
              type: "button",
              onClick: p,
              className: "dc__no-background dc__no-border dc__outline-none-imp p-0 dc__tab-focus dc__mxw-160",
              "data-testid": ja.getProfileImpactTestId(t.name),
              children: /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-12 fw-4 dc__ellipsis-right profile-list-button-text--secondary", children: x })
            }
          ) })
        ] })
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center pl-16 pr-16 dc__gap-16 flex-grow-1", children: _ ? ol.map(({ key: g }) => {
        const { valueInfoText: E, inheritingStatusType: C } = _[g];
        return /* @__PURE__ */ e.jsx(
          Ey,
          {
            headingTestId: `${g}-heading`,
            onHeadingClick: Pf[g] ? u(g) : null,
            heading: E,
            inheritingStatusType: C,
            profileType: t.type
          },
          g
        );
      }) : /* @__PURE__ */ e.jsx(
        th,
        {
          targetPlatform: a,
          profileName: t.name,
          handleShowDefaultPlatformDetails: u(null),
          useK8sDriver: t.useK8sDriver,
          doesPlatformExistInDefaultProfile: !!r.platformToConfigurationsMap[a]
        }
      ) }),
      /* @__PURE__ */ e.jsxs("div", { className: "w-80px flex dc__content-end dc__no-shrink dc__position-sticky dc__zi-4 dc__right-0 infra-list-item-bg dc__opacity-hover--child pr-16 dc__gap-8", children: [
        /* @__PURE__ */ e.jsx(
          j,
          {
            dataTestId: ja.getProfileEditTestId(t.name),
            ariaLabel: Ks.getEditProfileAriaLabel(t.name),
            icon: /* @__PURE__ */ e.jsx(Fs, {}),
            onClick: m,
            size: O.xs,
            variant: w.borderLess,
            style: B.neutral,
            showTooltip: !0,
            tooltipProps: { content: "Edit" }
          }
        ),
        !h && /* @__PURE__ */ e.jsx(
          nh,
          {
            profileName: t.name,
            useDeleteIcon: !0,
            handleDeleteSuccess: n
          }
        )
      ] })
    ] }),
    i && /* @__PURE__ */ e.jsx(
      eh,
      {
        handleClose: f,
        targetPlatform: Hf({
          sourcePlatform: _,
          targetPlatform: a,
          doesPlatformExistsInGlobalProfile: !!r.platformToConfigurationsMap[a]
        }),
        profileName: _ ? t.name : r.name,
        scrollTo: c,
        canEdit: !0,
        handleReloadData: n
      }
    )
  ] });
}, by = ({
  containerClassName: t = "",
  profiles: s,
  reloadProfiles: n,
  stickHeading: a,
  searchText: r,
  targetPlatform: o,
  globalProfile: i
}) => /* @__PURE__ */ e.jsx("div", { className: `${t} flexbox-col dc__overflow-auto`, children: /* @__PURE__ */ e.jsxs("div", { className: "mw-100p dc_width-max-content", children: [
  /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `flexbox cn-7 fs-12 fw-6 lh-20 bg__primary dc__uppercase dc_width-max-content mw-100p dc__border-bottom-n1 ${a ? "dc__position-sticky dc__top-0 dc__zi-5" : ""}`,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "w-240 flexbox dc__align-start dc__gap-12 pt-8 pb-8 pl-20 pr-20 dc__border-right-n1 dc__no-shrink dc__position-sticky dc__zi-4 dc__left-0 bg__primary", children: [
          /* @__PURE__ */ e.jsx("div", { className: "icon-dim-20" }),
          /* @__PURE__ */ e.jsx("p", { className: "m-0 flex", children: Ks.PROFILE_NAME })
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center pl-16 pr-16 dc__gap-16 flex-grow-1", children: ol.map((l) => /* @__PURE__ */ e.jsx("p", { className: "m-0 flexbox dc__align-items-center w-200 dc__no-shrink", children: l.name }, l.key)) })
      ]
    }
  ),
  s.map((l) => /* @__PURE__ */ e.jsx(
    Cy,
    {
      profile: l,
      searchText: r,
      reloadProfiles: n,
      targetPlatform: o,
      globalProfile: i
    },
    l.id
  ))
] }) }), Ny = () => {
  const t = Te(), s = () => {
    t.push(`${Ee.APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA_PROFILE_EDIT}/${ft}`);
  };
  return /* @__PURE__ */ e.jsxs(
    "button",
    {
      type: "button",
      "data-testid": ja.EDIT_DEFAULT_PROFILE_TEST_ID,
      className: "flexbox dc__align-items-center dc__gap-4 h-28 fw-6 fs-12 lh-18 cb-5 bg__primary dc__border pt-5 pb-5 pr-10 pl-8 dc__outline-none-imp br-4 dc__hover-n50",
      onClick: s,
      children: [
        /* @__PURE__ */ e.jsx(Fs, { className: "icon-dim-12 scb-5" }),
        Ks.EDIT_DEFAULT_PROFILE_TEXT
      ]
    }
  );
}, Ty = ({ handleSuccess: t }) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__border br-4", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 dc__mxw-600 p-16", children: [
    /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-14 fw-6 lh-20", children: Cs.BUILD_INFRA_INFO_TITLE }),
      /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-7 fs-13 fw-4 lh-20", children: Cs.BUILD_INFRA_INFO_DESCRIPTION })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12", children: [
      /* @__PURE__ */ e.jsx(wd, { handleSuccess: t }),
      /* @__PURE__ */ e.jsx(Ny, {})
    ] })
  ] }),
  /* @__PURE__ */ e.jsx(yb, { className: "infra-chipset__medium dc__no-shrink" })
] }), Iy = ({ profiles: t, reloadProfiles: s }) => {
  const { searchKey: n, handleSearch: a, targetPlatform: r, updateSearchParams: o, clearFilters: i } = _t({
    parseSearchParams: mS
  }), { showNormalProfilesEmptyState: l, globalProfile: c } = Q(
    () => t.reduce(
      (m, u) => (u.type === Pa.NORMAL ? m.showNormalProfilesEmptyState = !1 : u.type === Pa.GLOBAL && (m.globalProfile = u), m),
      { showNormalProfilesEmptyState: !0, globalProfile: null }
    ),
    [t]
  ), d = Q(() => {
    if (!n)
      return t;
    const m = n.toLowerCase();
    return t.filter((u) => u.name.toLowerCase().includes(m));
  }, [n, t]), p = (m) => {
    o({ targetPlatform: m });
  };
  return t.length ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col pt pl pr dc__gap-8 dc__border-bottom", children: [
      /* @__PURE__ */ e.jsx(Uc, { tooltipNode: /* @__PURE__ */ e.jsx(Rf, {}), children: /* @__PURE__ */ e.jsx(wd, { size: O.medium, handleSuccess: s }) }),
      /* @__PURE__ */ e.jsx(kf, { currentTab: Er.PROFILES })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "pl pr flexbox-col dc__gap-12", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space", children: [
      /* @__PURE__ */ e.jsx(
        Wt,
        {
          initialSearchText: n,
          containerClassName: "dc__mxw-250 flex-grow-1",
          handleEnter: a,
          inputProps: {
            placeholder: Ks.SEARCH_PROFILE_PLACEHOLDER
          },
          dataTestId: "search-profile"
        }
      ),
      /* @__PURE__ */ e.jsx("div", { className: "dc__mxw-300", children: /* @__PURE__ */ e.jsx(
        sh,
        {
          currentPlatformName: r,
          handlePlatformChange: p
        }
      ) })
    ] }) }),
    d.length > 0 ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(
        by,
        {
          containerClassName: "dc__border-top-n1",
          profiles: d,
          stickHeading: !0,
          searchText: n,
          reloadProfiles: s,
          targetPlatform: r,
          globalProfile: c
        }
      ),
      l && /* @__PURE__ */ e.jsx("div", { className: "pl pr", children: /* @__PURE__ */ e.jsx(Ty, { handleSuccess: s }) })
    ] }) : /* @__PURE__ */ e.jsx(qt, { handleClearFilters: i, classname: "h-100" })
  ] }) : /* @__PURE__ */ e.jsx(
    _e,
    {
      title: Ks.NO_PROFILE_EMPTY_STATE.title,
      subTitle: Ks.NO_PROFILE_EMPTY_STATE.subTitle
    }
  );
}, vy = () => {
  const t = de(new AbortController()), [s, n, a, r] = ne(
    () => es(
      () => gS({ abortControllerRef: t }),
      t
    )
  ), o = s || Pe(a);
  return /* @__PURE__ */ e.jsx("div", { className: "h-100 flexbox-col dc__gap-16", children: /* @__PURE__ */ e.jsx(
    Ke,
    {
      isLoading: o,
      progressingProps: {
        pageLoader: !0
      },
      error: a,
      errorScreenManagerProps: {
        code: a?.code,
        reload: r
      },
      children: /* @__PURE__ */ e.jsx(Iy, { profiles: n, reloadProfiles: r })
    }
  ) });
}, Ay = async ({
  platformName: t,
  profileName: s
}) => na(ra(), {
  platformName: t,
  profileName: s,
  queries: [
    {
      op: Fn.remove,
      path: Cr.PLATFORM
    }
  ]
}), Sy = async (t, s) => {
  try {
    await na(ra(), {
      profileName: s,
      queries: [
        {
          op: Fn.replace,
          path: Cr.PROFILE,
          value: {
            buildxDriverType: cE(t)
          }
        }
      ]
    }), Z.showToast({
      variant: ee.success,
      description: "K8s driver setting is updated"
    });
  } catch (n) {
    throw V(n), n;
  }
}, yy = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16 cn-8 fs-13 fw-4 lh-20", children: [
  /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "The configurations for the target platforms will be lost." }),
  /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "Are you sure?" })
] }), Ly = ({
  handleAddTargetPlatform: t,
  useK8sDriver: s,
  handleReloadData: n,
  savedProfileName: a,
  targetPlatformLength: r
}) => {
  const [o, i] = v(!1), [l, c] = v(!1), d = () => {
    i(!0);
  }, p = () => {
    i(!1);
  }, m = async () => {
    c(!0);
    const f = !s;
    try {
      await Sy(f, a), p(), n(), c(!1);
    } catch {
      c(!1);
    }
  }, u = async () => {
    s && r > 1 ? d() : await m();
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex column br-4 en-1 bw-1 bg__secondary dc__h-min-content dc__position-sticky dc__top-0 dc__zi-1 dc__align-start", children: [
      /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__gap-8 py-12 px-12 bg__secondary dc__border-bottom-n1", children: l ? /* @__PURE__ */ e.jsx(Je, { size: 20 }) : /* @__PURE__ */ e.jsx(
        $e,
        {
          value: Fe.CHECKED,
          onChange: u,
          isChecked: s,
          rootClassName: "mb-0",
          children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-6 lh-20", children: "Use K8s driver for build" })
        }
      ) }),
      /* @__PURE__ */ e.jsxs("div", { className: "px-16 py-12 flexbox-col dc__gap-16 bg__primary", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-16", children: [
          /* @__PURE__ */ e.jsx("div", { className: "flexbox-col cn-7 fs-13 fw-4 lh-20 dc__gap-16", children: s ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "When building images for a specific platform (e.g., Linux/ARM64), platform-specific configurations defined in this profile will be used." }),
            /* @__PURE__ */ e.jsxs("p", { className: "m-0", children: [
              "If platform-specific resources are not defined in this profile, the process will default to the respective platform's configuration defined in the '",
              ft,
              "' profile, if available."
            ] })
          ] }) : /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "Applications using this profile will use runner configuration, when building images." }) }),
          /* @__PURE__ */ e.jsx(Lb, { className: "icon-dim-36 dc__no-shrink" })
        ] }),
        s && /* @__PURE__ */ e.jsx(
          j,
          {
            dataTestId: "add-target-platform-button",
            size: O.small,
            startIcon: /* @__PURE__ */ e.jsx(Xt, {}),
            text: "Add target platform",
            onClick: t,
            variant: w.secondary
          }
        )
      ] })
    ] }),
    o && /* @__PURE__ */ e.jsx(
      zt,
      {
        variant: Ct.info,
        title: "Disable K8s driver for build",
        subtitle: /* @__PURE__ */ e.jsx(yy, {}),
        handleClose: p,
        buttonConfig: {
          primaryButtonConfig: {
            text: "Disable",
            onClick: m,
            isLoading: l
          },
          secondaryButtonConfig: {
            text: "Cancel",
            onClick: p,
            disabled: l
          }
        }
      }
    )
  ] });
}, jy = ({
  name: t,
  description: s,
  handleReloadData: n
}) => {
  const [a, r] = v(!1), o = () => {
    r(!0);
  }, i = () => {
    r(!1);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12 dc__opacity-hover dc__opacity-hover--parent w-100 pr-12", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6 flex-grow-1", children: [
        /* @__PURE__ */ e.jsx(Ie, { content: t, children: /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-14 fw-6 lh-20 dc__truncate", children: t }) }),
        /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-7 fs-13 fw-4 lh-20 dc__word-break", children: s || "No description provided" })
      ] }),
      /* @__PURE__ */ e.jsx(
        j,
        {
          ariaLabel: `Edit ${t} meta info`,
          dataTestId: `edit-${t}-meta-info`,
          icon: /* @__PURE__ */ e.jsx(Fs, {}),
          onClick: o,
          variant: w.borderLess,
          style: B.neutral,
          size: O.xs,
          showAriaLabelInTippy: !1
        }
      )
    ] }),
    a && /* @__PURE__ */ e.jsx(
      Wf,
      {
        handleCloseModal: i,
        handleReloadData: n,
        isEditView: !0,
        name: t,
        description: s
      }
    )
  ] });
}, Oy = ({
  targetPlatform: t,
  platformConfigurationData: s,
  defaultPlatformConfigurationData: n,
  savedProfileName: a,
  isTargetPlatformCreated: r,
  handleShowDeleteTargetPlatformDialog: o
}) => {
  const i = () => {
    o(t);
  }, l = Pd(t, s), c = Ha.reduce(
    (m, u) => {
      const f = bn(u, t);
      return m[u] = Uf(
        f ? s : n,
        u,
        t
      ), m;
    },
    {}
  ), d = `${t} configuration`, p = t === ht;
  return /* @__PURE__ */ e.jsxs("details", { className: "br-4 en-1 bw-1", open: p || r, children: [
    /* @__PURE__ */ e.jsxs("summary", { className: "flexbox dc__align-items-center dc__content-space bg__secondary dc__opacity-hover dc__opacity-hover--parent p-12 cursor", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12 dc__align-items-start", children: [
        /* @__PURE__ */ e.jsx(gr, { className: "icon-dim-20 dc__no-shrink scn-7 dc__transition--transform dc__flip-180--neg dc__accordion-summary--icon-flip-neg-90" }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
          /* @__PURE__ */ e.jsx(Ie, { content: d, children: /* @__PURE__ */ e.jsx("h4", { className: "m-0 cn-9 fs-13 fw-6 lh-20 dc__truncate", children: d }) }),
          p && /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-9 fs-12 fw-4 lh-20", children: "Used when building an image for a target platform if no specific configuration is set for that platform." })
        ] })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4", children: [
        /* @__PURE__ */ e.jsx(
          Md,
          {
            configurationType: null,
            targetPlatform: t,
            savedProfileName: a,
            isFormView: !0
          }
        ),
        !p && /* @__PURE__ */ e.jsx(
          j,
          {
            dataTestId: `delete-${t}-button`,
            ariaLabel: `Delete ${t} configuration`,
            size: O.xs,
            icon: /* @__PURE__ */ e.jsx(ts, {}),
            variant: w.borderLess,
            style: B.negativeGrey,
            onClick: i,
            showAriaLabelInTippy: !1
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "px-12", children: /* @__PURE__ */ e.jsx(
      Zf,
      {
        locatorToInheritingStatusMap: l,
        targetPlatform: t,
        savedProfileName: a,
        valuesUIConfigurationMap: c,
        canEdit: !0,
        isFormView: !0
      }
    ) })
  ] });
}, Zp = ({ isEditMode: t }) => /* @__PURE__ */ e.jsxs("ul", { className: "m-0 p-12 cn-9 fs-13 fw-4 lh-20", children: [
  /* @__PURE__ */ e.jsx("li", { className: "ml-12", children: (t ? Cs.EDIT_PROFILE_TIPPY : Cs.CREATE_PROFILE_TIPPY).infoText }),
  /* @__PURE__ */ e.jsx("li", { className: "ml-12", children: (t ? Cs.EDIT_PROFILE_TIPPY : Cs.CREATE_PROFILE_TIPPY).additionalContentText })
] }), Ry = (t) => t ? t === ft ? {
  tippyInfoText: "Global profile is applied to all applications by default.",
  tippyAdditionalContent: /* @__PURE__ */ e.jsx("div", { className: "px-12 pb-12", children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Profile enables you to control parameters like CPU, memory, build timeout, node selectors and tolerations to optimize build performance & cost." }) })
} : {
  tippyInfoText: "",
  tippyAdditionalContent: /* @__PURE__ */ e.jsx(Zp, { isEditMode: !0 })
} : {
  tippyInfoText: "",
  tippyAdditionalContent: /* @__PURE__ */ e.jsx(Zp, {})
}, Py = () => {
  const t = Te(), { profileName: s } = Ue(), { targetPlatformFormType: n, updateSearchParams: a, targetPlatform: r, configurationType: o } = _t({
    parseSearchParams: qS
  }), [i, l] = v(""), [c, d] = v(!1), p = () => {
    t.push(Ee.APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA);
  }, m = () => {
    p();
  }, {
    isLoading: u,
    profileResponse: f,
    responseError: _,
    reloadRequest: h,
    /**
     * Would be the dirty state on mount of UpdatePlatformForm would keep this in ref and on close or cancel of form would reset else let the state be
     */
    profileInput: x,
    profileInputErrors: g,
    handleProfileInputChange: E
  } = Dm({
    name: s,
    editProfile: !!s,
    canConfigureUseK8sDriver: !0
  }), C = !u && !_ && !!x?.configurations, [
    b,
    N,
    I,
    T
  ] = ne(Kf), A = JS(x?.configurations), S = (F) => {
    l(F);
  }, L = () => {
    l("");
  }, R = async () => {
    try {
      d(!0), await Ay({
        platformName: i,
        profileName: s
      }), L(), h();
    } catch (F) {
      V(F);
    } finally {
      d(!1);
    }
  }, y = () => {
    a({
      targetPlatformFormType: mo.CREATE,
      targetPlatform: null,
      configurationType: ue.CPU
    });
  }, M = () => {
    a({
      targetPlatformFormType: null,
      targetPlatform: null,
      configurationType: null
    });
  }, P = (F) => {
    a({
      targetPlatform: F
    });
  }, U = (F) => {
    a({
      configurationType: F
    });
  }, G = x?.useK8sDriver, H = () => !n || !C ? !1 : fS(r, G), oe = f?.profile?.type === Pa.GLOBAL, ae = H(), { tippyInfoText: re, tippyAdditionalContent: k } = Ry(s), D = () => ae ? /* @__PURE__ */ e.jsx(
    Qf,
    {
      configurationType: o,
      targetPlatform: r,
      handleClose: M,
      savedProfileName: s,
      profileInput: x,
      handleProfileInputChange: E,
      profileInputErrors: g,
      profileResponse: f,
      handleSuccess: h,
      handleUpdateConfigurationType: U,
      ...n === mo.CREATE ? {
        isPlatformCreationMode: !0,
        isLoadingAllTargetPlatformList: b,
        allTargetPlatformListError: I,
        reloadAllTargetPlatformList: T,
        allTargetPlatformList: N,
        handleUpdateTargetPlatformParams: P
      } : {
        isPlatformCreationMode: !1
      }
    }
  ) : !!i && /* @__PURE__ */ e.jsx(
    zt,
    {
      title: `Delete configuration for ${i}`,
      subtitle: "Are you sure, you want to delete?",
      handleClose: L,
      variant: Ct.delete,
      buttonConfig: {
        primaryButtonConfig: {
          onClick: R,
          isLoading: c,
          text: "Delete"
        },
        secondaryButtonConfig: {
          onClick: L,
          text: "Cancel"
        }
      }
    }
  );
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: "h-100 flexbox-col build-infra dc__content-space bg__primary", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col h-100 dc__gap-16 dc__overflow-hidden", children: [
      /* @__PURE__ */ e.jsx(
        Uc,
        {
          additionalContainerClasses: "pt pr pl dc__mxw-1200 dc__gap-12",
          tippyInfoText: re,
          profileName: s,
          tippyAdditionalContent: k,
          tooltipHeading: oe ? "Global Profile" : "Custom Profile",
          children: C && s && !oe && /* @__PURE__ */ e.jsx(nh, { profileName: s, handleDeleteSuccess: m })
        }
      ),
      /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto pb-16", children: /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__mxw-1200 pl pr", children: /* @__PURE__ */ e.jsx(
        Ke,
        {
          isLoading: u,
          progressingProps: {
            pageLoader: !0
          },
          error: _,
          errorScreenManagerProps: {
            code: _?.code,
            reload: h,
            redirectURL: Ee.APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA
          },
          children: x && /* @__PURE__ */ e.jsxs("div", { className: "dc__grid build-infra__profile-config-form--container dc__column-gap-12", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16", children: [
              !oe && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                /* @__PURE__ */ e.jsx(
                  jy,
                  {
                    name: x.name,
                    description: x.description,
                    handleReloadData: h
                  }
                ),
                /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom-n1" })
              ] }),
              A.map((F) => /* @__PURE__ */ e.jsx(
                Oy,
                {
                  targetPlatform: F,
                  platformConfigurationData: x.configurations[F],
                  defaultPlatformConfigurationData: x.configurations[ht],
                  isTargetPlatformCreated: !f?.profile?.configurations?.[F],
                  savedProfileName: s,
                  handleShowDeleteTargetPlatformDialog: S
                },
                F
              ))
            ] }),
            /* @__PURE__ */ e.jsx(
              Ly,
              {
                handleAddTargetPlatform: y,
                useK8sDriver: G,
                handleReloadData: h,
                savedProfileName: s,
                targetPlatformLength: A.length
              }
            )
          ] })
        }
      ) }) })
    ] }) }),
    D()
  ] });
}, FU = () => /* @__PURE__ */ e.jsx("div", { className: "flexbox-col bg__primary h-100 build-infra", children: /* @__PURE__ */ e.jsxs(Vt, { children: [
  /* @__PURE__ */ e.jsx(ge, { path: se.APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA_PROFILES, exact: !0, children: /* @__PURE__ */ e.jsx(vy, {}) }),
  /* @__PURE__ */ e.jsx(ge, { path: `${Ee.APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA_PROFILE_EDIT}/:profileName`, exact: !0, children: /* @__PURE__ */ e.jsx(Py, {}) }),
  /* @__PURE__ */ e.jsx(ge, { path: Ee.APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA_APPLICATIONS, exact: !0, children: /* @__PURE__ */ e.jsx(NS, { children: /* @__PURE__ */ e.jsx(xy, {}) }) }),
  /* @__PURE__ */ e.jsx(ms, { to: se.APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA_PROFILES })
] }) }), UU = async (t) => {
  try {
    return await le(`${$.CLUSTER_NAMESPACES}/${t}/v2`);
  } catch (s) {
    throw V(s), s;
  }
};
var _o = /* @__PURE__ */ ((t) => (t.START = "Start", t.CTA = "CTA", t))(_o || {}), wy = /* @__PURE__ */ ((t) => (t.CREATE = "create", t.UPDATE = "update", t))(wy || {});
const ah = ({ children: t }) => /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1", children: t });
ah.defaultProps = {
  // Defining for our internal use. We can't rely on name of the component due to minification
  __TYPE: _o.START
};
const rh = ({ children: t }) => t;
rh.defaultProps = {
  __TYPE: _o.CTA
};
const Qr = ({
  apiCallInProgress: t,
  handleModalClose: s,
  children: n,
  closeButtonText: a = "Cancel"
}) => {
  const r = px.toArray(n), o = r.find((l) => l?.props?.__TYPE === _o.CTA), i = r.find(
    (l) => l?.props?.__TYPE === _o.START
  );
  return /* @__PURE__ */ e.jsxs("footer", { className: "dc__position-abs dc__bottom-0 dc__left-0 w-100 bg__primary flexbox dc__content-end dc__border-top-n1 px-20 py-16 dc__gap-12 dc__no-shrink", children: [
    i,
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12", children: [
      /* @__PURE__ */ e.jsx(
        j,
        {
          dataTestId: "cancel-create-cluster-button",
          onClick: s,
          disabled: t,
          text: a,
          variant: w.secondary,
          style: B.neutral
        }
      ),
      o
    ] })
  ] });
};
Qr.Start = ah;
Qr.CTA = rh;
const Dy = () => le($.INFRASTRUCTURE_CHART_METADATA), My = async () => {
  try {
    const { result: t } = await Dy();
    return Object.values(
      t.map(({ installationType: s, valuesSchema: n, installationTypeDisplayName: a, displayName: r, iconUrl: o }) => {
        const i = {
          value: { installationType: s, installationTypeDisplayName: a },
          label: r || a || s,
          startIcon: /* @__PURE__ */ e.jsx(
            Bc,
            {
              imageProps: {
                height: 36,
                width: 36,
                src: o,
                alt: `${r} Icon`
              },
              fallbackImage: /* @__PURE__ */ e.jsx(W, { name: "ic-container", color: "B500" })
            }
          )
        };
        try {
          return {
            ...i,
            schema: JSON.parse(n)
          };
        } catch (l) {
          return {
            ...i,
            errorInParsing: l
          };
        }
      }).reduce(
        (s, n) => {
          const { label: a } = n;
          return s[a] = {
            label: a,
            value: [...s[a]?.value ?? [], n],
            startIcon: n.startIcon
          }, s;
        },
        {}
      )
    );
  } catch (t) {
    throw Pe(t) || V(t), t;
  }
}, oh = ({
  installationId: t,
  installationType: s,
  chartValues: n
}) => {
  const a = Ba({
    baseUrl: $.INFRASTRUCTURE,
    kind: ie.infrastructureInstallation,
    version: mt.v1
  });
  return we(a, {
    installationId: t,
    chartValues: n,
    installationType: s
  });
}, ky = async ({ installationType: t, data: s }) => {
  try {
    const {
      result: { installationId: n }
    } = await oh({ installationType: t, installationId: 0, chartValues: gt(s) });
    return Z.showToast({
      variant: ee.success,
      description: "Cluster creation initiated successfully"
    }), n;
  } catch (n) {
    return Pe(n) || V(n), -1;
  }
}, GU = ({
  apiCallInProgress: t,
  setApiCallInProgress: s,
  handleModalClose: n,
  handleRedirectToClusterInstallationStatus: a
}) => {
  const [r, o] = v(null), [i, l] = v({}), [c, d, p, m] = ne(
    My,
    []
  ), [u, f] = v(null);
  J(() => {
    if (d) {
      f(d[0]);
      const { value: C } = d[0];
      o(C[0].value.installationType), l({});
    }
  }, [d]);
  const _ = Q(
    () => u?.value.find((C) => C.value.installationType === r) ?? null,
    [u, r]
  ), h = (C) => {
    const { value: b } = C;
    f(C), o(b[0].value.installationType), l({});
  }, x = async ({ formData: C }) => {
    l(C), s(!0);
    const b = await ky({
      installationType: r,
      data: C
    });
    s(!1), b !== -1 && a(b);
  }, g = (C = []) => {
    V(new Error(Ji)), console.error("Form Validation Error", C);
  }, E = () => _.errorInParsing ? /* @__PURE__ */ e.jsx(Xe, { subtitle: _.errorInParsing.message }) : /* @__PURE__ */ e.jsx(
    la,
    {
      schema: _.schema,
      onSubmit: x,
      onError: g,
      formData: i,
      uiSchema: { "ui:order": ["name", "region", "vpc_cidr", "*"] },
      experimental_defaultFormStateBehavior: {
        emptyObjectFields: "populateAllDefaults"
      },
      children: /* @__PURE__ */ e.jsxs(Qr, { apiCallInProgress: t, handleModalClose: n, children: [
        /* @__PURE__ */ e.jsx(Qr.Start, { children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__align-items-center h-100", children: [
          /* @__PURE__ */ e.jsx(W, { color: "N700", name: "ic-info-outline", size: 16 }),
          /* @__PURE__ */ e.jsx("span", { className: "cn-7 lh-1-5 fs-13", children: "You can do advanced configuration post cluster creation" })
        ] }) }),
        /* @__PURE__ */ e.jsx(Qr.CTA, { children: /* @__PURE__ */ e.jsx(
          j,
          {
            text: "Create Cluster",
            size: O.large,
            dataTestId: "create-cluster-button",
            buttonProps: { type: "submit" },
            isLoading: t
          }
        ) })
      ] })
    },
    _.value.installationType
  );
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto dc__gap-16 p-20 bg__secondary", children: [
    !window._env_?.FEATURE_INFRA_PROVISION_INFO_BLOCK_HIDE && /* @__PURE__ */ e.jsx(
      Ot,
      {
        description: /* @__PURE__ */ e.jsxs("div", { className: "flexbox", children: [
          "This feature requires that OpenTofu, a FluxCD controller, is installed.  ",
          /* @__PURE__ */ e.jsx(
            $a,
            {
              docLinkKey: "GLOBAL_CONFIG_CLUSTER",
              text: "Learn more",
              dataTestId: "learn-more-about-cluster-and-environments-link",
              showExternalIcon: !0,
              size: O.xs,
              openInNewTab: !0
            }
          )
        ] }),
        variant: "information"
      }
    ),
    /* @__PURE__ */ e.jsx(
      Ke,
      {
        isLoading: c,
        progressingProps: {
          pageLoader: !0,
          size: 32
        },
        error: p || !c && !u,
        genericSectionErrorProps: {
          reload: m,
          rootClassName: "mh-250 bg__primary br-8 border__secondary"
        },
        children: u && _ && r && /* @__PURE__ */ e.jsxs("div", { className: "bg__primary br-8 border__secondary flexbox-col", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-20 px-20 pt-20", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12 dc__align-items-center", children: [
              /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-20 cn-7 w-250 dc__no-shrink", children: "Cluster Provider" }),
              /* @__PURE__ */ e.jsx(
                Ve,
                {
                  inputId: "create-cluster-select-picker",
                  options: d,
                  value: u,
                  onChange: h,
                  fullWidth: !0
                }
              )
            ] }),
            u.value.length > 1 && /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12 dc__align-items-center", children: [
              /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-20 cn-7 w-250", children: "Installation Type" }),
              /* @__PURE__ */ e.jsx(
                ds,
                {
                  className: "radio-group-no-border installation-type-radio",
                  value: r,
                  name: "installation-type-radio-group",
                  onChange: (C) => {
                    o(C.target.value);
                  },
                  children: u.value.map(({ label: C, value: b }) => /* @__PURE__ */ e.jsx(
                    Ze,
                    {
                      dataTestId: `${C}--radio`,
                      value: b.installationType,
                      children: b.installationTypeDisplayName || C
                    }
                  ))
                }
              )
            ] }),
            /* @__PURE__ */ e.jsx("div", { className: "divider__secondary--horizontal" })
          ] }),
          E()
        ] })
      }
    )
  ] });
}, Fy = () => /* @__PURE__ */ e.jsxs("div", { className: "p-12 fs-13 lh-20 cn-9", children: [
  /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "Labels will be attached to the provided namespace in the Kubernetes cluster." }),
  /* @__PURE__ */ e.jsx("br", {}),
  /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "Use these labels to filter/identify resources via CLI or in other Kubernetes tools." })
] }), Uy = ({ tags: t = [], setTags: s }) => {
  const n = () => {
    const l = {
      id: t.length + 1,
      key: "",
      value: "",
      propagate: !0,
      isPropagateDisabled: !0
    };
    s([l, ...t]);
  }, a = (l, c) => {
    const d = t.map((p, m) => l === m ? c : p);
    s(d);
  }, r = (l) => {
    const c = t.filter((d, p) => l !== p);
    s(c);
  }, o = () => /* @__PURE__ */ e.jsx(
    Dt,
    {
      theme: Mt.white,
      className: "w-300",
      placement: "top",
      Icon: Np,
      iconClass: "icon-dim-20",
      heading: "Propagate labels to namespace",
      infoText: "",
      additionalContent: Fy(),
      trigger: "click",
      interactive: !0,
      showCloseButton: !0,
      documentationLink: "KUBERNETES_LABELS",
      documentationLinkText: "Learn more about labels",
      openInNewTab: !0,
      children: /* @__PURE__ */ e.jsxs("button", { type: "button", className: "dc__transparent flex dc__gap-4", children: [
        /* @__PURE__ */ e.jsx(Np, { className: "icon-dim-16" }),
        /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-20 cn-7", children: "Propagate labels" }),
        /* @__PURE__ */ e.jsx(Ya, { className: "icon-dim-16 fcn-6" })
      ] })
    }
  ), i = () => /* @__PURE__ */ e.jsx("div", { children: t.map((l, c) => /* @__PURE__ */ e.jsx(dE, { index: c, tagData: l, setTagData: a, removeTag: r }, l.id)) });
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__content-space", children: [
      /* @__PURE__ */ e.jsx(
        j,
        {
          startIcon: /* @__PURE__ */ e.jsx(Xt, {}),
          dataTestId: "add-environment-label-button",
          text: "Add label",
          variant: w.text,
          onClick: n
        }
      ),
      o()
    ] }),
    i()
  ] });
}, Il = ({ heading: t, description: s }) => /* @__PURE__ */ e.jsxs("div", { className: "flex column dc__gap-4 text-center", children: [
  /* @__PURE__ */ e.jsx("h4", { className: "m-0 fs-13 lh-20 fw-6 cn-9", children: t }),
  /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-13 lh-20 cn-7", children: s })
] }), BU = ({ isLoading: t, error: s, addLabel: n, reload: a, tags: r, setTags: o }) => {
  const i = !(t || s) && !!r, l = () => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Je, { size: 24 }),
    /* @__PURE__ */ e.jsx(Il, { heading: "Connecting to cluster", description: "Checking for namespace and labels" })
  ] }), c = () => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(h_, { className: "icon-dim-24" }),
    /* @__PURE__ */ e.jsx(
      Il,
      {
        heading: s.code === da.SERVICE_TEMPORARY_UNAVAILABLE ? "Cluster not reachable" : s.code.toString(),
        description: s.errors[0].userMessage
      }
    ),
    /* @__PURE__ */ e.jsx(
      j,
      {
        variant: w.borderLess,
        size: O.small,
        dataTestId: "add-environment-labels-button",
        text: "Retry",
        onClick: a
      }
    )
  ] }), d = () => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Pb, { className: "icon-dim-24 scb-5" }),
    /* @__PURE__ */ e.jsx(
      Il,
      {
        heading: "Add/Edit labels to namespace",
        description: "Labels will be attached to the provided namespace in the Kubernetes cluster"
      }
    ),
    /* @__PURE__ */ e.jsx(
      j,
      {
        variant: w.borderLess,
        size: O.small,
        dataTestId: "environment-labels-button",
        text: "Add/Edit labels",
        onClick: n
      }
    )
  ] });
  return i ? /* @__PURE__ */ e.jsx(Uy, { tags: r, setTags: o }) : /* @__PURE__ */ e.jsx("div", { className: "flex bg__secondary py-24 px-16", children: /* @__PURE__ */ e.jsxs("div", { className: "flex column dc__gap-12 dc__mxw-300 mx-auto", children: [
    t && l(),
    !t && (s ? c() : d())
  ] }) });
}, eu = {
  [sr.USERNAME_PASSWORD]: "User Auth",
  [sr.ANONYMOUS]: "Anonymous"
}, $U = ({
  authenticationType: t,
  handleChangeOtherRegistryAuthType: s
}) => /* @__PURE__ */ e.jsxs(
  ds,
  {
    className: "flex-wrap regisrty-form__radio-group",
    value: t,
    name: "authentication-type",
    onChange: s,
    children: [
      /* @__PURE__ */ e.jsx("span", { className: "flex left cn-7 w-150 mr-16 fs-13 fw-6 lh-20 dc__required-field", children: "Authentication" }),
      /* @__PURE__ */ e.jsx(Ze, { value: sr.USERNAME_PASSWORD, dataTestId: "registry-user-auth-radio", children: eu[sr.USERNAME_PASSWORD] }),
      /* @__PURE__ */ e.jsx(Ze, { value: sr.ANONYMOUS, dataTestId: "registry-anonymous-auth-radio", children: eu[sr.ANONYMOUS] })
    ]
  }
);
var Xs = /* @__PURE__ */ ((t) => (t.GUI_SCHEMA = "guiSchema", t.HIBERNATION_PATCH = "hibernationPatch", t))(Xs || {});
const tu = {
  guiSchema: !0,
  hibernationPatch: !0
}, Gy = (t) => Object.keys(tu).reduce((s, n) => (s[n] = tu[n] && !t ? "" : null, s), {}), By = {
  resourceValue: {
    guiSchema: (t) => pE(t, !0),
    hibernationPatch: uE
  }
}, $y = {
  heading: "GUI Schema",
  tooltipHeading: "GUI Schema",
  tippyInfoText: /* @__PURE__ */ e.jsxs("div", { className: "fs-13 fw-4 lh-20", children: [
    /* @__PURE__ */ e.jsxs("p", { children: [
      "GUI Schema creates user-friendly forms for ",
      /* @__PURE__ */ e.jsx(
        $a,
        {
          docLinkKey: "DEPLOYMENT_CONFIGS",
          text: "Deployment Templates",
          dataTestId: "deployment-templates-link"
        }
      ),
      ". This helps users who:",
      /* @__PURE__ */ e.jsxs("ol", { children: [
        /* @__PURE__ */ e.jsx("li", { children: "Are unfamiliar with values.yaml" }),
        /* @__PURE__ */ e.jsx("li", { children: "Only need to adjust a few settings" })
      ] })
    ] }),
    /* @__PURE__ */ e.jsx("p", { children: "These forms appear next to the YAML configurations in Devtron Applications." })
  ] }),
  editorMode: Ts.JSON
}, Vy = {
  replicaCount: 0,
  autoscaling: {
    MinReplicas: 0,
    MaxReplicas: 0,
    enabled: !1
  },
  kedaAutoscaling: {
    minReplicaCount: 0,
    maxReplicaCount: 0,
    enabled: !1
  }
}, Yy = {
  heading: "Hibernation Patch (YAML)",
  tooltipHeading: "Hibernation Patch",
  additionalContent: /* @__PURE__ */ e.jsxs("div", { className: "p-12 fs-13 fw-4 lh-20 mxh-220 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsx("p", { children: "The Hibernation Patch is automatically applied to the Deployment Template when an application is hibernated. You can modify specific fields for hibernating applications." }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
      /* @__PURE__ */ e.jsx("span", { children: "Example:" }),
      /* @__PURE__ */ e.jsx("pre", { className: "dc__white-space-pre dc__no-border br-4", children: gt(Vy) })
    ] })
  ] }),
  editorMode: Ts.YAML
}, Hy = Object.values(Xs), Ky = (t) => {
  try {
    return gt(JSON.parse(t));
  } catch {
  }
  return "";
}, Wy = (t, s) => t === Xs.GUI_SCHEMA ? s : s?.trim() ? _E(s) : null, qy = (t) => ({
  // Only send id and resourceName in a put request, for post request BE checks based on selectors
  ...t.resourceId ? { resourceName: t.resourceName, id: t.resourceId } : {},
  resourceValue: Wy(t.resourceType, t.resourceValue),
  resourceType: t.resourceType,
  type: "JSON",
  selectors: [
    {
      attributeSelector: {
        category: "CHART",
        chartVersions: [
          {
            type: t.name,
            version: ""
          }
        ]
      }
    }
  ]
}), zy = (t, s) => ({
  alias: {
    ...$c(),
    configurations: null,
    "deployment-charts": {
      component: /* @__PURE__ */ e.jsx(Ao, { heading: "Deployment Charts" }),
      linked: !0
    },
    ":name": {
      component: /* @__PURE__ */ e.jsx(Ie, { content: t, children: /* @__PURE__ */ e.jsx("span", { className: "fs-16 fw-6 dc__mxw-400 dc__truncate cn-9", children: t }) }),
      linked: !1
    },
    ":resourceType": {
      component: /* @__PURE__ */ e.jsx("span", { className: "fs-16 fw-6 cn-9", children: s === Xs.GUI_SCHEMA ? "Edit GUI Schema" : "Hibernation Patch" }),
      linked: !1
    },
    ":version": null
  }
}), Xy = (t) => JSON.stringify(t, null, 2), ih = (t) => {
  const s = mE(t), n = Xy(s);
  return n === "{}" ? "" : n;
}, Jy = (t) => t === Xs.GUI_SCHEMA ? $y : Yy, Qy = () => {
  const { name: t, resourceType: s } = Ue(), { breadcrumbs: n } = yr(zy(t, s), [t, s]);
  return /* @__PURE__ */ e.jsx("header", { className: "px-20 py-16 dc__no-shrink dc__border-bottom bg__primary", children: /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__gap-4 dc__align-items-center fs-13 flex-grow-1", children: /* @__PURE__ */ e.jsx(Lr, { breadcrumbs: n, className: "flexbox dc__no-decor" }) }) });
}, Zy = async (t, s) => {
  try {
    const { result: n } = await le(
      Ws.DEPLOYMENT_CHARTS_LIST
    ), a = fE(n).find((c) => c.name === t);
    if (!a)
      throw new Ua({
        code: Ns.NOT_FOUND,
        errors: []
      });
    const r = {
      chartType: t,
      resourceType: s
    }, o = ye($.GLOBAL_CONFIG_DEPLOYMENT_CHART_RESOURCE_DETAIL, r), { result: i } = await le(o), l = {
      ...a,
      ...i
    };
    return l.resourceValue || (l.resourceValue = s === Xs.GUI_SCHEMA ? ih(t) : ""), l;
  } catch (n) {
    throw V(n), n;
  }
}, eL = async (t) => {
  try {
    const s = qy(t);
    return await (t.resourceId ? Bt : we)($.GLOBAL_CONFIG_DEPLOYMENT_CHART_RESOURCE, s), Z.showToast({
      variant: ee.success,
      description: t.resourceType === Xs.GUI_SCHEMA ? "GUI Schema updated successfully" : "Hibernation Patch updated successfully"
    }), !0;
  } catch (s) {
    return V(s), !1;
  }
}, tL = async (t) => {
  try {
    const {
      result: { defaultAppOverride: s }
    } = await le(`${$.DEPLOYMENT_TEMPLATE}/${t}`);
    return gt(s);
  } catch (s) {
    return V(s), "";
  }
}, VU = async ({
  appId: t,
  envId: s
}) => {
  const n = ye($.APP_HIBERNATION_PATCH, { appId: t, envId: s }), a = await le(n), { isHibernationPatchConfigured: r, selectors: o } = a.result;
  return {
    isHibernationPatchConfigured: r,
    chartName: o[0].attributeSelector.chartVersions[0].type
  };
};
var xn = /* @__PURE__ */ ((t) => (t.CLOSED = "CLOSED", t.PREVIEW_GUI = "PREVIEW_GUI", t.REFER_YAML = "REFER_YAML", t))(xn || {});
const sL = (t) => {
  switch (t) {
    case xn.PREVIEW_GUI:
      return "GUI (Preview)";
    case xn.REFER_YAML:
      return "Refer YAML (Latest version)";
    default:
      return null;
  }
}, nL = ({ schema: t, isValidSchema: s }) => {
  const [n, a] = v(), [r, o] = v({});
  J(() => {
    try {
      a(JSON.parse(t));
    } catch {
      Be();
    }
  }, [t]);
  const i = (l) => {
    o(l.formData);
  };
  return s ? n ? /* @__PURE__ */ e.jsx(
    la,
    {
      schema: n,
      uiSchema: Fa,
      formData: r,
      onChange: i
    }
  ) : /* @__PURE__ */ e.jsx(
    _e,
    {
      title: "Nothing to show",
      subTitle: "Provide GUI schema to generate a real-time preview of the GUI",
      image: Tp
    }
  ) : /* @__PURE__ */ e.jsx(
    _e,
    {
      title: "Invalid schema found",
      subTitle: "Provide a correct GUI schema to generate a real-time preview of the GUI",
      image: Tp
    }
  );
}, aL = ({ id: t }) => {
  const [s, n] = ne(() => tL(t), [t]);
  return /* @__PURE__ */ e.jsx("div", { className: "dc__overflow-auto h-100", children: /* @__PURE__ */ e.jsx(
    Gt,
    {
      mode: Ts.YAML,
      customLoader: /* @__PURE__ */ e.jsx(Je, { pageLoader: !0 }),
      readOnly: !0,
      loading: s,
      value: n || "",
      height: "100%"
    }
  ) });
}, rL = ({ state: t, setState: s, chartDetail: n, isValidSchema: a }) => {
  const r = (i) => () => {
    s((l) => ({ ...l, type: i }));
  }, o = () => {
    switch (t.type) {
      case xn.PREVIEW_GUI:
        return /* @__PURE__ */ e.jsx(nL, { schema: n.resourceValue, isValidSchema: a });
      case xn.REFER_YAML:
        return /* @__PURE__ */ e.jsx(aL, { id: n.versions[0].id });
      default:
        return null;
    }
  };
  return /* @__PURE__ */ e.jsxs("aside", { className: "flexbox-col bg__primary dc__border-left h-100 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__no-shrink dc__content-space dc__border-bottom-n1 px-16 py-12", children: [
      /* @__PURE__ */ e.jsx("span", { className: "fw-6 fs-13 lh-20 cn-9", children: sL(t.type) }),
      /* @__PURE__ */ e.jsx(
        "button",
        {
          type: "button",
          className: "dc__unset-button-styles flex",
          onClick: r(xn.CLOSED),
          "aria-label": "Close split pane",
          children: /* @__PURE__ */ e.jsx(As, { className: "icon-dim-16 dc__no-shrink" })
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "h-100 dc__overflow-auto", children: o() })
  ] });
}, oL = () => {
  const { replace: t } = Te(), { name: s, resourceType: n } = Ue();
  J(() => {
    Hy.includes(n) || t(se.APPLICATION_MANAGEMENT_CONFIGURATIONS_DEPLOYMENT_CHARTS);
  }, [n]);
  const a = n === Xs.GUI_SCHEMA, [r, o] = v({
    type: xn.CLOSED
  }), [i, l] = v(!1), [c, d] = v(
    Gy(!!s)
  ), [p, m, u, f, _] = ne(
    () => Zy(s, n),
    [s]
  ), h = Q(
    () => a ? ih(s) : m?.defaultValue,
    [s, m]
  ), x = () => {
    if (m.resourceType === Xs.GUI_SCHEMA)
      return m.resourceValue === h;
    const M = Ky(h);
    return (
      // checking with both as initially we receive as json string and after editing it is yaml string
      m.resourceValue === h || m.resourceValue === M
    );
  }, g = r.type !== xn.CLOSED, E = Object.values(c).some((M) => !Ht(M)), C = Object.values(hE).some((M) => M === s) && m && !x(), b = () => {
    C && _({ ...m, resourceValue: h });
  }, N = (M) => (P) => {
    d({
      ...c,
      [M]: By[M][n]?.(P).message ?? null
    }), _({ ...m, [M]: P });
  }, I = (M) => () => {
    o({ ...r, type: M });
  }, T = async () => {
    l(!0), await eL(m) && t(se.APPLICATION_MANAGEMENT_CONFIGURATIONS_DEPLOYMENT_CHARTS), l(!1);
  }, { heading: A, tooltipHeading: S, tippyInfoText: L, editorMode: R, additionalContent: y } = Jy(n);
  return /* @__PURE__ */ e.jsx(
    Ke,
    {
      isLoading: p,
      progressingProps: {
        pageLoader: !0
      },
      error: u,
      errorScreenManagerProps: {
        code: u?.code,
        reload: f,
        redirectURL: se.APPLICATION_MANAGEMENT_CONFIGURATIONS_DEPLOYMENT_CHARTS
      },
      children: m && /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col h-100 deployment-chart-detail bg__tertiary", children: [
        /* @__PURE__ */ e.jsx(Qy, {}),
        /* @__PURE__ */ e.jsx("div", { className: "m-8 dc__overflow-hidden flexbox-col flex-grow-1 br-4 dc__border bg__primary", children: /* @__PURE__ */ e.jsxs("div", { className: `${g ? "dc__grid-half" : "dc__grid-full"} h-100`, children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col h-100 dc__overflow-hidden", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space px-16 py-12 dc__gap-16 dc__border-bottom-n1", children: [
              /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__align-items-center", children: [
                /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4 dc__align-items-center", children: [
                  /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20", children: A }),
                  /* @__PURE__ */ e.jsx(
                    ca,
                    {
                      heading: S,
                      infoText: L,
                      iconClassName: "icon-dim-16 fcn-6",
                      additionalContent: y,
                      ...a ? {
                        documentationLinkText: "Learn how to write schema",
                        documentationLink: "RJSF_PLAYGROUND"
                      } : {}
                    }
                  )
                ] }),
                C && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                  /* @__PURE__ */ e.jsx("div", { className: "dc__divider dc__divider--n1 h-16" }),
                  /* @__PURE__ */ e.jsx(
                    j,
                    {
                      dataTestId: "reset-to-default-schema",
                      size: O.large,
                      text: "Reset to default",
                      startIcon: /* @__PURE__ */ e.jsx(wb, {}),
                      onClick: b,
                      variant: w.text
                    }
                  )
                ] })
              ] }),
              !g && /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__align-items-center", children: [
                a && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                  /* @__PURE__ */ e.jsx(
                    j,
                    {
                      dataTestId: "preview-gui-schema",
                      size: O.large,
                      text: "Preview GUI",
                      onClick: I(
                        xn.PREVIEW_GUI
                      ),
                      variant: w.text
                    }
                  ),
                  /* @__PURE__ */ e.jsx("div", { className: "dc__divider dc__divider--n1 h-16" })
                ] }),
                /* @__PURE__ */ e.jsx(
                  j,
                  {
                    dataTestId: "refer-yaml-button",
                    size: O.large,
                    text: "Refer YAML",
                    onClick: I(xn.REFER_YAML),
                    variant: w.text
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ e.jsx("div", { className: "deployment-chart-detail__editor flexbox-col dc__overflow-hidden h-100", children: /* @__PURE__ */ e.jsx(
              Gt,
              {
                mode: R,
                placeholder: a ? "Enter GUI Schema" : "Enter patch YAML here",
                height: "fitToParent",
                value: m.resourceValue,
                onChange: N("resourceValue")
              }
            ) }),
            /* @__PURE__ */ e.jsx("footer", { className: "px-16 py-12 flexbox dc__no-shrink dc__content-start dc__border-top", children: /* @__PURE__ */ e.jsx(
              j,
              {
                dataTestId: "save-chart",
                isLoading: i,
                disabled: E,
                text: "Save",
                onClick: T,
                showTooltip: E,
                tooltipProps: {
                  content: Mm({
                    type: a ? np.JSON : np.YAML,
                    parsingError: c.resourceValue
                  })
                }
              }
            ) })
          ] }),
          /* @__PURE__ */ e.jsx(
            rL,
            {
              state: r,
              setState: o,
              chartDetail: m,
              isValidSchema: !c.resourceValue
            }
          )
        ] }) })
      ] })
    }
  );
}, YU = () => /* @__PURE__ */ e.jsxs(Vt, { children: [
  /* @__PURE__ */ e.jsx(ge, { exact: !0, path: Y.APPLICATION_MANAGEMENT_CONFIGURATIONS_DEPLOYMENT_CHARTS_EDIT, children: /* @__PURE__ */ e.jsx(oL, {}) }),
  /* @__PURE__ */ e.jsx(ms, { to: se.APPLICATION_MANAGEMENT_CONFIGURATIONS_DEPLOYMENT_CHARTS })
] }), su = [
  {
    label: "GUI Schema",
    resourceType: Xs.GUI_SCHEMA
  },
  {
    label: "Hibernation Patch",
    resourceType: Xs.HIBERNATION_PATCH
  }
], HU = ({ name: t }) => {
  const s = Te(), n = (a) => {
    const r = su.find((o) => o.label === a.id)?.resourceType;
    r && s.push(`${se.APPLICATION_MANAGEMENT_CONFIGURATIONS_DEPLOYMENT_CHARTS}/${t}/${r}`);
  };
  return /* @__PURE__ */ e.jsx(
    ki,
    {
      id: "deployment-chart-action-menu",
      onClick: n,
      options: [
        {
          items: su.map(({ label: a }) => ({
            id: a,
            label: a,
            startIcon: { name: "ic-file-edit" }
          }))
        }
      ],
      buttonProps: {
        dataTestId: "deployment-chart-action-menu-button",
        icon: /* @__PURE__ */ e.jsx(W, { name: "ic-pencil", color: null }),
        variant: w.borderLess,
        ariaLabel: `Edit ${t}`,
        style: B.neutral,
        size: O.xs
      }
    }
  );
};
var mc = /* @__PURE__ */ ((t) => (t.APPLICATION_MANAGEMENT = "application-management", t.POLICIES = "policies", t.DEPLOYMENT_WINDOW = "deployment-window", t.WINDOWS = "windows", t.PROFILE_NAME = ":profileName", t.EDIT = "edit", t.CREATE_PROFILE = "create", t.APPLY_TO = "apply-to", t.LIST = "list", t))(mc || {});
const pt = {
  HEADING: "Deployment Window",
  CREATE: "Create",
  ADD_WINDOW: "Add Window",
  SAVE_SUBMIT: "Save",
  DONE: "Done",
  CANCEL: "Cancel",
  WINDOW_NAME_LABEL: "Window name",
  WINDOW_NAME_PLACEHOLDER: "Enter name for this window",
  DESCRIPTION_LABEL: "Description",
  DESCRIPTION_PLACEHOLDER: "Enter a description for this window",
  DISPLAY_MESSAGE_LABEL: "Display message",
  DISPLAY_MESSAGE_INFO: "Message will be shown in applications on which deployment window is applied",
  SPECIFIC_USERS_INFO: "Selected users must have permission to deploy for selected applications and environments.",
  SUPER_ADMIN: "Super admin",
  SPECIFIC_USERS: "Specific users",
  SPECIFIC_USERS_PLACEHOLDER: "Select users",
  DISPLAY_MESSAGE_PLACEHOLDER: "Enter message here",
  SINGLE_EDIT_SELECT_PREFIX: "deployment-window-profile-select",
  SINGLE_APPLY_PROFILE_SELECT_PLACEHOLDER: "Select deployment windows",
  EMPTY_STATE_TITLE: "Deployment Window – Your deployment time guardian!",
  EMPTY_STATE_SUB_TITLE: "Take control of deployments. Set blackout or maintenance windows to restrict or allow deployments for specific applications and environments.",
  EDIT: "Edit",
  DELETE: "Delete",
  NOTHING_TO_REMOVE: "Nothing to remove. No deployment windows are configured for the selection(s)",
  NO_RESULTS: "No results found",
  COULD_NOT_FOUND: " We Could not find any matching results",
  CLEAR_FILTERS: "Clear Filters",
  TIME_ZONE_SELECT_PLACEHOLDER: "Select time zone"
}, iL = [
  {
    id: "deployment-window-windows-tab",
    label: "Windows",
    tabType: "navLink",
    props: { to: Ee.DEPLOYMENT_WINDOW_WINDOWS }
  },
  {
    id: "deployment-window-apply-to-tab",
    label: "Apply To",
    tabType: "navLink",
    props: { to: Ee.DEPLOYMENT_WINDOW_APPLY_TO }
  }
], qo = {
  SUPERADMIN: "superadmin",
  SPECIFIC_USERS: "specific-users"
};
var or = /* @__PURE__ */ ((t) => (t.FIXED = "Once", t.DAILY = "Daily", t.WEEKLY = "Weekly", t.WEEKLY_RANGE = "Weekly (Range)", t.MONTHLY = "Monthly", t))(or || {}), $r = /* @__PURE__ */ ((t) => (t.DAILY = "Eg. Everyday at 8am", t.WEEKLY = "Eg. Mon, Wed, Fri", t.WEEKLY_RANGE = "Eg. Mon - Fri", t.MONTHLY = "Eg. 14th of every monthly", t))($r || {}), jn = /* @__PURE__ */ ((t) => (t.NAME = "NAME", t.TYPE = "TYPE", t.DESCRIPTION = "DESCRIPTION", t))(jn || {}), Dn = /* @__PURE__ */ ((t) => (t.APP_NAME = "appName", t.ENV_NAME = "envName", t.NAME = "name", t.TYPE = "type", t))(Dn || {}), Ls = /* @__PURE__ */ ((t) => (t.ADD = "Add", t.REMOVE = "Remove", t))(Ls || {}), ea = /* @__PURE__ */ ((t) => (t.APPLIED = "APPLIED", t.ADDED = "ADDED", t.REMOVED = "REMOVED", t))(ea || {}), oi = /* @__PURE__ */ ((t) => (t.UNDO = "UNDO", t.REMOVE = "REMOVE", t))(oi || {}), js = /* @__PURE__ */ ((t) => (t.APPLICATIONS = "applications", t.ENVIRONMENTS = "environments", t.POLICY_NAMES = "policyNames", t))(js || {});
const lL = [
  {
    title: or[he.DAILY],
    value: he.DAILY,
    subTitle: $r[he.DAILY]
  },
  {
    title: or[he.WEEKLY],
    value: he.WEEKLY,
    subTitle: $r[he.WEEKLY]
  },
  {
    title: or[he.WEEKLY_RANGE],
    value: he.WEEKLY_RANGE,
    subTitle: $r[he.WEEKLY_RANGE]
  },
  {
    title: or[he.MONTHLY],
    value: he.MONTHLY,
    subTitle: $r[he.MONTHLY]
  }
];
var je = /* @__PURE__ */ ((t) => (t.START = "start", t.END = "end", t.TIME_FROM = "timeFrom", t.TIME_TO = "timeTo", t.DAY_FROM = "dayFrom", t.DAY_TO = "dayTo", t.WEEK_DAY_FROM = "weekdayFrom", t.WEEK_DAY_TO = "weekdayTo", t.HOUR_FROM = "hourFrom", t.HOUR_TO = "hourTo", t))(je || {}), ba = /* @__PURE__ */ ((t) => (t.WINDOW_NAME = "windowName", t.DESCRIPTION = "description", t.DISPLAY_MESSAGE = "displayMessage", t))(ba || {});
const cL = io.tz.names(), dL = () => cL.map((t) => {
  const s = io.tz(t).format("Z");
  return {
    value: t,
    label: `(GMT ${s}) ${t} `
  };
}), lh = (/* @__PURE__ */ new Date()).getDay(), _c = Object.values(ya)[lh], nu = Object.values(ya)[lh + 1], Vr = { label: "08:00 AM", value: "08:00:00" }, Yr = { label: "08:00 PM", value: "20:00:00" }, fc = { label: "Third Last Day", value: "-3" }, hc = { label: "Last Day", value: "-1" }, gc = hd(), ch = (t) => io.tz(t).format("Z"), pL = ch(gc), au = (t) => {
  let s;
  switch (t) {
    case -1:
      s = "Last Day";
      break;
    case -2:
      s = "Second Last Day";
      break;
    case -3:
      s = "Third Last Day";
      break;
    default:
      s = gE(t);
  }
  return s;
}, uL = { label: `(GMT ${pL}) ${gc} `, value: gc }, dh = (t) => t === null || !t?.length ? { isValid: !1, message: "Duration is required to save this deployment window" } : { isValid: !0, message: "" }, ph = (t) => {
  try {
    return le($.DEPLOYMENT_WINDOW_PROFILE_LIST, { signal: t });
  } catch (s) {
    throw t?.aborted || V(s), s;
  }
}, kd = (t, s) => we($.DEPLOYMENT_WINDOW_APP_ENV_LIST, t, { signal: s }), uh = (t, s) => we($.DEPLOYMENT_WINDOW_BULK_APPLY, t, { signal: s }), mL = (t, s) => le(ye($.CREATE_DEPLOYMENT_WINDOW_PROFILE, { profileName: t }), { signal: s }), _L = (t, s) => Bt($.CREATE_DEPLOYMENT_WINDOW_PROFILE, t, { signal: s }), fL = (t, s) => we($.CREATE_DEPLOYMENT_WINDOW_PROFILE, t, { signal: s }), hL = (t) => we($.VALIDATE_DEPLOYMENT_WINDOW_PROFILE, t), gL = (t) => Js(ye($.CREATE_DEPLOYMENT_WINDOW_PROFILE, { profileId: t })), xL = async (t, s) => {
  try {
    const {
      result: { users: n, totalCount: a }
    } = await le(ye("user/v2", t ?? {}), {
      signal: s
    });
    return {
      users: n,
      totalCount: a
    };
  } catch (n) {
    throw V(n), n;
  }
}, mh = ({
  selectedProfileDataId: t,
  selectedProfileData: s,
  reloadWindow: n,
  closeConfirmationModal: a
}) => {
  const r = async () => {
    await gL(t), n();
  }, o = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 fs-13 cn-7", children: [
    /* @__PURE__ */ e.jsxs("p", { className: "lh-1-54", children: [
      "Deleting this ",
      s.type.toLowerCase(),
      " window will remove the deployment restrictions it imposes."
    ] }),
    /* @__PURE__ */ e.jsx("p", { className: "lh-1-54", children: "Are you sure you want to proceed?" })
  ] });
  return /* @__PURE__ */ e.jsx(
    Sr,
    {
      title: s.name,
      component: `${s.type.toLowerCase()} window`,
      onDelete: r,
      closeConfirmationModal: a,
      subtitle: o()
    }
  );
}, _h = ({
  deploymentWindow: t,
  timeZone: s,
  rootClassName: n = "",
  showStartDate: a = !0,
  showEndDate: r = !0,
  hideTruncate: o = !1
}) => {
  const [i, l] = v(""), c = (T) => it(T).format(Ir.DD_MMM_YYYY_HH_MM), d = (T) => it(T).format("DD MMM YYYY"), p = (T) => it(T, "HH:mm").format("hh:mm"), m = io.tz.names(), u = r && t.timeTo && t.timeTo !== fs, f = a && t.timeFrom && t.timeFrom !== fs, _ = f ? d(t.timeFrom) : "", h = u ? d(t.timeTo) : "", x = `${p(t.hourMinuteFrom)}
    ${Uo(t.hourMinuteFrom)} `, g = `${p(t.hourMinuteTo)}
    ${Uo(t.hourMinuteTo)} `, E = () => {
    let T = "";
    return f && u ? T = `(Recurrence Starts ${_}, Ends ${h})` : f ? T = `(Recurrence Starts ${_})` : u && (T = `(Recurrence Ends ${h})`), T;
  }, C = () => {
    let T = "";
    for (let A = 0; A < m.length; A++)
      m[A] === s && (T = m[A]);
    return io.tz(T).format("Z");
  }, b = (T) => T.map((S) => S.slice(0, 3)).join(", "), N = () => {
    let T = "";
    switch (t.frequency) {
      // TODO extract to a function in utils
      case he.FIXED: {
        T = `
                    Once • ${c(t.timeFrom)}
                    ${Uo(it(t.timeFrom).format("HH:mm"))} ${Ka}
                    ${c(t.timeTo)}
                    ${Uo(it(t.timeTo).format("HH:mm"))}
                `;
        break;
      }
      case he.DAILY: {
        T = `
                    Daily • ${x} ${Ka} ${g} ${E()}`;
        break;
      }
      case he.WEEKLY: {
        T = `
                    Repeats every • ${b(t.weekdays)} •
                    ${x} ${Ka} ${g} ${E()}
                `;
        break;
      }
      case he.MONTHLY: {
        T = `
                    Monthly • ${au(t.dayFrom)} of month
                    ${x} ${Ka}
                    ${au(t.dayTo)} of month
                    ${g} ${E()}
                `;
        break;
      }
      case he.WEEKLY_RANGE: {
        T = `
                    Weekly • ${Ft(t.weekdayFrom).substring(0, 3)},
                   ${x} ${Ka}
                    ${Ft(t.weekdayTo).substring(0, 3)},
                      ${g} ${E()}
                `;
        break;
      }
      default: {
        T = `${_} ${Ka} ${h} ${E()}`;
        break;
      }
    }
    l(T);
  };
  J(() => {
    N();
  }, [t, f, u]);
  const I = `${i} GMT${C()}`;
  return /* @__PURE__ */ e.jsx(lt, { className: "default-tt", arrow: !1, placement: "top", content: I, children: /* @__PURE__ */ e.jsx("span", { className: `${o ? "" : "dc__truncate"} ${n}`, children: I }) });
}, EL = (t, s) => {
  const n = t === Zt.BLACKOUT ? Fb : Ub;
  return /* @__PURE__ */ e.jsx(n, { className: " icon-dim-24" });
}, fh = (t) => t === Zt.BLACKOUT ? /* @__PURE__ */ e.jsx(Gb, { className: "icon-dim-16 scn-6" }) : /* @__PURE__ */ e.jsx(Oo, { className: "icon-dim-16 scn-6" }), ru = (t, s) => t.label < s.label ? -1 : t.label > s.label ? 1 : 0, CL = (t) => {
  let s = "";
  return t === ea.ADDED ? s = "bcg-1" : t === ea.REMOVED && (s = "bcr-1"), s;
}, bL = (t) => {
  if (Array.isArray(t) && t.length > 0) {
    const s = t.filter((r) => r.type === Zt.BLACKOUT).map((r) => ({
      label: r.label,
      value: r.value,
      type: r.type
    })), n = t.filter((r) => r.type !== Zt.BLACKOUT).map((r) => ({
      label: r.label,
      value: r.value,
      type: r.type
    })), a = [];
    return s.length > 0 && a.push({
      label: `${Ft(Zt.BLACKOUT)} windows`,
      options: s.sort(ru)
    }), n.length > 0 && a.push({
      label: `${Ft(Zt.MAINTENANCE)} windows`,
      options: n.sort(ru)
    }), a;
  }
  return [];
}, NL = (t) => t.map((n) => ({
  label: `Project: ${n.projectName}`,
  options: n.appList.map((a) => ({
    label: a.name,
    value: a.name,
    projectName: n.projectName,
    appId: a.id
  }))
})), TL = (t) => {
  let s = t;
  const n = s.reduce((a, r) => {
    const o = { ...a };
    return o[r.cluster_name] || (o[r.cluster_name] = []), o[r.cluster_name].push({
      label: r.environment_name,
      value: r.environment_name,
      clusterName: r.cluster_name
    }), o;
  }, {});
  return s = Object.entries(n).map(([a, r]) => ({
    label: `Cluster: ${a}`,
    options: r
  })), s;
}, IL = (t) => t.reduce((n, a) => (n[a.name] = a, n), {}), vL = (t) => t.map((n) => ({
  label: n.name,
  value: n.name,
  type: n.type,
  appliedStatus: ea.APPLIED
})), cl = (t) => ({
  [xa.APPLICATIONS]: t.getAll(xa.APPLICATIONS) || [],
  [xa.ENVIRONMENTS]: t.getAll(xa.ENVIRONMENTS) || [],
  [xa.POLICY_NAMES]: t.getAll(xa.POLICY_NAMES) || []
}), AL = (t, s, n) => {
  let a = {};
  const r = n.timeFrom ?? fs, o = n.timeTo ?? fs;
  switch (t) {
    case he.FIXED: {
      a = {
        // Spreading default values
        ...s,
        timeFrom: n.timeFrom,
        timeTo: n.timeTo,
        id: n.id,
        frequency: he.FIXED
      };
      break;
    }
    case he.DAILY: {
      a = {
        ...s,
        timeFrom: r,
        timeTo: o,
        hourMinuteFrom: n.hourMinuteFrom,
        hourMinuteTo: n.hourMinuteTo,
        frequency: he.DAILY
      };
      break;
    }
    case he.WEEKLY: {
      a = {
        ...s,
        weekdays: n.weekdays,
        frequency: he.WEEKLY,
        timeFrom: r,
        timeTo: o,
        hourMinuteFrom: n.hourMinuteFrom,
        hourMinuteTo: n.hourMinuteTo
      };
      break;
    }
    case he.WEEKLY_RANGE: {
      a = {
        ...s,
        weekdayFrom: n.weekdayFrom,
        weekdayTo: n.weekdayTo,
        frequency: he.WEEKLY_RANGE,
        timeFrom: r,
        timeTo: o,
        hourMinuteFrom: n.hourMinuteFrom,
        hourMinuteTo: n.hourMinuteTo
      };
      break;
    }
    case he.MONTHLY: {
      a = {
        ...s,
        dayFrom: n.dayFrom,
        dayTo: n.dayTo,
        frequency: he.MONTHLY,
        hourMinuteFrom: n.hourMinuteFrom,
        hourMinuteTo: n.hourMinuteTo,
        timeFrom: r,
        timeTo: o
      };
      break;
    }
  }
  return a;
}, SL = (t, s, n) => {
  let a = {
    timeFrom: fs,
    timeTo: fs,
    hourMinuteFrom: "",
    hourMinuteTo: "",
    dayFrom: 0,
    dayTo: 0,
    weekdayFrom: "",
    weekdayTo: "",
    frequency: he.FIXED,
    weekdays: null
  };
  switch (t.frequency) {
    case he.FIXED: {
      a = {
        ...a,
        frequency: he.FIXED,
        timeFrom: t.timeFrom,
        timeTo: t.timeTo,
        id: t.id
      };
      break;
    }
    case he.DAILY: {
      a = {
        ...a,
        frequency: he.DAILY,
        timeFrom: s ? t.timeFrom : a.timeFrom,
        timeTo: n ? t.timeTo : a.timeTo,
        id: t.id,
        hourMinuteFrom: t.hourMinuteFrom,
        hourMinuteTo: t.hourMinuteTo
      };
      break;
    }
    case he.WEEKLY: {
      a = {
        ...a,
        frequency: he.WEEKLY,
        id: t.id,
        hourMinuteFrom: t.hourMinuteFrom,
        hourMinuteTo: t.hourMinuteTo,
        weekdays: t.weekdays,
        timeFrom: s ? t.timeFrom : a.timeFrom,
        timeTo: n ? t.timeTo : a.timeTo
      };
      break;
    }
    case he.WEEKLY_RANGE: {
      a = {
        ...a,
        frequency: he.WEEKLY_RANGE,
        id: t.id,
        weekdayFrom: Ft(t.weekdayFrom),
        weekdayTo: Ft(t.weekdayTo),
        hourMinuteFrom: t.hourMinuteFrom,
        hourMinuteTo: t.hourMinuteTo,
        timeFrom: s ? t.timeFrom : a.timeFrom,
        timeTo: n ? t.timeTo : a.timeTo
      };
      break;
    }
    case he.MONTHLY: {
      a = {
        ...a,
        frequency: he.MONTHLY,
        id: t.id,
        dayFrom: Number(t.dayFrom),
        dayTo: Number(t.dayTo),
        hourMinuteFrom: t.hourMinuteFrom,
        hourMinuteTo: t.hourMinuteTo,
        timeFrom: s ? t.timeFrom : a.timeFrom,
        timeTo: n ? t.timeTo : a.timeTo
      };
      break;
    }
  }
  return a;
}, yL = ({ deploymentWindow: t, setDeploymentWindow: s }) => {
  const n = () => lL.map((r) => /* @__PURE__ */ e.jsx("div", { className: "px-8 py-6", children: /* @__PURE__ */ e.jsxs(
    Ze,
    {
      value: r.value,
      dataTestId: `window-frequency-${r.title.toLowerCase()}`,
      children: [
        r.title,
        /* @__PURE__ */ e.jsx("div", { className: "cn-7 dc__ellipsis-right dc__mxw-132", children: r.subTitle })
      ]
    }
  ) }, r.title)), a = (r) => {
    const o = r.target.value, i = { ...t };
    i.frequency = o, o === he.FIXED && (i.timeFrom = t.timeFrom === fs ? sn(null).toISOString() : t.timeFrom, i.timeTo = t.timeTo === fs ? sn(null, !0).toISOString() : t.timeTo), s(i);
  };
  return /* @__PURE__ */ e.jsx("div", { className: "add_duration-sidebar dc__border-right p-16 w-200 h-300", children: /* @__PURE__ */ e.jsxs(
    ds,
    {
      className: "no-border flexbox-col",
      value: t.frequency,
      name: "window-frequency",
      onChange: a,
      children: [
        /* @__PURE__ */ e.jsx("div", { className: "px-8 py-6", children: /* @__PURE__ */ e.jsx(
          Ze,
          {
            value: he.FIXED,
            dataTestId: `window-frequency-${he.FIXED.toLowerCase()}`,
            children: or.FIXED
          }
        ) }),
        /* @__PURE__ */ e.jsx("div", { className: "fs-12 fw-6 px-8 py-6", children: "REPEATS" }),
        n()
      ]
    }
  ) });
}, LL = ({
  deploymentWindow: t,
  setDeploymentWindow: s,
  timezone: n,
  showStartDate: a,
  setShowStartDate: r,
  showEndDate: o,
  setShowEndDate: i
}) => {
  const l = (k) => {
    let D;
    return k === je.HOUR_FROM ? t.hourMinuteFrom ? D = ap.find(
      (F) => F.value?.toString().substring(0, 5) === t.hourMinuteFrom
    ) : D = Vr : k === je.HOUR_TO && (t.hourMinuteTo ? D = ap.find(
      (F) => F.value?.toString().substring(0, 5) === t.hourMinuteTo
    ) : D = Yr), D;
  }, c = (k) => {
    let D;
    return k === je.DAY_FROM ? t.dayFrom ? D = rp.find(
      (F) => F.value === t.dayFrom.toString()
    ) : D = fc : k === je.DAY_TO && (t.hourMinuteTo ? D = rp.find((F) => F.value === t.dayTo.toString()) : D = hc), D;
  }, [d, p] = v(sn(null)), [m, u] = v(sn(null, !0)), [f, _] = v(
    fc
  ), [h, x] = v(
    hc
  ), [g, E] = v(l(je.HOUR_FROM)), [C, b] = v(l(je.HOUR_TO));
  J(() => {
    _(c(je.DAY_FROM)), x(c(je.DAY_TO)), E(l(je.HOUR_FROM)), b(l(je.HOUR_TO));
  }, [t]);
  const N = t.frequency === he.DAILY || t.frequency === he.WEEKLY, I = (k) => {
    s({
      ...t,
      weekdays: t.weekdays?.includes(k) ? t.weekdays.filter((D) => D !== k) : [...t.weekdays, k]
    });
  }, T = (k, D) => {
    D === je.DAY_FROM ? (_(k), s({
      ...t,
      dayFrom: k.value
    })) : (x(k), s({
      ...t,
      dayTo: k.value
    }));
  }, A = () => {
    const k = Object.values(ya);
    return /* @__PURE__ */ e.jsx("div", { className: "flex dc__content-space", children: k.map((D) => /* @__PURE__ */ e.jsx(
      "div",
      {
        className: `flexbox bw-1 pl-10 pr-10 pt-8 pb-8 br-18 cursor ${t.weekdays?.includes(Ft(D)) ? "eb-3 cb-5 bc-b50" : "en-2"}`,
        onClick: () => I(Ft(D)),
        children: Ft(D.slice(0, 3))
      },
      D
    )) });
  }, S = (k, D) => {
    const F = k.toISOString();
    if (D === je.TIME_FROM)
      if (p(k), new Date(k) >= new Date(t.timeTo)) {
        const q = new Date(k);
        q.setUTCDate(k.getUTCDate() + 1), u(q), s({
          ...t,
          timeFrom: F,
          timeTo: q.toISOString()
        });
      } else
        s({
          ...t,
          timeFrom: F
        });
    else
      u(k), s({
        ...t,
        timeTo: F
      });
  }, L = (k) => k === je.TIME_FROM ? t.timeFrom ? new Date(t.timeFrom) : d : t.timeTo ? new Date(t.timeTo) : m, R = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16", children: [
    /* @__PURE__ */ e.jsx(
      tr,
      {
        date: L(je.TIME_FROM),
        onChange: (k) => S(k, je.TIME_FROM),
        label: "From (Date & Time)",
        required: !0,
        id: "window-time-from"
      }
    ),
    /* @__PURE__ */ e.jsx(
      tr,
      {
        date: L(je.TIME_TO),
        onChange: (k) => S(k, je.TIME_TO),
        label: "To (Date & Time)",
        required: !0,
        id: "window-time-to"
      }
    )
  ] }), y = (k, D) => {
    const F = k.value.substring(0, 5);
    D === je.HOUR_FROM ? E(k) : D === je.HOUR_TO && b(k), s({
      ...t,
      hourMinuteFrom: D === je.HOUR_FROM ? F : t.hourMinuteFrom.substring(0, 5),
      hourMinuteTo: D === je.HOUR_TO ? F : t.hourMinuteTo.substring(0, 5)
    });
  }, M = () => /* @__PURE__ */ e.jsxs("div", { className: `${N ? " dc__grid-cols-2" : "flexbox-col"} dc__gap-16 pb-16`, children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6", children: [
      /* @__PURE__ */ e.jsx("div", { className: "cn-7 lh-20", children: "From (Time)" }),
      /* @__PURE__ */ e.jsx(
        Wa,
        {
          onChange: (k) => y(k, je.HOUR_FROM),
          selectedTimeOption: g,
          default12HourTime: Vr
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6", children: [
      /* @__PURE__ */ e.jsx("div", { className: "cn-7 lh-20", children: "To (Time)" }),
      /* @__PURE__ */ e.jsx(
        Wa,
        {
          onChange: (k) => y(k, je.HOUR_TO),
          selectedTimeOption: C,
          default12HourTime: Yr
        }
      )
    ] })
  ] }), P = (k, D) => {
    D === je.WEEK_DAY_FROM ? s({
      ...t,
      weekdayFrom: k.value
    }) : s({
      ...t,
      weekdayTo: k.value
    });
  }, U = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6", children: [
      /* @__PURE__ */ e.jsx("div", { className: "cn-7 lh-20", children: "From (Day of week & Time)" }),
      /* @__PURE__ */ e.jsxs("div", { className: "dc__grid-cols-2 dc__gap-8", children: [
        /* @__PURE__ */ e.jsx(
          Ve,
          {
            inputId: "week-day-to-select",
            placeholder: "Friday",
            options: Object.values(ya).map((k) => ({
              label: Ft(k),
              value: k
            })),
            isSearchable: !1,
            value: {
              label: Ft(
                t.weekdayFrom ? t.weekdayFrom : _c
              ),
              value: t.weekdayFrom ? t.weekdayFrom : _c
            },
            onChange: (k) => P(k, je.WEEK_DAY_FROM)
          }
        ),
        /* @__PURE__ */ e.jsx(
          Wa,
          {
            onChange: (k) => y(k, je.HOUR_FROM),
            selectedTimeOption: g,
            default12HourTime: Vr
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6", children: [
      /* @__PURE__ */ e.jsx("div", { className: "cn-7 lh-20", children: "To (Day of week & Time)" }),
      /* @__PURE__ */ e.jsxs("div", { className: "dc__grid-cols-2 dc__gap-8", children: [
        /* @__PURE__ */ e.jsx(
          Ve,
          {
            inputId: "weekly-date-select-from",
            placeholder: "Monday",
            options: Object.values(ya).map((k) => ({
              label: Ft(k),
              value: k
            })),
            isSearchable: !1,
            value: {
              label: Ft(
                t.weekdayTo ? t.weekdayTo : nu
              ),
              value: t.weekdayTo ? t.weekdayFrom : nu
            },
            onChange: (k) => P(k, je.WEEK_DAY_TO)
          }
        ),
        /* @__PURE__ */ e.jsx(
          Wa,
          {
            onChange: (k) => y(k, je.HOUR_TO),
            selectedTimeOption: C,
            default12HourTime: Yr
          }
        )
      ] })
    ] })
  ] }), G = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6", children: [
      /* @__PURE__ */ e.jsx("div", { className: "cn-7 lh-20", children: "From (Day of month & Time)" }),
      /* @__PURE__ */ e.jsxs("div", { className: "dc__grid-cols-2 dc__gap-8", children: [
        /* @__PURE__ */ e.jsx(
          op,
          {
            selectedMonthlyDate: f,
            onChange: (k) => T(k, je.DAY_FROM)
          }
        ),
        /* @__PURE__ */ e.jsx(
          Wa,
          {
            onChange: (k) => y(k, je.HOUR_FROM),
            selectedTimeOption: g,
            default12HourTime: Vr
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6", children: [
      /* @__PURE__ */ e.jsx("div", { className: "cn-7 lh-20", children: "To (Day of month & Time)" }),
      /* @__PURE__ */ e.jsxs("div", { className: "dc__grid-cols-2 dc__gap-8", children: [
        /* @__PURE__ */ e.jsx(
          op,
          {
            selectedMonthlyDate: h,
            onChange: (k) => T(k, je.DAY_TO)
          }
        ),
        /* @__PURE__ */ e.jsx(
          Wa,
          {
            onChange: (k) => y(k, je.HOUR_TO),
            selectedTimeOption: C,
            default12HourTime: Yr
          }
        )
      ] })
    ] })
  ] }), H = () => t.frequency === he.FIXED ? R() : N ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16", children: [
    t.frequency === he.WEEKLY && A(),
    M()
  ] }) : t.frequency === he.WEEKLY_RANGE ? U() : t.frequency === he.MONTHLY ? G() : null, oe = (k) => {
    k.target.name === je.START ? (r(!a), s({
      ...t,
      timeFrom: t.timeFrom === fs ? sn(null).toISOString() : t.timeFrom
    })) : (i(!o), s({
      ...t,
      timeTo: t.timeTo === fs ? sn(null, !0).toISOString() : t.timeTo
    }));
  }, ae = () => t.frequency !== he.FIXED && /* @__PURE__ */ e.jsxs("div", { className: "dc__border-top-n1 pt-16 flexbox-col dc__gap-12", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8", children: [
        /* @__PURE__ */ e.jsx(
          $e,
          {
            isChecked: a,
            onChange: oe,
            rootClassName: "icon-dim-20 mb-0-imp",
            dataTestId: `${je.START}-date`,
            value: Fe.CHECKED,
            name: je.START
          }
        ),
        /* @__PURE__ */ e.jsx("span", { className: "cn-7 lh-20", children: "Set start date" })
      ] }),
      a && /* @__PURE__ */ e.jsx("div", { className: "ml-28 flex-grow-none w-200", children: /* @__PURE__ */ e.jsx(
        tr,
        {
          date: L(je.TIME_FROM),
          onChange: (k) => S(k, je.TIME_FROM),
          id: "time-from",
          hideTimeSelect: !0
        }
      ) })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8", children: [
        /* @__PURE__ */ e.jsx(
          $e,
          {
            isChecked: o,
            onChange: oe,
            rootClassName: "icon-dim-20 mb-0-imp",
            dataTestId: `${je.END}-date`,
            value: Fe.CHECKED,
            name: je.END
          }
        ),
        /* @__PURE__ */ e.jsx("span", { className: "cn-7 lh-20", children: "Set end date" })
      ] }),
      o && /* @__PURE__ */ e.jsx("div", { className: "ml-28 flex-grow-none w-200", children: /* @__PURE__ */ e.jsx(
        tr,
        {
          date: L(je.TIME_TO),
          onChange: (k) => S(k, je.TIME_TO),
          id: "time-to",
          hideTimeSelect: !0,
          isTodayBlocked: !0
        }
      ) })
    ] })
  ] }), re = () => /* @__PURE__ */ e.jsxs("div", { className: "flex top left pt-16 dc__gap-8", children: [
    /* @__PURE__ */ e.jsx(Or, { className: "icon-dim-20 dc__no-shrink" }),
    /* @__PURE__ */ e.jsx(
      _h,
      {
        deploymentWindow: t,
        timeZone: n,
        showStartDate: a,
        showEndDate: o,
        hideTruncate: !0
      }
    )
  ] });
  return /* @__PURE__ */ e.jsx("div", { className: "window-configuration flexbox-col w-100 h-100 dc__overflow-hidden dc__gap-16", children: /* @__PURE__ */ e.jsxs("div", { className: "dc__overflow-auto h-300 py-16 px-16 ", children: [
    H(),
    ae(),
    re()
  ] }) });
}, jL = ({
  closeDurationModal: t,
  deploymentWindowProfile: s,
  setDeploymentWindowProfile: n,
  timezone: a,
  sequentialIndex: r
}) => {
  const [o, i] = v(!1), [l, c] = v(!1), [d, p] = v(""), [m, u] = v(!1), [f, _] = v({
    timeFrom: sn(null).toISOString(),
    timeTo: sn(null, !0).toISOString(),
    hourMinuteFrom: Vr.value.substring(0, 5),
    hourMinuteTo: Yr.value.substring(0, 5),
    dayFrom: Number(fc.value),
    dayTo: Number(hc.value),
    weekdayFrom: ya.MONDAY,
    weekdayTo: ya.FRIDAY,
    frequency: he.FIXED,
    weekdays: [Ft(_c)]
  }), h = (N, I) => {
    const T = I.deploymentWindowList[N];
    i(T.timeFrom !== fs), c(T.timeTo !== fs);
    const A = AL(
      T.frequency,
      f,
      T
    );
    _(A), p("");
  };
  J(() => {
    p("");
  }, [f.frequency]), J(() => {
    r > -1 && h(r, s);
  }, [r]);
  const x = () => {
    const N = s.deploymentWindowList || [], I = SL(f, o, l);
    r === -1 ? N.push(I) : N[r] = { ...I }, u(!0), hL(I).then((T) => {
      const A = {
        ...s,
        deploymentWindowList: N
      };
      T && (n(A), t(A.deploymentWindowList));
    }).catch((T) => {
      p(`${T?.errors?.[0].userMessage}`);
    }).finally(() => {
      u(!1);
    });
  }, g = () => /* @__PURE__ */ e.jsxs("div", { className: "modal__header px-20 py-16 dc__border-bottom-n1 mb-0", children: [
    /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsxs("h1", { className: "modal__title fs-16 lh-24", children: [
        "Add ",
        s.type.toLowerCase(),
        " duration"
      ] }),
      /* @__PURE__ */ e.jsxs("span", { className: "fs-13 lh-20", children: [
        "Selected time zone: (GMT",
        rd.tz(a).format("Z"),
        ") ",
        a
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(vt, { className: "icon-dim-24 cursor", onClick: () => t() })
  ] }), E = () => /* @__PURE__ */ e.jsxs("div", { className: "dc__sidebar-layout-200 flex left h-300", children: [
    /* @__PURE__ */ e.jsx(yL, { deploymentWindow: f, setDeploymentWindow: _ }),
    /* @__PURE__ */ e.jsx(
      LL,
      {
        deploymentWindow: f,
        setDeploymentWindow: _,
        timezone: a,
        setShowStartDate: i,
        setShowEndDate: c,
        showStartDate: o,
        showEndDate: l
      }
    )
  ] }), C = () => /* @__PURE__ */ e.jsxs("div", { className: "px-20 py-16 dc__border-top-n1 flex right dc__gap-12", children: [
    /* @__PURE__ */ e.jsx("button", { type: "button", className: "cta cancel", onClick: () => t(), children: pt.CANCEL }),
    /* @__PURE__ */ e.jsx(
      j,
      {
        onClick: x,
        isLoading: m,
        disabled: f.frequency === he.WEEKLY && !f.weekdays?.length,
        dataTestId: "save-duration",
        text: pt.DONE
      }
    )
  ] }), b = () => d ? /* @__PURE__ */ e.jsx(
    Ot,
    {
      variant: "error",
      borderConfig: { top: !1, left: !1, right: !1 },
      borderRadiusConfig: { top: !1, left: !1, right: !1, bottom: !1 },
      description: d
    }
  ) : null;
  return /* @__PURE__ */ e.jsx(cs, { className: "", onEscape: t, close: t, initialFocus: !1, children: /* @__PURE__ */ e.jsxs("div", { onClick: Le, className: "modal__body w-600 p-0 fs-13", children: [
    g(),
    b(),
    E(),
    C()
  ] }) });
}, OL = ({
  setSelectedTimeZone: t,
  selectedTimeZone: s,
  setDeploymentWindowProfile: n
}) => {
  const a = (o) => {
    t(o), n((i) => ({ ...i, timeZone: o.value }));
  }, r = () => /* @__PURE__ */ e.jsx(
    Ve,
    {
      inputId: "time-zone-select",
      classNamePrefix: pt.TIME_ZONE_SELECT_PLACEHOLDER,
      isClearable: !1,
      value: s,
      options: dL(),
      isSearchable: !0,
      onChange: a,
      placeholder: pt.SINGLE_APPLY_PROFILE_SELECT_PLACEHOLDER,
      hideSelectedOptions: !1,
      variant: cn.COMPACT,
      menuSize: O.large,
      shouldMenuAlignRight: !0
    }
  );
  return /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-8", children: [
    /* @__PURE__ */ e.jsx("span", { className: "cn-7", children: "Time zone" }),
    r()
  ] });
}, RL = ({
  deploymentWindowProfile: t,
  setDeploymentWindowProfile: s,
  selectedTimeZone: n,
  setSelectedTimeZone: a,
  formErrorObj: r,
  setFormDataErrorObj: o
}) => {
  const [i, l] = v(!1), [c, d] = v(-1), p = (A) => {
    const S = { ...r };
    S.durationWindow = dh(
      A ?? t.deploymentWindowList
    ), o(S);
  }, m = () => {
    l(!0);
  }, u = (A) => {
    p(A), l(!1);
  }, f = () => /* @__PURE__ */ e.jsxs("div", { className: "pt-8 pb-8 pl-16 pr-16 bg__tertiary dc__top-radius-4 flex dc__content-space", children: [
    /* @__PURE__ */ e.jsx("span", { className: "fw-6 lh-20", children: "Deployment window" }),
    /* @__PURE__ */ e.jsx(
      OL,
      {
        selectedTimeZone: n,
        setSelectedTimeZone: a,
        setDeploymentWindowProfile: s
      }
    )
  ] }), _ = () => Object.values(Zt).map((S) => {
    const L = S === Zt.BLACKOUT;
    return /* @__PURE__ */ e.jsx(Ze, { value: S, dataTestId: "trigger-STAGE-pipeline-manually-checkbox", children: /* @__PURE__ */ e.jsxs("div", { className: "cn-9", children: [
      "Set ",
      S.toLowerCase(),
      " window ",
      /* @__PURE__ */ e.jsx("br", {}),
      `${L ? "Block" : "Allow"} deployment ${L ? "only" : ""} in specified duration`
    ] }) }, S);
  }), h = (A) => {
    const S = { ...t };
    S.type = A, s(S);
  }, x = () => /* @__PURE__ */ e.jsx(
    ds,
    {
      className: "no-border flex left column dc__gap-12 cn-9",
      value: t.type,
      name: "window-type",
      onChange: (A) => {
        h(A.target.value);
      },
      children: _()
    }
  ), g = () => {
    m(), d(-1);
  }, E = () => /* @__PURE__ */ e.jsx(
    j,
    {
      dataTestId: "add-window-duration",
      text: "Add duration",
      startIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-add", color: null }),
      onClick: g,
      variant: w.text
    }
  ), C = (A) => {
    d(A), m();
  }, b = (A) => {
    const S = t.deploymentWindowList;
    S.splice(A, 1), s({
      ...t,
      deploymentWindowList: S
    }), p(t.deploymentWindowList);
  }, N = () => t.deploymentWindowList?.length > 0 && /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-4", children: t.deploymentWindowList.map((A, S) => /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "flex dc__content-space py-6 dc__hover-n50",
      "data-testId": S,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8", children: [
          iI(
            A.frequency,
            t.type === Zt.BLACKOUT
          ),
          /* @__PURE__ */ e.jsx(
            _h,
            {
              deploymentWindow: A,
              timeZone: n?.value,
              hideTruncate: !0
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex right dc__gap-8", children: [
          /* @__PURE__ */ e.jsx(Fs, { className: "icon-dim-16 cursor", onClick: () => C(S) }),
          /* @__PURE__ */ e.jsx(ua, { className: "icon-dim-16 cursor", onClick: () => b(S) })
        ] })
      ]
    },
    `${A.id}`
  )) }), I = () => r.durationWindow?.message && /* @__PURE__ */ e.jsxs("div", { className: "error-label form__error m-0-imp", children: [
    /* @__PURE__ */ e.jsx(Db, { className: "error-label-icon icon-dim-16-imp form__icon form__icon--error" }),
    r.durationWindow.message
  ] }, r.durationWindow.message), T = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col p-16 dc__gap-12", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space w-100 dc__gap-20", children: [
      x(),
      /* @__PURE__ */ e.jsx(
        "img",
        {
          src: t.type === Zt.BLACKOUT ? Mb : kb,
          alt: "window selection",
          className: "window-selection-img"
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "dc__border-n1" }),
    N(),
    E(),
    I()
  ] });
  return /* @__PURE__ */ e.jsxs("div", { className: "configure-window-wrapper w-100 bw-1 en-1 br-4", children: [
    f(),
    T(),
    i && /* @__PURE__ */ e.jsx(
      jL,
      {
        closeDurationModal: u,
        deploymentWindowProfile: t,
        setDeploymentWindowProfile: s,
        timezone: n?.value,
        sequentialIndex: c
      }
    )
  ] });
}, ou = () => {
  const t = Te(), [s, n] = v({
    id: 0,
    name: "",
    description: "",
    type: Zt.MAINTENANCE,
    displayMessage: "",
    isUserExcluded: !1,
    isSuperAdminExcluded: !1,
    deploymentWindowList: null,
    timeZone: "",
    enabled: !0,
    excludedUsersList: [],
    excludedUsersEmails: []
  }), [a, r] = v(!1), o = de(new AbortController()), [i, l] = v(), [c, d] = v(), [p, m] = v(!1), [u, f] = v({
    window: { isValid: !0, message: "" },
    description: { isValid: !0, message: "" },
    displayMessage: { isValid: !0, message: "" },
    durationWindow: { isValid: !0, message: "" }
  }), [_, h] = v(!1), [x, g] = v(uL), E = Ss(), { profileName: C } = Ue(), b = E.pathname.includes(Ee.DEPLOYMENT_WINDOW_EDIT), N = a || !u.window.isValid || !u.durationWindow.isValid || !u.description.isValid || !u.displayMessage.isValid, I = () => {
    h((re) => !re);
  }, T = () => {
    m(!0), mL(C, o.current.signal).then((re) => {
      const k = re.result.deploymentWindowList.map((F) => ({
        ...F,
        ...F.frequency === he.FIXED ? {
          timeFrom: ar(
            F.timeFrom,
            re.result.timeZone,
            !0
          ).toISOString(),
          timeTo: ar(F.timeTo, re.result.timeZone, !0).toISOString()
        } : null
      }));
      n({ ...re.result, deploymentWindowList: k });
      const D = re.result.excludedUsersEmails?.map((F) => ({
        label: F,
        value: F
      }));
      l(D), g({
        label: `(GMT ${ch(re.result.timeZone)}) ${re.result.timeZone} `,
        value: re.result.timeZone
      });
    }).catch((re) => {
      V(re);
    }).finally(() => {
      m(!1);
    });
  }, A = async () => {
    try {
      const k = (await xL({
        showAll: !0,
        offset: null,
        size: null,
        sortBy: xE.email,
        sortOrder: Ut.ASC,
        status: []
      })).users?.filter((D) => D.email_id !== "system").map((D) => ({
        label: D.email_id,
        value: D.id
      }));
      d(k);
    } catch (re) {
      V(re);
    }
  };
  J(() => {
    A(), b && T();
  }, []);
  const S = (re) => {
    l(re);
  }, L = (re) => {
    const { value: k } = re.target, D = { ...u };
    re.target.name === ba.WINDOW_NAME ? (n({ ...s, name: k }), D.window = Tn(k)) : re.target.name === ba.DESCRIPTION ? (n({ ...s, description: k }), D.description = dn(k)) : re.target.name === ba.DISPLAY_MESSAGE && (n({ ...s, displayMessage: k }), D.displayMessage = dn(k)), f(D);
  }, R = (re) => {
    re.target.id === qo.SUPERADMIN ? n({
      ...s,
      isSuperAdminExcluded: !s.isSuperAdminExcluded
    }) : re.target.id === qo.SPECIFIC_USERS && n({
      ...s,
      isUserExcluded: !s.isUserExcluded
    });
  }, y = (re, k) => /* @__PURE__ */ e.jsxs("span", { className: "flexbox", children: [
    /* @__PURE__ */ e.jsx("span", { children: re }),
    k && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      " ",
      /* @__PURE__ */ e.jsx(wt, { to: Ee.GLOBAL_CONFIG_AUTH_USER_PERMISSION, className: "flex", children: "Go to User Permissions" })
    ] })
  ] }), M = () => /* @__PURE__ */ e.jsxs("div", { className: "w-100 flexbox-col dc__gap-12", children: [
    /* @__PURE__ */ e.jsxs("span", { className: "fw-6", children: [
      "Choose who can take action ",
      s.type === Zt.BLACKOUT ? "during" : "outside",
      " the ",
      s.type.toLowerCase(),
      " window"
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12", children: [
      /* @__PURE__ */ e.jsx(
        $e,
        {
          rootClassName: "fs-13 app-group-checkbox",
          isChecked: s.isSuperAdminExcluded,
          value: Fe.CHECKED,
          onChange: R,
          dataTestId: "super-admin-access-checkbox",
          id: qo.SUPERADMIN,
          children: /* @__PURE__ */ e.jsxs("div", { className: "ml-4", children: [
            " ",
            pt.SUPER_ADMIN
          ] })
        }
      ),
      /* @__PURE__ */ e.jsx(
        $e,
        {
          rootClassName: "fs-13 app-group-checkbox",
          isChecked: s.isUserExcluded,
          value: Fe.CHECKED,
          onChange: R,
          dataTestId: "specific-users-access-checkbox",
          id: qo.SPECIFIC_USERS,
          children: /* @__PURE__ */ e.jsxs("div", { className: "ml-4", children: [
            " ",
            pt.SPECIFIC_USERS
          ] })
        }
      )
    ] }),
    s.isUserExcluded && /* @__PURE__ */ e.jsx(
      Ve,
      {
        inputId: "excluded-users-select",
        classNamePrefix: pt.SPECIFIC_USERS_PLACEHOLDER,
        isMulti: !0,
        isClearable: !1,
        value: i,
        options: c,
        onChange: S,
        placeholder: pt.SPECIFIC_USERS_PLACEHOLDER,
        closeMenuOnSelect: !1,
        hideSelectedOptions: !1,
        helperText: y(pt.SPECIFIC_USERS_INFO, !0)
      }
    )
  ] }), P = () => {
    t.push(Ee.DEPLOYMENT_WINDOW_WINDOWS);
  }, U = () => {
    const re = { ...u };
    if (re.window = Tn(s.name), re.durationWindow = dh(s.deploymentWindowList), f(re), !re.window.isValid || !re.durationWindow.isValid)
      return;
    const k = b ? _L : fL, D = s.deploymentWindowList?.map((q) => ({
      ...q,
      ...q.frequency === he.FIXED && {
        timeFrom: ar(q.timeFrom, x.value),
        timeTo: ar(q.timeTo, x.value)
      }
    })), F = {
      ...s,
      deploymentWindowList: D,
      excludedUsersEmails: i?.map((q) => q.label),
      // On create without any user, adding optional check
      isUserExcluded: s.isUserExcluded && i?.length > 0,
      timeZone: x.value
    };
    r(!0), k(F, o.current.signal).then(() => {
      P(), Z.showToast({
        variant: ee.success,
        description: "Deployment window created successfully"
      });
    }).catch((q) => {
      V(q);
    }).finally(() => {
      r(!1);
    });
  }, G = () => /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8 cta-section px-20 py-16 dc__border-top-n1 dc__position-sticky dc__bottom-0 bg__primary", children: [
    /* @__PURE__ */ e.jsx(
      j,
      {
        onClick: U,
        dataTestId: "save",
        isLoading: a,
        text: "Save Changes",
        disabled: N
      }
    ),
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "cancel",
        text: "Cancel",
        variant: w.secondary,
        style: B.neutral,
        component: Re.link,
        linkProps: {
          to: Ee.DEPLOYMENT_WINDOW_WINDOWS
        }
      }
    )
  ] }), H = () => /* @__PURE__ */ e.jsxs("div", { className: "create-edit-form flexbox-col dc__gap-16 px-20 pb-16 flex-grow-1-imp dc__overflow-auto h-100", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
      /* @__PURE__ */ e.jsx(
        yt,
        {
          label: pt.WINDOW_NAME_LABEL,
          placeholder: pt.WINDOW_NAME_PLACEHOLDER,
          name: ba.WINDOW_NAME,
          required: !0,
          value: s.name,
          onChange: L,
          fullWidth: !0,
          error: u.window?.message
        }
      ),
      /* @__PURE__ */ e.jsx(
        yt,
        {
          label: pt.DESCRIPTION_LABEL,
          placeholder: pt.DESCRIPTION_PLACEHOLDER,
          name: ba.DESCRIPTION,
          value: s.description,
          onChange: L,
          fullWidth: !0,
          error: u.description?.message
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "dc__border-top-n1" }),
    /* @__PURE__ */ e.jsx(
      RL,
      {
        deploymentWindowProfile: s,
        setDeploymentWindowProfile: n,
        setSelectedTimeZone: g,
        selectedTimeZone: x,
        formErrorObj: u,
        setFormDataErrorObj: f
      }
    ),
    /* @__PURE__ */ e.jsx("div", { className: "dc__border-top-n1" }),
    M(),
    /* @__PURE__ */ e.jsx("div", { className: "dc__border-top-n1" }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-4", children: /* @__PURE__ */ e.jsx(
      yt,
      {
        label: pt.DISPLAY_MESSAGE_LABEL,
        placeholder: pt.DISPLAY_MESSAGE_PLACEHOLDER,
        name: ba.DISPLAY_MESSAGE,
        value: s.displayMessage,
        onChange: L,
        fullWidth: !0,
        error: u.displayMessage.message,
        helperText: y(pt.DISPLAY_MESSAGE_INFO)
      }
    ) })
  ] });
  if (p)
    return /* @__PURE__ */ e.jsx(Je, { pageLoader: !0 });
  const oe = () => /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space px-20 pt-16 pb-24", children: [
    /* @__PURE__ */ e.jsx(
      Gi,
      {
        redirectUrl: Ee.DEPLOYMENT_WINDOW_WINDOWS,
        linkText: "Deployment Window",
        profileName: s.name
      }
    ),
    b && /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "flex cta delete small dc__fit-content override-button m-0-imp",
        onClick: I,
        children: [
          /* @__PURE__ */ e.jsx(ts, { className: "mr-8 icon-dim-16" }),
          "Delete"
        ]
      }
    )
  ] }), ae = {
    type: s.type,
    name: s.name
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "window-create-edit-wrapper fs-13 cn-9 dc__mxw-1000 h-100 flexbox-col flex-grow-1", children: [
    oe(),
    H(),
    G(),
    _ && /* @__PURE__ */ e.jsx(
      mh,
      {
        selectedProfileDataId: s.id,
        selectedProfileData: ae,
        reloadWindow: P,
        onClickDelete: I,
        closeConfirmationModal: I
      }
    )
  ] });
}, Fd = ({ shimmerRowClassName: t, hideLastColumn: s = !1 }) => {
  const n = () => /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading h-16 pt-8 pb-8" }), a = () => {
    const r = [];
    for (let o = 0; o < 3; o++)
      r.push(
        /* @__PURE__ */ e.jsxs("div", { className: `shimmer-loading-list__row dc__gap-16 px-20 ${t}`, children: [
          n(),
          n(),
          n(),
          n(),
          !s && n()
        ] }, o)
      );
    return r;
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    " ",
    a(),
    " "
  ] });
}, PL = ({
  setShowSelectionDialog: t,
  type: s,
  currentFilterData: n,
  updateSearchParams: a
}) => {
  const { handleBulkSelection: r } = It(), o = () => {
    t(null);
  }, i = () => {
    if (Z.showToast({
      variant: ee.info,
      description: ke.CLEAR_CONFIRMATION_DIALOG_TOAST
    }), t(null), s === Et.CLEAR_ALL) {
      r({
        action: st.CLEAR_ALL_SELECTIONS
      }), a({ [n.filterKey]: n.options });
      return;
    }
    r({
      action: st.CLEAR_SELECTIONS_AND_SELECT_ALL_ACROSS_PAGES
    });
  };
  return s !== Et.CLEAR_ALL && s !== Et.SELECT_ALL ? (Z.showToast({
    variant: ee.error,
    description: ke.CLEAR_CONFIRMATION_ERROR
  }), null) : /* @__PURE__ */ e.jsx(
    zt,
    {
      variant: Ct.custom,
      Icon: /* @__PURE__ */ e.jsx(f_, {}),
      title: s === Et.CLEAR_ALL ? ke.CLEAR_CONFIRMATION_TITLE.CLEAR_ALL : ke.CLEAR_CONFIRMATION_TITLE.SELECT_ALL,
      subtitle: s === Et.CLEAR_ALL ? ke.CLEAR_CONFIRMATION_SUB_TITLE.CLEAR_ALL : ke.CLEAR_CONFIRMATION_SUB_TITLE.SELECT_ALL,
      handleClose: o,
      buttonConfig: {
        secondaryButtonConfig: {
          text: ke.CLEAR_CONFIRMATION_CANCEL,
          onClick: o
        },
        primaryButtonConfig: {
          text: s === Et.CLEAR_ALL ? ke.CLEAR_CONFIRMATION_APPLY.CLEAR_ALL : ke.CLEAR_CONFIRMATION_APPLY.SELECT_ALL,
          onClick: i
        }
      }
    }
  );
}, wL = ({
  totalSelectedCount: t,
  setFilteredEnvListLoader: s,
  setFilteredAppEnvList: n,
  openMultiSelectionDialog: a
}) => {
  const r = de(new AbortController()), o = _t({
    initialSortKey: Dn.APP_NAME,
    parseSearchParams: cl
  }), { applications: i, environments: l, policyNames: c } = o, { selectedIdentifiers: d, handleBulkSelection: p } = It();
  if (!d)
    return null;
  let m;
  Object.keys(d)[0] !== us ? m = Object.values(d) : m = [];
  const u = d[us], f = {
    appNames: u ? i : m.map((x) => x.appName),
    envNames: u ? l : m.map((x) => x.envName),
    policyNames: u ? c : m.map((x) => x.policyNames),
    fieldNames: ["policyNames"],
    offset: 0,
    size: 20
  }, _ = () => {
    if (u)
      s(!0), kd(f, r.current.signal).then((x) => {
        x && n(x.result);
      }).catch((x) => V(x)).finally(() => {
        s(!1), a();
      });
    else {
      const x = m.map(
        (E) => ({
          appName: E.appName,
          envName: E.envName,
          policyNames: E.policyNames
        })
      ), g = {
        appEnvironmentPolicyMappings: x,
        totalCount: x.length,
        appliedPolicyNames: Array.from(
          x?.reduce((E, C) => (C.policyNames?.forEach((b) => E.add(b)), E), /* @__PURE__ */ new Set())
        )
      };
      n(g), a();
    }
  }, h = () => {
    p({
      action: st.CLEAR_ALL_SELECTIONS
    });
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "h-56 br-8 pt-12 pr-12 pb-12 pl-8 dc__gap-12 flexbox dc__align-items-center bulk-selection-widget", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8", children: [
      /* @__PURE__ */ e.jsx(Fi, { dragClassName: ll.SELECTOR_CLASS_NAME }),
      /* @__PURE__ */ e.jsx(
        "span",
        {
          className: "pt-0 pb-0 pl-6 pr-6 br-4 bcb-5 m-0 cn-0",
          "data-testid": wa.SELECTED_APPLICATIONS_COUNT,
          children: t
        }
      ),
      /* @__PURE__ */ e.jsx("strong", { className: "m-0 cn-9 fs-13 fw-6 lh-20", children: ke.SELECTED_COUNT_SUFFIX })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "h-20 dc__border-left" }),
    /* @__PURE__ */ e.jsx("div", { className: "cursor cta small", onClick: _, children: "Manage Windows" }),
    /* @__PURE__ */ e.jsx("div", { className: "h-20 dc__border-left" }),
    /* @__PURE__ */ e.jsx(
      "button",
      {
        type: "button",
        className: "dc__no-background flex dc__no-border dc__outline-none-imp dc__tab-focus scn-6",
        "aria-label": ke.CLEAR_BULK_SELECTION,
        "data-testid": wa.CLEAR_BULK_SELECTION,
        onClick: h,
        children: /* @__PURE__ */ e.jsx(ua, { className: "icon-dim-16" })
      }
    )
  ] });
}, DL = ({
  showMultiBulkSelectionDialog: t,
  totalCount: s,
  setFilteredAppEnvList: n,
  setFilteredEnvListLoader: a,
  profileNameMap: r,
  parentRef: o,
  openMultiSelectionDialog: i
}) => {
  const { selectedIdentifiers: l } = It(), c = Object.keys(l).length, d = l[us] ? s : c;
  return c === 0 ? null : /* @__PURE__ */ e.jsx(
    No,
    {
      zIndex: 15,
      positionVariant: To.PARENT_BOTTOM_CENTER,
      dragSelector: `.${ll.SELECTOR_CLASS_NAME}`,
      parentRef: o,
      children: /* @__PURE__ */ e.jsx(
        wL,
        {
          totalSelectedCount: d,
          showMultiBulkSelectionDialog: t,
          profileNameMap: r,
          setFilteredAppEnvList: n,
          setFilteredEnvListLoader: a,
          openMultiSelectionDialog: i
        }
      )
    }
  );
}, hh = ({
  windowOptions: t,
  selectedProfileValues: s,
  setSelectedProfileValues: n,
  onMenuOpen: a,
  onMenuClose: r
}) => {
  const o = t.map((l) => ({ ...l, startIcon: fh(l.type) })), i = (l) => {
    n(l);
  };
  return /* @__PURE__ */ e.jsx(
    Ve,
    {
      inputId: pt.SINGLE_EDIT_SELECT_PREFIX,
      isMulti: !0,
      isClearable: !1,
      value: s,
      options: o,
      onChange: i,
      placeholder: pt.SINGLE_APPLY_PROFILE_SELECT_PLACEHOLDER,
      closeMenuOnSelect: !1,
      hideSelectedOptions: !1,
      onMenuOpen: a,
      onMenuClose: r
    }
  );
}, Ud = ({
  profileMetaData: t,
  isRemovedProfilesView: s = !1,
  isReviewChangesContentView: n = !1,
  removePolicyNames: a,
  setRemovePolicyNames: r,
  showCrossIcon: o = !1,
  rootClassName: i = "",
  profileTruncated: l = !1
}) => {
  if (Array.isArray(t) && t.length === 0)
    return null;
  const c = (_, h) => /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "fw-6", children: [
      h && Ft(h),
      " Window"
    ] }),
    /* @__PURE__ */ e.jsx("div", { children: _ })
  ] }), d = (_, h) => {
    const x = (g) => /* @__PURE__ */ e.jsx(
      lt,
      {
        content: c(_, h),
        placement: "top",
        className: "default-tt dc__mxw-200",
        arrow: !1,
        children: g
      }
    );
    return /* @__PURE__ */ e.jsx(An, { condition: !!_ && l, wrap: x, children: /* @__PURE__ */ e.jsx("div", { className: ` ${l ? "dc__mxw-66 dc__ellipsis-right" : ""}`, children: _ }) });
  };
  if (!Array.isArray(t))
    return null;
  const p = (_, h, x) => {
    Le(_), r((g) => {
      const E = new Set(g);
      return x === oi.REMOVE ? E.add(h) : E.delete(h), E;
    });
  }, m = (_) => n || !o ? null : a?.has(_) ? /* @__PURE__ */ e.jsx(
    Lo,
    {
      className: "icon-dim-12 cursor scn-6",
      onClick: (h) => p(h, _, oi.UNDO)
    }
  ) : /* @__PURE__ */ e.jsx(
    vt,
    {
      className: "icon-dim-12 cursor scn-6",
      onClick: (h) => p(h, _, oi.REMOVE)
    }
  ), u = (_) => {
    let h = "";
    return a?.has(_) && s && (h = "dc__strike-through cursor"), h;
  }, f = (_) => /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `flex left en-2 bw-1 bg__secondary pl-6 pr-6 br-4 pt-1 pb-1 dc__gap-6 ${CL(_.appliedStatus)} ${u(_.profileName)} ${i || ""}`,
      children: [
        fh(_.type),
        d(_.profileName, _.type),
        m(_.profileName)
      ]
    },
    _.profileName
  );
  return /* @__PURE__ */ e.jsxs("div", { className: `flexbox fs-12 dc__gap-6 ${s ? "" : "cursor"} flex-wrap`, children: [
    (n || s ? t : t.slice(0, 4)).map(
      (_) => f(_)
    ),
    !(n || s) && t.length > 4 && /* @__PURE__ */ e.jsxs("div", { className: "flex left en-2 bw-1 bg__secondary pl-6 pr-6 br-4 cn-7 dc__w-fit-content", children: [
      "+",
      t.length - 4,
      " more"
    ] })
  ] });
}, ML = ({
  filteredAppEnvList: t,
  profileNameMap: s,
  selectedProfileValues: n,
  removePolicyNames: a
}) => {
  const [r, o] = v(t), [i, l] = v(!1), [c, d] = v(null), p = de(new AbortController()), { offset: m, changePage: u, changePageSize: f, pageSize: _ } = vs();
  J(
    () => () => {
      p.current.abort();
    },
    []
  );
  const { selectedIdentifiers: h } = It(), x = h[us], g = r.totalCount > km, E = Q(
    () => ({
      size: _,
      offset: m,
      appNames: [],
      envNames: [],
      policyNames: []
    }),
    [_, m]
  ), C = () => {
    l(!0), kd(E, p.current.signal).then((A) => {
      A && o(A.result);
    }).catch((A) => d(A.code)).finally(() => {
      l(!1);
    });
  };
  if (J(() => {
    x && E.offset > 0 ? C() : o(t);
  }, [E.offset, E.size]), !h)
    return null;
  const b = () => /* @__PURE__ */ e.jsxs("div", { className: "deployment-window__review-row dc__gap-12 pt-8 pb-8 dc__border-bottom-n1 fs-12 fw-6 cn-7 lh-20", children: [
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-row", children: "Application" }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-row", children: " Environment" }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-row", children: "APPLIED WINDOWS" })
  ] }), N = (A) => {
    if (A?.policyNames?.length > 0 || n?.length > 0) {
      const S = n?.filter((y) => !a.has(y.value))?.filter((y) => !A.policyNames?.includes(y.value)).map((y) => ({
        profileName: y.label,
        type: s[y.value]?.type,
        appliedStatus: ea.ADDED
      })), L = A.policyNames?.map((y) => ({
        profileName: y,
        type: s[y]?.type,
        appliedStatus: a.has(y) ? ea.REMOVED : ea.APPLIED
      })) ?? [], R = [...S, ...L];
      return /* @__PURE__ */ e.jsx(
        Ud,
        {
          profileMetaData: R,
          isReviewChangesContentView: !0,
          profileTruncated: !0
        }
      );
    }
    return /* @__PURE__ */ e.jsx("div", { className: "flex left dc__gap-4 cursor", children: "No windows" });
  }, I = x ? r.appEnvironmentPolicyMappings : r.appEnvironmentPolicyMappings.slice(m, m + _), T = () => I.map((A) => {
    const S = `${A.appName}/${A.envName}`;
    return /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "deployment-window__review-row dc__gap-12 dc__border-bottom-n1 pt-10 pb-10 dc__hover-n50 lh-20 flex left dc__align-start",
        children: [
          /* @__PURE__ */ e.jsx("div", { className: "flex left dc__ellipsis-right", children: A.appName }),
          /* @__PURE__ */ e.jsx("div", { className: "flex left dc__ellipsis-right", children: A.envName }),
          /* @__PURE__ */ e.jsx("div", { children: N(A) })
        ]
      },
      S
    );
  });
  return i ? /* @__PURE__ */ e.jsx(Je, {}) : c && c !== 200 ? /* @__PURE__ */ e.jsx(Xe, { code: c }) : /* @__PURE__ */ e.jsxs("div", { className: "window__review-config dc__overflow-auto", children: [
    b(),
    T(),
    g && /* @__PURE__ */ e.jsx(
      vo,
      {
        rootClassName: "flex dc__content-space pl-20 pr-20 dc__border-top-n1",
        size: t.totalCount ?? 0,
        offset: m,
        pageSize: _,
        changePage: u,
        changePageSize: f
      }
    )
  ] });
}, kL = ({
  toggleSelectionDialog: t,
  filteredAppEnvListLoader: s,
  filteredAppEnvList: n,
  profileNameMap: a,
  windowOptions: r,
  reloadApplyList: o,
  urlFilters: i
}) => {
  const [l, c] = v(!1), d = de(new AbortController()), { selectedIdentifiers: p, handleBulkSelection: m } = It(), [u, f] = v(Ls.ADD), _ = n.appliedPolicyNames, h = _?.map(
    (ae) => r?.find((re) => re.value === ae)
  ), [x, g] = v(/* @__PURE__ */ new Set()), [E, C] = v(
    u === Ls.ADD ? [] : h
  ), [b, N] = v(!1), I = Te();
  J(() => {
    C(u === Ls.ADD ? [] : h);
  }, [p]);
  const T = () => {
    m({
      action: st.CLEAR_ALL_SELECTIONS
    });
  }, A = () => {
    I.push({ search: "" });
  }, S = async () => {
    c(!0);
    let ae = [], re = {};
    if (!p["*"])
      ae = Object.values(p).map((D) => ({
        appName: D.appName,
        envName: D.envName
      }));
    else {
      const { applications: D, environments: F, policyNames: q } = i;
      re = {
        appNames: D,
        envNames: F,
        policyNames: q
      };
    }
    const k = {
      appEnvPolicyListFilter: re,
      applicationEnvironments: ae,
      applyToPolicyNames: E.map((D) => D.value),
      removePolicyNames: x.size ? Array.from(x) : []
    };
    try {
      await uh(k, d.current.signal), Z.showToast({
        variant: ee.success,
        description: "Deployment windows applied successfully"
      }), t(), T(), A();
    } catch (D) {
      V(D);
    } finally {
      o(), c(!1);
    }
  }, L = () => /* @__PURE__ */ e.jsxs("div", { className: "flex flex-align-center flex-justify dc__border-bottom bg__primary pt-12 pr-20 pb-12 pl-20", children: [
    /* @__PURE__ */ e.jsx("h3", { className: "fs-16 fw-6 lh-1-43 m-0 lh-24", children: "Bulk Edit " }),
    /* @__PURE__ */ e.jsx(vt, { className: "icon-dim-24", onClick: t })
  ] }), R = (ae) => {
    f(
      ae.value === Ls.ADD ? Ls.ADD : Ls.REMOVE
    );
  }, y = () => /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
    Qs,
    {
      segments: [
        {
          label: Ls.ADD,
          value: Ls.ADD
        },
        {
          label: Ls.REMOVE,
          value: Ls.REMOVE
        }
      ],
      value: u,
      onChange: R,
      name: "add-remove-window"
    }
  ) }), M = () => {
    N((ae) => !ae);
  };
  if (s)
    return /* @__PURE__ */ e.jsx(Je, { pageLoader: !0 });
  if (!n)
    return null;
  const P = _?.map((ae) => ({
    profileName: ae,
    type: a[ae]?.type,
    appliedStatus: ea.APPLIED
  })), U = P?.length === 0, G = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col window__review-body", children: [
    /* @__PURE__ */ e.jsx("div", { className: "fw-6 pb-6", children: u === Ls.ADD ? "Add Deployment Windows" : "Remove Deployment Windows" }),
    u === Ls.ADD ? /* @__PURE__ */ e.jsx(
      hh,
      {
        windowOptions: r,
        selectedProfileValues: E,
        setSelectedProfileValues: C
      }
    ) : /* @__PURE__ */ e.jsxs("div", { className: `en-2 bw-1 flex ${U ? "center" : "left"} br-4 bg__secondary  dc__gap-8 p-6`, children: [
      U && /* @__PURE__ */ e.jsx("div", { className: "flex dc__align-center cn-7 w-300 fs-12 lh-18", children: pt.NOTHING_TO_REMOVE }),
      /* @__PURE__ */ e.jsx(
        Ud,
        {
          profileMetaData: P,
          isRemovedProfilesView: !0,
          removePolicyNames: x,
          setRemovePolicyNames: g,
          showCrossIcon: !0,
          rootClassName: "bg__primary"
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-12 fw-6 dc__border-top-n1 mt-16 pt-16", children: [
        /* @__PURE__ */ e.jsxs("span", { children: [
          "Applying changes to ",
          n.totalCount,
          " Application environments"
        ] }),
        /* @__PURE__ */ e.jsxs("span", { className: "cb-5 cursor", onClick: M, children: [
          b ? "Hide " : "Review ",
          " Changes"
        ] })
      ] }),
      b && /* @__PURE__ */ e.jsx(
        ML,
        {
          filteredAppEnvList: n,
          profileNameMap: a,
          selectedProfileValues: E,
          removePolicyNames: x
        }
      )
    ] })
  ] }), H = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__gap-16 dc__overflow-auto px-20 pt-16", children: [
    y(),
    G()
  ] }), oe = () => /* @__PURE__ */ e.jsxs("div", { className: "dc__border-top flex right py-16 px-20", children: [
    /* @__PURE__ */ e.jsx("button", { className: "cta cancel flex h-36 mr-12", onClick: t, type: "button", children: "Cancel" }),
    /* @__PURE__ */ e.jsx(
      Vi,
      {
        rootClassName: "flex cta h-36",
        onClick: S,
        dataTestId: "save",
        disabled: l,
        isLoading: l,
        children: pt.SAVE_SUBMIT
      }
    )
  ] });
  return /* @__PURE__ */ e.jsx(cs, { close: t, className: "confirmation-dialog", children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "window__multi-edit-container h-100 bg__modal flexbox-col dc__content-space dc__overflow-hidden fs-13 cn-9 modal-body--ci-material",
      onClick: Le,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
          L(),
          H()
        ] }),
        oe()
      ]
    }
  ) });
}, FL = ({
  closeModal: t,
  appName: s,
  envName: n,
  policyNames: a,
  reloadApplyList: r,
  onClickShowSingleEditModal: o,
  windowOptions: i,
  profileNameMap: l
}) => {
  const [c, d] = v(null), p = de(new AbortController()), [m, u] = v([]), [f, _] = v([]), [h, x] = v(!1), { handleBulkSelection: g } = It();
  J(() => {
    const A = a?.map((S) => ({
      label: S,
      value: S,
      type: l[S]?.type
    }));
    d(A);
  }, []);
  const E = () => {
    if (!c)
      return [];
    const A = new Set(a);
    return c.filter((S) => !A.has(S.value)).map((S) => S.value);
  }, C = () => {
    if (!a || !c)
      return [];
    const A = new Set(c.map((S) => S.value));
    return a.filter((S) => !A.has(S));
  };
  J(() => {
    u(E()), _(C());
  }, [c]);
  const b = () => /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space pt-16 pb-16 pl-20 pr-20 dc__border-bottom-n1", children: [
    /* @__PURE__ */ e.jsxs("h2", { className: "fs-16 cn-9 fw-6 m-0", children: [
      "Edit Window for ",
      s,
      "/",
      n
    ] }),
    /* @__PURE__ */ e.jsx(vt, { className: "icon-dim-20 cursor", onClick: t })
  ] }), N = () => /* @__PURE__ */ e.jsx("div", { className: "mxh-500 pl-20 pr-20 pt-16 pb-16 h-200", children: /* @__PURE__ */ e.jsx(
    hh,
    {
      windowOptions: i,
      selectedProfileValues: c,
      setSelectedProfileValues: d,
      onMenuOpen: o,
      onMenuClose: o
    }
  ) }), I = async () => {
    x(!0);
    const A = {
      applicationEnvironments: [
        {
          appName: s,
          envName: n,
          policyNames: c?.map((S) => S.value)
        }
      ],
      applyToPolicyNames: m,
      removePolicyNames: f
    };
    await uh(A, p.current.signal).then(() => {
      r(), Z.showToast({
        variant: ee.success,
        description: "Deployment window created successfully"
      }), g({
        action: st.CLEAR_ALL_SELECTIONS
      });
    }).catch((S) => {
      V(S);
    }).finally(() => {
      t(), x(!1);
    });
  }, T = () => /* @__PURE__ */ e.jsxs("div", { className: "flex right dc__gap-16 dc__border-top-n1 pl-20 pr-20 pt-16 pb-16", children: [
    /* @__PURE__ */ e.jsx("button", { type: "button", className: "cta cancel small fs-13-imp lh-20 h-36", onClick: t, children: "Cancel" }),
    /* @__PURE__ */ e.jsx(
      Vi,
      {
        type: "button",
        onClick: I,
        rootClassName: "cta small fs-13-imp lh-20 h-36",
        isLoading: h,
        children: "Save Changes"
      }
    )
  ] });
  return /* @__PURE__ */ e.jsx(cs, { className: "confirmation-dialog", close: t, children: /* @__PURE__ */ e.jsxs("div", { onClick: Le, className: "modal__body br-8 bg__primary p-0 mt-40 w-600", children: [
    b(),
    N(),
    T()
  ] }) });
}, UL = ({
  identifier: t,
  identifierId: s,
  index: n,
  profileNameMap: a,
  onClickShowSingleEditModal: r,
  setSelectedProfileMetaData: o
}) => {
  const { selectedIdentifiers: i, handleBulkSelection: l } = It(), c = () => {
    const u = {
      [s]: t
    };
    if (i[us]) {
      l({
        action: st.CLEAR_IDENTIFIERS_AFTER_ACROSS_SELECTION,
        data: {
          identifierIds: [s]
        }
      });
      return;
    }
    l({
      action: i[s] ? st.CLEAR_IDENTIFIERS : st.SELECT_IDENTIFIER,
      data: {
        // In case we are clearing
        identifierIds: [s],
        // In case of selecting
        identifierObject: u
      }
    });
  }, d = () => {
    o({
      appName: t.appName,
      envName: t.envName,
      policyNames: t.policyNames
    }), r();
  }, p = () => {
    if (t?.policyNames?.length > 0) {
      const u = t.policyNames.map((f) => ({
        profileName: f,
        type: a[f]?.type
      }));
      return /* @__PURE__ */ e.jsx("div", { onClick: d, children: /* @__PURE__ */ e.jsx(Ud, { profileMetaData: u, profileTruncated: !0 }) });
    }
    return /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-4 cursor", onClick: d, children: [
      "No windows",
      /* @__PURE__ */ e.jsx(Bb, {})
    ] });
  }, m = !!(i[s] || i[us]);
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `deployment-window__apply-row dc__visible-hover dc__visible-hover--parent  dc__gap-1 dc__border-bottom-n1 pt-10 pb-10 dc__gap-16 pl-20 pr-20 dc__hover-n50 lh-20 flex left dc__align-start ${m ? "bc-b50--imp" : ""}`,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox w-40 dc__no-shrink", children: [
          !m && /* @__PURE__ */ e.jsx("div", { className: "dc__visible-hover--hide-child", children: /* @__PURE__ */ e.jsx(Qc, { className: "icon-dim-20" }) }),
          /* @__PURE__ */ e.jsx(
            $e,
            {
              isChecked: m,
              onChange: c,
              rootClassName: `icon-dim-20 ${m ? "" : "dc__visible-hover--child"}`,
              dataTestId: `activate-${t}`,
              tabIndex: n - 1,
              value: Fe.CHECKED
            }
          )
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "flex left dc__ellipsis-right pl-12", children: t.appName }),
        /* @__PURE__ */ e.jsx("div", { className: "flex left dc__ellipsis-right", children: t.envName }),
        /* @__PURE__ */ e.jsx("div", { children: p() })
      ]
    },
    s
  );
}, GL = ({
  appEnvList: t,
  appEnvListLoader: s,
  urlFilters: n,
  reloadApplyList: a,
  showMultiBulkSelectionDialog: r,
  windowOptions: o,
  toggleSelectionDialog: i,
  profileNameMap: l,
  filteredAppEnvList: c,
  filteredAppEnvListLoader: d
}) => {
  const [p, m] = v(!1), [u, f] = v(null), _ = !!t.appEnvironmentPolicyMappings?.length && t.appEnvironmentPolicyMappings?.length < t.totalCount || t.totalCount > km;
  J(() => {
    t.appEnvironmentPolicyMappings && t.appEnvironmentPolicyMappings.forEach((y) => {
      `${y.appName}${y.envName}`;
    });
  }, [t.appEnvironmentPolicyMappings?.length]);
  const h = () => {
    m(!0);
  }, x = () => {
    m(!1);
  }, { sortBy: g, sortOrder: E, handleSorting: C, offset: b, pageSize: N, changePage: I, changePageSize: T } = n, A = () => {
    C(Dn.APP_NAME);
  }, S = () => {
    C(Dn.ENV_NAME);
  }, L = () => /* @__PURE__ */ e.jsxs("div", { className: "deployment-window__apply-row dc__gap-16 pl-20 pr-20 pt-8 pb-8 dc__border-bottom-n1 fs-12 fw-6 cn-7 lh-20", children: [
    /* @__PURE__ */ e.jsx(bo, { showPagination: _ }),
    /* @__PURE__ */ e.jsx("div", { className: "pl-12", children: /* @__PURE__ */ e.jsx(
      Ne,
      {
        isSorted: g === Dn.APP_NAME,
        sortOrder: E,
        title: "Application",
        triggerSorting: A,
        disabled: s
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      Ne,
      {
        isSorted: g === Dn.ENV_NAME,
        sortOrder: E,
        title: "Environment",
        triggerSorting: S,
        disabled: s
      }
    ),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-row dc__gap-8", children: "APPLIED WINDOWS" })
  ] }), R = () => /* @__PURE__ */ e.jsxs("div", { className: "window-apply-list_table", children: [
    t.appEnvironmentPolicyMappings.map((y, M) => /* @__PURE__ */ e.jsx(
      UL,
      {
        identifier: y,
        identifierId: `${y.appName}-${y.envName}`,
        index: M,
        profileNameMap: l,
        onClickShowSingleEditModal: h,
        setSelectedProfileMetaData: f
      }
    )),
    _ && /* @__PURE__ */ e.jsx(
      vo,
      {
        rootClassName: "flex dc__content-space pl-20 pr-20 dc__border-top",
        size: t.totalCount ?? 0,
        offset: b,
        pageSize: N,
        changePage: I,
        changePageSize: T
      }
    )
  ] });
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1", children: [
    L(),
    R(),
    p && /* @__PURE__ */ e.jsx(
      FL,
      {
        closeModal: x,
        appName: u.appName,
        envName: u.envName,
        policyNames: u?.policyNames,
        profileNameMap: l,
        reloadApplyList: a,
        onClickShowSingleEditModal: h,
        windowOptions: o
      }
    ),
    r && /* @__PURE__ */ e.jsx(
      kL,
      {
        totalSelectedCount: t?.totalCount,
        toggleSelectionDialog: i,
        filteredAppEnvList: c,
        profileNameMap: l,
        windowOptions: o,
        filteredAppEnvListLoader: d,
        reloadApplyList: a,
        urlFilters: n
      }
    )
  ] });
}, BL = () => le("app/min"), $L = () => le("env/autocomplete"), vl = ({ placeholder: t, appliedFilters: s, options: n, handleApplyChange: a, inputId: r }) => {
  const o = s.map((l) => ({ value: l, label: l })), i = (l) => {
    a(l.map((c) => c.value));
  };
  return /* @__PURE__ */ e.jsx(
    Ps,
    {
      placeholder: t,
      options: n,
      appliedFilterOptions: o,
      handleApplyFilter: i,
      isLoading: !1,
      inputId: r,
      isDisabled: !1
    }
  );
}, VL = ({
  windowOptions: t,
  setWindowOptions: s,
  setProfileNameMap: n,
  setShowSelectionDialog: a,
  filterConfig: r,
  updateSearchParams: o,
  setCurrentFilterData: i
}) => {
  const [l, c] = v([]), [d, p] = v([]), m = de(new AbortController()), u = _t({
    initialSortKey: Dn.APP_NAME,
    parseSearchParams: cl
  }), { applications: f, environments: _, policyNames: h, clearFilters: x } = u, g = Q(
    () => ({
      [js.APPLICATIONS]: r.appNames,
      [js.ENVIRONMENTS]: r.envNames,
      [js.POLICY_NAMES]: r[js.POLICY_NAMES]
    }),
    [r.appNames, r.envNames, r[js.POLICY_NAMES]]
  );
  J(
    () => () => {
      m.current.abort();
    },
    []
  ), J(() => {
    !f && !_ && !h && x();
  }, [f, _, h]);
  const E = () => {
    Promise.all([
      BL(),
      $L(),
      ph(m.current.signal)
    ]).then((N) => {
      c(NL(N[0].result)), p(TL(N[1].result)), s(bL(vL(N[2].result))), n(IL(N[2].result));
    }).catch((N) => {
      V(N);
    });
  }, { selectedIdentifiers: C } = It();
  J(() => {
    E(), C[us] && a({
      type: Et.CLEAR_ALL
    });
  }, []);
  const b = (N) => (I) => {
    i({
      filterKey: N,
      options: I
    }), C[us] ? a({
      type: Et.CLEAR_ALL
    }) : o({ [N]: I });
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "window-filters-container flex left dc__gap-8 px-20 py-12", children: [
    /* @__PURE__ */ e.jsx(
      vl,
      {
        inputId: "application-filter",
        placeholder: "Application",
        options: l,
        appliedFilters: g[js.APPLICATIONS],
        handleApplyChange: b(js.APPLICATIONS)
      }
    ),
    /* @__PURE__ */ e.jsx(
      vl,
      {
        inputId: "environment-filter",
        placeholder: "Environment",
        options: d,
        appliedFilters: g[js.ENVIRONMENTS],
        handleApplyChange: b(js.ENVIRONMENTS)
      }
    ),
    /* @__PURE__ */ e.jsx(
      vl,
      {
        inputId: "deployment-window-filter",
        placeholder: "Deployment Windows",
        options: t,
        appliedFilters: g[js.POLICY_NAMES],
        handleApplyChange: b(js.POLICY_NAMES)
      }
    )
  ] });
}, YL = ({ parentRef: t }) => {
  const s = _t({
    initialSortKey: Dn.APP_NAME,
    parseSearchParams: cl
  }), {
    pageSize: n,
    offset: a,
    searchKey: r,
    sortBy: o,
    sortOrder: i,
    applications: l,
    environments: c,
    policyNames: d,
    updateSearchParams: p,
    clearFilters: m
  } = s, u = Q(
    () => ({
      size: n,
      offset: a,
      searchKey: r,
      sortBy: o,
      sortOrder: i,
      appNames: l,
      envNames: c,
      policyNames: d
    }),
    [
      n,
      a,
      r,
      o,
      i,
      JSON.stringify(l),
      JSON.stringify(c),
      JSON.stringify(d)
    ]
  ), [f, _] = v(null), [h, x] = v(null), [g, E] = v(!1), [C, b] = v(null), [N, I] = v(!1), [T, A] = v(null), [S, L] = v(!1), [R, y] = v({}), M = de(new AbortController()), [P, U] = v([]), [G, H] = v({
    filterKey: js.APPLICATIONS,
    options: []
  });
  J(
    () => () => {
      M.current.abort();
    },
    []
  );
  const oe = () => {
    E(!0), kd(u, M.current.signal).then((q) => {
      q && _(q.result);
    }).catch((q) => x(q.code)).finally(() => {
      E(!1);
    });
  };
  J(() => {
    oe();
  }, [u]);
  const ae = Q(
    () => f?.appEnvironmentPolicyMappings?.reduce((q, be) => (q[`${be.appName}-${be.envName}`] = be, q), {}) ?? {},
    [f?.appEnvironmentPolicyMappings]
  );
  if (h && h !== 200)
    return /* @__PURE__ */ e.jsx(Xe, { code: h });
  const re = () => I((q) => !q), k = () => I(!0), D = () => (b({
    type: Et.SELECT_ALL
  }), Io.OPEN), F = () => g ? /* @__PURE__ */ e.jsx(Fd, { shimmerRowClassName: "deployment-window__apply-row", hideLastColumn: !0 }) : !f || f?.totalCount === 0 ? /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 h-100", children: /* @__PURE__ */ e.jsx(
    qt,
    {
      title: pt.NO_RESULTS,
      subTitle: pt.COULD_NOT_FOUND,
      handleClearFilters: m
    }
  ) }) : /* @__PURE__ */ e.jsx(
    GL,
    {
      appEnvList: f,
      appEnvListLoader: g,
      urlFilters: s,
      reloadApplyList: oe,
      setAppEnvList: _,
      filteredAppEnvList: T,
      filteredAppEnvListLoader: S,
      setProfileNameMap: y,
      showMultiBulkSelectionDialog: N,
      toggleSelectionDialog: re,
      setFilteredEnvListLoader: L,
      setFilteredAppEnvList: A,
      profileNameMap: R,
      totalCount: f.totalCount,
      windowOptions: P
    }
  );
  return /* @__PURE__ */ e.jsx(
    Ui,
    {
      identifiers: ae,
      getSelectAllDialogStatus: D,
      children: /* @__PURE__ */ e.jsxs("div", { ref: t, className: "flexbox-col h-100", children: [
        /* @__PURE__ */ e.jsx(
          DL,
          {
            showMultiBulkSelectionDialog: N,
            setFilteredAppEnvList: A,
            setFilteredEnvListLoader: L,
            totalCount: f?.totalCount,
            profileNameMap: R,
            parentRef: t,
            openMultiSelectionDialog: k
          }
        ),
        /* @__PURE__ */ e.jsxs("div", { className: "deployment-window__apply flexbox-col flex-grow-1 dc__gap-12", children: [
          /* @__PURE__ */ e.jsx(
            VL,
            {
              windowOptions: P,
              setWindowOptions: U,
              setProfileNameMap: y,
              setShowSelectionDialog: b,
              filterConfig: u,
              updateSearchParams: p,
              setCurrentFilterData: H
            }
          ),
          F(),
          (C?.type === Et.CLEAR_ALL || C?.type === Et.SELECT_ALL) && /* @__PURE__ */ e.jsx(
            PL,
            {
              setShowSelectionDialog: b,
              type: C.type,
              currentFilterData: G,
              updateSearchParams: p
            }
          )
        ] })
      ] })
    }
  );
}, iu = () => {
  const t = Te(), s = () => {
    t.push(Ee.DEPLOYMENT_WINDOW_CREATE);
  };
  return /* @__PURE__ */ e.jsxs("button", { type: "button", onClick: s, className: "cta small flex", children: [
    /* @__PURE__ */ e.jsx(Xt, { className: "icon-dim-16" }),
    pt.ADD_WINDOW
  ] });
}, HL = () => {
  const t = de(new AbortController()), [s, n] = v(jn.NAME), [a, r] = v(Ut.ASC), [o, i, l, c] = ne(
    () => es(
      () => ph(t.current.signal),
      t
    )
  ), [d, p] = v([]), [m, u] = v(!1), [f, _] = v(null), h = Te(), x = _t({
    initialSortKey: Dn.APP_NAME,
    parseSearchParams: cl
  }), { searchKey: g, handleSearch: E } = x;
  if (J(() => {
    i?.result && p(
      i.result.sort((y, M) => EE("name", y, M)).filter((y) => y.name.includes(g))
    );
  }, [i?.result, g]), l && l.code !== 200)
    return /* @__PURE__ */ e.jsx(Xe, { code: l.code });
  const C = () => u((y) => !y), b = (y) => {
    const M = i?.result.find(
      (P) => P.name === y.currentTarget.dataset.profile
    );
    _(M ?? null), C();
  }, N = (y) => {
    const M = s === y && a === Ut.ASC ? Ut.DESC : Ut.ASC;
    n(y);
    const P = [...d].sort((U, G) => M === Ut.ASC ? U[y.toLowerCase()].localeCompare(G[y.toLowerCase()]) : G[y.toLowerCase()].localeCompare(U[y.toLowerCase()]));
    p(P), r(M);
  }, I = () => /* @__PURE__ */ e.jsxs("div", { className: "deployment-window__profile-list__row dc__border-bottom-n1 pt-6 pb-6 cn-7 fw-6 pl-20 pr-20 dc__gap-16 fs-12 lh-20", children: [
    /* @__PURE__ */ e.jsx("div", {}),
    /* @__PURE__ */ e.jsx(
      Ne,
      {
        title: jn.NAME,
        triggerSorting: () => N(jn.NAME),
        isSorted: s === jn.NAME,
        sortOrder: a,
        disabled: !1
      }
    ),
    /* @__PURE__ */ e.jsx(
      Ne,
      {
        title: jn.TYPE,
        triggerSorting: () => N(jn.TYPE),
        isSorted: s === jn.TYPE,
        sortOrder: a,
        disabled: !1
      }
    ),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox ", children: jn.DESCRIPTION }),
    /* @__PURE__ */ e.jsx("div", {})
  ] }), T = (y) => {
    if (!y)
      return /* @__PURE__ */ e.jsx("div", { className: "flex left", children: "-" });
    const M = (P) => /* @__PURE__ */ e.jsx(lt, { content: y, placement: "top", className: "default-tt dc__word-break", arrow: !1, children: P });
    return /* @__PURE__ */ e.jsx(An, { condition: !!y, wrap: M, children: /* @__PURE__ */ e.jsx("div", { className: "dc__w-fit-content dc__ellipsis-right", children: y }) });
  }, A = () => {
    if (o)
      return /* @__PURE__ */ e.jsx(Fd, { shimmerRowClassName: "deployment-window__profile-list__row" });
    const y = () => {
      E("");
    };
    if (g && d.length === 0)
      return /* @__PURE__ */ e.jsx(
        qt,
        {
          title: me.REQUEST_PROMOTION_EMPTY_SEARCH.TITLE,
          subTitle: me.REQUEST_PROMOTION_EMPTY_SEARCH.SUB_TITLE,
          handleClearFilters: y
        }
      );
    const M = (U) => {
      const G = {
        policyNames: U
      };
      h.push({
        search: new URLSearchParams(G).toString(),
        pathname: h.location.pathname.replace(
          mc.LIST,
          mc.APPLY_TO
        )
      });
    }, P = (U) => h.push(`${Ee.DEPLOYMENT_WINDOW_EDIT}/${U.currentTarget.dataset.profile}`);
    return /* @__PURE__ */ e.jsx("div", { className: "deployment-window-list__table", children: d.map((U) => /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "dc__border-bottom-n1 deployment-window__profile-list__row dc__gap-16 px-20 pt-10 pb-10 dc__hover-n50 dc__visible-hover dc__visible-hover--parent",
        children: [
          EL(U.type),
          /* @__PURE__ */ e.jsx("div", { className: "dc__align-items-center dc__gap-16 dc__p-16", children: /* @__PURE__ */ e.jsxs("div", { className: "deployment-window__profile-name", children: [
            /* @__PURE__ */ e.jsx(
              "button",
              {
                className: "m-0 fs-13 fw-4 lh-20 cb-5 cursor dc__ellipsis-right dc__unset-button-styles",
                "data-profile": U.name,
                onClick: P,
                "data-testid": U.name,
                type: "button",
                children: U.name
              }
            ),
            /* @__PURE__ */ e.jsx(
              "div",
              {
                className: "dc__underline-onhover fs-12 lh-18 cursor",
                onClick: () => M(U.name),
                children: /* @__PURE__ */ e.jsxs("span", { className: "cn-7 deployment-window__count", children: [
                  U.windowCount,
                  " deployments"
                ] })
              }
            )
          ] }) }),
          /* @__PURE__ */ e.jsxs("div", { className: "flex left", children: [
            Ft(U.type),
            " window"
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "dc__ellipsis-right flex left", children: T(U.description) }),
          /* @__PURE__ */ e.jsx("div", { className: "flex dc__gap-4  dc__visible-hover--child ", children: /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-4", children: [
            /* @__PURE__ */ e.jsx(
              j,
              {
                icon: /* @__PURE__ */ e.jsx(Fs, {}),
                ariaLabel: "Edit",
                variant: w.borderLess,
                style: B.neutral,
                "data-profile": U.name,
                size: O.xs,
                dataTestId: `deployment-window-edit-${U.name}`,
                onClick: P
              }
            ),
            /* @__PURE__ */ e.jsx(
              j,
              {
                icon: /* @__PURE__ */ e.jsx(ts, {}),
                variant: w.borderLess,
                style: B.negativeGrey,
                size: O.xs,
                ariaLabel: "Delete",
                dataTestId: `deployment-window-delete-${U.name}`,
                "data-profile": U.name,
                onClick: b
              }
            )
          ] }) })
        ]
      },
      U.id
    )) });
  }, S = () => /* @__PURE__ */ e.jsx(
    _e,
    {
      title: pt.EMPTY_STATE_TITLE,
      subTitle: pt.EMPTY_STATE_SUB_TITLE,
      image: $b,
      renderButton: () => /* @__PURE__ */ e.jsx(iu, {}),
      classname: "dc__text-center flex-grow-1",
      isButtonAvailable: !0
    }
  ), L = () => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    I(),
    A()
  ] }), R = () => /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-12 h-100", children: i?.result?.length === 0 ? S() : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "px-20 flex dc__content-space pt-12", children: [
      /* @__PURE__ */ e.jsx(
        Wt,
        {
          initialSearchText: g,
          containerClassName: "dc__mxw-250 flex-grow-1",
          handleEnter: E,
          inputProps: {
            placeholder: "Search"
          }
        }
      ),
      /* @__PURE__ */ e.jsx(iu, {})
    ] }),
    L()
  ] }) });
  return l?.code ? /* @__PURE__ */ e.jsx(Xe, { code: l.code }) : /* @__PURE__ */ e.jsxs("div", { className: "deployment-window-list flexbox-col h-100", children: [
    R(),
    f && m && /* @__PURE__ */ e.jsx(
      mh,
      {
        selectedProfileDataId: f.id,
        selectedProfileData: f,
        reloadWindow: c,
        onClickDelete: b,
        closeConfirmationModal: C
      }
    )
  ] });
}, KL = () => {
  const t = () => /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "Ensure seamless operations and prevent downtime during crucial events by allowing deployment related actions only in specified time periods." }),
    /* @__PURE__ */ e.jsx("br", {}),
    /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "Choose from blackout or maintenance windows to block or allow deployments with precision, putting you in command of your deployment schedule. Stay in control, stay efficient!" })
  ] });
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col pt-16 px-20 dc__gap-8 dc__border-bottom", children: [
    /* @__PURE__ */ e.jsx(
      kc,
      {
        showInfoIcon: !0,
        SVGImage: Vb,
        title: pt.HEADING,
        renderDescriptionContent: t,
        docLink: "GLOBAL_CONFIG_DEPLOYMENT_WINDOW"
      }
    ),
    /* @__PURE__ */ e.jsx(Ar, { tabs: iL, hideTopPadding: !0 })
  ] });
}, KU = ({ isSuperAdmin: t }) => {
  const s = de(null), n = Ss(), a = n.pathname.includes(Ee.DEPLOYMENT_WINDOW_CREATE) || n.pathname.includes(Ee.DEPLOYMENT_WINDOW_EDIT);
  if (!t)
    return /* @__PURE__ */ e.jsx(Fm, {});
  const r = () => /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__overflow-auto flex-grow-1", ref: s, children: /* @__PURE__ */ e.jsxs(Vt, { children: [
    /* @__PURE__ */ e.jsx(ge, { path: Ee.DEPLOYMENT_WINDOW_WINDOWS, exact: !0, children: /* @__PURE__ */ e.jsx(HL, {}) }),
    /* @__PURE__ */ e.jsx(ge, { path: `${Ee.DEPLOYMENT_WINDOW_APPLY_TO}`, exact: !0, children: /* @__PURE__ */ e.jsx(YL, { parentRef: s }) }),
    /* @__PURE__ */ e.jsx(
      ge,
      {
        path: `${Ee.DEPLOYMENT_WINDOW_EDIT}/:profileName`,
        exact: !0,
        render: ({ match: o }) => /* @__PURE__ */ e.jsx("section", { className: "flexbox-col flex-grow-1 dc__content-center", children: /* @__PURE__ */ e.jsx(ou, {}, o.params.profileName) })
      }
    ),
    /* @__PURE__ */ e.jsx(ge, { path: `${Ee.DEPLOYMENT_WINDOW_CREATE}`, exact: !0, children: /* @__PURE__ */ e.jsx(ou, {}) }),
    /* @__PURE__ */ e.jsx(ms, { to: Ee.DEPLOYMENT_WINDOW_WINDOWS })
  ] }) });
  return /* @__PURE__ */ e.jsxs("div", { className: "deployment-window__global bg__primary fs-13 cn-9 dc__overflow-hidden h-100 flexbox-col", children: [
    !a && /* @__PURE__ */ e.jsx(KL, {}),
    r()
  ] });
}, va = {
  HEADER: "Application Template",
  FEATURE_DESCRIPTION: "Application templates allow you create applications in a breeze."
}, Gd = ({
  isLoading: t,
  error: s,
  list: n,
  searchKey: a,
  reloadList: r,
  borderVariant: o,
  handleClearFilters: i,
  emptyStateConfig: l
}) => {
  const c = Q(() => {
    if (!a || s)
      return n;
    const d = a.toLowerCase();
    return n.filter(({ title: p }) => p.toLowerCase().includes(d));
  }, [a, n, s]);
  return t ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Go, { isLoading: !0, borderVariant: o }),
    /* @__PURE__ */ e.jsx(Go, { isLoading: !0, borderVariant: o }),
    /* @__PURE__ */ e.jsx(Go, { isLoading: !0, borderVariant: o })
  ] }) : s ? /* @__PURE__ */ e.jsx(Xe, { code: s?.code, reload: r }) : c.length === 0 ? a ? /* @__PURE__ */ e.jsx(qt, { handleClearFilters: i }) : /* @__PURE__ */ e.jsx(_e, { image: N_, ...l }) : /* @__PURE__ */ e.jsx(e.Fragment, { children: c.map(({ id: d, title: p, description: m, author: u, Icon: f, onClick: _, linkProps: h }) => /* @__PURE__ */ e.jsx(
    Go,
    {
      title: p,
      description: m,
      author: u,
      borderVariant: o,
      Icon: f,
      ..._ ? { onClick: _ } : { linkProps: h }
    },
    d
  )) });
}, gh = (t) => ({
  id: t.id,
  templateId: t.identifier,
  name: t.name ?? "",
  description: t.description ?? "",
  author: t.createdBy?.name
}), WL = (t) => t.result?.map(gh).sort((s, n) => Ce(s.name, n.name)) ?? [], qL = (t) => t.result?.map((s) => ({
  id: s.id,
  name: s.name,
  description: s.description ?? "",
  author: s.createdBy?.name
})).sort((s, n) => Ce(s.name, n.name)) ?? [], zL = async (t) => {
  try {
    const s = Ba({
      baseUrl: $.RESOURCE_TEMPLATE_OPTIONS,
      kind: ie.devtronApplication,
      version: mt.alpha1
    }), n = await we(
      s,
      {},
      {
        abortControllerRef: t
      }
    );
    return qL(n);
  } catch (s) {
    throw Pe(s) || V(s), s;
  }
}, XL = async (t, s) => {
  const n = {
    name: t.name,
    identifier: t.templateId,
    description: t.description,
    sourceDetail: {
      kind: ie.devtronApplication,
      version: mt.alpha1,
      id: s
    }
  }, { result: a } = await we(Ws.RESOURCE_TEMPLATE, n);
  return gh(a);
}, JL = ({ setSelectedApp: t }) => {
  const { searchKey: s, handleSearch: n, clearFilters: a } = vs(), r = de(new AbortController()), [o, i, l, c] = ne(
    () => zL(r)
  );
  J(
    () => () => {
      r.current.abort();
    },
    []
  );
  const d = Q(() => (i ?? []).map((m) => {
    const { id: u, name: f, ..._ } = m;
    return {
      id: String(u),
      title: f,
      ..._,
      onClick: () => {
        t(m);
      },
      Icon: /* @__PURE__ */ e.jsx(od, {})
    };
  }), [i]);
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col pt-20 dc__overflow-auto flex-grow-1 dc__gap-16", children: [
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "flexbox-col dc__gap-12 py-12 dc__position-sticky bg__primary px-20 dc__zi-2",
        style: { top: "-20px" },
        children: [
          /* @__PURE__ */ e.jsx("h3", { className: "m-0 fs-15 fw-6 lh-22 cn-9", children: "Choose an application to use as template" }),
          !l && /* @__PURE__ */ e.jsx(
            Wt,
            {
              dataTestId: "application-list-search",
              initialSearchText: s,
              size: O.medium,
              handleEnter: n
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col pb-20 px-20 flex-grow-1", children: /* @__PURE__ */ e.jsx(
      Gd,
      {
        list: d ?? [],
        searchKey: s,
        isLoading: o,
        error: l,
        reloadList: c,
        borderVariant: Vc.NONE,
        handleClearFilters: a,
        emptyStateConfig: {
          title: "No apps found",
          subTitle: "We couldn't find any matching applications."
        }
      }
    ) })
  ] });
}, Al = {
  HEADER_TEXT: "Create Application Template",
  TEMPLATE_CREATION_IN_PROGRESS: "Template creation in progress"
}, Sl = {
  name: CE,
  templateId: Tn,
  description: dn
}, QL = {
  name: !0,
  templateId: !0,
  description: !1
}, yl = (t) => QL[t] ? null : "", ZL = {
  data: {
    name: "",
    templateId: "",
    description: ""
  },
  validationErrors: {
    name: yl("name"),
    templateId: yl("templateId"),
    description: yl("description")
  }
}, ej = ({ selectedApp: t, setSelectedApp: s, formData: n, handleUpdateFormData: a }) => {
  const r = () => {
    s(null);
  }, { breadcrumbs: o } = yr(
    {
      alias: {
        ...se.APPLICATION_MANAGEMENT_TEMPLATES_DEVTRON_APP_CREATE.split("/").slice(1, 3).reduce((c, d) => Object.assign(c, { [d]: null }), {}),
        "devtron-apps": {
          component: /* @__PURE__ */ e.jsx(
            j,
            {
              onClick: r,
              dataTestId: "select-application-breadcrumb",
              text: "Select Application",
              variant: w.text
            }
          ),
          linked: !1
        },
        create: {
          component: /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-6", children: [
            /* @__PURE__ */ e.jsx(od, { className: "icon-dim-20 dc__no-shrink" }),
            /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20 cn-9", children: t.name })
          ] }),
          linked: !1
        }
      }
    },
    [t]
  ), i = (c) => (d) => {
    a(c, d.currentTarget.value);
  }, l = (c) => {
    a("description", c.currentTarget.value);
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-hidden", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "px-20 py-12 flexbox dc__gap-12 dc__border-bottom-n1 dc__align-items-center", children: [
      /* @__PURE__ */ e.jsx(
        j,
        {
          dataTestId: "back-to-app-list",
          component: Re.button,
          ariaLabel: "Back to application list",
          onClick: r,
          icon: /* @__PURE__ */ e.jsx(gr, {}),
          size: O.xs,
          variant: w.secondary,
          style: B.neutral
        }
      ),
      /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center dc__gap-4", children: /* @__PURE__ */ e.jsx(Lr, { breadcrumbs: o, className: "flexbox dc__no-decor lh-20 fs-14 fw-6 " }) })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1 p-20 flexbox-col dc__overflow-auto", children: /* @__PURE__ */ e.jsxs("div", { className: "p-20 flexbox-col dc__gap-16 dc__border-n1 br-8", children: [
      /* @__PURE__ */ e.jsx(id, { className: "dc__no-shrink icon-dim-48" }),
      /* @__PURE__ */ e.jsx(
        yt,
        {
          name: "template-display-name",
          label: "Template display name",
          required: !0,
          value: n.data.name,
          error: n.validationErrors.name,
          onChange: i("name"),
          placeholder: "Ex. Data Processing Pipeline"
        }
      ),
      /* @__PURE__ */ e.jsx(
        yt,
        {
          name: "template-template-id",
          label: "Template ID",
          required: !0,
          value: n.data.templateId,
          error: n.validationErrors.templateId,
          onChange: i("templateId"),
          placeholder: "Ex. data-processing-pipeline"
        }
      ),
      /* @__PURE__ */ e.jsx(
        vn,
        {
          label: "Description",
          name: "tenant-description",
          placeholder: "Write a description for this template",
          value: n.data.description,
          onChange: l,
          error: n.validationErrors.description
        }
      )
    ] }) })
  ] });
}, tj = () => {
  const { push: t } = Te(), [s, n] = v(), [a, r] = v(!1), [o, i] = v(structuredClone(ZL));
  Di({
    shouldPrompt: a
  });
  const l = () => {
    t(se.APPLICATION_MANAGEMENT_TEMPLATES_DEVTRON_APP);
  }, c = (p, m) => {
    i({
      data: { ...o.data, [p]: m },
      validationErrors: {
        ...o.validationErrors,
        [p]: Sl[p]?.(m).message ?? ""
      }
    });
  }, d = async () => {
    try {
      if (!Object.values(o.validationErrors).every(
        (u) => !Ht(u) && !u
      )) {
        i({
          ...o,
          validationErrors: Object.fromEntries(
            Object.entries(Sl).map(([u]) => [
              u,
              Sl[u]?.(o.data[u]).message ?? ""
            ])
          )
        }), Z.showToast({
          description: vr.INVALID_INPUT,
          variant: ee.error
        });
        return;
      }
      r(!0);
      const { id: m } = await XL(o.data, Number(s.id));
      r(!1), Z.showToast({
        description: "Template created successfully",
        variant: ee.success
      }), t(
        Kt(se.APPLICATION_MANAGEMENT_TEMPLATES_DEVTRON_APP_DETAIL, {
          appId: m
        })
      );
    } catch (p) {
      V(p), r(!1);
    }
  };
  return /* @__PURE__ */ e.jsx(
    $t,
    {
      onClose: l,
      onEscape: l,
      position: "right",
      width: "1024px",
      parentClassName: "h-100",
      children: /* @__PURE__ */ e.jsxs(
        "dialog",
        {
          className: "bg__primary h-100 cn-9 w-100 flexbox-col dc__overflow-hidden p-0",
          onClick: Le,
          children: [
            /* @__PURE__ */ e.jsxs("header", { className: "px-20 py-12 lh-24 flexbox dc__content-space dc__align-items-center dc__border-bottom", children: [
              /* @__PURE__ */ e.jsx("span", { className: "fs-16 fw-6 dc__first-letter-capitalize", children: Al.HEADER_TEXT }),
              /* @__PURE__ */ e.jsx(
                j,
                {
                  icon: /* @__PURE__ */ e.jsx(vt, {}),
                  dataTestId: "rb-bulk-action__cross",
                  component: Re.button,
                  style: B.negativeGrey,
                  size: O.xs,
                  variant: w.borderLess,
                  ariaLabel: `Close ${Al.HEADER_TEXT.toLowerCase()} drawer`,
                  showTooltip: a,
                  tooltipProps: {
                    content: Al.TEMPLATE_CREATION_IN_PROGRESS
                  },
                  disabled: a,
                  onClick: l,
                  showAriaLabelInTippy: !1
                }
              )
            ] }),
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox flex-grow-1 dc__overflow-hidden", children: [
              /* @__PURE__ */ e.jsx(
                bE,
                {
                  icon: /* @__PURE__ */ e.jsx(id, { className: "dc__no-shrink icon-dim-48" }),
                  heading: va.HEADER,
                  documentationLink: "GLOBAL_CONFIG_DEVTRON_APP_TEMPLATES",
                  rootClassName: "p-20 dc__no-shrink",
                  children: va.FEATURE_DESCRIPTION
                }
              ),
              s ? /* @__PURE__ */ e.jsx(
                ej,
                {
                  selectedApp: s,
                  setSelectedApp: n,
                  formData: o,
                  handleUpdateFormData: c
                }
              ) : /* @__PURE__ */ e.jsx(JL, { setSelectedApp: n })
            ] }),
            s && /* @__PURE__ */ e.jsx("footer", { className: "flexbox dc__content-end dc__border-top-n1 px-20 py-16 dc__gap-12 dc__no-shrink", children: /* @__PURE__ */ e.jsx(
              j,
              {
                dataTestId: "create-template-button",
                onClick: d,
                isLoading: a,
                text: "Create Template"
              }
            ) }),
            /* @__PURE__ */ e.jsx(jo, { when: a, message: Nn })
          ]
        }
      )
    }
  );
}, sj = async ({
  id: t,
  abortControllerRef: s
}) => {
  try {
    const { result: n } = await le(
      Yc({
        type: Hc.OVERVIEW,
        queryParams: { id: t }
      }),
      { abortControllerRef: s }
    );
    return n;
  } catch (n) {
    throw Pe(n) || V(n), n;
  }
}, nj = ({ id: t, description: s, ...n }) => we(Yc({ type: Hc.OVERVIEW, queryParams: { id: t } }), {
  ...n,
  description: s,
  id: t
}), aj = ({ description: t, id: s, identifier: n }) => Bt(
  Yc({
    type: Hc.README,
    queryParams: { id: n.toString() }
  }),
  {
    description: t,
    id: s,
    identifier: n
  }
), rj = `## Describe this template

Describe this template in a few words. The description could include the purpose, features, benefits, and target audience of your template. A well-written description will help users know about this template and how it works. Keep it concise and informative!`, oj = ({ templateOverview: t, refetchTemplateDetail: s }) => {
  const { appId: n } = Ue(), a = async (o) => {
    try {
      await nj({ ...t, description: o, id: +n }), await s(), Z.showToast({
        variant: ee.success,
        description: "Successfully saved"
      });
    } catch (i) {
      throw V(i), i;
    }
  }, r = async (o) => {
    await aj({ description: o, id: t.note.id, identifier: +n }), await s(), Z.showToast({
      variant: ee.success,
      description: "Saved changes"
    });
  };
  return /* @__PURE__ */ e.jsxs("main", { className: "flex-grow-1 px-20 devtron-app-template-container__overview dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "py-20 flexbox-col dc__gap-16", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
        /* @__PURE__ */ e.jsx(od, { className: "icon-dim-48 br-8" }),
        /* @__PURE__ */ e.jsx("h2", { className: "m-0 fs-16 lh-24 fw-7 cn-9 dc__word-break font-merriweather", children: t.appName }),
        /* @__PURE__ */ e.jsx(
          NE,
          {
            emptyState: "Write a short description for this app template",
            placeholder: "Write a short description for this app template",
            initialText: t.description,
            updateContent: a,
            validations: {
              maxLength: {
                value: ip,
                message: TE.getMaxCharMessage(ip)
              }
            }
          }
        )
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "divider__secondary--horizontal" }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
        /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-12 lh-20 cn-7", children: "Created By" }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex left", children: [
          sa(t.createdBy),
          /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-13 lh-20 fw-6 cn-9", children: t.createdBy })
        ] })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
        /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-12 lh-20 cn-7", children: "Created On" }),
        /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-13 lh-20 fw-6 cn-9", children: t.createdOn ? rd(t.createdOn).format(Ir.TWELVE_HOURS_FORMAT) : "-" })
      ] })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "py-20", children: /* @__PURE__ */ e.jsx(
      IE,
      {
        title: "Readme",
        updateDescription: r,
        text: t.note?.description || rj,
        updatedBy: t.note?.updatedBy,
        updatedOn: t.note?.updatedOn
      }
    ) })
  ] });
}, xh = async (t) => {
  try {
    const s = Ba({
      baseUrl: Ws.RESOURCE_TEMPLATE,
      kind: ie.devtronApplication,
      version: mt.alpha1,
      suffix: $.API_LIST_SUFFIX
    }), n = await le(s, {
      abortControllerRef: t
    });
    return WL(n);
  } catch (s) {
    throw Pe(s) || V(s), s;
  }
}, ij = () => {
  const { push: t } = Te(), { appId: s } = Ue(), [n, a] = ne(xh), { selectedOption: r, options: o } = Q(() => {
    if (!a)
      return { selectedOption: null, options: [] };
    const l = a.find((c) => c.id === Number(s));
    return {
      selectedOption: l ? {
        label: l.name,
        value: l.id
      } : null,
      options: a.map((c) => ({ label: c.name, value: c.id }))
    };
  }, [a, s]), i = (l) => {
    t(
      Kt(se.APPLICATION_MANAGEMENT_TEMPLATES_DEVTRON_APP_DETAIL, {
        appId: String(l.value)
      })
    );
  };
  return /* @__PURE__ */ e.jsx(
    sd,
    {
      menuPosition: "absolute",
      isLoading: n,
      options: o,
      noOptionsMessage: vE,
      onChange: i,
      components: {
        IndicatorSeparator: null,
        DropdownIndicator: AE,
        LoadingIndicator: null,
        ValueContainer: SE
      },
      value: r,
      styles: {
        ...lp,
        valueContainer: (l, c) => ({
          ...lp.valueContainer(l, c),
          flexWrap: "nowrap"
        })
      }
    }
  );
}, lj = ({ AppConfig: t }) => {
  const { path: s, url: n } = Wi(), { appId: a } = Ue(), r = de(new AbortController()), [o, i, l, c] = ne(
    () => es(
      () => sj({
        id: +a,
        abortControllerRef: r
      }),
      r
    ),
    [a],
    !!a,
    { resetOnChange: !1 }
  ), { breadcrumbs: d } = yr(
    {
      alias: {
        ...$c(),
        templates: { component: null, linked: !1 },
        "devtron-app": {
          component: /* @__PURE__ */ e.jsx(Ao, { heading: "Application Templates" }),
          linked: !0
        },
        detail: {
          component: /* @__PURE__ */ e.jsx(ij, {}),
          linked: !1
        },
        ":appId": {
          component: null,
          linked: !1
        }
      }
    },
    []
  );
  J(
    () => () => {
      r.current.abort();
    },
    []
  );
  const p = () => /* @__PURE__ */ e.jsx(Lr, { breadcrumbs: d }), m = () => {
    const f = [
      {
        id: "app-template-overview-tab",
        label: "Overview",
        tabType: "navLink",
        props: {
          to: `${n}/overview`,
          "data-action": "Template Overview Clicked",
          "data-testid": "app-template-overview-link"
        }
      },
      {
        id: "app-template-configuration-tab",
        label: "Configurations",
        tabType: "navLink",
        icon: Oo,
        props: {
          to: `${n}/${se.APP_CONFIG}`,
          "data-action": "Template Configuration Clicked",
          "data-testid": "app-template-config-link"
        }
      }
    ];
    return /* @__PURE__ */ e.jsx(Ar, { tabs: f, hideTopPadding: !0 });
  }, { isSuperAdmin: u } = Is();
  return /* @__PURE__ */ e.jsxs("main", { className: "flex-grow-1 flexbox-col dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsx(
      Yi,
      {
        breadCrumbs: p,
        isBreadcrumbs: !0,
        showTabs: !0,
        renderHeaderTabs: m,
        docPath: Kc.APP_MANAGEMENT
      }
    ),
    u ? /* @__PURE__ */ e.jsx(
      Ke,
      {
        isLoading: o,
        progressingProps: {
          pageLoader: !0
        },
        error: l,
        errorScreenManagerProps: {
          code: l?.code,
          reload: c,
          redirectURL: se.APPLICATION_MANAGEMENT_TEMPLATES_DEVTRON_APP
        },
        children: /* @__PURE__ */ e.jsxs(Vt, { children: [
          /* @__PURE__ */ e.jsx(ge, { path: `${s}/overview`, children: /* @__PURE__ */ e.jsx(oj, { templateOverview: i, refetchTemplateDetail: c }) }),
          /* @__PURE__ */ e.jsx(ge, { path: `${s}/${se.APP_CONFIG}`, children: /* @__PURE__ */ e.jsx(
            t,
            {
              resourceKind: ie.devtronApplication,
              appName: i?.appName ?? "",
              isTemplateView: !0
            }
          ) }),
          /* @__PURE__ */ e.jsx(ms, { to: `${s}/${se.APP_CONFIG}` })
        ] })
      }
    ) : /* @__PURE__ */ e.jsx(Xe, { code: da.PERMISSION_DENIED })
  ] });
}, Eh = ({ handleTemplateClick: t } = {}) => {
  const s = de(new AbortController()), [n, a, r, o] = ne(xh);
  J(
    () => () => {
      s.current.abort();
    },
    []
  );
  const i = Q(() => !n && a ? a.map((l) => {
    const { id: c, name: d, ...p } = l;
    return {
      id: String(c),
      title: d,
      ...p,
      ...t ? {
        onClick: () => t(l)
      } : {
        linkProps: {
          to: Kt(se.APPLICATION_MANAGEMENT_TEMPLATES_DEVTRON_APP_DETAIL, {
            appId: String(c)
          })
        }
      },
      Icon: /* @__PURE__ */ e.jsx(id, {})
    };
  }) : [], [n, a]);
  return {
    isTemplateListLoading: n,
    templateList: i,
    templateListError: r,
    reloadTemplateList: o
  };
}, cj = () => {
  const { searchKey: t, handleSearch: s, clearFilters: n } = _t(), { pathname: a } = Ss(), { isTemplateListLoading: r, templateList: o, templateListError: i, reloadTemplateList: l } = Eh(), { breadcrumbs: c } = yr(
    {
      alias: {
        ...$c(),
        templates: {
          component: /* @__PURE__ */ e.jsx(Ao, { heading: "Application Templates", isActive: !0 })
        },
        "devtron-app": null
      }
    },
    [a]
  ), d = () => /* @__PURE__ */ e.jsx(Lr, { breadcrumbs: c }), { isSuperAdmin: p } = Is();
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Yi, { breadCrumbs: d, isBreadcrumbs: !0, docPath: Kc.APP_MANAGEMENT }),
    p ? /* @__PURE__ */ e.jsx("div", { className: "flexbox-col py-16 dc__overflow-auto flex-grow-1 bg__tertiary flex-align-center", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-20 dc__mxw-800 flex-grow-1 w-100", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__align-items-center bg__tertiary dc__no-shrink", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__align-items-center", children: [
          /* @__PURE__ */ e.jsx("h1", { className: "fs-16 fw-6 lh-32 cn-9 m-0", children: va.HEADER }),
          /* @__PURE__ */ e.jsx(
            ca,
            {
              heading: va.HEADER,
              infoText: va.FEATURE_DESCRIPTION,
              documentationLink: "GLOBAL_CONFIG_DEVTRON_APP_TEMPLATES",
              iconClassName: "icon-dim-20",
              placement: "bottom"
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "dc__separated-flexbox dc__separated-flexbox--gap-8", children: [
          !i && /* @__PURE__ */ e.jsx(
            Wt,
            {
              dataTestId: "template-list-search",
              containerClassName: "w-250",
              initialSearchText: t,
              size: O.medium,
              handleEnter: s
            }
          ),
          /* @__PURE__ */ e.jsx(
            j,
            {
              linkProps: { to: se.APPLICATION_MANAGEMENT_TEMPLATES_DEVTRON_APP_CREATE },
              component: Re.link,
              dataTestId: "create-template-button",
              text: "Create Template",
              startIcon: /* @__PURE__ */ e.jsx(Xt, {}),
              size: O.medium,
              variant: w.primary
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-12 flex-grow-1", children: /* @__PURE__ */ e.jsx(
        Gd,
        {
          list: o,
          searchKey: t,
          isLoading: r,
          error: i,
          reloadList: l,
          borderVariant: Vc.ROUNDED,
          handleClearFilters: n,
          emptyStateConfig: {
            title: "Add your first app template",
            subTitle: va.FEATURE_DESCRIPTION
          }
        }
      ) })
    ] }) }) : /* @__PURE__ */ e.jsx(Xe, { code: da.PERMISSION_DENIED })
  ] });
}, WU = ({ AppConfig: t }) => /* @__PURE__ */ e.jsx("div", { className: "devtron-app-template-container bg__secondary flexbox-col h-100 dc__overflow-hidden", children: /* @__PURE__ */ e.jsxs(Vt, { children: [
  /* @__PURE__ */ e.jsx(ge, { path: se.APPLICATION_MANAGEMENT_TEMPLATES_DEVTRON_APP_DETAIL, children: /* @__PURE__ */ e.jsx(lj, { AppConfig: t }) }),
  /* @__PURE__ */ e.jsxs(ge, { path: se.APPLICATION_MANAGEMENT_TEMPLATES_DEVTRON_APP, children: [
    /* @__PURE__ */ e.jsx(cj, {}),
    /* @__PURE__ */ e.jsx(ge, { path: se.APPLICATION_MANAGEMENT_TEMPLATES_DEVTRON_APP_CREATE, exact: !0, children: /* @__PURE__ */ e.jsx(tj, {}) })
  ] }),
  /* @__PURE__ */ e.jsx(ms, { to: se.APPLICATION_MANAGEMENT_TEMPLATES_DEVTRON_APP })
] }) }), qU = ({ templateId: t, appName: s, description: n, labels: a, teamId: r, templatePatch: o }) => {
  const i = ye(
    Ba({
      baseUrl: Ws.RESOURCE_TEMPLATE,
      kind: ie.devtronApplication,
      version: mt.alpha1
    }),
    {
      templateIdentifier: t
    }
  );
  return we(i, {
    templateIdentifier: t,
    appName: s,
    description: n,
    labels: a,
    teamId: r,
    templatePatch: o
  });
}, zU = ({
  isBitbucketCloud: t,
  setIsBitbucketCloud: s
}) => {
  const n = () => {
    s(!t);
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "bitbucket-radio-group", children: [
    /* @__PURE__ */ e.jsx("label", { className: "form__label form__label--sentence dc__bold", children: "Select your Bitbucket host" }),
    /* @__PURE__ */ e.jsxs(
      ds,
      {
        className: "form__radio-group chartrepo-type__radio-group bitbucket-radio-group",
        name: "bitbucket-cloud-server-toggle",
        value: `${t}`,
        onChange: n,
        children: [
          /* @__PURE__ */ e.jsx(Ze, { value: "true", children: "Bitbucket Cloud" }),
          /* @__PURE__ */ e.jsx(Ze, { value: "false", children: "Bitbucket Data Center" })
        ]
      }
    )
  ] });
}, Ch = ({
  handleChange: t,
  name: s,
  isRequired: n,
  label: a,
  errorMessage: r,
  value: o,
  placeholder: i,
  isDisabled: l = !1,
  isEditMode: c = !1
}) => {
  const [d, p] = v(!1), m = (h) => {
    t(h, "sshKey");
  }, u = () => {
    p(!0);
  }, f = () => {
    p(!1);
  }, _ = !c || o?.length > 0 || d || o?.length > 0 ? o : xi;
  return /* @__PURE__ */ e.jsx(
    vn,
    {
      label: a,
      name: s,
      placeholder: i,
      value: _,
      onFocus: u,
      onBlur: f,
      onChange: m,
      disabled: l,
      required: n,
      shouldTrim: !1,
      error: r,
      fullWidth: !0
    }
  );
}, XU = ({
  authMode: t,
  initialAuthMode: s,
  handleAuthModeChange: n,
  handleChange: a,
  username: r,
  sshKey: o,
  token: i,
  id: l
}) => {
  const [c, d] = v(!1), p = !l || t !== s, m = i.value === xi ? "" : i.value, u = () => {
    d(!0);
  }, f = () => {
    d(!1);
  }, _ = (g) => {
    a(g, "token");
  }, h = (g) => {
    a(g, "username");
  }, x = p || m?.length > 0 || c ? m : xi;
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
    /* @__PURE__ */ e.jsxs(
      ds,
      {
        className: "radio-group-no-border bit-bucket-dc-credentials--radio-group",
        name: "toggle-git-access-credentials",
        value: t,
        onChange: n,
        children: [
          /* @__PURE__ */ e.jsx(Ze, { value: qa.PASSWORD, children: "Password" }),
          /* @__PURE__ */ e.jsx(Ze, { value: qa.SSH_AND_PASSWORD, children: "Personal Access Token + SSH Private Key" })
        ]
      }
    ),
    /* @__PURE__ */ e.jsx(
      yt,
      {
        value: r.value,
        error: r.error,
        onChange: h,
        label: "Bitbucket Username",
        name: "Bitbucket Username",
        placeholder: "Enter username",
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      yt,
      {
        value: x,
        error: i.error,
        onChange: _,
        name: t === qa.SSH_AND_PASSWORD ? "Personal Access Token" : "Password",
        label: t === qa.SSH_AND_PASSWORD ? "Personal Access Token" : "Password",
        placeholder: "Enter token",
        onFocus: u,
        onBlur: f,
        required: !0,
        labelTippyCustomizedConfig: t === qa.SSH_AND_PASSWORD ? {
          heading: "Personal Access Token",
          infoText: /* @__PURE__ */ e.jsx(
            $a,
            {
              docLinkKey: "GITOPS_BITBUCKET",
              text: "Check permissions required for PAT",
              dataTestId: "learn-more-about-bitbucket-pat-link",
              fontWeight: "normal"
            }
          )
        } : null
      }
    ),
    t === qa.SSH_AND_PASSWORD && /* @__PURE__ */ e.jsx(
      Ch,
      {
        value: o.value,
        errorMessage: o.error,
        handleChange: a,
        name: "SSH Key",
        label: "SSH Private Key",
        placeholder: "Enter SSH key",
        isEditMode: !p,
        isRequired: !0
      }
    )
  ] });
}, dj = (t, s) => t ? {
  sshHostConfig: {
    placeholder: "Eg. ssh://git-codecommit.ap-south-1.amazonaws.com",
    name: "aws-code-commit-ssh-host",
    disabled: s,
    required: !0,
    label: "SSH host (Use ssh://)"
  },
  usernameConfig: {
    placeholder: "Enter username (SSH KEY ID)",
    name: "aws-code-commit-username",
    label: "Enter username",
    disabled: s,
    required: !0
  },
  sshKeyConfig: {
    placeholder: "Enter SSH Private Key",
    name: "aws-code-commit-ssh-private-key",
    label: "SSH Private Key",
    disabled: !1,
    required: !0
  }
} : {
  sshHostConfig: {
    placeholder: "Eg. git@myremote.example",
    name: "generic-ssh-host",
    label: "SSH host",
    disabled: !1,
    required: !0
  },
  usernameConfig: {
    placeholder: "Enter username",
    name: "generic-username",
    label: "Enter username",
    disabled: !1,
    required: !1
  },
  sshKeyConfig: {
    placeholder: "Enter SSH Private Key",
    name: "generic-ssh-private-key",
    label: "SSH Private Key",
    disabled: !1,
    required: !0
  }
}, JU = ({
  sshHost: t,
  sshKey: s,
  username: n,
  handleChange: a,
  id: r,
  isActive: o,
  isAWSCodeCommit: i
}) => {
  const l = (u) => {
    a(u, "sshHost");
  }, c = (u) => {
    a(u, "username");
  }, { sshHostConfig: d, sshKeyConfig: p, usernameConfig: m } = dj(i, o);
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16 w-100", children: [
    /* @__PURE__ */ e.jsx(
      yt,
      {
        name: d.name,
        label: d.label,
        placeholder: d.placeholder,
        value: t.value,
        error: t.error,
        onChange: l,
        autoFocus: !0,
        required: d.required,
        disabled: d.disabled
      }
    ),
    /* @__PURE__ */ e.jsx(
      yt,
      {
        name: m.name,
        label: m.label,
        placeholder: m.placeholder,
        value: n.value,
        error: n.error,
        onChange: c,
        required: m.required,
        disabled: d.disabled
      }
    ),
    /* @__PURE__ */ e.jsx(
      Ch,
      {
        handleChange: a,
        name: p.name,
        isRequired: p.required,
        label: p.label,
        errorMessage: s.error,
        value: s.value,
        placeholder: p.placeholder,
        isDisabled: p.disabled,
        isEditMode: !!r
      }
    )
  ] });
}, Bd = ({
  requiredApprovals: t,
  onChangeRequiredApprovals: s
}) => {
  const n = (a) => {
    s(parseInt(a.value, 10));
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8", children: [
    /* @__PURE__ */ e.jsx(Xi, { className: "icon-dim-20" }),
    /* @__PURE__ */ e.jsx(Ie, { content: "Number of approvals required", alwaysShowTippyOnHover: !0, children: /* @__PURE__ */ e.jsx(
      Qs,
      {
        segments: yE(6).map((a, r) => ({
          label: `${r + 1}`,
          value: `${r + 1}`
        })),
        value: t?.toString() || "1",
        onChange: n,
        name: "required-approvals"
      }
    ) })
  ] });
};
var rs = /* @__PURE__ */ ((t) => (t.approvalTypeChange = "approvalTypeChange", t.addUserGroupCriteria = "addUserGroupCriteria", t.updateUserGroupCriteria = "updateUserGroupCriteria", t.deleteUserGroupCriteria = "deleteUserGroupCriteria", t.updateSpecificUserSelection = "updateSpecificUserSelection", t.updateRequiredCount = "updateRequiredCount", t.toggleManualApproval = "toggleManualApproval", t))(rs || {});
const pj = ({
  userApprovalConfig: t,
  handleUserConfigChange: s
}) => {
  const [n, a] = ne(() => vm()), [r, o] = ne(() => bd()), { userGroupOptions: i, availableUserGroupOptions: l } = Q(() => {
    const _ = (o ?? []).map(
      ({ name: g, userGroupId: E, usersCount: C }) => ({
        label: g,
        value: E,
        description: `Users in group: ${Eo(C)}`
      })
    ), h = t.userGroups.reduce((g, { identifier: E }) => (g[E] = !0, g), {});
    return {
      availableUserGroupOptions: _.filter(
        (g) => !h[g.value]
      ),
      userGroupOptions: _
    };
  }, [t.userGroups, o]), c = t.specificUsers.identifiers.map(
    (_) => LE(_)
  ), d = () => {
    s({
      action: rs.addUserGroupCriteria
    });
  }, p = (_, { requiredCount: h }) => ({ value: x }) => {
    s({
      action: rs.updateUserGroupCriteria,
      payload: {
        userGroupIndexToUpdate: _,
        updatedValue: {
          identifier: x,
          requiredCount: h
        }
      }
    });
  }, m = (_, { identifier: h }) => (x) => {
    s({
      action: rs.updateUserGroupCriteria,
      payload: {
        userGroupIndexToUpdate: _,
        updatedValue: {
          identifier: h,
          requiredCount: x
        }
      }
    });
  }, u = (_) => () => {
    s({
      action: rs.deleteUserGroupCriteria,
      payload: {
        userGroupIndexToDelete: _
      }
    });
  }, f = (_) => {
    s({
      action: rs.updateSpecificUserSelection,
      payload: {
        updatedUserSelections: _
      }
    });
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flex column left dc__gap-12 flex-grow-1 w-100 pl-26", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex column left dc__gap-12", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-12", children: [
        /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20 cn-7", children: "User Groups" }),
        /* @__PURE__ */ e.jsxs(
          "button",
          {
            className: "dc__unset-button-styles cb-5 flex left dc__gap-4 fw-6 fs-13 lh-20",
            type: "button",
            onClick: d,
            children: [
              /* @__PURE__ */ e.jsx(Xt, { className: "icon-dim-16 dc__no-shrink fcb-5" }),
              "Add Criteria"
            ]
          }
        )
      ] }),
      t.userGroups.map(({ identifier: _, requiredCount: h }, x) => /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: "flex left dc__gap-12",
          children: [
            /* @__PURE__ */ e.jsx("div", { className: "w-150", children: /* @__PURE__ */ e.jsx(
              Ve,
              {
                inputId: `user-group-selector-${x}`,
                options: l,
                variant: cn.COMPACT,
                size: O.medium,
                isLoading: r,
                isDisabled: r,
                placeholder: "Select a user group",
                value: i.find(({ value: g }) => g === _),
                onChange: p(x, {
                  requiredCount: h
                })
              }
            ) }),
            _ && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              /* @__PURE__ */ e.jsx(Ms, { className: "dc__no-shrink scn-6" }),
              /* @__PURE__ */ e.jsx(
                Bd,
                {
                  requiredApprovals: h,
                  onChangeRequiredApprovals: m(x, {
                    identifier: _
                  })
                }
              )
            ] }),
            /* @__PURE__ */ e.jsx(
              "button",
              {
                className: "dc__transparent p-4 flex dc__hover-remove-btn",
                type: "button",
                "aria-label": `Delete user group${_ ? `: ${_}` : ""}?`,
                onClick: u(x),
                children: /* @__PURE__ */ e.jsx(vt, { className: "icon-dim-16 dc__no-shrink" })
              }
            )
          ]
        },
        `${_}-${x}`
      ))
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom-n1 w-100" }),
    /* @__PURE__ */ e.jsx(
      Ve,
      {
        inputId: "specific-user-and-token-selector",
        label: "Specific Users",
        placeholder: "Select specific users",
        helperText: "All selected users must have the necessary permissions and provide approvals",
        isMulti: !0,
        options: a ?? [],
        isDisabled: n,
        isLoading: n,
        onChange: f,
        value: c,
        fullWidth: !0
      }
    )
  ] });
}, uj = ({
  handleUserConfigChange: t,
  userApprovalConfig: s,
  onChangeRequiredApprovals: n,
  userApprovalConfigErrorObj: a
}) => {
  const r = (o) => {
    t({
      action: rs.approvalTypeChange,
      payload: {
        event: o
      }
    });
  };
  return /* @__PURE__ */ e.jsx("div", { className: "manual-approval-type", children: /* @__PURE__ */ e.jsx(
    ds,
    {
      name: "approval-type",
      value: s.type,
      disabled: !1,
      onChange: r,
      className: "radio-group-no-border w-100",
      children: /* @__PURE__ */ e.jsxs("div", { className: "flex column left dc__gap-12 pr-40", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex column dc__gap-8 left", children: [
          /* @__PURE__ */ e.jsx(Ze, { value: is.any, children: /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8", children: [
            /* @__PURE__ */ e.jsx("span", { children: "Any Approver" }),
            s.type === is.any && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              /* @__PURE__ */ e.jsx(Ms, { className: "dc__no-shrink scn-6" }),
              /* @__PURE__ */ e.jsx(
                Bd,
                {
                  requiredApprovals: s.requiredCount,
                  onChangeRequiredApprovals: n
                }
              )
            ] })
          ] }) }),
          /* @__PURE__ */ e.jsx(Ze, { value: is.specific, children: /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8", children: [
            /* @__PURE__ */ e.jsx("span", { children: "Specific Approver" }),
            !a?.isValid && /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-4 cr-5 fs-12 lh-18 fw-4", children: [
              /* @__PURE__ */ e.jsx(Va, { className: "icon-dim-16 p-1 form__icon--error dc__no-shrink dc__align-self-start" }),
              /* @__PURE__ */ e.jsx("span", { className: "dc__ellipsis-right__2nd-line", children: a.message })
            ] })
          ] }) })
        ] }),
        s.type === is.specific && /* @__PURE__ */ e.jsx(
          pj,
          {
            handleUserConfigChange: t,
            userApprovalConfig: s
          }
        )
      ] })
    }
  ) });
}, Ll = 1, bh = ({
  handleUpdateUserApprovalConfig: t,
  renderManualApprovalEnableContent: s,
  labelText: n = "",
  subTitle: a,
  SvgIcon: r,
  subTitleWhenDisabled: o,
  showSpecificApprovals: i = !1,
  userApprovalConfig: l,
  userApprovalConfigErrorObj: c = {
    isValid: !0
  },
  hideIcon: d,
  hideManualApprovalToggle: p
}) => {
  const [m, u] = v(
    p || jE(l)
  ), f = ({ action: x, payload: g }) => {
    let E = structuredClone(l);
    switch (x) {
      case rs.approvalTypeChange: {
        const { event: C } = g, b = C.target.value;
        b === is.any && !E.requiredCount && (E.requiredCount = Ll), E.type = b;
        break;
      }
      case rs.addUserGroupCriteria:
        E.userGroups = [
          {
            identifier: null,
            requiredCount: Ll
          },
          ...E.userGroups
        ];
        break;
      case rs.updateUserGroupCriteria: {
        const {
          userGroupIndexToUpdate: C,
          updatedValue: { identifier: b, requiredCount: N }
        } = g;
        E.userGroups[C] = {
          ...E.userGroups[C],
          identifier: b,
          requiredCount: N
        };
        break;
      }
      case rs.deleteUserGroupCriteria: {
        const { userGroupIndexToDelete: C } = g;
        E.userGroups = E.userGroups.filter(
          (b, N) => N !== C
        );
        break;
      }
      case rs.updateSpecificUserSelection: {
        const { updatedUserSelections: C } = g;
        E.specificUsers = {
          ...E.specificUsers,
          identifiers: C.map(({ value: b }) => b)
        };
        break;
      }
      case rs.updateRequiredCount: {
        const { requiredCountToUpdate: C } = g;
        E.requiredCount = C;
        break;
      }
      case rs.toggleManualApproval:
        E.type = m ? is.notConfigured : is.any, m ? E = gd(null) : (E.type = is.any, E.requiredCount = Ll), u(OE);
        break;
      default:
        throw new Error(`Unsupported action: ${x}`);
    }
    t(E);
  }, _ = () => {
    f({
      action: rs.toggleManualApproval
    });
  }, h = (x) => {
    f({
      action: rs.updateRequiredCount,
      payload: {
        requiredCountToUpdate: x
      }
    });
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flex top left dc__gap-12", children: [
    !d && /* @__PURE__ */ e.jsx("div", { className: "dc__no-shrink", children: r ? /* @__PURE__ */ e.jsx(r, {}) : /* @__PURE__ */ e.jsx("div", { className: "icon-dim-44 bcn-1 br-8 flex", children: /* @__PURE__ */ e.jsx(Xi, { className: "icon-dim-24" }) }) }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 flex-grow-1", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex left flex-grow-1", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex-1", children: [
          /* @__PURE__ */ e.jsx("h4", { "data-testid": "manual-approval-heading", className: "fs-13 fw-6 lh-1-5 cn-9 mb-0 mt-0", children: n }),
          !m && o ? /* @__PURE__ */ e.jsx("div", { className: "form__label form__label--sentence m-0 mb-0-imp", children: o }) : a && /* @__PURE__ */ e.jsx("div", { className: "form__label form__label--sentence m-0 mb-0-imp", children: a })
        ] }),
        !p && /* @__PURE__ */ e.jsx(
          Gn,
          {
            name: "toggle-manual-approval",
            ariaLabel: "Toggle manual approval",
            isChecked: m,
            onChange: _
          }
        )
      ] }),
      m && (i ? /* @__PURE__ */ e.jsx(
        uj,
        {
          handleUserConfigChange: f,
          userApprovalConfig: l,
          userApprovalConfigErrorObj: c,
          onChangeRequiredApprovals: h
        }
      ) : /* @__PURE__ */ e.jsxs("div", { className: "mb-16 ml-60 flexbox-col dc__gap-12", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
          /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20 mb-6", children: "Required number of approvals" }),
          /* @__PURE__ */ e.jsx(
            Bd,
            {
              requiredApprovals: l.requiredCount,
              onChangeRequiredApprovals: h
            }
          )
        ] }),
        s && s()
      ] }))
    ] })
  ] });
}, QU = () => le("filters"), ZU = (t) => Bt("filters", t), e2 = (t) => le(`filters/${t}`), t2 = (t) => Js(`filters/${t}`), s2 = (t, s) => we(`filters/${t}`, s), mj = (t) => we("filters/expression/validate", t);
var $s = /* @__PURE__ */ ((t) => (t.PASS = "PASS", t.FAIL = "FAIL", t))($s || {});
function _j({ label: t, type: s, tooltip: n }) {
  const [a, r] = v(null), o = t, i = (c) => {
    c.stopPropagation(), r(Um(o));
  }, l = () => {
    if (!n)
      return `Defines filter condition for ${t}}`;
    const d = n.split(`
`).map((p) => /* @__PURE__ */ e.jsx("p", { className: "m-0", children: p }, p));
    return /* @__PURE__ */ e.jsx("div", { className: "flexbox-col", children: d });
  };
  return /* @__PURE__ */ e.jsx(lt, { content: l(), placement: "left", className: "default-tt p-8", interactive: !0, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "flexbox pr-12 pl-12 pt-8 pb-8 dc__align-items-center dc__gap-12 dc__lign-self-stretch bg__primary cursor dc__hover-n50",
      onClick: i,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1 flexbox dc__align-items-center cn-9 fs-13 fw-4 lh-16 dc__gap-6", children: [
          t,
          /* @__PURE__ */ e.jsx(
            Hi,
            {
              content: o,
              copiedTippyText: `Copied: ${o}`,
              copyToClipboardPromise: a
            }
          )
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center cn-5 fs-13 fw-4 lh-20", children: s })
      ]
    },
    t
  ) });
}
const fj = () => {
  const [t, s, n, a] = ne(Q_);
  return t ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col p-12 dc__gap-12 mxh-210 bg__primary dc__no-border dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100 h-32" }),
    /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100 h-32" }),
    /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100 h-32" }),
    /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100 h-32" })
  ] }) : n ? /* @__PURE__ */ e.jsx(ps, { reload: a }) : /* @__PURE__ */ e.jsx("div", { className: "flexbox-col pt-4 pb-4 mxh-210 bg__primary dc__no-border dc__overflow-auto", children: s.map((r) => /* @__PURE__ */ e.jsx(
    _j,
    {
      label: r.label,
      type: r.type,
      tooltip: r.tooltip
    },
    r.label
  )) });
}, lu = (t) => t === $s.PASS ? Vs.PASS : Vs.FAIL, hj = (t, s, n) => {
  const a = s.find(
    (o) => o.conditionType === lu(t)
  );
  return a && a.errorMsg ? ur.ERROR : n.find(
    (o) => o.conditionType === lu(t)
  )?.expression?.length ? ur.SUCCESS : ur.HOLD;
}, gj = (t, s, n, a) => {
  switch (hj(t, n, a)) {
    case ur.SUCCESS:
      return /* @__PURE__ */ e.jsx(Kb, { className: `icon-dim-16 ${s === t ? "scg-5" : "scn-6"}` });
    case ur.ERROR:
      return /* @__PURE__ */ e.jsx(Va, { className: "icon-dim-16 cn-5 alert-icon-r5-imp" });
    default:
      return null;
  }
}, xj = ({
  conditions: t,
  handleExpressionChange: s,
  CELExpressionsValidation: n,
  setConditionType: a,
  passConditionTooltipText: r,
  failConditionTooltipText: o,
  error: i
}) => {
  const l = Ss(), d = new URLSearchParams(l.search).get("conditionType"), p = () => {
    const h = t.find(
      (x) => x.conditionType === (d === $s.PASS ? Vs.PASS : Vs.FAIL)
    );
    return h ? h.expression : "";
  }, m = (h) => {
    a(h);
  }, u = (h, x) => {
    const g = h === $s.FAIL, E = () => {
      m(h);
    };
    return /* @__PURE__ */ e.jsx(
      lt,
      {
        content: /* @__PURE__ */ e.jsx("div", { className: "dc__mxw-400 word-break-none", children: x }),
        placement: "top",
        className: "default-tt w-200",
        arrow: !1,
        children: /* @__PURE__ */ e.jsx(
          "button",
          {
            className: `flex px-16 py-8 dc__content-space dc__outline-none-imp dc__transparent cn-9 ${d === h ? "dc__border-top dc__border-left dc__border-right dc__border-top-r2 dc__top-radius-4 dc__border-bottom-n0" : ""}`,
            type: "button",
            onClick: E,
            children: /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-6", children: [
              /* @__PURE__ */ e.jsx(
                Hb,
                {
                  className: `icon-dim-16 ${g ? "dc__flip-y" : ""} ${d === h ? "scb-5" : ""}`
                }
              ),
              /* @__PURE__ */ e.jsxs(
                "div",
                {
                  className: `fs-13 lh-20 ${d === h ? "cb-5 fw-6" : "cn-9"}`,
                  children: [
                    g ? "Fail" : "Pass",
                    " Conditions"
                  ]
                }
              ),
              gj(
                h,
                d,
                n,
                t
              )
            ] })
          }
        )
      }
    );
  }, f = () => {
    const h = n.find(
      (x) => x.conditionType === (d === $s.PASS ? Vs.PASS : Vs.FAIL)
    );
    return h?.errorMsg ? /* @__PURE__ */ e.jsx(Ot, { description: h.errorMsg, variant: "error" }) : null;
  }, _ = () => i && /* @__PURE__ */ e.jsxs("div", { className: "form__error flex left", children: [
    /* @__PURE__ */ e.jsx(Va, { className: "form__icon form__icon--error dc__no-shrink" }),
    i
  ] }, i);
  return /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__box-shadow-bottom-n2", children: [
      u($s.PASS, r),
      u($s.FAIL, o)
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox p-12 dc__gap-4 dc__align-self-stretch border__primary dc__no-bottom-border dc__no-top-border", children: [
        /* @__PURE__ */ e.jsx("p", { className: "m-0 flex-grow-1 flexbox fs-13 fw-4 lh-20", children: d === $s.PASS ? tc.PASS_CONDITION : tc.FAIL_CONDITION }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__align-items-center", children: [
          /* @__PURE__ */ e.jsx(
            Dt,
            {
              theme: Mt.white,
              className: "w-236 h-100 dc__align-left",
              placement: "bottom",
              Icon: cd,
              iconClass: "fcv-5",
              heading: "Filter criteria",
              showCloseButton: !0,
              trigger: "click",
              interactive: !0,
              additionalContent: /* @__PURE__ */ e.jsx(fj, {}),
              children: /* @__PURE__ */ e.jsx(
                "button",
                {
                  className: "h-20 fs-13 fw-4 lh-20 p-0 cb-5 dc__no-background dc__no-border dc__outline-none-imp",
                  type: "button",
                  children: "View filter criteria"
                }
              )
            }
          ),
          /* @__PURE__ */ e.jsx("div", { className: "h-12 dc__border-left bcn-2" }),
          /* @__PURE__ */ e.jsx(
            ca,
            {
              infoText: jT,
              heading: "CEL Expression",
              documentationLink: "CEL",
              children: /* @__PURE__ */ e.jsxs(
                "button",
                {
                  className: "flex dc__gap-4 dc__outline-none-imp p-0 dc__no-border dc__no-background",
                  type: "button",
                  children: [
                    /* @__PURE__ */ e.jsx("p", { className: "m-0 cb-5 fs-13 fw-4 lh-20", children: "CEL Expression" }),
                    /* @__PURE__ */ e.jsx(Ya, { className: "icon-dim-16 fcb-5" })
                  ]
                }
              )
            }
          )
        ] })
      ] }),
      f(),
      /* @__PURE__ */ e.jsx(
        vn,
        {
          name: "cel-expression",
          placeholder: OT,
          value: p(),
          onChange: s,
          borderRadiusConfig: {
            top: !1
          }
        }
      )
    ] }),
    _()
  ] });
}, St = {
  ALLOW_IMAGE_BUILDER_TO_APPROVE: "User who triggered build for the image can also approve",
  ALLOW_REQUESTER_TO_APPROVE: "User who requested image promotion can also approve",
  ALLOW_APPROVER_TO_DEPLOY: "Users who approved image promotion request can deploy the image",
  APPROVAL_TITLE: "Approval for Image Promotion Policy",
  APPROVAL_SUBTITLE_WHEN_DISABLED: "When enabled, only approved images can be directly promoted to the",
  APPROVAL_SUBTITLE_ENABLE: "Set required number of approvals to promote image to",
  CANCEL: "Cancel",
  CREATE_POLICY: "Create Policy",
  CREATE_POLICY_ASSIGN_INFO: "A Promotion policy can be assigned to environments in specific applications.",
  EDIT_POLICY: "Edit Policy",
  EMPTY_CREATE_TITLE: "Create promotion policies to allow direct promotion of images",
  EMPTY_CREATE_SUBTITLE: "Example: A policy could allow direct promotion of an image to production environments if it is built from a branch starting with ‘hotfix’.",
  IMAGE_PROMOTION_POLICY: "Image Promotion Policy",
  INFO_APPLY_TO: "Images are automatically promoted from the previous stage in a workflow. Configure policies for direct promotion to a target environment, skipping intermediate stages.",
  INFO_ASSIGN_TO: "A Promotion policy can be assigned to environments in specific applications.",
  PROMOTION_POLICY: "Promotion Policy",
  POLICY_NAME: "Policy Name",
  POLICY_NAME_PLACEHOLDER: "Eg. Allow hotfix branch",
  SAVE_CHANGES: "Save Changes",
  DESCRIPTION: "Description",
  DESCRIPTION_PLACEHOLDER: "Enter a description here",
  CONDITION_TITLE: "Image Filter Condition",
  CONDITION_SUBTITLE: "Only images passing the defined filter conditions will be eligible for promotion to the",
  TARGET_ENVIRONMENT: "Target Environment",
  PASS_CONDITION_TOOLTIP: "Matching images will be eligible for Image Promotion Policy",
  FAIL_CONDITION_TOOLTIP: "Matching images will not be eligible for Image Promotion Policy. If an image matches both pass and fail conditions, it will not be eligible.",
  DELETE_PROFILE: {
    DELETE_PROFILE_BUTTON: "Delete",
    CONFIRMATION_TEXT: "Are you sure?",
    getDeleteDialogTitle: (t) => `Delete policy '${t}'`,
    getDeleteDialogDescription: (t) => `Policy '${t}' will be deleted. Applications and environments using this policy will start using ‘Do not allow’ policy.`,
    getDeleteProfileSuccessToast: (t) => `Policy '${t}' deleted successfully`,
    getDeleteProfileAriaLabel: (t) => `Delete ${t}`
  }
}, cu = {
  DELETE_PROFILE: "Delete profile",
  POLICY_NAME: "Policy name",
  IDENTIFIER_COUNT: "Identifier count",
  EDIT_POLICY: "Edit policy"
};
var xc = /* @__PURE__ */ ((t) => (t.APPLICATION_MANAGEMENT = "application-management", t.POLICIES = "policies", t.IMAGE_PROMOTION = "image-promotion", t.POLICY_NAME = ":policyName", t.EDIT = "edit", t.CREATE = "image-promotion/create", t.APPLY_TO = "apply-to", t.LIST = "list", t))(xc || {}), ii = /* @__PURE__ */ ((t) => (t.NAME = "NAME", t.DESCRIPTION = "DESCRIPTION", t.APPROVAL_REQUIRED = "APPROVALS REQUIRED", t))(ii || {}), Qa = /* @__PURE__ */ ((t) => (t.APP_NAME = "appName", t.ENV_NAME = "envName", t.POLICY_NAME = "policyName", t.APPROVER_COUNT = "approverCount", t))(Qa || {});
const Ej = {
  getProfileDeleteTestId: (t) => `profile-delete-${t}`
};
var Hr = /* @__PURE__ */ ((t) => (t.POLICY_NAME = "policyName", t.DESCRIPTION = "description", t.CONDITIONS = "conditions", t))(Hr || {}), li = /* @__PURE__ */ ((t) => (t.ALLOW_IMAGE_BUILDER_TO_APPROVE = "allowImageBuilderToApprove", t.ALLOW_REQUESTER_TO_APPROVE = "allowRequesterToApprove", t.ALLOW_APPROVER_TO_DEPLOY = "allowApproverToDeploy", t))(li || {});
const Cj = {
  id: 0,
  name: "",
  description: "",
  conditions: [
    {
      conditionType: Vs.PASS,
      expression: ""
    }
  ],
  approvalMetadata: {
    approverCount: 0,
    allowImageBuilderToApprove: !1,
    allowRequesterToApprove: !1,
    allowApproverToDeploy: !1
  },
  appliedToCount: 0
}, bj = (t, s) => le(ye($.ARTIFACT_PROMOTION_POLICY_LIST, t ?? {}), { signal: s }), Nj = (t, s) => le(`${$.ARTIFACT_PROMOTION_POLICY_LIST}/${t}`, { signal: s }), Tj = (t, s, n) => Bt(`${$.ARTIFACT_PROMOTION_POLICY_LIST}/${n}`, t, { signal: s }), Ij = (t, s) => we($.ARTIFACT_PROMOTION_POLICY_LIST, t, { signal: s }), vj = (t) => Js(`${$.ARTIFACT_PROMOTION_POLICY_LIST}/${t}`), Nh = ({
  policyName: t,
  showDeleteIconOnly: s,
  handleDeleteSuccess: n = Be
}) => {
  const a = Te(), [r, o] = v(!1), i = () => {
    o(!1);
  }, l = () => {
    o(!0);
  }, c = async () => {
    await vj(t), a.push(Y.IMAGE_PROMOTION_PROFILE_LIST), n();
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs(
      "button",
      {
        className: `flex ${s ? "dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus infra-list-item-btn p-4 icon-delete" : "cta delete h-32 override-button m-0-imp dc__gap-8"}`,
        onClick: l,
        type: "button",
        "data-testid": Ej.getProfileDeleteTestId(t),
        "aria-label": St.DELETE_PROFILE.getDeleteProfileAriaLabel(t),
        children: [
          /* @__PURE__ */ e.jsx(ts, { className: "icon-dim-16" }),
          !s && St.DELETE_PROFILE.DELETE_PROFILE_BUTTON
        ]
      }
    ),
    r && /* @__PURE__ */ e.jsx(
      Sr,
      {
        title: t,
        component: "policy",
        subtitle: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("p", { className: "fs-13 cn-7 lh-20 m-0", children: St.DELETE_PROFILE.getDeleteDialogDescription(t) }),
          /* @__PURE__ */ e.jsx("p", { className: "fs-13 cn-7 lh-20 m-0", children: St.DELETE_PROFILE.CONFIRMATION_TEXT })
        ] }),
        closeConfirmationModal: i,
        onDelete: c,
        successToastMessage: St.DELETE_PROFILE.getDeleteProfileSuccessToast(t)
      }
    )
  ] });
}, du = (t) => t ? {
  isValid: !0,
  message: ""
} : {
  isValid: !1,
  message: "This is a required field. Please specify pass or fail conditions (or both)."
}, pu = () => {
  const t = Te(), [s, n] = v(Cj), [a, r] = v(!1), o = de(new AbortController()), [i, l] = v(!1), [c, d] = v(!1), [p, m] = v({
    policyName: { isValid: !0, message: "" },
    description: { isValid: !0, message: "" },
    condition: { isValid: !0, message: "" }
  }), u = Ss(), { policyName: f } = Ue(), _ = u.pathname.includes(Y.IMAGE_PROMOTION_PROFILE_EDIT), [h, x] = v(
    s.conditions
  ), g = new URLSearchParams(u.search), E = g.get("conditionType"), C = E === $s.PASS ? 1 : 0, [b, N] = v(0), I = {
    requiredCount: s.approvalMetadata?.approverCount ?? 0,
    specificUsers: {
      identifiers: []
    },
    type: is.any,
    userGroups: []
  }, T = a || !p.policyName.isValid || !p.description.isValid || !p.condition.isValid, A = (fe) => {
    g.set("conditionType", `${fe}`), t.push({ search: g.toString() });
  };
  J(() => {
    E === $s.PASS || E === $s.FAIL ? A(E) : A($s.PASS);
  }, [E]);
  const S = () => {
    l(!0), Nj(f, o.current.signal).then((fe) => {
      n(fe.result), l(!1);
    }).catch((fe) => {
      l(!1), N(fe.code);
    });
  };
  J(() => {
    _ && S();
  }, []);
  const L = (fe) => {
    const { value: Ge } = fe.target, xe = { ...p };
    fe.target.name === Hr.POLICY_NAME ? (n({ ...s, name: Ge }), xe.policyName = Tn(Ge)) : fe.target.name === Hr.DESCRIPTION && (n({ ...s, description: Ge }), xe.description = dn(Ge)), m(xe);
  }, R = () => {
    t.push(Y.IMAGE_PROMOTION_PROFILE_LIST);
  }, y = () => {
    const fe = { ...p };
    if (fe.policyName = Tn(s.name), fe.description = dn(s.description), fe.condition = du(
      s.conditions.some((Ge) => !!Ge.expression)
    ), m(fe), fe.condition.isValid) {
      d(!0), mj({
        conditions: s.conditions
      }).then((Se) => {
        (Se.result?.conditions?.filter((nt) => !!nt.errorMsg)).length === 0 ? x([]) : (x(Se.result?.conditions), Z.showToast({
          variant: ee.error,
          description: "Invalid Expression provided. Please check the expression and try again."
        }));
      }).catch(() => {
        Z.showToast({
          variant: ee.error,
          description: "Something went wrong while sending request. Please try again."
        });
      }).finally(() => {
        d(!1);
      });
      const Ge = _ ? Tj : Ij, xe = {
        ...s,
        conditions: s.conditions.map((Se) => ({
          conditionType: Se.conditionType,
          expression: Se.expression
        }))
      };
      r(!0), Ge(xe, o.current.signal, f).then(() => {
        Z.showToast({
          variant: ee.success,
          description: `Image promotion ${_ ? "updated" : "created"} successfully`
        }), r(!1), R();
      }).catch((Se) => {
        Se.code !== 422 && V(Se), r(!1);
      });
    }
  }, M = () => /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8 cta-section px-20 py-16 dc__border-top-n1 dc__position-sticky dc__bottom-0 bg__primary", children: [
    /* @__PURE__ */ e.jsx(
      j,
      {
        text: "Save Changes",
        onClick: y,
        dataTestId: "save",
        isLoading: c,
        disabled: T
      }
    ),
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "cancel-policy",
        text: "Cancel",
        variant: w.secondary,
        style: B.neutral,
        component: Re.link,
        linkProps: {
          to: Y.IMAGE_PROMOTION_PROFILE_LIST
        }
      }
    )
  ] }), P = (fe) => {
    const Ge = fe.currentTarget.value, xe = { ...p }, ze = [
      ...s.conditions.filter((nt) => nt.conditionType !== C),
      { conditionType: C, expression: Ge }
    ].filter((nt) => !!nt.expression);
    xe.condition = du(ze.length > 0), m(xe), n({
      ...s,
      conditions: ze
    });
  }, U = () => /* @__PURE__ */ e.jsx(lt, { className: "default-tt w-200", content: "Environments for which this policy is applied.", arrow: "false", children: /* @__PURE__ */ e.jsx("span", { className: "fw-6 text-underline-dashed", children: "target environment" }) }), G = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__border-top-n1 py-16 dc__gap-12", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col cn-9", children: [
      /* @__PURE__ */ e.jsx("span", { className: "fw-6", children: "Image Filter Conditions" }),
      /* @__PURE__ */ e.jsxs("div", { className: "cn-8 fs-12", children: [
        /* @__PURE__ */ e.jsx("span", { children: "Only images passing the defined filter conditions will be eligible for promotion to the" }),
        " ",
        U(),
        ". "
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(
      xj,
      {
        conditions: s.conditions,
        handleExpressionChange: P,
        CELExpressionsValidation: h,
        setConditionType: A,
        passConditionTooltipText: St.PASS_CONDITION_TOOLTIP,
        failConditionTooltipText: St.FAIL_CONDITION_TOOLTIP,
        error: p.condition?.message
      }
    )
  ] }), H = (fe) => {
    const Ge = { ...s };
    Ge.approvalMetadata.approverCount = fe.requiredCount, n(Ge);
  }, oe = (fe) => {
    const { name: Ge, checked: xe } = fe.target, Se = { ...s };
    Se.approvalMetadata[Ge] = xe, n(Se);
  }, ae = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
    /* @__PURE__ */ e.jsx(
      $e,
      {
        rootClassName: "mb-0-imp",
        isChecked: s.approvalMetadata.allowApproverToDeploy,
        value: Fe.CHECKED,
        name: li.ALLOW_APPROVER_TO_DEPLOY,
        dataTestId: "allow-approver-from-deploy",
        onChange: oe,
        children: St.ALLOW_APPROVER_TO_DEPLOY
      },
      "allow-approver-from-deploy"
    ),
    /* @__PURE__ */ e.jsx(
      $e,
      {
        rootClassName: "mb-0-imp",
        isChecked: s.approvalMetadata.allowRequesterToApprove,
        value: Fe.CHECKED,
        name: li.ALLOW_REQUESTER_TO_APPROVE,
        dataTestId: "allow-requester-from-approve",
        onChange: oe,
        children: St.ALLOW_REQUESTER_TO_APPROVE
      },
      "allow-requester-from-approve"
    ),
    /* @__PURE__ */ e.jsx(
      $e,
      {
        rootClassName: "mb-0-imp",
        isChecked: s.approvalMetadata.allowImageBuilderToApprove,
        value: Fe.CHECKED,
        name: li.ALLOW_IMAGE_BUILDER_TO_APPROVE,
        dataTestId: "allow-image-builder-from-approve",
        onChange: oe,
        children: St.ALLOW_IMAGE_BUILDER_TO_APPROVE
      },
      "allow-image-builder-from-approve"
    )
  ] }), re = (fe) => /* @__PURE__ */ e.jsx("div", { className: "fw-4 lh-20 cn-8 fs-12", children: fe ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("span", { children: St.APPROVAL_SUBTITLE_WHEN_DISABLED }),
    " ",
    U(),
    "."
  ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("span", { children: "Set required number of approvals to promote image to" }),
    " ",
    U(),
    ". ",
    /* @__PURE__ */ e.jsx("span", { children: "Only users with ‘Direct Promotion Approver’ role can approve." })
  ] }) }), k = () => /* @__PURE__ */ e.jsx("div", { className: "dc__border-top-n1 py-16", children: /* @__PURE__ */ e.jsx(
    bh,
    {
      userApprovalConfig: I,
      handleUpdateUserApprovalConfig: H,
      renderManualApprovalEnableContent: ae,
      labelText: St.APPROVAL_TITLE,
      subTitle: re(),
      subTitleWhenDisabled: re(!0),
      SvgIcon: Yb
    }
  ) }), D = () => /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space px-20 pt-16 pb-24 dc__mxw-1000", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex fs-16 fw-6 cn-9 lh-32 dc__gap-4", children: [
      /* @__PURE__ */ e.jsx("button", { type: "button", onClick: R, className: "cb-5 cursor dc__unset-button-styles", children: St.IMAGE_PROMOTION_POLICY }),
      /* @__PURE__ */ e.jsx("div", { className: "fw-4", children: "/" }),
      _ ? s.name : "Create"
    ] }),
    _ && /* @__PURE__ */ e.jsx(Nh, { policyName: f })
  ] }), F = () => /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-4", children: [
    /* @__PURE__ */ e.jsx("span", { className: "fw-6", children: "Assign Policy:" }),
    /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-4 lh-20 cn-9", children: St.CREATE_POLICY_ASSIGN_INFO }),
    /* @__PURE__ */ e.jsx($a, { docLinkKey: "IMAGE_PROMOTION_ASSIGN_TO", dataTestId: "learn-more-about-assigning-policy" })
  ] }), q = () => /* @__PURE__ */ e.jsx(Ot, { description: F() }), be = () => /* @__PURE__ */ e.jsx("div", { className: "create-edit-form flexbox-col dc__gap-16 pb-16 flex-grow-1-imp dc__overflow-auto h-100", children: /* @__PURE__ */ e.jsxs("div", { className: "dc__mxw-1000 px-20", children: [
    q(),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 py-16", children: [
      /* @__PURE__ */ e.jsx(
        yt,
        {
          label: St.POLICY_NAME,
          placeholder: St.POLICY_NAME_PLACEHOLDER,
          name: Hr.POLICY_NAME,
          required: !0,
          value: s.name,
          onChange: L,
          fullWidth: !0,
          autoFocus: !0,
          error: p.policyName?.message
        }
      ),
      /* @__PURE__ */ e.jsx(
        yt,
        {
          label: St.DESCRIPTION,
          placeholder: St.DESCRIPTION_PLACEHOLDER,
          name: Hr.DESCRIPTION,
          value: s.description,
          onChange: L,
          fullWidth: !0,
          error: p.description?.message
        }
      )
    ] }),
    G(),
    k()
  ] }) });
  return i ? /* @__PURE__ */ e.jsx(Je, { pageLoader: !0 }) : b ? /* @__PURE__ */ e.jsx(Xe, { code: b }) : /* @__PURE__ */ e.jsxs("div", { className: "promotion-create-edit-wrapper fs-13 cn-9 h-100 flexbox-col flex-grow-1", children: [
    D(),
    be(),
    M()
  ] });
}, Aj = () => {
  const t = Te(), s = () => {
    t.push(Y.IMAGE_PROMOTION_PROFILE_CREATE);
  };
  return /* @__PURE__ */ e.jsxs("button", { type: "button", onClick: s, className: "cta small flex dc__gap-6", children: [
    /* @__PURE__ */ e.jsx(Xt, { className: "icon-dim-16" }),
    St.CREATE_POLICY
  ] });
}, Sj = () => {
  const t = de(new AbortController()), s = Te(), n = _t({
    initialSortKey: Qa.POLICY_NAME
  }), { searchKey: a, handleSearch: r, sortOrder: o, sortBy: i, handleSorting: l } = n, c = Q(
    () => ({
      search: a,
      sortBy: i,
      sortOrder: o
    }),
    // invoke the function only in case of searchKey, sortBy or sortOrder change
    [a, i, o]
  ), [d, p, m, u] = ne(
    () => es(
      () => bj(c, t.current.signal),
      t
    ),
    [c]
  ), [f, _] = v([]);
  if (J(() => {
    p?.result && _(p.result);
  }, [p?.result, a]), m && m.code !== 200)
    return /* @__PURE__ */ e.jsx(Xe, { code: m.code });
  const h = () => l(Qa.POLICY_NAME), x = () => l(Qa.APPROVER_COUNT), g = () => /* @__PURE__ */ e.jsxs("div", { className: "image-promotion__profile-list__row dc__border-bottom-n1 pt-6 pb-6 cn-7 fw-6 pl-20 pr-20 dc__gap-16 fs-12 lh-20", children: [
    /* @__PURE__ */ e.jsx(Ne, { title: "", isSortable: !1 }),
    /* @__PURE__ */ e.jsx(
      Ne,
      {
        title: ii.NAME,
        triggerSorting: h,
        isSorted: i === Qa.POLICY_NAME,
        sortOrder: o,
        disabled: !1
      }
    ),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox ", children: ii.DESCRIPTION }),
    /* @__PURE__ */ e.jsx(
      Ne,
      {
        title: ii.APPROVAL_REQUIRED,
        triggerSorting: x,
        isSorted: i === Qa.APPROVER_COUNT,
        sortOrder: o,
        disabled: !1
      }
    ),
    /* @__PURE__ */ e.jsx(Ne, { title: "", isSortable: !1 })
  ] }), E = (y) => {
    if (!y)
      return /* @__PURE__ */ e.jsx("div", { className: "flex left", children: "-" });
    const M = (P) => /* @__PURE__ */ e.jsx(lt, { content: y, placement: "top", className: "default-tt dc__word-break", arrow: !1, children: P });
    return /* @__PURE__ */ e.jsx(An, { condition: !!y, wrap: M, children: /* @__PURE__ */ e.jsx("div", { className: "dc__w-fit-content dc__ellipsis-right", children: y }) });
  }, C = (y) => {
    const M = {
      policyNames: y
    };
    s.push({
      search: new URLSearchParams(M).toString(),
      pathname: s.location.pathname.replace(
        xc.LIST,
        xc.APPLY_TO
      )
    });
  }, b = () => {
    r("");
  }, N = (y) => Kt(Y.IMAGE_PROMOTION_PROFILE_EDIT, {
    profileName: y
  }), I = (y) => {
    s.push(N(y));
  }, T = () => d ? /* @__PURE__ */ e.jsx(Fd, { shimmerRowClassName: "image-promotion__profile-list__row px-20 py-10" }) : /* @__PURE__ */ e.jsx("div", { className: "image-promotion-list__table flexbox-col dc__overflow-auto h-100 flex-grow-1", children: f.map((y) => /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "dc__border-bottom-n1 image-promotion__profile-list__row dc__gap-16 px-20 pt-10 pb-10 dc__hover-n50",
      children: [
        /* @__PURE__ */ e.jsx("div", { className: "flex", children: /* @__PURE__ */ e.jsx(g_, {}) }),
        /* @__PURE__ */ e.jsx("div", { className: "dc__align-items-center dc__gap-16 dc__p-16", children: /* @__PURE__ */ e.jsxs("div", { className: "image-promotion__profile-name flex column left", children: [
          /* @__PURE__ */ e.jsx(
            wt,
            {
              className: "m-0 fs-13 fw-4 lh-20-imp cb-5 cursor dc__ellipsis-right w-250 anchor",
              to: N(y.name),
              children: y.name
            }
          ),
          /* @__PURE__ */ e.jsx(
            "button",
            {
              type: "button",
              "aria-label": cu.IDENTIFIER_COUNT,
              className: "dc__unset-button-styles dc__underline-onhover fs-12 lh-18-imp cursor dc__w-fit-content",
              onClick: () => C(y.name),
              children: /* @__PURE__ */ e.jsxs("span", { className: "cn-7 image-promotion__count", children: [
                y.appliedToCount,
                " deployments"
              ] })
            }
          )
        ] }) }),
        /* @__PURE__ */ e.jsx("div", { className: "dc__ellipsis-right flex left", children: E(y.description) }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex left", children: [
          y.approvalMetadata.approverCount,
          " Approvals"
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-4", children: [
          /* @__PURE__ */ e.jsx(
            "button",
            {
              type: "button",
              "aria-label": cu.EDIT_POLICY,
              className: "dc__hidden-hover dc__unset-button-styles image-promotion__profile-list__row-onhover dc__visible-hover--child p-4",
              onClick: () => I(y.name),
              children: /* @__PURE__ */ e.jsx(Fs, { className: "icon-dim-16 cursor flex" })
            }
          ),
          /* @__PURE__ */ e.jsx("div", { className: "image-promotion__profile-list__row-onhover dc__visible-hover--child", children: /* @__PURE__ */ e.jsx(
            Nh,
            {
              policyName: y.name,
              showDeleteIconOnly: !0,
              handleDeleteSuccess: u
            }
          ) })
        ] })
      ]
    },
    y.id
  )) }), A = () => /* @__PURE__ */ e.jsx(Aj, {}), S = () => /* @__PURE__ */ e.jsx(
    _e,
    {
      title: St.EMPTY_CREATE_TITLE,
      subTitle: St.EMPTY_CREATE_SUBTITLE,
      image: p_,
      renderButton: A,
      classname: "dc__text-center flex-grow-1",
      isButtonAvailable: !0
    }
  ), L = () => a && f.length === 0 ? /* @__PURE__ */ e.jsx(
    qt,
    {
      title: me.REQUEST_PROMOTION_EMPTY_SEARCH.TITLE,
      subTitle: me.REQUEST_PROMOTION_EMPTY_SEARCH.SUB_TITLE,
      handleClearFilters: b
    }
  ) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col h-100 dc__overflow-auto", children: [
    g(),
    T()
  ] }), R = () => /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-12 h-100", children: p?.result?.length === 0 && !a ? S() : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: "px-20 flex dc__content-space pt-12", children: /* @__PURE__ */ e.jsx(
      Wt,
      {
        initialSearchText: a,
        containerClassName: "dc__mxw-250 flex-grow-1",
        handleEnter: r,
        inputProps: {
          placeholder: "Search Policy"
        }
      }
    ) }),
    L()
  ] }) });
  return m?.code ? /* @__PURE__ */ e.jsx(Xe, { code: m.code }) : /* @__PURE__ */ e.jsx("div", { className: "image-promotion-list flexbox-col h-100", children: R() });
}, yj = () => /* @__PURE__ */ e.jsxs("div", { children: [
  /* @__PURE__ */ e.jsxs("ol", { className: "px-20 mb-20", children: [
    /* @__PURE__ */ e.jsx("li", { children: "To promote an image directly to a later stage bypassing intermediate stages, you can set up a promotion policy." }),
    /* @__PURE__ */ e.jsx("li", { children: "Images are always promoted to the immediate next stage irrespective of the policy." })
  ] }),
  /* @__PURE__ */ e.jsxs("p", { className: "m-0", children: [
    "A policy can optionally have eligibility criteria for images (eg. image must be built from a branch containing ‘hotfix’) and approval requirements. ",
    /* @__PURE__ */ e.jsx("span", { className: "fw-6", children: " The policy must be applied on the target environment." })
  ] })
] }), Lj = () => /* @__PURE__ */ e.jsx(
  rl,
  {
    featureTitleWithInfoProps: {
      SVGImage: Wb,
      docLink: "IMAGE_PROMOTION",
      title: St.IMAGE_PROMOTION_POLICY,
      renderDescriptionContent: yj
    },
    createProfileLink: Y.IMAGE_PROMOTION_PROFILE_CREATE,
    profileListingLink: Y.IMAGE_PROMOTION_PROFILE_LIST,
    createAppliedProfileLink: Y.IMAGE_PROMOTION_APPLIED_PROFILE_CREATE,
    appliedProfileListingLink: Y.IMAGE_PROMOTION_APPLIED_PROFILE_LIST,
    exceptionLink: null
  }
), n2 = () => {
  const { pathname: t } = Ss(), { push: s } = Te(), { isSuperAdmin: n } = Is(), a = t === Y.IMAGE_PROMOTION_PROFILE_LIST || t === Y.IMAGE_PROMOTION_APPLIED_PROFILE_LIST, r = () => {
    s(Y.IMAGE_PROMOTION_APPLIED_PROFILE_LIST);
  }, o = (i) => {
    const l = Kt(Y.IMAGE_PROMOTION_APPLIED_PROFILE_EDIT, {
      appliedProfileId: i
    });
    s(l);
  };
  return n ? /* @__PURE__ */ e.jsxs("div", { className: "image-promotion-global-wrapper bg__primary fs-13 cn-9 dc__overflow-hidden h-100 flexbox-col", children: [
    a && /* @__PURE__ */ e.jsx(Lj, {}),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col h-100 flex-grow-1 dc__overflow-auto", children: /* @__PURE__ */ e.jsxs(Vt, { children: [
      /* @__PURE__ */ e.jsx(ge, { path: Y.IMAGE_PROMOTION_PROFILE_LIST, exact: !0, children: /* @__PURE__ */ e.jsx(Sj, {}) }),
      /* @__PURE__ */ e.jsx(ge, { path: Y.IMAGE_PROMOTION_PROFILE_EDIT, exact: !0, children: ({ match: i }) => /* @__PURE__ */ e.jsx(pu, {}, i.params.policyName) }),
      /* @__PURE__ */ e.jsx(ge, { path: Y.IMAGE_PROMOTION_PROFILE_CREATE, exact: !0, children: /* @__PURE__ */ e.jsx(pu, {}) }),
      /* @__PURE__ */ e.jsx(ge, { path: Y.IMAGE_PROMOTION_APPLIED_PROFILE_EDIT, exact: !0, children: ({ match: i }) => /* @__PURE__ */ e.jsx(
        ia,
        {
          redirectToAppliedProfileList: r,
          policyKind: X.imagePromotion
        },
        `applied-profile-detail-${i.params.appliedProfileId}`
      ) }),
      /* @__PURE__ */ e.jsx(ge, { path: Y.IMAGE_PROMOTION_APPLIED_PROFILE_CREATE, children: /* @__PURE__ */ e.jsx(
        ia,
        {
          redirectToAppliedProfileList: r,
          policyKind: X.imagePromotion
        }
      ) }),
      /* @__PURE__ */ e.jsx(ge, { path: Y.IMAGE_PROMOTION_APPLIED_PROFILE_LIST, children: /* @__PURE__ */ e.jsx(
        al,
        {
          policyKind: X.imagePromotion,
          redirectToEditMatchCriterion: o
        }
      ) }),
      /* @__PURE__ */ e.jsx(ms, { to: Y.IMAGE_PROMOTION_PROFILE_LIST })
    ] }) })
  ] }) : /* @__PURE__ */ e.jsx(Fm, {});
}, jj = () => /* @__PURE__ */ e.jsxs("div", { className: "fs-13 fw-4 lh-20 cn-9", children: [
  /* @__PURE__ */ e.jsxs("div", { children: [
    "Create lock profiles to restrict editing of sensitive configurations in ",
    /* @__PURE__ */ e.jsx(
      "a",
      {
        href: "https://docs.devtron.ai/resources/glossary#base-deployment-template",
        className: "anchor",
        target: "_blank",
        rel: "noreferrer",
        children: "Deployment Templates"
      }
    ),
    "."
  ] }),
  /* @__PURE__ */ e.jsx("div", { className: "mt-20", children: "Apply these profiles to specific deployment templates or broader criteria like production environments. Only super admins can modify locked fields." })
] }), Th = () => /* @__PURE__ */ e.jsx(
  rl,
  {
    featureTitleWithInfoProps: {
      SVGImage: qb,
      docLink: "GLOBAL_CONFIG_LOCK_DEPLOYMENT_CONFIG",
      title: "Lock Deployment Configuration",
      renderDescriptionContent: jj
    },
    createProfileLink: Y.LOCK_CONFIGURATION_PROFILE_CREATE,
    profileListingLink: Y.LOCK_CONFIGURATION_PROFILE_LIST,
    createAppliedProfileLink: Y.LOCK_CONFIGURATION_APPLIED_PROFILE_CREATE,
    appliedProfileListingLink: Y.LOCK_CONFIGURATION_APPLIED_PROFILE_LIST,
    exceptionLink: null
  }
), Oj = () => {
  const { push: t } = Te(), s = () => {
    t(Y.LOCK_CONFIGURATION_APPLIED_PROFILE_LIST);
  }, n = (a) => {
    const r = Kt(Y.LOCK_CONFIGURATION_APPLIED_PROFILE_EDIT, {
      appliedProfileId: a
    });
    t(r);
  };
  return /* @__PURE__ */ e.jsxs(Vt, { children: [
    /* @__PURE__ */ e.jsx(ge, { path: Y.LOCK_CONFIGURATION_APPLIED_PROFILE_CREATE, children: /* @__PURE__ */ e.jsx(
      ia,
      {
        redirectToAppliedProfileList: s,
        policyKind: X.lockConfiguration
      }
    ) }),
    /* @__PURE__ */ e.jsx(ge, { path: Y.LOCK_CONFIGURATION_APPLIED_PROFILE_EDIT, children: ({ match: a }) => /* @__PURE__ */ e.jsx(
      ia,
      {
        redirectToAppliedProfileList: s,
        policyKind: X.lockConfiguration
      },
      `applied-profile-detail-${a.params.appliedProfileId}`
    ) }),
    /* @__PURE__ */ e.jsxs(ge, { path: Y.LOCK_CONFIGURATION_APPLIED_PROFILE_LIST, children: [
      /* @__PURE__ */ e.jsx(Th, {}),
      /* @__PURE__ */ e.jsx(
        al,
        {
          policyKind: X.lockConfiguration,
          redirectToEditMatchCriterion: n
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(ms, { to: Y.LOCK_CONFIGURATION_PROFILE_LIST })
  ] });
}, Rj = async (t, s) => {
  await Js(
    ks({
      kind: s === X.plugins ? X.plugins : X.lockConfiguration,
      version: mt.alpha1,
      queryParams: {
        identifier: t
      }
    })
  );
}, dl = ({ name: t, profileType: s, handleClose: n, handleSuccess: a }) => {
  const r = async () => {
    await Rj(t, s), a();
  };
  return /* @__PURE__ */ e.jsx(
    Sr,
    {
      title: t,
      component: s === X.plugins ? "plugin policy" : "lock profile",
      onDelete: r,
      subtitle: s === X.plugins ? "Deleting this plugin will no longer enforce tasks." : "Deleting this lock profile will remove the configuration editing restriction it imposes.",
      closeConfirmationModal: n,
      confirmationConfig: {
        identifier: "delete-plugin-policy",
        confirmationKeyword: t
      },
      successToastMessage: `${s === X.plugins ? "Plugin" : "Lock"} profile ${t} deleted successfully`
    }
  );
}, Ih = {
  name: "",
  description: "",
  config: ""
}, Pj = "JSONPath expressions", uu = "Refer values.yaml", wj = (t) => t.split(`
`).map((s) => s.trim()).filter((s) => !!s), Dj = (t) => ({
  identifier: t.name,
  description: t.description,
  spec: {
    def: {
      rules: [
        {
          type: "DeploymentTemplate",
          paths: {
            deny: wj(t.config)
          }
        }
      ]
    }
  }
}), vh = (t) => ({
  name: t?.identifier,
  description: t?.description ?? "",
  config: t?.spec?.def?.rules?.map((s) => s?.paths?.deny?.join(`
`)).filter((s) => !!s).join(`
`) ?? ""
}), Mj = (t) => t?.dataList ? t.dataList.map(vh) : [], kj = async () => {
  try {
    const { result: t } = await le(
      ks({
        kind: X.lockConfiguration,
        version: mt.alpha1,
        suffix: $.API_LIST_SUFFIX
      })
    );
    return Mj(t).map(({ name: s, description: n }) => ({
      name: s,
      description: n
    }));
  } catch (t) {
    throw V(t), t;
  }
}, Fj = async (t) => {
  if (!t)
    return structuredClone(Ih);
  try {
    const { result: s } = await le(
      ks({
        kind: X.lockConfiguration,
        version: mt.alpha1,
        queryParams: {
          identifier: t
        }
      })
    );
    return vh(s);
  } catch (s) {
    throw V(s), s;
  }
}, Uj = async (t, s) => {
  try {
    const n = Dj(s);
    return await (t ? Bt : we)(
      ks({
        kind: X.lockConfiguration,
        version: mt.alpha1,
        queryParams: {
          identifier: t
        }
      }),
      n
    ), jd(X.lockConfiguration), !0;
  } catch (n) {
    return V(n), !1;
  }
}, Gj = async (t) => {
  try {
    const {
      result: { defaultAppOverride: s }
    } = await le(`${$.DEPLOYMENT_TEMPLATE}/${t}`);
    return gt(s);
  } catch (s) {
    return Pe(s) || V(s), "";
  }
}, Bj = {
  name: !0,
  description: !1,
  config: !0
}, $j = (t) => Object.keys(Ih).reduce(
  (s, n) => ({ ...s, [n]: Bj[n] && !t ? "" : null }),
  {}
), Vj = {
  name: Tn,
  description: dn,
  config: Ln
}, Yj = ({
  isSplitPaneOpen: t,
  handleOpenJsonPathExamplesSplitPane: s,
  handleOpenReferValuesSplitPane: n
}) => /* @__PURE__ */ e.jsxs("section", { className: "flexbox dc__no-shrink dc__content-space fs-13 pt-8 pb-7 lh-20 fw-4 px-20 dc__border-bottom-n1", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__align-items-center", children: [
    /* @__PURE__ */ e.jsx(x_, { className: "dc__icon-dim-16" }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-4", children: [
      /* @__PURE__ */ e.jsx("p", { className: "m-0", children: `Provide ${Pj} to lock keys.` }),
      /* @__PURE__ */ e.jsx(
        "button",
        {
          type: "button",
          "aria-label": "View example",
          className: "dc__unset-button-styles cb-5",
          onClick: s,
          children: "View example"
        }
      )
    ] })
  ] }),
  !t && /* @__PURE__ */ e.jsx(
    "button",
    {
      type: "button",
      "aria-label": uu,
      className: "dc__unset-button-styles",
      onClick: n,
      children: /* @__PURE__ */ e.jsx("span", { className: "cb-5", children: uu })
    }
  )
] });
var Bs = /* @__PURE__ */ ((t) => (t.CLOSED = "CLOSED", t.REFER_VALUES = "REFER_VALUES", t.JSONPATH_EXAMPLES = "JSONPATH_EXAMPLES", t))(Bs || {});
const Hj = [
  ["JSONpath examples", "Description"],
  ["$", "the root object/element"],
  ["@", "the current object/element"],
  [". or []", "child operator"],
  ["..", "recursive descent. JSONPath borrows this syntax from E4X"],
  ["*", "wildcard. All objects/elements regardless their names"],
  [
    "[]",
    "subscript operator. XPath usses it to iterate over element collections and for predicates. In Javascript and JSON it is the native array operator"
  ],
  [
    "[,]",
    "Union operator in XPath results in a combination of node sets. JSONPath allows alternate names or array incices as a set"
  ],
  ["[start:end:step]", "array slice operator borrowed from ES4"],
  ["?()", "applies a filter (script) expression"],
  ["()", "script expression, using the underlying script engine"]
], Kj = [
  "ingress",
  "ingressinternal.hosts",
  "ingressInternal.hosts[*].pathType",
  "ingressInternal.hosts[1:3].paths"
], Wj = () => /* @__PURE__ */ e.jsxs("div", { "data-testid": "json-path-expressions-modal", className: "flexbox-col dc__gap-16 p-16", children: [
  /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-20", children: "Devtron uses JSONpath expressions to evaluate given allowed/locked paths" }),
  /* @__PURE__ */ e.jsxs("pre", { className: "fs-14 mono br-4", children: [
    "Example:",
    Kj.map((t) => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx("br", {}),
      " ",
      t
    ] }))
  ] }),
  /* @__PURE__ */ e.jsx("div", { className: "dc__striped-table", children: Hj.map((t, s) => /* @__PURE__ */ e.jsx(
    "div",
    {
      className: `${s === 0 ? "dc__border-top-n1" : ""} dc__border-bottom-n1`,
      style: {
        display: "grid",
        gridTemplateColumns: "200px 1fr"
      },
      children: t.map((n, a, r) => /* @__PURE__ */ e.jsx(
        "span",
        {
          className: `px-12 py-8 dc__border-left-n1 ${a === r.length - 1 ? " dc__border-right-n1" : ""} ${a === 0 ? "flex" : "flexbox dc__align-items-center"} ${s === 0 ? "dc__bold" : ""}`,
          children: n
        },
        n
      ))
    },
    t.join()
  )) }),
  /* @__PURE__ */ e.jsx(
    "a",
    {
      target: "_blank",
      rel: "noreferrer noopener",
      href: "https://goessner.net/articles/JsonPath/index.html#e2",
      className: "dc__link dc__no-decor",
      children: "Learn more about JSONpath expressions"
    }
  )
] }), qj = () => {
  const [t, s] = v(null), n = de(new AbortController()), [a, r] = ne(
    () => es(() => Gj(t), n),
    [t],
    !!t
  );
  return /* @__PURE__ */ e.jsx(
    Gt,
    {
      mode: Ts.YAML,
      customLoader: /* @__PURE__ */ e.jsx(Je, { pageLoader: !0 }),
      readOnly: !0,
      loading: a || !t,
      value: r || "",
      height: "fitToParent",
      children: /* @__PURE__ */ e.jsx(Gt.Header, { children: /* @__PURE__ */ e.jsx(RE, { setSelectedChartRefId: s }) })
    }
  );
}, mu = "JSONPath Example", _u = "Refer Values", zj = ({ state: t, setState: s }) => {
  const n = (i) => () => {
    s({ ...t, type: i });
  }, a = () => {
    switch (t.type) {
      case Bs.REFER_VALUES:
        return /* @__PURE__ */ e.jsx(qj, {});
      case Bs.JSONPATH_EXAMPLES:
        return /* @__PURE__ */ e.jsx(Wj, {});
      default:
        return null;
    }
  }, r = () => /* @__PURE__ */ e.jsx(
    "button",
    {
      type: "button",
      className: "dc__unset-button-styles icon-dim-16",
      onClick: n(Bs.CLOSED),
      "aria-label": "Close split pane",
      children: /* @__PURE__ */ e.jsx(As, { className: "icon-dim-16" })
    }
  ), o = [
    {
      id: "refer-values-tab",
      label: _u,
      tabType: "button",
      props: {
        onClick: n(Bs.REFER_VALUES),
        "aria-label": `Open ${_u} tab`
      },
      active: t.type === Bs.REFER_VALUES
    },
    {
      id: "json-path-example-tab",
      label: mu,
      tabType: "button",
      props: {
        onClick: n(Bs.JSONPATH_EXAMPLES),
        "aria-label": `Open ${mu} tab`
      },
      active: t.type === Bs.JSONPATH_EXAMPLES
    }
  ];
  return /* @__PURE__ */ e.jsxs("aside", { className: "flexbox-col bg__primary dc__border-left dc__overflow-hidden", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__no-shrink dc__content-space dc__align-items-center dc__border-bottom-n1 px-12", children: [
      /* @__PURE__ */ e.jsx(Ar, { tabs: o }),
      r()
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "dc__overflow-auto flexbox-col flex-grow-1", children: a() })
  ] });
}, Xj = ({
  isSplitPaneOpen: t,
  handleEditorTextChange: s,
  splitPaneState: n,
  setSplitPaneState: a,
  text: r,
  handleOpenJsonPathExamplesSplitPane: o,
  handleOpenReferValuesSplitPane: i,
  apiCallInProgress: l,
  disableSaveButton: c,
  handleCancelClick: d,
  handleSaveChanges: p
}) => {
  const m = r.split(`
`).some((u) => u.trim() === "$");
  return /* @__PURE__ */ e.jsxs(
    "section",
    {
      className: `${t ? "dc__grid-half" : "dc__grid-full"} flex-grow-1 dc__overflow-hidden dc__border-top`,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__position-rel", children: [
          /* @__PURE__ */ e.jsx(
            Yj,
            {
              isSplitPaneOpen: t,
              handleOpenJsonPathExamplesSplitPane: o,
              handleOpenReferValuesSplitPane: i
            }
          ),
          m && /* @__PURE__ */ e.jsx(
            Ot,
            {
              description: "You have entered $ as a locked key. Please use $.* if you wish to lock all the keys of yaml.",
              variant: "error",
              borderConfig: { top: !1, left: !1, right: !1 },
              borderRadiusConfig: { top: !1, left: !1, right: !1, bottom: !1 }
            }
          ),
          /* @__PURE__ */ e.jsx(
            Gt,
            {
              mode: Ts.PLAINTEXT,
              noParsing: !0,
              placeholder: "Enter keys that you want to lock via JSONpath expressions",
              height: "fitToParent",
              value: r,
              onChange: s
            }
          ),
          /* @__PURE__ */ e.jsxs("footer", { className: "flexbox left dc__border-top-n1 px-20 py-16 dc__gap-12 dc__no-shrink", children: [
            /* @__PURE__ */ e.jsx(
              j,
              {
                dataTestId: "lock-profile__save",
                onClick: p,
                isLoading: l,
                disabled: c || l || m,
                variant: w.primary,
                component: Re.button,
                showTooltip: c,
                tooltipProps: {
                  content: vr.INVALID_INPUT
                },
                text: "Save Changes"
              }
            ),
            /* @__PURE__ */ e.jsx(
              j,
              {
                dataTestId: "lock-profile__cancel",
                onClick: d,
                disabled: l,
                variant: w.secondary,
                component: Re.button,
                text: "Cancel"
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ e.jsx(zj, { state: n, setState: a })
      ]
    }
  );
}, Jj = ({
  validationErrors: t,
  name: s,
  description: n,
  showDeleteButton: a,
  handleProfileDelete: r,
  handleProfileNameChange: o,
  handleProfileDescriptionChange: i
}) => /* @__PURE__ */ e.jsxs("section", { className: "flexbox-col dc__gap-16 py-16 px-20 dc__no-shrink dc__mxw-960", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space", children: [
    /* @__PURE__ */ e.jsx(
      Gi,
      {
        redirectUrl: Y.LOCK_CONFIGURATION_PROFILE_LIST,
        linkText: "Lock Deployment Configuration",
        profileName: s,
        nestedBreadCrumbsText: "Profiles"
      }
    ),
    a && /* @__PURE__ */ e.jsxs(
      "button",
      {
        type: "button",
        className: "cta delete override-button flex dc__gap-6 h-32 m-0-imp",
        onClick: r,
        children: [
          /* @__PURE__ */ e.jsx(ts, { className: "icon-dim-14 dc__no-shrink" }),
          "Delete"
        ]
      }
    )
  ] }),
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12", children: [
    /* @__PURE__ */ e.jsx("div", { className: "w-250", children: /* @__PURE__ */ e.jsx(
      yt,
      {
        name: "lock-deployment-config-profile-name",
        error: t.name,
        required: !0,
        placeholder: "Enter profile name",
        label: "Name",
        value: s,
        onChange: o
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      yt,
      {
        name: "lock-deployment-config-profile-description",
        error: t.description,
        label: "Description",
        placeholder: "Enter description",
        value: n,
        onChange: i,
        fullWidth: !0
      }
    )
  ] })
] }), fu = () => {
  const { profileName: t } = Ue(), { push: s, replace: n } = Te(), [a, r, o, i, l] = ne(
    () => Fj(t),
    [t]
  ), [c, d] = v({
    type: Bs.CLOSED
  }), [p, m] = v(!1), [u, f] = v(
    $j(!!t)
  ), [_, h] = v(!1), x = c.type !== Bs.CLOSED, g = Object.values(u).some((S) => !Ht(S)), E = (S) => (L) => {
    f({
      ...u,
      [S]: Vj[S]?.(L).message ?? null
    }), l({ ...r, [S]: L });
  }, C = (S) => (L) => {
    E(S)(L.currentTarget.value);
  }, b = (S) => () => {
    d({ ...c, type: S });
  }, N = async () => {
    h(!0), await Uj(t, r) && s(Y.LOCK_CONFIGURATION_PROFILE_LIST), h(!1);
  }, I = () => {
    s(Y.LOCK_CONFIGURATION_PROFILE_LIST);
  }, T = (S) => () => {
    m(S);
  }, A = () => {
    n(Y.LOCK_CONFIGURATION_PROFILE_LIST);
  };
  return /* @__PURE__ */ e.jsx(
    Ke,
    {
      isLoading: a,
      progressingProps: {
        pageLoader: !0
      },
      error: o,
      errorScreenManagerProps: {
        code: o?.code,
        reload: i,
        redirectURL: Y.LOCK_CONFIGURATION_PROFILE_EDIT
      },
      children: !a && !o && /* @__PURE__ */ e.jsxs("main", { className: "bg__primary flexbox-col flex-grow-1 lock-config__profile--detail dc__overflow-hidden", children: [
        /* @__PURE__ */ e.jsx(
          Jj,
          {
            validationErrors: u,
            showDeleteButton: !!t,
            name: r.name,
            description: r.description,
            handleProfileDelete: T(!0),
            handleProfileNameChange: C("name"),
            handleProfileDescriptionChange: C("description")
          }
        ),
        /* @__PURE__ */ e.jsx(
          Xj,
          {
            text: r.config,
            isSplitPaneOpen: x,
            handleEditorTextChange: E("config"),
            splitPaneState: c,
            setSplitPaneState: d,
            handleOpenJsonPathExamplesSplitPane: b(
              Bs.JSONPATH_EXAMPLES
            ),
            handleOpenReferValuesSplitPane: b(Bs.REFER_VALUES),
            disableSaveButton: g,
            handleCancelClick: I,
            handleSaveChanges: N,
            apiCallInProgress: _
          }
        ),
        p && /* @__PURE__ */ e.jsx(
          dl,
          {
            name: t,
            handleClose: T(!1),
            handleSuccess: A,
            profileType: X.lockConfiguration
          }
        )
      ] })
    }
  );
};
var Ec = /* @__PURE__ */ ((t) => (t.profileName = "profileName", t))(Ec || {});
const Qj = Array.from(Array(3).keys()).map((t) => ({
  config: "",
  description: "",
  name: `profile-${t}`
})), Zj = (t) => (s) => /* @__PURE__ */ e.jsx(lt, { content: t, arrow: !1, className: "default-tt dc__word-break dc__mxw-250", placement: "top", children: s }), eO = () => {
  const [t, s] = v(null), { searchKey: n, handleSearch: a, clearFilters: r, sortOrder: o, handleSorting: i } = _t({
    initialSortKey: Ec.profileName
  }), [l, c, d, p] = ne(() => kj()), m = Q(() => {
    if (c?.length) {
      const g = n.trim().toLowerCase(), E = c.sort((C, b) => Ce(C.name, b.name, o));
      return g ? E.filter(
        (C) => C.name.toLowerCase().includes(g)
      ) : E;
    }
    return [];
  }, [n, c, o]), u = () => /* @__PURE__ */ e.jsxs(wt, { to: Y.LOCK_CONFIGURATION_PROFILE_CREATE, className: "cta flex left dc__gap-4 lh-20-imp anchor", children: [
    /* @__PURE__ */ e.jsx(Xt, { className: "icon-dim-16 dc__no-shrink fcn-0" }),
    "Create Profile"
  ] }), f = () => {
    i(Ec.profileName);
  }, _ = (g) => () => {
    s(g);
  }, h = () => {
    s(null);
  }, x = () => d ? null : !l && !c.length ? /* @__PURE__ */ e.jsx(
    _e,
    {
      image: C_,
      title: "Create profiles to lock fields in deployment template",
      subTitle: "Lock desired fields (such as ingress) to prevent editing by non-super admin users",
      isButtonAvailable: !0,
      renderButton: u,
      classname: "flex-grow-1"
    }
  ) : !l && !m.length ? /* @__PURE__ */ e.jsx(qt, { classname: "flex-grow-1", handleClearFilters: r }) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsx("div", { className: "px-20 py-16", children: /* @__PURE__ */ e.jsx(
      Wt,
      {
        inputProps: {
          placeholder: "Search profile"
        },
        initialSearchText: n,
        handleEnter: a,
        containerClassName: "w-250"
      }
    ) }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-16 lock-profiles-list__table-row lock-profiles-list__table-row--header dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center dc__uppercase bg__primary px-20", children: [
        /* @__PURE__ */ e.jsx("span", {}),
        /* @__PURE__ */ e.jsx(
          Ne,
          {
            isSorted: !0,
            sortOrder: o,
            triggerSorting: f,
            title: "Profile Name",
            disabled: l
          }
        ),
        /* @__PURE__ */ e.jsx(Ne, { title: "Description", isSortable: !1 })
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: l ? Qj.map((g) => /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: "display-grid dc__column-gap-16 lock-profiles-list__table-row fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-20 dc__border-bottom-n1 show-shimmer-loading",
          children: [
            /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
            /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
            /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" })
          ]
        },
        g.name
      )) : m.map((g) => {
        const E = Kt(Y.LOCK_CONFIGURATION_PROFILE_EDIT, {
          profileName: g.name
        });
        return /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: "display-grid dc__column-gap-16 lock-profiles-list__table-row fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-20 dc__border-bottom-n1 dc__hover-n50 dc__visible-hover dc__visible-hover--parent",
            children: [
              /* @__PURE__ */ e.jsx(E_, { className: "icon-dim-20 dc__no-shrink scb-5" }),
              /* @__PURE__ */ e.jsx(
                lt,
                {
                  content: g.name,
                  arrow: !1,
                  className: "default-tt dc__word-break dc__mxw-250",
                  placement: "top",
                  children: /* @__PURE__ */ e.jsx(
                    wt,
                    {
                      to: E,
                      className: "anchor dc__w-fit-content dc__truncate",
                      dangerouslySetInnerHTML: {
                        __html: ta.sanitize(
                          aa({
                            searchText: n,
                            text: g.name,
                            highlightClasses: "bcy-2"
                          })
                        )
                      }
                    }
                  )
                }
              ),
              /* @__PURE__ */ e.jsx(
                An,
                {
                  condition: !!g.description,
                  wrap: Zj(g.description),
                  children: /* @__PURE__ */ e.jsx("span", { className: "dc__w-fit-content dc__truncate", children: g.description || "-" })
                }
              ),
              /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-4 dc__no-shrink", children: [
                /* @__PURE__ */ e.jsx(
                  wt,
                  {
                    to: E,
                    className: "dc__visible-hover--child dc__transparent p-4 dc__no-decor flex",
                    "aria-label": `Edit ${g.name}`,
                    children: /* @__PURE__ */ e.jsx(Fs, { className: "icon-dim-16 dc__no-shrink scn-6" })
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  "button",
                  {
                    type: "button",
                    className: "dc__visible-hover--child dc__transparent p-4 flex",
                    "aria-label": `Delete ${g.name}`,
                    onClick: _(g.name),
                    children: /* @__PURE__ */ e.jsx(ts, { className: "icon-dim-16 dc__no-shrink scr-5" })
                  }
                )
              ] })
            ]
          },
          g.name
        );
      }) })
    ] }),
    !!t && /* @__PURE__ */ e.jsx(
      dl,
      {
        name: t,
        handleClose: h,
        handleSuccess: p,
        profileType: X.lockConfiguration
      }
    )
  ] });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Th, {}),
    /* @__PURE__ */ e.jsx(
      Ke,
      {
        isLoading: !1,
        error: d,
        errorScreenManagerProps: {
          code: d?.code,
          reload: p
        },
        children: x()
      }
    )
  ] });
}, tO = () => /* @__PURE__ */ e.jsxs(Vt, { children: [
  /* @__PURE__ */ e.jsx(ge, { path: Y.LOCK_CONFIGURATION_PROFILE_CREATE, children: /* @__PURE__ */ e.jsx(fu, {}) }),
  /* @__PURE__ */ e.jsx(ge, { path: Y.LOCK_CONFIGURATION_PROFILE_EDIT, children: ({ match: t }) => /* @__PURE__ */ e.jsx(fu, {}, `profile-detail-${t.params.profileName}`) }),
  /* @__PURE__ */ e.jsx(ge, { path: Y.LOCK_CONFIGURATION_PROFILE_LIST, children: /* @__PURE__ */ e.jsx(eO, {}) }),
  /* @__PURE__ */ e.jsx(ms, { to: Y.LOCK_CONFIGURATION_PROFILE_LIST })
] }), a2 = () => {
  const { isSuperAdmin: t } = Is();
  return t ? /* @__PURE__ */ e.jsx("div", { className: "flexbox-col h-100 dc__overflow-hidden bg__primary", children: /* @__PURE__ */ e.jsxs(Vt, { children: [
    /* @__PURE__ */ e.jsx(ge, { path: Y.LOCK_CONFIGURATION_PROFILE_LIST, children: /* @__PURE__ */ e.jsx(tO, {}) }),
    /* @__PURE__ */ e.jsx(ge, { path: Y.LOCK_CONFIGURATION_APPLIED_PROFILE_LIST, children: /* @__PURE__ */ e.jsx(Oj, {}) }),
    /* @__PURE__ */ e.jsx(ms, { to: Y.LOCK_CONFIGURATION_PROFILE_LIST })
  ] }) }) : /* @__PURE__ */ e.jsx(Xe, { code: da.PERMISSION_DENIED });
}, sO = () => /* @__PURE__ */ e.jsxs("div", { className: "fs-13 fw-4 lh-20 cn-9", children: [
  /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "The plugin policy enables you to enforce required tasks (via plugins) during specific stages (before or after) in build or deployment pipelines." }),
  /* @__PURE__ */ e.jsx("p", { className: "mt-20 mb-0", children: "How to create and enforce policy!" }),
  /* @__PURE__ */ e.jsxs("ol", { className: "mb-0 pl-20 fw-6", children: [
    /* @__PURE__ */ e.jsxs("li", { children: [
      /* @__PURE__ */ e.jsx("span", { children: "Create a policy" }),
      " ",
      /* @__PURE__ */ e.jsx("span", { className: "fw-4", children: "with plugins assigned to specific pipeline stage." })
    ] }),
    /* @__PURE__ */ e.jsxs("li", { children: [
      /* @__PURE__ */ e.jsx("span", { children: "Apply the policy" }),
      " ",
      /* @__PURE__ */ e.jsx("span", { className: "fw-4", children: "to all pipelines globally or to pipelines" }),
      " ",
      /* @__PURE__ */ e.jsx("span", { children: "matching criteria like project/application, cluster/environment, or branch." })
    ] })
  ] }),
  /* @__PURE__ */ e.jsx("p", { className: "mt-20 mb-0", children: "You can also choose to block or allow the pipeline trigger if the policy is not followed." })
] }), Ah = () => /* @__PURE__ */ e.jsx(
  rl,
  {
    featureTitleWithInfoProps: {
      SVGImage: Jb,
      docLink: "GLOBAL_CONFIG_PLUGINS_POLICY",
      title: "Plugin Policy",
      renderDescriptionContent: sO
    },
    createProfileLink: Y.PLUGIN_POLICY_PROFILE_CREATE,
    profileListingLink: Y.PLUGIN_POLICY_PROFILE_LIST,
    createAppliedProfileLink: Y.PLUGIN_POLICY_APPLIED_PROFILE_CREATE,
    appliedProfileListingLink: Y.PLUGIN_POLICY_APPLIED_PROFILE_LIST,
    exceptionLink: null
  }
), nO = () => {
  const { push: t } = Te(), s = () => {
    t(Y.PLUGIN_POLICY_APPLIED_PROFILE_LIST);
  }, n = (a) => {
    const r = Kt(Y.PLUGIN_POLICY_APPLIED_PROFILE_EDIT, {
      appliedProfileId: a
    });
    t(r);
  };
  return /* @__PURE__ */ e.jsxs(Vt, { children: [
    /* @__PURE__ */ e.jsx(ge, { path: Y.PLUGIN_POLICY_APPLIED_PROFILE_CREATE, children: /* @__PURE__ */ e.jsx(
      ia,
      {
        redirectToAppliedProfileList: s,
        policyKind: X.plugins
      }
    ) }),
    /* @__PURE__ */ e.jsx(ge, { path: Y.PLUGIN_POLICY_APPLIED_PROFILE_EDIT, children: ({ match: a }) => /* @__PURE__ */ e.jsx(
      ia,
      {
        redirectToAppliedProfileList: s,
        policyKind: X.plugins
      },
      `applied-profile-detail-${a.params.appliedProfileId}`
    ) }),
    /* @__PURE__ */ e.jsxs(ge, { path: Y.PLUGIN_POLICY_APPLIED_PROFILE_LIST, children: [
      /* @__PURE__ */ e.jsx(Ah, {}),
      /* @__PURE__ */ e.jsx(
        al,
        {
          policyKind: X.plugins,
          redirectToEditMatchCriterion: n
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(ms, { to: Y.PLUGIN_POLICY_PROFILE_LIST })
  ] });
}, Sh = (t, s) => ({
  name: t?.identifier,
  description: t?.description ?? "",
  consequence: NI(t?.spec?.def?.consequence),
  rules: t?.spec?.def?.rules?.map((n) => {
    const { icon: a, name: r, pluginIdentifier: o } = s.parentPluginStore[n.parentPluginId];
    return {
      applyToStage: n.applyToStage ?? null,
      applyToVersion: n.applyToVersion ?? null,
      pluginConfig: {
        icon: a,
        name: r,
        parentPluginId: n.parentPluginId,
        pluginIdentifier: o
      }
    };
  }) ?? [],
  type: t?.spec?.def?.type ?? Qt.ciPlugin
}), aO = (t) => {
  const { name: s, consequence: n, description: a, rulesMap: r, type: o } = t;
  return {
    identifier: s,
    description: a,
    spec: {
      def: {
        type: o,
        consequence: n.action === Es.ALLOW_UNTIL_TIME ? {
          action: n.action,
          metadataField: n.metadataField
        } : {
          action: n.action
        },
        rules: r[o].map(({ applyToStage: i, applyToVersion: l, pluginConfig: c, version: d }) => ({
          applyToStage: i,
          applyToVersion: l,
          parentPluginId: null,
          parentPluginIdentifier: c.pluginIdentifier,
          version: d
        }))
      }
    }
  };
}, yh = (t) => [
  ...new Set((t ?? []).map((s) => s.parentPluginIdentifier).filter(Boolean))
], rO = (t) => ({
  data: (t?.data ?? []).map(({ id: s, identifier: n, offendingPipelineCount: a }) => ({
    id: s,
    identifier: n,
    offendingPipelineCount: a ?? 0
  })),
  lastSeenToken: t?.lastSeenToken ?? null,
  loadMore: t?.loadMore ?? !1
}), oO = async () => {
  try {
    const t = ks({
      kind: X.plugins,
      version: mt.alpha1,
      suffix: $.API_LIST_SUFFIX,
      queryParams: {
        lite: !1
      }
    }), { result: s } = await le(t);
    if (!s?.dataList?.length)
      return [];
    const { pluginStore: n } = await Gm({
      appId: null,
      parentPluginIdentifiers: yh(
        s.dataList.flatMap((a) => a?.spec?.def?.rules ?? [])
      ),
      shouldShowError: !1
    });
    return s.dataList.map((a) => Sh(a, n));
  } catch (t) {
    throw V(t), t;
  }
}, iO = async (t) => {
  try {
    const s = ks({
      kind: X.plugins,
      version: mt.alpha1,
      queryParams: {
        identifier: t
      }
    }), { result: n } = await le(s), { pluginStore: a } = await Gm({
      appId: null,
      parentPluginIdentifiers: yh(n?.spec?.def?.rules),
      shouldShowError: !1
    });
    return {
      profileDetail: Sh(n, a),
      pluginStore: a
    };
  } catch (s) {
    throw V(s), s;
  }
}, lO = async ({ formState: t, profileName: s }) => {
  const n = aO(t);
  try {
    return await (s ? Bt : we)(
      ks({
        kind: X.plugins,
        version: mt.alpha1,
        queryParams: {
          identifier: s
        }
      }),
      n
    ), jd(X.plugins), !0;
  } catch (a) {
    return V(a), !1;
  }
}, Lh = async ({
  profileName: t,
  lastSeenToken: s,
  searchKey: n
}) => {
  try {
    const a = ks({
      kind: X.plugins,
      version: mt.alpha1,
      suffix: $.PLUGIN_POLICY_OFFENDING_DEVTRON_APP_LIST,
      queryParams: {
        policyIdentifier: t,
        lastSeenToken: s,
        size: 40,
        searchKey: n
      }
    }), { result: r } = await le(a);
    return rO(r);
  } catch (a) {
    throw V(a), a;
  }
};
var kt = /* @__PURE__ */ ((t) => (t.updateName = "updateName", t.updateDescription = "updateDescription", t.updateType = "updateType", t.updateRules = "updateRules", t.updateApplyToStageAtIndex = "updateApplyToStageAtIndex", t.removeRuleAtIndex = "removeRuleAtIndex", t.bulkUpdateApplyToStage = "bulkUpdateApplyToStage", t.updateConsequenceAction = "updateConsequenceAction", t.updateConsequenceTime = "updateConsequenceTime", t))(kt || {});
const cO = {
  name: "",
  description: "",
  type: Qt.ciPlugin,
  consequence: {
    action: Es.ALLOW_FOREVER
  },
  rulesMap: {
    [Qt.ciPlugin]: [],
    [Qt.cdPlugin]: []
  }
}, dO = [
  {
    label: "Pre-build stage",
    value: Pn.PRE_CI,
    shownOnPluginPolicyType: Qt.ciPlugin
  },
  {
    label: "Post-build stage",
    value: Pn.POST_CI,
    shownOnPluginPolicyType: Qt.ciPlugin
  },
  {
    label: "Pre-deploy stage",
    value: Pn.PRE_CD,
    shownOnPluginPolicyType: Qt.cdPlugin
  },
  {
    label: "Post-deploy stage",
    value: Pn.POST_CD,
    shownOnPluginPolicyType: Qt.cdPlugin
  }
], pO = (t) => ({
  name: t ? null : "",
  description: null,
  consequence: null
}), uO = ({
  policyType: t,
  mandatoryPluginRules: s
}) => {
  const n = dO.filter(
    ({ shownOnPluginPolicyType: i }) => i === t
  ), a = s.reduce(
    (i, l) => (l.applyToStage && (i[l.applyToStage] || (i[l.applyToStage] = 0), i[l.applyToStage] += 1), i),
    {
      [Pn.PRE_CI]: 0,
      [Pn.POST_CI]: 0,
      [Pn.PRE_CD]: 0,
      [Pn.POST_CD]: 0
    }
  ), r = s.length, o = (
    // Mixed should only be shown if at least one of the rules have the apply to stage selected
    // and all of the selections are not the same
    Object.values(a).some((i) => i > 0) && !Object.values(Pn).some(
      (i) => a[i] === r
    )
  );
  return {
    enforceToStageOptions: n,
    bulkEnforceToStageOptions: [
      ...o ? [
        {
          label: "Mixed",
          value: "mixed",
          isSelected: !0
        }
      ] : [],
      ...n.map((i) => ({
        ...i,
        isSelected: r > 0 && a[i.value] === r
      }))
    ]
  };
}, mO = (t) => !!t && t.action === Es.ALLOW_UNTIL_TIME && t.metadataField && it(t.metadataField).utc().isBefore((/* @__PURE__ */ new Date()).toUTCString()), _O = hd(), fO = fd(), hO = ({
  consequence: t,
  consequencesError: s,
  handleConsequenceActionChange: n,
  handleFormStateChange: a
}) => {
  const r = (o) => {
    a({
      action: kt.updateConsequenceTime,
      value: o.toISOString()
    });
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
    /* @__PURE__ */ e.jsx("h3", { className: "fs-14 fw-6 cn-9 lh-20 m-0", children: "Consequences, if policy is not adhered to" }),
    /* @__PURE__ */ e.jsxs(
      ds,
      {
        className: "radio-group-no-border dc_max-width__max-content dc__inline-radio-group flexbox-col flexbox-imp dc__gap-10",
        value: t.action,
        name: "consequence-action-type",
        onChange: n,
        children: [
          /* @__PURE__ */ e.jsx(Ze, { value: Es.ALLOW_FOREVER, dataTestId: "consequence-allow-forever", children: "Allow respective triggers with warning" }),
          /* @__PURE__ */ e.jsx(Ze, { value: Es.BLOCK, dataTestId: "consequence-block", children: "Block respective triggers immediately" }),
          /* @__PURE__ */ e.jsx(Ze, { value: Es.ALLOW_UNTIL_TIME, dataTestId: "consequence-block", children: "Block respective triggers from date/time" })
        ]
      }
    ),
    t.action === Es.ALLOW_UNTIL_TIME && /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8 ml-26", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12", children: [
        /* @__PURE__ */ e.jsx("div", { className: "w-350", children: /* @__PURE__ */ e.jsx(
          tr,
          {
            date: new Date(t.metadataField),
            onChange: r,
            required: !0,
            id: "policy-consequence-select-date",
            openDirection: "up",
            error: s
          }
        ) }),
        /* @__PURE__ */ e.jsx("div", { className: "py-6", children: /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-4", children: [
          /* @__PURE__ */ e.jsx(ed, { className: "scn-6 dc__no-shrink icon-dim-16" }),
          /* @__PURE__ */ e.jsxs("p", { className: "m-0 cn-7 fs-12 fw-4 lh-20", children: [
            "Time zone: (GMT ",
            fO,
            ") ",
            _O
          ] })
        ] }) })
      ] }),
      t.metadataField && !s && (mO(t) ? /* @__PURE__ */ e.jsx(
        Ot,
        {
          description: "Respective triggers are blocked based on set time",
          variant: "warning"
        }
      ) : /* @__PURE__ */ e.jsx(
        Ot,
        {
          description: /* @__PURE__ */ e.jsxs("div", { children: [
            /* @__PURE__ */ e.jsx("span", { children: "Respective triggers will be" }),
            " ",
            /* @__PURE__ */ e.jsxs("span", { className: "fw-6", children: [
              "allowed with warning till ",
              it(t.metadataField).format(
                Ir.TWELVE_HOURS_FORMAT
              )
            ] })
          ] })
        }
      ))
    ] })
  ] });
}, gO = ({ icon: t, name: s, handlePluginSelection: n, parentPluginId: a }) => {
  const r = () => {
    n(a);
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flex br-4 dc__border bg__primary dc__gap-4 px-6 py-2 dc__mxw-250", children: [
    /* @__PURE__ */ e.jsx(
      Wc,
      {
        fallbackImageClassName: "icon-dim-16",
        imageProps: {
          alt: `${s} icon`,
          src: t,
          width: 16,
          height: 16,
          className: "dc__no-shrink"
        }
      }
    ),
    /* @__PURE__ */ e.jsx("span", { className: "dc__truncate cn-9 fs-12 fw-4 lh-20", children: s }),
    /* @__PURE__ */ e.jsx(
      "button",
      {
        type: "button",
        onClick: r,
        className: "dc__no-background dc__no-border dc__outline-none-imp flex dc__tab-focus icon-dim-12",
        "aria-label": `deselect ${s}`,
        children: /* @__PURE__ */ e.jsx(As, { className: "dc__no-shrink scn-6 icon-dim-12" })
      }
    )
  ] });
}, xO = ({
  handleClose: t,
  isEditMode: s,
  handleSuccess: n,
  selectedPluginRules: a,
  pluginDataStore: r,
  handlePluginDataStoreUpdate: o
}) => {
  const [i, l] = v({
    selectedPluginsMap: a.reduce((x, g) => (x[g.pluginConfig.parentPluginId] = !0, x), {}),
    availableTags: [],
    filters: structuredClone(PE),
    pluginList: [],
    totalCount: 0
  }), { selectedPluginsCount: c, allSelectedPlugins: d } = Q(() => {
    const x = Object.keys(i.selectedPluginsMap);
    return {
      selectedPluginsCount: x.length,
      allSelectedPlugins: x.map((g) => {
        const { latestVersionId: E } = r.parentPluginStore[g];
        return r.pluginVersionStore[E];
      })
    };
  }, [i.selectedPluginsMap, r]), p = (x) => {
    const g = structuredClone(i.selectedPluginsMap);
    g[x] ? delete g[x] : g[x] = !0, l((E) => ({
      ...E,
      selectedPluginsMap: g
    }));
  }, m = (x) => {
    l((g) => ({
      ...g,
      availableTags: x
    }));
  }, u = (x) => {
    l((g) => ({
      ...g,
      pluginList: x
    }));
  }, f = (x) => {
    l((g) => ({
      ...g,
      totalCount: x
    }));
  }, _ = (x) => {
    l((g) => ({
      ...g,
      filters: x
    }));
  }, h = () => {
    const x = Object.values(
      r.parentPluginStore
    ).filter((g) => i.selectedPluginsMap[g.id]).map(({ name: g, pluginIdentifier: E, icon: C, id: b }) => ({
      parentPluginId: b,
      name: g,
      pluginIdentifier: E,
      icon: C
    }));
    n({ selectedPluginConfigList: x }), t();
  };
  return /* @__PURE__ */ e.jsx($t, { position: "right", width: "1120px", onClose: t, children: /* @__PURE__ */ e.jsx("div", { className: "bg__primary h-100 flexbox-col", onClick: Le, children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__content-space dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
      /* @__PURE__ */ e.jsx("div", { className: "dc__position-sticky dc__top-0 bg__primary dc__zi-20", children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-justify dc__border-bottom pt-10 pr-20 pb-10 pl-20", children: [
        /* @__PURE__ */ e.jsxs("h2", { className: "fs-16 fw-6 lh-24 m-0 dc__ellipsis-right", children: [
          "Select plugin(s) to ",
          s ? "edit" : "create",
          " policy"
        ] }),
        /* @__PURE__ */ e.jsx(
          j,
          {
            size: O.large,
            icon: /* @__PURE__ */ e.jsx(ua, {}),
            dataTestId: "close-modal",
            ariaLabel: "Close modal",
            showAriaLabelInTippy: !1,
            style: B.negativeGrey,
            variant: w.borderLess,
            onClick: t
          }
        )
      ] }) }),
      /* @__PURE__ */ e.jsx("main", { className: "flexbox-col dc__content-space flex-grow-1 dc__overflow-auto", children: /* @__PURE__ */ e.jsxs("div", { className: "dc__overflow-auto display-grid plugin-profiles-list__add-plugin-modal-container dc__column-gap-24 flex-grow-1", children: [
        /* @__PURE__ */ e.jsx(
          wE,
          {
            rootClassName: "dc__mxw-800 px-20 flex-grow-1 dc__gap-12 mw-600 pb-20",
            availableTags: i.availableTags,
            handleUpdateAvailableTags: m,
            pluginDataStore: r,
            handlePluginDataStoreUpdate: o,
            handlePluginSelection: p,
            isSelectable: !0,
            selectedPluginsMap: i.selectedPluginsMap,
            persistFilters: !0,
            parentPluginList: i.pluginList,
            handleParentPluginListUpdate: u,
            parentTotalCount: i.totalCount,
            handleParentTotalCount: f,
            parentFilters: i.filters,
            handleUpdateParentFilters: _,
            showCardBorder: !0
          }
        ),
        !!c && /* @__PURE__ */ e.jsxs("aside", { className: "pt-70 flexbox-col dc__gap-8 dc__position-sticky dc__top-0 bg__primary dc__zi-1 w-300 dc__overflow-auto dc__align-self-start pb-12 pr-12", children: [
          /* @__PURE__ */ e.jsx("h4", { className: "m-0 cn-9 fs-13 fw-6 lh-20", children: "Selected Plugins" }),
          /* @__PURE__ */ e.jsx("div", { className: "flexbox flex-wrap dc__gap-8", children: d.map((x) => /* @__PURE__ */ e.jsx(
            gO,
            {
              icon: x.icon,
              name: x.name,
              handlePluginSelection: p,
              parentPluginId: x.parentPluginId
            },
            x.name
          )) })
        ] })
      ] }) })
    ] }),
    /* @__PURE__ */ e.jsxs("footer", { className: "px-20 py-16 flex right dc__gap-12 dc__border-top", children: [
      /* @__PURE__ */ e.jsx(
        j,
        {
          dataTestId: "cancel-button",
          text: "Cancel",
          variant: w.secondary,
          style: B.neutral,
          onClick: t
        }
      ),
      /* @__PURE__ */ e.jsx(j, { dataTestId: "done-button", text: "Done", onClick: h })
    ] })
  ] }) }) });
}, EO = ({
  isEditMode: t,
  handleFormStateChange: s,
  mandatoryPluginRules: n,
  policyType: a,
  initialPluginStore: r
}) => {
  const [o, i] = v(!0), [l, c] = v(!1), [d, p] = v(
    structuredClone(t && r ? r : DE)
  ), m = n.length === 0, { enforceToStageOptions: u, bulkEnforceToStageOptions: f } = Q(
    () => uO({
      policyType: a,
      mandatoryPluginRules: n
    }),
    [a, n]
  ), _ = () => {
    c((N) => !N);
  }, h = () => {
    i((N) => !N);
  }, x = (N) => {
    const { parentPluginStore: I, pluginVersionStore: T } = N;
    p((A) => ME(A, I, T));
  }, g = ({ selectedPluginConfigList: N }) => {
    s({
      action: kt.updateRules,
      value: N
    });
  }, E = (N) => (I) => {
    s({
      action: kt.updateApplyToStageAtIndex,
      value: {
        ruleIndex: N,
        applyToStage: I.value
      }
    });
  }, C = (N) => () => {
    s({
      action: kt.removeRuleAtIndex,
      value: N
    });
  }, b = (N) => {
    const { value: I } = N;
    I !== "mixed" && s({
      action: kt.bulkUpdateApplyToStage,
      value: I
    });
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space dc__gap-4", children: [
        /* @__PURE__ */ e.jsx("h3", { className: "fs-14 fw-6 lh-20 cn-9 m-0", children: "Mandatory Plugin(s)" }),
        !m && /* @__PURE__ */ e.jsx(
          j,
          {
            text: "Add Plugin",
            startIcon: /* @__PURE__ */ e.jsx(Xt, {}),
            dataTestId: "add-plugin",
            variant: w.text,
            size: O.medium,
            onClick: _
          }
        )
      ] }),
      m ? /* @__PURE__ */ e.jsx(
        ps,
        {
          useInfoIcon: !0,
          title: "Add Plugin to policy",
          subTitle: "Add mandatory plugins and enforce it to pre/post pipeline stage.",
          description: "",
          withBorder: !0,
          buttonText: "Add plugin",
          reload: _
        }
      ) : (
        // Required for re-mounting the select picker
        /* @__PURE__ */ e.jsxs("div", { className: "dc__border-n1 br-4", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-16 mandatory-plugin-list__table-row mandatory-plugin-list__table-row--header dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center dc__uppercase bg__primary px-12", children: [
            /* @__PURE__ */ e.jsx("span", {}),
            /* @__PURE__ */ e.jsx(Ne, { title: "Plugin", isSortable: !1 }),
            /* @__PURE__ */ e.jsx(Ne, { title: "Enforce to Stage", isSortable: !1 }),
            /* @__PURE__ */ e.jsx("span", {})
          ] }),
          /* @__PURE__ */ e.jsxs("div", { children: [
            /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-16 mandatory-plugin-list__table-row fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-12 dc__border-bottom-n1", children: [
              /* @__PURE__ */ e.jsx(
                j,
                {
                  icon: /* @__PURE__ */ e.jsx(zi, { className: o ? "" : "dc__flip-90--neg" }),
                  dataTestId: "toggle-plugin-rules",
                  ariaLabel: "Toggle plugin rules",
                  showAriaLabelInTippy: !1,
                  onClick: h,
                  size: O.xs,
                  variant: w.borderLess,
                  style: B.neutral
                }
              ),
              /* @__PURE__ */ e.jsxs("span", { className: "dc__truncate", children: [
                n.length,
                " plugin(s) selected"
              ] }),
              /* @__PURE__ */ e.jsx("div", { className: "dc__w-fit-content", children: /* @__PURE__ */ e.jsx(
                Ve,
                {
                  inputId: "bulk-enforce-stage",
                  options: f,
                  value: f.find((N) => N.isSelected) ?? null,
                  variant: cn.COMPACT,
                  placeholder: "Select",
                  onChange: b
                }
              ) }),
              /* @__PURE__ */ e.jsx("span", {})
            ] }),
            o && n.map(({ pluginConfig: N, applyToStage: I }, T) => /* @__PURE__ */ e.jsxs(
              "div",
              {
                className: "display-grid dc__column-gap-16 mandatory-plugin-list__table-row fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-12 dc__border-bottom-n1 last-child__no-border",
                children: [
                  /* @__PURE__ */ e.jsx("div", { className: "flex", children: /* @__PURE__ */ e.jsx(
                    Wc,
                    {
                      fallbackImageClassName: "icon-dim-20",
                      imageProps: {
                        alt: `${N.name} icon`,
                        src: N.icon,
                        width: 20,
                        height: 20,
                        className: "dc__no-shrink"
                      }
                    }
                  ) }),
                  /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: N.name }),
                  /* @__PURE__ */ e.jsx("div", { className: "dc__w-fit-content", children: /* @__PURE__ */ e.jsx(
                    Ve,
                    {
                      inputId: `enforce-${N.pluginIdentifier}-to-stage`,
                      options: u,
                      value: u.find(
                        (A) => A.value === I
                      ) ?? null,
                      variant: cn.COMPACT,
                      placeholder: "Select",
                      onChange: E(T)
                    }
                  ) }),
                  /* @__PURE__ */ e.jsx(
                    j,
                    {
                      icon: /* @__PURE__ */ e.jsx(ua, {}),
                      dataTestId: `remove-plugin-${N.pluginIdentifier}`,
                      ariaLabel: `Remove plugin ${N.name}`,
                      variant: w.borderLess,
                      size: O.xs,
                      style: B.negativeGrey,
                      onClick: C(T)
                    }
                  )
                ]
              },
              N.pluginIdentifier
            ))
          ] })
        ] }, a)
      )
    ] }),
    l && /* @__PURE__ */ e.jsx(
      xO,
      {
        isEditMode: t,
        handleClose: _,
        handleSuccess: g,
        selectedPluginRules: n,
        pluginDataStore: d,
        handlePluginDataStoreUpdate: x
      }
    )
  ] });
}, CO = ({ formErrors: t, formState: s, profileName: n }) => {
  const [a, r] = v(!1), { push: o } = Te(), i = Object.values(t).some((d) => !Ht(d)), l = () => {
    o(Y.PLUGIN_POLICY_PROFILE_LIST);
  }, c = async () => {
    let d;
    if (i ? d = Ji : s.rulesMap[s.type].length === 0 ? d = "Define at least one plugin to policy" : s.rulesMap[s.type].some((p) => Ht(p.applyToStage)) && (d = "Enforce each plugin to any stage"), d) {
      Z.showToast({
        variant: ee.error,
        title: "Cannot Save",
        description: d
      });
      return;
    }
    if (r(!0), await lO({ formState: s, profileName: n })) {
      l();
      return;
    }
    r(!1);
  };
  return /* @__PURE__ */ e.jsxs("footer", { className: "flexbox left dc__border-top-n1 px-20 py-16 dc__gap-12 dc__no-shrink", children: [
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "plugin-profile__save",
        onClick: c,
        isLoading: a,
        disabled: i || a,
        showTooltip: i,
        tooltipProps: {
          content: vr.INVALID_INPUT
        },
        text: "Save Changes"
      }
    ),
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "plugin-profile__cancel",
        onClick: l,
        disabled: a,
        variant: w.secondary,
        style: B.neutral,
        text: "Cancel"
      }
    )
  ] });
}, hu = () => {
  const { profileName: t } = Ue(), { replace: s } = Te(), n = !!t, [a, r] = v(
    structuredClone(cO)
  ), [o, i] = v(
    pO(n)
  ), [l, c, d, p] = ne(
    () => iO(t),
    [t],
    n
  ), [m, u] = v(!1);
  J(() => {
    if (c?.profileDetail) {
      const { name: g, description: E, rules: C, type: b, consequence: N } = c.profileDetail, I = Object.values(Qt).reduce(
        (T, A) => (T[A] = A === b ? structuredClone(C) : C.map((S) => ({
          ...S,
          applyToStage: null
        })), T),
        {
          [Qt.ciPlugin]: [],
          [Qt.cdPlugin]: []
        }
      );
      r({
        name: g,
        description: E,
        type: b,
        consequence: N,
        rulesMap: I
      });
    }
  }, [c]);
  const f = ({ action: g, value: E }) => {
    const C = structuredClone(a), b = structuredClone(o);
    switch (g) {
      case kt.updateName:
        C.name = E, b.name = Tn(E).message;
        break;
      case kt.updateDescription:
        C.description = E, b.description = dn(E).message;
        break;
      case kt.updateType:
        C.type = E;
        break;
      case kt.updateConsequenceAction:
        C.consequence.action = E, b.consequence = null, E === Es.ALLOW_UNTIL_TIME && (C.consequence.metadataField = sn(
          C.consequence.metadataField,
          // Get the next day slot as default if the time is unavailable
          !C.consequence.metadataField
        ).toISOString(), b.consequence = Kl(
          new Date(C.consequence.metadataField)
        ).message);
        break;
      case kt.updateConsequenceTime:
        C.consequence.metadataField = E, b.consequence = Kl(new Date(E)).message;
        break;
      case kt.updateRules: {
        const N = C.rulesMap[C.type].reduce((I, T) => (I[T.pluginConfig.pluginIdentifier] = T, I), {});
        Object.keys(C.rulesMap).forEach((I) => {
          C.rulesMap[I] = E.map((T) => ({
            ...I === C.type && N[T.pluginIdentifier] ? N[T.pluginIdentifier] : {
              applyToStage: null,
              // Add support for other applyToVersion some prioritized
              applyToVersion: lf.all
            },
            pluginConfig: T
          }));
        });
        break;
      }
      case kt.updateApplyToStageAtIndex: {
        const { ruleIndex: N, applyToStage: I } = E;
        C.rulesMap[C.type][N].applyToStage = I;
        break;
      }
      case kt.removeRuleAtIndex:
        C.rulesMap[C.type] = C.rulesMap[C.type].filter(
          (N, I) => I !== E
        );
        break;
      case kt.bulkUpdateApplyToStage:
        C.rulesMap[C.type] = C.rulesMap[C.type].map((N) => ({
          ...N,
          applyToStage: E
        }));
        break;
      default:
        throw new Error(`Unsupported action: ${g}`);
    }
    r(C), i(b);
  }, _ = (g) => (E) => {
    f({
      action: g,
      value: E.target.value
    });
  }, h = () => {
    u((g) => !g);
  }, x = () => {
    s(Y.PLUGIN_POLICY_PROFILE_LIST);
  };
  return /* @__PURE__ */ e.jsx(
    Ke,
    {
      isLoading: l,
      progressingProps: {
        pageLoader: !0
      },
      error: d,
      errorScreenManagerProps: {
        code: d?.code,
        reload: p,
        redirectURL: Y.PLUGIN_POLICY_PROFILE_LIST
      },
      children: !l && !d && /* @__PURE__ */ e.jsxs("main", { className: "bg__primary flexbox-col flex-grow-1 dc__overflow-hidden", children: [
        /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16 py-16 px-20 dc__no-shrink dc__mxw-960", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space", children: [
            /* @__PURE__ */ e.jsx(
              Gi,
              {
                redirectUrl: Y.PLUGIN_POLICY_PROFILE_LIST,
                linkText: "Plugin Policy",
                profileName: t,
                nestedBreadCrumbsText: "Policies"
              }
            ),
            n && /* @__PURE__ */ e.jsx(
              j,
              {
                startIcon: /* @__PURE__ */ e.jsx(ts, {}),
                text: "Delete",
                onClick: h,
                dataTestId: `delete-profile-${t}`,
                size: O.medium,
                variant: w.secondary,
                style: B.negative
              }
            )
          ] }),
          /* @__PURE__ */ e.jsxs("section", { className: "flexbox-col dc__gap-16", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12", children: [
              /* @__PURE__ */ e.jsx("div", { className: "w-250", children: /* @__PURE__ */ e.jsx(
                yt,
                {
                  name: "plugin-profile-name",
                  required: !0,
                  placeholder: "Enter profile name",
                  label: "Name",
                  value: a.name,
                  onChange: _(kt.updateName),
                  error: o.name,
                  autoFocus: !0
                }
              ) }),
              /* @__PURE__ */ e.jsx(
                yt,
                {
                  name: "plugin-profile-description",
                  fullWidth: !0,
                  label: "Description",
                  placeholder: "Enter description",
                  value: a.description,
                  onChange: _(kt.updateDescription),
                  error: o.description
                }
              )
            ] }),
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6 dc__inline-radio-group", children: [
              /* @__PURE__ */ e.jsx("p", { className: "fs-13 fw-4 lh-20 cn-7 m-0", children: "This policy applies to" }),
              /* @__PURE__ */ e.jsxs(
                ds,
                {
                  name: "policy-type",
                  value: a.type,
                  onChange: _(kt.updateType),
                  className: "radio-group-no-border",
                  children: [
                    /* @__PURE__ */ e.jsx(Ze, { value: Qt.ciPlugin, children: "Build pipeline" }),
                    /* @__PURE__ */ e.jsx(Ze, { value: Qt.cdPlugin, children: "Deployment pipeline" })
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom-n1 w-100" }),
            /* @__PURE__ */ e.jsx(
              EO,
              {
                handleFormStateChange: f,
                isEditMode: n,
                mandatoryPluginRules: a.rulesMap[a.type],
                policyType: a.type,
                initialPluginStore: c?.pluginStore
              }
            ),
            /* @__PURE__ */ e.jsx(
              hO,
              {
                consequence: a.consequence,
                consequencesError: o.consequence,
                handleConsequenceActionChange: _(
                  kt.updateConsequenceAction
                ),
                handleFormStateChange: f
              }
            )
          ] })
        ] }) }),
        /* @__PURE__ */ e.jsx(CO, { formState: a, formErrors: o, profileName: t }),
        m && /* @__PURE__ */ e.jsx(
          dl,
          {
            name: t,
            handleClose: h,
            handleSuccess: x,
            profileType: X.plugins
          }
        )
      ] })
    }
  );
}, bO = ({
  profileName: t,
  resourceListResponse: s,
  selectedResourceId: n,
  handleSelectResource: a
}) => {
  const [r, o] = v(!1), [i, l] = v(!1), [c, d] = v({
    data: structuredClone(s.data),
    lastSeenToken: s.lastSeenToken,
    loadMore: s.loadMore
  }), p = (u) => (f) => {
    f.stopPropagation(), a(u);
  }, m = async () => {
    l(!1), o(!0);
    try {
      const { data: u, lastSeenToken: f, loadMore: _ } = await Lh({
        lastSeenToken: c.lastSeenToken,
        profileName: t
      });
      d({
        data: [...structuredClone(c.data), ...structuredClone(u)],
        lastSeenToken: f,
        loadMore: _
      });
    } catch {
      l(!0);
    } finally {
      o(!1);
    }
  };
  return /* @__PURE__ */ e.jsxs("aside", { className: "w-200 dc__no-shrink dc__border-right-n1 h-100 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsx("h3", { className: "m-0 px-16 py-12 fs-13 fw-6 lh-20 cn-7 dc__uppercase dc__border-bottom-n1 bg__primary dc__position-sticky dc__top-0 dc__zi-1", children: "Applications" }),
    /* @__PURE__ */ e.jsxs("div", { className: "p-8", children: [
      c.data.map((u) => {
        const f = n === u.id;
        return /* @__PURE__ */ e.jsxs(
          "button",
          {
            className: `dc__transparent px-8 py-6 br-4 flex dc__content-space dc__gap-4 fs-13 fw-6 lh-20 w-100 ${f ? "bcb-1" : "dc__hover-n50"}`,
            type: "button",
            onClick: p(u.id),
            children: [
              /* @__PURE__ */ e.jsx("span", { className: `${f ? "cb-5" : "cn-9"} dc__truncate`, children: u.identifier }),
              /* @__PURE__ */ e.jsx("span", { className: `br-12 px-6 ${f ? "bcb-5 cn-0" : "bcn-1 cn-7"}`, children: u.offendingPipelineCount })
            ]
          },
          u.identifier
        );
      }),
      r && ["90", "70", "50"].map((u) => /* @__PURE__ */ e.jsx("div", { className: `p-8 h-32 w-${u}`, children: /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100 h-100" }) }, u)),
      c.loadMore && !r && /* @__PURE__ */ e.jsx(kE, { callback: m, hasError: i })
    ] })
  ] });
}, NO = ({ OfflinePipelineModalAppView: t }) => {
  const [s, n] = v(null), { push: a } = Te(), { profileName: r } = Ue(), [o, i, l, c] = ne(
    () => Lh({
      lastSeenToken: null,
      profileName: r
    }),
    [r]
  ), d = i?.data?.find((f) => f.id === s)?.identifier ?? "", p = () => {
    a(Y.PLUGIN_POLICY_PROFILE_LIST);
  }, m = (f) => {
    n(f);
  }, u = () => /* @__PURE__ */ e.jsx(j, { dataTestId: "acknowledge-no-offending-pipelines", text: "Okay", onClick: p });
  return J(() => {
    if (i?.data) {
      const { data: f } = i;
      n(f[0]?.id ?? null);
    }
  }, [i]), /* @__PURE__ */ e.jsx($t, { position: "right", width: "1120px", onClose: p, children: /* @__PURE__ */ e.jsx("div", { className: "bg__primary h-100 flexbox-col", onClick: Le, children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsx("div", { className: "dc__position-sticky dc__top-0 bg__primary dc__zi-20", children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-justify dc__border-bottom pt-10 pr-20 pb-10 pl-20", children: [
      /* @__PURE__ */ e.jsxs("h2", { className: "fs-16 fw-6 lh-24 m-0 dc__ellipsis-right", children: [
        "Non-compliant pipelines for policy '",
        r,
        "'"
      ] }),
      /* @__PURE__ */ e.jsx(
        j,
        {
          size: O.large,
          icon: /* @__PURE__ */ e.jsx(ua, {}),
          dataTestId: "close-modal",
          ariaLabel: "Close modal",
          showAriaLabelInTippy: !1,
          style: B.negativeGrey,
          variant: w.borderLess,
          onClick: p
        }
      )
    ] }) }),
    /* @__PURE__ */ e.jsx(
      Ke,
      {
        isLoading: o,
        progressingProps: {
          pageLoader: !0
        },
        error: l,
        errorScreenManagerProps: {
          code: l?.code,
          reload: c
        },
        children: !o && !l && i.data.length > 0 ? /* @__PURE__ */ e.jsxs("section", { className: "flexbox flex-grow-1 dc__overflow-auto h-100", children: [
          /* @__PURE__ */ e.jsx(
            bO,
            {
              resourceListResponse: i,
              profileName: r,
              selectedResourceId: s,
              handleSelectResource: m
            }
          ),
          /* @__PURE__ */ e.jsx("main", { className: "w-100 p-16 flex-grow-1 dc__overflow-auto", children: s && t && /* @__PURE__ */ e.jsx(
            t,
            {
              appId: s,
              policyKind: X.plugins,
              policyName: r,
              appName: d
            }
          ) })
        ] }) : /* @__PURE__ */ e.jsx(
          _e,
          {
            title: "All pipelines are compliant",
            subTitle: "All matching pipelines have required plugins configured.",
            isButtonAvailable: !0,
            renderButton: u,
            classname: "flex-grow-1",
            image: Zb,
            imageType: bs.Large
          }
        )
      }
    )
  ] }) }) });
}, TO = Array.from(Array(3).keys()).map((t) => ({
  name: `plugin-${t}`,
  description: "",
  consequence: {
    action: Es.BLOCK
  },
  rules: [],
  type: Qt.cdPlugin
}));
var Cc = /* @__PURE__ */ ((t) => (t.policyName = "policyName", t))(Cc || {});
const IO = {
  [Es.BLOCK]: {
    title: "Block",
    icon: /* @__PURE__ */ e.jsx(b_, { className: "scr-5" }),
    getTippyContent: () => "Respective pipeline trigger is blocked"
  },
  [Es.ALLOW_UNTIL_TIME]: {
    title: "Block after..",
    icon: /* @__PURE__ */ e.jsx(tN, {}),
    getTippyContent: (t) => `Respective pipeline trigger will be blocked after ${it(t).format(Ir.TWELVE_HOURS_FORMAT)} (GMT ${fd()}). Allowed with warning till then.`
  },
  [Es.ALLOW_FOREVER]: {
    title: "Allowed with warning",
    icon: /* @__PURE__ */ e.jsx(eN, {}),
    getTippyContent: () => "Respective pipeline trigger is allowed with warning"
  }
}, vO = ({ consequence: t }) => {
  const s = IO[t.action];
  return /* @__PURE__ */ e.jsx(Ie, { content: s.getTippyContent(t.metadataField), alwaysShowTippyOnHover: !0, children: /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-6 dc__w-fit-content", children: [
    /* @__PURE__ */ e.jsx("span", { className: "dc__no-shrink icon-dim-20 flex dc__fill-available-space", children: s.icon }),
    /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-20 cn-9 dc__truncate", children: s.title })
  ] }) });
}, AO = ({ rules: t }) => {
  const s = t.length;
  return s ? /* @__PURE__ */ e.jsx(
    Ie,
    {
      alwaysShowTippyOnHover: !0,
      content: /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("h6", { className: "m-0 fs-12 lh-20 fw-6", children: "Mandatory Plugins" }),
        /* @__PURE__ */ e.jsx("ul", { className: "m-0 pl-20", children: t.map(({ pluginConfig: n }) => /* @__PURE__ */ e.jsx("li", { children: n.name }, n.pluginIdentifier)) })
      ] }),
      interactive: !0,
      className: "dc__overflow-auto mxh-400",
      children: /* @__PURE__ */ e.jsxs("div", { className: "dc__border-n1 bg__primary px-8 py-6 flex left dc__gap-8 dc__border-radius-40 dc__w-fit-content", children: [
        t.slice(0, 2).map(({ pluginConfig: n }, a) => /* @__PURE__ */ e.jsxs(Nr, { children: [
          a > 0 && /* @__PURE__ */ e.jsx("span", { className: "dc__divider dc__divider--n1 h-10" }),
          /* @__PURE__ */ e.jsx(
            Wc,
            {
              fallbackImageClassName: "icon-dim-16",
              imageProps: {
                alt: `${n.name} icon`,
                src: n.icon,
                width: 16,
                height: 16,
                className: "dc__no-shrink"
              }
            }
          )
        ] }, n.pluginIdentifier)),
        s > 2 && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("span", { className: "dc__divider dc__divider--n1 h-10" }),
          /* @__PURE__ */ e.jsxs("span", { className: "fs-13 fw-4 lh-16 cn-9 dc__truncate", children: [
            "+",
            s - 2
          ] })
        ] })
      ] })
    }
  ) : /* @__PURE__ */ e.jsx("span", { children: "-" });
};
var fo = /* @__PURE__ */ ((t) => (t.plugin = "plugin", t))(fo || {});
const SO = (t) => ({
  [fo.plugin]: t.getAll(fo.plugin).map((s) => s.trim()).filter((s) => !!s)
}), yO = (t, s, n) => {
  const { searchKey: a, plugin: r, sortOrder: o } = n, i = s?.result ?? [], l = i.reduce((d, { pluginIdentifier: p, name: m }) => (d[p] = m, d), {}), c = i.map(({ pluginIdentifier: d, name: p }) => ({
    label: p,
    value: d
  }));
  if (t?.length) {
    const d = a.toLowerCase(), p = r.reduce((u, f) => (u[f] = !0, u), {});
    let m = d ? t.filter((u) => u.name.toLowerCase().includes(d)) : t;
    return r.length && (m = m.filter(
      (u) => u.rules.some((f) => p[f.pluginConfig.pluginIdentifier])
    )), {
      filteredProfileList: m.sort((u, f) => Ce(u.name, f.name, o)),
      pluginOptions: c,
      appliedPluginOptions: c.filter(
        ({ value: u }) => p[u]
      ),
      pluginIdentifierToNameMap: l
    };
  }
  return {
    filteredProfileList: [],
    pluginOptions: [],
    appliedPluginOptions: [],
    pluginIdentifierToNameMap: {}
  };
}, LO = ({
  OfflinePipelineModalAppView: t
}) => {
  const [s, n] = v(null), { searchKey: a, handleSearch: r, clearFilters: o, sortOrder: i, handleSorting: l, plugin: c, updateSearchParams: d } = _t({
    initialSortKey: Cc.policyName,
    parseSearchParams: SO
  }), [p, m, u, f] = ne(() => oO()), [_, h, x, g] = ne(
    () => Sm({
      type: "ALL"
    }),
    [],
    !!m
  ), { filteredProfileList: E, pluginOptions: C, appliedPluginOptions: b, pluginIdentifierToNameMap: N } = Q(
    () => yO(m, h, {
      sortOrder: i,
      searchKey: a,
      plugin: c
    }),
    [m, i, a, JSON.stringify(c), h]
  ), I = !!a || c.length > 0, T = (P) => {
    d({
      [fo.plugin]: P.map(({ value: U }) => U)
    });
  }, A = () => {
    l(Cc.policyName);
  }, S = (P) => () => {
    n(P);
  }, L = () => {
    n(null);
  }, R = (P, U) => P === fo.plugin ? N[U] ?? null : null, y = () => /* @__PURE__ */ e.jsx(
    j,
    {
      component: Re.link,
      linkProps: { to: Y.PLUGIN_POLICY_PROFILE_CREATE },
      text: "Create Profile",
      startIcon: /* @__PURE__ */ e.jsx(Xt, {}),
      size: O.medium,
      dataTestId: "create-profile"
    }
  ), M = () => u ? null : !p && !E.length ? I ? /* @__PURE__ */ e.jsx(qt, { handleClearFilters: o }) : /* @__PURE__ */ e.jsx(
    _e,
    {
      image: Xb,
      title: "Create policy to enforce mandatory plugins",
      subTitle: "You can enforce mandatory plugins to any stage (Pre-build, post-build, pre-deploy, post-deploy) by creating plugin policy and applying it to matching criteria (Eg. Application, Environment, Branch)",
      isButtonAvailable: !0,
      renderButton: y,
      classname: "flex-grow-1"
    }
  ) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "py-16 px-20 flex dc__content-space dc__gap-8 dc__zi-2", children: [
      /* @__PURE__ */ e.jsx(
        Wt,
        {
          inputProps: {
            placeholder: "Search policy",
            autoFocus: !0
          },
          initialSearchText: a,
          handleEnter: r
        }
      ),
      /* @__PURE__ */ e.jsx(
        Ps,
        {
          options: C,
          placeholder: "Plugins",
          appliedFilterOptions: b,
          handleApplyFilter: T,
          inputId: "plugin-filter",
          isDisabled: p || _,
          isLoading: _,
          optionListError: x,
          reloadOptionList: g,
          shouldMenuAlignRight: !0
        }
      )
    ] }),
    !p && /* @__PURE__ */ e.jsx(
      Ga,
      {
        filterConfig: {
          plugin: c
        },
        clearFilters: o,
        onRemoveFilter: d,
        className: "px-20 pb-16 pt-0-imp",
        getFormattedValue: R
      }
    ),
    /* @__PURE__ */ e.jsxs("section", { children: [
      /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-16 plugin-profiles-list__table-row plugin-profiles-list__table-row--header dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center dc__uppercase bg__primary px-20 dc__position-sticky dc__top-0 dc__zi-1", children: [
        /* @__PURE__ */ e.jsx("span", {}),
        /* @__PURE__ */ e.jsx(
          Ne,
          {
            isSorted: !0,
            sortOrder: i,
            triggerSorting: A,
            title: "Profile Name",
            disabled: p
          }
        ),
        /* @__PURE__ */ e.jsx(Ne, { title: "Description", isSortable: !1 }),
        /* @__PURE__ */ e.jsx(Ne, { title: "Plugins", isSortable: !1 }),
        /* @__PURE__ */ e.jsx(Ne, { title: "Respective Trigger is", isSortable: !1 }),
        /* @__PURE__ */ e.jsx("span", {})
      ] }),
      /* @__PURE__ */ e.jsx("main", { children: p ? TO.map((P) => /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: "display-grid dc__column-gap-16 plugin-profiles-list__table-row fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-20 dc__border-bottom-n1 show-shimmer-loading",
          children: [
            /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
            /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
            /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
            /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
            /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
            /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" })
          ]
        },
        P.name
      )) : E.map((P) => {
        const U = Kt(Y.PLUGIN_POLICY_PROFILE_EDIT, {
          profileName: P.name
        });
        return /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: "display-grid dc__column-gap-16 plugin-profiles-list__table-row fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-20 dc__border-bottom-n1 dc__hover-n50 dc__visible-hover dc__visible-hover--parent",
            children: [
              /* @__PURE__ */ e.jsx("div", { className: "icon-dim-16 dc__no-shrink", children: cf[P.type] }),
              /* @__PURE__ */ e.jsx(Ie, { content: P.name, placement: "top", children: /* @__PURE__ */ e.jsx(
                wt,
                {
                  to: U,
                  className: "anchor dc__w-fit-content dc__truncate",
                  dangerouslySetInnerHTML: {
                    __html: ta.sanitize(
                      aa({
                        searchText: a,
                        text: P.name,
                        highlightClasses: "bcy-2"
                      })
                    )
                  }
                }
              ) }),
              /* @__PURE__ */ e.jsx(Ie, { content: P.description, children: /* @__PURE__ */ e.jsx("span", { className: "dc__w-fit-content dc__truncate", children: P.description || "-" }) }),
              /* @__PURE__ */ e.jsx(AO, { rules: P.rules }),
              /* @__PURE__ */ e.jsx(vO, { consequence: P.consequence }),
              /* @__PURE__ */ e.jsx("div", { className: "dc__visible-hover--child", children: /* @__PURE__ */ e.jsxs("div", { className: "flex right dc__gap-8 dc__no-shrink", children: [
                /* @__PURE__ */ e.jsx(
                  j,
                  {
                    icon: /* @__PURE__ */ e.jsx(zb, {}),
                    component: Re.link,
                    dataTestId: `show-non-compliant-pipeline-for-${P.name}`,
                    linkProps: {
                      to: Kt(
                        Y.PLUGIN_POLICY_PROFILE_LIST_OFFENDING_PIPELINES,
                        {
                          profileName: P.name
                        }
                      )
                    },
                    ariaLabel: "Show non-compliant pipelines",
                    variant: w.borderLess,
                    style: B.warning,
                    size: O.xs
                  }
                ),
                /* @__PURE__ */ e.jsx("div", { className: "dc__divider" }),
                /* @__PURE__ */ e.jsx(
                  j,
                  {
                    icon: /* @__PURE__ */ e.jsx(Fs, {}),
                    component: Re.link,
                    linkProps: {
                      to: U
                    },
                    dataTestId: `edit-${P.name}`,
                    ariaLabel: "Edit",
                    variant: w.borderLess,
                    style: B.neutral,
                    size: O.xs
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  j,
                  {
                    icon: /* @__PURE__ */ e.jsx(ts, {}),
                    dataTestId: `delete-${P.name}`,
                    ariaLabel: "Delete",
                    variant: w.borderLess,
                    style: B.negativeGrey,
                    size: O.xs,
                    onClick: S(P.name)
                  }
                )
              ] }) })
            ]
          },
          P.name
        );
      }) })
    ] }),
    !!s && /* @__PURE__ */ e.jsx(
      dl,
      {
        name: s,
        handleSuccess: f,
        handleClose: L,
        profileType: X.plugins
      }
    )
  ] });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Ah, {}),
    /* @__PURE__ */ e.jsx(
      Ke,
      {
        isLoading: !1,
        error: u,
        errorScreenManagerProps: {
          reload: f,
          code: u?.code
        },
        children: M()
      }
    ),
    /* @__PURE__ */ e.jsx(Vt, { children: /* @__PURE__ */ e.jsx(ge, { path: Y.PLUGIN_POLICY_PROFILE_LIST_OFFENDING_PIPELINES, exact: !0, children: /* @__PURE__ */ e.jsx(NO, { OfflinePipelineModalAppView: t }) }) })
  ] });
}, jO = ({ OfflinePipelineModalAppView: t }) => /* @__PURE__ */ e.jsxs(Vt, { children: [
  /* @__PURE__ */ e.jsx(ge, { path: Y.PLUGIN_POLICY_PROFILE_CREATE, children: /* @__PURE__ */ e.jsx(hu, {}) }),
  /* @__PURE__ */ e.jsx(ge, { path: Y.PLUGIN_POLICY_PROFILE_EDIT, children: ({ match: s }) => /* @__PURE__ */ e.jsx(hu, {}, `plugin-profile-detail-${s.params.profileName}`) }),
  /* @__PURE__ */ e.jsx(ge, { path: Y.PLUGIN_POLICY_PROFILE_LIST, children: /* @__PURE__ */ e.jsx(LO, { OfflinePipelineModalAppView: t }) }),
  /* @__PURE__ */ e.jsx(ms, { to: Y.PLUGIN_POLICY_PROFILE_LIST })
] }), r2 = ({
  OfflinePipelineModalAppView: t
}) => {
  const { isSuperAdmin: s } = Is();
  return s ? /* @__PURE__ */ e.jsx("div", { className: "flexbox-col h-100 dc__overflow-hidden bg__primary", children: /* @__PURE__ */ e.jsxs(Vt, { children: [
    /* @__PURE__ */ e.jsx(ge, { path: Y.PLUGIN_POLICY_PROFILE_LIST, children: /* @__PURE__ */ e.jsx(jO, { OfflinePipelineModalAppView: t }) }),
    /* @__PURE__ */ e.jsx(ge, { path: Y.PLUGIN_POLICY_APPLIED_PROFILE_LIST, children: /* @__PURE__ */ e.jsx(nO, {}) }),
    /* @__PURE__ */ e.jsx(ms, { to: Y.PLUGIN_POLICY_PROFILE_LIST })
  ] }) }) : /* @__PURE__ */ e.jsx(Xe, { code: da.PERMISSION_DENIED });
};
var ci = /* @__PURE__ */ ((t) => (t.ENVIRONMENT_NAME = "environmentName", t))(ci || {}), jh = /* @__PURE__ */ ((t) => (t.CLUSTER = "cluster", t))(jh || {});
const OO = (t) => ({
  cluster: t.getAll(jh.CLUSTER)?.filter((n) => !!n) || []
}), RO = (t) => {
  const s = {};
  return {
    environmentList: t.map(
      ({ clusterName: a, envName: r, variableCount: o, missingVariableCount: i }) => (s[a] = {
        label: a,
        value: a
      }, {
        name: r,
        clusterName: a,
        variableCount: o || 0,
        missingVariableCount: i || 0
      })
    ),
    clusterOptions: Object.values(s).sort((a, r) => Ce(a.label, r.label))
  };
}, PO = (t, s, n, a) => {
  if (!t?.length)
    return [];
  const r = s.toLowerCase();
  return t.filter((o) => {
    const i = o.name.toLowerCase().includes(r), l = n.length === 0 || n.includes(o.clusterName);
    return i && l;
  }).sort((o, i) => Ce(o.name, i.name, a));
}, Oh = () => le($.GLOBAL_VARIABLES_SUMMARY), wO = async () => {
  try {
    const { result: t } = await Oh();
    return t?.length ? RO(t) : {
      environmentList: [],
      clusterOptions: []
    };
  } catch (t) {
    throw V(t), t;
  }
}, DO = async () => {
  try {
    const { result: t } = await Oh();
    return t?.length ? {
      options: t.map(({ envName: s }) => ({ label: s, value: s })).sort((s, n) => Ce(s.label, n.label)),
      environmentNameMap: t.reduce(
        (s, { envName: n }) => (s[n] = !0, s),
        {}
      )
    } : { options: [], environmentNameMap: {} };
  } catch (t) {
    throw V(t), t;
  }
}, bc = "We require valid key-value pairs", MO = ({
  environmentOptions: t,
  isLoading: s,
  hasError: n,
  reloadData: a,
  optionsContainEnvName: r
}) => {
  const o = Te(), { path: i } = Wi(), { environmentName: l, ...c } = Ue(), d = () => n ? /* @__PURE__ */ e.jsx(ps, { reload: a }) : /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-7 fs-13 fw-4 lh-20 py-6 px-8", children: "No environments found" }), p = Q(() => r ? t : [
    {
      label: l,
      value: l
    },
    ...t
  ], [t, r]), m = (u) => {
    o.push(Kt(i, { ...c, environmentName: u.label }));
  };
  return /* @__PURE__ */ e.jsx(
    sd,
    {
      styles: UO,
      options: p,
      placeholder: "Environment name",
      isLoading: s,
      value: {
        label: l,
        value: l
      },
      components: {
        IndicatorSeparator: null,
        NoOptionsMessage: d,
        LoadingIndicator: FE
      },
      onChange: m,
      className: "w-200",
      maxMenuHeight: 250,
      inputId: "scoped-variables-environment-details-select"
    }
  );
}, kO = ({
  reloadScopedVariables: t
}) => {
  const s = Te(), n = () => {
    t(), s.push(se.APPLICATION_MANAGEMENT_CONFIGURATIONS_SCOPED_VARIABLES);
  };
  return /* @__PURE__ */ e.jsx("button", { className: "dc__outline-none dc__no-border p-0 bg__primary", type: "button", onClick: n, children: /* @__PURE__ */ e.jsx("h2", { className: "m-0 fs-16 lh-32 cb-5", children: "Scoped Variables" }) });
}, FO = ({
  environmentOptions: t,
  isLoading: s,
  hasError: n,
  reloadData: a,
  optionsContainEnvName: r,
  reloadScopedVariables: o
}) => ({
  alias: {
    "application-management": null,
    configurations: null,
    "scoped-variables": {
      component: /* @__PURE__ */ e.jsx(kO, { reloadScopedVariables: o }),
      linked: !1
    },
    [dr.ENVIRONMENT_LIST]: {
      component: /* @__PURE__ */ e.jsx(Ao, { heading: "Environments" }),
      linked: !0
    },
    ":environmentName": {
      component: /* @__PURE__ */ e.jsx(
        MO,
        {
          environmentOptions: t,
          isLoading: s,
          hasError: n,
          reloadData: a,
          optionsContainEnvName: r
        }
      ),
      linked: !1
    }
  }
}), UO = {
  ...qr,
  control: (t, s) => s.menuIsOpen ? qr.control(t, s) : {
    border: "none",
    minHeight: "20px",
    display: "grid",
    gridTemplateColumns: "auto 20px",
    justifyContent: "flex-start",
    gap: "4px",
    alignItems: "center",
    cursor: "pointer",
    color: "var(--N900)"
  },
  singleValue: (t, s) => ({
    ...t,
    color: s.selectProps.menuIsOpen ? "var(--N500)" : "var(--N900)",
    fontSize: "16px"
  }),
  valueContainer: (t, s) => ({
    ...qr.valueContainer(t, s),
    padding: s.selectProps.menuIsOpen ? "0 8px" : "0"
  })
}, Rh = (t) => {
  try {
    const s = zs.parse(t);
    return !s || typeof s != "object" || Array.isArray(s) ? {
      isValid: !1,
      message: bc
    } : {
      isValid: !0,
      parsedYAMLObject: s
    };
  } catch (s) {
    return {
      isValid: !1,
      message: s.message || bc
    };
  }
}, GO = (t) => Ht(t) ? "" : typeof t == "string" ? t : JSON.stringify(t), BO = (t) => Object.keys(t).map((s, n) => ({
  key: s,
  value: GO(t[s]),
  id: n + 1
})).sort((s, n) => Ce(s.key, n.key)), gu = (t) => {
  const s = t.reduce((n, { key: a, value: r }) => (n[a] = r, n), {});
  return gt(s);
}, $O = ({
  environmentVariablesList: t,
  mandatoryVariablesMap: s
}) => t.map((n) => ({
  id: n.id,
  data: {
    key: {
      value: n.key,
      disabled: !0,
      required: s[n.key]
    },
    value: {
      value: n.value
    }
  }
})), VO = ({
  variablesYAML: t,
  handleVariablesYAMLUpdate: s,
  handleUpdateErrorMessages: n
}) => {
  const [a, r] = v(Ut.ASC), o = () => {
    const i = a === Ut.ASC ? Ut.DESC : Ut.ASC;
    try {
      const { isValid: l, message: c, parsedYAMLObject: d } = Rh(t);
      if (!l) {
        Z.showToast({
          variant: ee.error,
          description: c
        }), n([c]);
        return;
      }
      const m = Object.keys(d).sort(
        (u, f) => Ce(u, f, i)
      ).reduce(
        (u, f) => (u[f] = d[f], u),
        {}
      );
      s(gt(m));
    } catch {
      Z.showToast({
        variant: ee.error,
        description: bc
      });
      return;
    }
    r(i);
  };
  return /* @__PURE__ */ e.jsx(Gt.Container, { flexExpand: !0, children: /* @__PURE__ */ e.jsx(
    Gt,
    {
      mode: Ts.YAML,
      noParsing: !0,
      value: t,
      height: "fitToParent",
      onChange: s,
      children: /* @__PURE__ */ e.jsx(Gt.Header, { children: /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space dc__gap-16", children: [
        /* @__PURE__ */ e.jsx(
          j,
          {
            dataTestId: "sort-keys-btn",
            variant: w.borderLess,
            style: B.neutral,
            text: "Sort keys",
            startIcon: /* @__PURE__ */ e.jsx(
              cN,
              {
                className: `dc__transition--transform ${a === Ut.DESC ? "dc__flip-180" : ""}`
              }
            ),
            onClick: o,
            size: O.xs
          }
        ),
        /* @__PURE__ */ e.jsx(Gt.Clipboard, {})
      ] }) })
    }
  ) });
}, YO = async (t) => {
  try {
    const s = { environment: t }, { result: n } = await le(
      ye($.GLOBAL_VARIABLES_FILTER, s)
    );
    return n?.length ? {
      environmentList: n.map((a, r) => ({
        key: a.key || "",
        value: a.value || "",
        id: r + 1
      })),
      ...n.reduce(
        (a, { key: r, isMandatory: o }) => (o && (a.mandatoryVariablesMap[r] = !0), a.originalKeysMap[r] = !0, a),
        { mandatoryVariablesMap: {}, originalKeysMap: {} }
      )
    } : {
      environmentList: [],
      mandatoryVariablesMap: {},
      originalKeysMap: {}
    };
  } catch (s) {
    throw V(s), s;
  }
}, HO = async (t, s) => {
  const n = {
    environment: t,
    data: s.map(({ key: a, value: r }) => ({
      key: a,
      value: r
    }))
  };
  return Bt($.GLOBAL_VARIABLES, n);
}, KO = ({
  environmentNameMap: t,
  reloadScopedVariables: s
}) => {
  const { environmentName: n } = Ue(), a = Te(), [
    r,
    o,
    i,
    l
  ] = ne(
    () => YO(n),
    [t, n],
    !!t[n]
  ), [c, d] = v(Bo.GUI), [p, m] = v(!1), [u, f] = v([]), [_, h] = v(""), [x, g] = v([]), E = (P) => {
    h(P);
  }, C = (P) => {
    f(P);
  };
  J(() => {
    if (!r && !i && o) {
      const { environmentList: P } = o, U = structuredClone(P).map(({ key: G, value: H, id: oe }) => ({ key: G, value: H, id: oe })).sort((G, H) => Ce(G.key, H.key));
      E(gu(U)), C(U);
    }
  }, [o, r, i]);
  const b = () => {
    a.push(
      `${se.APPLICATION_MANAGEMENT_CONFIGURATIONS_SCOPED_VARIABLES}/${dr.ENVIRONMENT_LIST}`
    );
  }, N = (P) => {
    g(P);
  }, I = () => {
    if (c === Bo.GUI)
      return {
        variableArray: u,
        hasParsingError: !1
      };
    const { isValid: P, message: U, parsedYAMLObject: G } = Rh(_);
    return P ? {
      variableArray: BO(G),
      hasParsingError: !1
    } : (N([U]), {
      variableArray: [],
      hasParsingError: !0,
      errorMessage: U
    });
  }, T = () => {
    try {
      const { variableArray: P, hasParsingError: U, errorMessage: G } = I();
      if (U)
        return {
          isValid: !1,
          message: G
        };
      const H = [], oe = [], ae = [];
      let re = !1;
      P.forEach(({ key: F, value: q }) => {
        o.mandatoryVariablesMap[F] && !q && oe.push(F), F && !o.originalKeysMap[F] && ae.push(F), F || (re = !0);
      });
      const { isValid: k, message: D } = GE(P.map(({ key: F }) => F));
      return oe.length && H.push(`Values for following variables is required: ${oe.join(", ")}`), ae.length && H.push(`Addition of new keys is not supported: ${ae.join(", ")}`), k || H.push(D), re && H.push("Key for all variables are required"), N(H), {
        isValid: !H.length,
        message: H[0]
      };
    } catch {
      return {
        isValid: !1,
        message: "We require valid list of key-value pairs"
      };
    }
  }, A = async () => {
    try {
      if (!T().isValid) {
        Z.showToast({
          variant: ee.error,
          description: "Please resolve the errors before saving the changes"
        });
        return;
      }
      m(!0), await HO(n, I().variableArray), m(!1), s(), b(), Z.showToast({
        variant: ee.success,
        description: "Environment variables successfully updated"
      });
    } catch (P) {
      m(!1), V(P), N([P.errors?.[0]?.userMessage || "Something went wrong"]);
    }
  }, S = () => {
    b();
  }, L = (P) => {
    const U = P.value;
    if (U === c)
      return;
    if (!T().isValid) {
      Z.showToast({
        variant: ee.error,
        description: "Please resolve the errors before switching the mode"
      });
      return;
    }
    if (d(U), U === Bo.GUI) {
      const { variableArray: H } = I();
      C(H);
      return;
    }
    const G = structuredClone(u).sort(
      (H, oe) => Ce(H.key, oe.key)
    );
    E(gu(G));
  }, R = () => /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-4", children: x.length === 1 ? /* @__PURE__ */ e.jsx("p", { className: "cn-9 fs-13 fw-4 lh-20 m-0", children: x[0] }) : /* @__PURE__ */ e.jsx(e.Fragment, { children: x.map((P, U) => /* @__PURE__ */ e.jsxs("p", { className: "cn-9 fs-13 fw-4 lh-20 m-0", children: [
    U + 1,
    ". ",
    P
  ] }, P)) }) }), y = () => c === Bo.YAML ? /* @__PURE__ */ e.jsx(
    VO,
    {
      variablesYAML: _,
      handleVariablesYAMLUpdate: E,
      handleUpdateErrorMessages: N
    }
  ) : /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1", children: /* @__PURE__ */ e.jsx(
    UE,
    {
      isAdditionNotAllowed: !0,
      isSortable: !0,
      placeholder: {
        value: "Enter Value"
      },
      headerLabel: { key: "Key", value: "Value" },
      rows: $O({
        environmentVariablesList: u,
        mandatoryVariablesMap: o.mandatoryVariablesMap
      }),
      onChange: C
    }
  ) }), M = () => o ? u.length ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: "dc__overflow-auto flexbox-col flex-grow-1 px-20 pb-12", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__content-space dc__gap-12", children: [
      /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
        Qs,
        {
          segments: Bm,
          value: c,
          onChange: L,
          name: "environment-details-mode-control"
        }
      ) }),
      !!x?.length && /* @__PURE__ */ e.jsx(Ot, { variant: "error", description: R() }),
      y()
    ] }) }),
    /* @__PURE__ */ e.jsxs("div", { className: "py-16 px-20 dc__border-top-n1 flexbox dc__gap-12 dc__no-shrink", children: [
      /* @__PURE__ */ e.jsx(
        j,
        {
          text: "Save changes",
          isLoading: p,
          dataTestId: "save-environment-variables",
          onClick: A
        }
      ),
      /* @__PURE__ */ e.jsx(
        j,
        {
          text: "Cancel",
          variant: w.secondary,
          style: B.neutral,
          dataTestId: "cancel-environment-details",
          onClick: S
        }
      )
    ] })
  ] }) : /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1", children: /* @__PURE__ */ e.jsx(
    _e,
    {
      title: "No variables found",
      subTitle: "No variables are available for this environment"
    }
  ) }) : null;
  return t[n] ? /* @__PURE__ */ e.jsx(
    Ke,
    {
      isLoading: r,
      error: i,
      progressingProps: {
        pageLoader: !0
      },
      errorScreenManagerProps: {
        code: i?.code,
        reload: l,
        redirectURL: `${se.APPLICATION_MANAGEMENT_CONFIGURATIONS_SCOPED_VARIABLES}/${dr.ENVIRONMENT_LIST}`
      },
      children: M()
    }
  ) : /* @__PURE__ */ e.jsx(
    Xe,
    {
      code: Ns.NOT_FOUND,
      redirectURL: `${se.APPLICATION_MANAGEMENT_CONFIGURATIONS_SCOPED_VARIABLES}/${dr.ENVIRONMENT_LIST}`
    }
  );
}, WO = ({ reloadScopedVariables: t }) => {
  const { environmentName: s } = Ue(), [
    n,
    a,
    r,
    o
  ] = ne(DO), { breadcrumbs: i } = yr(
    FO({
      environmentOptions: a?.options || [],
      isLoading: n,
      hasError: !!r,
      reloadData: o,
      optionsContainEnvName: !!a?.environmentNameMap?.[s] || !1,
      reloadScopedVariables: t
    }),
    [n, a, r, s]
  );
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__content-space dc__overflow-auto bg__primary w-100 h-100", children: [
    /* @__PURE__ */ e.jsx("div", { className: "flexbox pt-16 pb-24 px-20", children: /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center dc__gap-4", children: /* @__PURE__ */ e.jsx(Lr, { breadcrumbs: i }) }) }),
    /* @__PURE__ */ e.jsx(
      Ke,
      {
        isLoading: n,
        progressingProps: {
          pageLoader: !0
        },
        error: r,
        errorScreenManagerProps: {
          code: r?.code,
          reload: o,
          redirectURL: `${se.APPLICATION_MANAGEMENT_CONFIGURATIONS_SCOPED_VARIABLES}/${dr.ENVIRONMENT_LIST}`
        },
        children: /* @__PURE__ */ e.jsx(
          KO,
          {
            environmentNameMap: a?.environmentNameMap,
            reloadScopedVariables: t
          },
          s
        )
      }
    )
  ] });
}, o2 = ({ reloadScopedVariables: t }) => /* @__PURE__ */ e.jsx(
  ge,
  {
    path: `${se.APPLICATION_MANAGEMENT_CONFIGURATIONS_SCOPED_VARIABLES}/${dr.ENVIRONMENT_LIST}/:environmentName`,
    exact: !0,
    children: /* @__PURE__ */ e.jsx(WO, { reloadScopedVariables: t })
  }
), qO = ({
  environmentResponseError: t,
  reloadData: s,
  isLoading: n,
  clusterOptions: a = [],
  handleClusterSelection: r,
  clusterList: o
}) => {
  const i = o?.map((c) => ({ label: c, value: c })) || [], l = (c) => {
    r(c.map((d) => d.label));
  };
  return /* @__PURE__ */ e.jsx(
    Ps,
    {
      options: a,
      appliedFilterOptions: i,
      optionListError: t,
      reloadOptionList: s,
      handleApplyFilter: l,
      isLoading: n,
      placeholder: "Select Clusters",
      inputId: "cluster-variable-select",
      isDisabled: !1,
      shouldMenuAlignRight: !0,
      menuPosition: "absolute"
    }
  );
}, zO = ({ name: t, variableCount: s, missingVariableCount: n }) => {
  const a = Te();
  return /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-20 scoped-variables-environment-list__row-wrapper px-20 py-12 dc__hover-n50", children: [
    /* @__PURE__ */ e.jsx(wt, { to: `${a.location.pathname}/${t}`, className: "anchor fs-13 fw-4 lh-20", children: t }),
    /* @__PURE__ */ e.jsxs("span", { className: "dc__truncate fs-13 fw-4 lh-20", children: [
      s,
      " variables"
    ] }),
    !!n && /* @__PURE__ */ e.jsxs("span", { className: "dc__truncate cr-5 fs-13 fw-4 lh-20", children: [
      n,
      " mandatory values missing"
    ] })
  ] });
}, XO = ({ environmentList: t, clearFilters: s, areFiltersApplied: n }) => t?.length ? /* @__PURE__ */ e.jsx(e.Fragment, { children: t.map(({ name: a, variableCount: r, missingVariableCount: o }) => /* @__PURE__ */ e.jsx(
  zO,
  {
    name: a,
    variableCount: r,
    missingVariableCount: o
  },
  a
)) }) : n ? /* @__PURE__ */ e.jsx(qt, { handleClearFilters: s }) : /* @__PURE__ */ e.jsx(_e, { title: "No environments found", subTitle: "Please create environments first" }), JO = () => /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-20 scoped-variables-environment-list__row-wrapper px-20 py-12 dc__align-items-center", children: [
  /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100 h-16" }),
  /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100 h-16" }),
  /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-150 h-16" })
] }), QO = () => /* @__PURE__ */ e.jsx(e.Fragment, { children: Array(3).fill(0).map((t, s) => (
  // eslint-disable-next-line react/no-array-index-key
  /* @__PURE__ */ e.jsx(JO, {}, s)
)) }), i2 = () => {
  const [t, s, n, a] = ne(wO), {
    sortBy: r,
    sortOrder: o,
    handleSorting: i,
    searchKey: l,
    handleSearch: c,
    cluster: d,
    clearFilters: p,
    updateSearchParams: m
  } = _t({
    initialSortKey: ci.ENVIRONMENT_NAME,
    parseSearchParams: OO
  }), u = (h) => {
    m({
      cluster: h
    });
  }, f = () => {
    i(ci.ENVIRONMENT_NAME);
  }, _ = Q(
    () => PO(s?.environmentList, l, d, o),
    [s?.environmentList, l, d, o]
  );
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-auto h-100 w-100", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "py-12 px-20 flexbox dc__content-space dc__align-items-center", children: [
      /* @__PURE__ */ e.jsx(
        Wt,
        {
          initialSearchText: l,
          handleEnter: c,
          inputProps: {
            placeholder: "Search environment"
          },
          containerClassName: "dc__mxw-250 w-100"
        }
      ),
      /* @__PURE__ */ e.jsx(
        qO,
        {
          environmentResponseError: n,
          reloadData: a,
          isLoading: t,
          clusterOptions: s?.clusterOptions,
          handleClusterSelection: u,
          clusterList: d
        }
      )
    ] }),
    !!d?.length && /* @__PURE__ */ e.jsx(
      Ga,
      {
        filterConfig: {
          cluster: d
        },
        onRemoveFilter: m,
        clearFilters: p,
        className: "w-100 pb-12-imp pt-0-imp px-20",
        clearButtonClassName: "dc__no-background-imp dc__no-border-imp dc__tab-focus"
      }
    ),
    (t || _?.length > 0) && /* @__PURE__ */ e.jsxs("div", { className: "display-grid dc__column-gap-20 scoped-variables-environment-list__row-wrapper dc__align-items-center dc__uppercase bg__primary dc__position-sticky dc__top-0 dc__zi-1 dc__border-bottom-n1 fs-12 fw-6 lh-20 px-20 py-8 cn-7", children: [
      /* @__PURE__ */ e.jsx(
        Ne,
        {
          isSorted: r === ci.ENVIRONMENT_NAME,
          sortOrder: o,
          title: "Environment name",
          triggerSorting: f,
          disabled: !1
        }
      ),
      /* @__PURE__ */ e.jsx("span", { className: "dc__uppercase dc__ellipsis-right", children: "Scoped variables" })
    ] }),
    /* @__PURE__ */ e.jsx(
      Ke,
      {
        isLoading: t,
        error: n,
        customLoader: /* @__PURE__ */ e.jsx(QO, {}),
        errorScreenManagerProps: {
          code: n?.code,
          reload: a
        },
        children: /* @__PURE__ */ e.jsx(
          XO,
          {
            environmentList: _,
            clearFilters: p,
            areFiltersApplied: !!l || !!d?.length
          }
        )
      }
    )
  ] });
}, Ph = () => {
  const t = Te(), s = () => {
    t.push(Ee.NETWORK_STATUS_CONTROLLER_CREATE);
  };
  return /* @__PURE__ */ e.jsxs("button", { className: "cta h-28 flex dc__gap-8", type: "button", onClick: s, children: [
    /* @__PURE__ */ e.jsx(Xt, { className: "dc__no-shrink icon-dim-12 fcn-0" }),
    "Add Controller"
  ] });
};
var wh = /* @__PURE__ */ ((t) => (t.CONTROLLER_ACTIVE = "Controller-Active", t.CONTROLLER_STANDBY = "Controller-Standby", t))(wh || {}), pl = /* @__PURE__ */ ((t) => (t.COLUMN_TEMPLATE = "columnTemplate", t))(pl || {}), mn = /* @__PURE__ */ ((t) => (t.SYSTEM_CONTROLLER_NAME = "systemControllerName", t.NUMBER_OF_SUB_CLOUDS = "numberOfSubClouds", t))(mn || {}), Dh = /* @__PURE__ */ ((t) => (t.SUB_CLOUD_PAGE_SIZE = "subCloudPageSize", t))(Dh || {});
const ZO = [
  {
    field: "invprovision",
    label: "Invprovision"
  },
  {
    field: "administrative",
    label: "Administrative"
  },
  {
    field: "operational",
    label: "Operational"
  },
  {
    field: "availability",
    label: "Availability"
  }
], Mh = ZO.map(
  (t, s) => ({
    ...t,
    width: 180,
    isSortable: !0,
    type: "string",
    order: s
  })
), eR = [
  {
    field: "deploy-status",
    label: "Deploy Status"
  },
  {
    field: "software-version",
    label: "Software Version"
  },
  {
    field: "availability-status",
    label: "Availability"
  },
  {
    field: "management-state",
    label: "Management State"
  },
  {
    field: "error-description",
    label: "Error"
  },
  {
    field: "region-name",
    label: "Region Name"
  },
  {
    field: "management-start-ip",
    label: "Management Start IP"
  }
], kh = eR.map(
  (t, s) => ({
    ...t,
    width: 180,
    type: "string",
    order: s
  })
), mr = {
  systemControllerMap: {},
  ids: [],
  columnConfig: {
    systemControllerColumns: Mh,
    subCloudColumns: kh,
    id: 0
  }
}, tR = {
  id: 0,
  key: pl.COLUMN_TEMPLATE,
  value: null
}, xu = 20, Eu = 3, Fh = (t) => ({
  analyze: t?.analyze || "",
  manage: t?.manage || "",
  deploy: t?.deploy || ""
}), sR = (t) => t?.length ? t.find((s) => s?.capabilities?.Personality === wh.CONTROLLER_ACTIVE) : null, Cu = (t) => ({
  field: t?.field || "",
  label: t?.label || "",
  order: t?.order ? parseInt(t.order, 10) : 0,
  // TODO: Constant
  width: t?.width ? parseInt(t.width, 10) : 180,
  isSortable: t?.isSortable || !1,
  type: t?.type || "string"
}), nR = ({
  systemControllerResponse: t,
  columnConfigResponse: s
}) => {
  if (!t?.length)
    return structuredClone(mr);
  const n = t.reduce(
    (a, r) => {
      const { id: o, actionLinks: i, subclouds: l, systemControllers: c, systemControllerDetails: d } = r;
      if (!o || !c?.ihosts?.length)
        return a;
      const p = sR(c.ihosts);
      return p && (a.ids.push(o), a.systemControllerMap[o] = {
        id: o,
        actionLinks: Fh(i),
        subclouds: l && Array.isArray(l) ? l.sort((m, u) => Ce(m?.name || "", u?.name || "")) : [],
        activeController: p,
        systemControllerName: d?.isystems?.[0]?.name || "",
        systemControllerDetails: d
      }), a;
    },
    structuredClone(mr)
  );
  try {
    const a = JSON.parse(s.value), r = a?.systemControllerColumns?.map(Cu)?.filter((i) => i.field && i.label)?.sort((i, l) => no(i.order, l.order)), o = a?.subCloudColumns?.map(Cu)?.filter((i) => i.field && i.label)?.sort((i, l) => no(i.order, l.order));
    return {
      ...n,
      columnConfig: {
        id: s.id || 0,
        systemControllerColumns: r?.length ? r : structuredClone(Mh),
        subCloudColumns: o?.length ? o : structuredClone(kh)
      }
    };
  } catch {
    return Z.showToast({
      variant: ee.warn,
      description: "Issue while parsing column config data, reverting to default column config"
    }), n;
  }
}, aR = (t) => {
  const { ipAddress: s, username: n, actionLinks: a } = t;
  return {
    ipAddress: s || "",
    username: n || "",
    password: "",
    actionLinks: Fh(a)
  };
}, jl = ({ rootClassName: t, style: s }) => /* @__PURE__ */ e.jsxs("div", { className: `${t || ""} flexbox dc__align-items-center dc__gap-4`, style: s || {}, children: [
  /* @__PURE__ */ e.jsx(Or, { className: "icon-dim-16 dc__no-shrink fcn-6" }),
  /* @__PURE__ */ e.jsx("i", { className: "dc__truncate cn-6 fs-13 fw-4 lh-20", children: "No data found" })
] }), rR = (t) => {
  switch (t) {
    case mn.NUMBER_OF_SUB_CLOUDS:
      return "number";
    default:
      return "string";
  }
}, oR = (t) => ({
  subCloudPageSize: +(t.get(Dh.SUB_CLOUD_PAGE_SIZE) || xu) || xu
}), iR = async (t) => {
  const { result: s } = await le(
    ye(Ws.ATTRIBUTES, { key: pl.COLUMN_TEMPLATE }),
    {
      signal: t
    }
  );
  return s || structuredClone(tR);
}, lR = async (t) => {
  const { result: s } = await le($.SYSTEM_NETWORK_CONTROLLER_INFO, {
    signal: t,
    timeout: window._env_.SYSTEM_CONTROLLER_LISTING_TIMEOUT || window._env_.GLOBAL_API_TIMEOUT || 6e4
  });
  return s ? s.map((n) => {
    const r = JSON.parse(n.subclouds || "{}")?.subclouds || [];
    return {
      ...n,
      systemControllers: JSON.parse(n.systemControllers || "[]"),
      subclouds: r,
      systemControllerDetails: JSON.parse(n.systemControllerDetails || "{}")
    };
  }) : [];
}, cR = async ({
  signal: t
}) => {
  try {
    const [s, n] = await Promise.all([
      iR(t),
      lR(t)
    ]);
    return nR({
      columnConfigResponse: s,
      systemControllerResponse: n
    });
  } catch (s) {
    throw Pe(s) || V(s), s;
  }
}, dR = async ({
  controllerId: t
}) => {
  try {
    const { result: s } = await le(
      `${$.SYSTEM_NETWORK_CONTROLLER_CONFIG}/${t}`
    );
    return aR(s);
  } catch (s) {
    throw V(s), s;
  }
}, pR = async ({
  id: t,
  controllerForm: s
}) => {
  const n = {
    ...s,
    id: t
  };
  return Bt($.SYSTEM_NETWORK_CONTROLLER_CONFIG, n);
}, uR = async (t) => Js(`${$.SYSTEM_NETWORK_CONTROLLER_CONFIG}/${t}`), mR = {
  ipAddress: "",
  username: "",
  password: "",
  actionLinks: {
    analyze: "",
    manage: "",
    deploy: ""
  }
}, _R = {
  ipAddress: "",
  username: "",
  password: "",
  analyze: "",
  manage: "",
  deploy: ""
}, zo = [
  cp.HTTP,
  cp.HTTPS
];
var ws = /* @__PURE__ */ ((t) => (t.UPDATE_IP_ADDRESS = "UPDATE_IP_ADDRESS", t.UPDATE_USERNAME = "UPDATE_USERNAME", t.UPDATE_PASSWORD = "UPDATE_PASSWORD", t.UPDATE_ANALYZE_LINK = "UPDATE_ANALYZE_LINK", t.UPDATE_MANAGE_LINK = "UPDATE_MANAGE_LINK", t.UPDATE_DEPLOY_LINK = "UPDATE_DEPLOY_LINK", t))(ws || {});
const di = ({
  label: t,
  placeholder: s,
  value: n,
  error: a,
  handleChange: r,
  action: o,
  required: i = !1,
  autoFocus: l = !1,
  isSensitive: c = !1,
  type: d,
  ...p
}) => {
  const [m, u] = v(!1), f = (g) => {
    r({ payload: g.target.value, action: o });
  }, _ = () => {
    u(!0);
  }, h = () => {
    u(!1);
  }, x = !c || m || n ? n : xi;
  return /* @__PURE__ */ e.jsx(
    yt,
    {
      ...p,
      name: `${o}-input`,
      label: t,
      value: x,
      error: a,
      placeholder: s,
      required: i,
      autoFocus: l,
      onChange: f,
      onFocus: _,
      onBlur: h,
      type: d,
      fullWidth: !0
    }
  );
}, Ol = ({
  action: t,
  label: s,
  handleChange: n,
  value: a,
  error: r
}) => /* @__PURE__ */ e.jsx(
  di,
  {
    placeholder: "Enter URL",
    value: a,
    error: r,
    handleChange: n,
    action: t,
    label: s,
    required: !1,
    layout: "row"
  }
), fR = ({
  handleChange: t,
  controllerForm: s,
  controllerFormError: n
}) => {
  const { controllerId: a } = Ue(), r = !!a;
  return /* @__PURE__ */ e.jsxs("div", { className: "p-20 flexbox-col flex-grow-1 dc__gap-16 dc__overflow-auto w-100", children: [
    /* @__PURE__ */ e.jsx(
      di,
      {
        label: "Controller URL",
        required: !0,
        placeholder: "Enter controller URL",
        value: s.ipAddress,
        error: n.ipAddress,
        handleChange: t,
        action: ws.UPDATE_IP_ADDRESS,
        autoFocus: !0
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "dc__grid-cols-2 dc__column-gap-12", children: [
      /* @__PURE__ */ e.jsx(
        di,
        {
          label: "Username",
          required: !0,
          placeholder: "Enter username",
          value: s.username,
          error: n.username,
          handleChange: t,
          action: ws.UPDATE_USERNAME
        }
      ),
      /* @__PURE__ */ e.jsx(
        di,
        {
          label: "Password",
          required: !0,
          placeholder: "Enter password",
          value: s.password,
          error: n.password,
          handleChange: t,
          action: ws.UPDATE_PASSWORD,
          isSensitive: r,
          type: "password"
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom" }),
    /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-13 fw-6 lh-20", children: "Action links" }),
    /* @__PURE__ */ e.jsx(
      Ol,
      {
        label: "Analyze",
        action: ws.UPDATE_ANALYZE_LINK,
        handleChange: t,
        value: s.actionLinks.analyze,
        error: n.analyze
      }
    ),
    /* @__PURE__ */ e.jsx(
      Ol,
      {
        label: "Manage",
        action: ws.UPDATE_MANAGE_LINK,
        handleChange: t,
        value: s.actionLinks.manage,
        error: n.manage
      }
    ),
    /* @__PURE__ */ e.jsx(
      Ol,
      {
        label: "Deploy",
        action: ws.UPDATE_DEPLOY_LINK,
        handleChange: t,
        value: s.actionLinks.deploy,
        error: n.deploy
      }
    )
  ] });
}, bu = ({ handleSuccess: t, handleClose: s }) => {
  const { controllerId: n } = Ue(), [a, r] = v(
    structuredClone(mR)
  ), [
    o,
    i,
    l,
    c
  ] = ne(() => dR({ controllerId: +n }), [n], !!n), [d, p] = v(
    structuredClone(_R)
  ), [m, u] = v(!1);
  J(() => {
    n && !o && !l && i && r(i);
  }, [o, l, i, n]);
  const f = ({ payload: g, action: E }) => {
    const C = structuredClone(a), b = structuredClone(d);
    switch (E) {
      case ws.UPDATE_IP_ADDRESS:
        C.ipAddress = g, b.ipAddress = $o(g, zo, !0).message;
        break;
      case ws.UPDATE_USERNAME:
        C.username = g, b.username = Ln(g).message;
        break;
      case ws.UPDATE_PASSWORD:
        C.password = g, b.password = n ? "" : Ln(g).message;
        break;
      case ws.UPDATE_ANALYZE_LINK:
        C.actionLinks.analyze = g, b.analyze = g ? $o(g, zo).message : "";
        break;
      case ws.UPDATE_MANAGE_LINK:
        C.actionLinks.manage = g, b.manage = g ? $o(g, zo).message : "";
        break;
      case ws.UPDATE_DEPLOY_LINK:
        C.actionLinks.deploy = g, b.deploy = g ? $o(g, zo).message : "";
        break;
      default:
        Z.showToast({
          variant: ee.error,
          description: `Invalid action type: ${E}`
        });
        break;
    }
    r(C), p(b);
  }, _ = async () => {
    try {
      const g = Object.values(d).some((C) => !!C), E = !Ln(a.ipAddress).isValid || !Ln(a.username).isValid || !n && !Ln(a.password).isValid;
      if (g) {
        Z.showToast({
          variant: ee.error,
          description: "Please resolve the errors before saving"
        });
        return;
      }
      if (E) {
        Z.showToast({
          variant: ee.error,
          description: "Please fill all the required fields before saving"
        }), p({
          ipAddress: Ln(a.ipAddress).message,
          username: Ln(a.username).message,
          password: n ? "" : Ln(a.password).message
        });
        return;
      }
      u(!0), await pR({
        id: n ? +n : void 0,
        controllerForm: a
      }), Z.showToast({
        variant: ee.success,
        description: "Controller saved successfully"
      }), t(), s(), u(!1);
    } catch (g) {
      V(g), u(!1);
    }
  }, h = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space py-12 px-20 dc__gap-8 dc__border-bottom dc__align-items-center", children: [
    /* @__PURE__ */ e.jsx("h2", { className: "m-0 cn-9 fs-16 fw-6 lh-24 dc__truncate", children: n ? "Edit controller" : "Add controller" }),
    /* @__PURE__ */ e.jsx(
      "button",
      {
        type: "button",
        className: "p-0 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus h-20 w-20 dc__tab-focus",
        onClick: s,
        "aria-label": "close modal",
        "data-testid": "close modal",
        children: /* @__PURE__ */ e.jsx(As, { className: "icon-dim-20 dc__no-shrink scn-6" })
      }
    )
  ] }), x = m || o || !!l;
  return /* @__PURE__ */ e.jsx(cs, { className: "", onEscape: s, close: s, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "bg__primary dc__position-fixed dc__right-0 dc__top-0 h-100 flexbox-col dc__content-space w-800",
      onClick: Le,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__content-space dc__overflow-auto", children: [
          h(),
          /* @__PURE__ */ e.jsx(
            Ke,
            {
              isLoading: o,
              progressingProps: {
                pageLoader: !0
              },
              error: l,
              errorScreenManagerProps: {
                code: l?.code,
                redirectURL: se.NETWORK_STATUS_INTERFACE,
                reload: c
              },
              children: /* @__PURE__ */ e.jsx(
                fR,
                {
                  handleChange: f,
                  controllerForm: a,
                  controllerFormError: d
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-end dc__align-items-center py-16 px-20 dc__gap-12 dc__border-top", children: [
          /* @__PURE__ */ e.jsx("button", { type: "button", className: "h-36 cta cancel flex", onClick: s, children: "Cancel" }),
          /* @__PURE__ */ e.jsx(
            Vi,
            {
              isLoading: m,
              onClick: _,
              rootClassName: `h-36 cta flex ${x ? "dc__disabled" : ""}`,
              type: "button",
              disabled: x,
              children: n ? "Save" : "Add"
            }
          )
        ] })
      ]
    }
  ) });
}, hR = ({
  handleClose: t,
  isLoadingSystemController: s,
  systemControllerMap: n,
  systemControllerError: a,
  refetchDetails: r
}) => {
  const { controllerId: o } = Ue(), i = n?.[+o || 0], l = i?.systemControllerName || "", c = i?.systemControllerDetails, d = Q(() => s || a || !c ? "" : JSON.stringify(c, null, 2), [s, a, i]), p = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space py-12 px-20 dc__gap-8 dc__border-bottom dc__align-items-center", children: [
    /* @__PURE__ */ e.jsxs("h2", { className: "m-0 cn-9 fs-16 fw-6 lh-24 dc__truncate flex-grow-1", children: [
      "System Controller ",
      s ? /* @__PURE__ */ e.jsx("span", { className: "dc__loading-dots cn-0" }) : `'${l}'`
    ] }),
    /* @__PURE__ */ e.jsx(
      "button",
      {
        type: "button",
        className: "p-0 flex dc__no-border dc__no-background dc__no-shrink dc__outline-none-imp dc__tab-focus h-20 w-20 dc__tab-focus",
        onClick: t,
        "aria-label": "close modal",
        "data-testid": "close modal",
        children: /* @__PURE__ */ e.jsx(As, { className: "icon-dim-20 dc__no-shrink scn-6" })
      }
    )
  ] }), m = () => c ? /* @__PURE__ */ e.jsx(Gt, { readOnly: !0, mode: Ts.JSON, value: d, theme: qc.dark, height: "100%" }) : /* @__PURE__ */ e.jsx(
    _e,
    {
      title: "Unable to retrieve data for this system controller",
      subTitle: "No data available for this system controller"
    }
  );
  return /* @__PURE__ */ e.jsx(cs, { className: "", onEscape: t, close: t, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "bg__primary dc__position-fixed dc__right-0 dc__top-0 h-100 flexbox-col dc__content-space w-800",
      onClick: Le,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__content-space dc__overflow-auto", children: [
          p(),
          /* @__PURE__ */ e.jsx(
            Ke,
            {
              isLoading: s,
              progressingProps: {
                pageLoader: !0
              },
              error: a,
              errorScreenManagerProps: {
                code: a?.code,
                reload: r,
                redirectURL: se.NETWORK_STATUS_INTERFACE
              },
              children: m()
            }
          )
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__content-end dc__align-items-center py-16 px-20 dc__gap-12 dc__border-top", children: /* @__PURE__ */ e.jsx("button", { className: "h-36 cta flex", onClick: t, type: "button", children: "Okay" }) })
      ]
    }
  ) });
}, gR = {
  ...mr.columnConfig,
  subCloudColumns: JSON.stringify(mr.columnConfig.subCloudColumns, null, 2),
  systemControllerColumns: JSON.stringify(
    mr.columnConfig.systemControllerColumns,
    null,
    2
  )
}, xR = ["field", "label"];
var Zr = /* @__PURE__ */ ((t) => (t.SYSTEM_CONTROLLER = "System controller", t.SUB_CLOUD = "Sub cloud", t))(Zr || {});
const ER = ({ tabName: t, currentTab: s, handleTabSwitch: n }) => {
  const a = t === s, r = () => {
    a || n(t);
  };
  return /* @__PURE__ */ e.jsx(
    "button",
    {
      className: `mr-16 dc__tab-focus pr-0 pl-0 pt-0 flexbox dc__align-items-center dc__no-border dc__no-background h-100 mb-neg-1 ${a ? "cb-5 fs-13 fw-6 dc__border-bottom-2--b5" : "cn-9 fs-13 fw-4 dc__hover-color-b500 mb-0"}`,
      onClick: r,
      type: "button",
      children: t
    }
  );
}, CR = ({ currentTab: t, handleTabSwitch: s }) => {
  const n = Object.values(Zr);
  return /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-end w-100 h-28", children: n.map((a) => /* @__PURE__ */ e.jsx(
    ER,
    {
      tabName: a,
      currentTab: t,
      handleTabSwitch: s
    },
    a
  )) });
}, bR = async (t) => {
  const s = {
    id: t.id,
    key: pl.COLUMN_TEMPLATE,
    value: JSON.stringify({
      systemControllerColumns: JSON.parse(t.systemControllerColumns),
      subCloudColumns: JSON.parse(t.subCloudColumns)
    })
  };
  return t.id ? Bt(Ws.ATTRIBUTES_UPDATE, s) : we(Ws.ATTRIBUTES_CREATE, s);
}, NR = ({
  handleClose: t,
  handleSuccess: s,
  isLoadingConfig: n,
  refetchConfig: a,
  configError: r,
  savedColumnConfig: o
}) => {
  const [i, l] = v(
    Zr.SYSTEM_CONTROLLER
  ), [c, d] = v(!1), [p, m] = v(
    structuredClone(gR)
  );
  J(() => {
    !n && !r && o && m({
      ...o,
      subCloudColumns: JSON.stringify(o.subCloudColumns, null, 2),
      systemControllerColumns: JSON.stringify(o.systemControllerColumns, null, 2)
    });
  }, [n, a, r]);
  const u = (C) => {
    m((b) => ({
      ...b,
      [i === Zr.SYSTEM_CONTROLLER ? "systemControllerColumns" : "subCloudColumns"]: C
    }));
  }, f = () => i === Zr.SYSTEM_CONTROLLER ? p.systemControllerColumns : p.subCloudColumns, _ = (C) => {
    try {
      const b = JSON.parse(C);
      if (!Array.isArray(b) || !b.length)
        return {
          isValid: !1,
          message: "Config must be a valid array with at least one column"
        };
      const I = [];
      if (b.forEach((S, L) => {
        if (typeof S == "object" && !Array.isArray(S)) {
          const R = xR.reduce((y, M) => (S?.[M] || y.push(M), y), []);
          R.length > 0 && I.push(
            `${R.join(",")} values are missing from object at index - ${L}`
          );
        } else
          I.push(`Please provide valid object at index - ${L}`);
      }), I?.length > 0)
        return {
          isValid: !1,
          message: I[0]
        };
      const T = [], A = {};
      return b.forEach((S) => {
        A[S.field] && T.push(S.field), A[S.field] = !0;
      }), T.length > 0 ? {
        isValid: !1,
        message: `Following field values are duplicated: ${T.join(",")}`
      } : {
        isValid: !0
      };
    } catch (b) {
      return {
        isValid: !1,
        message: b.message || "Please ensure valid format."
      };
    }
  }, h = (C) => {
    const { isValid: b, message: N } = _(f());
    if (!b) {
      Z.showToast({
        variant: ee.error,
        description: N || "Please ensure data is valid before switching tabs"
      });
      return;
    }
    l(C);
  }, x = async () => {
    try {
      const { isValid: C, message: b } = _(p.systemControllerColumns);
      if (!C) {
        Z.showToast({
          variant: ee.error,
          description: b
        });
        return;
      }
      const { isValid: N, message: I } = _(
        p.subCloudColumns
      );
      if (!N) {
        Z.showToast({
          variant: ee.error,
          description: I
        });
        return;
      }
      d(!0), await bR(p), Z.showToast({
        variant: ee.success,
        description: "Config saved successfully"
      }), s(), t(), d(!1);
    } catch (C) {
      V(C), d(!1);
    }
  }, g = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col px-20 dc__border-bottom", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-8 py-12 dc__align-items-center", children: [
      /* @__PURE__ */ e.jsx("h2", { className: "m-0 cn-9 fs-16 fw-6 lh-24 dc__truncate", children: "Customize columns" }),
      /* @__PURE__ */ e.jsx(
        "button",
        {
          type: "button",
          className: "p-0 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus h-20 w-20 dc__tab-focus",
          onClick: t,
          "aria-label": "close modal",
          "data-testid": "close modal",
          children: /* @__PURE__ */ e.jsx(As, { className: "icon-dim-20 dc__no-shrink scn-6" })
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(CR, { currentTab: i, handleTabSwitch: h })
  ] }), E = c || n || !!r;
  return /* @__PURE__ */ e.jsx(cs, { className: "", onEscape: t, close: t, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "bg__primary dc__position-fixed dc__right-0 dc__top-0 h-100 flexbox-col dc__content-space w-800",
      onClick: Le,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__content-space dc__overflow-auto", children: [
          g(),
          /* @__PURE__ */ e.jsx(
            Ke,
            {
              isLoading: n,
              progressingProps: {
                pageLoader: !0
              },
              error: r,
              errorScreenManagerProps: {
                code: r?.code,
                reload: a,
                redirectURL: se.NETWORK_STATUS_INTERFACE
              },
              children: /* @__PURE__ */ e.jsx(
                Gt,
                {
                  mode: Ts.JSON,
                  value: f(),
                  theme: qc.dark,
                  onChange: u,
                  height: "100%"
                },
                i
              )
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-end dc__align-items-center py-16 px-20 dc__gap-12 dc__border-top", children: [
          /* @__PURE__ */ e.jsx("button", { type: "button", className: "h-36 cta cancel flex", onClick: t, children: "Cancel" }),
          /* @__PURE__ */ e.jsx(
            Vi,
            {
              isLoading: c,
              onClick: x,
              rootClassName: `h-36 cta flex ${E ? "dc__disabled" : ""}`,
              type: "button",
              disabled: E,
              children: "Save"
            }
          )
        ] })
      ]
    }
  ) });
}, TR = () => {
  const t = Te(), s = () => {
    t.push(Ee.NETWORK_STATUS_CUSTOMIZE_COLUMNS);
  };
  return /* @__PURE__ */ e.jsxs("button", { className: "cta cancel h-32 flex dc__gap-4", type: "button", onClick: s, children: [
    /* @__PURE__ */ e.jsx(Oo, { className: "dc__no-shrink icon-dim-14 scn-7 dc__fill-transparent" }),
    "Columns"
  ] });
}, Nu = ({
  field: t,
  label: s,
  width: n,
  isSortable: a,
  sortOrder: r,
  sortBy: o,
  handleSorting: i
}) => {
  const l = () => {
    i(t);
  };
  return /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center", style: { width: `${n}px` }, children: /* @__PURE__ */ e.jsx(
    Ne,
    {
      isSorted: o === t,
      sortOrder: r,
      title: s,
      triggerSorting: l,
      disabled: !1,
      isSortable: a,
      showTippyOnTruncate: !0
    }
  ) });
}, Ja = (t = !1) => `flexbox dc__transparent dc__hover-n50 dc__align-items-center py-6 px-8 w-100 dc__gap-8 ${t ? "dc__disabled" : ""}`, Tu = ({
  isSystemController: t,
  handleShowDeleteModal: s,
  id: n,
  analyze: a,
  manage: r,
  deploy: o
}) => {
  const i = Te(), l = (_) => {
    window.open(_, "_blank", "noopener,noreferrer");
  }, c = () => {
    l(a);
  }, d = () => {
    l(r);
  }, p = () => {
    l(o);
  }, m = () => {
    i.push(`${Ee.NETWORK_STATUS_CONTROLLER_EDIT}/${n}`);
  }, u = () => {
    i.push(`${Ee.NETWORK_STATUS_CONTROLLER_DETAILS}/${n}`);
  }, f = () => {
    s();
  };
  return /* @__PURE__ */ e.jsxs(pr, { autoPosition: !0, autoClose: !0, children: [
    /* @__PURE__ */ e.jsx(
      pr.Button,
      {
        isKebab: !0,
        rootClassName: "icon-dim-24 dc__no-shrink p-4 dc__no-background dc__no-border dc__outline-none-imp flex dc__tab-focus dc__hover-n50",
        children: /* @__PURE__ */ e.jsx(T_, { className: "flex icon-dim-16 dc__no-shrink icon-color-n6" })
      }
    ),
    /* @__PURE__ */ e.jsxs(pr.Body, { rootClassName: "br-4 py-4 w-120 flexbox-col dc__gap-4 dc__overflow-hidden dc__border dc__box-shadow--menu", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
        /* @__PURE__ */ e.jsxs(
          "button",
          {
            type: "button",
            className: Ja(!a),
            onClick: c,
            disabled: !a,
            children: [
              /* @__PURE__ */ e.jsx(bi, { className: "icon-dim-16 dc__no-shrink fcn-8" }),
              /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Analyze" })
            ]
          }
        ),
        /* @__PURE__ */ e.jsxs(
          "button",
          {
            type: "button",
            className: Ja(!r),
            onClick: d,
            disabled: !r,
            children: [
              /* @__PURE__ */ e.jsx(Oo, { className: "icon-dim-16 dc__no-shrink scn-8" }),
              /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Manage" })
            ]
          }
        ),
        /* @__PURE__ */ e.jsxs(
          "button",
          {
            type: "button",
            className: Ja(!o),
            onClick: p,
            disabled: !o,
            children: [
              /* @__PURE__ */ e.jsx(dd, { className: "icon-dim-16 scn-8 dc__no-shrink" }),
              /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Deploy" })
            ]
          }
        )
      ] }),
      t && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom-n1" }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
          /* @__PURE__ */ e.jsxs(
            "button",
            {
              type: "button",
              className: Ja(),
              onClick: u,
              children: [
                /* @__PURE__ */ e.jsx(m_, { className: "icon-dim-16 dc__no-shrink scn-8" }),
                /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Details" })
              ]
            }
          ),
          /* @__PURE__ */ e.jsxs("button", { type: "button", className: Ja(), onClick: m, children: [
            /* @__PURE__ */ e.jsx(Fs, { className: "icon-dim-16 scn-8 dc__no-shrink" }),
            /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Edit" })
          ] }),
          /* @__PURE__ */ e.jsxs("button", { type: "button", className: Ja(), onClick: f, children: [
            /* @__PURE__ */ e.jsx(ts, { className: "icon-dim-16 scr-5 dc__no-shrink" }),
            /* @__PURE__ */ e.jsx("span", { className: "cr-5 fs-13 fw-4 lh-20", children: "Delete" })
          ] })
        ] })
      ] })
    ] })
  ] });
}, IR = ({
  id: t,
  reloadData: s,
  controllerData: n,
  isOpen: a,
  handleToggleControllerExpansion: r,
  searchText: o,
  systemControllerColumnConfig: i,
  subCloudColumnConfig: l,
  subCloudPageSize: c,
  handleChangeSubCloudPageNumber: d,
  subCloudPageNumber: p
}) => {
  const [m, u] = v(!1), f = () => {
    u(!0);
  }, _ = () => {
    u(!1);
  }, h = async () => {
    await uR(t), s();
  }, x = () => {
    r(t);
  }, {
    actionLinks: { analyze: g, manage: E, deploy: C },
    subclouds: b,
    activeController: N,
    systemControllerName: I
  } = n, T = b?.length || 0, A = T > c, S = b?.slice(c * (p - 1), c * p) || [], L = (y) => {
    d(t, y);
  }, R = () => S?.length ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "display-grid network-status-interface__controller-list-row dc__border-bottom dc_width-max-content mw-100p", children: [
      /* @__PURE__ */ e.jsx("div", { className: "dc__border-right flexbox dc__align-items-center dc__gap-4 pl-28 pr-8 cn-7 fs-12 fw-6 lh-18 dc__position-sticky dc__zi-4 dc__left-0 bg__secondary", children: /* @__PURE__ */ e.jsx("div", { className: "pl-24 dc__border-left py-8 flexbox dc__align-items-center dc__gap-4", children: /* @__PURE__ */ e.jsx("span", { className: "dc__uppercase dc__truncate", children: "Sub cloud" }) }) }),
      /* @__PURE__ */ e.jsx("div", { className: "flexbox flex-grow-1 px-20 py-8 dc__gap-12 cn-7 fw-6 lh-18 bg__secondary", children: l.map((y, M) => {
        const P = y.label;
        return /* @__PURE__ */ e.jsx(
          "div",
          {
            style: { width: `${y.width}px` },
            children: /* @__PURE__ */ e.jsx(
              lt,
              {
                content: P,
                arrow: !1,
                className: "default-tt dc__word-break dc__mxw-200",
                children: /* @__PURE__ */ e.jsx("span", { className: "dc__uppercase dc__truncate dc_max-width__max-content", children: P })
              }
            )
          },
          `sub-cloud-${t}_${M}-${y.field}-header`
        );
      }) })
    ] }),
    S.map((y, M) => /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "display-grid network-status-interface__controller-list-row dc__border-bottom dc_width-max-content mw-100p dc__hover-n50 bg__secondary",
        children: [
          /* @__PURE__ */ e.jsx("div", { className: "pl-28 pr-8 flexbox dc__content-space dc__gap-16 dc__position-sticky sticky-header-hover dc__zi-4 dc__left-0 bg__secondary flex-grow-1 dc__border-right", children: /* @__PURE__ */ e.jsxs("div", { className: "py-10 pl-24 dc__border-left flexbox dc__content-space dc__gap-16 flex-grow-1", children: [
            /* @__PURE__ */ e.jsx(
              lt,
              {
                className: "default-tt dc__mxw-200 dc__word-break",
                arrow: !1,
                content: y.name || "-",
                children: /* @__PURE__ */ e.jsx(
                  "span",
                  {
                    className: "dc__truncate cn-9 fs-13 fw-4 lh-20",
                    dangerouslySetInnerHTML: {
                      __html: ta.sanitize(
                        aa({
                          searchText: o,
                          text: y.name || "-",
                          highlightClasses: "dc__search-highlight-bg"
                        })
                      )
                    }
                  }
                )
              }
            ),
            /* @__PURE__ */ e.jsx(
              Tu,
              {
                isSystemController: !1,
                analyze: g,
                manage: E,
                deploy: C
              }
            )
          ] }) }),
          /* @__PURE__ */ e.jsx("div", { className: "flexbox flex-grow-1 px-20 py-12 dc__gap-12", children: l.map((P, U) => {
            const { field: G } = P;
            if (!(y[G] !== void 0))
              return /* @__PURE__ */ e.jsx(
                jl,
                {
                  style: {
                    width: `${P.width}px`
                  }
                },
                `sub-cloud-row-field-${G}-${t}_${U}`
              );
            const oe = y[G] || "-";
            return /* @__PURE__ */ e.jsx(
              "div",
              {
                style: {
                  width: `${P.width}px`
                },
                children: /* @__PURE__ */ e.jsx(
                  lt,
                  {
                    content: oe,
                    arrow: !1,
                    className: "default-tt dc__mxw-200 dc__word-break",
                    children: /* @__PURE__ */ e.jsx("span", { className: "dc__truncate cn-9 fs-13 fw-4 lh-20 dc_max-width__max-content", children: oe })
                  }
                )
              },
              `sub-cloud-row-field-${G}-${t}_${U}`
            );
          }) })
        ]
      },
      `subcloud-row-${t}_${M}-${y.name || ""}`
    )),
    A && /* @__PURE__ */ e.jsx("div", { className: "display-grid network-status-interface__sub-cloud-pagination-container dc__border-bottom", children: /* @__PURE__ */ e.jsx(
      vo,
      {
        size: T,
        pageSize: c,
        offset: c * (p - 1),
        changePage: L,
        isPageSizeFix: !0,
        rootClassName: "flexbox dc__content-space bg__primary px-20 m-0 dc__align-items-center network-status-interface__pagination-container dc__position-sticky dc__zi-4 dc__left-0"
      }
    ) })
  ] }) : /* @__PURE__ */ e.jsx("div", { className: "display-grid network-status-interface__controller-list-row dc__border-bottom dc_width-max-content mw-100p bg__secondary dc__hover-n50", children: /* @__PURE__ */ e.jsx("div", { className: "dc__border-right flexbox dc__align-items-center dc__gap-4 pl-28 pr-8 cn-7 fs-13 fw-4 lh-20 sticky-header-hover dc__position-sticky dc__zi-4 dc__left-0 bg__secondary", children: /* @__PURE__ */ e.jsx("div", { className: "pl-24 dc__border-left py-8 flexbox dc__align-items-center dc__gap-4", children: /* @__PURE__ */ e.jsx("span", { children: o ? "No matching sub cloud found" : "No sub cloud found" }) }) }) });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc_width-max-content mw-100p", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "display-grid network-status-interface__controller-list-row dc__border-bottom-n1 dc_width-max-content mw-100p dc__visible-hover dc__visible-hover--parent dc__hover-n50", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "pl-16 pr-8 py-10 flexbox dc__gap-12 dc__content-space flex-grow-1 dc__border-right cn-9 fs-13 fw-4 lh-20 sticky-header-hover dc__position-sticky dc__zi-4 dc__left-0 bg__primary", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-12", children: [
            !a && /* @__PURE__ */ e.jsx(pN, { className: "icon-dim-24 scn-6 dc__no-shrink dc__visible-hover--hide-child" }),
            /* @__PURE__ */ e.jsx(
              "button",
              {
                className: `dc__transparent icon-dim-24 ${a ? "" : "dc__visible-hover--child"}`,
                type: "button",
                onClick: x,
                "aria-label": `Toggle ${I || ""} expansion`,
                children: /* @__PURE__ */ e.jsx(
                  zi,
                  {
                    className: `dc__no-shrink icon-dim-20 dc__transition--transform fcn-6 ${a ? "" : "dc__flip-90--neg"}`
                  }
                )
              }
            ),
            I ? /* @__PURE__ */ e.jsx(
              lt,
              {
                content: I,
                arrow: !1,
                className: "default-tt dc__word-break dc__mxw-200",
                children: /* @__PURE__ */ e.jsx(
                  "span",
                  {
                    className: "dc__truncate cn-9 fs-13 fw-4 lh-20",
                    dangerouslySetInnerHTML: {
                      __html: ta.sanitize(
                        aa({
                          searchText: o,
                          text: I,
                          highlightClasses: "dc__search-highlight-bg"
                        })
                      )
                    }
                  }
                )
              }
            ) : /* @__PURE__ */ e.jsx(jl, {})
          ] }),
          /* @__PURE__ */ e.jsx(
            Tu,
            {
              isSystemController: !0,
              handleShowDeleteModal: f,
              id: t,
              analyze: g,
              manage: E,
              deploy: C
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox flex-grow-1 px-20 py-12 dc__gap-12", children: [
          /* @__PURE__ */ e.jsx("span", { className: "w-180 cn-9 fs-13 fw-4 lh-20 dc__truncate", children: T }),
          i.map((y, M) => {
            const { field: P } = y;
            if (!(N?.[P] !== void 0))
              return /* @__PURE__ */ e.jsx(
                jl,
                {
                  style: {
                    width: `${y.width}px`
                  }
                },
                `system-controller-row-field-${P}-${t}_${M}`
              );
            const G = N[P] || "-";
            return /* @__PURE__ */ e.jsx(
              "div",
              {
                style: {
                  width: `${y.width}px`
                },
                children: /* @__PURE__ */ e.jsx(lt, { content: G, arrow: !1, className: "default-tt dc__word-break", children: /* @__PURE__ */ e.jsx(
                  "span",
                  {
                    className: "dc__truncate cn-9 fs-13 fw-4 lh-20 dc_max-width__max-content",
                    children: G
                  },
                  `system-controller-row-field-${P}-${t}_${M}`
                ) })
              }
            );
          })
        ] })
      ] }),
      a && R()
    ] }),
    m && /* @__PURE__ */ e.jsx(
      Sr,
      {
        title: I,
        component: "system controller",
        subtitle: "System controller will be removed from Devtron.",
        closeConfirmationModal: _,
        onDelete: h,
        successToastMessage: "System controller deleted successfully",
        children: /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-13 cn-7", children: "Are you sure?" })
      }
    )
  ] });
}, vR = () => /* @__PURE__ */ e.jsx(Ph, {}), AR = () => {
  const { path: t } = Wi(), s = Te(), n = de(new AbortController()), a = () => es(
    () => cR({ signal: n.current.signal }),
    n
  ), [
    r,
    o,
    i,
    l
  ] = ne(a), c = r || Pe(i), [d, p] = v({}), [m, u] = v({}), f = () => {
    u({});
  }, _ = (xe, Se) => {
    u((ze) => ({
      ...ze,
      [xe]: Se
    }));
  }, {
    sortBy: h,
    sortOrder: x,
    handleSorting: g,
    searchKey: E,
    handleSearch: C,
    clearFilters: b,
    pageSize: N,
    offset: I,
    changePageSize: T,
    changePage: A,
    subCloudPageSize: S
  } = _t({
    initialSortKey: mn.SYSTEM_CONTROLLER_NAME,
    parseSearchParams: oR
  }), L = !!E || !!I, R = Q(() => {
    try {
      if (!o)
        return structuredClone(mr);
      const { systemControllerMap: xe, ids: Se, columnConfig: ze } = o, nt = Se.reduce(
        (At, Lt) => {
          const hs = xe[Lt], { systemControllerName: _s } = hs, ys = E.toLowerCase(), $n = hs.subclouds?.filter(
            (fa) => fa?.name && fa.name.toLowerCase().includes(ys)
          ) || [];
          if (!$n.length && !(_s && _s.toLowerCase().includes(ys)))
            return At;
          const ml = {
            ...hs,
            subclouds: $n
          };
          return {
            ...At,
            [Lt]: ml
          };
        },
        {}
      ), K = ze.systemControllerColumns.find(
        (At) => At.field === h
      ), te = h === mn.SYSTEM_CONTROLLER_NAME || h === mn.NUMBER_OF_SUB_CLOUDS, De = !!K || te, We = !!K && !K.isSortable;
      if (!De || !h || We)
        return {
          ...o,
          systemControllerMap: nt,
          ids: Se
        };
      const pe = te ? rR(h) : K?.type || "string", Ye = Object.keys(nt).map(Number);
      return Ye.sort((At, Lt) => {
        if (te) {
          if (h === mn.SYSTEM_CONTROLLER_NAME)
            return Ce(
              nt[At].systemControllerName || "",
              nt[Lt].systemControllerName || "",
              x
            );
          if (h === mn.NUMBER_OF_SUB_CLOUDS) {
            const ys = nt[At].subclouds?.length || 0, $n = nt[Lt].subclouds?.length || 0;
            return no(ys, $n, x);
          }
          return 0;
        }
        const hs = nt[+At].activeController?.[h], _s = nt[+Lt].activeController?.[h];
        return pe === "number" ? no(hs || 0, _s || 0, x) : Ce(
          hs ? JSON.stringify(hs) : "",
          _s ? JSON.stringify(_s) : "",
          x
        );
      }), {
        ...o,
        systemControllerMap: nt,
        ids: Ye
      };
    } catch (xe) {
      return Z.showToast({
        variant: ee.error,
        description: "Something went wrong while sorting/searching the data"
      }), ka(xe), o;
    }
  }, [
    E,
    h,
    x,
    o,
    r,
    i
  ]), { showPagination: y, currentPageIds: M } = Q(() => {
    if (!R?.ids)
      return {
        showPagination: !1,
        currentPageIds: []
      };
    const xe = structuredClone(R.ids);
    return {
      showPagination: xe.length > N,
      currentPageIds: xe.slice(I, I + N)
    };
  }, [R.ids, N, I]);
  J(
    () => () => {
      n.current.abort();
    },
    []
  );
  const P = () => {
    s.push(t);
  }, U = () => {
    g(mn.SYSTEM_CONTROLLER_NAME);
  }, G = () => {
    l();
  }, H = Q(() => R?.ids ? R.ids.every((xe) => d[xe]) : !1, [R?.ids, d]), oe = () => {
    if (!R?.ids)
      return;
    if (H) {
      p({});
      return;
    }
    const xe = R.ids.reduce(
      (Se, ze) => ({ ...Se, [ze]: !0 }),
      {}
    );
    p(xe);
  }, ae = (xe) => {
    p((Se) => {
      if (Se[xe]) {
        const ze = { ...Se };
        return delete ze[xe], ze;
      }
      return { ...Se, [xe]: !0 };
    });
  }, re = () => {
    f(), b();
  }, k = (xe) => {
    f(), C(xe);
  }, D = (xe) => /* @__PURE__ */ e.jsxs("div", { className: "display-grid network-status-interface__controller-list-row dc__border-bottom dc_width-max-content mw-100p", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "pl-16 pr-8 py-6 flexbox dc__gap-12 flex-grow-1 dc__border-right cn-7 fs-12 fw-6 lh-20 dc__position-sticky dc__zi-4 dc__left-0 bg__primary", children: [
      /* @__PURE__ */ e.jsx(
        "button",
        {
          className: `dc__transparent icon-dim-24 ${c ? "dc__disabled" : ""}`,
          type: "button",
          onClick: oe,
          "aria-label": "Toggle all controllers expansion",
          disabled: c,
          children: /* @__PURE__ */ e.jsx(
            zi,
            {
              className: `dc__no-shrink icon-dim-20 dc__transition--transform fcn-6 ${H ? "" : "dc__flip-90--neg"}`
            }
          )
        }
      ),
      xe ? /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading h-20 w-236" }) : /* @__PURE__ */ e.jsx(
        Ne,
        {
          isSorted: h === mn.SYSTEM_CONTROLLER_NAME,
          sortOrder: x,
          title: "System Controller",
          triggerSorting: U,
          disabled: !1
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox flex-grow-1 px-20 py-8 dc__gap-12 cn-7 fs-12 fw-6 lh-20", children: xe ? Array(Eu).fill(0).map((Se, ze) => /* @__PURE__ */ e.jsx(
      "div",
      {
        className: "flexbox w-150",
        children: /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading h-20 w-100px" })
      },
      `system-controller-header-column-shimmer-${ze}`
    )) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(
        Nu,
        {
          field: mn.NUMBER_OF_SUB_CLOUDS,
          label: "NO. OF SUB CLOUDS",
          width: 180,
          isSortable: !0,
          sortOrder: x,
          sortBy: h,
          handleSorting: g
        }
      ),
      R.columnConfig.systemControllerColumns.map(
        ({ field: Se, label: ze, width: nt, isSortable: K }, te) => /* @__PURE__ */ e.jsx(
          Nu,
          {
            field: Se,
            label: ze,
            width: nt,
            isSortable: K,
            sortOrder: x,
            sortBy: h,
            handleSorting: g
          },
          `system-controller-${te}-${Se}-header`
        )
      )
    ] }) })
  ] }), F = i && !Pe(i), q = (xe) => /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "display-grid network-status-interface__controller-list-row dc__border-bottom-n1",
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "py-10 pl-16 pr-8 flexbox dc__gap-12 dc__border-right dc__align-items-center", children: [
          /* @__PURE__ */ e.jsx("div", { className: "icon-dim-24 dc__no-shrink shimmer-loading" }),
          /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1 shimmer-loading h-20" })
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "flexbox flex-grow-1 px-20 py-12 dc__gap-12", children: Array(Eu).fill(0).map((Se, ze) => /* @__PURE__ */ e.jsx(
          "div",
          {
            className: "flexbox w-150",
            children: /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading h-20 w-150" })
          },
          `system-controller-shimmer-column-${ze}`
        )) })
      ]
    },
    `system-controller-shimmer-%${xe}`
  ), be = () => c ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
    D(!0),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: Array(5).fill(0).map((xe, Se) => q(Se)) })
  ] }) : F ? /* @__PURE__ */ e.jsx(
    Xe,
    {
      code: i.code,
      reload: l
    }
  ) : M?.length ? /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: /* @__PURE__ */ e.jsxs("div", { className: "mw-100p dc_width-max-content", children: [
    D(),
    M.map((xe) => /* @__PURE__ */ e.jsx(
      IR,
      {
        id: xe,
        reloadData: l,
        controllerData: R.systemControllerMap[xe],
        isOpen: !!d[xe],
        handleToggleControllerExpansion: ae,
        searchText: E,
        subCloudColumnConfig: R.columnConfig.subCloudColumns,
        systemControllerColumnConfig: R.columnConfig.systemControllerColumns,
        subCloudPageSize: S,
        handleChangeSubCloudPageNumber: _,
        subCloudPageNumber: m[xe] || 1
      },
      `${xe}-system-controller-list-row`
    ))
  ] }) }) : L ? /* @__PURE__ */ e.jsx(
    qt,
    {
      handleClearFilters: re,
      imageType: bs.Large,
      classname: "flex-grow-1"
    }
  ) : /* @__PURE__ */ e.jsx(
    _e,
    {
      title: "No System Controllers",
      subTitle: "Add a system controller to view its subclouds",
      classname: "flex-grow-1",
      isButtonAvailable: !0,
      imageType: bs.Large,
      image: dN,
      renderButton: vR
    }
  ), fe = !c && !L && !R?.ids?.length, Ge = F || fe;
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1", children: [
      !Ge && /* @__PURE__ */ e.jsxs("div", { className: "py-12 px-20 flexbox dc__align-items-center dc__content-space w-100", children: [
        /* @__PURE__ */ e.jsx(
          Wt,
          {
            containerClassName: "w-250",
            inputProps: {
              placeholder: "Search controller or subcloud"
            },
            initialSearchText: E,
            handleEnter: k
          }
        ),
        /* @__PURE__ */ e.jsx(TR, {})
      ] }),
      be()
    ] }),
    y && /* @__PURE__ */ e.jsx(
      vo,
      {
        size: R.ids.length,
        pageSize: N,
        offset: I,
        changePage: A,
        changePageSize: T,
        isPageSizeFix: !0,
        rootClassName: "flexbox dc__content-space bg__primary px-20 m-0 dc__border-top dc__align-items-center dc__position-sticky dc__bottom-0 dc__zi-5 network-status-interface__pagination-container"
      }
    ),
    /* @__PURE__ */ e.jsxs(Vt, { children: [
      /* @__PURE__ */ e.jsx(ge, { path: Ee.NETWORK_STATUS_CONTROLLER_CREATE, exact: !0, children: /* @__PURE__ */ e.jsx(
        bu,
        {
          handleClose: P,
          handleSuccess: G
        }
      ) }),
      /* @__PURE__ */ e.jsx(ge, { path: Y.NETWORK_STATUS_CONTROLLER_EDIT, exact: !0, children: /* @__PURE__ */ e.jsx(
        bu,
        {
          handleClose: P,
          handleSuccess: G
        }
      ) }),
      /* @__PURE__ */ e.jsx(ge, { path: Ee.NETWORK_STATUS_CUSTOMIZE_COLUMNS, exact: !0, children: /* @__PURE__ */ e.jsx(
        NR,
        {
          handleClose: P,
          handleSuccess: G,
          isLoadingConfig: r,
          refetchConfig: l,
          configError: i,
          savedColumnConfig: R?.columnConfig
        }
      ) }),
      /* @__PURE__ */ e.jsx(ge, { path: Y.NETWORK_STATUS_CONTROLLER_DETAILS, exact: !0, children: /* @__PURE__ */ e.jsx(
        hR,
        {
          handleClose: P,
          isLoadingSystemController: r,
          refetchDetails: l,
          systemControllerError: i,
          systemControllerMap: R?.systemControllerMap
        }
      ) })
    ] })
  ] });
}, l2 = () => {
  const { isSuperAdmin: t } = Is(), s = () => t ? /* @__PURE__ */ e.jsx(Ph, {}) : null, n = () => t ? /* @__PURE__ */ e.jsx(AR, {}) : /* @__PURE__ */ e.jsx(Xe, { code: Ns.PERMISSION_DENIED });
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 h-100 bg__primary dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsx(Yi, { headerName: "Network Status Interface", renderActionButtons: s }),
    n()
  ] });
};
var Nc = /* @__PURE__ */ ((t) => (t.VulnerabilityFound = "10001", t.ApprovalNodeFail = "10002", t.FilteringConditionFail = "10003", t.DeploymentWindowFail = "10004", t.PreCDDoesNotExists = "10005", t.PostCDDoesNotExists = "10006", t.ArtifactNotAvailable = "10007", t.MandatoryPluginNotAdded = "10009", t.MandatoryTagNotAdded = "10010", t.ExceptionUser = "10013", t.CannotTrigger = "CannotTrigger", t.NotAuthorized = "403", t.CanTriggerInDeploymentWindow = "10008", t.CanTrigger = "200", t))(Nc || {});
function SR({ userApprovalMetadata: t }) {
  return /* @__PURE__ */ e.jsxs("div", { className: "deployment-approval-container pl-20 pr-20 pt-20", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "deployment-status-breakdown-row pt-8 pb-8 pl-8 pr-8 bg__primary bw-1 border-collapse en-2", children: [
      /* @__PURE__ */ e.jsx(qs, { className: "icon-dim-20 green-tick" }),
      /* @__PURE__ */ e.jsx("span", { className: "ml-12 mr-12 fs-13", children: /* @__PURE__ */ e.jsxs("span", { children: [
        "Approval requested by ",
        t.requestedUserData.userEmail
      ] }) })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "vertical-connector" }),
    !!t.approvalConfigData.currentCount && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsxs("div", { className: "deployment-status-breakdown-row pt-8 pb-8 pl-8 pr-8 bg__primary bw-1 border-collapse flexbox dc__gap-12 en-2", children: [
        /* @__PURE__ */ e.jsx(qs, { className: "icon-dim-20 green-tick" }),
        /* @__PURE__ */ e.jsx(
          M_,
          {
            userApprovalMetadata: t,
            showCount: !0,
            hideApprovalCheckIcon: !0,
            showInfoIcon: !0
          }
        )
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "vertical-connector" })
    ] })
  ] });
}
const c2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: SR
}, Symbol.toStringTag, { value: "Module" }));
var $d = /* @__PURE__ */ ((t) => (t.CUSTOM_PANEL = "CustomPanel", t))($d || {});
const Uh = Symbol("expanded"), yR = Symbol("collapsed"), Iu = {
  GUI: "gui",
  JSON: "json"
}, LR = "Key not available", vu = Object.values($d).reduce(
  (t, s) => (t[s] = !0, t),
  {}
);
var pi = /* @__PURE__ */ ((t) => (t.date = "date", t.dateTime = "date-time", t.uri = "uri", t))(pi || {});
const d2 = {
  [ie.job]: "Job",
  [ie.devtronApplication]: "Devtron Application",
  [ie.helmChart]: "Helm Applications",
  [ie.cluster]: "Cluster",
  [ie.release]: "Release",
  [ie.tenant]: "Tenant"
}, p2 = [
  { value: Iu.GUI, label: "GUI" },
  { value: Iu.JSON, label: "JSON" }
], jR = (t) => {
  const s = nr(t);
  return (
    // Excluding only null, undefined and '' since the value can also be 0
    // Trimming to show null state in case of trailing spaces
    [null, void 0, ""].includes(
      s === "string" ? t.trim() : t
    ) || // for object type
    s === "object" && Object.keys(t).length === 0 || // for array type
    s === "array" && t.length === 0
  );
}, u2 = ({
  resourceId: t,
  resourceIdentifier: s
}) => t ? {
  id: t
} : {
  identifier: s
}, Gh = (t, s, n) => t.updatePath ? rn({
  json: n,
  path: on(BE(t.updatePath)),
  wrap: !1,
  resultType: "value"
}) : n[s];
class OR extends ux {
  constructor(s) {
    super(s), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError() {
    return { hasError: !0 };
  }
  componentDidUpdate(s) {
    const { children: n } = this.props;
    s.children !== n && this.setState({ hasError: !1 });
  }
  componentDidCatch(s) {
    ka(s);
  }
  render() {
    const { hasError: s } = this.state;
    if (s) {
      const { fallback: a } = this.props;
      return a;
    }
    const { children: n } = this.props;
    return n;
  }
}
const Bh = jc({}), RR = ({
  value: t,
  ...s
}) => /* @__PURE__ */ e.jsx(Bh.Provider, { value: t, ...s }), PR = () => Oc(Bh), Au = () => /* @__PURE__ */ e.jsx(e.Fragment, { children: "-" }), Za = ({ value: t, icon: s }) => (
  // Added extra div for handling the center alignment in case of sibling having additional height
  /* @__PURE__ */ e.jsx("div", { className: "dc__ellipsis-right", children: /* @__PURE__ */ e.jsxs("div", { className: "dc__word-break flexbox flex-align-center dc__gap-8", children: [
    s && /* @__PURE__ */ e.jsx(
      "div",
      {
        className: "icon-dim-20 mw-20 flexbox flex-justify-center flex-align-center dc__border-radius-50-per dc__uppercase cn-0 fw-4",
        style: { backgroundColor: $E(t) },
        children: t[0]
      }
    ),
    /* @__PURE__ */ e.jsx("span", { className: "cn-9 dc__ellipsis-right", children: t })
  ] }) })
), wR = ({ value: t, id: s }) => {
  const { jsonViewExpansionMap: n, currentView: a, updateJsonViewExpansionMap: r } = PR(), o = n[s], i = o === !0 || o === null && a === Uh, l = JSON.stringify(t, null, 2), c = (d) => {
    r(s, d);
  };
  return J(() => {
    s in n || r(s, null);
  }, []), /* @__PURE__ */ e.jsxs("div", { id: `object-item__${s}`, className: "mw-none w-100", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "catalog__object-item display-grid flex-align-center dc__gap-8 h-24", children: [
      i ? /* @__PURE__ */ e.jsx("div", { className: "fs-14 fw-6 lh-16", children: "Value" }) : /* @__PURE__ */ e.jsx("div", { className: "dc__ellipsis-right mono pt-4 pb-4 pr-6 pl-6 fs-12 lh-16 bg__secondary br-4", children: l }),
      i ? /* @__PURE__ */ e.jsx(l_, { onClick: () => c(!1), className: "icon-dim-16 scn-6 cursor" }) : /* @__PURE__ */ e.jsx(c_, { onClick: () => c(!0), className: "icon-dim-16 fcn-6 cursor" }),
      /* @__PURE__ */ e.jsx(Hi, { content: l })
    ] }),
    i && /* @__PURE__ */ e.jsx("code", { className: "dc__word-break dc__block mxh-250 dc__overflow-auto br-4 bg__secondary pr-6 pl-6 pt-4 pb-4 cn-9 dc__white-space-pre mono fs-14 lh-16", children: l })
  ] });
}, DR = ({ value: t }) => {
  const { url: s, ...n } = VE(t);
  return /* @__PURE__ */ e.jsxs(
    "a",
    {
      className: "anchor cb-5 fs-13 fw-4 lh-24 dc__ellipsis-right flexbox flex-align-center dc__gap-4",
      ...n,
      children: [
        /* @__PURE__ */ e.jsx(bi, { className: "icon-dim-16 mw-16" }),
        /* @__PURE__ */ e.jsx("span", { className: "dc__ellipsis-right", children: s })
      ]
    }
  );
}, $h = () => /* @__PURE__ */ e.jsx(Za, { value: "Parsing error" });
function ui({ fieldSchema: t = {}, value: s, icon: n, id: a }) {
  try {
    if (jR(s))
      return /* @__PURE__ */ e.jsx(Au, {});
    const { type: r = nr(s) } = t, o = !!t.additionalProperties, i = !!t.refType || r === "array" && !!t.items?.refType || o && !!t.additionalProperties?.refType, l = !!t.$ref || r === "array" && !!t.items?.$ref || o && !!t.additionalProperties?.$ref;
    let c = r;
    switch (o ? c = "object" : i ? c = Array.isArray(s) ? "refType/array" : "refType/object" : (l || typeof c != "string") && (c = nr(s)), c) {
      case "number":
      case "integer":
        return /* @__PURE__ */ e.jsx(Za, { value: s, icon: n });
      case "boolean":
        return /* @__PURE__ */ e.jsx("div", { className: "dc__capitalize", children: /* @__PURE__ */ e.jsx(Za, { value: s?.toString() || "False", icon: n }) });
      case "string": {
        const { format: d } = t, p = s;
        switch (d) {
          case pi.uri:
            return /* @__PURE__ */ e.jsx(DR, { value: p });
          case pi.date: {
            const m = it(p || "").format(
              Ap.DATE_FORMAT_WITH_WEEKDAY
            );
            return /* @__PURE__ */ e.jsx(Za, { value: m, icon: n });
          }
          case pi.dateTime: {
            const m = it(p || "").format(
              Ap.TWELVE_HOURS_FORMAT_WITHOUT_WEEKDAY
            );
            return /* @__PURE__ */ e.jsx(Za, { value: m, icon: n });
          }
          default:
            return /* @__PURE__ */ e.jsx(Za, { value: p, icon: n });
        }
      }
      case "object":
        return /* @__PURE__ */ e.jsx(wR, { value: s, id: a });
      case "array":
        return /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-4 dc__ellipsis-right", children: s.map((d, p) => (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ e.jsx("div", { className: "catalog__item--array-bullets", children: /* @__PURE__ */ e.jsx(ui, { value: d, fieldSchema: t.items, id: `${a}-${p}` }) }, p)
        )) });
      case "refType/array":
        return /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-4 dc__ellipsis-right", children: s.map((d, p) => (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ e.jsx("div", { className: "catalog__item--array-bullets", children: /* @__PURE__ */ e.jsx(
            ui,
            {
              value: d.name,
              icon: d.icon,
              fieldSchema: {
                type: nr(d.name)
              },
              id: `${a}-${p}`
            }
          ) }, p)
        )) });
      case "refType/object":
        return /* @__PURE__ */ e.jsx(
          ui,
          {
            value: s.name,
            icon: s.icon,
            fieldSchema: {
              type: nr(s.name)
            },
            id: a
          }
        );
      case "null":
        return /* @__PURE__ */ e.jsx(Au, {});
      default:
        throw new Error(`Unsupported type for Catalog Item: ${r}`);
    }
  } catch (r) {
    return ka(r), /* @__PURE__ */ e.jsx($h, {});
  }
}
const MR = (t) => /* @__PURE__ */ e.jsx(OR, { fallback: /* @__PURE__ */ e.jsx($h, {}), children: /* @__PURE__ */ e.jsx(ui, { ...t }) }), Tc = ({ title: t, catalogItemProps: s }) => /* @__PURE__ */ e.jsxs("div", { className: "catalog__item fs-13 fw-4 lh-24", children: [
  /* @__PURE__ */ e.jsx("span", { className: "cn-7 dc__ellipsis-right", children: t }),
  /* @__PURE__ */ e.jsx(MR, { ...s })
] }), kR = ({ sectionData: t = {}, sectionSchema: s, sectionKey: n }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: Object.entries(s.properties).map(([a, r]) => {
  const o = r, i = o.title || a, l = Gh(o, a, t), c = `${n}_${a}`;
  return /* @__PURE__ */ e.jsx(
    Tc,
    {
      title: i,
      catalogItemProps: {
        id: c,
        value: l,
        fieldSchema: o
      }
    },
    c
  );
}) }), FR = ({ originalFormData: t, originalSchema: s }) => {
  const n = s.type, a = !!s.additionalProperties, r = Object.entries(s.properties || {}).reduce(
    (d, [p, m]) => (vu[p] || (d[p] = m), d),
    {}
  ), o = {
    ...s,
    properties: r
  }, i = Object.entries(t).reduce(
    (d, [p, m]) => (vu[p] || (d[p] = m), d),
    {}
  ), l = t[$d.CUSTOM_PANEL];
  if (n === "object" && !a)
    return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      Object.entries(o.properties).map(([d, p]) => {
        const m = p, u = m.title || d, f = Gh(m, d, i), _ = m.type || nr(f);
        return !!!m.additionalProperties && _ === "object" && m?.properties ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
          /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-6 cn-9", children: u }),
          /* @__PURE__ */ e.jsx("div", { className: "dc__border-top-n1 mt-8 mb-12" }),
          /* @__PURE__ */ e.jsx("div", { className: "catalog__section", children: /* @__PURE__ */ e.jsx(
            kR,
            {
              sectionData: f,
              sectionSchema: m,
              sectionKey: d
            }
          ) })
        ] }, d) : /* @__PURE__ */ e.jsx(
          Tc,
          {
            title: u,
            catalogItemProps: {
              id: d,
              value: f,
              fieldSchema: m
            }
          },
          d
        );
      }),
      !!l?.links?.length && /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
          /* @__PURE__ */ e.jsx("h3", { className: "m-0 fs-13 fw-6 cn-9", children: "Custom Panel" }),
          /* @__PURE__ */ e.jsx("div", { className: "dc__border-top-n1" })
        ] }),
        /* @__PURE__ */ e.jsx(YE, { iframeList: l.links, maxHeight: 800, maxWidth: 900 })
      ] })
    ] });
  const c = o.title || LR;
  return /* @__PURE__ */ e.jsx(
    Tc,
    {
      title: c,
      catalogItemProps: {
        id: "primitive-value",
        /**
         * NOTE: The value is not fetched using getSchemaValue because
         * setting updatePath on a root primitive type does not make sense.
         * UpdatePath should only be set when the root schema type is an object.
         */
        value: i,
        fieldSchema: o
      }
    }
  );
}, UR = () => /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100 h-132" }), Su = ({ count: t, areFiltersLoading: s }) => /* @__PURE__ */ e.jsxs(
  "div",
  {
    className: `flexbox-col dc__gap-12 dc__align-items-center h-100 w-100 dc__overflow-auto ${s ? "bg__primary px-20" : ""}`,
    children: [
      s && /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center dc__content-space pt-20 pb-16 w-100", children: /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading h-20 w-100px" }) }),
      Array.from({ length: t }).map((n, a) => (
        // Disabling eslint rule since no unique key is available for shimmer
        // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ e.jsx(UR, {}, a)
      ))
    ]
  }
), Vh = ({ isLoading: t, handleFetchMoreData: s }) => /* @__PURE__ */ e.jsx(
  "button",
  {
    className: "show-older-images-cta cta ghosted flex h-32",
    onClick: s,
    disabled: t,
    type: "button",
    children: t ? /* @__PURE__ */ e.jsx(Je, { styles: { height: "32px" } }) : "Fetch more images"
  }
), Yh = ({ materialInformationList: t }) => /* @__PURE__ */ e.jsx(e.Fragment, { children: t.map((s, n) => {
  const a = HE(s);
  return (a.WebhookData?.Data || a.Author || a.Message || a.Date || a.Commit) && // eslint-disable-next-line react/no-array-index-key
  /* @__PURE__ */ e.jsx("div", { className: "bg__primary br-4 en-2 bw-1 m-12", children: /* @__PURE__ */ e.jsx(
    KE,
    {
      index: n,
      materialUrl: s.url,
      showMaterialInfoHeader: !0,
      commitInfo: a,
      materialSourceType: s.type,
      selectedCommitInfo: "",
      materialSourceValue: s.branch
    }
  ) }, n);
}) }), GR = ({
  bulkActionsData: { showNodeListingOptions: t, showBulkRestartOption: s, isResourceRecommendationView: n },
  onActionClick: a
}) => /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__gap-4", children: n ? /* @__PURE__ */ e.jsx(
  j,
  {
    dataTestId: "open-resource-recommendation-modal",
    size: O.small,
    text: "Apply Changes",
    "data-key": "applyResourceRecommendation",
    endIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-caret-right", color: null }),
    onClick: a
  }
) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
  t && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      j,
      {
        icon: /* @__PURE__ */ e.jsx(CN, {}),
        dataTestId: "rb-bulk-action__action-widget--cordon",
        component: Re.button,
        style: B.negativeGrey,
        variant: w.borderLess,
        ariaLabel: "Cordon node(s)",
        size: O.small,
        "data-key": "cordon",
        onClick: a,
        showAriaLabelInTippy: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      j,
      {
        icon: /* @__PURE__ */ e.jsx(bN, {}),
        dataTestId: "rb-bulk-action__action-widget--uncordon",
        component: Re.button,
        style: B.neutral,
        variant: w.borderLess,
        ariaLabel: "Uncordon node(s)",
        "data-key": "uncordon",
        size: O.small,
        onClick: a,
        showAriaLabelInTippy: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      j,
      {
        icon: /* @__PURE__ */ e.jsx(EN, {}),
        dataTestId: "rb-bulk-action__action-widget--drain",
        component: Re.button,
        style: B.negativeGrey,
        variant: w.borderLess,
        ariaLabel: "Drain node(s)",
        "data-key": "drain",
        size: O.small,
        onClick: a,
        showAriaLabelInTippy: !0
      }
    )
  ] }),
  s && /* @__PURE__ */ e.jsx(
    j,
    {
      icon: /* @__PURE__ */ e.jsx(W, { name: "ic-arrows-clockwise", color: null }),
      dataTestId: "rb-bulk-action__action-widget--restart",
      component: Re.button,
      style: B.neutral,
      variant: w.borderLess,
      ariaLabel: "Restart workload(s)",
      "data-key": "restart",
      size: O.small,
      onClick: a,
      showAriaLabelInTippy: !0
    }
  ),
  /* @__PURE__ */ e.jsx(
    j,
    {
      icon: /* @__PURE__ */ e.jsx(ts, {}),
      dataTestId: "rb-bulk-action__action-widget--delete",
      component: Re.button,
      style: B.negativeGrey,
      variant: w.borderLess,
      ariaLabel: `Delete ${t ? "node" : "resource"}(s)`,
      "data-key": "delete",
      size: O.small,
      onClick: a,
      showAriaLabelInTippy: !0
    }
  )
] }) }), Hh = {
  [rt.API_VERSION]: "API Version",
  [rt.CONTAINER_NAME]: "Container Name",
  [rt.CPU_LIMIT]: "CPU Limits",
  [rt.CPU_REQUEST]: "CPU Requests",
  [rt.KIND]: "Kind",
  [rt.MEMORY_LIMIT]: "Mem Limits",
  [rt.MEMORY_REQUEST]: "Mem Requests",
  [rt.NAME]: "Workload",
  [rt.NAMESPACE]: "Namespace"
}, BR = {
  [rt.API_VERSION]: 180,
  [rt.CONTAINER_NAME]: 150,
  [rt.CPU_LIMIT]: 150,
  [rt.CPU_REQUEST]: 150,
  [rt.KIND]: 150,
  [rt.MEMORY_LIMIT]: 150,
  [rt.MEMORY_REQUEST]: 150,
  [rt.NAME]: 314,
  [rt.NAMESPACE]: 150
}, Kh = [
  {
    label: "Container Name",
    key: rt.CONTAINER_NAME
  },
  {
    label: "Workload Name",
    key: rt.NAME
  },
  {
    label: "Kind",
    key: rt.KIND
  },
  {
    label: "Namespace",
    key: rt.NAMESPACE
  },
  {
    label: "Current → Recommended CPU (Req)",
    key: rt.CPU_REQUEST
  },
  {
    label: "Current → Recommended CPU (Lim)",
    key: rt.CPU_LIMIT
  },
  {
    label: "Current → Recommended memory (Req)",
    key: rt.MEMORY_REQUEST
  },
  {
    label: "Current → Recommended memory (Lim)",
    key: rt.MEMORY_LIMIT
  }
], m2 = (t, s) => ({
  id: s,
  name: "Resource Recommender",
  title: "Resource Recommendation",
  url: t,
  isSelected: !1,
  type: "fixed",
  showNameOnSelect: !0,
  isAlive: !1,
  isAlpha: !0,
  defaultUrl: t
}), $R = ({
  clusterId: t,
  apiVersion: s,
  kind: n,
  namespace: a
}) => {
  const { group: r, version: o } = hr(s), i = !!(s && n);
  return {
    clusterId: t,
    ...i || a ? {
      k8sRequest: {
        resourceIdentifier: {
          ...i ? {
            groupVersionKind: {
              Group: r,
              Version: o,
              Kind: n
            }
          } : {},
          ...a ? { namespace: a } : {}
        }
      }
    } : {}
  };
}, VR = (t) => {
  const s = (t.headers || []).filter((o) => !!o), { data: n } = t, r = (n || []).filter(
    (o) => o.kind && o.apiVersion && o.namespace && o.containerName && o.name
  ).map((o) => {
    const i = {
      cpuLimit: null,
      cpuRequest: null,
      memoryLimit: null,
      memoryRequest: null
    }, l = {
      id: `${o.name}-${o.apiVersion}-${o.kind}-${o.namespace}-${o.containerName}`
    };
    return Object.keys(o).forEach((c) => {
      if (c in i) {
        l[c] = o[c].delta, i[c] = o[c];
        return;
      }
      l[c] = o[c] || "";
    }), l.additionalMetadata = i, l;
  });
  return {
    resourceList: {
      headers: s,
      data: r
    }
  };
}, ir = (t) => t ? t === "none" ? "None" : t : "NA", YR = (t) => (t || []).map(
  (s) => Kh.reduce(
    (n, { key: a }) => {
      const r = s?.additionalMetadata?.[a];
      return n[a] = r ? `${ir(r.current?.value)} -> ${ir(r.recommended?.value)} ${r.delta ? `(${r.delta})%` : ""}` : s?.[a] || "", n;
    },
    {}
  )
), yu = ({
  delta: t,
  recommended: s,
  current: n,
  isTooltipView: a = !1
}) => {
  const r = s?.value, o = n?.value, i = !r || r === "none", l = !o || o === "none";
  return t === 0 || l && i ? {
    class: "cn-3",
    badgeProps: { variant: "custom", bgColor: "N100", fontColor: "N700" },
    iconProps: {
      color: a ? "N300" : "N700",
      name: "ic-minus"
    }
  } : t > 0 || !i && l ? {
    class: "cr-5",
    badgeProps: { variant: "negative" },
    iconProps: {
      color: a ? "R500" : "R700",
      name: "ic-arrow-right",
      rotateBy: 270
    }
  } : {
    class: "cg-5",
    badgeProps: { variant: "positive" },
    iconProps: {
      color: a ? "G500" : "G700",
      name: "ic-arrow-right",
      rotateBy: 90
    }
  };
}, HR = (t) => {
  const s = (t || []).map((r) => ({
    kind: r.Kind,
    apiVersion: r.Group ? `${r.Group}/${r.Version}` : r.Version
  })), n = {};
  s.forEach(({ apiVersion: r, kind: o }) => {
    n[r] || (n[r] = []), n[r].push({
      kind: o,
      apiVersion: r
    });
  });
  const a = Object.keys(n).sort(Ce);
  return [
    {
      options: [
        {
          label: "All Kinds",
          value: null
        }
      ]
    },
    ...a.map((r) => ({
      label: r,
      options: n[r].map((o) => ({
        label: o.kind,
        value: {
          apiVersion: o.apiVersion,
          kind: o.kind
        }
      })).sort((o, i) => Ce(o.label, i.label))
    }))
  ];
}, Lu = (t) => ({
  ...t.has(dp) ? {
    selectedKindGVKFilter: t.get(dp)
  } : {},
  ...t.has(pp) ? {
    selectedAPIVersionGVKFilter: t.get(pp)
  } : {},
  ...t.has("namespace") ? { selectedNamespace: t.get("namespace") } : {}
}), KR = (t, s) => !s.searchKey || Object.entries(t.data).some(
  ([n, a]) => n !== "id" && a !== null && a !== void 0 && String(a).toLowerCase().includes(s.searchKey.toLowerCase())
), WR = async ({
  clusterId: t,
  namespace: s,
  apiVersion: n,
  kind: a,
  resourceListAbortControllerRef: r
}) => {
  try {
    const { result: o } = await we(
      $.K8S_RESOURCE_RECOMMENDATION_LIST,
      $R({
        clusterId: t,
        apiVersion: n,
        kind: a,
        namespace: s
      }),
      {
        abortControllerRef: r
      }
    );
    return VR(o);
  } catch (o) {
    throw Pe(o) || V(o), o;
  }
}, qR = async (t) => {
  const { result: s } = await le(
    `${$.K8S_RESOURCE}/${t}/${$.RECOMMENDATION_DETAILS}`
  );
  return {
    lastScannedOn: s.lastScannedOn || "",
    gvkList: HR(s.supportedGVKs)
  };
}, zR = async (t, s, n) => {
  try {
    const a = t.map(
      (o) => () => Qi({
        name: o.name,
        namespace: o.namespace,
        clusterId: s,
        gvk: {
          Group: hr(o.apiVersion).group,
          Version: hr(o.apiVersion).version,
          Kind: o.kind
        },
        isResourceRecommender: !0,
        abortControllerRef: n
      })
    );
    return (await Tr(a)).reduce((o, i, l) => {
      const c = t[l];
      if (i.status === Mi.FULFILLED) {
        const d = i.value?.manifestResponse;
        return o[c.id] = {
          currentManifest: d?.manifest ? gt(d.manifest) : null,
          recommendedManifest: d?.recommendedManifest ? gt(d.recommendedManifest) : null
        }, o;
      }
      return o[c.id] = null, o;
    }, {});
  } catch (a) {
    throw V(a), a;
  }
}, Wh = async (t) => {
  try {
    await we($.K8S_RESOURCE_RECOMMENDATION_SYNC, { clusterId: t }), Z.showToast({
      variant: ee.success,
      title: "Checking again",
      description: "Hang tight! We’re looking for the latest data to generate recommendations."
    });
  } catch (s) {
    V(s);
  }
}, qh = ({
  handleClose: t,
  clusterId: s,
  resourceList: n,
  handleReloadDataAfterBulkOperation: a
}) => {
  const r = de(new AbortController()), [o, i, l, c] = ne(
    () => zR(n, s, r)
  ), [d, p] = v({}), [m, u] = v(null), [f, _] = v(!1), h = (L) => {
    u(L);
  }, x = (L) => {
    p((R) => ({
      ...R,
      [L]: !R[L]
    }));
  }, g = Q(() => {
    const L = n.reduce(
      (y, M) => {
        const P = `${M.apiVersion}/${M.kind}`;
        return y[P] || (y[P] = []), y[P].push(M), y;
      },
      {}
    ), R = Object.keys(L).sort(Ce);
    return Object.keys(L).forEach((y) => {
      L[y].sort((M, P) => Ce(M.name, P.name));
    }), R.map((y, M) => ({
      header: y,
      id: y,
      isExpanded: !d[y],
      items: L[y].map((P, U) => ({
        title: P.name,
        id: P.id,
        isActive: m === P.id || M === 0 && U === 0 && !m,
        onClick: () => h(P.id),
        iconConfig: !o && !i?.[P.id]?.recommendedManifest ? {
          Icon: Va,
          props: {
            className: "icon-dim-16 alert-icon-r5-imp dc__no-svg-stroke mt-2"
          }
        } : null
      }))
    }));
  }, [d, m, o, i]), E = Q(
    () => n.reduce((L, R) => (L[R.id] = R, L), {}),
    // Resource list is not expected to change during the modal lifecycle
    []
  ), C = Q(() => i ? n.filter(
    (R) => !!i[R.id]?.recommendedManifest
  ).map((R) => ({
    name: R.name,
    additionalKeys: [{ label: "Kind", value: R.kind, isSortable: !0, width: "150px" }],
    operation: (y) => Zi(
      {
        name: R.name,
        namespace: R.namespace,
        clusterId: s,
        gvk: {
          Group: hr(R.apiVersion).group,
          Version: hr(R.apiVersion).version,
          Kind: R.kind
        },
        manifest: i[R.id].recommendedManifest
      },
      y
    )
  })) : [], [i]), b = () => {
    if (C.length === 0) {
      Z.showToast({
        variant: ee.error,
        description: "No resource recommendations available to apply."
      });
      return;
    }
    _(!0);
  }, N = m || g[0].items[0].id, I = i?.[N];
  J(
    () => () => {
      r.current.abort();
    },
    []
  );
  const T = (L) => {
    const { Pending: R, Progressing: y, Completed: M } = L;
    return R || y ? /* @__PURE__ */ e.jsx("span", { className: "cn-8 fs-12 fw-4 lh-20", children: "Applying recommended changes" }) : `${M} resource(s) recommendation changes applied`;
  }, A = () => o ? n.length === 1 ? /* @__PURE__ */ e.jsx("div", { className: "flex w-100 h-100 flex-grow-1", children: /* @__PURE__ */ e.jsx(Je, { pageLoader: !0 }) }) : /* @__PURE__ */ e.jsx(
    _e,
    {
      classname: "dc__text-center",
      title: "Fetching recommendations",
      subTitle: "Fetching resource recommendation for the selected resources",
      SvgImage: jr,
      imageType: bs.Large
    }
  ) : I ? I.recommendedManifest ? /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__overflow-auto flex-grow-1", children: /* @__PURE__ */ e.jsx(
    Gt,
    {
      mode: Ts.YAML,
      noParsing: !0,
      diffView: !0,
      readOnly: !0,
      originalValue: I.currentManifest || "",
      modifiedValue: I.recommendedManifest,
      height: "fitToParent",
      collapseUnchangedDiffView: !0,
      children: /* @__PURE__ */ e.jsxs(Gt.Header, { hideDefaultSplitHeader: !0, children: [
        /* @__PURE__ */ e.jsx("h4", { className: "m-0 cn-9 fs-12 fw-6 lh-20 px-16", children: "Current" }),
        /* @__PURE__ */ e.jsx("h4", { className: "m-0 cn-9 fs-12 fw-6 lh-20 px-16", children: "Recommended" })
      ] })
    }
  ) }) : /* @__PURE__ */ e.jsx(
    _e,
    {
      title: "No resource recommendation available",
      subTitle: "There is no resource recommendation available for the selected resource."
    }
  ) : /* @__PURE__ */ e.jsx(
    _e,
    {
      title: "Manifest details not available",
      subTitle: "Please try again later or contact support if the issue persists."
    }
  ), S = () => l ? /* @__PURE__ */ e.jsx(Xe, { code: l.code, reload: c }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    n.length > 1 && /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__overflow-auto dc__no-shrink w-250 p-8 border__primary--right", children: /* @__PURE__ */ e.jsx(
      Fc,
      {
        config: g,
        tabType: "button",
        onCollapseBtnClick: x
      }
    ) }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-auto flex-grow-1", children: [
      /* @__PURE__ */ e.jsx("h3", { className: "m-0 px-16 py-8 cn-9 fs-13 fw-6 lh-1-5 flexbox dc__gap-4", children: E[N] ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        E[N].kind,
        " ",
        /* @__PURE__ */ e.jsx("span", { className: "cn-6 fs-13 fw-4 lh-1-5", children: "/" }),
        E[N].name,
        " ",
        /* @__PURE__ */ e.jsx("span", { className: "cn-6 fs-13 fw-4 lh-1-5", children: "/" }),
        /* @__PURE__ */ e.jsxs("span", { className: "px-6 py-2 bcb-1 br-4 dc__gap-4 dc__align-items-center flexbox dc__mxw-200", children: [
          /* @__PURE__ */ e.jsx(W, { name: "ic-container", color: "B700", size: 14 }),
          /* @__PURE__ */ e.jsx(
            Ie,
            {
              content: E[N].containerName,
              children: /* @__PURE__ */ e.jsx("span", { className: "dc__truncate cb-7 fs-12 fw-5 lh-16", children: E[N].containerName })
            }
          )
        ] })
      ] }) : "Resource Details" }),
      A()
    ] })
  ] });
  return f ? /* @__PURE__ */ e.jsx(
    So,
    {
      data: null,
      operations: C,
      textConfig: {
        prompt: Nn,
        resultsHeader: "Apply resource recommendation changes"
      },
      shouldSkipConfirmation: !0,
      handleModalClose: t,
      handleReloadDataAfterBulkOperation: a,
      getResultsChartSummaryText: T,
      disableTransition: !0
    }
  ) : /* @__PURE__ */ e.jsx($t, { position: "right", width: "1024px", onEscape: t, onClose: t, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "flexbox-col dc__content-space h-100 bg__modal--primary shadow__modal dc__overflow-auto",
      onClick: Le,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-auto flex-grow-1", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "px-20 py-12 flexbox dc__content-space dc__align-items-center border__primary--bottom", children: [
            /* @__PURE__ */ e.jsx("h2", { className: "m-0 fs-16 fw-6 lh-24 cn-9", children: "Apply resource recommendation changes" }),
            /* @__PURE__ */ e.jsx(
              j,
              {
                dataTestId: "header-close-button",
                ariaLabel: "Close",
                showAriaLabelInTippy: !1,
                onClick: t,
                variant: w.borderLess,
                style: B.negativeGrey,
                icon: /* @__PURE__ */ e.jsx(W, { name: "ic-close-large", color: null }),
                size: O.xs
              }
            )
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "flexbox flex-grow-1 dc__overflow-auto w-100", children: S() })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-end dc__gap-12 py-16 px-20 border__primary--top dc__no-shrink", children: [
          /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: "footer-cancel-button",
              variant: w.secondary,
              text: "Cancel",
              style: B.neutral,
              size: O.large,
              onClick: t
            }
          ),
          /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: "footer-apply-button",
              variant: w.primary,
              size: O.large,
              disabled: !i,
              text: "Apply Changes",
              onClick: b
            }
          )
        ] })
      ]
    }
  ) });
}, zh = async ({
  resource: t,
  getManifestResource: s,
  updateManifestResourceHelmApps: n,
  abortControllerRef: a
}) => {
  const {
    result: {
      manifestResponse: { manifest: r }
    }
  } = await s(null, "", "", !0, t, a.current.signal);
  if (!r)
    return;
  const o = "/spec/template/metadata", i = `${o}/annotations`, l = "devtron/restart", c = {
    json: r,
    wrap: !1,
    resultType: "value"
  }, d = (/* @__PURE__ */ new Date()).toISOString();
  rn({ path: on(o), ...c }) ? rn({
    path: on(i),
    ...c
  }) ? Aa(
    r,
    {
      op: "add",
      // NOTE: we only need to escape / in restartLabel when making a path out of it
      path: `${i}/${hm(l)}t`,
      value: d
    },
    !1,
    !0
  ) : Aa(
    r,
    {
      op: "add",
      path: i,
      value: { [l]: d }
    },
    !1,
    !0
  ) : Aa(
    r,
    {
      op: "add",
      path: o,
      value: {
        annotations: {
          [l]: d
        }
      }
    },
    !1,
    !0
  ), await n(
    null,
    "",
    "",
    JSON.stringify(r),
    !0,
    t,
    a.current.signal
  );
}, XR = ({
  selection: t,
  operationType: s,
  clusterId: n
}) => async (a) => {
  const r = {
    kind: t.kind,
    name: t.name,
    version: t.version,
    clusterId: n,
    nodeCordonOptions: {
      // NOTE: if we need to cordon the node we should send true
      unschedulableDesired: s === "cordon"
    }
  };
  await WE(r, a);
}, JR = ({ selection: t, clusterId: s }) => async (n, a) => {
  const r = {
    kind: t.kind,
    name: t.name,
    version: t.version,
    clusterId: s,
    nodeDrainOptions: a
  };
  await qE(r, n);
}, QR = ({
  selection: t,
  selectedResource: s,
  clusterId: n,
  getManifestResource: a,
  updateManifestResourceHelmApps: r
}) => async (o) => {
  const i = {
    clusterId: n,
    group: s.gvk.Group,
    kind: s.gvk.Kind,
    version: s.gvk.Version,
    namespace: t.namespace,
    containers: [],
    name: t.name
  };
  await zh({
    resource: i,
    getManifestResource: a,
    updateManifestResourceHelmApps: r,
    abortControllerRef: o
  });
}, ZR = ({ selection: t, clusterId: s }) => async (n) => {
  const a = {
    clusterId: Number(s),
    name: String(t.name),
    version: String(t.version),
    kind: String(t.kind)
  };
  await zE(a, n);
}, eP = ({
  selection: t,
  clusterId: s,
  selectedResource: n
}) => async (a, r) => {
  const o = {
    clusterId: Number(s),
    k8sRequest: {
      resourceIdentifier: {
        groupVersionKind: n.gvk,
        namespace: String(t.namespace),
        name: String(t.name)
      },
      forceDelete: r
    }
  };
  await $m(o, a);
}, Xh = (t) => {
  switch (t) {
    case "delete":
      return "deleted";
    case "restart":
      return "restarted";
    case "cordon":
      return "cordoned";
    case "uncordon":
      return "uncordoned";
    case "drain":
      return "drained";
    default:
      return ka(`Unknown operation type ${t} en-countered`), t;
  }
}, tP = (t) => {
  switch (t) {
    case "delete":
      return "Deleting";
    case "restart":
      return "Restarting";
    case "cordon":
      return "Cordoning";
    case "uncordon":
      return "Uncordoning";
    default:
      return "In progress";
  }
}, sP = (t, s) => (n) => {
  const { Pending: a, Progressing: r, Completed: o } = n;
  return a || r ? /* @__PURE__ */ e.jsx("span", { className: "dc__loading-dots", children: tP(t) }) : `${o} ${s}(s) ${Xh(t)}`;
}, nP = (t, s) => {
  if (t === "delete" && s.toLowerCase() === "node")
    return QE.subtitle;
  switch (t) {
    case "cordon":
      return Wl.cordonInfoText;
    case "uncordon":
      return Wl.uncordonInfoText;
    case "drain":
      return Vm.Actions.infoText;
    default:
      return `Selected ${s}(s) will be ${Xh(t)}. Are you sure?`;
  }
}, aP = ({
  numberOfOperations: t,
  selectedResource: s,
  action: n,
  clusterName: a,
  isNodeListing: r,
  renderAdditionalOptionsForConfirmationModal: o
}) => {
  const i = s.gvk.Kind, l = Ft(n), c = {
    title: `${l} ${t} ${i}(s) of cluster ‘${a}’`,
    subtitle: nP(n, i),
    buttonConfig: {
      primaryButtonConfig: {
        text: l
      },
      secondaryButtonConfig: {
        text: "Cancel"
      }
    },
    confirmationConfig: {
      identifier: `${n}-confirmation`,
      confirmationKeyword: a
    }
  }, { CordonIcon: d, UncordonIcon: p } = Wl, { DrainIcon: m } = Vm;
  switch (n) {
    case "delete":
      return {
        variant: Ct.delete,
        ...c,
        ...r ? {} : {
          children: o(JE),
          buttonConfig: {
            ...c.buttonConfig,
            primaryButtonConfig: {
              ...c.buttonConfig.primaryButtonConfig
            }
          }
        }
      };
    case "restart":
      return {
        variant: Ct.custom,
        Icon: /* @__PURE__ */ e.jsx(v_, {}),
        ...c
      };
    case "cordon":
      return {
        ...c,
        variant: Ct.custom,
        Icon: /* @__PURE__ */ e.jsx(d, {}),
        buttonConfig: {
          ...c.buttonConfig,
          primaryButtonConfig: {
            ...c.buttonConfig.primaryButtonConfig,
            style: B.negative
          }
        }
      };
    case "uncordon":
      return {
        variant: Ct.custom,
        Icon: /* @__PURE__ */ e.jsx(p, {}),
        ...c
      };
    case "drain":
      return {
        variant: Ct.custom,
        Icon: /* @__PURE__ */ e.jsx(m, { className: "scr-5" }),
        children: o(XE),
        ...c,
        buttonConfig: {
          ...c.buttonConfig,
          primaryButtonConfig: {
            ...c.buttonConfig.primaryButtonConfig,
            style: B.negative
          }
        }
      };
    default:
      throw new Error(`Unknown operation type ${n} found`);
  }
}, rP = ({
  action: t,
  bulkOperationModalData: {
    selectedResource: s,
    clusterId: n,
    clusterName: a,
    isNodeListing: r,
    handleReloadDataAfterBulkOperation: o,
    getManifestResource: i,
    updateManifestResourceHelmApps: l
  },
  selections: c,
  onClose: d
}) => {
  const [p, m] = v(null), { replace: u } = Te(), f = Ss(), { isBulkSelectionApplied: _, selectedIdentifiers: h, handleBulkSelection: x } = It(), g = () => (_ ? c : Object.values(h)) ?? [], E = Q(() => {
    const N = g().map(({ data: I }) => I);
    return t === "cordon" || t === "uncordon" ? N.map((I) => ({
      name: I.name,
      operation: XR({ selection: I, operationType: t, clusterId: n })
    })) : t === "drain" ? N.map((I) => ({
      name: I.name,
      operation: JR({ selection: I, clusterId: n })
    })) : t === "restart" ? N.map((I) => ({
      name: I.name,
      operation: QR({
        clusterId: n,
        getManifestResource: i,
        updateManifestResourceHelmApps: l,
        selectedResource: s,
        selection: I
      })
    })) : N.map((I) => ({
      name: I.name,
      operation: r ? ZR({ selection: I, clusterId: n }) : eP({ clusterId: n, selectedResource: s, selection: I })
    }));
  }, [r, _, c, h, n, s]), C = (N) => /* @__PURE__ */ e.jsx(N, { optionsData: p, setOptionsData: m }), b = () => {
    x({ action: st.CLEAR_ALL_SELECTIONS });
    const N = new URLSearchParams(f.search);
    N.delete(ZE.PAGE_NUMBER), u(`${f.pathname}?${N.toString()}`), o();
  };
  if (t === "applyResourceRecommendation") {
    const N = g().map(({ data: I }) => I);
    return /* @__PURE__ */ e.jsx(
      qh,
      {
        resourceList: N,
        clusterId: n,
        handleClose: d,
        handleReloadDataAfterBulkOperation: b
      }
    );
  }
  return /* @__PURE__ */ e.jsx(
    So,
    {
      data: p,
      operations: E,
      textConfig: {
        prompt: Nn,
        resultsHeader: `${t} ${s.gvk.Kind} status`
      },
      confirmationModalConfig: aP({
        numberOfOperations: E.length,
        renderAdditionalOptionsForConfirmationModal: C,
        clusterName: a,
        isNodeListing: r,
        action: t,
        selectedResource: s
      }),
      handleModalClose: d,
      handleReloadDataAfterBulkOperation: b,
      getResultsChartSummaryText: sP(t, s.gvk.Kind)
    }
  );
}, oP = {
  Group: "crd.devtron.ai",
  Kind: "GuiSchema",
  Version: mt.alpha1
}, iP = {
  Group: "crd.devtron.ai",
  Kind: "LockSchema",
  Version: mt.alpha1
}, ju = "drag-selector", lr = {
  BulkSelectionWidgetClicked: {
    category: "Resource Browser",
    action: "RESOURCE_BROWSER_GET_KUBECONFIG_BULK_CLICKED"
  },
  IndividualKubeConfig: {
    category: "Resource Browser",
    action: "RESOURCE_BROWSER_GET_KUBECONFIG_INDIVIDUAL_CLICKED"
  },
  CopyButton: {
    category: "Resource Browser",
    action: "RESOURCE_BROWSER_GET_KUBECONFIG_COPYCOMMAND_CLICKED"
  },
  ReachableClusterToggleEnabled: {
    category: "Resource Browser",
    action: "RESOURCE_BROWSER_GET_KUBECONFIG_BULK_REACHABLE_CLUSTERS_ENABLED"
  },
  ReachableClusterToggleDisabled: {
    category: "Resource Browser",
    action: "RESOURCE_BROWSER_GET_KUBECONFIG_BULK_REACHABLE_CLUSTERS_DISABLED"
  },
  DoNotSetContextSelect: {
    category: "Resource Browser",
    action: "RESOURCE_BROWSER_GET_KUBECONFIG_BULK_SETCONTEXT_OPTION_DONOTSET_CHANGED"
  },
  SetContextSelect: {
    category: "Resource Browser",
    action: "RESOURCE_BROWSER_GET_KUBECONFIG_BULK_SETCONTEXT_OPTION_SELECTED_CLUSTER_CHANGED"
  }
}, mi = {
  label: "Do not set context",
  value: ""
  //  Value will be empty in this case, as it will append the context to the command
}, lP = ({
  onChangeShowKubeConfigModal: t,
  isBulkWidgetButton: s = !1,
  setSelectedClusterName: n,
  clusterName: a
}) => {
  const r = () => {
    t(), n?.(a), ct.event(
      s ? lr.BulkSelectionWidgetClicked : lr.IndividualKubeConfig
    );
  };
  return s ? /* @__PURE__ */ e.jsx(
    j,
    {
      text: "Get kubeconfig",
      dataTestId: "rb-cluster-bulk-selection-kube-config",
      onClick: r,
      size: O.medium
    }
  ) : /* @__PURE__ */ e.jsx(
    j,
    {
      icon: /* @__PURE__ */ e.jsx(W, { name: "ic-file-key", color: null }),
      onClick: r,
      dataTestId: "rb-cluster-bulk-selection-kube-config",
      variant: w.borderLess,
      ariaLabel: "Get kubeconfig",
      size: O.xs,
      style: B.neutral
    }
  );
}, _2 = ({ clusterData: t }) => {
  const {
    selectedIdentifiers: s,
    handleBulkSelection: n,
    getSelectedIdentifiersCount: a
  } = It(), r = a(), o = !!s[t.name], i = () => {
    const { name: l } = t;
    s[l] ? n({
      action: st.CLEAR_IDENTIFIERS,
      data: {
        identifierIds: [l]
      }
    }) : n({
      action: st.SELECT_IDENTIFIER,
      data: {
        identifierObject: {
          ...s,
          [l]: t
        }
      }
    });
  };
  return /* @__PURE__ */ e.jsx(
    "div",
    {
      className: o || r > 0 ? "dc__visible" : "dc__visible-hover--child flex left",
      children: /* @__PURE__ */ e.jsx(
        $e,
        {
          disabled: !t.id,
          isChecked: o,
          onChange: i,
          rootClassName: "icon-dim-20 m-0",
          dataTestId: `activate-${t.name}`,
          value: Fe.CHECKED
        }
      )
    }
  );
}, cP = (t) => [
  mi,
  {
    label: "Set Context of",
    options: (t || []).map((s) => ({
      label: s,
      value: s
    }))
  }
], dP = (t) => `kubectl config use-context devtron-${t}`, pP = (t) => {
  const s = Ym(Hm);
  return `kubectl config set-cluster devtron-${t} --server=https://${window.location.host}/orchestrator/k8s/proxy/cluster/${t} --insecure-skip-tls-verify
kubectl config set-credentials devtron-${t} --token=${s}
kubectl config set-context devtron-${t} --cluster=devtron-${t} --user=devtron-${t}`;
}, Ou = (t, s) => {
  const n = Array.isArray(t) ? t : [t], a = n.map(pP), r = n.length === 1 ? n[0] : void 0, o = s || r;
  return [
    a.join(`
`),
    o ? dP(r || s) : ""
  ].filter(Boolean).join(`
`);
}, f2 = ({
  clusterName: t = "",
  handleModalClose: s,
  isSingleClusterButton: n = !1,
  isClusterDetailListLoading: a,
  identifierMap: r
}) => {
  const [o, i] = v(mi), [l, c] = v(!1), [d, p] = v(null), { selectedIdentifiers: m } = It(), u = Object.keys(m) || [], f = Object.keys(m || {}).filter((T) => {
    const A = r[T];
    return A && A.status !== eC.CONNECTION_FAILED;
  }), _ = Q(() => t ? Ou(t, o.value || t) : Ou(l ? f : u, o.value), [l, f, u, o.value, t]), h = () => {
    ct.event({
      category: "Resource Browser",
      action: "Get kubeconfig copy button clicked"
    }), p(Um(_));
  }, x = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-10 dc__align-items-center dc__border-bottom-n1 p-12 dc__content-space px-20 py-16", children: [
    /* @__PURE__ */ e.jsx("span", { className: "fs-16 fw-6 lh-20 cn-9", children: "Get kubeconfig" }),
    /* @__PURE__ */ e.jsx(
      j,
      {
        variant: w.borderLess,
        ariaLabel: "Close",
        showAriaLabelInTippy: !1,
        onClick: s,
        icon: /* @__PURE__ */ e.jsx(W, { name: "ic-close-large", color: null }),
        dataTestId: "close-kubeconfig-modal",
        size: O.xs,
        style: B.negativeGrey
      }
    )
  ] }), g = (T) => {
    i(T), ct.event(
      T.value === mi.value ? lr.DoNotSetContextSelect : lr.SetContextSelect
    );
  }, E = () => {
    c(!l), l ? ct.event(lr.ReachableClusterToggleDisabled) : (i(
      f.includes(o.value) ? o : mi
    ), ct.event(lr.ReachableClusterToggleEnabled));
  }, C = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col border__secondary bw-1 px-16 py-12 fs-13 br-8 dc__gap-12", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-16 dc__content-space top", children: [
      /* @__PURE__ */ e.jsxs("p", { className: "m-0", children: [
        /* @__PURE__ */ e.jsx("div", { className: "lh-20", children: "Get access for reachable clusters only" }),
        /* @__PURE__ */ e.jsx("div", { className: "fs-12 lh-18 cn-7", children: a ? "Checking cluster status…" : `${f.length}/${u.length} selected clusters are
                            reachable` })
      ] }),
      /* @__PURE__ */ e.jsx(
        Gn,
        {
          name: "toggle-selective-cluster",
          ariaLabel: "Toggle access reachable clusters",
          isChecked: l,
          onChange: E,
          isLoading: a
        }
      )
    ] }),
    (f.length > 1 || !l) && /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-16 dc__content-space border__secondary--top pt-12", children: [
      /* @__PURE__ */ e.jsx("span", { className: "lh-20", children: "Set current cluster context" }),
      /* @__PURE__ */ e.jsx(
        Ve,
        {
          inputId: "cluster-kube-config",
          options: cP(l ? f : u),
          size: O.medium,
          onChange: g,
          value: o
        }
      )
    ] })
  ] }), b = () => /* @__PURE__ */ e.jsxs("div", { className: "flex column dc__gap-12 dc__align-items-center p-20 mh-170 border__secondary--top pt-12", children: [
    /* @__PURE__ */ e.jsx(W, { name: "ic-info-outline", size: 24, color: null }),
    /* @__PURE__ */ e.jsx("div", { className: "flex fs-13 lh-20 dc__mxw-250 dc__text-center", children: "None of the selected clusters are reachable." })
  ] }), N = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 p-20", children: [
    u.length > 1 && !n && C(),
    !f.length && l ? b() : /* @__PURE__ */ e.jsxs(
      "ol",
      {
        className: `steps-with-trail--normal ${u.length > 1 ? "border__secondary--top pt-12" : ""} px-0`,
        children: [
          /* @__PURE__ */ e.jsx("li", { children: /* @__PURE__ */ e.jsxs("span", { className: "fs-13 lh-20", children: [
            /* @__PURE__ */ e.jsx("b", { className: "fw-6", children: "Prerequisites:" }),
            " ",
            /* @__PURE__ */ e.jsx(
              "a",
              {
                href: "https://kubernetes.io/docs/reference/kubectl/",
                target: "_blank",
                rel: "noreferrer noopener",
                className: "dc__underline dc__link-n9",
                children: "kubectl"
              }
            ),
            " must be installed"
          ] }) }),
          /* @__PURE__ */ e.jsx("li", { children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-hidden dc__gap-4", children: [
            /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-20", children: "Run below command on terminal to get server URI & bearer token" }),
            /* @__PURE__ */ e.jsx("pre", { className: "mono p-10 br-8 fs-13 m-0 p-0 dc__overflow-auto bg__secondary dc__border-n1 mxh-100", children: _ })
          ] }) })
        ]
      }
    )
  ] }), I = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__align-items-center dc__border-top-n1 p-12 dc__gap-12 px-20 py-16", children: [
    /* @__PURE__ */ e.jsx(
      $a,
      {
        docLinkKey: "KUBE_CONFIG",
        text: "View documentation",
        dataTestId: "kubeconfig-modal-view-documentation",
        showExternalIcon: !0,
        openInNewTab: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "copy-kubeconfig-commands",
        size: O.medium,
        onClick: h,
        startIcon: /* @__PURE__ */ e.jsx(Hi, { content: _, copyToClipboardPromise: d }),
        disabled: !f?.length && l,
        text: "Copy command"
      }
    )
  ] });
  return /* @__PURE__ */ e.jsx(cs, { className: "visible-modal__body", onEscape: s, children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__border dc__m-auto mt-40 br-8 bg__primary w-600 cn-9", children: [
    x(),
    N(),
    I()
  ] }) });
}, h2 = ({
  parentRef: t,
  count: s,
  handleClearBulkSelection: n,
  onChangeShowKubeConfigModal: a,
  selectedIdentifiersIds: r = []
}) => {
  const o = s !== 2;
  return /* @__PURE__ */ e.jsx(
    No,
    {
      dragSelector: `.${ju}`,
      positionVariant: To.PARENT_BOTTOM_CENTER,
      zIndex: "calc(var(--modal-index) - 1)",
      parentRef: t,
      children: /* @__PURE__ */ e.jsxs("div", { className: "dc__separated-flexbox dc__separated-flexbox--gap-8 p-12 bulk-selection-widget br-8", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
          /* @__PURE__ */ e.jsx(Fi, { dragClassName: ju }),
          /* @__PURE__ */ e.jsxs("div", { className: "fs-13 lh-20 fw-6 flex dc__gap-12", children: [
            /* @__PURE__ */ e.jsx("span", { className: "flex dc__gap-2 bcb-5 cn-0 br-4 px-6", children: s }),
            /* @__PURE__ */ e.jsx("span", { className: "cn-9", children: "Selected" })
          ] })
        ] }),
        /* @__PURE__ */ e.jsx(lP, { isBulkWidgetButton: !0, onChangeShowKubeConfigModal: a }),
        /* @__PURE__ */ e.jsx(
          j,
          {
            icon: /* @__PURE__ */ e.jsx(W, { name: "ic-arrows-left-right", color: null }),
            dataTestId: "rb-bulk-action__action-widget--compare-clusters",
            component: Re.link,
            style: B.neutral,
            variant: w.borderLess,
            ariaLabel: o ? "Select 2 clusters to compare & sync resources between the clusters" : "Compare & sync resources in selected clusters",
            size: O.small,
            disabled: o,
            linkProps: {
              to: {
                pathname: `${se.INFRASTRUCTURE_MANAGEMENT_RESOURCE_BROWSER}${se.COMPARE_CLUSTERS}`,
                search: `sourceClusterId=${r[0]}&targetClusterId=${r[1]}`
              }
            }
          }
        ),
        /* @__PURE__ */ e.jsx(
          j,
          {
            icon: /* @__PURE__ */ e.jsx(W, { name: "ic-close-large", color: null }),
            dataTestId: "rb-bulk-action__action-widget--close",
            component: Re.button,
            style: B.negativeGrey,
            variant: w.borderLess,
            ariaLabel: "Clear selection(s)",
            size: O.small,
            onClick: n,
            showAriaLabelInTippy: !0
          }
        )
      ] })
    }
  );
}, g2 = ({ sourceClusterId: t, isIconButton: s = !1 }) => {
  const n = {
    sourceClusterId: t,
    targetClusterId: null
  }, a = ye(
    `${se.INFRASTRUCTURE_MANAGEMENT_RESOURCE_BROWSER}${se.COMPARE_CLUSTERS}`,
    n
  );
  if (!window._env_.FEATURE_RB_SYNC_CLUSTER_ENABLE)
    return null;
  if (s)
    return /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "compare-cluster-button",
        ariaLabel: "Compare & sync clusters",
        icon: /* @__PURE__ */ e.jsx(Ti, {}),
        component: Re.link,
        linkProps: {
          to: a
        },
        variant: w.borderLess,
        style: B.neutral,
        size: O.xs
      }
    );
  const r = () => {
    zc({
      category: "RB Cluster Action",
      action: "RB_CLUSTER_COMPARE_SYNC"
    });
  };
  return /* @__PURE__ */ e.jsx(
    j,
    {
      dataTestId: "compare-cluster-button",
      text: "Compare & Sync",
      component: Re.link,
      linkProps: {
        to: a
      },
      variant: w.secondary,
      size: O.small,
      startIcon: /* @__PURE__ */ e.jsx(Ti, {}),
      onClick: r
    }
  );
}, Rl = "compatibilityType", Pl = "compatibilitySubType", Ru = (t) => (t ?? []).map(({ title: s, type: n, summaryAndValidationData: a }) => ({
  type: n,
  title: s,
  summaryAndValidationData: (a ?? []).map((r) => ({
    type: r.type,
    title: r.title,
    subTitle: r.subTitle ?? "",
    k8sObjectsSummaryReport: {
      headers: r.k8sObjectsSummaryReport?.headers ?? [],
      data: (r.k8sObjectsSummaryReport?.data ?? []).map((o, i) => ({
        id: i,
        ...o
      }))
    }
  }))
})), Pu = {}, uP = async ({ clusterId: t, targetK8sVersion: s }, n) => {
  try {
    const a = `${t}/${s}`, r = Pu[a];
    if (r && ((/* @__PURE__ */ new Date()).getTime() - r.timestamp) / 1e3 < 120)
      return r.data;
    const o = ye($.CLUSTER_PRE_UPGRADE_CHECK, {
      targetK8sVersion: s,
      clusterId: t
    }), i = {
      timeout: window._env_.CONFIGURABLE_TIMEOUT ? parseInt(window._env_.CONFIGURABLE_TIMEOUT, 10) : null,
      abortControllerRef: n
    }, { result: l } = await le(o, i), c = Ru(l);
    return Pu[a] = {
      timestamp: (/* @__PURE__ */ new Date()).getTime(),
      data: c
    }, Ru(l);
  } catch (a) {
    throw Pe(a) || V(a), a;
  }
}, x2 = ({
  clusterId: t,
  targetK8sVersion: s,
  updateTabUrl: n
}) => {
  const a = de(new AbortController()), r = Ss(), { replace: o } = Te(), i = new URLSearchParams(r.search), l = i.get(Rl), c = i.get(Pl), [d, p, m, u] = ne(
    () => uP(
      {
        targetK8sVersion: s,
        clusterId: t
      },
      a
    ),
    [t, s],
    !!s
  ), [f, _] = v({}), h = (C, b) => {
    const N = new URLSearchParams(i);
    return C ? N.set(Rl, C) : N.delete(Rl), b ? N.set(Pl, b) : N.delete(Pl), `${r.pathname}?${N.toString()}`;
  };
  J(() => () => a.current.abort(), []), J(() => {
    if (p?.length > 0) {
      const C = Object.fromEntries(
        p.map(({ type: b }) => [b, !0])
      );
      _(C);
    }
  }, [p]), J(() => {
    if (p?.length > 0 && (!l || !c)) {
      const C = l ?? p[0].type, b = h(
        C,
        c ?? p.find((N) => N.type === C)?.summaryAndValidationData?.[0]?.type
      );
      n({
        url: b
      }), o(b);
    } else {
      const C = h(l, c);
      n({
        url: C
      });
    }
  }, [l, c, p]);
  const x = (C) => {
    const b = structuredClone(f);
    b[C] ? delete b[C] : b[C] = !0, _(b);
  }, g = p?.find(({ type: C }) => C === l)?.summaryAndValidationData.find(({ type: C }) => C === c)?.k8sObjectsSummaryReport ?? {
    headers: [],
    data: []
  }, E = (p ?? []).map(
    ({ title: C, type: b, summaryAndValidationData: N }) => ({
      header: C,
      id: b,
      isExpanded: f[b],
      items: N.map((I) => {
        const T = h(b, I.type);
        return {
          title: I.title,
          subtitle: I.subTitle,
          href: T,
          isActive: () => l === b && c === I.type,
          onClick: () => {
            n({
              url: T
            });
          }
        };
      })
    })
  );
  return {
    isLoading: d || Pe(m),
    compatibilityInfoData: p,
    compatibilityError: m,
    refetchCompatibilityList: u,
    resourceListForCurrentData: g,
    sidebarConfig: E,
    onCollapseBtnClick: x
  };
}, Li = ({
  semanticPrefix: t,
  variant: s = "dropdown",
  selectInputId: n,
  clusterOptions: a,
  selectedClusterOption: r,
  handleClusterSelect: o,
  handleReload: i,
  areCurrentViewActionsDisabled: l,
  showBulkSelectionCheckbox: c = !1,
  isBulkSelectionDisabled: d = !1
}) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__align-items-center dc__gap-12 px-16", children: [
  c && /* @__PURE__ */ e.jsx(
    bo,
    {
      showPagination: !1,
      disabled: d,
      showChevronDownIcon: !1,
      selectAllIfNotPaginated: !0
    }
  ),
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 flex-grow-1", children: [
    /* @__PURE__ */ e.jsx("label", { className: "m-0 cn-7 fs-13 fw-4 lh-20", htmlFor: n, children: "Cluster" }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8", children: [
      s === "dropdown" ? /* @__PURE__ */ e.jsx("div", { className: "dc__mxw-300", children: /* @__PURE__ */ e.jsx(
        Ve,
        {
          classNamePrefix: "compare-cluster__cluster-select",
          inputId: n,
          options: a,
          value: r,
          placeholder: "Select Cluster",
          onChange: o,
          variant: cn.COMPACT,
          isDisabled: l
        }
      ) }) : r?.label && /* @__PURE__ */ e.jsx(Ie, { content: r.label, children: /* @__PURE__ */ e.jsx("h3", { className: "m-0 fs-13 lh-20 fw-6 dc__truncate", children: r.label }) }),
      r?.isProd && /* @__PURE__ */ e.jsx(Km, { label: "Production", size: O.xxs })
    ] })
  ] }),
  s === "dropdown" && r && /* @__PURE__ */ e.jsx(
    j,
    {
      dataTestId: `${t}-refetch-cluster-data-button`,
      icon: /* @__PURE__ */ e.jsx(Lo, {}),
      style: B.neutral,
      variant: w.borderLess,
      ariaLabel: "Reload resources",
      onClick: i,
      disabled: l,
      size: O.xs
    }
  )
] });
var Tt = /* @__PURE__ */ ((t) => (t.SOURCE = "source", t.TARGET = "target", t))(Tt || {}), an = /* @__PURE__ */ ((t) => (t.VIEW_ALL = "view-all", t.ONLY_MATCHING = "only-matching", t.ONLY_NON_MATCHING = "only-non-matching", t.VIEW_LEFT_JOIN = "view-left-join", t.VIEW_RIGHT_JOIN = "view-right-join", t))(an || {});
const mP = [ao.Event, ao.Node], _P = "source-cluster-select-id", fP = "target-cluster-select-id", Jh = [
  {
    label: "View all",
    value: an.VIEW_ALL,
    description: "Displays all resources from both clusters without any filters"
  },
  {
    label: "Only matching",
    value: an.ONLY_MATCHING,
    description: "Shows resources that exist in both clusters"
  },
  {
    label: "Only non-matching",
    value: an.ONLY_NON_MATCHING,
    description: "Shows resources that are present in one cluster but not the other"
  }
], hP = (t, s) => [
  ...Jh,
  {
    label: "View left join",
    value: an.VIEW_LEFT_JOIN,
    description: `Displays all resources from '${t.label}' and only matching resources from '${s.label}'`
  },
  {
    label: "View right join",
    value: an.VIEW_RIGHT_JOIN,
    description: `Displays all resources from '${s.label}' and only matching resources from '${t.label}'`
  }
], Ic = Jh[0], gP = 36, xP = 40, wu = {
  RESOURCE_DOES_NOT_EXIST: "This resource no longer exists",
  MANIFEST_NOT_AVAILABLE: "Manifest not available"
}, vc = ({
  name: t,
  namespace: s,
  onChange: n = Be,
  isResourcePresentInCluster: a,
  direction: r,
  showBgOnHover: o = !1,
  isChecked: i = !1,
  isDisabled: l = !1,
  resourceCopyButtonConfig: c
}) => {
  const d = r === "end", p = () => /* @__PURE__ */ e.jsx("div", { className: c.isVisible ? null : "dc__visibility-hidden", children: /* @__PURE__ */ e.jsx(
    j,
    {
      dataTestId: "resource-copy-button",
      ariaLabel: c.tooltip || "copy-resource",
      icon: /* @__PURE__ */ e.jsx(Ms, { className: d ? "dc__flip-180" : null }),
      variant: w.borderLess,
      onClick: c.onClick,
      size: O.xs,
      isOpacityHoverChild: !0
    }
  ) });
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `flexbox dc__align-items-center dc__content-space py-8 dc__gap-8 ${d ? "pl-28 pr-16" : "pl-16 pr-28"} ${o ? "dc__hover-n50" : ""}`,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-12", children: [
          d ? p() : /* @__PURE__ */ e.jsx(
            $e,
            {
              disabled: l,
              isChecked: i,
              onChange: n,
              value: Fe.CHECKED,
              rootClassName: "m-0"
            }
          ),
          /* @__PURE__ */ e.jsx(Ie, { content: t, children: /* @__PURE__ */ e.jsx(
            "span",
            {
              className: `${a ? "cb-5" : "cr-5 dc__opacity-0_6"} fs-13 fw-4 lh-20 dc__truncate`,
              children: t
            }
          ) })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-12", children: [
          s && /* @__PURE__ */ e.jsx(Ie, { content: s, children: /* @__PURE__ */ e.jsx(
            "span",
            {
              className: `cn-7 fs-13 fw-4 lh-20 dc__truncate ${a ? "" : "dc__opacity-0_6"}`,
              children: s
            }
          ) }),
          !d && p()
        ] })
      ]
    }
  );
}, Ac = ({
  rootClassName: t,
  showSelectionCheckbox: s = !0,
  isDisabled: n,
  isChecked: a,
  resourceGroupIdentifier: r,
  clusterResourceCount: o,
  onChange: i = Be
}) => /* @__PURE__ */ e.jsxs("div", { className: `flexbox dc__gap-12 pt-8 pb-7 px-16 dc__border-bottom-n1 ${t || ""}`, children: [
  s ? /* @__PURE__ */ e.jsx(
    $e,
    {
      disabled: n,
      isChecked: a,
      onChange: i,
      value: Fe.CHECKED,
      rootClassName: "m-0"
    }
  ) : /* @__PURE__ */ e.jsx("div", { className: "icon-dim-20 dc__no-shrink" }),
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-6", children: [
    /* @__PURE__ */ e.jsx(Ie, { content: r, children: /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-7 fs-12 fw-6 lh-18 dc__truncate", children: r }) }),
    (!!o || o === 0) && /* @__PURE__ */ e.jsx(tC, { count: o })
  ] })
] });
var er = /* @__PURE__ */ ((t) => (t.SOURCE_CLUSTER_ID = "sourceClusterId", t.TARGET_CLUSTER_ID = "targetClusterId", t.RESOURCE_LIST_FILTER = "resourceListFilter", t.COMPARE_RESOURCE_IDENTIFIER = "compareResourceIdentifier", t.COMPARE_RESOURCE_LIST_IDENTIFIER = "compareResourceListIdentifier", t))(er || {});
const EP = () => ({
  alias: {
    ...sC(),
    "resource-browser": {
      component: /* @__PURE__ */ e.jsx(Ao, { heading: "Resource Browser" }),
      linked: !0
    },
    [se.COMPARE_CLUSTERS.slice(1)]: {
      component: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-16 fw-6 lh-24", children: "Compare & Sync Clusters" }),
      linked: !1
    }
  }
}), wl = ({
  id: t,
  name: s,
  isProd: n
}) => ({
  label: s,
  value: t,
  isProd: n
}), CP = (t) => {
  const s = Number(t.get(er.SOURCE_CLUSTER_ID) || 0), n = Number(t.get(er.TARGET_CLUSTER_ID) || 0);
  return {
    sourceClusterId: s,
    targetClusterId: s !== n ? n : 0,
    resourceListFilter: t.get(
      er.RESOURCE_LIST_FILTER
    ) || Ic.value,
    compareResourceIdentifier: s && n ? t.get(er.COMPARE_RESOURCE_IDENTIFIER) : "",
    compareResourceListIdentifier: s && n ? t.get(er.COMPARE_RESOURCE_LIST_IDENTIFIER) : ""
  };
}, br = (t, s) => t ? `${t}/${s}` : s, en = ({ name: t, kind: s, group: n = "", namespace: a = "" }) => `${n}/${s}/${t}/${a}`, bP = ({
  resourceFilterType: t,
  resourceItemIdentifier: s,
  sourceKindResourceMap: n,
  targetKindResourceMap: a
}) => {
  switch (t) {
    case an.ONLY_MATCHING:
      return !!n[s] && !!a[s];
    case an.ONLY_NON_MATCHING:
      return !n[s] || !a[s];
    case an.VIEW_LEFT_JOIN:
      return !!n[s];
    case an.VIEW_RIGHT_JOIN:
      return !!a[s];
    default:
      return !0;
  }
}, eo = ({
  sourceClusterDataStore: t,
  targetClusterDataStore: s,
  resourceFilterType: n = an.VIEW_ALL,
  selectedResourceGroupIdentifierOptionsList: a = []
}) => {
  const r = structuredClone(t), o = structuredClone(s), i = a?.reduce((u, { value: f }) => (u[f] = !0, u), {}) || {}, l = Array.from(
    new Set(
      Object.keys(r.resourceDataStore).concat(
        Object.keys(o.resourceDataStore)
      )
    )
  ).filter(
    (u) => !!i[u] || !a?.length
  ), { resourceDataStore: c, identifiersMap: d, areAllResourcesPresentInBothClusters: p, totalResourceCount: m } = l.reduce(
    (u, f) => {
      const _ = r.resourceDataStore[f], h = o.resourceDataStore[f], x = _?.gvk.Group || h?.gvk.Group, g = _?.gvk.Kind || h?.gvk.Kind, E = _?.resources || [], C = h?.resources || [], b = _?.resourceMap || {}, N = h?.resourceMap || {}, I = {}, T = E.concat(C).reduce((A, S) => {
        const L = en({
          name: S.name,
          namespace: S.namespace,
          group: x,
          kind: g
        });
        return !I[L] && bP({
          resourceFilterType: n,
          resourceItemIdentifier: L,
          sourceKindResourceMap: b,
          targetKindResourceMap: N
        }) && (I[L] = !0, A.push(S)), A;
      }, []).sort((A, S) => {
        const L = A.namespace || "", R = S.namespace || "";
        return L === R ? Ce(A.name, S.name) : Ce(L, R);
      });
      return u.resourceDataStore[f] = {
        resources: T,
        identifier: f,
        group: x,
        kind: g,
        areAllResourcesPresentInBothClusters: T.every(({ name: A, namespace: S }) => {
          const L = en({
            name: A,
            namespace: S,
            group: x,
            kind: g
          });
          return !!b[L] && !!N[L];
        })
      }, u.totalResourceCount += T.length, T.forEach(({ name: A, namespace: S }) => {
        const L = en({
          name: A,
          namespace: S,
          group: x,
          kind: g
        });
        if (!b[L] || !N[L]) {
          u.areAllResourcesPresentInBothClusters = !1;
          const y = b[L] ? Tt.TARGET : Tt.SOURCE;
          u.identifiersMap[L] = {
            name: A,
            namespace: S,
            resourceListIdentifier: br(x, g),
            clusterType: y
          };
        }
      }), u;
    },
    {
      resourceDataStore: {},
      identifiersMap: {},
      areAllResourcesPresentInBothClusters: !0,
      totalResourceCount: 0
    }
  );
  return {
    sourceClusterDataStore: r,
    targetClusterDataStore: o,
    resourceDataStore: c,
    resourceGroupIdentifierList: Object.keys(c).sort(Ce),
    identifiersMap: d,
    areAllResourcesPresentInBothClusters: p,
    totalResourceCount: m
  };
}, NP = (t) => {
  const s = structuredClone(t);
  return s?.metadata?.resourceVersion && delete s.metadata.resourceVersion, gt(s);
}, Sc = (t, s) => ({
  sourceClusterDataStore: {
    clusterId: t,
    resourceDataStore: {},
    totalCount: 0
  },
  targetClusterDataStore: {
    clusterId: s,
    resourceDataStore: {},
    totalCount: 0
  },
  resourceDataStore: {},
  resourceGroupIdentifierList: [],
  identifiersMap: {},
  areAllResourcesPresentInBothClusters: !0,
  totalResourceCount: 0
}), Qh = ({
  resourceGroupIdentifierList: t,
  combinedResourcesDataStore: s,
  clusterResourceDataStore: n = {}
}) => t.reduce((a, r) => {
  const { resources: o, group: i, kind: l } = s[r], c = n[r];
  if (o?.length) {
    const d = o.map(
      ({ name: m, namespace: u }) => en({
        group: i,
        name: m,
        namespace: u,
        kind: l
      })
    );
    a[r] = {
      id: r,
      isGroup: !0,
      name: r,
      clusterResourceCount: o.length,
      children: d,
      height: gP,
      depth: 0
    };
    const p = c?.resourceMap || {};
    o.forEach(({ name: m, namespace: u }, f) => {
      const _ = d[f], h = !!p[_];
      a[_] = {
        id: _,
        name: m,
        namespace: u,
        resourceIdentifier: _,
        resourceGroupIdentifier: r,
        isResourcePresentInCluster: h,
        height: xP,
        depth: 1
      };
    });
  }
  return a;
}, {}), TP = ({
  filteredCompareClusterDataStore: t,
  resourceIdentifier: s,
  resourceListIdentifier: n
}) => {
  const { sourceClusterDataStore: a, targetClusterDataStore: r } = t, o = a.resourceDataStore[n]?.resourceMap?.[s] ?? null, i = r.resourceDataStore[n]?.resourceMap?.[s] ?? null, { name: l, namespace: c } = o ?? i ?? {}, d = t[o ? "sourceClusterDataStore" : "targetClusterDataStore"].resourceDataStore, { gvk: p } = d[n] ?? {};
  return {
    gvk: p,
    name: l,
    namespace: c,
    isResourcePresentInSourceCluster: !!o,
    isResourcePresentInTargetCluster: !!i
  };
}, Du = ({
  clusterDataStore: t,
  resource: s,
  resourceListIdentifier: n,
  resourceIdentifier: a
}) => {
  const r = t;
  return r.resourceDataStore[n].resources.push(s), r.resourceDataStore[n].resources.sort((o, i) => {
    const l = o.namespace || "", c = i.namespace || "";
    return l === c ? Ce(o.name, i.name) : Ce(l, c);
  }), r.resourceDataStore[n].resourceMap[a] = s, r.totalCount += 1, r;
}, IP = ({
  compareClusterDataStore: t,
  resourceListIdentifier: s,
  gvk: n,
  clusterType: a,
  resourceManifest: r
}) => {
  let { sourceClusterDataStore: o, targetClusterDataStore: i } = t;
  const l = zs.parse(r).metadata ?? { name: "", namespace: "" }, c = en({ ...l, group: n.Group, kind: n.Kind });
  return a === Tt.SOURCE && !o.resourceDataStore[s].resourceMap[c] ? o = Du({
    clusterDataStore: o,
    resource: l,
    resourceIdentifier: c,
    resourceListIdentifier: s
  }) : a === Tt.TARGET && !i.resourceDataStore[s].resourceMap[c] && (i = Du({
    clusterDataStore: i,
    resource: l,
    resourceIdentifier: c,
    resourceListIdentifier: s
  })), eo({
    sourceClusterDataStore: o,
    targetClusterDataStore: i
  });
}, vP = ({ clusterName: t }) => /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__align-items-center dc__content-center dc__gap-12 w-100", children: /* @__PURE__ */ e.jsxs("div", { className: "w-300 flexbox-col dc__gap-12", children: [
  /* @__PURE__ */ e.jsx(Je, { size: 20 }),
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
    /* @__PURE__ */ e.jsxs("h3", { className: "m-0 cn-9 fs-14 fw-6 lh-20 dc__truncate dc__align-center", children: [
      "Connecting to ",
      `'${t}'`
    ] }),
    /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-8 fs-13 fw-4 lh-20 dc__align-center", children: "Trying to connect to the Kubernetes cluster and fetch resources" })
  ] })
] }) }), Mu = ({
  combinedResourcesDataStore: t,
  clusterResourceDataStore: s,
  isClusterSelected: n,
  clusterFetchInfo: a,
  clusterName: r,
  reloadClusterData: o,
  resourceGroupIdentifierList: i,
  showSelectionCheckbox: l = !0,
  originalResourceCount: c,
  filteredResourceCount: d,
  handleClearFilters: p
}) => {
  const m = Q(
    () => Qh({
      combinedResourcesDataStore: t,
      resourceGroupIdentifierList: i,
      clusterResourceDataStore: s
    }),
    [t, i, s]
  ), u = (h) => {
    const { node: x } = h;
    if (x.isGroup) {
      const { name: b, clusterResourceCount: N } = x;
      return /* @__PURE__ */ e.jsx(
        Ac,
        {
          isDisabled: !0,
          showSelectionCheckbox: l,
          resourceGroupIdentifier: b,
          clusterResourceCount: N
        }
      );
    }
    const { name: g, namespace: E, isResourcePresentInCluster: C } = x;
    return /* @__PURE__ */ e.jsx(
      vc,
      {
        name: g,
        namespace: E,
        isResourcePresentInCluster: C,
        direction: l ? "start" : "end",
        resourceCopyButtonConfig: { isVisible: !1 },
        isDisabled: !0,
        showBgOnHover: !0
      }
    );
  }, f = () => /* @__PURE__ */ e.jsx(j, { dataTestId: "cluster-not-reachable-retry-btn", onClick: o, text: "Retry" }), _ = () => c ? /* @__PURE__ */ e.jsx(qt, { handleClearFilters: p }) : /* @__PURE__ */ e.jsx(
    _e,
    {
      title: "No resources found",
      subTitle: "No resources found or you do not have the required permission"
    }
  );
  return n ? a.isLoading ? /* @__PURE__ */ e.jsx(vP, { clusterName: r }) : a.error ? /* @__PURE__ */ e.jsx(
    _e,
    {
      title: `‘${r}’ is not reachable`,
      subTitle: a.error.errors?.[0]?.userMessage,
      isButtonAvailable: !0,
      renderButton: f
    }
  ) : d ? /* @__PURE__ */ e.jsx(Wm, { items: m, renderItem: u }) : _() : /* @__PURE__ */ e.jsx("div", { className: "flex", children: /* @__PURE__ */ e.jsx(_e, { title: "Select a cluster to compare with", SvgImage: uN }) });
}, ku = async (t, s, n) => {
  const a = s.filter(
    (c) => !!c?.gvk && !mP.includes(c.gvk.Kind)
  ), r = a.map(
    (c) => () => Ki(
      nC(String(t), Co.value, c, {}),
      n
    )
  ), o = await Tr(r), { resourceDataStore: i, totalCount: l } = o.reduce(
    (c, d, p) => {
      if (d.status === Mi.FULFILLED) {
        const m = (d.value?.result?.data || []).filter((_) => _.name).map((_) => ({
          name: _.name,
          namespace: _.namespace || ""
        })), { gvk: u } = a[p], f = m.reduce(
          (_, h) => {
            const x = en({
              name: h.name,
              namespace: h.namespace,
              group: u.Group,
              kind: u.Kind
            });
            return _[x] = h, _;
          },
          {}
        );
        return c.resourceDataStore[br(u.Group, u.Kind)] = {
          gvk: u,
          resources: m,
          resourceMap: f
        }, c.totalCount += m.length, c;
      }
      return c.resourceDataStore[br(
        a[p].gvk.Group,
        a[p].gvk.Kind
      )] = {
        gvk: a[p].gvk,
        resources: [],
        resourceMap: {}
      }, c;
    },
    {
      resourceDataStore: {},
      totalCount: 0
    }
  );
  return {
    clusterId: t,
    resourceDataStore: i,
    totalCount: l
  };
}, AP = async ({
  sourceClusterId: t,
  targetClusterId: s,
  compareClusterDataStore: n,
  signal: a
}) => {
  const r = structuredClone(n);
  if (!t && !s)
    return {
      sourceClusterDataStore: r.sourceClusterDataStore,
      targetClusterDataStore: r.targetClusterDataStore
    };
  const o = await Promise.allSettled([
    t ? up(String(t)) : null,
    s ? up(String(s)) : null
  ]);
  if ((!t || o[0].status === "rejected") && (!s || o[1].status === "rejected")) {
    if (o[0].status === "rejected")
      throw o[0].reason;
    if (o[1].status === "rejected")
      throw o[1].reason;
  }
  const i = o[0].status === "fulfilled" ? o[0].value?.result?.apiResources : [], l = o[1].status === "fulfilled" ? o[1].value?.result?.apiResources : [], c = t ? await ku(t, i, a) : r.sourceClusterDataStore, d = s ? await ku(s, l, a) : r.targetClusterDataStore;
  return {
    sourceClusterDataStore: c,
    targetClusterDataStore: d
  };
}, Dl = async ({
  sourceClusterId: t,
  targetClusterId: s,
  compareClusterDataStore: n,
  signal: a
}) => {
  const r = structuredClone(n) || Sc(t, s);
  if (!t && !s)
    return r;
  const { sourceClusterDataStore: o, targetClusterDataStore: i } = await AP({
    sourceClusterId: t,
    targetClusterId: s,
    compareClusterDataStore: r,
    signal: a
  });
  return eo({
    sourceClusterDataStore: o,
    targetClusterDataStore: i
  });
}, SP = async (t, { name: s, namespace: n, manifestSourceClusterId: a, creationTargetClusterId: r, gvk: o }) => {
  const i = Dc({
    clusterId: a,
    group: o.Group,
    version: o.Version,
    kind: o.Kind,
    name: s,
    namespace: n
  }), {
    result: {
      manifestResponse: { manifest: l }
    }
  } = await we(Ws.K8S_RESOURCE, i, { abortControllerRef: t }), c = await Nm({
    clusterId: r,
    manifest: NP(l)
  });
  J_(c);
}, Fu = async ({ name: t, namespace: s, clusterId: n, gvk: a }, r) => {
  try {
    const {
      manifestResponse: { manifest: o }
    } = await Qi({
      name: t,
      namespace: s,
      clusterId: n,
      gvk: a,
      abortControllerRef: r
    });
    return o ? gt(o) : "";
  } catch (o) {
    if (!Pe(o)) {
      if (o.errors?.[0]?.code && +o.errors[0].code === Ns.NOT_FOUND)
        return null;
      V(o);
    }
    throw o;
  }
}, Uu = ({
  isResourcePresentInCluster: t,
  clusterId: s,
  manifest: n,
  gvk: a,
  name: r,
  namespace: o
}) => t ? Zi({
  clusterId: s,
  gvk: a,
  name: r,
  namespace: o,
  manifest: n
}) : xd({
  clusterId: s,
  manifest: n
}), yP = ({
  compareClusterDataStore: t,
  resourceGroupIdentifier: s
}) => {
  const { selectedIdentifiers: n, handleBulkSelection: a } = It(), { resources: r, areAllResourcesPresentInBothClusters: o, group: i, kind: l } = t.resourceDataStore[s], c = t.sourceClusterDataStore.resourceDataStore[s], d = t.targetClusterDataStore.resourceDataStore[s], p = c?.resourceMap || {}, m = d?.resourceMap || {}, u = r.filter(
    (x) => !!p[en({ group: i, kind: l, ...x })]
  ).length, f = r.filter(
    (x) => !!m[en({ group: i, kind: l, ...x })]
  ).length, _ = !o && r.every(({ name: x, namespace: g }) => {
    const E = en({
      name: x,
      namespace: g,
      group: i,
      kind: l
    });
    return !p[E] || !m[E] ? !!n[E] : !0;
  }), h = () => {
    if (_) {
      a({
        action: st.CLEAR_IDENTIFIERS,
        data: {
          identifierIds: r.map(
            ({ name: g, namespace: E }) => en({
              name: g,
              namespace: E,
              group: i,
              kind: l
            })
          )
        }
      });
      return;
    }
    const x = r.reduce((g, { name: E, namespace: C }) => {
      const b = en({
        name: E,
        namespace: C,
        group: i,
        kind: l
      });
      if (!p[b] || !m[b]) {
        const I = p[b] ? Tt.TARGET : Tt.SOURCE;
        g[b] = {
          name: E,
          namespace: C,
          resourceListIdentifier: br(i, l),
          clusterType: I
        };
      }
      return g;
    }, {});
    a({
      action: st.SELECT_IDENTIFIER,
      data: {
        identifierObject: x
      }
    });
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "dc__grid-half", children: [
    /* @__PURE__ */ e.jsx(
      Ac,
      {
        isDisabled: o,
        isChecked: _,
        resourceGroupIdentifier: s,
        clusterResourceCount: u,
        onChange: h
      }
    ),
    /* @__PURE__ */ e.jsx(
      Ac,
      {
        showSelectionCheckbox: !1,
        resourceGroupIdentifier: s,
        clusterResourceCount: f
      }
    )
  ] });
}, LP = ({
  compareClusterDataStore: t,
  name: s,
  namespace: n,
  resourceIdentifier: a,
  resourceGroupIdentifier: r,
  handleOpenSourceClusterSingleResourceCreationDialog: o,
  handleOpenTargetClusterSingleResourceCreationDialog: i,
  handleCompareResource: l,
  sourceClusterName: c,
  targetClusterName: d
}) => {
  const { selectedIdentifiers: p, handleBulkSelection: m } = It(), { group: u, kind: f } = t.resourceDataStore[r], _ = t.sourceClusterDataStore.resourceDataStore[r], h = t.targetClusterDataStore.resourceDataStore[r], x = _?.resourceMap || {}, g = h?.resourceMap || {}, E = () => {
    if (p[a]) {
      m({
        action: st.CLEAR_IDENTIFIERS,
        data: {
          identifierIds: [a]
        }
      });
      return;
    }
    if (!x[a] || !g[a]) {
      const S = x[a] ? Tt.TARGET : Tt.SOURCE;
      m({
        action: st.SELECT_IDENTIFIER,
        data: {
          identifierObject: {
            [a]: {
              name: s,
              namespace: n,
              resourceListIdentifier: br(u, f),
              clusterType: S
            }
          }
        }
      });
    }
  }, C = (A = !0) => () => A ? o(a) : i(a), b = () => {
    l({
      resourceIdentifier: a,
      resourceListIdentifier: br(u, f)
    });
  }, N = !!x[a], I = !!g[a], T = !!p[a];
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `dc__grid-half dc__hover-n50 dc__opacity-hover dc__opacity-hover--parent ${T ? "bc-b50" : ""}`,
      children: [
        /* @__PURE__ */ e.jsx(
          vc,
          {
            name: s,
            namespace: n,
            onChange: E,
            isResourcePresentInCluster: N,
            direction: "start",
            isChecked: T,
            isDisabled: N && I,
            resourceCopyButtonConfig: {
              isVisible: N && !I,
              onClick: C(!1),
              tooltip: `Create resource in ${d}`
            }
          }
        ),
        /* @__PURE__ */ e.jsx("div", { className: "dc__align-reload-center dc__zi-20 dc__opacity-hover--child bg__primary", children: /* @__PURE__ */ e.jsx(
          j,
          {
            dataTestId: "compare-resources-button",
            ariaLabel: "Compare manifest",
            icon: /* @__PURE__ */ e.jsx(Ti, {}),
            variant: w.secondary,
            style: B.neutral,
            size: O.xs,
            onClick: b
          }
        ) }),
        /* @__PURE__ */ e.jsx(
          vc,
          {
            name: s,
            namespace: n,
            isResourcePresentInCluster: I,
            direction: "end",
            resourceCopyButtonConfig: {
              isVisible: !N && I,
              onClick: C(),
              tooltip: `Create resource in ${c}`
            }
          }
        )
      ]
    }
  );
}, jP = ({
  filteredCompareClusterDataStore: t,
  handleOpenSourceClusterSingleResourceCreationDialog: s,
  handleOpenTargetClusterSingleResourceCreationDialog: n,
  handleCompareResource: a,
  sourceClusterName: r,
  targetClusterName: o
}) => {
  const i = Q(
    () => Qh({
      combinedResourcesDataStore: t.resourceDataStore,
      resourceGroupIdentifierList: t.resourceGroupIdentifierList
    }),
    [
      t.resourceDataStore,
      t.resourceGroupIdentifierList
    ]
  ), l = ({ node: c }) => {
    if (c.isGroup) {
      const { name: f } = c;
      return /* @__PURE__ */ e.jsx(
        yP,
        {
          resourceGroupIdentifier: f,
          compareClusterDataStore: t
        }
      );
    }
    const { name: d, namespace: p, resourceGroupIdentifier: m, resourceIdentifier: u } = c;
    return /* @__PURE__ */ e.jsx(
      LP,
      {
        name: d,
        namespace: p,
        resourceGroupIdentifier: m,
        resourceIdentifier: u,
        compareClusterDataStore: t,
        handleOpenSourceClusterSingleResourceCreationDialog: s,
        handleOpenTargetClusterSingleResourceCreationDialog: n,
        handleCompareResource: a,
        sourceClusterName: r,
        targetClusterName: o
      }
    );
  };
  return /* @__PURE__ */ e.jsx(
    Wm,
    {
      className: "flex-grow-1 vertical-divider vertical-divider--zi-2 dc__zi-0",
      items: i,
      renderItem: l
    }
  );
}, OP = ({
  sourceClusterFetchInfo: t,
  targetClusterFetchInfo: s,
  handleFetchSourceClusterData: n,
  handleFetchTargetClusterData: a,
  clusterOptions: r,
  selectedSourceClusterOption: o,
  selectedTargetClusterOption: i,
  compareClusterDataStore: l,
  filteredCompareClusterDataStore: c,
  selectedResourceGroupIdentifierOptionsList: d,
  setSelectedResourceGroupIdentifierOptionsList: p,
  resourceListFilter: m,
  setResourceListFilter: u,
  handleCompareResource: f
}) => {
  const { selectedIdentifiers: _, handleBulkSelection: h } = It(), [x, g] = v(null), [E, C] = v(null), b = Q(() => {
    const te = l.resourceGroupIdentifierList || [], De = l.sourceClusterDataStore.resourceDataStore, We = l.targetClusterDataStore.resourceDataStore, pe = te.reduce((Ye, dt) => {
      const At = De[dt], Lt = We[dt], hs = At?.gvk || Lt?.gvk, _s = hs?.Group || "K8sEmptyGroup", ys = hs?.Kind || dt;
      return Ye[_s] || (Ye[_s] = []), Ye[_s].push({
        label: ys,
        value: dt,
        tooltipProps: {
          content: ys,
          placement: "right"
        }
      }), Ye;
    }, {});
    return Object.keys(pe).map(
      (Ye) => {
        const dt = pe[Ye];
        return {
          label: Ye,
          options: dt.sort(
            (At, Lt) => Ce(At.label, Lt.label)
          )
        };
      }
    );
  }, [l]), N = Q(
    () => o && i ? hP(o, i) : [],
    [o, i]
  ), I = () => {
    h({
      action: st.CLEAR_ALL_SELECTIONS
    });
  }, T = (te) => {
    I(), u(te.value);
  }, A = (te) => {
    I(), p(te || []);
  }, S = () => {
    I(), m !== Ic.value && T(Ic), A([]);
  }, L = async (te) => {
    te.value !== o?.value && (I(), await n(te.value));
  }, R = async (te) => {
    te.value !== i?.value && (I(), await a(te.value));
  }, y = async () => {
    I(), await n(+o.value);
  }, M = async () => {
    i && (I(), await a(+i.value));
  }, P = () => {
    C(Tt.TARGET);
  }, U = () => {
    C(Tt.SOURCE);
  }, G = () => {
    g(null), C(null);
  }, H = (te) => {
    g(te), U();
  }, oe = (te) => {
    g(te), P();
  }, ae = (te) => {
    const De = te.kind.reduce((pe, Ye) => (pe[Ye] = !0, pe), {}), We = d.filter(
      ({ label: pe }) => De[pe]
    );
    A(We);
  }, re = () => {
    A([]);
  }, k = Object.keys(_ || {}), D = k.length, { sourceClusterSelectedIdentifiers: F, targetClusterSelectedIdentifiers: q } = k.reduce(
    (te, De) => {
      const We = _[De];
      return We.clusterType === Tt.SOURCE ? te.sourceClusterSelectedIdentifiers.push(De) : We.clusterType === Tt.TARGET && te.targetClusterSelectedIdentifiers.push(De), te;
    },
    {
      sourceClusterSelectedIdentifiers: [],
      targetClusterSelectedIdentifiers: []
    }
  ), be = () => {
    const te = E === Tt.SOURCE ? o.value : i.value, De = E === Tt.SOURCE ? i.value : o.value, We = E === Tt.SOURCE ? F : q, pe = x ? [x] : We, Ye = E === Tt.SOURCE ? l.targetClusterDataStore.resourceDataStore : l.sourceClusterDataStore.resourceDataStore;
    return pe.map((dt) => {
      const { name: At, namespace: Lt, resourceListIdentifier: hs } = c.identifiersMap[dt], { gvk: _s } = Ye[hs];
      return {
        name: At,
        additionalKeys: [
          { label: "Namespace", value: Lt, isSortable: !0, width: "150px" },
          { label: "Kind", value: _s.Kind, isSortable: !0, width: "150px" }
        ],
        operation: (ys) => SP(ys, {
          name: At,
          namespace: Lt,
          manifestSourceClusterId: De,
          creationTargetClusterId: te,
          gvk: _s
        })
      };
    });
  }, fe = !!o && !!i, Ge = t.isLoading || s.isLoading, xe = t.error || s.error, Se = fe && !Ge && !xe && !c.areAllResourcesPresentInBothClusters, ze = (te) => te.Pending || te.Progressing ? /* @__PURE__ */ e.jsx("span", { className: "dc__loading-dots", children: "Creating" }) : `${te.Completed} resource(s) created`, nt = () => {
    const te = E === Tt.SOURCE ? o.label : i.label, De = be(), We = De.length === 1;
    return /* @__PURE__ */ e.jsx(
      So,
      {
        confirmationModalConfig: {
          title: We ? `Create resource in '${te}'` : `Create ${De.length} resources in '${te}'`,
          subtitle: `${We ? `This will create the ${De[0].additionalKeys.find(({ label: pe }) => pe === "Kind").value} / ${De[0].name} in the ${te}.` : `This will create the selected resources in the ${te}.`}. Are you sure?`,
          variant: Ct.info,
          confirmationConfig: {
            identifier: "resource-creation-confirmation",
            confirmationKeyword: te
          },
          buttonConfig: {
            primaryButtonConfig: {
              text: We ? "Create resource" : "Create resources"
            },
            secondaryButtonConfig: {
              text: "Cancel"
            }
          }
        },
        getResultsChartSummaryText: ze,
        handleModalClose: G,
        handleReloadDataAfterBulkOperation: E === Tt.SOURCE ? y : M,
        textConfig: {
          resultsHeader: "Resource creation status",
          prompt: Nn
        },
        operations: De
      }
    );
  }, K = () => {
    const te = !fe || !!xe, De = l.totalResourceCount, We = c.totalResourceCount;
    return te || Ge ? /* @__PURE__ */ e.jsxs("div", { className: "dc__grid-half vertical-divider vertical-divider--zi-2 flex-grow-1 dc__zi-0 mh-0", children: [
      /* @__PURE__ */ e.jsx(
        Mu,
        {
          resourceGroupIdentifierList: c.resourceGroupIdentifierList,
          combinedResourcesDataStore: c.resourceDataStore,
          clusterResourceDataStore: c.sourceClusterDataStore.resourceDataStore,
          isClusterSelected: !!o,
          clusterFetchInfo: t,
          clusterName: o?.label,
          reloadClusterData: y,
          originalResourceCount: De,
          filteredResourceCount: We,
          handleClearFilters: S
        }
      ),
      /* @__PURE__ */ e.jsx(
        Mu,
        {
          resourceGroupIdentifierList: c.resourceGroupIdentifierList,
          combinedResourcesDataStore: c.resourceDataStore,
          clusterResourceDataStore: c.targetClusterDataStore.resourceDataStore,
          isClusterSelected: !!i,
          clusterFetchInfo: s,
          clusterName: i?.label,
          reloadClusterData: M,
          showSelectionCheckbox: !1,
          originalResourceCount: De,
          filteredResourceCount: We,
          handleClearFilters: S
        }
      )
    ] }) : De ? We ? /* @__PURE__ */ e.jsx(
      jP,
      {
        filteredCompareClusterDataStore: c,
        handleOpenSourceClusterSingleResourceCreationDialog: H,
        handleOpenTargetClusterSingleResourceCreationDialog: oe,
        handleCompareResource: f,
        sourceClusterName: o.label,
        targetClusterName: i.label
      }
    ) : /* @__PURE__ */ e.jsx(qt, { handleClearFilters: S }) : /* @__PURE__ */ e.jsx(
      _e,
      {
        title: "No resources found",
        subTitle: "No resources found or you do not have the required permission"
      }
    );
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1 flexbox-col mh-0", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1 flexbox-col mh-0", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col px-16 py-12 dc__gap-6", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12 dc__align-items-center", children: [
            /* @__PURE__ */ e.jsx(
              Ps,
              {
                isDisabled: !1,
                isLoading: !1,
                placeholder: "Kind",
                inputId: "compare-clusters__resource-group-identifier-select",
                options: b,
                appliedFilterOptions: d,
                handleApplyFilter: A
              }
            ),
            o && i && /* @__PURE__ */ e.jsx(
              Ve,
              {
                inputId: "compare-clusters__resource-filter-select",
                options: N,
                value: wc(
                  N,
                  m,
                  null
                ),
                onChange: T,
                isClearable: !1,
                menuSize: O.large
              }
            )
          ] }),
          /* @__PURE__ */ e.jsx(
            Ga,
            {
              filterConfig: {
                kind: d.map(({ label: te }) => te)
              },
              onRemoveFilter: ae,
              clearFilters: re
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 mh-0", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "dc__grid-half vertical-divider pt-8 pb-7 dc__border-bottom-n1", children: [
            /* @__PURE__ */ e.jsx(
              Li,
              {
                semanticPrefix: "source-cluster",
                selectInputId: _P,
                clusterOptions: r.filter(
                  (te) => te.value !== i?.value
                ),
                selectedClusterOption: o,
                handleClusterSelect: L,
                handleReload: y,
                showBulkSelectionCheckbox: !0,
                isBulkSelectionDisabled: !Se,
                areCurrentViewActionsDisabled: t.isLoading || s.isLoading
              }
            ),
            /* @__PURE__ */ e.jsx(
              Li,
              {
                semanticPrefix: "target-cluster",
                selectInputId: fP,
                clusterOptions: r.filter(
                  (te) => te.value !== o?.value
                ),
                selectedClusterOption: i,
                handleClusterSelect: R,
                handleReload: M,
                areCurrentViewActionsDisabled: s.isLoading || t.isLoading
              }
            )
          ] }),
          K()
        ] })
      ] }),
      D > 0 && /* @__PURE__ */ e.jsxs("div", { className: "dc__grid-half vertical-divider dc__border-top dc__no-shrink", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__align-items-center px-16 py-12", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12 dc__align-items-center", children: [
            /* @__PURE__ */ e.jsx(
              j,
              {
                dataTestId: "deselect-all-resources-button",
                variant: w.borderLess,
                style: B.negative,
                onClick: I,
                icon: /* @__PURE__ */ e.jsx(vt, {}),
                ariaLabel: "Deselect all resources",
                showAriaLabelInTippy: !1,
                size: O.small
              }
            ),
            /* @__PURE__ */ e.jsxs("span", { className: "cn-9 fs-13 fw-6 lh-20 dc__word-break", children: [
              D,
              " resources selected"
            ] })
          ] }),
          q.length > 0 && /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: "create-resources-in-target-cluster-button",
              text: `Create ${q.length} resources`,
              size: O.small,
              endIcon: /* @__PURE__ */ e.jsx(Ms, {}),
              onClick: P
            }
          )
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center px-16 py-10", children: F.length > 0 && /* @__PURE__ */ e.jsx(
          j,
          {
            dataTestId: "create-resources-in-source-cluster-button",
            text: `Create ${F.length} resources`,
            size: O.small,
            startIcon: /* @__PURE__ */ e.jsx(Ms, { className: "dc__flip-180" }),
            onClick: U
          }
        ) })
      ] })
    ] }),
    !!E && nt()
  ] });
}, Gu = ({ errorMsg: t }) => /* @__PURE__ */ e.jsxs("div", { className: "dc__text-center flex-grow-1 flexbox-col dc__align-items-center dc__content-center", children: [
  /* @__PURE__ */ e.jsx(mN, { className: "fcn-7 icon-dim-32" }),
  /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-14", children: t })
] }), RP = ({
  resourceIdentifier: t,
  resourceListIdentifier: s,
  filteredCompareClusterDataStore: n,
  selectedSourceClusterOption: a,
  selectedTargetClusterOption: r,
  handleGoBack: o,
  setCompareClusterDataStore: i
}) => {
  const [l, c] = v(!0), [d, p] = v(!1), [m, u] = v({
    value: "",
    hasError: !1,
    isSuccess: !1,
    hasUnsavedChanges: !1
  }), [f, _] = v({
    value: "",
    hasError: !1,
    isSuccess: !1,
    hasUnsavedChanges: !1
  }), h = de(new AbortController()), x = de(new AbortController()), g = de(!0), E = de({ source: !1, target: !1 }), C = a.value, b = r.value, N = l || d, { gvk: I, isResourcePresentInSourceCluster: T, isResourcePresentInTargetCluster: A, name: S, namespace: L } = TP({ filteredCompareClusterDataStore: n, resourceIdentifier: t, resourceListIdentifier: s }), [R, y, M, P] = ne(
    () => es(
      () => Fu({ gvk: I, name: S, clusterId: C, namespace: L }, h),
      h
    ),
    [],
    T
  ), [U, G, H, oe] = ne(
    () => es(
      () => Fu({ gvk: I, name: S, clusterId: b, namespace: L }, x),
      x
    ),
    [],
    A
  ), ae = T || A, k = !R && !U && (!M && !H), D = R || U, F = D || d, q = m.hasUnsavedChanges || f.hasUnsavedChanges;
  Di({ shouldPrompt: q }), J(
    () => () => {
      h.current.abort(), x.current.abort();
    },
    []
  ), J(() => {
    R || (u({
      value: y ?? "",
      hasError: !1,
      hasUnsavedChanges: !1,
      isSuccess: E.current.source
    }), E.current.source = !1);
  }, [R, y]), J(() => {
    U || (_({
      value: G ?? "",
      hasError: !1,
      hasUnsavedChanges: !1,
      isSuccess: E.current.target
    }), E.current.target = !1);
  }, [U, G]);
  const be = () => {
    c(!1);
  }, fe = (pe) => {
    _({
      ...f,
      value: pe,
      hasError: !1,
      hasUnsavedChanges: pe !== (G ?? "")
    });
  }, Ge = (pe) => {
    u({
      ...m,
      value: pe,
      hasError: !1,
      hasUnsavedChanges: pe !== (y ?? "")
    });
  }, xe = () => {
    c(!0), u({
      value: y ?? "",
      hasUnsavedChanges: !1,
      hasError: !1,
      isSuccess: !1
    }), _({
      value: G ?? "",
      hasUnsavedChanges: !1,
      hasError: !1,
      isSuccess: !1
    });
  }, Se = ({
    clusterType: pe,
    resourceManifest: Ye
  }) => {
    i(
      (dt) => IP({
        compareClusterDataStore: dt,
        clusterType: pe,
        gvk: I,
        resourceListIdentifier: s,
        resourceManifest: Ye
      })
    );
  }, ze = async () => {
    try {
      p(!0);
      const [pe, Ye] = await Promise.allSettled([
        m.hasUnsavedChanges ? Uu({
          isResourcePresentInCluster: T,
          clusterId: C,
          manifest: m.value,
          gvk: I,
          name: S,
          namespace: L
        }) : null,
        f.hasUnsavedChanges ? Uu({
          isResourcePresentInCluster: A,
          clusterId: b,
          manifest: f.value,
          gvk: I,
          name: S,
          namespace: L
        }) : null
      ]);
      pe.status === "fulfilled" && Ye.status === "fulfilled" ? (Z.showToast({
        variant: ee.success,
        description: "Changes applied successfully"
      }), pe.value && (Se({
        clusterType: Tt.SOURCE,
        resourceManifest: m.value
      }), P()), Ye.value && (Se({
        clusterType: Tt.TARGET,
        resourceManifest: f.value
      }), oe()), p(!1), c(!0)) : pe.status === "fulfilled" && pe.value ? (E.current.source = !0, Se({
        clusterType: Tt.SOURCE,
        resourceManifest: m.value
      }), P()) : Ye.status === "fulfilled" && Ye.value && (E.current.target = !0, Se({
        clusterType: Tt.TARGET,
        resourceManifest: f.value
      }), oe()), pe.status === "rejected" && (u((dt) => ({
        ...dt,
        hasError: !0,
        isSuccess: !1
      })), V(pe.reason)), Ye.status === "rejected" && (_((dt) => ({
        ...dt,
        hasError: !0,
        isSuccess: !1
      })), V(Ye.reason)), (pe.status === "rejected" || Ye.status === "rejected") && p(!1);
    } catch (pe) {
      p(!1), V(pe);
    }
  }, nt = () => l ? /* @__PURE__ */ e.jsx(
    j,
    {
      dataTestId: "edit-yaml-button",
      startIcon: /* @__PURE__ */ e.jsx(Fs, {}),
      variant: w.borderLess,
      size: O.small,
      text: "Edit YAML",
      disabled: D,
      onClick: be
    }
  ) : /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-12", children: [
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "apply-yaml-changes-button",
        startIcon: /* @__PURE__ */ e.jsx(qs, {}),
        variant: w.borderLess,
        size: O.small,
        text: "Apply Changes",
        isLoading: F,
        disabled: F,
        onClick: ze
      }
    ),
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "cancel-yaml-changes-button",
        variant: w.text,
        style: B.neutral,
        size: O.small,
        text: "Cancel",
        disabled: F,
        onClick: xe
      }
    )
  ] }), K = ({ hasError: pe, isSuccess: Ye, hasUnsavedChanges: dt }) => pe ? /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-6 mr-16", children: [
    /* @__PURE__ */ e.jsx(h_, { className: "icon-dim-16" }),
    /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-13 lh-20 cr-5", children: "Failed to apply changes" })
  ] }) : dt ? /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-6 mr-16", children: [
    /* @__PURE__ */ e.jsx("span", { className: "w-8 h-8 dc__border-radius-50-per bcy-5" }),
    /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-13 lh-20 cn-7", children: "Unsaved changes" })
  ] }) : Ye ? /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-6 mr-16", children: [
    /* @__PURE__ */ e.jsx(qs, { className: "icon-dim-16 scg-5" }),
    /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-13 lh-20 cg-7", children: "Changes applied" })
  ] }) : null, te = (pe, Ye, dt, At) => pe ? /* @__PURE__ */ e.jsx(Je, { pageLoader: !0 }) : Ye ? /* @__PURE__ */ e.jsx(Gu, { errorMsg: wu.MANIFEST_NOT_AVAILABLE }) : /* @__PURE__ */ e.jsx(
    Gt,
    {
      mode: Ts.YAML,
      noParsing: !0,
      readOnly: N,
      value: dt,
      height: "100%",
      onChange: At
    }
  ), De = () => /* @__PURE__ */ e.jsx("div", { className: "flex h-100", children: /* @__PURE__ */ e.jsxs("div", { className: "dc__align-self-stretch flex-grow-1 dc__grid-half vertical-divider", children: [
    te(
      R,
      M,
      m.value,
      Ge
    ),
    te(
      U,
      H,
      f.value,
      fe
    )
  ] }) }), We = () => g.current && (R || U) ? (g.current = !1, /* @__PURE__ */ e.jsx(Je, { pageLoader: !0 })) : k ? /* @__PURE__ */ e.jsx(
    Gt,
    {
      mode: Ts.YAML,
      noParsing: !0,
      diffView: !0,
      readOnly: N,
      originalValue: m.value,
      modifiedValue: f.value,
      height: "fitToParent",
      isOriginalModifiable: !0,
      onOriginalValueChange: Ge,
      onModifiedValueChange: fe
    }
  ) : De();
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(jo, { when: q, message: aC }),
    /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1 flexbox-col mh-0", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__content-space px-16 py-10", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-12 py-2", children: [
          /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: "go-back-to-clusters-resource-list",
              ariaLabel: "go-back-to-clusters-resource-list",
              icon: /* @__PURE__ */ e.jsx(Ms, { className: "dc__flip-180" }),
              variant: w.secondary,
              style: B.neutral,
              size: O.xs,
              showAriaLabelInTippy: !1,
              onClick: o,
              disabled: d
            }
          ),
          ae && /* @__PURE__ */ e.jsx("h2", { className: "m-0 fs-14 lh-20 fw-6", children: `${I.Kind} / ${S}` })
        ] }),
        ae && k && nt()
      ] }),
      ae ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1 dc__grid-half vertical-divider pt-8 pb-7 dc__border-bottom-n1", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__content-space", children: [
              /* @__PURE__ */ e.jsx(
                Li,
                {
                  variant: "text",
                  semanticPrefix: "source-cluster",
                  selectedClusterOption: a
                }
              ),
              K(m)
            ] }),
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__content-space", children: [
              /* @__PURE__ */ e.jsx(
                Li,
                {
                  variant: "text",
                  semanticPrefix: "target-cluster",
                  selectedClusterOption: r
                }
              ),
              K(f)
            ] })
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: `dc__align-self-stretch ${l ? "px-15" : "px-5"}` })
        ] }),
        We()
      ] }) : /* @__PURE__ */ e.jsx(Gu, { errorMsg: wu.RESOURCE_DOES_NOT_EXIST })
    ] })
  ] });
}, PP = () => Io.CLOSED, wP = ({ clusterList: t }) => {
  const {
    sourceClusterId: s,
    targetClusterId: n,
    resourceListFilter: a,
    compareResourceIdentifier: r,
    compareResourceListIdentifier: o,
    updateSearchParams: i
  } = _t({
    parseSearchParams: CP
  }), [l, c] = v([]), [d, p] = v({
    isLoading: !1,
    error: null
  }), [m, u] = v({
    isLoading: !1,
    error: null
  }), f = de(new AbortController()), [
    _,
    h,
    x,
    g,
    E
  ] = ne(
    () => Dl({
      sourceClusterId: s,
      targetClusterId: n,
      signal: f.current.signal
    })
  );
  J(
    () => () => {
      f.current.abort();
    },
    []
  ), J(() => {
    p({ isLoading: _ && !!s, error: null }), u({ isLoading: _ && !!n, error: null });
  }, [_]);
  const C = !!(r && o), b = Q(
    () => h ? eo({
      sourceClusterDataStore: h.sourceClusterDataStore,
      targetClusterDataStore: h.targetClusterDataStore,
      resourceFilterType: a,
      selectedResourceGroupIdentifierOptionsList: l
    }) : Sc(s, n),
    [h, a, l]
  ), N = t.map(({ id: G, name: H, isProd: oe }) => wl({ id: G, name: H, isProd: oe })).sort((G, H) => Ce(G.label.toString(), H.label.toString())), { selectedSourceClusterOption: I, selectedTargetClusterOption: T } = t.reduce(
    (G, { id: H, name: oe, isProd: ae }) => (H === s ? G.selectedSourceClusterOption = wl({
      id: s,
      name: oe || "",
      isProd: ae
    }) : H === n && (G.selectedTargetClusterOption = wl({
      id: n,
      name: oe || "",
      isProd: ae
    })), G),
    { selectedSourceClusterOption: null, selectedTargetClusterOption: null }
  ), A = (G) => {
    i({ sourceClusterId: G });
  }, S = (G) => {
    i({ targetClusterId: G });
  }, L = (G) => {
    i({ resourceListFilter: G });
  }, R = ({
    resourceIdentifier: G,
    resourceListIdentifier: H
  }) => {
    i(
      {
        compareResourceIdentifier: G,
        compareResourceListIdentifier: H
      },
      {
        // Intentionally using push here to allow user to go back to the previous screen
        // But there are certain limitations when the user goes back to the previous screen and
        // and changes the cluster.
        redirectionMethod: "push"
      }
    );
  }, y = () => {
    i({ compareResourceIdentifier: null, compareResourceListIdentifier: null });
  }, M = async (G) => {
    p({
      isLoading: !0,
      error: null
    }), A(G), E(
      eo({
        sourceClusterDataStore: {
          clusterId: G,
          resourceDataStore: {},
          totalCount: 0
        },
        targetClusterDataStore: h.targetClusterDataStore
      })
    );
    try {
      const H = await Dl({
        sourceClusterId: G,
        // Can go with old data store since only source cluster is changing which anyways will be updated
        compareClusterDataStore: h,
        signal: f.current.signal
      });
      f.current = new AbortController(), E(H), p({
        isLoading: !1,
        error: null
      });
    } catch (H) {
      p({
        isLoading: !1,
        error: H
      });
    }
  }, P = async (G) => {
    u({
      isLoading: !0,
      error: null
    }), S(G), E(
      eo({
        sourceClusterDataStore: h.sourceClusterDataStore,
        targetClusterDataStore: {
          clusterId: G,
          resourceDataStore: {},
          totalCount: 0
        }
      })
    );
    try {
      const H = await Dl({
        targetClusterId: G,
        // Can go with old data store since only target cluster is changing which anyways will be updated
        compareClusterDataStore: h,
        signal: f.current.signal
      });
      f.current = new AbortController(), E(H), u({
        isLoading: !1,
        error: null
      });
    } catch (H) {
      u({
        isLoading: !1,
        error: H
      });
    }
  }, U = () => C ? /* @__PURE__ */ e.jsx(
    RP,
    {
      resourceIdentifier: r,
      resourceListIdentifier: o,
      filteredCompareClusterDataStore: b,
      selectedSourceClusterOption: I,
      selectedTargetClusterOption: T,
      handleGoBack: y,
      setCompareClusterDataStore: E
    }
  ) : /* @__PURE__ */ e.jsx(
    Ui,
    {
      identifiers: b.identifiersMap,
      getSelectAllDialogStatus: PP,
      children: /* @__PURE__ */ e.jsx(
        OP,
        {
          sourceClusterFetchInfo: d,
          targetClusterFetchInfo: m,
          handleFetchSourceClusterData: M,
          handleFetchTargetClusterData: P,
          clusterOptions: N,
          selectedSourceClusterOption: I,
          selectedTargetClusterOption: T,
          compareClusterDataStore: h ?? Sc(s, n),
          filteredCompareClusterDataStore: b,
          selectedResourceGroupIdentifierOptionsList: l,
          setSelectedResourceGroupIdentifierOptionsList: c,
          resourceListFilter: a,
          setResourceListFilter: L,
          handleCompareResource: R
        }
      )
    }
  );
  return /* @__PURE__ */ e.jsx(
    Ke,
    {
      isLoading: C && _,
      progressingProps: {
        pageLoader: !0
      },
      error: x,
      errorScreenManagerProps: {
        code: x?.code,
        reload: g,
        redirectURL: se.INFRASTRUCTURE_MANAGEMENT_RESOURCE_BROWSER
      },
      children: U()
    }
  );
}, E2 = () => {
  const [t, s, n, a] = ne(
    () => rC()
  ), { breadcrumbs: r } = yr(EP()), o = () => /* @__PURE__ */ e.jsx(Lr, { breadcrumbs: r }), i = (s?.result || []).filter((l) => !l.isVirtualCluster);
  return /* @__PURE__ */ e.jsxs("div", { className: "bg__primary flexbox-col h-100 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsx(Yi, { isBreadcrumbs: !0, breadCrumbs: o, docPath: Kc.INFRA_MANAGEMENT }),
    /* @__PURE__ */ e.jsx(
      Ke,
      {
        isLoading: t,
        progressingProps: {
          pageLoader: !0
        },
        error: n,
        errorScreenManagerProps: {
          code: n?.code,
          redirectURL: se.INFRASTRUCTURE_MANAGEMENT_RESOURCE_BROWSER,
          reload: a
        },
        children: i.length ? /* @__PURE__ */ e.jsx(wP, { clusterList: i }) : /* @__PURE__ */ e.jsx(
          _e,
          {
            classname: "flex-grow-1",
            title: "No Clusters Found",
            subTitle: "Please add a cluster to compare"
          }
        )
      }
    )
  ] });
}, to = {
  Group: "pincher.devtron.ai",
  Version: "v1alpha1",
  Kind: "Hibernator"
}, DP = async (t, s) => {
  try {
    const a = ((await Ki({
      clusterId: +t,
      k8sRequest: {
        resourceIdentifier: {
          groupVersionKind: to
        }
      }
    }))?.result?.data || []).map((i) => ({
      name: i?.name,
      namespace: i?.namespace
    })).filter((i) => i.name && i.namespace), r = a.map(
      (i) => () => Qi({
        name: i.name,
        namespace: i.namespace,
        abortControllerRef: s,
        gvk: to,
        clusterId: +t
      })
    );
    return (await Tr(r)).reduce((i, l, c) => {
      const { name: d, namespace: p } = a[c], m = Yt(), u = l?.status === Mi.FULFILLED ? l?.value?.manifestResponse?.manifest : null;
      return u && (i[m] = {
        id: m,
        name: d,
        data: u,
        namespace: p,
        isSelected: c === 0
      }), i;
    }, {});
  } catch {
    return {};
  }
}, Zh = (t) => ({
  $schema: "http://json-schema.org/draft-07/schema#",
  type: "object",
  title: "Hibernator Configuration",
  description: "Configuration for Hibernator resource to manage hibernation of Kubernetes workloads",
  properties: {
    metadata: {
      type: "object",
      title: "Metadata",
      properties: {
        name: {
          type: "string",
          title: "Name",
          description: "Name of the hibernator resource",
          minLength: 1,
          readOnly: t
        },
        namespace: {
          type: "string",
          title: "Namespace",
          description: "Namespace where the hibernator resource will be created",
          default: "default",
          minLength: 1,
          readOnly: t
        }
      },
      required: ["name", "namespace"]
    },
    spec: {
      type: "object",
      title: "Hibernator Specification",
      properties: {
        action: {
          type: "string",
          title: "Action",
          description: "Action to be performed by the hibernator",
          enum: ["hibernate", "unhibernate", "pause"],
          default: "hibernate"
        },
        hibernate: {
          type: "boolean",
          title: "Hibernate",
          description: "Enable hibernation for selected resources",
          default: !1
        },
        unHibernate: {
          type: "boolean",
          title: "Un-Hibernate",
          description: "Disable hibernation for selected resources",
          default: !1
        },
        pause: {
          type: "boolean",
          title: "Pause",
          description: "Pause hibernation operations",
          default: !1
        },
        pauseUntil: {
          type: "object",
          title: "Pause Until",
          description: "Pause hibernation until specified date and time",
          properties: {
            dateTime: {
              type: "string",
              title: "Date Time",
              description: "Date and time until which hibernation should be paused",
              format: "date-time"
            },
            timeZone: {
              type: "string",
              title: "Time Zone",
              description: "Time zone for the specified date time",
              default: "UTC"
            }
          },
          required: ["dateTime", "timeZone"]
        },
        deleteStore: {
          type: "boolean",
          title: "Delete Store",
          description: "Delete persistent storage when hibernating",
          default: !1
        },
        reSyncInterval: {
          type: "integer",
          title: "Re-sync Interval",
          description: "Interval in seconds for re-syncing hibernator state",
          minimum: 1,
          default: 300
        },
        revisionHistoryLimit: {
          type: "integer",
          title: "Revision History Limit",
          description: "Number of revision history entries to keep",
          minimum: 0,
          default: 10
        },
        targetReplicas: {
          type: "array",
          title: "Target Replicas",
          description: "Array of target replica counts for different resources",
          items: {
            type: "integer",
            minimum: 0
          }
        },
        selectors: {
          type: "array",
          title: "Resource Selectors",
          description: "Selectors to identify resources for hibernation",
          items: {
            type: "object",
            title: "Selector",
            properties: {
              inclusions: {
                type: "array",
                title: "Inclusions",
                description: "Resources to include in hibernation",
                items: {
                  type: "object",
                  title: "Inclusion Rule",
                  properties: {
                    namespaceSelector: {
                      type: "object",
                      title: "Namespace Selector",
                      properties: {
                        name: {
                          type: "string",
                          title: "Namespace Name",
                          description: "Specific namespace name to target"
                        },
                        labels: {
                          type: "array",
                          title: "Labels",
                          description: "Label selectors for namespace",
                          items: {
                            type: "string"
                          }
                        },
                        fieldSelector: {
                          type: "array",
                          title: "Field Selectors",
                          description: "Field selectors for namespace",
                          items: {
                            type: "string"
                          }
                        }
                      }
                    },
                    objectSelector: {
                      type: "object",
                      title: "Object Selector",
                      properties: {
                        type: {
                          type: "string",
                          title: "Resource Type",
                          description: "Kubernetes resource type (e.g., Deployment, StatefulSet)",
                          enum: [
                            "Deployment",
                            "StatefulSet",
                            "DaemonSet",
                            "ReplicaSet",
                            "Job",
                            "CronJob"
                          ]
                        },
                        name: {
                          type: "string",
                          title: "Resource Name",
                          description: "Specific resource name to target"
                        },
                        labels: {
                          type: "array",
                          title: "Labels",
                          description: "Label selectors for the resource",
                          items: {
                            type: "string"
                          }
                        },
                        fieldSelector: {
                          type: "array",
                          title: "Field Selectors",
                          description: "Field selectors for the resource",
                          items: {
                            type: "string"
                          }
                        }
                      },
                      required: ["type"]
                    }
                  },
                  required: ["objectSelector"]
                },
                minItems: 1
              },
              exclusions: {
                type: "array",
                title: "Exclusions",
                description: "Resources to exclude from hibernation",
                items: {
                  type: "object",
                  title: "Exclusion Rule",
                  properties: {
                    namespaceSelector: {
                      type: "object",
                      title: "Namespace Selector",
                      properties: {
                        name: {
                          type: "string",
                          title: "Namespace Name",
                          description: "Specific namespace name to exclude"
                        },
                        labels: {
                          type: "array",
                          title: "Labels",
                          description: "Label selectors for namespace",
                          items: {
                            type: "string"
                          }
                        },
                        fieldSelector: {
                          type: "array",
                          title: "Field Selectors",
                          description: "Field selectors for namespace",
                          items: {
                            type: "string"
                          }
                        }
                      }
                    },
                    objectSelector: {
                      type: "object",
                      title: "Object Selector",
                      properties: {
                        type: {
                          type: "string",
                          title: "Resource Type",
                          description: "Kubernetes resource type to exclude",
                          enum: [
                            "Deployment",
                            "StatefulSet",
                            "DaemonSet",
                            "ReplicaSet",
                            "Job",
                            "CronJob"
                          ]
                        },
                        name: {
                          type: "string",
                          title: "Resource Name",
                          description: "Specific resource name to exclude"
                        },
                        labels: {
                          type: "array",
                          title: "Labels",
                          description: "Label selectors for the resource",
                          items: {
                            type: "string"
                          }
                        },
                        fieldSelector: {
                          type: "array",
                          title: "Field Selectors",
                          description: "Field selectors for the resource",
                          items: {
                            type: "string"
                          }
                        }
                      },
                      required: ["type"]
                    }
                  },
                  required: ["objectSelector"]
                }
              }
            },
            required: ["inclusions"]
          },
          minItems: 1
        },
        timeRangesWithZone: {
          type: "object",
          title: "Time Ranges with Zone",
          description: "Time-based hibernation configuration",
          properties: {
            timeZone: {
              type: "string",
              title: "Time Zone",
              description: "Default time zone for time ranges",
              default: "UTC"
            },
            timeRanges: {
              type: "array",
              title: "Time Ranges",
              description: "Array of time ranges for hibernation scheduling",
              items: {
                type: "object",
                title: "Time Range",
                properties: {
                  timeFrom: {
                    type: "string",
                    title: "Time From",
                    description: "Start time (HH:MM format)",
                    pattern: "^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$"
                  },
                  timeTo: {
                    type: "string",
                    title: "Time To",
                    description: "End time (HH:MM format)",
                    pattern: "^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$"
                  },
                  weekdayFrom: {
                    type: "string",
                    title: "Weekday From",
                    description: "Starting day of the week",
                    enum: [
                      "monday",
                      "tuesday",
                      "wednesday",
                      "thursday",
                      "friday",
                      "saturday",
                      "sunday"
                    ]
                  },
                  weekdayTo: {
                    type: "string",
                    title: "Weekday To",
                    description: "Ending day of the week",
                    enum: [
                      "monday",
                      "tuesday",
                      "wednesday",
                      "thursday",
                      "friday",
                      "saturday",
                      "sunday"
                    ]
                  },
                  timeZone: {
                    type: "string",
                    title: "Time Zone Override",
                    description: "Override the default time zone for this range"
                  },
                  cronExpressionFrom: {
                    type: "string",
                    title: "Cron Expression From",
                    description: "Cron expression for start time (alternative to timeFrom/weekdayFrom)"
                  },
                  cronExpressionTo: {
                    type: "string",
                    title: "Cron Expression To",
                    description: "Cron expression for end time (alternative to timeTo/weekdayTo)"
                  }
                },
                required: ["timeFrom", "timeTo", "weekdayFrom", "weekdayTo"]
              }
            }
          },
          required: ["timeRanges"]
        }
      },
      required: ["action", "selectors"]
    }
  },
  required: ["metadata", "spec"]
}), MP = (t, s) => {
  const n = {};
  return Object.entries(t).forEach(([a, r]) => {
    oC.validateFormData(
      r.data,
      Zh(!!s[a])
    )?.errors?.length && (n[a] = !0);
  }), n;
}, kP = (t, s, n) => {
  const o = Object.keys(n || {}).filter((l) => !s[l]).map((l) => {
    const c = n[l];
    return {
      name: c.name,
      operation: (d) => $m(
        {
          clusterId: +t,
          k8sRequest: {
            resourceIdentifier: {
              groupVersionKind: to,
              namespace: c.namespace,
              name: c.name
            }
          }
        },
        d
      )
    };
  });
  return [...Object.values(s).map((l) => {
    const c = n[l.id], d = {
      kind: to.Kind,
      apiVersion: "pincher.devtron.ai/v1alpha1",
      ...l.data
    };
    return c ? {
      name: l.name,
      operation: (p) => Zi(
        {
          name: c.name,
          namespace: c.namespace,
          clusterId: +t,
          gvk: to,
          manifest: gt(d)
        },
        p
      )
    } : {
      name: l.name,
      operation: (p) => xd(
        {
          clusterId: +t,
          manifest: gt(d)
        },
        p
      )
    };
  }), ...o];
}, C2 = ({ handleClose: t, clusterId: s }) => {
  const [n, a] = v({}), r = de(new AbortController()), [o, i] = ne(
    () => DP(+s, r),
    [s],
    !!s
  ), [l, c] = v({}), [d, p] = v(!1);
  J(
    () => () => {
      r.current.abort();
    },
    []
  ), J(() => {
    !o && i && a(i);
  }, [o, i]);
  const m = Object.keys(i || {}), u = Object.keys(n), f = u.find((T) => n[T].isSelected) || n[u[0]]?.id || null, _ = () => {
    const T = Yt();
    a((A) => {
      const S = structuredClone(A);
      return Object.keys(S).forEach((L) => {
        S[L].isSelected = !1;
      }), S[T] = {
        id: T,
        name: "",
        namespace: "",
        data: {},
        isSelected: !0
      }, S;
    });
  }, h = (T) => (A) => {
    A.stopPropagation(), a((S) => {
      const L = structuredClone(S);
      return delete L[T], L;
    });
  }, x = ({ formData: T, errors: A }) => {
    c((S) => {
      const L = structuredClone(S);
      return A?.length ? L[f] = !0 : delete L[f], L;
    }), a((S) => {
      const L = structuredClone(S);
      return f && (L[f].name = T.metadata?.name || "", L[f].namespace = T.metadata?.namespace || "", L[f].data = T), L;
    });
  }, g = () => {
    if (u.length === 0 && m.length === 0) {
      Z.showToast({
        variant: ee.error,
        description: "Please add at least one hibernation rule."
      });
      return;
    }
    const T = MP(n, i);
    if (c(T), Object.keys(T).length) {
      Z.showToast({
        variant: ee.error,
        description: "Please fix the errors in the form before applying changes."
      });
      return;
    }
    p(!0);
  }, E = () => /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-20 bg__primary br-8 border__secondary", children: /* @__PURE__ */ e.jsx(
    la,
    {
      className: "w-100",
      schema: Zh(!!i[f]),
      formData: n[f].data || {},
      onChange: x,
      experimental_defaultFormStateBehavior: {
        emptyObjectFields: "skipDefaults"
      },
      liveValidate: !0,
      uiSchema: Fa
    }
  ) }), C = () => /* @__PURE__ */ e.jsx(
    j,
    {
      dataTestId: "add-rule-button-empty-state",
      variant: w.secondary,
      size: O.medium,
      startIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-add", color: null }),
      text: "Add Rule",
      onClick: _
    }
  ), b = (T) => (A) => {
    A.stopPropagation(), !("key" in A && A.key !== "Enter" && A.key !== " ") && a((S) => {
      const L = structuredClone(S);
      return Object.keys(L).forEach((R) => {
        L[R].isSelected = R === T;
      }), L;
    });
  }, N = () => o ? /* @__PURE__ */ e.jsx(
    _e,
    {
      title: "Loading Hibernation Rules",
      subTitle: "Please wait while we fetch the hibernation rules.",
      SvgImage: jr,
      imageType: bs.Large
    }
  ) : f ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox flex-grow-1 dc__overflow-auto w-100", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col w-240 dc__no-shrink dc__overflow-auto border__primary--right", children: [
      /* @__PURE__ */ e.jsx("div", { className: "p-12", children: /* @__PURE__ */ e.jsx(
        j,
        {
          dataTestId: "add-rule-button",
          variant: w.secondary,
          size: O.medium,
          startIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-add", color: null }),
          text: "Add Rule",
          onClick: _,
          fullWidth: !0
        }
      ) }),
      /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__overflow-auto px-12 py-8 w-100", children: u.map((T) => /* @__PURE__ */ e.jsxs(
        "div",
        {
          role: "button",
          onClick: b(T),
          onKeyDown: b(T),
          tabIndex: 0,
          className: `flexbox dc__gap-8 w-100 h-32 br-4 px-8 py-6 dc__align-items-center dc__visible-hover dc__visible-hover--parent ${f === T ? "bcb-1" : "dc__hover-n50"}`,
          children: [
            l[T] ? /* @__PURE__ */ e.jsx(W, { name: "ic-error", color: "R500" }) : /* @__PURE__ */ e.jsx(W, { name: "ic-gavel", color: f === T ? "B500" : "N800" }),
            /* @__PURE__ */ e.jsx(
              "h3",
              {
                className: `m-0 fs-13 fw-6 lh-1-5 dc__truncate flex-grow-1 ${f === T ? "cb-5" : "cn-9"}`,
                children: n[T].name || "Unnamed Rule"
              }
            ),
            /* @__PURE__ */ e.jsx("div", { className: "dc__visible-hover--child", children: /* @__PURE__ */ e.jsx(
              j,
              {
                dataTestId: `delete-rule-button-${T}`,
                icon: /* @__PURE__ */ e.jsx(W, { name: "ic-delete", color: null }),
                ariaLabel: `Delete ${n[T].name || "Unnamed"} Rule`,
                showAriaLabelInTippy: !1,
                variant: w.borderLess,
                style: B.negative,
                size: O.xs,
                onClick: h(T)
              }
            ) })
          ]
        },
        T
      )) })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col p-20 dc__overflow-auto flex-grow-1 bg__secondary", children: E() })
  ] }) : /* @__PURE__ */ e.jsx(
    _e,
    {
      title: "Hibernation Rules",
      subTitle: "Add a rule to start hibernating your resources.",
      isButtonAvailable: !0,
      renderButton: C
    }
  ), I = (T) => {
    const { Pending: A, Progressing: S, Completed: L } = T;
    return A || S ? /* @__PURE__ */ e.jsx("span", { className: "cn-8 fs-12 fw-4 lh-20", children: "Applying hibernation rules" }) : `${L} resource(s) hibernation rules applied`;
  };
  if (d) {
    const T = kP(s, n, i);
    return /* @__PURE__ */ e.jsx(
      So,
      {
        data: null,
        operations: T,
        textConfig: {
          prompt: Nn,
          resultsHeader: "Hibernation Rules"
        },
        shouldSkipConfirmation: !0,
        handleModalClose: t,
        handleReloadDataAfterBulkOperation: t,
        getResultsChartSummaryText: I,
        disableTransition: !0
      }
    );
  }
  return /* @__PURE__ */ e.jsx($t, { position: "right", width: "1024px", onEscape: t, onClose: t, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "flexbox-col dc__content-space h-100 bg__modal--primary shadow__modal dc__overflow-auto",
      onClick: Le,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-auto flex-grow-1", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "px-20 py-12 flexbox dc__content-space dc__align-items-center border__primary--bottom", children: [
            /* @__PURE__ */ e.jsx("h2", { className: "m-0 fs-16 fw-6 lh-24 cn-9", children: "Hibernation Rules" }),
            /* @__PURE__ */ e.jsx(
              j,
              {
                dataTestId: "header-close-button",
                ariaLabel: "Close",
                showAriaLabelInTippy: !1,
                onClick: t,
                variant: w.borderLess,
                style: B.negativeGrey,
                icon: /* @__PURE__ */ e.jsx(W, { name: "ic-close-large", color: null }),
                size: O.xs
              }
            )
          ] }),
          N()
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-end dc__gap-12 py-16 px-20 border__primary--top dc__no-shrink", children: [
          /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: "footer-cancel-button",
              variant: w.secondary,
              text: "Cancel",
              style: B.neutral,
              size: O.large,
              onClick: t
            }
          ),
          /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: "footer-apply-button",
              variant: w.primary,
              size: O.large,
              text: "Save Changes",
              isLoading: o,
              onClick: g
            }
          )
        ] })
      ]
    }
  ) });
}, b2 = ({
  guiSchema: t,
  handleChange: s,
  manifestYAMLString: n,
  handleSwitchToYAMLMode: a,
  manifestGUIFormRef: r
}) => {
  const o = Q(() => {
    try {
      return zs.parse(n);
    } catch {
      return {};
    }
  }, [n]);
  return Object.keys(t || {}).length ? /* @__PURE__ */ e.jsx("div", { className: "dc__overflow-auto flexbox-col flex-grow-1", children: /* @__PURE__ */ e.jsx(
    la,
    {
      className: "w-100 dc__mxw-1200",
      schema: t,
      formData: o || {},
      onChange: s,
      experimental_defaultFormStateBehavior: {
        emptyObjectFields: "skipDefaults"
      },
      liveValidate: !0,
      uiSchema: Fa,
      ref: r
    }
  ) }) : /* @__PURE__ */ e.jsx(
    _e,
    {
      image: Ql,
      title: "GUI schema not found",
      subTitle: "The GUI view is generated by a schema. Please provide GUI schema through CRD.",
      children: /* @__PURE__ */ e.jsx(
        j,
        {
          endIcon: /* @__PURE__ */ e.jsx(Ms, {}),
          onClick: a,
          variant: w.secondary,
          text: "Switch to advanced",
          dataTestId: "switch-to-advanced-view"
        }
      )
    }
  );
}, FP = "Monitoring Dashboard", Bu = "rb-monitoring-dashboard__grid-layout--title", $u = ({ useDefaultStyles: t = !0, handleOpenAddPanelModal: s }) => /* @__PURE__ */ e.jsx(
  j,
  {
    dataTestId: "open-add-panel-modal",
    variant: t ? w.primary : w.text,
    text: "Add Panel",
    startIcon: /* @__PURE__ */ e.jsx(Xt, {}),
    onClick: s,
    size: t ? O.large : O.small
  }
), UP = async ({ clusterId: t, id: s, panelName: n, embedIframe: a }) => {
  const r = `${$.CLUSTER}/${t}/${$.PANEL}`, o = s ? `/${s}` : "", i = s ? Bt : we, l = {
    name: n,
    embedIframe: qm(a, n)
  };
  return i(`${r}${o}`, l);
}, GP = (t) => {
  const { isValid: s, message: n } = iC(t);
  return {
    isValid: () => s,
    message: n
  };
}, BP = (t) => ({
  panelName: {
    required: !0
  },
  embedIframe: {
    required: !0,
    custom: GP(t.embedIframe)
  }
}), $P = ({
  initialFormData: t,
  onClose: s,
  handleSuccess: n
}) => {
  const { clusterId: a } = Ue(), { data: r, errors: o, register: i, handleSubmit: l } = Pm({
    initialValues: t,
    validations: BP
  }), [c, d] = v(!1), p = async ({
    id: _,
    panelName: h,
    embedIframe: x
  }) => {
    try {
      d(!0), await UP({
        clusterId: +a,
        id: _,
        panelName: h,
        embedIframe: x
      }), d(!1), Z.showToast({
        variant: ee.success,
        description: `Panel '${h}' has been successfully ${_ ? "updated" : "created"}.`
      }), n();
    } catch (g) {
      V(g), d(!1);
    }
  }, m = () => /* @__PURE__ */ e.jsxs("header", { className: "flexbox dc__align-items-center dc__content-space px-20 py-12 dc__border-bottom", children: [
    /* @__PURE__ */ e.jsx("h2", { className: "m-0 fs-16 lh-1-5 fw-6", children: `${t.panelName ? "Edit" : "Add"} panel` }),
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "monitoring-panel-crud-modal-close-btn",
        ariaLabel: "close-button",
        showAriaLabelInTippy: !1,
        icon: /* @__PURE__ */ e.jsx(vt, {}),
        onClick: s,
        variant: w.borderLess,
        style: B.negativeGrey,
        size: O.xs
      }
    )
  ] }), u = () => /* @__PURE__ */ e.jsxs("form", { className: "px-20 py-16 flex-grow-1 flexbox-col dc__gap-16", onSubmit: wm, children: [
    /* @__PURE__ */ e.jsx(
      yt,
      {
        value: r.panelName,
        ...i("panelName"),
        label: "Panel name",
        placeholder: "Enter panel name",
        error: o.panelName,
        required: !0,
        autoFocus: !0,
        shouldTrim: !1
      }
    ),
    /* @__PURE__ */ e.jsx(
      vn,
      {
        value: r.embedIframe,
        ...i("embedIframe"),
        placeholder: "Enter embed code",
        label: "Embed iframe",
        required: !0,
        error: o.embedIframe?.[0]
      }
    ),
    /* @__PURE__ */ e.jsx(Ot, { description: "Please ensure that the embedded iframe has required permission to connect from external webpages." })
  ] }), f = () => /* @__PURE__ */ e.jsxs("footer", { className: "flex right dc__gap-12 px-20 py-16 dc__border-top", children: [
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "monitoring-panel-crud-modal-cancel-btn",
        text: "Cancel",
        variant: w.secondary,
        style: B.neutral,
        onClick: s,
        disabled: c
      }
    ),
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "monitoring-panel-crud-modal-save-btn",
        text: "Save",
        isLoading: c,
        onClick: l(p)
      }
    )
  ] });
  return /* @__PURE__ */ e.jsx(cs, { className: "monitoring-panel-crud-modal", onEscape: s, close: s, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      onClick: Le,
      className: "monitoring-panel-crud-modal__container bg__primary dc__border br-8 dc__mxw-600 flexbox-col",
      children: [
        m(),
        u(),
        f()
      ]
    }
  ) });
}, N2 = (t, s) => ({
  id: s,
  name: FP,
  url: t,
  isSelected: !1,
  type: "fixed",
  showNameOnSelect: !1,
  hideName: !0
}), eg = (t) => `panel-template-clusterId-${t}`, VP = (t) => ({
  i: `${t}`,
  x: 0,
  y: 0,
  w: 6,
  h: 6,
  minH: 3,
  minW: 3
}), YP = (t, s) => {
  const { ids: n, panelDetails: a } = t.reduce(
    (o, i) => (o.ids.push(i.id), o.panelDetails[i.id] = i, o),
    { ids: [], panelDetails: {} }
  ), r = n.reduce((o, i) => (o[i] = s.panelConfiguration[i] || structuredClone(VP(i)), o), {});
  return {
    ids: n,
    panelDetails: a,
    templateConfigurationId: s.templateConfigurationId,
    panelConfiguration: r
  };
}, Vu = ({
  panelConfiguration: t
}) => {
  const s = structuredClone(t) || {};
  return Object.values(s);
}, HP = async ({
  clusterId: t,
  shouldShowError: s = !0
}) => {
  try {
    const { result: n } = await le(`${$.CLUSTER}/${t}/${$.PANELS}`);
    return n ? n.filter((a) => a.embedIframe && a.id).map(({ id: a, name: r, embedIframe: o }, i) => ({
      id: a,
      embedIframe: qm(o, r),
      name: r || `Panel ${i + 1}`
    })) : [];
  } catch (n) {
    throw s && V(n), n;
  }
}, KP = async ({
  clusterId: t,
  shouldShowError: s = !0
}) => {
  try {
    const { result: n } = await le(
      ye($.CLUSTER_PANEL_TEMPLATE, { key: eg(t) })
    );
    return n ? {
      panelConfiguration: JSON.parse(n.value),
      templateConfigurationId: n.id
    } : {
      panelConfiguration: {}
    };
  } catch (n) {
    return s && V(n), {
      panelConfiguration: {}
    };
  }
}, WP = async ({
  clusterId: t,
  shouldShowError: s = !0
}) => {
  try {
    const [n, a] = await Promise.all([
      HP({ clusterId: t, shouldShowError: !1 }),
      KP({ clusterId: t, shouldShowError: !1 })
    ]);
    return YP(n, a);
  } catch (n) {
    throw s && V(n), n;
  }
}, qP = async ({
  clusterId: t,
  panelLayoutConfig: s,
  templateConfigurationId: n
}) => {
  const a = s.reduce(
    (o, { i, x: l, y: c, w: d, h: p }) => ({
      ...o,
      [i]: {
        i,
        x: l,
        y: c,
        w: d,
        h: p
      }
    }),
    {}
  ), r = {
    id: n,
    key: eg(t),
    value: JSON.stringify(a)
  };
  return Bt($.CLUSTER_PANEL_TEMPLATE, r);
}, zP = async ({ panelId: t, clusterId: s }) => Js(`${$.CLUSTER}/${s}/${$.PANEL}/${t}`);
var Kr = /* @__PURE__ */ ((t) => (t.UPDATE = "UPDATE", t.DELETE = "DELETE", t))(Kr || {});
const XP = ix.WidthProvider(lx), T2 = () => {
  const { clusterId: t } = Ue(), [s, n, a, r] = ne(
    () => WP({ clusterId: +t }),
    [t],
    !!+t
  ), [o, i] = v([]), [l, c] = v({
    isOpen: !1
  }), [d, p] = v(!1), [m, u] = v(!1);
  J(() => {
    !s && !a && n && i(
      Vu({ panelConfiguration: n.panelConfiguration })
    );
  }, [s, n, a]);
  const f = (P) => {
    c({ isOpen: !0, panelId: P, type: Kr.UPDATE });
  }, _ = (P) => {
    c({ isOpen: !0, panelId: P, type: Kr.DELETE });
  }, h = () => {
    c({ isOpen: !1 });
  }, x = () => {
    p(!0);
  }, g = () => {
    p(!1), i(
      Vu({ panelConfiguration: n.panelConfiguration })
    );
  }, E = () => {
    r(), h(), p(!1);
  }, C = (P) => {
    i(P);
  }, b = async () => {
    u(!0);
    try {
      await qP({
        clusterId: +t,
        panelLayoutConfig: o,
        templateConfigurationId: n.templateConfigurationId
      }), Z.showToast({
        variant: ee.success,
        description: "Layout is successfully saved."
      }), E();
    } catch (P) {
      V(P);
    } finally {
      u(!1);
    }
  }, N = async () => {
    await zP({
      clusterId: +t,
      panelId: l.panelId
    }), E();
  }, I = () => f(), T = (P) => () => f(P), A = (P) => () => _(P), S = () => /* @__PURE__ */ e.jsx($u, { handleOpenAddPanelModal: I }), L = () => {
    const P = l.panelId;
    if (P) {
      const { id: U, name: G, embedIframe: H } = n.panelDetails[P];
      return {
        id: U,
        panelName: G,
        embedIframe: H
      };
    }
    return {
      id: null,
      panelName: "",
      embedIframe: ""
    };
  }, R = () => d ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "save-panel-layout-config",
        startIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-check", color: null }),
        text: "Save Changes",
        variant: w.text,
        onClick: b,
        isLoading: m,
        size: O.small
      }
    ),
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "cancel-panel-layout-config",
        text: "Cancel",
        variant: w.text,
        onClick: g,
        style: B.neutral,
        size: O.small,
        disabled: m
      }
    )
  ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx($u, { useDefaultStyles: !1, handleOpenAddPanelModal: I }),
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "re-arrange-layout",
        variant: w.text,
        text: "Rearrange",
        startIcon: /* @__PURE__ */ e.jsx(fN, {}),
        onClick: x,
        size: O.small
      }
    )
  ] }), y = () => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "px-16 py-6 flexbox dc__gap-12 dc__border-bottom", children: [
      /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-12 fw-6 lh-20", children: "Monitoring Dashboard" }),
      /* @__PURE__ */ e.jsx("div", { className: "dc__border-left h-16" }),
      R()
    ] }),
    /* @__PURE__ */ e.jsx(
      XP,
      {
        className: "rb-monitoring-dashboard dc__overflow-auto h-100",
        rowHeight: 30,
        layout: o,
        onLayoutChange: C,
        cols: 12,
        useCSSTransforms: !0,
        isDraggable: d,
        isResizable: d,
        draggableHandle: `.${Bu}`,
        containerPadding: [16, 16],
        children: n.ids.map((P) => {
          const { embedIframe: U, name: G } = n.panelDetails[P];
          return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__border br-4 bg__primary", children: [
            /* @__PURE__ */ e.jsxs(
              "div",
              {
                className: `${Bu} br-4 flexbox dc__align-items-center ${d ? "p-12 bg__secondary dc__grabbable" : "px-12 pt-12 bg__primary"} dc__gap-12`,
                children: [
                  /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-4 flex-grow-1", children: [
                    d && /* @__PURE__ */ e.jsx(_N, { className: "icon-dim-16 dc__no-shrink scn-7" }),
                    /* @__PURE__ */ e.jsx(Ie, { content: G, children: /* @__PURE__ */ e.jsx("h4", { className: "dc__truncate m-0 cn-9 fs-13 fw-6 lh-20", children: G }) })
                  ] }),
                  !d && /* @__PURE__ */ e.jsxs(pr, { autoClose: !0, children: [
                    /* @__PURE__ */ e.jsx(
                      pr.Button,
                      {
                        rootClassName: "flex dc__no-shrink icon-dim-20 p-0 dc__no-background dc__no-border dc__outline-none-imp dc__tab-focus dc__hover-n50",
                        isKebab: !0,
                        dataTestId: "panel-more-options-popup",
                        children: /* @__PURE__ */ e.jsx(T_, { className: "flex icon-dim-16 dc__no-shrink icon-color-n6" })
                      }
                    ),
                    /* @__PURE__ */ e.jsx(pr.Body, { rootClassName: "br-4 dc__overflow-hidden dc__border dc__box-shadow--menu mt-8", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col p-4 dc__gap-4", children: [
                      /* @__PURE__ */ e.jsxs(
                        "button",
                        {
                          type: "button",
                          "data-testid": `edit-panel-${G}`,
                          onClick: T(P),
                          className: "dc__transparent flexbox dc__align-items-center dc__gap-8 px-8 py-6 dc__hover-n50",
                          children: [
                            /* @__PURE__ */ e.jsx(Fs, { className: "icon-dim-16 dc__no-shrink scn-8" }),
                            /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Edit" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ e.jsxs(
                        "button",
                        {
                          type: "button",
                          "data-testid": `delete-panel-${G}`,
                          className: "dc__transparent flexbox dc__align-items-center dc__gap-8 px-8 py-6 dc__hover-n50",
                          onClick: A(P),
                          children: [
                            /* @__PURE__ */ e.jsx(ts, { className: "icon-dim-16 dc__no-shrink scr-5" }),
                            /* @__PURE__ */ e.jsx("span", { className: "cr-5 fs-13 fw-4 lh-20", children: "Delete" })
                          ]
                        }
                      )
                    ] }) })
                  ] })
                ]
              }
            ),
            /* @__PURE__ */ e.jsx(
              "div",
              {
                className: "dc__overflow-auto p-12 h-100",
                dangerouslySetInnerHTML: {
                  __html: lC(U)
                }
              }
            )
          ] }, P);
        })
      }
    )
  ] }), M = () => l.isOpen ? l.type === Kr.UPDATE ? /* @__PURE__ */ e.jsx(
    $P,
    {
      initialFormData: L(),
      onClose: h,
      handleSuccess: E
    }
  ) : l.type === Kr.DELETE && /* @__PURE__ */ e.jsx(
    Sr,
    {
      title: n?.panelDetails[l.panelId]?.name,
      component: "panel",
      onDelete: N,
      closeConfirmationModal: h,
      successToastMessage: "Panel deleted successfully"
    }
  ) : null;
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1 dc__overflow-hidden flexbox-col w-100", children: /* @__PURE__ */ e.jsx(
      Ke,
      {
        isLoading: s,
        progressingProps: {
          pageLoader: !0
        },
        error: a,
        errorScreenManagerProps: {
          code: a?.code,
          reload: r,
          redirectURL: se.INFRASTRUCTURE_MANAGEMENT_RESOURCE_BROWSER
        },
        children: n?.ids?.length ? y() : /* @__PURE__ */ e.jsx(
          _e,
          {
            title: "Setup your monitoring dashboard",
            subTitle: "Elevate your Kubernetes visibility by embedding the metrics that matter to you",
            SvgImage: hN,
            imageType: bs.Large,
            isButtonAvailable: !0,
            renderButton: S
          }
        )
      }
    ) }),
    M()
  ] });
}, Da = ({
  shrinkHeightToContent: t,
  heading: s,
  description: n,
  children: a,
  hideBorderBottom: r,
  hideChildrenPadding: o,
  status: i
}) => /* @__PURE__ */ e.jsxs(
  "div",
  {
    className: `br-4 border__primary bg__primary flexbox-col dc__overflow-auto ${t ? "dc__h-min-content" : ""}`,
    children: [
      /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: `flexbox dc__content-space dc__gap-8 px-16 py-8 dc__align-items-center ${r ? "" : "border__secondary--bottom"}`,
          children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
              /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-14 fw-6 lh-1-5 dc__truncate", children: s }),
              !!n && /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-13 cn-7 fw-4 lh-1-5", children: n })
            ] }),
            i && /* @__PURE__ */ e.jsx("span", { className: `${Ma} bcg-1 cg-7`, children: i })
          ]
        }
      ),
      /* @__PURE__ */ e.jsx("div", { className: `flexbox-col dc__gap-16 dc__overflow-auto ${o ? "" : "p-16"}`, children: a })
    ]
  }
), JP = ({ heading: t, items: s }) => /* @__PURE__ */ e.jsxs("div", { className: "py-4 flexbox-col", children: [
  /* @__PURE__ */ e.jsx("h4", { className: "m-0 cn-7 fs-14 fw-6 lh-1-5 dc__truncate px-16 py-6", children: t }),
  s.map(({ key: n, value: a }) => /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "px-16 py-6 flexbox dc__content-space dc__gap-4 dc__hover-n50",
      children: [
        /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-13 fw-4 lh-1-5", children: n }),
        /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-6 lh-1-5 dc__truncate", children: a })
      ]
    },
    `${n}-${t}-${a}`
  ))
] }), QP = ({ heading: t, items: s }) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6", children: [
  /* @__PURE__ */ e.jsx("h4", { className: "m-0 cn-7 fs-13 fw-6 lh-1-5 dc__truncate", children: t }),
  /* @__PURE__ */ e.jsx("div", { className: "br-4 border__secondary py-4 flexbox-col", children: s.map(({ key: n, value: a, subText: r }) => /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "px-16 py-6 flexbox dc__content-space dc__gap-4 dc__hover-n50",
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
          /* @__PURE__ */ e.jsx("span", { className: `fs-13 ${r ? "cn-8 fw-6" : "cn-7 fw-4"} lh-1-5`, children: n }),
          /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-13 fw-4 lh-1-5", children: r })
        ] }),
        /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-6 lh-1-5 dc__truncate", children: a })
      ]
    },
    `${n}-${t}-${a}`
  )) })
] }), Yu = ({
  heading: t,
  description: s,
  status: n,
  itemGroups: a,
  containItemGroupWithBorder: r
}) => /* @__PURE__ */ e.jsx(
  Da,
  {
    heading: t,
    description: s,
    status: n,
    hideChildrenPadding: !r,
    children: /* @__PURE__ */ e.jsx("div", { className: `flexbox-col ${r ? "dc__gap-16" : ""}`, children: a.map(
      (o, i) => r ? /* @__PURE__ */ e.jsx(
        QP,
        {
          heading: o.heading,
          items: o.items
        },
        `${o.heading}-${t}`
      ) : /* @__PURE__ */ e.jsxs(Nr, { children: [
        /* @__PURE__ */ e.jsx(JP, { heading: o.heading, items: o.items }),
        i !== a.length - 1 && /* @__PURE__ */ e.jsx("div", { className: "divider divider--n1" })
      ] }, `${o.heading}-${t}`)
    ) })
  }
), ZP = {
  heading: "Hardware Details",
  description: "Detailed system hardware information",
  status: "OK",
  itemGroups: [
    {
      heading: "System",
      items: [
        {
          key: "Model",
          value: "PowerEdge XR8620t"
        },
        {
          key: "Manufacturer",
          value: "Dell Inc."
        },
        {
          key: "Service Tag",
          value: "4TW3H04"
        },
        {
          key: "Express Service Code",
          value: "10514558164"
        },
        {
          key: "Part Number",
          value: "0HG7X2A01"
        },
        {
          key: "System Type",
          value: "Physical"
        },
        {
          key: "Chassis",
          value: "PowerEdge XR8000"
        },
        {
          key: "Chassis Height",
          value: "2U"
        }
      ]
    },
    {
      heading: "Processor",
      items: [
        {
          key: "Model",
          value: "Inter(R) Xeon(R) Gold 6433N"
        },
        {
          key: "Cores",
          value: "32"
        },
        {
          key: "Threads",
          value: "64"
        },
        {
          key: "L2 Cache",
          value: "32x2 MB"
        },
        {
          key: "L3 Cache",
          value: "60 MB"
        }
      ]
    },
    {
      heading: "Memory",
      items: [
        {
          key: "Total Memory",
          value: "256 GB"
        },
        {
          key: "Memory Type",
          value: "ECC DDR5"
        },
        {
          key: "Memory Speed",
          value: "4400 MT/s"
        },
        {
          key: "DIMM Slots",
          value: "8 of 8"
        }
      ]
    }
  ]
}, ew = {
  heading: "Firmware Versions",
  description: "Current firmware for system components",
  status: "OK",
  itemGroups: [
    {
      heading: "BIOS",
      items: [
        {
          key: "Version",
          value: "2.4.4"
        },
        {
          key: "Release Date",
          value: "09/27/2024"
        }
      ]
    },
    {
      heading: "iDRAC",
      items: [
        {
          key: "Version",
          value: "7.10.90.00"
        },
        {
          key: "Previous",
          value: "7.10.50.00"
        }
      ]
    },
    {
      heading: "Network Interfaces",
      items: [
        {
          key: "Intel(R) ethernet 100G 2P E810-C Adapter",
          subText: "40:A6:B7:B2:8D:00",
          value: "22.0.9"
        }
      ]
    },
    {
      heading: "Other Components",
      items: [
        {
          key: "System CPLD",
          value: "1.1.3"
        },
        {
          key: "TPM",
          value: "7.2.2.0"
        }
      ]
    }
  ]
}, tw = () => /* @__PURE__ */ e.jsxs("div", { className: `dc__grid-cols-2 dc__gap-16 ${Do}`, children: [
  /* @__PURE__ */ e.jsx(Yu, { ...ZP }),
  /* @__PURE__ */ e.jsx(Yu, { ...ew, containItemGroupWithBorder: !0 })
] }), sw = [
  {
    heading: "Intel(R) Ethernet 100G 2P E810-C Adapter",
    description: "NIC.Slot.1-1-1",
    status: "OK",
    items: [
      {
        key: "Firmware",
        value: "22.0.9"
      },
      {
        key: "Mac address",
        value: "40:A6:B7:B2:8D:00"
      }
    ]
  },
  {
    heading: "Embedded NIC 1",
    description: "NIC.Embedded.1-1-1",
    status: "OK",
    items: [
      {
        key: "Status",
        value: "Enabled"
      },
      {
        key: "Boot Protocol",
        value: "IPv4"
      }
    ]
  },
  {
    heading: "Embedded NIC 2",
    description: "NIC.Embedded.2-1-1",
    status: "OK",
    items: [
      {
        key: "Status",
        value: "Enabled"
      },
      {
        key: "Boot Protocol",
        value: "IPv4"
      }
    ]
  }
], Hu = [
  "Successfully logged in using windriver, from 128.224.75.204 and REDFISH",
  "the session for windriver from 128.224.75.204 using GUI is logged off.",
  "Successfully logged in using windriver, from 128.224.75.104 and REDFISH",
  "Successfully logged in using windriver, from 128.224.75.105 and REDFISH",
  "The previous lof entry was repeated 5 times",
  "Successfully logged in using windriver, from 128.224.207.127 and RedFish",
  "The previous lof entry was repeated 2 times",
  "The previous lof entry was repeated 2 times",
  "The previous lof entry was repeated 2 times",
  "The previous lof entry was repeated 2 times",
  "The previous lof entry was repeated 2 times",
  "The previous lof entry was repeated 2 times",
  "The previous lof entry was repeated 2 times",
  "The previous lof entry was repeated 2 times",
  "The previous lof entry was repeated 2 times",
  "The previous lof entry was repeated 2 times",
  "The previous lof entry was repeated 2 times"
], nw = Array(100).fill({
  time: /* @__PURE__ */ new Date(),
  severity: "OK",
  message: ""
}).map((t, s) => ({
  time: new Date(Date.now() - s * 1e3).toLocaleString(),
  severity: "OK",
  message: Hu[s % Hu.length]
})), aw = () => /* @__PURE__ */ e.jsxs("div", { className: `dc__grid dc__gap-16 network-and-logs__container ${Do}`, children: [
  /* @__PURE__ */ e.jsx(Da, { heading: "Network Interfaces", description: "System network adapters", children: /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-16", children: sw.map((t) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__align-items-center dc__content-space", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
        /* @__PURE__ */ e.jsx("h4", { className: "m-0 cn-9 fs-13 fw-6 lh-1-5", children: t.heading }),
        /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-13 fw-4 lh-1-5", children: t.description })
      ] }),
      /* @__PURE__ */ e.jsx("span", { className: `${Ma} bcg-1 cg-7`, children: t.status })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col py-4 br-4 border__secondary ", children: t.items.map((s) => /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "flexbox dc__content-space dc__gap-8 dc__hover-n50 px-16 py-6",
        children: [
          /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-13 fw-4 lh-1-5", children: s.key }),
          /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-6 lh-1-5", children: s.value })
        ]
      },
      `${s.key}-${s.value}-${t.heading}`
    )) })
  ] }, `${t.heading}-network-interface`)) }) }),
  /* @__PURE__ */ e.jsx(
    Da,
    {
      heading: "System Event Logs",
      description: "Recent system events and alerts",
      hideBorderBottom: !0,
      hideChildrenPadding: !0,
      children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-auto", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "network-and-logs__system-events-logs--row dc__grid dc__column-gap-12 px-16 py-6 cn-7 fs-12 fw-6 lh-20 dc__position-sticky dc__top-0 bg__primary dc__zi-1", children: [
          /* @__PURE__ */ e.jsx(Ne, { isSortable: !1, title: "Time" }),
          /* @__PURE__ */ e.jsx(Ne, { isSortable: !1, title: "Severity" }),
          /* @__PURE__ */ e.jsx(Ne, { isSortable: !1, title: "Message" })
        ] }),
        nw.map((t) => /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: "network-and-logs__system-events-logs--row dc__grid dc__column-gap-12 dc__hover-n50 px-16 py-8",
            children: [
              /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20 dc__word-break", children: t.time }),
              /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-start", children: /* @__PURE__ */ e.jsx("span", { className: `${Ma} bcg-1 cg-7`, children: t.severity }) }),
              /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: t.message })
            ]
          },
          `${t.time}-${t.message}`
        ))
      ] })
    }
  )
] }), rw = [
  {
    heading: "PSU 1",
    headingVariant: O.large,
    value: 167,
    status: "OK",
    statusBadgeClass: "bcg-1 cg-7",
    infoListItems: [
      {
        key: "Input",
        value: "175W"
      },
      {
        key: "Voltage",
        value: "232V"
      },
      {
        key: "Type",
        value: "AC240V"
      },
      {
        key: "Efficiency",
        value: "85%"
      }
    ]
  },
  {
    heading: "PSU 2",
    headingVariant: O.large,
    value: 167,
    status: "OK",
    statusBadgeClass: "bcg-1 cg-7",
    infoListItems: [
      {
        key: "Input",
        value: "176W"
      },
      {
        key: "Voltage",
        value: "228V"
      },
      {
        key: "Type",
        value: "AC240V"
      },
      {
        key: "Efficiency",
        value: "85%"
      }
    ]
  }
], ow = [
  {
    heading: "Current consumption",
    headingVariant: O.medium,
    value: 207,
    progressData: {
      minValue: 0,
      maxValue: 1957
    }
  },
  {
    heading: "Power Metrics (1 min)",
    headingVariant: O.medium,
    infoListItems: [
      {
        key: "Min",
        value: "189W"
      },
      {
        key: "Max",
        value: "221W"
      },
      {
        key: "Average",
        value: "206W"
      }
    ]
  },
  {
    heading: "Power Allocation",
    headingVariant: O.medium,
    infoListItems: [
      {
        key: "Allocated",
        value: "1351W"
      },
      {
        key: "Capacity",
        value: "1957W"
      },
      {
        key: "Requested",
        value: "903W"
      },
      {
        key: "Power Cap",
        value: "32767W"
      }
    ]
  }
], Ku = ({ items: t, infoBlockProps: s, heading: n, description: a }) => {
  const r = (o) => o.value ? /* @__PURE__ */ e.jsxs("div", { className: `flexbox dc__content-space dc__gap-8 ${o.infoListItems?.length ? "px-16 py-8" : ""}`, children: [
    /* @__PURE__ */ e.jsxs("h5", { className: "m-0 cn-9 fs-16 fw-6 lh-1-5", children: [
      o.value,
      "W"
    ] }),
    o.status && /* @__PURE__ */ e.jsx("span", { className: `${Ma} ${o.statusBadgeClass}`, children: o.status })
  ] }) : null;
  return /* @__PURE__ */ e.jsxs(Da, { shrinkHeightToContent: !0, heading: n, description: a, children: [
    t.map((o) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6 dc__overflow-auto", children: [
      /* @__PURE__ */ e.jsx(
        "h4",
        {
          className: `m-0 cn-7 lh-1-5 ${o.headingVariant === O.large ? "fs-14 fw-6" : "fs-13 fw-4"}`,
          children: o.heading
        }
      ),
      /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: `flexbox-col br-4 border__secondary dc__overflow-auto ${o.infoListItems?.length ? "py-4" : "p-12 dc__gap-12"}`,
          children: [
            r(o),
            o.progressData && /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6", children: [
              /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-8", children: [
                /* @__PURE__ */ e.jsxs("span", { className: "cn-7 fs-13 fw-4 lh-1-5", children: [
                  o.progressData.minValue,
                  "W"
                ] }),
                /* @__PURE__ */ e.jsxs("span", { className: "cn-7 fs-13 fw-4 lh-1-5", children: [
                  o.progressData.maxValue,
                  "W"
                ] })
              ] }),
              /* @__PURE__ */ e.jsx(
                Ra,
                {
                  entities: [
                    {
                      value: o.value - o.progressData.minValue,
                      color: "var(--G300)"
                    },
                    {
                      value: o.progressData.maxValue - o.value,
                      color: "var(--N100)"
                    }
                  ],
                  showAnimationOnBar: !0,
                  hideLegend: !0
                }
              )
            ] }),
            o.infoListItems?.length && /* @__PURE__ */ e.jsx(e.Fragment, { children: o.infoListItems.map((i) => /* @__PURE__ */ e.jsxs(
              "div",
              {
                className: "flexbox dc__content-space dc__gap-8 px-16 py-8 dc__hover-n50",
                children: [
                  /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-13 fw-4 lh-1-5", children: i.key }),
                  /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-6 lh-1-5", children: i.value })
                ]
              },
              `${o.heading}-${i.key}-${n}`
            )) })
          ]
        }
      )
    ] }, o.heading)),
    /* @__PURE__ */ e.jsx(Ot, { ...s })
  ] });
}, iw = () => /* @__PURE__ */ e.jsxs("div", { className: `dc__grid-cols-2 dc__gap-16 ${Do}`, children: [
  /* @__PURE__ */ e.jsx(
    Ku,
    {
      heading: "Power supplies",
      description: "PSU status and readings",
      infoBlockProps: {
        heading: "Power supply Information",
        description: "Both power supplies are operating normally in a redundant configuration. Total system power consumption is 207W"
      },
      items: rw
    }
  ),
  /* @__PURE__ */ e.jsx(
    Ku,
    {
      heading: "Power Metrics",
      description: "System power consumption details",
      infoBlockProps: {
        variant: "warning",
        heading: "Power cap status",
        description: "Power capping is currently disabled. enable power capping to limit system power consumption"
      },
      items: ow
    }
  )
] });
var Na = /* @__PURE__ */ ((t) => (t.SYSTEM_INFORMATION = "System Information", t.HEALTH_STATUS = "Health Status", t.POWER_CONSUMPTION = "Power Consumption", t.PROCESSOR = "Processor", t.MEMORY = "Memory", t.STORAGE = "Storage", t))(Na || {});
const lw = [
  {
    heading: Na.SYSTEM_INFORMATION,
    items: [
      {
        key: "Model",
        value: "PowerEdge XR8620t"
      },
      {
        key: "Manufacturer",
        value: "Dell Inc."
      },
      {
        key: "Service Tag",
        value: "4TW3H04"
      },
      {
        key: "Serial Number",
        value: "MXFC4003BO0020"
      },
      {
        key: "BIOS Version",
        value: "2.4.4"
      },
      {
        key: "iDRAC Version",
        value: "7.10.90.00"
      },
      {
        key: "Power State",
        value: "On",
        valueBadgeClass: "bcg-1 cg-7"
      }
    ]
  },
  {
    heading: Na.HEALTH_STATUS,
    infoBlockProps: {
      variant: "success",
      layout: "column",
      heading: "System Status",
      description: "All components operating normally"
    },
    items: [
      {
        key: "CPU",
        value: "OK",
        valueBadgeClass: "bcg-1 cg-7"
      },
      {
        key: "Memory",
        value: "OK",
        valueBadgeClass: "bcg-1 cg-7"
      },
      {
        key: "Cores",
        value: "OK",
        valueBadgeClass: "bcg-1 cg-7"
      },
      {
        key: "Temperature",
        value: "OK",
        valueBadgeClass: "bcg-1 cg-7"
      },
      {
        key: "Power Supplies",
        value: "OK",
        valueBadgeClass: "bcg-1 cg-7"
      },
      {
        key: "Storage",
        value: "OK",
        valueBadgeClass: "bcg-1 cg-7"
      }
    ]
  },
  {
    heading: Na.POWER_CONSUMPTION,
    items: [
      {
        key: "207W",
        useKeyAsHeading: !0,
        value: "Current",
        valueBadgeClass: "bg__secondary cn-7"
      },
      {
        key: "Min",
        value: "189W"
      },
      {
        key: "Max",
        value: "221W"
      },
      {
        key: "Average",
        value: "206W"
      },
      {
        key: "Capacity",
        value: "1957W"
      },
      {
        key: "Current Usage",
        value: "11%",
        progressDetails: {
          value: 11,
          color: "var(--B300)"
        }
      }
    ]
  },
  {
    heading: Na.PROCESSOR,
    items: [
      {
        key: "Model",
        value: "Intel(R) Xeon(R) Gold 6433N"
      },
      {
        key: "Count",
        value: "1"
      },
      {
        key: "Cores",
        value: "32 (64 Threads)"
      },
      {
        key: "Base Speed",
        value: "1.40 GHz"
      },
      {
        key: "Temperature",
        value: "38°C"
      },
      {
        key: "Status",
        value: "OK",
        valueBadgeClass: "bcg-1 cg-7"
      }
    ]
  },
  {
    heading: Na.MEMORY,
    items: [
      {
        key: "Total Memory",
        value: "256 GB"
      },
      {
        key: "Type",
        value: "ECC DDR5"
      },
      {
        key: "Speed",
        value: "4400 MT/s"
      },
      {
        key: "DIMM Slots",
        value: "8 of 8 populated"
      },
      {
        key: "Operation Mode",
        value: "OptimizerMode"
      },
      {
        key: "Status",
        value: "OK",
        valueBadgeClass: "bcg-1 cg-7"
      }
    ]
  },
  {
    heading: Na.STORAGE,
    items: [
      {
        key: "Storage Mode",
        value: "NonRaid"
      },
      {
        key: "Boot Device",
        value: "PCleSSD.Integrated.1-0"
      },
      {
        key: "Status",
        value: "OK",
        valueBadgeClass: "bcg-1 cg-7"
      }
    ]
  }
], cw = ({ heading: t, infoBlockProps: s, items: n }) => /* @__PURE__ */ e.jsx(Da, { heading: t, hideChildrenPadding: !0, children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-auto py-4", children: [
  s && /* @__PURE__ */ e.jsx("div", { className: "px-16 py-8", children: /* @__PURE__ */ e.jsx(Ot, { ...s }) }),
  n.map(({ key: a, useKeyAsHeading: r, valueBadgeClass: o, progressDetails: i, value: l }) => /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `flexbox-col dc__gap-6 ${r ? "" : "dc__hover-n50"}`,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__content-space dc__gap-8 px-16 py-6", children: [
          /* @__PURE__ */ e.jsx("span", { className: r ? "cn-9 fs-16 fw-6 lh-26" : "cn-7 fs-13 fw-4 lh-1-5", children: a }),
          o ? /* @__PURE__ */ e.jsx("span", { className: `${Ma} ${o}`, children: l }) : /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-1-5 cn-9 dc__truncate", children: l })
        ] }),
        i && /* @__PURE__ */ e.jsx(
          Ra,
          {
            entities: [
              {
                value: i.value,
                color: i.color
              },
              {
                value: 100 - i.value,
                color: "var(--N100)"
              }
            ],
            rootClassName: "px-16 pb-6",
            showAnimationOnBar: !0,
            hideLegend: !0
          }
        )
      ]
    },
    `${a}-${t}`
  ))
] }) }), dw = () => /* @__PURE__ */ e.jsx("div", { className: `dc__grid dc__gap-16 system-overview__container ${Do}`, children: lw.map((t) => /* @__PURE__ */ e.jsx(cw, { ...t }, t.heading)) }), pw = [
  {
    heading: "CPU1 Temperature",
    icon: "ic-cpu",
    value: 38,
    status: "OK",
    minValue: 3,
    maxValue: 96
  },
  {
    heading: "Inlet Temperature",
    icon: "ic-thermometer",
    value: 22,
    status: "OK",
    minValue: -22,
    maxValue: 62
  }
], uw = [
  {
    heading: "System Board Fan 1A",
    value: 6e3,
    status: "OK",
    minValue: 480,
    maxValue: 1e4
  },
  {
    heading: "System Board Fan 1B",
    value: 5280,
    status: "OK",
    minValue: 480,
    maxValue: 1e4
  },
  {
    heading: "System Board Fan 2A",
    value: 6e3,
    status: "OK",
    minValue: 480,
    maxValue: 1e4
  },
  {
    heading: "System Board Fan 2B",
    value: 5280,
    status: "OK",
    minValue: 480,
    maxValue: 1e4
  }
], mw = () => /* @__PURE__ */ e.jsxs("div", { className: `dc__grid-cols-2 dc__gap-16 ${Do}`, children: [
  /* @__PURE__ */ e.jsxs(
    Da,
    {
      shrinkHeightToContent: !0,
      heading: "Temperature Sensors",
      description: "Current temperature readings",
      children: [
        pw.map((t) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 br-4 border__secondary p-12", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-8", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__align-items-center", children: [
              /* @__PURE__ */ e.jsx(W, { name: t.icon, color: "N700", size: 16 }),
              /* @__PURE__ */ e.jsx("h4", { className: "m-0 cn-7 fs-14 fw-6 lh-1-5", children: t.heading })
            ] }),
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
              /* @__PURE__ */ e.jsxs("span", { className: "cn-7 fs-14 fw-6 lh-1-5", children: [
                t.value,
                "°C"
              ] }),
              /* @__PURE__ */ e.jsx("span", { className: `${Ma} bcg-1 cg-7`, children: t.status })
            ] })
          ] }),
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-8", children: [
              /* @__PURE__ */ e.jsxs("span", { className: "cn-7 fs-13 fw-4 lh-1-5", children: [
                "Critical: ",
                t.minValue,
                "°C"
              ] }),
              /* @__PURE__ */ e.jsxs("span", { className: "cn-7 fs-13 fw-4 lh-1-5", children: [
                "Warning: ",
                t.maxValue,
                "°C"
              ] })
            ] }),
            /* @__PURE__ */ e.jsx(
              Ra,
              {
                entities: [
                  {
                    value: t.value - t.minValue,
                    color: "var(--G500)"
                  },
                  {
                    // Logic is: totalValue - consumedValue = (maxValue - minValue) - (item.value - minValue) = maxValue - item.value
                    value: t.maxValue - t.value,
                    color: "var(--N100)"
                  }
                ],
                showAnimationOnBar: !0,
                hideLegend: !0
              }
            )
          ] })
        ] }, `${t.heading}-temperature`)),
        /* @__PURE__ */ e.jsx(
          Ot,
          {
            heading: "Temperature Status",
            description: "All temperature sensors are within normal operating ranges. The system is running at optimal temperature"
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ e.jsx(Da, { shrinkHeightToContent: !0, heading: "Cooling Fans", description: "Fan speeds and status", children: uw.map((t) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6", children: [
    /* @__PURE__ */ e.jsx("h4", { className: "m-0 cn-7 fs-13 fw-4 lh-1-5", children: t.heading }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 br-4 border__secondary p-12", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-8", children: [
        /* @__PURE__ */ e.jsxs("h5", { className: "m-0 cn-9 fs-16 fw-6 lh-1-5", children: [
          t.value,
          " RPM"
        ] }),
        /* @__PURE__ */ e.jsx("span", { className: `${Ma} bcg-1 cg-7`, children: t.status })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6", children: [
        /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__content-space dc__gap-8", children: /* @__PURE__ */ e.jsxs("span", { className: "cn-7 fs-13 fw-4 lh-1-5", children: [
          "Min: ",
          t.minValue,
          " RPM"
        ] }) }),
        /* @__PURE__ */ e.jsx(
          Ra,
          {
            entities: [
              {
                value: t.value - t.minValue,
                color: "var(--G500)"
              },
              {
                // TODO: Check this logic correctness
                value: t.maxValue - (t.value - t.minValue),
                color: "var(--N100)"
              }
            ],
            showAnimationOnBar: !0,
            hideLegend: !0
          }
        )
      ] })
    ] })
  ] }, `${t.heading}-cooling-fans`)) })
] }), Do = "py-12 px-20 bg__primary h-100 w-100 dc__overflow-auto flex-grow-1", Ma = "px-6 py-2 br-4 dc__truncate fs-13 fw-5 lh-20 dc__text-center", I2 = [
  {
    id: "system-overview",
    label: "System Overview",
    renderComponent: () => /* @__PURE__ */ e.jsx(dw, {})
  },
  {
    id: "hardware",
    label: "Hardware",
    renderComponent: () => /* @__PURE__ */ e.jsx(tw, {})
  },
  {
    id: "thermal",
    label: "Thermal",
    renderComponent: () => /* @__PURE__ */ e.jsx(mw, {})
  },
  {
    id: "power",
    label: "Power",
    renderComponent: () => /* @__PURE__ */ e.jsx(iw, {})
  },
  {
    id: "network-and-logs",
    label: "Network & Logs",
    renderComponent: () => /* @__PURE__ */ e.jsx(aw, {})
  }
], _w = "scan-cluster-version-input", fw = "?chartCategoryId=1", hw = 5e3, gw = {
  name: {
    // NOTE: disabled will make it impossible to copy the text but for readonly we will be able at least copy the text
    "ui:disabled": !0
  },
  region: {
    "ui:disabled": !0
  },
  vpc_cidr: {
    "ui:disabled": !0
  },
  availability_zones: {
    "ui:disabled": !0
  },
  private_access_cidrs: {
    "ui:disabled": !0
  }
}, tg = ({
  version: t,
  isLatest: s
}) => {
  const n = `v${t}`;
  return {
    label: s ? `${n} (Latest)` : n,
    value: t
  };
}, sg = ({
  valuesSchema: t,
  values: s,
  installationType: n,
  installationId: a,
  name: r,
  installationStatus: o,
  installedEntityId: i,
  conditions: l
}) => ({
  schema: JSON.parse(t || "{}"),
  // Empty string handling
  values: zs.parse(s || "{}"),
  installationType: n,
  status: o,
  installationId: a,
  name: r,
  conditions: l ?? [],
  correspondingClusterId: i > 0 ? i : 0
}), xw = (t) => {
  switch (t) {
    case "True":
      return { name: "ic-check", color: "G500" };
    case "Unknown":
      return { name: "ic-in-progress", color: null };
    default:
      return { name: "ic-close-large", color: "R500" };
  }
}, Ew = (t) => {
  switch (t) {
    case Zs.Deleted:
      return { header: "Cluster deleted", icon: "ic-delete", color: "R500" };
    case Zs.Deleting:
      return { header: "Deleting cluster", icon: "ic-delete-dots", color: "R500" };
    case Zs.Updating:
      return { header: "Updating cluster", icon: "ic-circle-loader", color: "O500" };
    case Zs.Failed:
      return { header: "Cluster creation failed", icon: "ic-close-large", color: "R500" };
    case Zs.Installed:
      return { header: "Cluster created", icon: "ic-success", color: null };
    case Zs.Creating:
    default:
      return { header: "Creating cluster", icon: "ic-circle-loader", color: "O500" };
  }
}, Cw = async (t) => {
  const s = {
    sourceK8sVersion: t[0] === "v" ? t.slice(1) : t
  }, { result: n } = await le(ye($.CLUSTER_K8S_VERSIONS_LIST, s)), a = n?.filter((o) => !!o.version)?.map(({ version: o, isLatest: i }) => ({
    version: o,
    isLatest: i || !1
  })) || [], r = a.find((o) => o.isLatest)?.version || a[0]?.version;
  return {
    versionList: a,
    latestVersion: r
  };
}, v2 = async (t) => {
  const s = Ba({
    baseUrl: $.INFRASTRUCTURE,
    kind: ie.infrastructureInstallation,
    version: mt.v1
  });
  await Js(`${s}/${t}`);
}, bw = async ({ abortControllerRef: t }) => {
  const s = Ba({
    baseUrl: $.INFRASTRUCTURE,
    kind: ie.infrastructureInstallation,
    version: mt.v1
  });
  return le(s, { abortControllerRef: t });
}, A2 = async ({
  abortControllerRef: t
}) => {
  try {
    const { result: s } = await bw({ abortControllerRef: t });
    return (s ?? []).map(sg);
  } catch (s) {
    throw Pe(s) || V(s), s;
  }
}, Nw = async ({
  id: t,
  name: s,
  abortControllerRef: n
}) => {
  const a = Ba({
    baseUrl: $.INFRASTRUCTURE,
    kind: ie.infrastructureInstallation,
    version: mt.v1
  });
  return le(ye(a, t ? { id: t } : { name: s }), { abortControllerRef: n });
}, Tw = async ({
  clusterName: t,
  installationId: s,
  abortControllerRef: n
}) => {
  try {
    const { result: a } = await Nw({
      abortControllerRef: n,
      ...s ? { id: s } : { name: t }
    });
    return a.installationId ? sg(a) : null;
  } catch (a) {
    throw Pe(a) || V(a), a;
  }
}, Iw = async ({
  data: t,
  installationId: s,
  installationType: n
}) => {
  try {
    return await oh({
      installationId: s,
      chartValues: gt(t),
      installationType: n
    }), Z.showToast({
      variant: ee.success,
      description: "Cluster update initiated successfully"
    }), !0;
  } catch (a) {
    return V(a), !1;
  }
}, vw = async (t, s) => {
  const n = ye($.RECOMMENDED_CHARTS_STATUS, {
    clusterId: s,
    appStoreId: t
  });
  return (await le(n)).result || {};
}, Wu = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col p-12 br-8 bg__primary border__primary dc__overflow-hidden dc__gap-8 mw-232", children: [
  /* @__PURE__ */ e.jsx("div", { className: "h-32 w-32 shimmer" }),
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
    /* @__PURE__ */ e.jsx("span", { className: "shimmer h-16 w-100px" }),
    /* @__PURE__ */ e.jsx("span", { className: "shimmer h-16 w-100px" })
  ] })
] }), Aw = ({ name: t, id: s, icon: n, statusDetails: a, statusLoading: r }) => {
  const { status: o, installedAppId: i, environmentId: l } = a, c = i && l, d = c ? `/dashboard${se.INFRASTRUCTURE_MANAGEMENT_APP}/${se.DEVTRON_CHARTS}/${se.APP_DEPLOYMNENT_HISTORY}/${i}/env/${l}` : `/dashboard${se.INFRASTRUCTURE_MANAGEMENT_CHART_STORE_DISCOVER}/chart/${s}/deploy-chart`;
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "flexbox-col p-12 br-8 bg__primary border__primary dc__overflow-hidden dc__gap-8 mw-232 dc__hover-n50 dc__opacity-hover dc__opacity-hover--parent",
      onClick: cC(d),
      role: "button",
      tabIndex: 0,
      children: [
        /* @__PURE__ */ e.jsx(
          Bc,
          {
            imageProps: {
              src: n,
              height: 36,
              width: 36,
              alt: `${t} icon`,
              className: "dc__chart-grid-item__icon"
            },
            fallbackImage: /* @__PURE__ */ e.jsx(W, { name: "ic-helm", size: 36, color: "N500" })
          }
        ),
        /* @__PURE__ */ e.jsxs("div", { children: [
          /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 cn-9 lh-1-5 dc__truncate dc__w-fit-content", children: t }),
          /* @__PURE__ */ e.jsx("div", { className: "flex fs-12 dc__content-start lh-20 dc__gap-4", children: r ? /* @__PURE__ */ e.jsx("span", { className: "shimmer w-100px h-20" }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx("div", { className: `flex left ${o === "Installed" ? "cg-5" : ""}`, children: /* @__PURE__ */ e.jsx(zm, { hideIcon: o === "Installed", status: o }) }),
            /* @__PURE__ */ e.jsx("span", { className: "dc__opacity-hover--child", children: "/" }),
            /* @__PURE__ */ e.jsx("span", { className: "fw-6 cb-5 dc__opacity-hover--child", children: `${c ? "Details" : "Deploy"}` })
          ] }) })
        ] })
      ]
    }
  );
}, S2 = ({ clusterId: t, getAvailableCharts: s }) => {
  const [n, a, r, o] = ne(
    () => s(fw),
    []
  ), i = (a?.result || []).map((p) => p.id).join(), [l, c] = ne(
    () => vw(i, t),
    [],
    !!i
  );
  if (a && !a.result?.length)
    return null;
  const d = () => n ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Wu, {}),
    /* @__PURE__ */ e.jsx(Wu, {})
  ] }) : r ? /* @__PURE__ */ e.jsx(
    ps,
    {
      rootClassName: "flex flex-grow-1",
      title: "Could not load recommended add ons",
      subTitle: "",
      reload: o
    }
  ) : (a?.result ?? []).map(({ name: p, id: m, icon: u }) => {
    const f = c?.[m] ?? { status: "Installed", installedAppId: 0, environmentId: 0 };
    return /* @__PURE__ */ e.jsx(
      Aw,
      {
        name: p,
        id: m,
        icon: u,
        statusDetails: f,
        statusLoading: l
      },
      `${p}-${m}`
    );
  });
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col br-4 bg__primary border__primary dc__overflow-hidden mb-16", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox px-16 py-10 dc__gap-8", children: [
      /* @__PURE__ */ e.jsx(I_, { className: "icon-dim-20" }),
      /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-20 fw-6 cn-9", children: "Recommended Add-ons" })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox p-16 dc__gap-12 dc__overflow-auto", children: d() })
  ] });
}, ng = ({ values: t, schema: s }) => {
  const [n, a] = v(
    {}
  ), r = (i, l) => {
    a((c) => ({
      // Using the value from callback to handle the batch updates
      ...c,
      [i]: l
    }));
  }, o = Object.entries(n).every(([, i]) => i) ? Uh : yR;
  return /* @__PURE__ */ e.jsx(
    RR,
    {
      value: {
        jsonViewExpansionMap: n,
        updateJsonViewExpansionMap: r,
        currentView: o
      },
      children: /* @__PURE__ */ e.jsx(FR, { originalFormData: t, originalSchema: s })
    }
  );
}, ag = ({
  values: t,
  setIsEditModalOpen: s,
  schema: n,
  installationId: a,
  installationType: r,
  pollClusterConfig: o
}) => {
  const i = de(null), [l, c] = v(!1), [d, p] = v(t), m = () => {
    s(!1);
  }, u = async ({ formData: h }) => {
    c(!0), p(h);
    const x = await Iw({ installationId: a, installationType: r, data: h });
    c(!1), x && (o(h.name), m());
  }, f = (h = []) => {
    V(new Error(Ji)), console.error("Form Validation Error", h);
  }, _ = () => {
    i.current.submit();
  };
  return /* @__PURE__ */ e.jsx($t, { position: "right", width: "800px", onEscape: m, onClose: m, children: /* @__PURE__ */ e.jsxs("div", { className: "h-100 bg__primary flexbox-col dc__overflow-hidden", onClick: Le, children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space py-16 px-20 dc__border-bottom", children: [
      /* @__PURE__ */ e.jsx("h2", { className: "fs-16 cn-9 fw-6 m-0", children: "Edit cluster configuration" }),
      /* @__PURE__ */ e.jsx(
        j,
        {
          icon: /* @__PURE__ */ e.jsx(vt, {}),
          dataTestId: "close-create-cluster-modal-button",
          component: Re.button,
          style: B.negativeGrey,
          size: O.xs,
          variant: w.borderLess,
          ariaLabel: "Close new cluster drawer",
          showTooltip: l,
          tooltipProps: {
            content: Nn
          },
          disabled: l,
          onClick: m,
          showAriaLabelInTippy: !1
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "dc__overflow-auto flex-grow-1", children: /* @__PURE__ */ e.jsx(
      la,
      {
        ref: i,
        uiSchema: {
          ...Fa,
          ...structuredClone(gw)
        },
        schema: n,
        onSubmit: u,
        formData: d,
        onError: f
      }
    ) }),
    /* @__PURE__ */ e.jsxs("footer", { className: "dc__border-top flex dc__gap-8 right bg__primary pt-16 pr-20 pb-16 pl-20", children: [
      /* @__PURE__ */ e.jsx(
        j,
        {
          text: "Cancel",
          size: O.large,
          dataTestId: "close-create-cluster-button",
          disabled: l,
          onClick: m,
          variant: w.secondary,
          style: B.neutral
        }
      ),
      /* @__PURE__ */ e.jsx(
        j,
        {
          text: "Update Cluster",
          size: O.large,
          dataTestId: "update-create-cluster-button",
          buttonProps: { type: "submit" },
          isLoading: l,
          onClick: _
        }
      )
    ] })
  ] }) });
}, Sw = ({ type: t, status: s, isExpanded: n, toggleExpandStage: a }) => {
  const { name: r, color: o } = xw(s);
  return /* @__PURE__ */ e.jsxs(
    "button",
    {
      "data-testId": `installation status ${t} state`,
      className: "flexbox dc__unset-button-styles dc__align-items-center dc__gap-8 px-8 py-6 br-4 bg__overlay--primary",
      type: "button",
      onClick: a,
      "aria-label": `expand collapse ${t} details`,
      children: [
        /* @__PURE__ */ e.jsx(
          u_,
          {
            className: `icon-dim-16 dc__transition--transform icon-stroke__white ${n ? "" : "dc__flip-n90 dc__opacity-0_5"}`
          }
        ),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-12", children: [
          /* @__PURE__ */ e.jsx(W, { name: r, color: o }),
          /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20 cn-9", children: t })
        ] })
      ]
    }
  );
}, yw = ({ index: t, title: s, description: n }) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
  /* @__PURE__ */ e.jsx("span", { className: "w-36 dc__text-align-end dc__no-shrink", children: t }),
  /* @__PURE__ */ e.jsxs("span", { children: [
    s,
    ": ",
    n
  ] })
] }), Lw = ({ stageDetails: t, type: s }) => {
  const [n, a] = v(!0), r = () => {
    a((o) => !o);
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
    /* @__PURE__ */ e.jsx(
      Sw,
      {
        status: t.status,
        type: s,
        isExpanded: n,
        toggleExpandStage: r
      }
    ),
    n && /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-4 lh-24 cn-9 mono", children: Object.keys(t).map((o, i) => (
      // NOTE: Using index as key is not recommended, but in this case, the order of steps is fixed and won't change
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ e.jsx(yw, { index: i + 1, title: o, description: t[o] }, i)
    )) })
  ] });
}, jw = ({ conditions: t = [] }) => /* @__PURE__ */ e.jsx(
  "div",
  {
    className: `p-8 flexbox-col dc__gap-4 flex-grow-1 dc__overflow-auto ${dC(qc.dark)}`,
    style: { backgroundColor: "var(--terminal-bg)" },
    children: t.length ? t.map((s, n) => {
      const { type: a, lastProbeTime: r, ...o } = s;
      return /* @__PURE__ */ e.jsx(Lw, { stageDetails: o, type: a }, n);
    }) : /* @__PURE__ */ e.jsx(Je, { size: 24 })
  }
), Ow = ({ clusterId: t }) => {
  const s = `${se.INFRASTRUCTURE_MANAGEMENT_RESOURCE_BROWSER}/${t}/${Co.value}/${ao.Overview.toLowerCase()}/k8sEmptyGroup`;
  return /* @__PURE__ */ e.jsx(
    j,
    {
      dataTestId: "go-to-cluster-overview",
      text: "Go to cluster overview",
      endIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-arrow-right", color: "B500" }),
      variant: w.text,
      component: Re.link,
      linkProps: {
        to: s
      }
    }
  );
}, Rw = ({ installationId: t, handleClose: s, hideEditButton: n }) => {
  const [a, r] = v(!0), [o, i] = v(null), [l, c] = v(null), [d, p] = v(!1), m = de(new AbortController()), u = de(null), { schema: f, values: _ } = l ?? {}, h = () => Tw({ installationId: +t, abortControllerRef: m }).then((I) => {
    if (!I)
      throw new Ua({
        code: da.NOT_FOUND,
        errors: [new pC({ userMessage: "No matching installation cluster found" })]
      });
    c(I), i(null);
  }).catch((I) => {
    throw Pe(I) || V(I), i(I), clearTimeout(u.current), m.current.abort(), I;
  }).finally(() => {
    r(!1);
  }), x = () => {
    u.current === null && (u.current = setTimeout(() => {
      h().then(() => {
        u.current = null, x();
      }).catch(Be);
    }, hw));
  }, g = () => {
    m.current = new AbortController(), h().catch(Be), x();
  };
  J(() => (g(), () => {
    m.current.abort(), clearTimeout(u.current);
  }), []);
  const E = l?.status !== Zs.Deleting && l?.status !== Zs.Deleted, C = () => s ? /* @__PURE__ */ e.jsx(
    j,
    {
      dataTestId: "close-installation-status-dialog",
      icon: /* @__PURE__ */ e.jsx(W, { name: "ic-close-small", color: null }),
      ariaLabel: "close installation status dialog",
      showAriaLabelInTippy: !1,
      size: O.xs,
      variant: w.borderLess,
      style: B.negativeGrey,
      onClick: s
    }
  ) : l.correspondingClusterId && E ? /* @__PURE__ */ e.jsx(Ow, { clusterId: l.correspondingClusterId }) : null, b = () => {
    p(!0);
  }, N = () => {
    if (a)
      return /* @__PURE__ */ e.jsx(Je, { size: 32 });
    if (o && !l || !l)
      return /* @__PURE__ */ e.jsx(
        ps,
        {
          title: "Could not load installation status",
          subTitle: "",
          rootClassName: "flex-grow-1",
          reload: g
        }
      );
    const { header: I, icon: T, color: A } = Ew(
      l.correspondingClusterId && l.status === Zs.Creating ? Zs.Installed : l.status
    );
    return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col w-300 bg__secondary dc__no-shrink", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 cn-9 p-24 border__secondary--bottom", children: [
          /* @__PURE__ */ e.jsx("div", { className: "flex p-8 br-8 bcn-1 dc__w-fit-content", children: /* @__PURE__ */ e.jsx(W, { name: "ic-amazon-eks", size: 32, color: null }) }),
          /* @__PURE__ */ e.jsx("span", { className: "dc__truncate fs-16 fw-7 lh-1-5 font-merriweather", children: l.name })
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-12 dc__overflow-auto p-24 catalog__cluster-config flex-grow-1", children: /* @__PURE__ */ e.jsx(ng, { schema: f, values: _ }) }),
        !n && E && /* @__PURE__ */ e.jsx("div", { className: "border__secondary--top flexbox px-24 py-16", children: /* @__PURE__ */ e.jsx(
          j,
          {
            dataTestId: "edit-cluster-config-button",
            startIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-pencil", color: null }),
            text: "Edit Configurations",
            variant: w.text,
            size: O.large,
            onClick: b
          }
        ) })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox p-24 dc__content-space", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-8", children: [
            /* @__PURE__ */ e.jsx(W, { name: T, color: A, size: 20 }),
            /* @__PURE__ */ e.jsx("span", { "data-testid": "cluster-installation-status", className: "fs-16 fw-6 lh-1-5", children: I })
          ] }),
          C()
        ] }),
        /* @__PURE__ */ e.jsx(jw, { conditions: l.conditions })
      ] })
    ] });
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox w-800 h-500 bg__primary border__primary br-12  dc__overflow-hidden", children: [
    N(),
    d && /* @__PURE__ */ e.jsx(
      ag,
      {
        installationId: l.installationId,
        installationType: l.installationType,
        schema: l.schema,
        setIsEditModalOpen: p,
        values: l.values,
        pollClusterConfig: g
      }
    )
  ] });
}, Pw = ({ installationId: t, handleClose: s }) => /* @__PURE__ */ e.jsx(Mc, { onEscape: s, children: /* @__PURE__ */ e.jsx("div", { className: "dc__m-auto mt-40", children: /* @__PURE__ */ e.jsx(Rw, { installationId: t, handleClose: s, hideEditButton: !0 }) }) }), y2 = ({ clusterConfig: t, pollClusterConfig: s }) => {
  const [n, a] = v(!1), [r, o] = v(!1), { schema: i = {}, values: l = {}, installationType: c, status: d, installationId: p, name: m = "" } = t ?? {}, u = d === Zs.Updating;
  J(() => {
    u && s(m);
  }, [u]);
  const f = () => {
    a(!0);
  }, _ = () => {
    o(!0), s(m);
  }, h = () => {
    o(!1);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("section", { className: "bg__primary en-2 br-4 bw-1 fs-13 fw-4 lh-20 cn-7 mb-12", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "dc__border-bottom dc__top-radius-4 bg__secondary flex flex-justify px-16 py-8", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox flex-align-center dc__gap-6", children: [
          /* @__PURE__ */ e.jsx(W, { name: "ic-sliders-vertical", color: "N900", size: 16 }),
          /* @__PURE__ */ e.jsx("span", { className: "fw-6 cn-9 mr-8", children: "Cluster Configuration" })
        ] }),
        /* @__PURE__ */ e.jsx(
          j,
          {
            dataTestId: "edit-cluster-config-button",
            startIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-pencil", size: 16, color: "N700" }),
            size: O.small,
            text: "Edit",
            variant: w.borderLess,
            onClick: f
          }
        )
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16 p-16", children: [
        /* @__PURE__ */ e.jsx("div", { className: "dc__overflow-auto mxh-504", children: /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__gap-20 catalog__cluster-config catalog__cluster-config--wrap flex-wrap", children: /* @__PURE__ */ e.jsx(ng, { values: l, schema: i }) }) }),
        u && /* @__PURE__ */ e.jsxs("div", { className: "flexbox px-12 py-8 dc__gap-8 br-4 bg__secondary", children: [
          /* @__PURE__ */ e.jsx(zm, { status: Tm.PROGRESSING, hideMessage: !0 }),
          /* @__PURE__ */ e.jsx("span", { className: "fw-6 lh-20 fs-13 co-5", children: "Update in progress" }),
          /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: "view-update-cluster-config-button",
              text: "View details",
              variant: w.text,
              onClick: _
            }
          )
        ] })
      ] })
    ] }),
    p && r && /* @__PURE__ */ e.jsx(
      Pw,
      {
        installationId: p?.toString(),
        handleClose: h
      }
    ),
    n && /* @__PURE__ */ e.jsx(
      ag,
      {
        installationId: p,
        installationType: c,
        schema: i,
        setIsEditModalOpen: a,
        values: l,
        pollClusterConfig: s
      }
    )
  ] });
}, ww = ({
  currentVersion: t,
  latestVersion: s,
  clusterListOptions: n,
  targetVersion: a,
  setTargetVersion: r,
  clusterName: o,
  handleCloseClusterDialog: i,
  handleOpenScanClusterTab: l
}) => {
  const c = t === s, d = (u) => {
    r(u.value);
  }, p = () => {
    zc({
      category: "RB Upgrade Cluster",
      action: "RB_CLUSTER_CHECK_UPGRADE_COMPATIBILITY_SCAN_CLUSTER"
    }), l(a), i();
  }, m = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 w-100", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
      /* @__PURE__ */ e.jsxs("span", { className: "cn-8 fs-13 fw-4 lh-20 dc__truncate dc_max-width__max-content", children: [
        "Current version: ",
        t
      ] }),
      c && /* @__PURE__ */ e.jsxs("span", { className: "cn-8 fs-13 fw-4 lh-20 dc__truncate dc_max-width__max-content", children: [
        "Latest version available: ",
        t
      ] })
    ] }),
    !c && /* @__PURE__ */ e.jsx(
      Ve,
      {
        inputId: _w,
        label: "Select target version",
        required: !0,
        options: n,
        value: tg({
          version: a,
          isLatest: a === s
        }),
        onChange: d
      }
    )
  ] });
  return /* @__PURE__ */ e.jsx(
    zt,
    {
      variant: Ct.custom,
      Icon: /* @__PURE__ */ e.jsx(gN, {}),
      title: c ? `Cluster ${o} is running the latest Kubernetes version` : `Upgrade Kubernetes version for cluster ${o}`,
      handleClose: i,
      buttonConfig: {
        secondaryButtonConfig: {
          text: c ? "Close" : "Cancel",
          onClick: i
        },
        ...c ? {} : {
          primaryButtonConfig: {
            text: "Scan Cluster",
            onClick: p
          }
        }
      },
      children: m()
    }
  );
}, L2 = ({
  handleOpenScanClusterTab: t,
  clusterName: s,
  currentVersion: n
}) => {
  const [
    a,
    r,
    o,
    i
  ] = ne(() => Cw(n), [n], !!n), [l, c] = v(!1), [d, p] = v(null), m = r?.latestVersion, u = () => {
    if (zc({
      category: "RB Upgrade Cluster",
      action: "RB_CLUSTER_CHECK_UPGRADE_COMPATIBILITY"
    }), o?.code === Ns.PERMISSION_DENIED) {
      Z.showToast({
        variant: ee.notAuthorized,
        title: mp.TITLE,
        description: mp.SUBTITLE
      });
      return;
    }
    c(!0);
  };
  J(() => {
    !a && !o && r?.latestVersion && p(r.latestVersion);
  }, [a, r, o]);
  const f = Q(
    () => r?.versionList?.map(tg) || [],
    [r]
  ), _ = () => {
    c(!1);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "py-8 px-12 flexbox-col dc__gap-8 br-4 eb-2 bw-1 bcb-1", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-8", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
          /* @__PURE__ */ e.jsx("h6", { className: "m-0 cn-9 fs-13 fw-6 lh-20", children: "Migrating to another K8s version?" }),
          /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-13 fw-4 lh-20 cn-9", children: "Check Kubernetes objects api-version compatibility and get migration path for K8s objects and prepare it for cluster upgrades." })
        ] }),
        /* @__PURE__ */ e.jsx(qi, { className: "icon-dim-20 dc__no-shrink" })
      ] }),
      /* @__PURE__ */ e.jsx(
        j,
        {
          dataTestId: "check-cluster-upgrade-compatibility",
          text: "Check compatibility",
          variant: w.text,
          size: O.medium,
          onClick: u,
          ...a ? { disabled: !0, endIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-circle-loader", color: null }) } : {}
        }
      )
    ] }),
    l && /* @__PURE__ */ e.jsx(
      ww,
      {
        currentVersion: n,
        latestVersion: m || n,
        clusterListOptions: f,
        targetVersion: d,
        setTargetVersion: p,
        clusterName: s,
        handleCloseClusterDialog: _,
        handleOpenScanClusterTab: t,
        ...o ? { hasError: !!o, reload: i } : {}
      }
    )
  ] });
};
var Oa = /* @__PURE__ */ ((t) => (t.DELETE = "DELETE", t.POD_SPREAD = "POD_SPREAD", t.HIBERNATION_RULES = "HIBERNATION_RULES", t))(Oa || {});
const Dw = [
  {
    items: [
      {
        id: Oa.POD_SPREAD,
        label: "Set Pod spread",
        startIcon: { name: "ic-two-cubes", color: "N800" },
        componentType: "button"
      },
      {
        id: Oa.HIBERNATION_RULES,
        label: "Hibernation rules",
        startIcon: { name: "ic-hibernate-circle", color: "N800" },
        componentType: "button"
      }
    ]
  },
  {
    items: [
      {
        id: Oa.DELETE,
        label: "Delete",
        startIcon: { name: "ic-delete" },
        componentType: "button",
        type: "negative"
      }
    ]
  }
], j2 = ({ handleDelete: t, handleHibernationRules: s, handlePodSpread: n }) => {
  const a = (r) => {
    switch (r.id) {
      case Oa.DELETE:
        t();
        break;
      case Oa.POD_SPREAD:
        n();
        break;
      case Oa.HIBERNATION_RULES:
        s();
        break;
      default:
        Be();
    }
  };
  return /* @__PURE__ */ e.jsx(
    ki,
    {
      id: "resource-browser-page-header-popup",
      onClick: a,
      options: Dw,
      buttonProps: {
        dataTestId: "resource-browser-page-header-popup-button",
        icon: /* @__PURE__ */ e.jsx(W, { name: "ic-more-vertical", color: "N700" }),
        variant: w.borderLess,
        style: B.neutral,
        showAriaLabelInTippy: !1,
        ariaLabel: "Edit Cluster options",
        size: O.medium
      }
    }
  );
}, Mw = ({
  resourceInfo: t,
  columnName: s,
  showAbsoluteValuesInResourceRecommender: n
}) => {
  const { delta: a, recommended: r, current: o } = t, { badgeProps: i, iconProps: l } = yu(t), c = () => {
    const { iconProps: d, class: p } = yu({
      ...t,
      isTooltipView: !0
    });
    return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
      /* @__PURE__ */ e.jsx("div", { className: "flexbox border__white-10--bottom px-8", children: /* @__PURE__ */ e.jsx("h6", { className: "m-0 fs-12 fw-6 lh-18 dc__word-break p-8", children: Hh[s] || s }) }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4 px-16 py-8", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__content-space w-100", children: [
          /* @__PURE__ */ e.jsx("span", { className: "fs-12 fw-4 lh-18", children: "Current" }),
          /* @__PURE__ */ e.jsx("span", { className: "fs-12 fw-6 lh-18 dc__word-break", children: ir(o?.value) })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__content-space w-100", children: [
          /* @__PURE__ */ e.jsx("span", { className: "fs-12 fw-4 lh-18", children: "Recommended" }),
          /* @__PURE__ */ e.jsx("span", { className: "fs-12 fw-6 lh-18 dc__word-break", children: ir(r?.value) })
        ] }),
        Ht(r?.value) ? /* @__PURE__ */ e.jsx("span", { className: "fs-11 fw-4 lh-1-5", children: "No recommendation available due to insufficient data" }) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__content-space w-100", children: [
          /* @__PURE__ */ e.jsx("span", { className: "fs-12 fw-4 lh-18", children: "Change" }),
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-2 dc__align-items-center", children: [
            /* @__PURE__ */ e.jsx(W, { ...d, size: 12 }),
            /* @__PURE__ */ e.jsx("span", { className: `fs-12 fw-6 lh-18 ${p}`, children: !Ht(a) && `${Math.abs(a)}%` })
          ] })
        ] })
      ] })
    ] });
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4 py-12", children: [
    /* @__PURE__ */ e.jsx(Ie, { alwaysShowTippyOnHover: !0, className: "no-content-padding", content: c(), children: Ht(r?.value) ? /* @__PURE__ */ e.jsx("span", { children: "No Recommendation" }) : /* @__PURE__ */ e.jsx("div", { className: "dc__inline-block", children: /* @__PURE__ */ e.jsx(
      Km,
      {
        label: !Ht(a) && `${Math.abs(a)}%`,
        endIconProps: l,
        size: O.xxs,
        ...i
      }
    ) }) }),
    n && /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-4 dc__word-break", children: [
      /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-12 fw-5 lh-1-5 dc__word-break", children: ir(o?.value) }),
      /* @__PURE__ */ e.jsx(W, { name: "ic-arrow-right", color: "N700", size: 12 }),
      /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-12 fw-5 lh-1-5 dc__word-break", children: ir(r?.value) })
    ] })
  ] });
}, kw = ({
  field: t,
  row: { id: s, data: n },
  filterData: { searchKey: a },
  signals: r,
  handleReloadDataAfterBulkOperation: o,
  resourceRecommenderConfig: { showAbsoluteValuesInResourceRecommender: i }
}) => {
  const l = n, { push: c } = Te(), { clusterId: d } = Ue(), [p, m] = v(null), u = (h) => {
    const { name: x, namespace: g = Co.value, kind: E, apiVersion: C } = h.currentTarget.dataset, b = hr(C).group.toLowerCase() || uC, N = Kt(mC.K8S_RESOURCE_DETAIL, {
      clusterId: d,
      namespace: g,
      name: x,
      kind: E.toLowerCase(),
      group: b
    });
    c(`${N}/${_C.manifest}`);
  };
  J(() => {
    const h = ({ detail: { activeRowData: x } }) => {
      x.id === s && m(x.data);
    };
    return t === "name" && r.addEventListener(_p.ENTER_PRESSED, h), () => {
      t === "name" && r.removeEventListener(_p.ENTER_PRESSED, h);
    };
  }, []);
  const f = () => {
    m(l);
  }, _ = () => {
    m(null);
  };
  return l.additionalMetadata?.[t] ? /* @__PURE__ */ e.jsx(
    Mw,
    {
      resourceInfo: l.additionalMetadata[t],
      columnName: t,
      showAbsoluteValuesInResourceRecommender: i
    }
  ) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    t === "name" ? /* @__PURE__ */ e.jsx(
      "div",
      {
        className: "flexbox dc__align-items-center dc__gap-4 dc__content-space py-10 pr-6",
        "data-testid": "created-resource-name",
        children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-start dc__content-space dc__gap-8 flex-grow-1", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-start dc__gap-4 flex-grow-1 dc__visible-hover dc__visible-hover--parent", children: [
            /* @__PURE__ */ e.jsx(Ie, { content: l.name, children: /* @__PURE__ */ e.jsx(
              "button",
              {
                type: "button",
                className: "dc__unset-button-styles dc__align-left dc__truncate cursor-default",
                "data-name": l.name,
                "data-namespace": l.namespace,
                "data-kind": l.kind,
                "data-api-version": l.apiVersion,
                onClick: u,
                children: /* @__PURE__ */ e.jsx(
                  "span",
                  {
                    className: "dc__link cursor",
                    dangerouslySetInnerHTML: {
                      __html: ta.sanitize(
                        aa({
                          searchText: a,
                          text: String(l.name),
                          highlightClasses: "p-0 fw-6 bcy-2"
                        })
                      )
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ e.jsx(
              Hi,
              {
                content: String(l.name),
                rootClassName: "mt-4 dc__visible-hover--child"
              }
            )
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "generic-table__row__hover-item", children: /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: `apply-recommendation-${l.id}`,
              text: "Apply",
              endIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-caret-right", color: null }),
              onClick: f,
              size: O.medium,
              variant: w.text,
              isOpacityHoverChild: !0
            }
          ) })
        ] })
      }
    ) : /* @__PURE__ */ e.jsx("div", { className: "flexbox py-10 dc__align-items-center", children: /* @__PURE__ */ e.jsx(Ie, { content: l[t]?.toString(), children: /* @__PURE__ */ e.jsx(
      "span",
      {
        className: t === "status" ? "dc__no-shrink" : "dc__truncate dc__ellipsis-right",
        "data-testid": `${t}-count`,
        dangerouslySetInnerHTML: {
          __html: ta.sanitize(
            aa({
              searchText: a,
              text: l[t]?.toString(),
              highlightClasses: "p-0 fw-6 bcy-2"
            })
          )
        }
      }
    ) }) }),
    p && /* @__PURE__ */ e.jsx(
      qh,
      {
        handleClose: _,
        clusterId: +d,
        resourceList: [p],
        handleReloadDataAfterBulkOperation: o
      }
    )
  ] });
}, O2 = ({
  selectedCluster: t,
  dynamicSort: s,
  ResourceRecommenderTableViewWrapper: n
}) => {
  const a = de(new AbortController()), { clusterId: r } = Ue(), [o, i] = v(!1), [l, c] = v(!0), [d, p] = v(!1), { selectedAPIVersionGVKFilter: m, selectedKindGVKFilter: u, selectedNamespace: f } = _t({
    parseSearchParams: Lu
  }), _ = () => es(
    () => WR({
      clusterId: +r,
      namespace: f === Co.value ? null : f,
      apiVersion: m,
      kind: u,
      resourceListAbortControllerRef: a
    }),
    a
  ), [
    h,
    x,
    g,
    E
  ] = ne(
    _,
    [r, f, u, m],
    !!r
  );
  J(
    () => () => {
      a.current.abort();
    },
    []
  );
  const C = h || Pe(g), b = !Pe(g) && !C ? g : null, [N, I, T, A] = ne(
    () => qR(+r),
    [r],
    !!r
  ), S = I?.gvkList || [], { resourceList: L } = x || {}, R = Q(
    () => L?.headers.map(
      (oe) => ({
        field: oe,
        label: Hh[oe],
        size: {
          range: {
            maxWidth: 600,
            minWidth: 70,
            startWidth: BR[oe]
          }
        },
        CellComponent: kw,
        comparator: s(oe),
        isSortable: !0,
        horizontallySticky: oe === rt.NAME
      })
    ) ?? [],
    [x]
  ), y = Q(
    () => (L?.data || []).map((oe) => ({
      data: oe,
      id: oe.id
    })),
    [x]
  ), M = async () => {
    p(!0), await Wh(+r), p(!1);
  }, P = () => /* @__PURE__ */ e.jsx(
    j,
    {
      dataTestId: "configure-prometheus-button",
      text: "Configure Prometheus",
      endIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-arrow-right", color: null }),
      component: Re.link,
      linkProps: {
        to: Kt(se.GLOBAL_CONFIG_EDIT_CLUSTER, { clusterId: r }),
        target: "_blank",
        rel: "noopener noreferrer"
      }
    }
  ), U = () => /* @__PURE__ */ e.jsx(
    j,
    {
      dataTestId: "initiate-resource-recommender-scan-button",
      text: "Check for recommendations",
      startIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-arrows-clockwise", color: null }),
      size: O.large,
      onClick: M,
      isLoading: d
    }
  ), G = () => {
    c(!1);
  }, H = () => b?.code === Ns.PRE_CONDITION_FAILED ? /* @__PURE__ */ e.jsx(
    _e,
    {
      title: "Set up Prometheus to monitor this cluster",
      subTitle: "Configure Prometheus to analyze resource usage and recommend resource configurations for this cluster",
      isButtonAvailable: !0,
      renderButton: P,
      SvgImage: xN,
      imageType: bs.Large
    }
  ) : I && !I.lastScannedOn ? /* @__PURE__ */ e.jsx(
    _e,
    {
      title: "No recommendations yet",
      subTitle: "We haven’t collected any data for recommendations in this cluster yet. Start a request to analyze usage and generate helpful configuration suggestions.",
      SvgImage: Ip,
      imageType: bs.Large,
      isButtonAvailable: !0,
      renderButton: U
    }
  ) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    l && /* @__PURE__ */ e.jsx(
      Ot,
      {
        description: "This is an experimental feature. Apply recommendations with caution.",
        size: O.medium,
        buttonProps: {
          dataTestId: "collapse-is-experimental-warning-button",
          icon: /* @__PURE__ */ e.jsx(W, { name: "ic-close-small", color: null }),
          ariaLabel: "Close is experimental feature warning",
          onClick: G,
          variant: w.borderLess,
          style: B.neutral,
          showAriaLabelInTippy: !1
        },
        borderConfig: {
          top: !1,
          right: !1,
          left: !1
        },
        borderRadiusConfig: {
          top: !1,
          right: !1,
          left: !1,
          bottom: !1
        }
      }
    ),
    /* @__PURE__ */ e.jsx(
      fC,
      {
        columns: R,
        rows: y,
        filtersVariant: hC.URL,
        id: "table__resource-recommender",
        paginationVariant: gC.PAGINATED,
        ViewWrapper: n,
        loading: C,
        pageSizeOptions: fp,
        filter: KR,
        additionalFilterProps: {
          initialSortKey: "namespace",
          parseSearchParams: Lu,
          defaultPageSize: fp[0].value
        },
        bulkSelectionConfig: {
          BulkActionsComponent: GR,
          bulkActionsData: {
            isResourceRecommendationView: !0
          },
          getSelectAllDialogStatus: () => Io.CLOSED,
          BulkOperationModal: rP,
          bulkOperationModalData: {
            selectedResource: {
              gvk: {
                Group: "",
                Version: "",
                Kind: ao.ResourceRecommender
              },
              namespaced: !0
            },
            isNodeListing: !1,
            getManifestResource: Be,
            updateManifestResourceHelmApps: Be,
            clusterId: +r,
            clusterName: t?.label ?? "",
            handleReloadDataAfterBulkOperation: E
          }
        },
        emptyStateConfig: {
          noRowsConfig: {
            title: "No recommendations yet",
            subTitle: "Start a request to analyze usage and generate helpful configuration suggestions.",
            SvgImage: Ip,
            imageType: bs.Large,
            isButtonAvailable: !0,
            renderButton: U
          }
        },
        additionalProps: {
          selectedCluster: t,
          selectedResource: {
            gvk: {
              Group: "",
              Version: "",
              Kind: ao.ResourceRecommender
            },
            namespaced: !0
          },
          resourceListError: b,
          reloadResourceList: E,
          resourceRecommenderConfig: {
            setShowAbsoluteValuesInResourceRecommender: i,
            showAbsoluteValuesInResourceRecommender: o,
            resourceLastScannedOnDetails: I ? {
              lastScannedOn: I.lastScannedOn
            } : null
          },
          gvkFilterConfig: {
            gvkOptions: S,
            areGVKOptionsLoading: N,
            reloadGVKOptions: A,
            gvkOptionsError: T
          }
        }
      }
    )
  ] });
  return /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__content-space h-100 w-100 dc__overflow-auto", children: H() });
}, R2 = ({ lastScannedOn: t, filteredRows: s }) => {
  const { clusterId: n } = Ue(), [a, r] = v(t), [o, i] = v(!1), l = de(null), { open: c, overlayProps: d, popoverProps: p, triggerProps: m, scrollableRef: u, closePopover: f } = xC({
    id: "resource-recommender-action-menu",
    width: 240,
    alignment: "end"
  }), _ = () => bC({
    startTime: t,
    endTime: (/* @__PURE__ */ new Date()).toISOString(),
    fallbackString: ""
  });
  J(() => (t && (r(_()), l.current = setInterval(() => {
    r(_());
  }, 1e3)), () => {
    l.current && (clearInterval(l.current), l.current = null);
  }), [t]);
  const h = async (g) => {
    g.stopPropagation(), i(!0), await Wh(+n), i(!1), f();
  }, x = () => Promise.resolve(YR((s || []).map((g) => g.data)));
  return /* @__PURE__ */ e.jsx(
    EC,
    {
      open: c,
      overlayProps: d,
      popoverProps: p,
      triggerProps: m,
      triggerElement: null,
      buttonProps: {
        dataTestId: "open-resource-recommender-action-menu",
        variant: w.secondary,
        style: B.neutral,
        size: O.medium,
        icon: /* @__PURE__ */ e.jsx(W, { name: "ic-more-vertical", color: null }),
        ariaLabel: "Open resource recommender action menu",
        showAriaLabelInTippy: !1
      },
      children: /* @__PURE__ */ e.jsxs("div", { ref: u, className: "dc__overflow-auto p-4", onClick: f, children: [
        /* @__PURE__ */ e.jsxs(
          "button",
          {
            type: "button",
            className: "bg__hover dc__transparent flexbox dc__gap-8 px-8 py-6 w-100",
            disabled: o,
            onClick: h,
            children: [
              /* @__PURE__ */ e.jsx("span", { className: "mt-2 flex dc__no-shrink dc__align-start", children: o ? /* @__PURE__ */ e.jsx(W, { name: "ic-circle-loader", color: "O500", size: 16 }) : /* @__PURE__ */ e.jsx(W, { name: "ic-arrows-clockwise", color: "N800", size: 16 }) }),
              /* @__PURE__ */ e.jsxs("span", { className: "flexbox-col", children: [
                /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-1-5 dc__align-left", children: "Re-scan for recommendations" }),
                a && /* @__PURE__ */ e.jsxs("span", { className: "cn-7 fs-12 fw-4 lh-1-5 dc__align-left", children: [
                  "Last scanned ",
                  a,
                  " ago"
                ] })
              ] })
            ]
          }
        ),
        /* @__PURE__ */ e.jsx(
          CC,
          {
            fileName: "Devtron Resource Recommendations",
            headers: Kh,
            triggerElementConfig: {
              customButton: {
                className: "bg__hover flexbox dc__gap-8 px-8 py-6 w-100",
                content: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                  /* @__PURE__ */ e.jsx("span", { className: "mt-2 flex dc__no-shrink", children: /* @__PURE__ */ e.jsx(W, { name: "ic-download", size: 16, color: "N800" }) }),
                  /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-1-5", children: "Export CSV" })
                ] })
              }
            },
            apiPromise: x,
            disabled: !s.length,
            modalConfig: {
              hideDialog: !0
            }
          }
        )
      ] })
    }
  );
}, P2 = ({
  resource: t,
  getManifestResource: s,
  updateManifestResourceHelmApps: n,
  onClose: a,
  onSuccess: r
}) => {
  const [o, i] = v(!1), l = de(new AbortController()), c = async () => {
    i(!0);
    const p = Ft(t.kind);
    try {
      await zh({
        resource: t,
        getManifestResource: s,
        updateManifestResourceHelmApps: n,
        abortControllerRef: l
      }), Z.showToast({
        variant: ee.success,
        description: `${p} '${t.name}' restarted successfully`
      }), r?.(), a();
    } catch {
      Z.showToast({
        variant: ee.error,
        description: `Failed to restart ${p} '${t.name}'`
      });
    } finally {
      i(!1);
    }
  }, d = () => {
    o && l.current.abort(), a();
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(jo, { when: o, message: Nn }),
    /* @__PURE__ */ e.jsx(
      zt,
      {
        variant: Ct.custom,
        Icon: /* @__PURE__ */ e.jsx(v_, {}),
        title: `Restart ${t.kind} '${t.name}'?`,
        subtitle: "Selected workload will be restarted. Are you sure?",
        buttonConfig: {
          primaryButtonConfig: {
            text: "Restart",
            onClick: c,
            isLoading: o
          },
          secondaryButtonConfig: {
            text: "Cancel",
            onClick: d,
            disabled: o
          }
        },
        handleClose: d
      }
    )
  ] });
}, w2 = async ({
  clusterId: t,
  gvk: s,
  signal: n
}) => {
  try {
    const { result: a } = await Ki(
      {
        clusterId: t,
        filter: `self.spec.applyTo.exists(a, a.group == ${JSON.stringify(s.Group)} && a.kind == ${JSON.stringify(s.Kind)} && a.version == ${JSON.stringify(s.Version)})`,
        k8sRequest: {
          resourceIdentifier: {
            groupVersionKind: oP
          }
        }
      },
      n
    ), r = a?.data?.[0]?.spec?.schema || "{}";
    return JSON.parse(r);
  } catch {
    return {};
  }
}, D2 = async ({
  clusterId: t,
  gvk: s,
  signal: n
}) => {
  try {
    const { result: a } = await Ki(
      {
        clusterId: t,
        filter: `self.spec.applyTo.exists(a, a.group == ${JSON.stringify(s.Group)} && a.kind == ${JSON.stringify(s.Kind)} && a.version == ${JSON.stringify(s.Version)})`,
        k8sRequest: {
          resourceIdentifier: {
            groupVersionKind: iP
          }
        }
      },
      n
    );
    return a?.data?.[0]?.spec?.lockedPaths ?? null;
  } catch {
    return null;
  }
}, Fw = (t, s, n) => {
  try {
    const a = v0(
      {
        edited: t,
        unedited: s,
        patches: xo(s, t)
      },
      n,
      !0
    );
    return JSON.stringify(cx(s, a, !1, !1).newDocument);
  } catch {
    throw new Error("Unable to apply eligibe changes");
  }
}, M2 = (t, s, n) => {
  const a = Kd({ edited: s, unedited: t, patches: xo(t, s) }, n);
  return !!Object.keys(a ?? {}).length;
}, qu = ({ content: t = "", type: s }) => {
  const [n, a] = v(!t), r = s === "eligible", o = r ? "Eligible" : "Not eligible", i = () => {
    a((l) => !l);
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "br-4 dc__border flexbox-col w-100", children: [
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: `flexbox dc__content-space dc__align-items-center px-12 py-8 dc__gap-8 dc__border-bottom ${r ? "bcg-1" : "bcr-1"}`,
        children: [
          r ? /* @__PURE__ */ e.jsx(NN, { className: "dc__no-shrink icon-dim-16 scg-6" }) : /* @__PURE__ */ e.jsx(TN, { className: "dc__no-shrink icon-dim-16 scr-5" }),
          /* @__PURE__ */ e.jsx("span", { className: `flex-grow-1 fs-13 fw-6 lh-16 ${r ? "cg-6" : "cr-5"}`, children: o }),
          /* @__PURE__ */ e.jsx(
            "button",
            {
              type: "button",
              className: "dc__unset-button-styles flex",
              onClick: i,
              "aria-label": `${n ? "Reveal" : "Hide"} content`,
              "data-testid": "ineligible-changes-modal__toggle-collapse",
              children: /* @__PURE__ */ e.jsx(gr, { className: `dc__transition--transform ${n ? "dc__flip-270" : "dc__flip-90"}` })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ e.jsx(NC, { expand: !n, children: /* @__PURE__ */ e.jsx("pre", { className: "flexbox-col p-8 fs-13 lh-20 dc__align-start m-0 read-only-expression dark dc__no-border mono text__white dc__bottom-left-radius dc__bottom-right-radius", children: t.split(`
`).map((l, c) => (
      // line can be repetitive, so we need to use index as key
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ e.jsx("span", { children: l }, c)
    )) }) })
  ] });
}, k2 = ({
  uneditedManifest: t,
  editedManifest: s,
  handleCallApplyChangesAPI: n,
  handleModalClose: a,
  lockedKeys: r = []
}) => {
  const [o, i] = v(!1), [l, c] = v(!1), { eligibleChanges: d, unEligibleChanges: p } = Q(() => {
    const _ = [
      {
        edited: s,
        unedited: t,
        patches: xo(t, s)
      },
      r
    ], h = Kd(..._), x = fg(..._);
    return {
      unEligibleChanges: Object.keys(h).length ? gt(h) : "",
      eligibleChanges: Object.keys(x).length ? gt(x) : ""
    };
  }, []), m = () => {
    i((_) => !_);
  }, u = async () => {
    try {
      if (!o)
        return;
      const _ = Fw(s, t, r);
      c(!0), await n(_), a();
    } catch (_) {
      V(_);
    }
  }, f = l ? Be : a;
  return /* @__PURE__ */ e.jsx(
    $t,
    {
      width: "800px",
      position: "right",
      parentClassName: "h-100",
      onEscape: f,
      onClose: f,
      children: /* @__PURE__ */ e.jsxs(
        "dialog",
        {
          className: "bg__primary h-100 cn-9 w-100 flexbox-col dc__overflow-hidden p-0",
          onClick: Le,
          children: [
            /* @__PURE__ */ e.jsxs("header", { className: "flexbox dc__content-space dc__align-items-center dc__border-bottom px-20 py-12", children: [
              /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
                /* @__PURE__ */ e.jsx(Zc, { className: "dc__no-shrink icon-dim-24" }),
                /* @__PURE__ */ e.jsx("span", { className: "fs-16 fw-6 lh-24 cn-9", children: "Some changes are not eligible for update" })
              ] }),
              /* @__PURE__ */ e.jsx(
                j,
                {
                  dataTestId: "ineligible-changes-modal__close",
                  disabled: l,
                  onClick: f,
                  size: O.xs,
                  icon: /* @__PURE__ */ e.jsx(As, {}),
                  ariaLabel: "Close drawer",
                  showAriaLabelInTippy: !1,
                  style: B.neutral,
                  variant: w.borderLess
                }
              )
            ] }),
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 flex-grow-1 dc__overflow-auto py-12 px-16", children: [
              /* @__PURE__ */ e.jsx("span", { className: "fs-14 lh-22 cn-9", children: "Some of the keys are locked and prohibited to change by non-super admin users." }),
              /* @__PURE__ */ e.jsx(qu, { content: p, type: "unEligible" }),
              !!d && /* @__PURE__ */ e.jsx(qu, { content: d, type: "eligible" })
            ] }),
            /* @__PURE__ */ e.jsx("footer", { className: "flexbox dc__content-space p-16 dc__align-items-center dc__border-top dc__gap-12", children: d ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              /* @__PURE__ */ e.jsx(
                $e,
                {
                  isChecked: o,
                  onChange: m,
                  value: Fe.CHECKED,
                  name: "Save eligible changes",
                  rootClassName: "m-0",
                  disabled: !d,
                  children: /* @__PURE__ */ e.jsx("span", { className: "fs-14 lh-22 cn-9", children: "Save eligible changes" })
                }
              ),
              /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12", children: [
                /* @__PURE__ */ e.jsx(
                  j,
                  {
                    dataTestId: "ineligible-changes-modal__cancel",
                    size: O.medium,
                    variant: w.secondary,
                    disabled: l,
                    onClick: f,
                    text: "Cancel"
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  j,
                  {
                    dataTestId: "ineligible-changes-modal__save",
                    size: O.medium,
                    disabled: !o,
                    variant: w.primary,
                    isLoading: l,
                    onClick: u,
                    text: "Save changes"
                  }
                )
              ] })
            ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1", children: /* @__PURE__ */ e.jsx(Ot, { description: P_ }) }),
              /* @__PURE__ */ e.jsx(
                j,
                {
                  dataTestId: "ineligible-changes-modal__okay",
                  size: O.medium,
                  variant: w.primary,
                  onClick: f,
                  text: "Okay"
                }
              )
            ] }) })
          ]
        }
      )
    }
  );
}, F2 = ({ mode: t, handleToggle: s, isDisabled: n }) => /* @__PURE__ */ e.jsx(
  Qs,
  {
    value: t,
    onChange: s,
    disabled: n,
    segments: Bm,
    size: O.xs,
    name: "-manifest-gui-yaml-segmented-control"
  }
), Uw = xm(() => import("./index-B-wJlVfZ.js")), Gw = xm(() => import("./index-BKpLsKn2.js")), Bw = () => {
  const { path: t } = Wi(), s = () => /* @__PURE__ */ e.jsxs(Vt, { children: [
    /* @__PURE__ */ e.jsx(ge, { path: `${t}/${Ee.WATCHERS}`, children: /* @__PURE__ */ e.jsx(Gw, {}) }),
    /* @__PURE__ */ e.jsx(ge, { path: `${t}/${Ee.INTERCEPTED_CHANGES}`, children: /* @__PURE__ */ e.jsx(Uw, {}) }),
    /* @__PURE__ */ e.jsx(ms, { to: `${t}/${Ee.WATCHERS}` })
  ] });
  return /* @__PURE__ */ e.jsx("div", { className: "event-watcher-container flexbox-col flex-grow-1 h-100 bg__primary dc__overflow-hidden", children: /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-hidden", children: s() }) });
}, U2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Bw
}, Symbol.toStringTag, { value: "Module" })), $w = ({
  email: t,
  handleToggleEmailSelection: s,
  isSelected: n
}) => {
  const a = () => {
    s(t);
  };
  return /* @__PURE__ */ e.jsx(
    $e,
    {
      isChecked: n,
      onChange: a,
      rootClassName: "icon-dim-20 w-100 dc_max-width__max-content mb-0 br-4",
      dataTestId: `toggle-notify-user-${t}`,
      tabIndex: 0,
      value: Fe.CHECKED,
      children: /* @__PURE__ */ e.jsx(so, { identifier: t })
    }
  );
}, Ml = ({
  groupName: t,
  handleToggleEmailSelection: s,
  handleToggleGroupSelection: n,
  emailList: a,
  searchKey: r,
  selectedEmails: o,
  requiredCount: i,
  approvalType: l
}) => {
  const c = a.length > 0 && a.every((u) => o[u]), d = (u = !1) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__content-space flex-grow-1", children: [
    r ? /* @__PURE__ */ e.jsx(Ie, { content: t, children: /* @__PURE__ */ e.jsx("h4", { className: "m-0 dc__truncate cn-7 fs-12 fw-6 lh-20 dc__uppercase flex-grow-1", children: t }) }) : /* @__PURE__ */ e.jsx(
      $e,
      {
        isChecked: c,
        onChange: n,
        rootClassName: "icon-dim-20 mb-0 w-100 dc_max-width__max-content br-4",
        dataTestId: `toggle-notify-group-${t}`,
        tabIndex: 0,
        value: Fe.CHECKED,
        disabled: u,
        children: /* @__PURE__ */ e.jsx(Ie, { content: t, children: /* @__PURE__ */ e.jsx("span", { className: "m-0 dc__truncate cn-7 fs-12 fw-6 lh-20 dc__uppercase", children: t }) })
      }
    ),
    /* @__PURE__ */ e.jsx(D_, { requiredApprovalCount: i })
  ] });
  if (a.length === 0)
    return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
      d(!0),
      /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-13 fw-4 lh-20", children: La[l].noUsersFound })
    ] });
  const p = r.toLowerCase(), m = vi(a).filter(
    (u) => u.toLowerCase().includes(p)
  );
  return m.length ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
    d(),
    m.map((u) => /* @__PURE__ */ e.jsx(
      $w,
      {
        isSelected: o[u] || !1,
        email: u,
        handleToggleEmailSelection: s
      },
      `${t}-${u}-checkbox`
    ))
  ] }) : null;
}, Vw = ({
  children: t,
  selectedEmails: s,
  setSelectedEmails: n,
  approvalConfigData: a,
  approvalType: r
}) => {
  const { email: o } = yo(), { searchKey: i, handleSearch: l, clearFilters: c } = vs(), { allEmailList: d, anyUsersEmails: p, specificUsersEmails: m } = Q(() => {
    const I = qn(
      a.anyUserApprovedInfo.approverList,
      o
    ), T = qn(
      a.specificUsersApprovedInfo.approverList,
      o
    ), A = qn(
      a.userGroupsApprovedInfo.userGroups.flatMap(({ approverList: S }) => S),
      o
    );
    return {
      allEmailList: vi([
        .../* @__PURE__ */ new Set([...I, ...T, ...A])
      ]),
      anyUsersEmails: I,
      specificUsersEmails: T
    };
  }, [a]), u = Object.keys(s).length, f = u === d.length, _ = (I) => {
    if (!i)
      return I;
    const T = i.toLowerCase();
    return I.filter((A) => A.toLowerCase().includes(T));
  }, h = () => {
    if (f) {
      n({});
      return;
    }
    n((I) => {
      const T = structuredClone(I);
      return d.forEach((A) => {
        T[A] = !0;
      }), T;
    });
  }, x = (I) => {
    n((T) => {
      const A = structuredClone(T);
      return A[I] ? (delete A[I], A) : (A[I] = !0, A);
    });
  }, g = (I) => {
    l(I);
  }, E = (I) => {
    const T = vi(I);
    if (T.every((S) => s[S])) {
      n((S) => {
        const L = structuredClone(S);
        return T.forEach((R) => {
          delete L[R];
        }), L;
      });
      return;
    }
    n((S) => {
      const L = structuredClone(S);
      return T.forEach((R) => {
        L[R] = !0;
      }), L;
    });
  }, C = (I, T) => () => {
    if (I !== "group") {
      E(I === "specific" ? m : p);
      return;
    }
    const A = qn(
      a.userGroupsApprovedInfo.userGroups.find(
        ({ groupIdentifier: S }) => S === T
      ).approverList,
      o
    );
    E(A);
  }, b = () => /* @__PURE__ */ e.jsxs("p", { className: "m-0 fw-4 fs-13 cn-9", children: [
    "Users must have '",
    /* @__PURE__ */ e.jsx("span", { className: "dc__lowercase", children: La[r].title }),
    "' permission."
  ] }), N = () => _(d).length === 0 ? /* @__PURE__ */ e.jsx(
    ps,
    {
      useInfoIcon: !0,
      title: "No users found",
      subTitle: "No users found for the search query",
      description: null,
      reload: c,
      buttonText: "Clear search"
    }
  ) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16", children: [
      m.length > 0 && /* @__PURE__ */ e.jsx(
        Ml,
        {
          groupName: nn.specificUsersHeading,
          handleToggleEmailSelection: x,
          handleToggleGroupSelection: C("specific"),
          emailList: m,
          searchKey: i,
          selectedEmails: s,
          requiredCount: a.specificUsersApprovedInfo.requiredCount,
          approvalType: r
        }
      ),
      a.userGroupsApprovedInfo.userGroups.map(
        ({ groupName: T, groupIdentifier: A, approverList: S, requiredCount: L }) => {
          const R = qn(S, o);
          return /* @__PURE__ */ e.jsx(
            Ml,
            {
              groupName: T,
              handleToggleEmailSelection: x,
              handleToggleGroupSelection: C("group", A),
              emailList: R,
              searchKey: i,
              selectedEmails: s,
              requiredCount: L,
              approvalType: r
            },
            `group-${A}`
          );
        }
      ),
      p.length > 0 && /* @__PURE__ */ e.jsx(
        Ml,
        {
          groupName: nn.anyBelowUsers,
          handleToggleEmailSelection: x,
          handleToggleGroupSelection: C("any"),
          emailList: p,
          searchKey: i,
          selectedEmails: s,
          requiredCount: a.anyUserApprovedInfo.requiredCount,
          approvalType: r
        }
      )
    ] }),
    b()
  ] });
  return /* @__PURE__ */ e.jsxs("div", { className: "h-100 dc__overflow-hidden dc__align-left flexbox-col dc__content-space", children: [
    /* @__PURE__ */ e.jsx("div", { className: "h-100 mxh-250 dc__overflow-auto flexbox-col dc__gap-12 py-12 px-16", children: d.length > 0 ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(
        Wt,
        {
          initialSearchText: i,
          handleEnter: g,
          inputProps: {
            placeholder: "Search users to notify",
            autoFocus: !0
          },
          containerClassName: "w-100"
        }
      ),
      !i && /* @__PURE__ */ e.jsx(
        $e,
        {
          isChecked: f,
          onChange: h,
          rootClassName: "icon-dim-20 w-100 dc_max-width__max-content mb-0 br-4",
          dataTestId: "toggle-notify-all-users",
          tabIndex: 0,
          value: Fe.CHECKED,
          children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Notify all users" })
        }
      ),
      N()
    ] }) : /* @__PURE__ */ e.jsxs("div", { className: "fs-13 fw-4 cn-7 lh-20", children: [
      /* @__PURE__ */ e.jsx("span", { children: nn.noApproverInfoMsg }),
      " ",
      /* @__PURE__ */ e.jsx(wt, { to: Ee.AUTH_USERS, target: "_blank", className: "anchor", children: nn.permissions })
    ] }) }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-12 py-12 px-16 dc__border-top-n1", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 py-6 dc__align-items-center", children: [
        /* @__PURE__ */ e.jsx(Or, { className: "dc__no-shrink icon-dim-16" }),
        /* @__PURE__ */ e.jsxs("span", { className: "cn-9 fs-13 fw-4 lh-20 dc__truncate", children: [
          u,
          " users will be notified"
        ] })
      ] }),
      t
    ] })
  ] });
}, rg = ({
  isDefaultConfigPresent: t,
  isConfigured: s,
  nonConfiguredClassNames: n = ""
}) => /* @__PURE__ */ e.jsxs("div", { className: `flex column p-12 dc__align-start dc__border-dashed br-4 bg__secondary ${n}`, children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flex dc__align-start", children: [
    /* @__PURE__ */ e.jsx(AN, { className: "icon-dim-36 p-8 dc__border bg__primary", style: { borderRadius: "18px" } }),
    /* @__PURE__ */ e.jsx(
      SN,
      {
        className: "icon-dim-36 p-8 dc__border bg__primary",
        style: { borderRadius: "18px", marginLeft: "-12px" }
      }
    ),
    /* @__PURE__ */ e.jsx(
      Oo,
      {
        className: "icon-dim-36 p-8 dc__border bg__primary scn-6",
        style: { borderRadius: "18px", marginLeft: "-12px" }
      }
    )
  ] }),
  /* @__PURE__ */ e.jsxs("div", { className: "mt-8 flex column", children: [
    /* @__PURE__ */ e.jsx("span", { className: "w-100 fs-12 fw-6 lh-18", children: s && !t ? Yo.noDefaultStateTitle : Yo.notConfiguredTitle }),
    /* @__PURE__ */ e.jsx("span", { className: "fs-12 fw-4 lh-18 mt-4", children: s && !t ? Yo.noDefaultStateInfo : Yo.notConfiguredInfo })
  ] }),
  /* @__PURE__ */ e.jsx("div", { className: "dc__link mt-8 dc__align-center", children: /* @__PURE__ */ e.jsx(wt, { to: Ee.NOTIFIER_CONFIG, target: "_blank", children: /* @__PURE__ */ e.jsxs("div", { className: "flex row dc__align-start ml-0", children: [
    /* @__PURE__ */ e.jsx("span", { children: "Take me there" }),
    /* @__PURE__ */ e.jsx("span", { className: "ml-5 mt-3 fcb-5 icon-fill-blue-imp path", children: /* @__PURE__ */ e.jsx(Ms, { className: "scb-5 icon-dim-14" }) })
  ] }) }) })
] }), Yw = (t) => {
  switch (t) {
    case Pt.CANCEL:
      return {
        style: B.negative,
        variant: w.secondary
      };
    case Pt.APPROVE:
      return {
        style: B.positive,
        variant: w.primary
      };
    default:
      return {
        style: B.default,
        variant: w.primary
      };
  }
}, Hw = (t) => {
  const s = w_[t].toLowerCase().split(" ").join("-");
  return t === Pt.SUBMIT ? `${s}-approval` : `submit-${s}`;
}, Xo = ({ approvalRequestType: t, isLoading: s, onClick: n }) => {
  const a = Hw(t), r = (o) => {
    n(o, t);
  };
  return /* @__PURE__ */ e.jsx(
    j,
    {
      ...Yw(t),
      dataTestId: a,
      onClick: r,
      isLoading: s,
      text: w_[t],
      size: O.medium
    }
  );
}, Kw = ({
  configs: t,
  isDefaultConfigPresent: s,
  requestButtonProps: n,
  isTippyVisible: a,
  handleTippyClose: r,
  toggleTippyVisibility: o,
  selectedEmails: i,
  setSelectedEmails: l,
  approvalConfigData: c,
  envName: d,
  approvalRequestType: p,
  approvalType: m
}) => {
  const u = () => /* @__PURE__ */ e.jsx(
    Vw,
    {
      selectedEmails: i,
      setSelectedEmails: l,
      approvalConfigData: c,
      approvalType: m,
      children: /* @__PURE__ */ e.jsx(Xo, { approvalRequestType: p, ...n })
    },
    Number(a)
  ), f = () => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex column p-16 dc__align-start dc__border-bottom-n1", children: [
      /* @__PURE__ */ e.jsx("div", { className: "flex column fs-13 fw-4", children: La[m].usersWithPermission }),
      /* @__PURE__ */ e.jsx(
        rg,
        {
          isDefaultConfigPresent: s,
          isConfigured: t,
          nonConfiguredClassNames: "mt-12"
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "flex right py-12 px-16", children: /* @__PURE__ */ e.jsx(Xo, { approvalRequestType: p, ...n }) })
  ] }), _ = () => {
    switch (p) {
      case Pt.SUBMIT:
        return {
          heading: Os.requestApproval.heading,
          additionalContent: t && s ? u() : f(),
          buttonProps: {
            dataTestId: "request-approval",
            text: Os.requestApproval.label
          }
        };
      case Pt.APPROVE:
        return {
          heading: Os.approveRequest.heading,
          infoText: `${Os.approveRequest.infoText} ${d}?`,
          additionalContent: /* @__PURE__ */ e.jsx("div", { className: "flex right pt-4 pb-16 px-16", children: /* @__PURE__ */ e.jsx(Xo, { approvalRequestType: p, ...n }) }),
          buttonProps: {
            dataTestId: "approve-approval",
            text: Os.approveRequest.label,
            style: B.positive
          }
        };
      case Pt.CANCEL:
        return {
          heading: Os.cancelRequest.heading,
          infoText: Os.cancelRequest.infoText,
          additionalContent: /* @__PURE__ */ e.jsx("div", { className: "flex right pt-4 pb-16 px-16", children: /* @__PURE__ */ e.jsx(Xo, { approvalRequestType: p, ...n }) }),
          buttonProps: {
            dataTestId: "cancel-approval",
            text: Os.cancelRequest.label,
            style: B.negative
          }
        };
      default:
        return {};
    }
  }, { heading: h, additionalContent: x, infoText: g, buttonProps: E } = _();
  return /* @__PURE__ */ e.jsx(
    Dt,
    {
      theme: Mt.white,
      className: "w-350 h-100 dc__align-left",
      placement: "bottom-end",
      iconClass: "fcv-5",
      heading: h,
      infoText: g,
      additionalContent: x,
      showCloseButton: !0,
      onClose: r,
      trigger: "click",
      interactive: !0,
      visible: a,
      children: /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(j, { ...E, onClick: o, variant: w.text }) })
    }
  );
}, og = ({
  material: t,
  envName: s,
  stageType: n,
  appId: a,
  pipelineId: r,
  parentEnvironmentName: o,
  selectedApprovalTab: i,
  getModuleInfo: l,
  ciPipelineId: c,
  appReleaseTagNames: d,
  setAppReleaseTagNames: p,
  tagsEditable: m,
  setTagsEditable: u,
  hideImageTaggingHardDelete: f,
  configs: _,
  isDefaultConfigPresent: h,
  triggerType: x,
  nodeRequestedUserId: g,
  isSuperAdmin: E,
  closeModal: C,
  handleReloadOnApprovalSuccess: b,
  isIsolatedEnvironment: N,
  environmentId: I,
  deploymentApprovalInfo: T
}) => {
  const [A, S] = v({}), [L, R] = v(!1), [y, M] = v(!1), [P, U] = v(/* @__PURE__ */ new Map()), [G, H] = v(/* @__PURE__ */ new Map()), [oe, ae] = v({});
  J(() => {
    l && l(Xm.SECURITY).then((K) => {
      M(K.result?.status?.toLowerCase() === CT);
    }).catch(Be);
  }, []), J(() => {
    const K = /* @__PURE__ */ new Map();
    t.forEach((te) => {
      K.set(te.id, te);
    }), H(K);
  }, [t]);
  const re = (K, te, De) => {
    const We = new Map(G), pe = G.get(K);
    te && (pe.imageReleaseTags = te), De && (pe.imageComment = De), We.set(K, pe), H(We);
  }, k = (K) => {
    const te = new Map(P);
    te.set(K, !te.get(K)), U(te);
  }, D = (K) => {
    S((te) => ({
      ...te,
      [K]: !te[K]
    }));
  }, F = ({
    id: K,
    approvalRequestId: te,
    noConfirmation: De
  }) => (We, pe) => {
    R(!0);
    const Ye = Object.keys(oe), dt = {
      appId: +a,
      actionType: pd[pe.toLowerCase()],
      pipelineId: +r,
      artifactId: +K,
      approvalRequestId: pe === Pt.SUBMIT ? 0 : te,
      approvalNotificationConfig: { emailIds: Ye }
    };
    _d(dt).then(() => {
      Z.showToast({
        variant: ee.success,
        description: pe === Pt.APPROVE && x === Jo.automatic ? yp[`${pe}_AUTO_CD`] : yp[pe]
      }), De || D(K), R(!1), i === Me.APPROVAL ? C(We) : b();
    }).catch((At) => {
      V(At), R(!1);
    });
  }, q = (K) => {
    L || (S((te) => ({
      ...te,
      [K]: !1
    })), ae({}));
  }, be = (K, te) => /* @__PURE__ */ e.jsx("div", { className: "flex dc__gap-12 ml-12", children: /* @__PURE__ */ e.jsx(lt, { className: "default-tt w-200", arrow: !1, placement: "top", content: te, children: /* @__PURE__ */ e.jsx("i", { className: `cr-5 fs-13 fw-4 lh-24 m-0 ${K ? "" : "cursor-not-allowed"}`, children: "Excluded" }) }) }), fe = (K, te) => /* @__PURE__ */ e.jsx(
    Kw,
    {
      approvalRequestType: te,
      configs: _,
      isDefaultConfigPresent: h,
      requestButtonProps: {
        onClick: F({
          id: K.id,
          approvalRequestId: K.userApprovalMetadata?.approvalRequestId
        }),
        isLoading: L
      },
      isTippyVisible: A[K.id],
      handleTippyClose: () => q(K.id),
      toggleTippyVisibility: () => D(K.id),
      selectedEmails: oe,
      setSelectedEmails: ae,
      approvalConfigData: T?.approvalConfigData,
      envName: s,
      approvalType: In.Image
    }
  ), Ge = (K) => {
    const te = g, De = K.userApprovalMetadata?.requestedUserData?.userId;
    return K.vulnerable ? /* @__PURE__ */ e.jsx("span", { className: "material-history__scan-error", children: Os.vulnerability.found }) : K.userApprovalMetadata?.approvalRuntimeState === Em.requested ? De !== te && K.triggeredBy === te ? K.filterState !== as.ALLOWED ? be(!1, za) : /* @__PURE__ */ e.jsx(
      lt,
      {
        className: "default-tt w-200",
        arrow: !1,
        placement: "top",
        content: Os.imageBuilderTippy,
        children: /* @__PURE__ */ e.jsx("span", { className: "cb-5 dc__opacity-0_5 cursor-default", "data-testid": "builder-approve-disabled", children: Os.approveRequest.label })
      }
    ) : K.userApprovalMetadata.hasCurrentUserApproved ? K.filterState !== as.ALLOWED ? be(!0, za) : /* @__PURE__ */ e.jsx("span", { className: "cg-5 cursor-default", "data-testid": "approved-by-you", children: Os.approvedByYou }) : De && te && De === te ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      fe(K, Pt.CANCEL),
      K.filterState !== as.ALLOWED && /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-12 ml-12", children: [
        /* @__PURE__ */ e.jsx("div", { className: "h-20 dc__border-left" }),
        /* @__PURE__ */ e.jsx(
          lt,
          {
            className: "default-tt w-200",
            arrow: !1,
            placement: "top",
            content: za,
            children: /* @__PURE__ */ e.jsx("i", { className: "cr-5 fs-13 fw-4 lh-24 m-0", children: "Excluded" })
          }
        )
      ] })
    ] }) : K.userApprovalMetadata.canCurrentUserApprove && De !== te ? K.filterState !== as.ALLOWED ? be(!1, za) : fe(K, Pt.APPROVE) : K.filterState !== as.ALLOWED ? be(!1, za) : /* @__PURE__ */ e.jsx("span", { className: "cn-5 cursor-default", "data-testid": "awaiting-approval", children: Os.awaiting }) : K.filterState !== as.ALLOWED ? be(!1, za) : fe(K, Pt.SUBMIT);
  }, xe = (K) => /* @__PURE__ */ e.jsx(
    md,
    {
      requestedUserId: g,
      userApprovalMetadata: K.userApprovalMetadata,
      cancelRequest: F({
        id: K.id,
        approvalRequestId: K.userApprovalMetadata?.approvalRequestId,
        noConfirmation: !0
      }),
      isLoading: L,
      approvalType: In.Image
    }
  ), Se = (K) => {
    const { promotionApprovalMetadata: te } = K, De = te?.approvedUsersData?.map((We) => We.userEmail);
    return {
      isLatest: K.latest,
      isRunningOnParentCD: K.runningOnParentCd,
      artifactStatus: K.artifactStatus,
      environmentName: s,
      parentEnvironmentName: o,
      stageType: n,
      showLatestTag: !1,
      isVirtualEnvironment: N,
      targetPlatforms: K.targetPlatforms,
      additionalInfo: te?.promotedFromType ? /* @__PURE__ */ e.jsx(
        uT,
        {
          promotedTo: s,
          promotedFrom: te.promotedFrom,
          promotedFromType: te.promotedFromType,
          promotedBy: te.requestedUserData?.userEmail,
          approvedBy: De,
          promotionPolicyName: te.policy?.name,
          showBackgroundColor: !0
        }
      ) : null
    };
  }, ze = (K) => ({
    imagePath: K.imagePath,
    registryName: K.registryName,
    registryType: K.registryType,
    image: K.image,
    deployedTime: null,
    deployedBy: K.deployedBy,
    isRollbackTrigger: !1,
    excludedImagePathNode: K.filterState === as.ALLOWED ? null : /* @__PURE__ */ e.jsx(TC, { image: K.image }),
    approvalChecksNode: i === Me.PENDING ? xe(K) : null
  }), nt = (K) => ({
    ciPipelineId: c,
    artifactId: +K.id,
    imageComment: G.get(+K.id)?.imageComment,
    imageReleaseTags: G.get(+K.id)?.imageReleaseTags,
    appReleaseTagNames: d,
    setAppReleaseTagNames: p,
    tagsEditable: m,
    toggleCardMode: k,
    setTagsEditable: u,
    hideHardDelete: f,
    updateCurrentAppMaterial: re,
    isSuperAdmin: E,
    forceReInit: !0
  });
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: t.map((K) => {
    const te = Jm(K.materialInfo), De = !P.get(+K.id);
    return /* @__PURE__ */ e.jsx(
      Qm,
      {
        testIdLocator: String(K.index),
        cta: Ge(K),
        sequentialCDCardTitleProps: Se(K),
        artifactInfoProps: ze(K),
        imageTagContainerProps: nt(K),
        children: K.materialInfo.length > 0 && De && te && /* @__PURE__ */ e.jsx(
          Zm,
          {
            environmentId: I,
            isSecurityModuleInstalled: y,
            artifactId: +K.id,
            applicationId: a,
            changesCard: /* @__PURE__ */ e.jsx(Yh, { materialInformationList: K.materialInfo }),
            isScanned: K.scanned,
            isScanEnabled: K.scanEnabled,
            SecurityModalSidebar: Wd
          }
        )
      },
      `material-history-${K.index}`
    );
  }) });
}, G2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: og
}, Symbol.toStringTag, { value: "Module" }));
function ig({
  tabs: t,
  initialTab: s = t?.[0].value,
  onChange: n,
  handleEnableFiltersView: a
}) {
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8", children: [
    /* @__PURE__ */ e.jsx(lt, { content: RT, placement: "top", arrow: !1, className: "default-tt", children: /* @__PURE__ */ e.jsx(
      "button",
      {
        type: "button",
        onClick: a,
        className: "h-24 dc__no-background dc__no-border dc__outline-none-imp flex",
        children: /* @__PURE__ */ e.jsx(IN, { className: "icon-dim-16" })
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      Qs,
      {
        segments: t,
        value: s,
        onChange: n,
        name: "filter-action-bar-segmented-control"
      }
    )
  ] });
}
const B2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ig
}, Symbol.toStringTag, { value: "Module" }));
function Ww({
  title: t,
  actionHandler: s
}) {
  return /* @__PURE__ */ e.jsx(qt, { title: t, handleClearFilters: s });
}
const zu = (t, s) => (t.current.abort(), t.current = new AbortController(), s()), qw = ({ deploymentApprovalInfo: t, approvalType: s }) => {
  const n = bT(t), {
    eligibleApprovers: { specificUsers: a, anyUsers: r, userGroups: o }
  } = t, i = Q(
    () => ({
      currentCount: null,
      requiredCount: null,
      kind: null,
      anyUserApprovedInfo: {
        ...r,
        currentCount: null,
        requiredCount: null
      },
      specificUsersApprovedInfo: {
        ...a,
        currentCount: null,
        requiredCount: null
      },
      userGroupsApprovedInfo: {
        currentCount: null,
        requiredCount: null,
        userGroups: o.map((l) => ({
          ...l,
          currentCount: null,
          requiredCount: null
        }))
      },
      isExceptionUser: null
    }),
    [t]
  );
  return n === 0 ? /* @__PURE__ */ e.jsx("div", { className: "h-100 mxh-210 dc__overflow-auto dc__align-left flexbox-col dc__gap-12 p-12", children: /* @__PURE__ */ e.jsx(ps, { title: "No eligible approvers found", subTitle: "", description: "", useInfoIcon: !0 }) }) : /* @__PURE__ */ e.jsx("div", { className: "h-100 mxh-210 dc__overflow-auto dc__align-left flexbox-col", children: /* @__PURE__ */ e.jsx("div", { className: "p-12", children: /* @__PURE__ */ e.jsx(
    ud,
    {
      approvalConfigData: i,
      showApprovalCountBadge: !1,
      showUserApprovalStatus: !1,
      approvalType: s
    }
  ) }) });
}, zw = ({ deploymentApprovalInfo: t }) => {
  const s = t.approvalConfigData.requiredCount, n = s === 1 ? `${s} approval is required.` : `${s} approvals are required.`;
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4", children: [
    /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: n }),
    /* @__PURE__ */ e.jsx(
      Dt,
      {
        theme: Mt.white,
        className: "w-300 h-100",
        placement: "bottom",
        Icon: Xi,
        iconClass: "fcv-5 dc__no-shrink",
        heading: "Eligible approvers",
        additionalContent: /* @__PURE__ */ e.jsx(
          qw,
          {
            deploymentApprovalInfo: t,
            approvalType: In.Image
          }
        ),
        showCloseButton: !0,
        trigger: "click",
        interactive: !0,
        children: /* @__PURE__ */ e.jsx(
          "button",
          {
            type: "button",
            className: "dc__transparent p-0 cn-9 fs-13 fw-6 lh-20 dc__underline",
            "data-testid": "show-eligible-approver-tippy",
            children: "Eligible approvers"
          }
        )
      }
    )
  ] });
}, Xw = ({
  node: t,
  materialType: s,
  stageType: n,
  closeApprovalModal: a,
  appId: r,
  pipelineId: o,
  getModuleInfo: i,
  ciPipelineId: l,
  history: c
}) => {
  const { searchParams: d } = Gc(), { isSuperAdmin: p } = e_(), m = d.search, u = d[Op] || Me.APPROVAL, [f, _] = v(m), [h, x] = v(m?.length > 0), [g, E] = v([]), [C, b] = v([]), [N, I] = v([]), [T, A] = v([]), [S, L] = v(!1), [R, y] = v(!1), [M, P] = v(Us.ELIGIBLE), [U, G] = v(!1), [H, oe] = v([]), [ae, re] = v(!1), [k, D] = v(!1), [F, q] = v(!1), [be, fe] = v(!1), [Ge, xe] = v({
    configs: !1,
    isDefaultConfigPresent: !1
  }), Se = de(new AbortController()), ze = de(new AbortController()), [nt, K, te, De] = ne(
    () => zu(
      Se,
      () => zr(
        Xr.CD_MATERIALS,
        o,
        Sa.APPROVAL,
        Se.current.signal,
        {
          offset: 0,
          size: 20,
          search: m
        }
      )
    ),
    [o, n, s, m],
    !!o
  ), [
    We,
    pe,
    Ye,
    dt
  ] = ne(
    () => zu(
      ze,
      () => zr(
        Xr.CD_MATERIALS,
        o,
        Sa.APPROVAL,
        ze.current.signal,
        // It is meant to fetch the first 20 materials
        {
          offset: 0,
          size: 20,
          search: m,
          resource: tn.PENDING_APPROVAL
        }
      )
    ),
    [o, n, s, m],
    !!o
  ), At = async () => {
    q(!0);
    try {
      const [{ result: ve }] = await Promise.all([Xc()]);
      xe({
        ...Ge,
        configs: ve.isConfigured,
        isDefaultConfigPresent: ve.is_default_configured
      });
    } finally {
      q(!1);
    }
  };
  J(() => {
    At();
  }, []);
  const Lt = u === Me.APPROVAL ? K?.resourceFilters : pe?.resourceFilters, hs = u === Me.APPROVAL ? K?.hideImageTaggingHardDelete ?? !1 : pe?.hideImageTaggingHardDelete ?? !1, _s = u === Me.APPROVAL ? K?.requestedUserId : pe?.requestedUserId, ys = u === Me.APPROVAL ? K?.deploymentApprovalInfo : pe?.deploymentApprovalInfo;
  J(() => {
    if (!nt && K)
      if (A(K.materials), G(K.tagsEditable), oe(K.appReleaseTagNames), D(K.materials.length >= K.totalCount), K.resourceFilters?.length && !h) {
        P(Us.ELIGIBLE);
        const ve = K.materials.filter(
          (He) => He.filterState === as.ALLOWED
        );
        b(ve);
      } else
        b(K.materials);
  }, [K, nt]), J(() => {
    if (!We && pe)
      if (I(pe.materials), G(pe.tagsEditable), oe(pe.appReleaseTagNames), re(
        pe.materials.length >= pe.totalCount
      ), pe.resourceFilters?.length && !h) {
        P(Us.ELIGIBLE);
        const ve = pe.materials.filter(
          (He) => He.filterState === as.ALLOWED
        );
        E(ve);
      } else
        E(pe.materials);
  }, [pe, We]);
  const $n = () => /* @__PURE__ */ e.jsxs("div", { "data-testid": "approval-for-deployment-heading", className: "trigger-modal__header dc__no-border pb-12 cn-9", children: [
    /* @__PURE__ */ e.jsxs("h1", { className: "modal__title", children: [
      nn.heading,
      " ",
      /* @__PURE__ */ e.jsx("span", { className: "fw-6", children: t.environmentName || "" })
    ] }),
    /* @__PURE__ */ e.jsx(
      "button",
      {
        "data-testid": "close-approval-node-box",
        type: "button",
        className: "dc__transparent",
        onClick: a,
        children: /* @__PURE__ */ e.jsx("img", { alt: "close", src: gb })
      }
    )
  ] }), ml = () => {
    dt();
  }, fa = (ve) => {
    if (ve !== u) {
      fe(!1), ve === Me.APPROVAL ? De() : dt(), x(!1), L(!1), _("");
      const He = {
        ...d,
        [Op]: ve
      };
      delete He.search, c.push({
        search: new URLSearchParams(He).toString()
      });
    }
  }, _l = () => {
    const ve = !!N?.filter(
      (Dr) => Dr.filterState === as.ALLOWED
    ).length, He = [
      {
        id: "all-images-tab",
        label: nn.tab.first,
        tabType: "button",
        props: {
          onClick: () => fa(Me.APPROVAL),
          "data-testid": "all-images-tab",
          "data-selected-tab": 0
        },
        active: u === Me.APPROVAL
      },
      {
        id: "approval-requested-tab",
        label: nn.tab.second,
        tabType: "button",
        props: {
          onClick: () => fa(Me.PENDING),
          "data-testid": "approval-requested-tab",
          "data-selected-tab": 1
        },
        active: u === Me.PENDING,
        showIndicator: ve
      }
    ];
    return /* @__PURE__ */ e.jsx("div", { className: "pl-20 dc__border-bottom", children: /* @__PURE__ */ e.jsx(Ar, { tabs: He, hideTopPadding: !0 }) });
  }, Rg = (ve) => {
    _(ve), x(ve.length > 0);
    const He = {
      ...d,
      search: ve
    };
    ve || delete He.search, c.push({
      search: new URLSearchParams(He).toString()
    });
  }, Pg = () => {
    x(!1), E(N), b(T), _("");
    const ve = {
      ...d
    };
    delete ve.search, c.push({
      search: new URLSearchParams(ve).toString()
    });
  }, wg = () => {
    u === Me.APPROVAL ? De() : dt(), h && L(!1);
  }, Dg = () => {
    L(!0);
  }, Mg = (ve, He) => [
    {
      label: `Eligible images ${ve}/${He}`,
      value: Us.ELIGIBLE
    },
    {
      label: `Latest ${He} images`,
      value: Us.ALL
    }
  ], Jd = () => {
    y(!0);
  }, kg = () => {
    y(!1);
  }, Qd = (ve) => {
    if (Lt?.length) {
      if (u === Me.APPROVAL) {
        const Mo = T.filter(
          (ko) => ko.filterState === as.ALLOWED
        ), Sn = ve === Us.ELIGIBLE ? Mo : T;
        b(Sn);
        return;
      }
      const He = N.filter(
        (Mo) => Mo.filterState === as.ALLOWED
      ), Dr = ve === Us.ELIGIBLE ? He : N;
      E(Dr);
    }
  }, Fg = (ve) => {
    Le(ve), P(Us.ALL), Qd(Us.ALL);
  }, Ug = (ve) => {
    const { value: He } = ve;
    P(He), Qd(He);
  }, Gg = () => u === Me.APPROVAL ? T.filter((ve) => ve.filterState === as.ALLOWED).length : N.filter((ve) => ve.filterState === as.ALLOWED).length, Zd = () => {
    if (!be) {
      fe(!0);
      const ve = u === Me.APPROVAL ? T.length : N.length;
      u === Me.APPROVAL ? (Se.current.abort(), Se.current = new AbortController()) : (ze.current.abort(), ze.current = new AbortController()), zr(
        Xr.CD_MATERIALS,
        o,
        Sa.APPROVAL,
        u === Me.APPROVAL ? Se.current.signal : ze.current.signal,
        {
          offset: ve,
          size: 20,
          search: m,
          resource: u === Me.PENDING ? tn.PENDING_APPROVAL : null
        }
      ).then((He) => {
        if (He) {
          const Dr = [...He.materials], Sn = (u === Me.APPROVAL ? T : N).concat(Dr), ko = Sn.filter(
            (Fo) => Fo.filterState === as.ALLOWED
          ), ep = Lt?.length && !h && M === Us.ELIGIBLE;
          u === Me.APPROVAL ? (A(Sn), b(ep ? ko : Sn), D(Sn.length >= He.totalCount)) : (I(Sn), E(ep ? ko : Sn), re(Sn.length >= He.totalCount));
          const fl = `Fetched ${He.materials.length} images.`;
          if (Lt?.length && !h) {
            const Fo = He.materials.filter(
              (Qg) => Qg.filterState === as.ALLOWED
            ).length, tp = Fo === 0 ? "No new eligible images found." : `${Fo} new eligible images found.`;
            M === Us.ELIGIBLE ? Z.showToast({
              variant: ee.info,
              description: `${fl} ${tp}`
            }) : Z.showToast({
              variant: ee.success,
              description: `${fl} ${tp}`
            });
          } else
            Z.showToast({
              variant: ee.success,
              description: fl
            });
        }
      }).catch((He) => {
        V(He);
      }).finally(() => {
        fe(!1);
      });
    }
  }, Bg = () => {
    const ve = u === Me.PENDING ? N.length : T.length, He = Gg();
    return Lt?.length && !R && !h ? /* @__PURE__ */ e.jsx(
      ig,
      {
        tabs: Mg(He, ve),
        onChange: Ug,
        handleEnableFiltersView: Jd,
        initialTab: M
      }
    ) : u === Me.APPROVAL ? "Request approval for an image to deploy or rollback to" : ys ? /* @__PURE__ */ e.jsx(zw, { deploymentApprovalInfo: ys }) : null;
  }, $g = () => /* @__PURE__ */ e.jsx(
    j,
    {
      dataTestId: "fetch-more-images",
      text: "Fetch more images",
      onClick: Zd,
      disabled: be,
      isLoading: be,
      fullWidth: !0,
      variant: w.secondary
    }
  ), Vg = () => {
    const ve = u === Me.APPROVAL ? T.length : N.length;
    return /* @__PURE__ */ e.jsxs("p", { className: "m-0 flex cn-8 fs-13 fw-4 lh-20", children: [
      /* @__PURE__ */ e.jsx(
        "button",
        {
          className: "dc__no-background p-0 dc__outline-none-imp dc__no-border dc__border-bottom-imp mr-4",
          type: "button",
          onClick: Jd,
          children: "Filter"
        }
      ),
      "is applied on",
      /* @__PURE__ */ e.jsx(
        "button",
        {
          className: "dc__no-background p-0 dc__outline-none-imp dc__no-border dc__border-bottom-imp ml-4 mb-neg-1",
          type: "button",
          onClick: Fg,
          children: ` latest ${ve} images`
        }
      )
    ] });
  }, Yg = (ve) => ve ? /* @__PURE__ */ e.jsx(
    _e,
    {
      image: Ci,
      title: Rs.noEligibleImages.title,
      subTitle: Vg(),
      isButtonAvailable: !(u === Me.APPROVAL && k || u === Me.PENDING && ae),
      renderButton: $g
    }
  ) : /* @__PURE__ */ e.jsx(Ww, { actionHandler: Pg }), Hg = () => {
    const ve = u === Me.APPROVAL ? !k && !!C?.length : !ae && !!g?.length;
    return /* @__PURE__ */ e.jsx("div", { className: "w-100 flexbox-col pb-24", children: ve && /* @__PURE__ */ e.jsx(Vh, { isLoading: be, handleFetchMoreData: Zd }) });
  }, Kg = () => {
    const ve = u === Me.PENDING && g.length === 0 || u === Me.APPROVAL && C.length === 0, He = Lt?.length && ve && !h;
    return /* @__PURE__ */ e.jsxs("div", { className: "trigger-modal__body flex-grow-1 dc__overflow-auto", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex dc__align-center dc__content-space material-list__title pb-16", children: [
        /* @__PURE__ */ e.jsx("div", { className: "flex dc__align-start", children: Bg() }),
        /* @__PURE__ */ e.jsxs("div", { className: "h-32 flex dc__content-end dc__align-center dc__column-gap-8", children: [
          /* @__PURE__ */ e.jsx(
            "div",
            {
              className: `flex dc__align-center dc__position-rel margin-right-0 ${S || h ? "" : "w-28 mt-4"} h-32 cursor-text mr-8`,
              children: S || h ? /* @__PURE__ */ e.jsx(
                Wt,
                {
                  initialSearchText: f,
                  handleEnter: Rg,
                  inputProps: {
                    placeholder: "Search image tag",
                    autoFocus: !0
                  },
                  dataTestId: "Search-by-approver-name"
                }
              ) : /* @__PURE__ */ e.jsx("div", { className: "cursor", onClick: Dg, children: /* @__PURE__ */ e.jsx(ad, { className: "search__icon icon-dim-18 icon-color-n6" }) })
            }
          ),
          /* @__PURE__ */ e.jsx(
            "button",
            {
              className: "pb-0 pl-0 pr-0 flexbox dc__content-end dc__align-center dc__outline-none-imp dc__no-background dc__no-border",
              onClick: wg,
              type: "button",
              "aria-label": "Refetch images",
              children: /* @__PURE__ */ e.jsx(A_, { className: "icon-dim-16 scn-6 cursor" })
            }
          )
        ] })
      ] }),
      ve ? Yg(He) : /* @__PURE__ */ e.jsx(
        og,
        {
          material: u === Me.PENDING ? g : C,
          envName: t.environmentName,
          stageType: n,
          appId: r,
          pipelineId: o,
          parentEnvironmentName: t.parentEnvironmentName,
          selectedApprovalTab: u,
          getModuleInfo: i,
          ciPipelineId: l,
          appReleaseTagNames: H,
          setAppReleaseTagNames: oe,
          tagsEditable: U,
          setTagsEditable: G,
          configs: Ge.configs,
          isDefaultConfigPresent: Ge.isDefaultConfigPresent,
          hideImageTaggingHardDelete: hs,
          triggerType: t?.triggerType,
          nodeRequestedUserId: _s,
          isSuperAdmin: p,
          closeModal: a,
          handleReloadOnApprovalSuccess: ml,
          isIsolatedEnvironment: t.isVirtualEnvironment,
          environmentId: t.environmentId,
          deploymentApprovalInfo: ys
        }
      ),
      Hg()
    ] });
  }, Wg = () => /* @__PURE__ */ e.jsx(
    "button",
    {
      className: "cta ghosted flex h-36",
      "data-selected-tab": "0",
      type: "button",
      onClick: () => fa(Me.APPROVAL),
      children: Rs.noPendingImages.label
    }
  ), qg = () => u === Me.APPROVAL ? /* @__PURE__ */ e.jsx(
    _e,
    {
      image: Ci,
      title: Rs.noImage.title,
      subTitle: Rs.noImage.subTitle,
      isButtonAvailable: !1
    }
  ) : /* @__PURE__ */ e.jsx(
    _e,
    {
      image: S_,
      title: Rs.noPendingImages.title,
      subTitle: Rs.noPendingImages.subTitle,
      isButtonAvailable: !0,
      renderButton: Wg
    }
  ), zg = () => u === Me.APPROVAL ? te : Ye, Xg = () => u === Me.APPROVAL ? De : dt, Jg = () => h || (u === Me.PENDING ? N.length > 0 : T.length > 0) ? Kg() : qg();
  return u === Me.APPROVAL && (nt || te?.code === 0) || u === Me.PENDING && (We || Ye?.code === 0) ? /* @__PURE__ */ e.jsx(cs, { className: "", parentClassName: "dc__overflow-hidden", close: a, children: /* @__PURE__ */ e.jsxs("div", { className: "modal-body--cd-material h-100 contains-diff-view", onClick: Le, children: [
    $n(),
    _l(),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 dc__align-items-center h-100 w-100 pl-20 pr-20", children: [
      /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center dc__content-space pt-20 pb-16 w-100", children: /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading", style: { width: "100px", height: "20px" } }) }),
      /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100", style: { height: "150px" } }),
      /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100", style: { height: "150px" } }),
      /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100", style: { height: "150px" } }),
      /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100", style: { height: "150px" } })
    ] })
  ] }) }) : u === Me.APPROVAL && te || u === Me.PENDING && Ye ? (V(zg()), /* @__PURE__ */ e.jsx(cs, { className: "", parentClassName: "dc__overflow-hidden", close: a, children: /* @__PURE__ */ e.jsxs("div", { className: "modal-body--cd-material h-100 contains-diff-view", onClick: Le, children: [
    $n(),
    _l(),
    /* @__PURE__ */ e.jsx(IC, { reload: Xg() })
  ] }) })) : /* @__PURE__ */ e.jsx(cs, { className: "", parentClassName: "dc__overflow-hidden", close: a, children: R && Lt?.length ? /* @__PURE__ */ e.jsx("div", { className: "modal-body--cd-material h-100 contains-diff-view", onClick: Le, children: /* @__PURE__ */ e.jsx(
    Og,
    {
      isFromBulkCD: !1,
      resourceFilters: Lt,
      handleDisableFiltersView: kg,
      envName: t.environmentName,
      closeModal: a
    }
  ) }) : /* @__PURE__ */ e.jsxs("div", { className: "modal-body--cd-material h-100 contains-diff-view flexbox-col", onClick: Le, children: [
    $n(),
    _l(),
    F ? /* @__PURE__ */ e.jsx(Je, { size: 32, fillColor: "var(--N500)" }) : Jg()
  ] }) });
}, $2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xw
}, Symbol.toStringTag, { value: "Module" })), Jw = ({
  approvalConfigData: t,
  approvalType: s
}) => t.requiredCount ? /* @__PURE__ */ e.jsx("div", { className: "h-100 mxh-210 dc__overflow-auto dc__align-left p-12", children: /* @__PURE__ */ e.jsx(
  ud,
  {
    approvalConfigData: t,
    showUserApprovalStatus: !1,
    approvalType: s
  }
) }) : /* @__PURE__ */ e.jsx("div", { className: "h-100 mxh-210 dc__overflow-auto dc__align-left flexbox-col dc__gap-12 p-12", children: /* @__PURE__ */ e.jsx(
  ps,
  {
    useInfoIcon: !0,
    title: "Approval policy not configured",
    subTitle: "",
    description: ""
  }
) }), Qw = ({
  children: t,
  pipelineId: s,
  onClose: n,
  visible: a,
  appendTo: r,
  approvalType: o
}) => {
  const [i, l, c, d] = ne(
    () => IT(s),
    [s]
  ), p = Q(() => l ? {
    ...l,
    currentCount: null,
    anyUserApprovedInfo: {
      ...l.anyUserApprovedInfo,
      currentCount: null
    },
    specificUsersApprovedInfo: {
      ...l.specificUsersApprovedInfo,
      currentCount: null
    },
    userGroupsApprovedInfo: {
      ...l.userGroupsApprovedInfo,
      currentCount: null,
      userGroups: l.userGroupsApprovedInfo.userGroups.map((u) => ({
        ...u,
        currentCount: null
      }))
    }
  } : null, [l]), m = () => i ? ["90", "70", "50"].map((u) => /* @__PURE__ */ e.jsx("div", { className: `p-8 h-32 w-${u}`, children: /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100 h-100" }) }, u)) : c ? /* @__PURE__ */ e.jsx(ps, { reload: d }) : /* @__PURE__ */ e.jsx(
    Jw,
    {
      approvalConfigData: p,
      approvalType: o
    }
  );
  return /* @__PURE__ */ e.jsx(
    Dt,
    {
      theme: Mt.white,
      className: "default-tt w-300 h-100",
      placement: "bottom",
      Icon: lo,
      iconClass: "icon-stroke-n7 dc__no-shrink",
      heading: `${i || c ? "--" : p.requiredCount} approvals required`,
      additionalContent: m(),
      showCloseButton: !0,
      onClose: n,
      interactive: !0,
      visible: a,
      appendTo: r,
      children: t
    }
  );
}, Zw = ({
  edges: t,
  startNode: s,
  endNode: n,
  onClickEdge: a,
  addCDButtons: r,
  handleCDSelect: o,
  workflowId: i,
  ciPipelineId: l,
  isWebhookCD: c,
  isParallelEdge: d,
  leftTooltipContent: p,
  showApprovalConfigInfoTippy: m = !1,
  isTemplateView: u
}) => {
  const [f, _] = v(!1), h = t.some(
    (S) => ql(S.endNode.approvalConfigData)
  ), x = ql(n.approvalConfigData), g = () => {
    _((S) => !S);
  }, E = () => {
    const S = s.x + s.width, L = s.y + s.height / 2, R = n.x, y = n.y + s.height / 2, M = (S + R) / 2, P = (L + y) / 2;
    return {
      lineStartX: S,
      lineStartY: L,
      lineEndX: R,
      lineEndY: y,
      midPointX: M,
      midPointY: P
    };
  }, C = () => {
    const { lineStartX: S, lineStartY: L, lineEndX: R, lineEndY: y, midPointX: M, midPointY: P } = E();
    return S > R ? `M${S} ${L} H ${S + 15} V ${P} H${R - 15} V ${y} H ${R}` : L !== y ? `M${S} ${L} H ${h ? M - 14 : M} V ${y} H ${R}` : `M${S} ${L} L ${R} ${y}`;
  }, b = (S, L, R) => {
    const M = { x: (R ? 10 : -10) + (S.x + L.x) / 2, y: S.y }, P = { x: R ? M.x - 10 : M.x + 10, y: S.y }, U = { x: R ? P.x - 10 : P.x + 10, y: S.y }, G = { x: U.x, y: S.y - 10 }, H = { x: U.x, y: S.y + 10 };
    return {
      pathD: `M${M.x} ${M.y} L ${G.x} ${G.y} L ${P.x} ${P.y} L ${H.x} ${H.y} Z`,
      pointX: G.x,
      pointY: G.y
    };
  }, N = () => {
    const { lineStartX: S, lineStartY: L, lineEndX: R, lineEndY: y, midPointX: M, midPointY: P } = E();
    return S > R ? b(
      {
        x: M,
        y: P
      },
      {
        x: S,
        y
      },
      S < R
    ) : b(
      {
        x: M,
        y
      },
      {
        x: R,
        y: L
      },
      S < R
    );
  }, I = (S) => {
    vC({
      position: S,
      handleCDSelect: o,
      startNode: s,
      endNode: n,
      workflowId: i,
      ciPipelineId: l,
      isWebhookCD: c,
      isParallelEdge: d
    });
  }, T = N(), A = (S) => m && f && !u ? /* @__PURE__ */ e.jsx(
    Qw,
    {
      pipelineId: +n.id,
      onClose: g,
      visible: m && f,
      appendTo: document.getElementById(AC.WORKFLOW_EDITOR_CONTAINER),
      approvalType: In.Image,
      children: S
    }
  ) : /* @__PURE__ */ e.jsx(Ie, { alwaysShowTippyOnHover: !0, content: "Approvals required for image deployment", children: S });
  return /* @__PURE__ */ e.jsxs("g", { className: "edge-group", children: [
    /* @__PURE__ */ e.jsx(
      "path",
      {
        className: "color-path",
        d: C(),
        fill: "transparent",
        stroke: jp.strokeSolid,
        strokeWidth: 2
      }
    ),
    x && !r?.length ? A(
      /* @__PURE__ */ e.jsxs(
        "g",
        {
          style: {
            transform: `translate(${T.pointX - 13}px, ${T.pointY - 7}px)`
          },
          onClick: m ? g : a,
          "data-testid": "approval-node-button",
          className: "dc__outline-none-imp cursor",
          width: "32",
          height: "32",
          children: [
            /* @__PURE__ */ e.jsx(
              "rect",
              {
                x: "0.5",
                y: "0.5",
                width: "31",
                height: "31",
                rx: "7.5",
                stroke: "var(--N200)",
                fill: "var(--bg-primary)"
              }
            ),
            /* @__PURE__ */ e.jsx(
              "path",
              {
                d: "M10.6667 22.6663H21.3333M11.3333 19.9997H20.6667C21.0349 19.9997 21.3333 19.7012 21.3333 19.333V17.333C21.3333 16.9648 21.0349 16.6663 20.6667 16.6663H11.3333C10.9651 16.6663 10.6667 16.9648 10.6667 17.333V19.333C10.6667 19.7012 10.9651 19.9997 11.3333 19.9997ZM17 16.6663L18.2965 10.9618C18.4861 10.1275 17.8519 9.33301 16.9963 9.33301H15.0037C14.1481 9.33301 13.5139 10.1275 13.7035 10.9618L15 16.6663H17Z",
                stroke: "var(--V500)",
                fill: "var(--bg-primary)",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
              }
            )
          ]
        }
      )
    ) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      !r?.length && /* @__PURE__ */ e.jsx("path", { d: T.pathD, fill: jp.arrowColor }),
      /* @__PURE__ */ e.jsx(
        hp,
        {
          position: gp.LEFT,
          addCDButtons: r,
          endNode: n,
          startNode: s,
          handleAddCD: I,
          tooltipContent: p
        }
      ),
      /* @__PURE__ */ e.jsx(
        hp,
        {
          position: gp.RIGHT,
          addCDButtons: r,
          endNode: n,
          startNode: s,
          handleAddCD: I
        }
      )
    ] })
  ] });
}, V2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Zw
}, Symbol.toStringTag, { value: "Module" }));
function e0({ viewAllImages: t }) {
  return /* @__PURE__ */ e.jsxs("span", { children: [
    "Not finding the image you’re looking for? Images will be available here for deployment after approval. ",
    /* @__PURE__ */ e.jsx("span", { className: "cb-5 cursor", onClick: t, children: "View images for approval" })
  ] });
}
const Y2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: e0
}, Symbol.toStringTag, { value: "Module" })), t0 = ({ matId: t, appId: s, pipelineId: n, userApprovalMetadata: a, reloadMaterials: r }) => {
  const [o, i] = v(!1), l = (d) => {
    d.stopPropagation(), i(!0);
    const p = {
      appId: s,
      actionType: pd.cancel,
      pipelineId: +n,
      artifactId: +d.currentTarget.dataset.id,
      approvalRequestId: +d.currentTarget.dataset.requestId
    };
    _d(p).then(() => {
      Z.showToast({
        variant: ee.success,
        description: "Image approval expired"
      }), r?.();
    }).catch((m) => {
      V(m);
    }).finally(() => {
      i(!1);
    });
  }, c = () => /* @__PURE__ */ e.jsx("div", { className: "flex right px-16 pb-16 pt-4", children: /* @__PURE__ */ e.jsx(
    j,
    {
      text: "Expire approval",
      dataTestId: `expire-approval-${t}`,
      "data-request-id": a?.approvalRequestId,
      "data-id": t,
      onClick: l,
      isLoading: o,
      variant: w.secondary,
      style: B.negative,
      size: O.medium
    }
  ) });
  return /* @__PURE__ */ e.jsx(
    Dt,
    {
      theme: Mt.white,
      className: "w-300 h-100 dc__align-left",
      placement: "bottom-end",
      iconClass: "fcv-5",
      heading: "Expire approval",
      infoText: "Are you sure you want to expire the deployment approval for this image? A new approval request would need to be raised if you want to deploy this image.",
      additionalContent: c(),
      showCloseButton: !0,
      trigger: "click",
      interactive: !0,
      children: /* @__PURE__ */ e.jsx("span", { className: "mr-16 cr-5 cursor", "data-id": t, children: "Expire approval" })
    }
  );
}, H2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: t0
}, Symbol.toStringTag, { value: "Module" })), s0 = (t) => t.filter(
  ({ identifier: s, requiredCount: n }) => !!s && n > 0
), n0 = (t) => {
  const { type: s, requiredCount: n, userGroups: a, specificUsers: r } = t ?? {};
  switch (s) {
    case is.any:
      if (n === 0)
        return {
          isValid: !1,
          message: "Please specify at least one approver"
        };
      break;
    case is.specific:
      if (s0(a).length === 0 && r.identifiers.length === 0)
        return {
          isValid: !1,
          message: "Please specify user group criteria or specific users"
        };
      break;
    case is.notConfigured:
  }
  return {
    isValid: !0
  };
};
var xt = /* @__PURE__ */ ((t) => (t.Draft = "Draft", t.Propose = "Propose", t.Express = "Express", t))(xt || {});
const Xu = {
  "last-version-outdated": "This file version is outdated. Please refresh to get the latest changes.",
  "already-in-terminal-state": "This draft no longer exists. The changes were either approved or discarded, please refresh to check the latest state.",
  "user-committed-to-draft": "You have made changes to this file. Users who have edited a file cannot approve the changes.",
  "template-outdated": "Configuration version being used for this file is outdated. Please discard this draft and create a new one.",
  "draft-exists-already": "A draft already exists against this file. Please refresh to view the latest state.",
  "config-protection-disabled": "Configuration protection for this environment has been disabled. Please refresh and try saving again."
}, Ju = {
  [xt.Draft]: {
    label: "Save as draft",
    description: "Others can make changes to the saved draft"
  },
  [xt.Propose]: {
    label: "Propose changes",
    description: "Submit changes for approval"
  },
  [xt.Express]: {
    label: "Express Create",
    description: "You’re allowed to create file without approval"
  }
}, Qu = {
  [xt.Draft]: null,
  [xt.Propose]: {
    label: "Propose Changes",
    description: "File will be deleted after the request is approved"
  },
  [xt.Express]: {
    label: "Express Delete",
    description: "Delete file without approval"
  }
}, Zu = "Create without approval", wr = (t) => {
  if (t instanceof Ua && Array.isArray(t.errors)) {
    const s = t.errors.find((n) => !!Xu[n.userMessage]);
    if (s) {
      Z.showToast({
        variant: ee.error,
        description: Xu[s.userMessage]
      });
      return;
    }
  }
  V(t);
}, kl = (t) => vi(t).sort(Ce).map((s) => ({
  label: s,
  value: s,
  startIcon: sa(s, "mr-0-imp")
})), lg = (t, s, n = {}) => {
  const a = hi(null), r = {
    [Xn.configMap]: a,
    [Xn.configSecret]: a,
    [Xn.deploymentTemplate]: a,
    [Xn.deploymentTrigger]: a
  };
  return (t ?? []).reduce(
    (o, i) => {
      const l = (i?.approvalConfigurations ?? []).reduce((c, d) => (c[d.kind] = hi(d), c), structuredClone(r));
      return o[i[s]] = {
        isApprovalApplicable: Object.values(l).some((c) => ql(c)) || !1,
        approvalConfigurationMap: l
      }, o;
    },
    n
  );
}, Vd = (t) => we($.CONFIG_DRAFTS, t), K2 = (t) => le(`${$.CONFIG_DRAFTS}/${t}`), a0 = async (t, s, n, a, r) => {
  const o = ye($.CONFIG_DRAFTS, {
    resourceName: a,
    resourceType: n,
    appId: t,
    envId: s
  }), i = await le(o, { abortControllerRef: r });
  return {
    ...i,
    result: {
      ...i?.result,
      userApprovalMetadata: SC(i?.result?.userApprovalMetadata)
    }
  };
}, W2 = (t, s, n) => le(`${$.CONFIG_DRAFTS}/app?appId=${t}&envId=${s}&resourceType=${n}`), ul = (t) => Bt(`${$.CONFIG_DRAFTS_VERSION}`, t), r0 = (t, s) => we(`${$.CONFIG_DRAFTS}/approve?draftId=${t}&draftVersionId=${s}`, {}), o0 = (t) => le(`${$.CONFIG_DRAFTS_COMMENTS}/${t}`), i0 = (t, s) => Js(`${$.CONFIG_DRAFTS_COMMENTS}?draftId=${t}&draftCommentId=${s}`), q2 = async (t) => {
  const s = ye($.CONFIG_PROTECT, {
    appId: t
  }), { result: n } = await le(s), a = hi(null), r = {
    [Xn.configMap]: a,
    [Xn.configSecret]: a,
    [Xn.deploymentTemplate]: a,
    [Xn.deploymentTrigger]: a
  };
  return lg(n, "envId", {
    [yC]: {
      isApprovalApplicable: !1,
      approvalConfigurationMap: structuredClone(r)
    }
  });
}, z2 = async (t) => {
  const s = ye(`${$.CONFIG_PROTECT}/env`, {
    envId: t
  }), { result: n } = await le(s);
  return lg(n, "appId");
}, cg = ({
  draftId: t,
  draftVersionId: s,
  resourceName: n,
  envName: a,
  reload: r,
  children: o,
  onClose: i,
  handleLockConfigError: l
}) => {
  const [c, d] = v(!1), p = () => {
    d(!0), r0(t, s).then(() => {
      r(), Z.showToast({
        variant: ee.success,
        description: "You have successfully approved the changes"
      });
    }).catch((u) => {
      u.code === Ns.UNPROCESSABLE_ENTITY && l?.(), wr(u);
    }).finally(() => {
      d(!1);
    });
  }, m = () => /* @__PURE__ */ e.jsx("div", { className: "flex right pt-4 px-16 pb-16", children: /* @__PURE__ */ e.jsx(
    j,
    {
      text: "Approve",
      onClick: p,
      dataTestId: "approve-changes-confirm-button",
      isLoading: c,
      style: B.positive,
      size: O.medium
    }
  ) });
  return /* @__PURE__ */ e.jsx(
    Dt,
    {
      theme: Mt.white,
      placement: "top-end",
      heading: "Approve changes",
      infoText: `Are you sure you want to approve changes${n ? ` to the ${n}` : ""}${a ? ` for ${a}` : ""}?`,
      showCloseButton: !0,
      additionalContent: m(),
      interactive: !0,
      className: "w-300",
      ...n === "deployment template" ? { showOnCreate: !0, trigger: "manual" } : { trigger: "click" },
      onClose: i,
      children: /* @__PURE__ */ e.jsx("div", { children: o })
    }
  );
}, dg = ({ value: t, onChange: s }) => /* @__PURE__ */ e.jsx(
  ds,
  {
    className: "approval-action-type__radio-group flex left column",
    value: t,
    name: "delete-action-type",
    onChange: s,
    children: Object.keys(xt).filter((n) => n !== xt.Draft).map((n) => /* @__PURE__ */ e.jsx(Ze, { dataTestId: `${n}-type`, value: xt[n], children: /* @__PURE__ */ e.jsxs("span", { className: "flexbox-col dc__no-text-transform", children: [
      /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 lh-20", children: Qu[n].label }),
      /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-12 lh-18", children: Qu[n].description })
    ] }) }, n))
  }
), Yd = ({
  appId: t,
  envId: s,
  resourceType: n,
  resourceName: a,
  setSelectedApprovals: r,
  selectedApprovals: o
}) => {
  const { email: i } = yo(), [l, c] = v(!1), [d, p, m, u] = ne(
    () => Promise.all([a0(t, s, n, a), Xc()])
  ), { approvalConfigData: f, config: _ } = Q(() => p ? {
    config: {
      configs: p[1].result.isConfigured ?? !1,
      isDefaultConfigPresent: p[1].result.is_default_configured ?? !1
    },
    approvalConfigData: p[0].result.userApprovalMetadata.approvalConfigData
  } : {
    config: {
      configs: !1,
      isDefaultConfigPresent: !1
    },
    approvalConfigData: null
  }, [p]), h = !!(_.configs && _.isDefaultConfigPresent), x = Q(() => {
    if (h) {
      const C = kl(
        qn(f.anyUserApprovedInfo.approverList, i)
      ), b = kl(
        qn(
          f.specificUsersApprovedInfo.approverList,
          i
        )
      );
      return [
        ...f.userGroupsApprovedInfo.userGroups.map(
          ({ approverList: I, groupName: T }) => ({
            label: T,
            options: kl(
              qn(I, i)
            )
          })
        ),
        {
          label: nn.specificUsersHeading,
          options: b
        },
        {
          label: nn.anyBelowUsers,
          options: C
        }
      ];
    }
    return [];
  }, [f, h]), g = (C) => {
    r(C);
  }, E = () => {
    c((C) => {
      const b = C ? [] : [
        ...new Set(
          x.flatMap(
            (N) => "options" in N ? N.options : [N]
          )
        )
      ];
      return r(b), !C;
    });
  };
  return !h && !d ? /* @__PURE__ */ e.jsx(
    rg,
    {
      isDefaultConfigPresent: _.isDefaultConfigPresent,
      isConfigured: _.configs
    }
  ) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8 fs-13", children: [
    !l && /* @__PURE__ */ e.jsx(
      Ve,
      {
        label: "Select approvers to notify",
        value: o,
        options: x,
        fullWidth: !0,
        inputId: "select-approval",
        onChange: g,
        isMulti: !0,
        placeholder: "Search people",
        isSearchable: !0,
        isClearable: !0,
        optionListError: m,
        reloadOptionList: u,
        isLoading: d,
        isDisabled: d,
        multiSelectProps: {
          isGroupHeadingSelectable: !0
        }
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-4", children: [
      /* @__PURE__ */ e.jsx(
        $e,
        {
          isChecked: l,
          onChange: E,
          value: Fe.CHECKED,
          rootClassName: "mb-0 w-20 p-2 dc__align-self-start dc__no-shrink",
          id: "notify-all-users"
        }
      ),
      /* @__PURE__ */ e.jsx("label", { htmlFor: "notify-all-users", className: "m-0 fs-13 fw-4 lh-20 cn-9 cursor", children: "Notify all users" })
    ] })
  ] });
}, l0 = ({
  id: t,
  appId: s,
  envId: n,
  resourceType: a,
  resourceName: r,
  latestDraft: o,
  handleClose: i,
  reload: l,
  expressDeleteConfig: c
}) => {
  const [d, p] = v(""), [m, u] = v(!1), [f, _] = v([]), [h, x] = v(xt.Propose), g = h === xt.Express, E = (T) => {
    p(T.target.value);
  }, C = (T) => {
    x(T.target.value);
  }, b = () => {
    const T = [];
    if (f && f?.length > 0)
      for (let A = 0; A < f.length; A++) T.push(f[A].label);
    return T;
  }, N = async () => {
    u(!0);
    try {
      if (o) {
        const T = {
          draftId: o.draftId,
          lastDraftVersionId: o.draftVersionId,
          action: 3,
          data: JSON.stringify({ id: t }),
          userComment: d,
          changeProposed: !0
        };
        await ul(T);
      } else {
        const T = {
          appId: s,
          envId: n,
          resource: a,
          resourceName: r,
          action: 3,
          data: JSON.stringify({ id: t }),
          userComment: d,
          changeProposed: !0,
          protectNotificationConfig: {
            emailIds: b()
          }
        };
        await Vd(T);
      }
      Z.showToast({
        variant: ee.success,
        description: "Draft created successfully! Resource will be deleted after it is approved."
      }), l();
    } catch (T) {
      wr(T);
    } finally {
      u(!0), i();
    }
  }, I = () => {
    let T = "";
    return a === 1 ? T = "ConfigMap" : a === 2 && (T = "Secret"), `Delete ${T} ‘${r}’?`;
  };
  return /* @__PURE__ */ e.jsx(
    zt,
    {
      title: I(),
      subtitle: c?.showExpressDelete ? `The ${a === 1 ? "ConfigMap" : "Secret"} will be permanently removed.` : /* @__PURE__ */ e.jsxs("p", { className: "m-0 fs-13 lh-20", children: [
        "The file will be permanently removed after the deletion request is approved.",
        /* @__PURE__ */ e.jsx("br", {}),
        "Are you sure you want to raise a deletion request?"
      ] }),
      Icon: /* @__PURE__ */ e.jsx(W, { name: "ic-medium-delete", color: null, size: 48 }),
      variant: Ct.custom,
      buttonConfig: {
        secondaryButtonConfig: {
          text: "Cancel",
          onClick: i,
          disabled: m
        },
        primaryButtonConfig: {
          text: g ? "Delete" : "Propose change",
          onClick: g ? c?.onClick : N,
          style: g ? B.negative : B.default,
          isLoading: g ? c?.isLoading : m
        }
      },
      handleClose: i,
      shouldCloseOnEscape: !0,
      ...g ? {
        confirmationConfig: {
          identifier: "express-edit-delete",
          confirmationKeyword: "delete"
        }
      } : {},
      children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
        c?.showExpressDelete && /* @__PURE__ */ e.jsx(dg, { value: h, onChange: C }),
        !g && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(
            Yd,
            {
              appId: s,
              envId: n,
              resourceType: a,
              resourceName: r,
              setSelectedApprovals: _,
              selectedApprovals: f
            }
          ),
          /* @__PURE__ */ e.jsx(
            vn,
            {
              label: "Comment",
              placeholder: "Leave a comment",
              "data-testid": "save-draft-comment-textbox",
              value: d,
              name: "comment",
              onChange: E
            }
          )
        ] })
      ] })
    }
  );
}, X2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: l0
}, Symbol.toStringTag, { value: "Module" })), c0 = ({
  appId: t,
  envId: s,
  resourceType: n,
  resourceName: a,
  prepareDataToSave: r,
  handleClose: o,
  latestDraft: i,
  reload: l,
  expressDeleteConfig: c
}) => {
  const [d, p] = v(""), [m, u] = v(!1), [f, _] = v([]), [h, x] = v(xt.Propose), g = h === xt.Express, E = (I) => {
    p(I.target.value);
  }, C = () => (f ?? []).map((I) => I.label), b = (I) => {
    x(I.target.value);
  }, N = async () => {
    u(!0);
    try {
      if (i) {
        const I = {
          draftId: i.draftId,
          lastDraftVersionId: i.draftVersionId,
          action: 3,
          data: JSON.stringify(r()),
          userComment: d,
          changeProposed: !0
        };
        await ul(I);
      } else {
        const I = {
          appId: t,
          envId: s,
          resource: n,
          resourceName: a,
          action: 3,
          data: JSON.stringify(r()),
          userComment: d,
          changeProposed: !0,
          protectNotificationConfig: {
            emailIds: C()
          }
        };
        await Vd(I);
      }
      Z.showToast({
        variant: ee.success,
        description: "Override will be deleted after it is approved."
      }), l();
    } catch (I) {
      wr(I);
    } finally {
      u(!1), o();
    }
  };
  return /* @__PURE__ */ e.jsx(
    zt,
    {
      title: "Delete all overrides from this file",
      subtitle: c?.showExpressDelete ? "This action will delete the override for this file, and the inherited configurations from the base will be used as-is." : /* @__PURE__ */ e.jsxs("p", { className: "m-0 fs-13 lh-20", children: [
        "This action will result in the removal of all overrides, and the original base configurations for this file will be reinstated.",
        /* @__PURE__ */ e.jsx("br", {}),
        "Changes will be published after they’re approved."
      ] }),
      variant: Ct.warning,
      buttonConfig: {
        secondaryButtonConfig: {
          text: "Cancel",
          onClick: o,
          disabled: m
        },
        primaryButtonConfig: {
          text: g ? "Delete override" : "Propose change",
          onClick: g ? c?.onClick : N,
          isLoading: g ? c?.isLoading : m
        }
      },
      handleClose: o,
      shouldCloseOnEscape: !0,
      ...g ? {
        confirmationConfig: {
          identifier: "express-edit-delete-override",
          confirmationKeyword: "delete override"
        }
      } : {},
      children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
        c?.showExpressDelete && /* @__PURE__ */ e.jsx(dg, { value: h, onChange: b }),
        !g && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(
            Yd,
            {
              appId: t,
              envId: s,
              resourceType: n,
              resourceName: a,
              setSelectedApprovals: _,
              selectedApprovals: f
            }
          ),
          /* @__PURE__ */ e.jsx(
            vn,
            {
              label: "Comment",
              placeholder: "Leave a comment",
              value: d,
              name: "comment",
              onChange: E
            }
          )
        ] })
      ] })
    }
  );
}, J2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: c0
}, Symbol.toStringTag, { value: "Module" })), d0 = ({
  draftId: t,
  draftVersionId: s,
  toggleDraftComments: n,
  handleUpdateAreCommentsPresent: a
}) => {
  const [r, o] = v(!0), [i, l] = v(!1), [c, d] = v([]), [p, m] = v(""), [u, f] = v(-1), _ = () => {
    o(!0), o0(t).then((A) => {
      A.result && d(
        A.result.versionComments?.flatMap((S) => S.userComments).sort((S, L) => L.commentId - S.commentId) ?? []
      ), a?.(A.result?.versionComments?.length > 0);
    }).catch((A) => {
      V(A);
    }).finally(() => {
      o(!1);
    });
  };
  J(() => {
    _();
  }, [t, s]);
  const h = (A) => {
    m(A.target.value);
  }, x = () => {
    l(!0), ul({
      draftId: t,
      lastDraftVersionId: s,
      action: 1,
      data: "",
      userComment: p
    }).then(() => {
      m(""), _(), Z.showToast({
        variant: ee.success,
        description: "Comment added successfully"
      });
    }).catch((S) => {
      V(S);
    }).finally(() => {
      l(!1);
    });
  }, g = (A) => {
    l(!0), i0(t, Number(A.currentTarget.dataset.commentId)).then(() => {
      f(-1), _(), Z.showToast({
        variant: ee.success,
        description: "Comment deleted successfully"
      });
    }).catch((S) => {
      V(S);
    }).finally(() => {
      l(!1);
    });
  }, E = (A) => /* @__PURE__ */ e.jsx("div", { className: "flex right pt-4 pb-16 px-16", children: /* @__PURE__ */ e.jsx(
    j,
    {
      text: "Delete comment",
      isLoading: i,
      dataTestId: "delete-comment-confirm-button",
      "data-comment-id": A,
      onClick: g,
      size: O.medium,
      variant: w.secondary,
      style: B.negative
    }
  ) }), C = (A) => {
    f(u === -1 ? A : -1);
  }, b = () => (A, S) => {
    Le(S), A.id === "delete" && C(A.dataAttributesId);
  }, N = (A) => /* @__PURE__ */ e.jsx(
    ki,
    {
      id: "draft-comments-action-menu",
      onClick: b,
      options: [
        {
          items: [
            {
              id: "delete",
              label: "Delete comment",
              startIcon: { name: "ic-delete" },
              type: "negative",
              dataAttributesId: A
            }
          ]
        }
      ],
      buttonProps: {
        dataTestId: "draft-comments-action-menu-button",
        icon: /* @__PURE__ */ e.jsx(W, { name: "ic-more-vertical", color: null }),
        variant: w.borderLess,
        ariaLabel: "Open action menu",
        style: B.neutral,
        size: O.xs
      }
    }
  ), I = () => /* @__PURE__ */ e.jsx("div", { className: "p-16 dc__overflow-auto flex-grow-1", children: c.map((A, S) => /* @__PURE__ */ e.jsx(
    Dt,
    {
      theme: Mt.white,
      className: "w-300 h-100 dc__align-left mr-4 mt--56",
      placement: "top-end",
      iconClass: "fcv-5",
      heading: "Delete comment",
      infoText: "Are you sure you want to delete this comment?",
      additionalContent: E(A.commentId),
      showCloseButton: !0,
      onClose: () => C(A.commentId),
      trigger: "manual",
      interactive: !0,
      visible: u === A.commentId,
      children: /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: "flex left top dc__gap-8 w-100 mb-16",
          "data-testid": `comment-${S}`,
          children: [
            /* @__PURE__ */ e.jsx("div", { className: "icon-dim-20", children: sa(A.userEmail) }),
            /* @__PURE__ */ e.jsxs("div", { className: "w-100", children: [
              /* @__PURE__ */ e.jsxs("div", { className: "flex top dc__content-space mb-8", children: [
                /* @__PURE__ */ e.jsxs("div", { className: "flex column left", children: [
                  /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20 dc__ellipsis-right", children: A.userEmail }),
                  /* @__PURE__ */ e.jsx("span", { className: "fs-12 fw-4 lh-20 ", children: it(A.commentedAt).format("HH:mm A, DD MMMM YYYY") })
                ] }),
                N(A.commentId)
              ] }),
              /* @__PURE__ */ e.jsx("p", { className: "fs-13 fw-4 lh-20 cn-9 dc__word-break m-0", children: A.comment })
            ] })
          ]
        },
        `comment-${S}`
      )
    }
  )) }), T = () => /* @__PURE__ */ e.jsx(
    _e,
    {
      classname: "dc__skip-align-reload-center flex-grow-1",
      image: vN,
      title: "No comments",
      isButtonAvailable: !1
    }
  );
  return /* @__PURE__ */ e.jsxs("div", { className: "deployment-config__comments-view w-300 dc__no-shrink draft-comments-container bg__primary dc__border-left dc__overflow-hidden flexbox-col", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space w-100 pt-12 pb-12 pl-16 pr-16 m-0 dc__border-bottom", children: [
      /* @__PURE__ */ e.jsxs("h3", { className: "fs-13 fw-6 lh-20 m-0", children: [
        r ? "" : c.length,
        " Comments"
      ] }),
      /* @__PURE__ */ e.jsx(
        vt,
        {
          className: "icon-dim-24 cursor",
          "data-testid": "save-changes-modal-close",
          onClick: n
        }
      )
    ] }),
    r ? /* @__PURE__ */ e.jsx(Je, { size: 36 }) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
      c.length > 0 ? I() : T(),
      /* @__PURE__ */ e.jsxs("div", { className: "flex top dc__content-space dc__gap-8 pt-14 pb-14 pl-12 pr-12 dc__border-top mxh-210 dc__overflow-auto dc__no-shrink", children: [
        /* @__PURE__ */ e.jsx(
          vn,
          {
            placeholder: "Add a comment",
            value: p,
            onChange: h,
            name: "add-new-comment-textarea",
            fullWidth: !0
          }
        ),
        /* @__PURE__ */ e.jsx("div", { className: "dc__align-self-end", children: /* @__PURE__ */ e.jsx(
          j,
          {
            isLoading: i,
            disabled: i || !p,
            onClick: x,
            icon: /* @__PURE__ */ e.jsx(qs, { className: "icon-dim-16 dc__no-svg-fill" }),
            ariaLabel: "Add comment",
            showAriaLabelInTippy: !1,
            dataTestId: "add-new-comment"
          }
        ) })
      ] })
    ] })
  ] });
}, Q2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: d0
}, Symbol.toStringTag, { value: "Module" })), p0 = ({
  value: t,
  onChange: s,
  showExpressCreate: n = !1
}) => /* @__PURE__ */ e.jsx(
  ds,
  {
    className: "approval-action-type__radio-group flex left column",
    value: t,
    name: "save-action-type",
    onChange: s,
    children: Object.keys(xt).filter((a) => n || a !== xt.Express).map((a) => /* @__PURE__ */ e.jsx(Ze, { dataTestId: `${a}-type`, value: xt[a], children: /* @__PURE__ */ e.jsxs("span", { className: "flexbox-col dc__no-text-transform", children: [
      /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 lh-20", children: Ju[a].label }),
      /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-12 lh-18", children: Ju[a].description })
    ] }) }, a))
  }
), u0 = ({
  envName: t,
  resourceName: s,
  resourceType: n,
  handleClose: a,
  isCreate: r
}) => {
  const o = () => r ? `${t || "Base Configurations"} / Create ${n === 1 ? "ConfigMap" : "Secret"}` : `${t || "Base Configurations"} / ${n === 3 ? "Deployment Template" : s}`;
  return /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space dc__gap-8 px-16 pt-12 pb-11 border__primary--bottom", children: [
    /* @__PURE__ */ e.jsx(Ie, { content: o(), children: /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-16 lh-24 fw-6 dc__ellipsis-right", children: o() }) }),
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "close-save-changes-modal",
        ariaLabel: "close-save-changes-modal",
        icon: /* @__PURE__ */ e.jsx(W, { name: "ic-close-large", color: "N600" }),
        showAriaLabelInTippy: !1,
        variant: w.borderLess,
        style: B.negativeGrey,
        size: O.xs,
        onClick: a
      }
    )
  ] });
}, m0 = (t) => /* @__PURE__ */ e.jsx(cs, { children: t }), _0 = ({
  appId: t,
  envId: s,
  envName: n,
  resourceType: a,
  resourceName: r,
  prepareDataToSave: o,
  latestDraft: i,
  handleClose: l,
  reload: c,
  showAsModal: d,
  saveEligibleChangesCb: p,
  handleProcessSaveResponse: m,
  isCreate: u,
  showExpressCreate: f,
  expressCreateConfig: _ = {}
}) => {
  const [h, x] = v(
    i?.draftState === ro.AwaitApproval ? xt.Propose : xt.Draft
  ), [g, E] = v(""), [C, b] = v(!1), [N, I] = v([]), [T, A] = v(""), S = h === xt.Draft, L = h === xt.Express, { registerShortcut: R, unregisterShortcut: y } = LC();
  J(() => (R({ keys: ["Enter"], callback: _?.onClick || Be }), () => {
    y(["Enter"]);
  }), [_]);
  const M = (ae) => {
    E(ae.target.value);
  }, P = (ae) => {
    x(ae.target.value);
  }, U = (ae) => {
    A(ae.target.value);
  }, G = () => {
    let ae = "";
    return a === 1 ? ae = "ConfigMap" : a === 2 && (ae = "Secret"), `Create ${ae}`;
  }, H = () => N.map((ae) => ae.label), oe = async () => {
    b(!0);
    try {
      const ae = o(), k = {
        action: ae.id > 0 ? 2 : 1,
        data: JSON.stringify({ ...ae, saveEligibleChanges: p }),
        userComment: g,
        changeProposed: h === xt.Propose,
        protectNotificationConfig: {
          emailIds: h === xt.Propose ? H() : []
        }
      };
      let D = null;
      if (i) {
        const F = {
          draftId: i.draftId,
          lastDraftVersionId: i.draftVersionId,
          ...k
        };
        D = await ul(F);
      } else {
        const F = {
          appId: t,
          envId: s,
          resource: a,
          resourceName: r,
          ...k
        };
        D = await Vd(F);
      }
      if (m?.(D), D?.result?.isLockConfigError) {
        b(!1);
        return;
      }
      Z.showToast({
        variant: ee.success,
        description: S ? "Draft updated successfully" : "Draft updated successfully! Changes will be published after it is approved."
      }), c(), b(!1);
    } catch (ae) {
      wr(ae), b(!1);
    }
  };
  return /* @__PURE__ */ e.jsx(An, { condition: d, wrap: m0, children: /* @__PURE__ */ e.jsx(
    "div",
    {
      className: `w-400 bg__primary border__primary br-8 dc__m-auto mt-40 ${d ? "" : "position-bottom-right"}`,
      children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
        /* @__PURE__ */ e.jsx(
          u0,
          {
            envName: n,
            resourceName: r,
            resourceType: a,
            handleClose: l,
            isCreate: u
          }
        ),
        /* @__PURE__ */ e.jsxs("div", { className: "mxh-500 dc__overflow-auto p-16 flex-grow-1 flexbox-col dc__gap-16", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox py-8 px-12 dc__gap-8 bcv-1 ev-2 bw-1 br-4", children: [
            /* @__PURE__ */ e.jsx(W, { name: "ic-stamp", color: "V500", size: 20 }),
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col fs-13 lh-20 cn-9", children: [
              /* @__PURE__ */ e.jsx("p", { className: "m-0 fw-6", children: "Approval policy" }),
              /* @__PURE__ */ e.jsxs("p", { className: "m-0 fw-4", children: [
                "Configuration change requires approval based on",
                /* @__PURE__ */ e.jsx(wt, { to: Y.APPROVAL_POLICY_APPLIED_POLICY_LIST, target: "_blank", children: " applied approval policy" })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
            i?.draftState !== ro.AwaitApproval && /* @__PURE__ */ e.jsx(
              p0,
              {
                value: h,
                onChange: P,
                showExpressCreate: f
              }
            ),
            !L && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              h === xt.Propose && /* @__PURE__ */ e.jsx(
                Yd,
                {
                  appId: t,
                  envId: s,
                  resourceType: a,
                  resourceName: r,
                  setSelectedApprovals: I,
                  selectedApprovals: N
                }
              ),
              /* @__PURE__ */ e.jsx(
                vn,
                {
                  label: "Comment",
                  placeholder: "Leave a comment",
                  value: g,
                  name: "comment",
                  onChange: M
                }
              )
            ] })
          ] }),
          L && /* @__PURE__ */ e.jsx(
            yt,
            {
              name: "express-create-confirmation-input",
              value: T,
              onChange: U,
              label: jC(Zu),
              fullWidth: !0,
              placeholder: "Type to confirm",
              required: !0,
              autoFocus: !0
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex right p-16 dc__gap-12", children: [
          /* @__PURE__ */ e.jsx(
            j,
            {
              text: "Cancel",
              dataTestId: "cancel-changes",
              onClick: l,
              disabled: C,
              variant: w.secondary,
              style: B.neutral,
              size: O.medium
            }
          ),
          L && _ ? /* @__PURE__ */ e.jsx(
            j,
            {
              text: G(),
              dataTestId: "express-create",
              onClick: _.onClick,
              isLoading: _.isLoading,
              disabled: T.trim() !== Zu,
              style: B.warning,
              size: O.medium
            }
          ) : /* @__PURE__ */ e.jsx(
            j,
            {
              text: S ? "Save as draft" : "Propose changes",
              dataTestId: "save-changes",
              onClick: oe,
              isLoading: C,
              disabled: C,
              size: O.medium
            }
          )
        ] })
      ] })
    }
  ) });
}, Z2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _0
}, Symbol.toStringTag, { value: "Module" })), pg = () => /* @__PURE__ */ e.jsxs("p", { className: "flex left dc__gap-8 px-12 py-8 m-0", children: [
  /* @__PURE__ */ e.jsx(qs, { className: "dc__no-shrink icon-dim-16 scg-5" }),
  /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-20 fw-6 cg-5", children: "Approved by you" })
] }), eG = ({
  componentName: t,
  configMapSecretData: s,
  draftData: n,
  parentName: a,
  updateCMSecret: r
}) => {
  if (s && OC(s.externalType) || n.draftState !== ro.AwaitApproval)
    return null;
  if (n.userApprovalMetadata.hasCurrentUserApproved)
    return /* @__PURE__ */ e.jsx(pg, {});
  const i = n.userApprovalMetadata.canCurrentUserApprove;
  return /* @__PURE__ */ e.jsx("div", { className: "py-12 px-16 dc__border-top-n1 flex right dc__gap-12 configmap-secret-container__approval-tippy", children: n.canApprove && i ? /* @__PURE__ */ e.jsx(
    cg,
    {
      draftId: n.draftId,
      draftVersionId: n.draftVersionId,
      resourceName: t,
      reload: r,
      envName: a,
      children: /* @__PURE__ */ e.jsx(
        j,
        {
          dataTestId: "cm-secret-approve-btn",
          text: "Approve Changes",
          size: O.medium,
          style: B.positive
        }
      )
    }
  ) : /* @__PURE__ */ e.jsx(
    j,
    {
      dataTestId: "cm-secret-approve-btn",
      text: "Approve Changes",
      size: O.medium,
      style: B.positive,
      disabled: !0,
      showTooltip: !0,
      tooltipProps: {
        placement: "top-end",
        content: i ? "You have made changes to this file. Users who have edited cannot approve the changes." : "You do not have permission to approve configuration changes for this application - environment combination."
      }
    }
  ) });
}, tG = "Cannot change data type for this file as it is overridden with Patch strategy in some environment(s)", sG = "Cannot delete this file as it is overridden with Patch strategy in some environment(s)", f0 = ({
  draftChartVersion: t,
  currentEditorChartVersion: s
}) => {
  const n = t ? ` (v${t})` : "", a = s ? ` (v${s})` : "";
  return [
    {
      label: "Values generated from",
      options: [
        {
          label: `Approval Pending ${n}`,
          value: zl.APPROVAL_PENDING
        },
        {
          label: `Values from draft ${a}`,
          value: zl.VALUES_FROM_DRAFT
        }
      ]
    }
  ];
}, nG = ({
  selectedOptionValue: t = zl.APPROVAL_PENDING,
  handleCompareFromOptionSelection: s,
  draftChartVersion: n,
  currentEditorChartVersion: a,
  isDeleteOverrideView: r
}) => {
  const o = f0({
    draftChartVersion: n,
    currentEditorChartVersion: a
  }), i = o[0].options.find((l) => l.value === t);
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__align-items-center", children: [
    /* @__PURE__ */ e.jsx(td, { className: "icon-dim-16 scn-9 dc__no-shrink" }),
    r ? /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-12 fw-6 lh-20", children: "Approval pending" }) : /* @__PURE__ */ e.jsx(
      Ve,
      {
        inputId: "compare-template-values-select",
        options: o,
        value: i,
        variant: cn.COMPACT,
        onChange: s,
        isSearchable: !1,
        size: O.small
      }
    )
  ] });
}, aG = ({
  isAppMetricsEnabled: t,
  showApplicationMetrics: s,
  isLoading: n,
  selectedChart: a,
  isDisabled: r,
  toggleAppMetrics: o,
  parsingError: i,
  restoreLastSavedYAML: l,
  handleExpressEditPublish: c,
  handleExpressEditCancel: d
}) => /* @__PURE__ */ e.jsxs(
  "div",
  {
    className: `flexbox ${s ? "dc__content-space" : "dc__content-end"} dc__align-items-center p-12 bg__primary dc__border-top`,
    children: [
      /* @__PURE__ */ e.jsx(
        Xl,
        {
          showApplicationMetrics: s,
          isLoading: n,
          selectedChart: a,
          isDisabled: r,
          toggleAppMetrics: o,
          isAppMetricsEnabled: t,
          parsingError: i,
          restoreLastSavedYAML: l
        }
      ),
      /* @__PURE__ */ e.jsxs("div", { className: "flex right dc__gap-12", children: [
        /* @__PURE__ */ e.jsx(
          j,
          {
            dataTestId: "base-deployment-template-express-edit-cancel-button",
            disabled: r,
            onClick: d,
            text: "Cancel",
            variant: w.secondary,
            style: B.neutral,
            size: O.medium
          }
        ),
        /* @__PURE__ */ e.jsx(t_, { parsingError: i, restoreLastSavedYAML: l, children: /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
          j,
          {
            dataTestId: "base-deployment-template-express-edit-publish-button",
            disabled: r,
            onClick: c,
            text: "Publish Changes",
            size: O.medium,
            style: B.warning
          }
        ) }) })
      ] })
    ]
  }
);
var _i = /* @__PURE__ */ ((t) => (t.OBJECT = "OBJECT", t.LEAF = "LEAF", t))(_i || {});
const fi = (t, s) => {
  if (t >= s.length)
    return {
      "ui:widget": "hidden"
    };
  if (s[t] === "$")
    return fi(t + 1, s);
  const n = s[t];
  return !Number.isNaN(Number(n)) || n === "*" ? { items: fi(t + 1, s) } : { [n]: fi(t + 1, s) };
}, em = (t) => {
  const s = t.reduce(
    (n, a) => (a.selectionStatus ? n[a.selectionStatus] += 1 : n[a.isChecked ? "all-selected" : "none-selected"] += 1, n),
    { "none-selected": 0, "all-selected": 0, "some-selected": 0 }
  );
  return s["all-selected"] === t.length ? "all-selected" : s["none-selected"] === t.length ? "none-selected" : "some-selected";
}, h0 = (t, s) => {
  try {
    return rn({
      json: t,
      path: on(s),
      resultType: "value",
      wrap: !1
    }) !== void 0;
  } catch {
    return null;
  }
}, g0 = (t) => {
  const s = t.lastIndexOf("*"), n = t.slice(0, s + 1), a = t.slice(s + 1);
  return { firstPart: n, lastPart: a };
}, x0 = (t, s) => {
  try {
    let n = [];
    if (s.op === "add") {
      const { firstPart: a, lastPart: r } = g0(s.path);
      n = rn({
        json: t,
        path: on(a),
        resultType: "pointer"
      }).map((o) => `${o}${r}`);
    } else
      n = rn({
        json: t,
        path: on(s.path),
        resultType: "pointer"
      });
    if (!Array.isArray(n))
      return;
    n.forEach((a) => Aa(t, { ...s, path: a }, !0, !0));
  } catch (n) {
    V(n);
  }
}, E0 = (t) => t.replace(/\*/g, "0"), C0 = (t, s) => {
  (Object.hasOwn(t, "isChecked") && !t.isChecked || t.selectionStatus === "none-selected") && s.push(t.path);
};
class rG {
  /**
   * Can throw error while parsing schema & json
   * @param schema (string) the json schema
   * @param json (string) the corresponding json
   */
  constructor(s, n) {
    gs(this, "schema", null);
    gs(this, "json", null);
    gs(this, "schemaPathToUpdatePathMap", {});
    gs(this, "totalCheckedCount", 0);
    gs(this, "root");
    gs(this, "_constructTree", (s, n, a) => {
      if (!a)
        throw new xp("Problem constructing the tree", "In traversal found an undefined json object");
      if (a.type === "object" && a.properties && typeof a.properties == "object") {
        const l = Object.entries(a.properties).sort(([, d]) => d && typeof d == "object" && d.type === "boolean" ? -1 : 0).map(
          ([d, p]) => this._constructTree(d, `${n}/${d}`, p)
        ), c = em(l);
        return {
          key: s,
          selectionStatus: c,
          type: _i.OBJECT,
          fieldType: a.type,
          title: a.title ?? s,
          path: n,
          children: l
        };
      }
      const o = this.schemaPathToUpdatePathMap[n] && this.schemaPathToUpdatePathMap[n] !== n ? this.schemaPathToUpdatePathMap[n] : null, i = h0(this.json, o ?? n);
      return i && (this.totalCheckedCount += 1), {
        key: s,
        type: _i.LEAF,
        fieldType: a.type,
        isChecked: i,
        title: a.title,
        path: n,
        ...o ? { updatePath: o } : {}
      };
    });
    gs(this, "constructTree", () => {
      if (this.schema.type !== "object" || !this.schema.properties || typeof this.schema.properties != "object" || !Object.keys(this.schema.properties).length)
        throw new xp(
          "Invalid GUI schema found",
          "The saved GUI schema is probably invalid. Please conform your schema to json schema draft-07"
        );
      return this._constructTree("", "", this.schema);
    });
    gs(this, "inOrder", (s) => {
      const { node: n, wf: a } = s;
      s.node && (a(n, s.data), n.children?.forEach((r) => this.inOrder({ ...s, node: r })));
    });
    gs(this, "postOrder", (s) => {
      const { node: n, wf: a } = s;
      s.node && (n.children?.forEach((r) => this.postOrder({ ...s, node: r })), a(n, s.data));
    });
    gs(this, "updateNodeWherePathMatches", (s, n) => {
      if (s.path === n.path) {
        if (s.type !== _i.LEAF)
          throw new Error("None leaf is being updated!");
        s.isChecked = !s.isChecked;
        const a = s.updatePath ?? s.path;
        s.isChecked ? (this.totalCheckedCount += 1, n.json = Ei([
          n.json,
          Jc(E0(a), PC(s.fieldType))
        ])) : (this.totalCheckedCount -= 1, x0(n.json, { op: "remove", path: a }));
      }
      s.children && (s.selectionStatus = em(s.children));
    });
    gs(this, "getUncheckedNodes", () => {
      const s = [];
      return this.inOrder({ node: this.root, wf: C0, data: s }), s;
    });
    gs(this, "updateNodeForPath", ({ path: s, json: n }) => {
      const a = structuredClone(n), r = { path: s, json: a };
      return this.postOrder({ node: this.root, wf: this.updateNodeWherePathMatches, data: r }), r.json;
    });
    gs(this, "getUISchema", () => Ei(
      this.getUncheckedNodes().map(
        (s) => fi(0, rn.toPathArray(on(s)))
      )
    ));
    this.schema = zs.parse(s), this.schemaPathToUpdatePathMap = RC(this.schema), this.json = zs.parse(n), this.totalCheckedCount = 0, this.root = this.constructTree();
  }
}
const ug = ({ node: t, updateNodeForPath: s, disabled: n, hasParent: a }) => {
  const r = () => {
    ct.event({
      category: "Deployment Template",
      action: "GUI Checkbox clicked"
    }), s(t.path);
  }, o = !!t.children?.length, i = t.title ?? t.key;
  return /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-4", children: o ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-20 fw-6 cn-9", children: i }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col pl-12 mt-8 mb-8 dc__border-left-n1 dc__gap-8", children: t.children.map((l) => /* @__PURE__ */ e.jsx(
      ug,
      {
        disabled: n,
        node: l,
        updateNodeForPath: s,
        hasParent: !0
      },
      l.key
    )) })
  ] }) : /* @__PURE__ */ e.jsx(
    $e,
    {
      value: Fe.CHECKED,
      disabled: n,
      isChecked: t.isChecked,
      onChange: r,
      rootClassName: "mb-0 fs-13 cn-7 lh-20",
      name: i,
      children: /* @__PURE__ */ e.jsx("span", { className: a ? "" : "fw-6", children: i })
    }
  ) });
}, oG = ({
  disabled: t,
  node: s,
  updateNodeForPath: n
}) => /* @__PURE__ */ e.jsx("div", { className: "dc__overflow-auto py-20 pl-32 pr-20 flexbox-col dc__gap-12", children: s.children.map((a) => /* @__PURE__ */ e.jsx(
  ug,
  {
    disabled: t,
    node: a,
    updateNodeForPath: n,
    hasParent: !1
  },
  a.key
)) }), Hd = {
  isKey: !1,
  next: {}
}, ji = (t) => t.split("/").slice(1), b0 = (t) => {
  const s = ji(t);
  let n = Hd;
  for (let a = 0; a < s.length; a++) {
    const r = s[a];
    n.next[r] || (n.next[r] = {
      next: {}
    }), n = n.next[r];
  }
  n.isKey = !0;
}, N0 = (t) => {
  const s = ji(t);
  let n = Hd;
  for (let a = 0; a < s.length; a++) {
    if (n = n.next[s[a]], !n)
      return !1;
    if (n.isKey)
      return !0;
  }
  return !!n?.isKey;
}, T0 = ({ patches: t }) => {
  const s = t.map(({ path: n, value: a }) => Jc(n, a));
  return Ei(s);
}, I0 = (t, s) => (Hd.next = {}, s.forEach((n) => b0(n)), t.map((n) => N0(n))), mg = (t, s, n) => {
  const a = t.map((o) => o.path), r = I0(a, s);
  return t.filter((o, i) => n ? !r[i] : r[i]);
}, ho = (t) => {
  const { path: s, value: n } = t;
  return !n || typeof n != "object" || !Object.keys(n).length ? [t] : Object.entries(n).flatMap(([a, r]) => {
    const o = { ...t, path: `${s}/${hm(a)}`, value: r };
    return ho(o);
  });
}, Fl = (t, s) => ({ ...t, id: s }), v0 = ({ edited: t, unedited: s, patches: n }, a, r) => {
  const o = [
    .../* @__PURE__ */ new Set([
      ...oo(a, s, "pointer"),
      ...oo(a, t, "pointer")
    ])
  ], i = mg(
    n.flatMap((p, m) => p.op === "add" ? ho(p).map((u) => Fl(u, m)) : p.op === "remove" ? ho({
      ...p,
      value: rn({
        path: on(p.path),
        json: s,
        resultType: "value",
        wrap: !0
      })[0]
    }).map((u) => Fl(u, m)) : Fl(p, m)),
    o,
    !r
  ), l = /* @__PURE__ */ new Set(), c = {};
  return i.forEach(({ id: p, op: m, path: u }) => {
    const f = n[p];
    if (m !== "add" && m !== "remove" || f.path === u) {
      l.add(p);
      return;
    }
    if (m === "add") {
      Aa(f.value, { op: "remove", path: u.slice(f.path.length) });
      return;
    }
    c[f.path] = [
      ...c[f.path] ?? [],
      Jc(
        u,
        rn({
          json: s,
          path: on(u),
          wrap: !1,
          resultType: "value"
        })
      )
    ];
  }), n.filter((p, m) => !l.has(m)).concat(
    Object.entries(c).map(([p, m]) => ({
      op: "add",
      path: p,
      value: rn({
        json: Ei(m),
        path: on(p),
        resultType: "value",
        wrap: !1
      })
    }))
  );
}, A0 = ({ edited: t, unedited: s, patches: n }, a, r) => {
  const o = [
    .../* @__PURE__ */ new Set([
      ...oo(a, s, "pointer"),
      ...oo(a, t, "pointer")
    ])
  ];
  return mg(
    n.flatMap((i) => i.op === "add" ? ho(i) : i.op === "remove" ? ho({
      ...i,
      value: rn({
        path: on(i.path),
        json: s,
        resultType: "value",
        wrap: !0
      })[0]
    }) : i),
    o,
    r
  );
}, _g = (t, s, n) => {
  const a = A0(t, s, n);
  return T0({ ...t, patches: a });
}, Kd = (t, s) => s_(
  _g(t, s, !1),
  n_
), fg = (t, s) => s_(
  _g(t, s, !0),
  n_
), hg = (t) => t ? Object.values(t).some((s) => s !== null && typeof s == "object" ? Array.isArray(s) ? !0 : hg(s) : !1) : !1, tm = (t, s) => {
  const n = zs.parse(t) ?? {}, a = structuredClone(n), o = oo(s, n, "pointer").map(
    (i) => ({
      op: "remove",
      path: i
    })
    // TODO: check if this is truly required
  ).sort(({ path: i }, { path: l }) => {
    const c = ji(i), d = ji(l);
    let p = 0;
    for (let m = 0; m < c.length && m < d.length; m++) {
      const u = Number(c[m]), f = Number(d[m]), _ = !Number.isNaN(u), h = !Number.isNaN(f);
      if (_ && h && (p = f - u, p))
        break;
      if (c[m] < d[m]) {
        p = -1;
        break;
      }
      if (c[m] > d[m]) {
        p = 1;
        break;
      }
      p = 0;
    }
    return p;
  }).reduce((i, l) => {
    try {
      return Aa(i, l).newDocument;
    } catch {
      return i;
    }
  }, n);
  return {
    document: o,
    addOperations: xo(o ?? {}, a ?? {})
  };
}, S0 = (t, s) => {
  const n = structuredClone(t);
  return s.forEach((a) => {
    try {
      Aa(n, a);
    } catch {
    }
  }), n;
}, iG = ({
  hideLockedKeys: t,
  lhs: s,
  rhs: n,
  lockedConfigKeysWithLockType: a,
  removedPatches: r,
  hideLockKeysToggled: o,
  unableToParseYaml: i,
  readOnly: l,
  uneditedDocument: c
}) => {
  let d = s, p = n;
  if (t) {
    if (d) {
      const { document: m } = tm(d, a.config);
      d = gt(m);
    }
    if (p && (o.current || l) && !i) {
      const { document: m, addOperations: u } = tm(
        p,
        a.config
      );
      p = gt(m), u.length && (r.current = u);
    }
    o.current = !1;
  } else if ((o.current || l) && !t && !i && r.current.length && p) {
    const m = zs.parse(p), u = zs.parse(c);
    p = gt(
      wC(
        u,
        S0(m, r.current)
      )
    ), r.current = [], o.current = !1;
  }
  return { updatedLHS: d, updatedRHS: p };
}, y0 = ({
  documents: t,
  lockedConfigKeysWithLockType: s
}) => {
  const n = {
    ...t,
    patches: xo(t.unedited ?? {}, t.edited ?? {})
  }, a = Kd(n, s.config), r = fg(n, s.config), o = s.allowed ? r : a, i = s.allowed ? a : r;
  return {
    ineligibleChanges: o,
    eligibleChanges: i
  };
}, L0 = async (t, s, n) => {
  try {
    const a = await le(
      ye($.LOCK_CONFIG_API_ROUTE, { appId: t, envId: s }),
      { signal: n }
    );
    return {
      ...a,
      result: {
        id: a?.result?.id ?? 0,
        allowed: a?.result?.allowed ?? !1,
        config: a?.result?.config ?? []
      }
    };
  } catch (a) {
    throw V(a), a;
  }
}, Ul = ({ message: t, variant: s = "information", closeModal: n }) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12 flex-grow-1", children: [
  /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1", children: /* @__PURE__ */ e.jsx(Ot, { description: t, variant: s }) }),
  /* @__PURE__ */ e.jsx(j, { dataTestId: "close-diff-modal", text: "Okay", onClick: n })
] }), j0 = ({
  closeModal: t,
  showLockedDiffForApproval: s,
  onSave: n,
  documents: a,
  appId: r,
  envId: o,
  isSaving: i
}) => {
  const [l, c, d, p] = ne(
    () => L0(r, o),
    [r, o]
  ), [m, u] = v(!1), f = c?.result || DC, { ineligibleChanges: _, eligibleChanges: h } = y0({
    documents: a,
    lockedConfigKeysWithLockType: f
  }), x = hg(h), g = Object.values(h).length === 0, E = async () => {
    await n(!0);
  }, C = () => {
    u((T) => !T);
  }, b = () => {
    const T = gt(_, { sortMapEntries: !0, simpleKeys: !0 }), A = gt(h, { sortMapEntries: !0, simpleKeys: !0 });
    return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col py-12 px-16 dc__gap-12 flex-grow-1 dc__overflow-auto", children: [
      /* @__PURE__ */ e.jsx("div", { className: "fs-14 fw-4", children: "Some of the keys are locked and prohibited to change by non-super admin users." }),
      /* @__PURE__ */ e.jsxs("div", { className: "dc__border dc__grid-half h-100", children: [
        /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__border-right", children: /* @__PURE__ */ e.jsx(Gt, { mode: Ts.YAML, readOnly: !0, value: T, height: "fitToParent", children: /* @__PURE__ */ e.jsx(
          "div",
          {
            className: "pl-12 pt-12 pb-12 pr-12 bcr-2 fw-6",
            style: { backgroundColor: "var(--code-editor-red)" },
            children: "NOT eligible for update"
          }
        ) }) }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1", children: [
          /* @__PURE__ */ e.jsx(
            "div",
            {
              className: "pl-12 pt-12 pb-12 pr-12 fw-6",
              style: { backgroundColor: "var(--code-editor-green)" },
              children: "Eligible for update"
            }
          ),
          g ? /* @__PURE__ */ e.jsx("div", { className: "flex flex-grow-1", children: "No Changes" }) : /* @__PURE__ */ e.jsx(Gt, { mode: Ts.YAML, readOnly: !0, value: A, height: "fitToParent" })
        ] })
      ] })
    ] });
  }, N = () => s ? /* @__PURE__ */ e.jsx(Ul, { message: xT, closeModal: t }) : g ? /* @__PURE__ */ e.jsx(Ul, { message: P_, closeModal: t }) : x ? /* @__PURE__ */ e.jsx(Ul, { message: ET, variant: "warning", closeModal: t }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: "flex dc__gap-8", children: /* @__PURE__ */ e.jsx(
      $e,
      {
        isChecked: m,
        value: Fe.CHECKED,
        onChange: C,
        rootClassName: "mb-0 icon-dim-24 w-100",
        dataTestId: "save-eligible-changes",
        children: /* @__PURE__ */ e.jsx("span", { className: "fs-14", children: "Save changes which are eligible to update" })
      }
    ) }),
    /* @__PURE__ */ e.jsxs("div", { className: "ml-auto flex dc__gap-12", children: [
      /* @__PURE__ */ e.jsx(
        j,
        {
          dataTestId: "close-modal-diff",
          text: "Cancel",
          onClick: t,
          variant: w.secondary
        }
      ),
      /* @__PURE__ */ e.jsx(
        j,
        {
          dataTestId: "save-modal-diff",
          text: "Save Changes",
          isLoading: i,
          disabled: !m || i,
          onClick: E
        }
      )
    ] })
  ] }), I = () => l ? /* @__PURE__ */ e.jsx(Je, { pageLoader: !0 }) : d ? /* @__PURE__ */ e.jsx(Xe, { code: d.code, reload: p }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    b(),
    /* @__PURE__ */ e.jsx("div", { className: "pt-16 pb-16 pl-16 pr-16 flex  dc__border-top", children: N() })
  ] });
  return /* @__PURE__ */ e.jsx($t, { position: "right", width: "800px", onEscape: t, onClose: t, children: /* @__PURE__ */ e.jsxs("div", { className: "h-100 bg__primary flexbox-col locked-diff-modal", onClick: Le, children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space pt-16 pb-16 pl-16 pr-16 dc__border-bottom", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 ", children: [
        /* @__PURE__ */ e.jsx(W, { name: "ic-warning", color: null, size: 24 }),
        /* @__PURE__ */ e.jsx("div", { className: "fs-16 fw-6", children: "Some changes are not eligible for update" })
      ] }),
      /* @__PURE__ */ e.jsx(
        j,
        {
          dataTestId: "close-deployment-diff",
          icon: /* @__PURE__ */ e.jsx(W, { name: "ic-close-large", color: null }),
          size: O.xs,
          onClick: t,
          ariaLabel: "close deployment diff drawer",
          showAriaLabelInTippy: !1,
          style: B.negativeGrey,
          variant: w.borderLess
        }
      )
    ] }),
    I()
  ] }) });
}, lG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: j0
}, Symbol.toStringTag, { value: "Module" })), cG = () => /* @__PURE__ */ e.jsxs("li", { className: "m-0 fs-13 lh-20 cn-9 fw-4", children: [
  /* @__PURE__ */ e.jsx("strong", { className: "m-0 fw-6", children: "Patch:" }),
  " Updates only specified fields, keeping other inherited values intact. Ideal for making minor adjustments to inherited configurations."
] }), dG = ({
  isAppMetricsEnabled: t,
  showApplicationMetrics: s,
  isLoading: n,
  selectedChart: a,
  isDisabled: r,
  toggleAppMetrics: o,
  latestDraft: i,
  isCiPipeline: l,
  handleTriggerSaveDraft: c,
  validateApprovalState: d,
  handleReload: p,
  showApproveButton: m,
  isPublishedView: u,
  parsingError: f,
  restoreLastSavedYAML: _,
  isDryRunView: h,
  handleApprovalLockConfigError: x
}) => {
  const { envId: g } = Ue(), [E, C] = v(!1), b = !!i?.userApprovalMetadata?.canCurrentUserApprove, N = !b || !i?.canApprove, I = !g && !l, T = () => {
    d() && C(!0);
  }, A = () => {
    C(!1);
  }, S = () => {
    if (m) {
      if (i?.userApprovalMetadata?.hasCurrentUserApproved)
        return /* @__PURE__ */ e.jsx(pg, {});
      if (N) {
        const R = b ? "You have made changes to this file. Users who have edited cannot approve the changes." : "You do not have permission to approve configuration changes for this application - environment combination.";
        return /* @__PURE__ */ e.jsx(
          j,
          {
            showTooltip: !!R,
            tooltipProps: {
              content: R
            },
            style: B.positive,
            isLoading: n,
            disabled: !0,
            dataTestId: "validate-approval-btn",
            text: "Approve changes",
            size: O.medium
          }
        );
      }
      return E ? /* @__PURE__ */ e.jsx(
        cg,
        {
          draftId: i.draftId,
          draftVersionId: i.draftVersionId,
          resourceName: "deployment template",
          reload: p,
          onClose: A,
          handleLockConfigError: x,
          children: /* @__PURE__ */ e.jsx(
            j,
            {
              style: B.positive,
              isLoading: n,
              disabled: r,
              dataTestId: "placeholder-approve-changes-btn",
              text: "Approve changes",
              size: O.medium
            }
          )
        }
      ) : /* @__PURE__ */ e.jsx(
        j,
        {
          style: B.positive,
          isLoading: n,
          disabled: r,
          onClick: T,
          dataTestId: "validate-approval-btn",
          text: "Approve changes",
          size: O.medium
        }
      );
    }
    return /* @__PURE__ */ e.jsx(t_, { parsingError: f, restoreLastSavedYAML: _, children: /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
      j,
      {
        onClick: c,
        disabled: r,
        isLoading: n,
        text: I ? "Save & Next" : "Save changes...",
        dataTestId: I ? "base-deployment-template-save-and-next-button" : "base-deployment-template-save-changes-button",
        endIcon: I ? /* @__PURE__ */ e.jsx(
          Ms,
          {
            className: `icon-dim-16 dc__no-shrink ${r ? "scn-4" : "scn-0"}`
          }
        ) : null,
        size: O.medium
      }
    ) }) });
  }, L = () => m || h ? /* @__PURE__ */ e.jsx(
    Xl,
    {
      isAppMetricsEnabled: t,
      showApplicationMetrics: s,
      onlyShowCurrentStatus: !0
    }
  ) : /* @__PURE__ */ e.jsx(
    Xl,
    {
      showApplicationMetrics: s,
      isLoading: n,
      selectedChart: a,
      isDisabled: r,
      toggleAppMetrics: o,
      isAppMetricsEnabled: t,
      parsingError: f,
      restoreLastSavedYAML: _
    }
  );
  return /* @__PURE__ */ e.jsxs(
    "footer",
    {
      className: `flexbox ${s ? "dc__content-space" : "dc__content-end"} dc__align-items-center p-12 bg__primary dc__border-top ${E ? "deployment-template__approval-tippy" : ""}`,
      children: [
        L(),
        !u && S()
      ]
    }
  );
}, sm = [
  {
    label: "Published values",
    value: Qo.PUBLISHED_VALUES
  },
  {
    label: "Approval Pending",
    value: Qo.APPROVAL_PENDING
  },
  {
    label: "Values from draft",
    value: Qo.VALUES_FROM_DRAFT
  }
], pG = ({
  selectedOptionValue: t = Qo.PUBLISHED_VALUES,
  handleChangeDryRunEditorMode: s
}) => {
  const n = (a) => {
    s(a.value);
  };
  return /* @__PURE__ */ e.jsx(
    Ve,
    {
      options: sm,
      value: sm.find((a) => a.value === t),
      onChange: n,
      inputId: "dry-run-editor-mode-select",
      variant: cn.COMPACT,
      isSearchable: !1,
      size: O.small
    }
  );
}, O0 = async (t) => {
  try {
    const {
      result: { versionMetadata: s }
    } = await le(`${$.CONFIG_DRAFTS_VERSION}/${t}`);
    return s?.sort(
      (n, a) => no(n.draftVersionId, a.draftVersionId, Ut.DESC)
    ) || [];
  } catch (s) {
    throw V(s), s;
  }
}, gg = (t, s, n) => Bt(
  ye($.CONFIG_DRAFTS, {
    draftId: t,
    draftVersionId: s,
    state: n
  }),
  {}
), uG = ({
  requestedUserId: t,
  userApprovalMetadata: s,
  draftId: n,
  draftVersionId: a,
  handleReload: r
}) => {
  const [o, i] = v(!1), l = async () => {
    i(!0);
    try {
      await gg(n, a, ro.Discarded), Z.showToast({
        variant: ee.success,
        description: "Draft discarded successfully"
      }), r();
    } catch (c) {
      wr(c);
    } finally {
      i(!1);
    }
  };
  return /* @__PURE__ */ e.jsx(
    md,
    {
      placement: "bottom-end",
      showOnlyCountInButton: !0,
      userApprovalMetadata: s,
      cancelRequest: l,
      isLoading: o,
      requestedUserId: t,
      approvalType: In.Config
    }
  );
}, mG = ({
  shouldMergeTemplateWithPatches: t,
  handleToggleShowTemplateMergedWithPatch: s,
  isDisabled: n
}) => /* @__PURE__ */ e.jsx(
  $e,
  {
    value: Fe.CHECKED,
    onChange: s,
    isChecked: t,
    disabled: n,
    rootClassName: "mb-0",
    children: "Show merged"
  }
), _G = ({
  areCommentsPresent: t,
  handleToggleCommentsView: s
}) => /* @__PURE__ */ e.jsx(
  j,
  {
    ariaLabel: "View / Add Comment",
    dataTestId: "toggle-comments-view",
    showAriaLabelInTippy: !0,
    variant: w.borderLess,
    style: B.neutral,
    onClick: s,
    icon: t ? /* @__PURE__ */ e.jsx(jN, { className: "icon-dim-20 dc__no-shrink" }) : /* @__PURE__ */ e.jsx(LN, { className: "icon-dim-20 dc__no-shrink" }),
    size: O.xs
  }
), R0 = ({
  selectedTab: t,
  isApprovalPending: s,
  hasPublishedConfig: n
}) => {
  switch (t) {
    case Zo.COMPARE:
      return {
        label: s ? "Compare & Approve" : "Compare",
        icon: "ic-arrows-left-right"
      };
    case Zo.EDIT_DRAFT:
      return {
        label: "Edit Draft",
        icon: "ic-pencil"
      };
    case Zo.PUBLISHED:
      return {
        label: n ? "Published" : "Yet to Publish",
        icon: n ? "ic-check" : "ic-timeout-dash"
      };
    default:
      return {
        label: "Values",
        icon: null
      };
  }
}, fG = (t, s, n, a) => t ? {
  text: s ? "Show locked keys" : "Hide locked keys",
  dataTestId: `${s ? "show" : "hide"}-locked-keys-popup-button`,
  icon: s ? /* @__PURE__ */ e.jsx(td, { className: "icon-dim-16 scn-8 dc__no-shrink" }) : /* @__PURE__ */ e.jsx(wN, { className: "icon-dim-16 scn-8 dc__no-shrink" }),
  onClick: () => a(!s),
  disabled: n
} : null, hG = (t, s) => ({
  text: "Discard draft",
  dataTestId: "discard-draft-popup-button",
  icon: /* @__PURE__ */ e.jsx(ON, { className: "icon-dim-16 dc__no-shrink" }),
  onClick: (n) => {
    Le(n), t();
  },
  disabled: s
}), gG = (t, s) => ({
  text: "Show activity history",
  dataTestId: "show-activity-history-popup-button",
  icon: /* @__PURE__ */ e.jsx(RN, { className: "icon-dim-16 dc__no-shrink scn-8" }),
  onClick: (n) => {
    Le(n), t();
  },
  disabled: s
}), xg = () => /* @__PURE__ */ e.jsx(
  "button",
  {
    className: "flex dc__no-shrink icon-dim-20 p-0 dc__no-background dc__no-border dc__outline-none-imp dc__tab-focus dc__hover-n50",
    type: "button",
    "aria-label": "Open/Close Config toolbar options menu",
    children: /* @__PURE__ */ e.jsx(PN, { className: "icon-dim-16 fcn-6 dc__flip-90", "data-testid": "config-more-options-popup" })
  }
), xG = (t, s) => ({
  text: `Express delete${s ? " override" : ""}`,
  dataTestId: "express-delete-popup-button",
  icon: /* @__PURE__ */ e.jsx(W, { name: "ic-delete-lightning", color: "R500" }),
  variant: "negative",
  onClick: (n) => {
    Le(n), t();
  }
}), EG = ({
  selectedTab: t,
  handleProtectionViewTabChange: s,
  isApprovalPending: n = !1,
  hasPublishedConfig: a = !1,
  isDisabled: r,
  parsingError: o,
  restoreLastSavedYAML: i
}) => {
  const l = (d) => () => {
    s(d);
  }, c = Object.values(Zo).map((d) => {
    const { icon: p, label: m } = R0({ selectedTab: d, isApprovalPending: n, hasPublishedConfig: a });
    return {
      icon: p,
      label: m,
      id: `visit-${d}`,
      active: t === d,
      tabType: "button",
      disabled: r,
      shouldWrapTooltip: !!o,
      tooltipProps: {
        alwaysShowTippyOnHover: !0,
        interactive: !0,
        content: Mm({
          parsingError: o,
          restoreLastSavedYAML: i
        })
      },
      props: {
        onClick: l(d),
        "data-testid": `visit-${d}`
      }
    };
  });
  return /* @__PURE__ */ e.jsx(Ar, { size: O.medium, tabs: c });
}, P0 = ({
  activityList: t,
  loadingActivityList: s,
  reloadActivityList: n,
  activityListError: a,
  handleClearPopupNode: r
}) => {
  const { email: o } = yo(), i = () => /* @__PURE__ */ e.jsx("ol", { className: "pt-8 pl-0 mb-0 ml-12 pr-12 dc__list-style-none dc__border-left", children: t.map((c, d) => /* @__PURE__ */ e.jsxs(
    "li",
    {
      className: "flex left dc__gap-12 top pb-8 fs-12 fw-4 lh-20 cn-9",
      children: [
        /* @__PURE__ */ e.jsx("div", { className: "icon-dim-8 bcn-3 br-16 mt-6 ml--4" }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex top left dc__content-space dc__gap-8 w-100", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flex column left", children: [
            /* @__PURE__ */ e.jsx("span", { className: "fw-6", children: d === t.length - 1 ? "Draft created" : "Updated" }),
            /* @__PURE__ */ e.jsx("span", { children: c.userEmail === o ? "You" : c.userEmail })
          ] }),
          /* @__PURE__ */ e.jsx("span", { className: "cn-7", children: it(c.activityTime).format(Ir.TWELVE_HOURS_FORMAT) })
        ] })
      ]
    },
    `${c.activityTime.toString()}-${d}`
  )) }), l = () => /* @__PURE__ */ e.jsx("div", { className: "dc__overflow-auto mxh-250 br-4 bg__primary flexbox-col", children: /* @__PURE__ */ e.jsx(
    Ke,
    {
      isLoading: s,
      error: a,
      genericSectionErrorProps: {
        reload: n
      },
      children: t?.length ? i() : /* @__PURE__ */ e.jsx(
        ps,
        {
          title: "No activity found",
          description: "No activity found for this draft. Activity will be recorded when you make changes to the draft.",
          reload: n,
          useInfoIcon: !0
        }
      )
    }
  ) });
  return /* @__PURE__ */ e.jsx(
    Dt,
    {
      theme: Mt.white,
      heading: "Activity history",
      className: "w-300 h-100",
      iconClass: "scv-5",
      showCloseButton: !0,
      interactive: !0,
      visible: !0,
      onClose: r,
      additionalContent: l(),
      placement: "bottom-end",
      children: xg()
    }
  );
}, CG = ({
  popupNodeType: t,
  handleClearPopupNode: s,
  draftId: n,
  draftVersionId: a,
  handleReload: r
}) => {
  const [o, i] = v(!1), [l, c, d, p] = ne(
    () => O0(+n),
    [n, t],
    !!n && t === hl.EDIT_HISTORY
  ), m = async () => {
    i(!0);
    try {
      await gg(n, a, ro.Discarded), Z.showToast({
        variant: ee.success,
        description: "Draft discarded successfully"
      }), s(), r();
    } catch (u) {
      wr(u);
    } finally {
      i(!1);
    }
  };
  return t ? t === hl.DISCARD_DRAFT ? /* @__PURE__ */ e.jsx(
    R_,
    {
      handleDiscardDraft: m,
      handleClearPopupNode: s,
      isDraftDeleting: o,
      placement: "bottom-end",
      approvalType: In.Config,
      children: xg()
    }
  ) : t === hl.EDIT_HISTORY ? /* @__PURE__ */ e.jsx(
    P0,
    {
      activityList: c,
      loadingActivityList: l,
      reloadActivityList: p,
      activityListError: d,
      handleClearPopupNode: s
    }
  ) : null : null;
}, bG = async ({
  values: t,
  mergeStrategy: s = MC.PATCH,
  resourceType: n,
  appId: a,
  envId: r,
  resourceId: o,
  resourceName: i,
  signal: l,
  shouldShowError: c = !0
}) => {
  try {
    const { result: d } = await we(
      $.CONFIG_OPERATIONS,
      {
        values: t,
        mergeStrategy: s,
        resourceType: n,
        appId: a,
        resourceId: o,
        resourceName: i,
        envId: r
      },
      { signal: l }
    );
    return d?.mergedValues || [];
  } catch (d) {
    throw !Pe(d) && c && V(d), d;
  }
}, NG = ({
  isInheriting: t,
  handleSetIsInheriting: s,
  useRemoteCache: n,
  handleSetUseRemoteCache: a,
  isBlobStorageConfigured: r
}) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__align-items-center", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-6", children: [
      /* @__PURE__ */ e.jsx("h3", { className: "dc__uppercase cn-6 fs-12 lh-20 fw-6 m-0", children: "Docker layer caching" }),
      /* @__PURE__ */ e.jsx(
        Dt,
        {
          theme: Mt.white,
          className: "flex w-300 h-100",
          placement: "bottom",
          Icon: cd,
          iconClass: "fcb-5",
          heading: "Docker layer caching",
          infoText: `
                            Docker images are built layer by layer.
                            Docker's layer caching mechanism allows unchanged layers to be
                            reused across pipeline runs, drastically reducing build times.
                        `,
          showCloseButton: !0,
          trigger: "click",
          interactive: !0,
          children: /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(Ya, { className: "icon-dim-16 fcn-6 cursor dc__no-shrink flex" }) })
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(
      Gn,
      {
        name: "workflow-cache-inheriting-toggle",
        ariaLabel: "Toggle to inherit cache settings from global configuration",
        tooltipContent: `${t ? "Inheriting" : "Not inheriting"} from global`,
        isChecked: t,
        shape: "square",
        variant: "theme",
        iconName: "ic-world-globe",
        onChange: s
      }
    )
  ] }),
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
    /* @__PURE__ */ e.jsx(
      $e,
      {
        value: Fe.CHECKED,
        isChecked: n,
        onChange: a,
        rootClassName: "mb-0 py-6",
        name: "use-remote-cache-checkbox",
        dataTestId: "use-remote-cache-checkbox",
        disabled: t,
        children: /* @__PURE__ */ e.jsx(
          Ie,
          {
            content: "Using remote cache reduces pipeline run time",
            alwaysShowTippyOnHover: !0,
            placement: "right",
            children: /* @__PURE__ */ e.jsx("span", { className: "dc__underline-dotted fs-13 cn-9 lh-20", children: "Use remote cache" })
          }
        )
      }
    ),
    !r && /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8 py-8 px-12 br-4 ey-2 bcy-1 dc__align-start", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__align-start", children: [
        /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Setup blob storage to use cache" }),
        /* @__PURE__ */ e.jsx(Zc, { className: "icon-dim-20 m-2 dc__no-shrink flex" })
      ] }),
      /* @__PURE__ */ e.jsx(
        $a,
        {
          docLinkKey: "BLOB_STORAGE",
          text: a_.ARTIFACTS_EMPTY_STATE_TEXTS.ConfigureBlobStorage,
          dataTestId: "configure-blob-storage",
          showExternalIcon: !0,
          openInNewTab: !0
        }
      )
    ] })
  ] })
] }), w0 = ({ hasDrift: t, liveManifest: s, desiredManifest: n }) => /* @__PURE__ */ e.jsx(
  Gt,
  {
    readOnly: !0,
    mode: Ts.YAML,
    diffView: !0,
    noParsing: !0,
    modifiedValue: gt(s),
    originalValue: gt(n),
    height: "fitToParent",
    children: /* @__PURE__ */ e.jsxs(Gt.Header, { hideDefaultSplitHeader: !0, children: [
      /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-12 fw-6 lh-20 cn-9", children: "Desired Manifest" }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 pl-16 dc__align-items-center m-0 fs-12 fw-6 lh-20 cn-9", children: [
        /* @__PURE__ */ e.jsx("span", { children: "Live Manifest" }),
        t && /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4 dc__align-items-center dc__no-shrink", children: [
          /* @__PURE__ */ e.jsx(Ii, { className: "icon-dim-16" }),
          /* @__PURE__ */ e.jsx("span", { className: "cy-7", children: "Config Drift" })
        ] })
      ] })
    ] })
  }
), TG = (t) => t?.hasDrift && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
  t.health?.status && /* @__PURE__ */ e.jsx("span", { className: "dc__bullet mw-4" }),
  /* @__PURE__ */ e.jsx("span", { className: "cy-7", children: "Config drift detected" })
] }), IG = (t) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox bcy-8 cn-0 px-20 py-4 dc__gap-8", children: [
  /* @__PURE__ */ e.jsx("span", { children: "Out of sync from desired manifest." }),
  /* @__PURE__ */ e.jsx("button", { className: "dc__unset-button-styles dc__underline", type: "button", onClick: t, children: "Check configuration drift" })
] }), D0 = (t) => {
  const s = t.resources.reduce((n, a) => (n[a.kind] || (n[a.kind] = {
    kind: a.kind,
    hasDrift: !1,
    nodes: []
  }), n[a.kind].nodes.push(a), n[a.kind].hasDrift = n[a.kind].hasDrift || a.hasDrift, n), {});
  return { resources: Object.values(s) };
}, M0 = async ({
  appId: t,
  envId: s,
  setSelectedNode: n,
  setExpandedState: a
}) => {
  const r = {
    appId: t,
    envId: s
  }, o = ye($.DRIFT_MANAGED_RESOURCES, r), i = await le(o), l = D0(i.result);
  return l.resources.length && (a({ [l.resources[0].kind]: !0 }), n(l.resources[0].nodes[0])), l;
}, vG = (t, s) => we($.DRIFT_MANAGED_RESOURCE, t, { signal: s }), k0 = ({ appId: t, envId: s }) => {
  const [n, a] = v(null), [r, o] = v({}), [i, l, c, d] = ne(
    () => M0({ appId: +t, envId: +s, setSelectedNode: a, setExpandedState: o }),
    [t, s]
  ), p = (x) => {
    a(x);
  }, m = (x) => {
    const g = r[x] ?? !1;
    o({ ...r, [x]: !g });
  }, u = Q(
    () => l?.resources.map((x) => ({
      id: x.kind,
      header: x.kind,
      ...x.hasDrift && !r[x.kind] && {
        headerIconConfig: {
          Icon: Ii
        }
      },
      items: x.nodes.map((g) => ({
        title: g.name,
        ...g.hasDrift && {
          iconConfig: {
            Icon: Ii
          }
        },
        isActive: n?.name === g.name && n?.kind === g.kind,
        onClick: () => p(g)
      })),
      isExpanded: r[x.kind] ?? !1
    })) ?? [],
    [l, n, r]
  ), { hasDrift: f, predictedLiveState: _, normalizedLiveState: h } = n ?? {};
  return /* @__PURE__ */ e.jsx(
    Ke,
    {
      isLoading: i,
      error: c,
      progressingProps: {
        pageLoader: !0
      },
      errorScreenManagerProps: {
        code: c?.code,
        reload: d
      },
      children: /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1 flexbox mh-0", children: [
        /* @__PURE__ */ e.jsx("div", { className: "w-240 dc__border-right p-8 dc__no-shrink dc__overflow-auto", children: /* @__PURE__ */ e.jsx(
          Fc,
          {
            config: u,
            tabType: "button",
            onCollapseBtnClick: m
          }
        ) }),
        n && /* @__PURE__ */ e.jsxs("div", { className: "mw-none flexbox-col flex-grow-1", children: [
          /* @__PURE__ */ e.jsx("div", { className: "px-12 py-8 fs-13 fw-6 lh-20 cn-9", children: `${n.kind} / ${n.name}` }),
          /* @__PURE__ */ e.jsx(
            w0,
            {
              hasDrift: f,
              liveManifest: h,
              desiredManifest: _
            },
            `${n.kind} / ${n.name}`
          )
        ] })
      ] })
    }
  );
}, AG = ({ areConfigurationsDrifted: t, appName: s, appId: n, envId: a }) => {
  const { setTempAppWindowConfig: r } = Is(), o = /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
    /* @__PURE__ */ e.jsx("span", { className: "fs-12 fw-6 lh-18", children: t ? "Configuration drift" : "Configurations in sync" }),
    /* @__PURE__ */ e.jsx("span", { className: "fs-12 fw-4 lh-18 dc__word-break", children: t ? "Config drift detected between live & desired manifests" : "Live & desired manifests are in sync" })
  ] }), i = (l) => {
    l.stopPropagation(), r({
      open: !0,
      title: `${s} / Live and desired manifest comparison`,
      component: /* @__PURE__ */ e.jsx(k0, { appId: n, envId: a })
    });
  };
  return /* @__PURE__ */ e.jsx(
    j,
    {
      ariaLabel: "config-drift-status",
      dataTestId: "config-drift-status",
      icon: t ? /* @__PURE__ */ e.jsx(Ii, {}) : /* @__PURE__ */ e.jsx(DN, {}),
      variant: w.borderLess,
      size: O.xl,
      showTooltip: !0,
      tooltipProps: {
        content: o,
        placement: "top",
        className: "w-250"
      },
      style: t ? B.warning : B.positive,
      onClick: i
    }
  );
}, F0 = ({ currentRolloutWeight: t, currentSetWeight: s }) => /* @__PURE__ */ e.jsxs("div", { className: "dc__position-abs dc__top-0 dc__left-0 w-100 h-100", children: [
  !!t && /* @__PURE__ */ e.jsx(
    "div",
    {
      style: {
        width: `${t}%`,
        background: "linear-gradient(90deg, var(--G100, #E9FBF4) 0%, var(--G200, #B6E9D3) 100%)"
      },
      className: "h-100"
    }
  ),
  !!s && /* @__PURE__ */ e.jsx(
    MN,
    {
      style: {
        width: `${s - t}%`,
        left: `${t}%`
      },
      className: "dc__position-abs dc__top-0"
    }
  )
] }), Gl = ({
  title: t,
  status: s,
  subTitle: n,
  iconName: a,
  actionButtonConfig: r,
  renderActionButton: o,
  currentSetWeight: i,
  currentRolloutWeight: l
}) => {
  const c = window._env_.FEATURE_CANARY_ROLLOUT_PROGRESS_ENABLE;
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col bg__primary w-220 br-8 border__primary dc__overflow-hidden shadow__card--10", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox px-12 pt-12 pb-8 dc__content-space dc__position-rel", children: [
      (c || l === 100) && !!(l || i) && /* @__PURE__ */ e.jsx(F0, { currentRolloutWeight: l, currentSetWeight: i }),
      /* @__PURE__ */ e.jsxs("div", { className: "dc__position-rel w-100", children: [
        /* @__PURE__ */ e.jsx("span", { className: "fs-12 fw-4 lh-20 cn-7", children: t }),
        /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-6 lh-20 cn-9", children: s })
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "dc__zi-1", children: /* @__PURE__ */ e.jsx(W, { name: a, size: 24, color: null }) })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "py-7 px-12 flexbox dc__content-space dc__align-item-center border__secondary--top", children: [
      n && /* @__PURE__ */ e.jsx("span", { className: "fs-12 fw-4 lh-20 cn-9 dc__mxw-100 dc__truncate", children: n }),
      o?.(),
      r && /* @__PURE__ */ e.jsx(
        j,
        {
          dataTestId: "strategy-action-button",
          text: r.text,
          variant: w.text,
          size: O.small,
          onClick: r.onClick
        }
      )
    ] })
  ] });
}, SG = ({
  appId: t,
  envId: s,
  appName: n,
  envName: a,
  renderRollbackButton: r,
  isResourceTreeReloading: o
}) => {
  const i = de(new AbortController()), [l, c] = v(null), [d, p] = v(!1), [m, u, f, _] = ne(
    () => es(
      () => Ed({
        appId: t,
        envId: s,
        options: { signal: i.current.signal }
      }),
      i
    ),
    [t, s, o],
    !!t && !!s && o,
    { resetOnChange: !1 }
  ), h = !!(m || Pe(f));
  if ((h || !f) && (!u || h && u?.[0]?.error))
    return /* @__PURE__ */ e.jsx(kC, {});
  const x = u?.[0]?.strategy, g = u?.[0]?.error;
  if (x !== "BLUE-GREEN" && x !== "CANARY" || sc(g?.code) || // using == as we are expecting number but receiving string
  // eslint-disable-next-line eqeqeq
  g?.code == Ns.FAILED_DEPENDENCY)
    return null;
  if (f || !u?.length || g)
    return /* @__PURE__ */ e.jsx(
      Gl,
      {
        title: `${x ? Mn[x] : "Deployment"} Strategy`,
        status: "--",
        subTitle: "Failed to load",
        iconName: x ? co[x] : "ic-cube",
        actionButtonConfig: {
          text: "Retry",
          onClick: _
        }
      }
    );
  const { phase: E, steps: C, currentStepIndex: b, rolloutIdentifier: N, currentPodHash: I, autoPromotionEnabled: T, promoteFull: A } = u[0], S = E === "Healthy", L = () => {
    c(null);
  }, R = async ({ promoteAction: k, toastConfig: D }) => {
    try {
      p(!0), await ef({
        appId: t,
        envId: s,
        promoteAction: k,
        currentStepIndex: b,
        rolloutName: N.name,
        currentPodHash: I
      }), L(), Z.showToast({
        variant: ee.success,
        title: D.title,
        description: D.description
      }), _();
    } catch (F) {
      V(F);
    } finally {
      p(!1);
    }
  }, y = () => {
    ct.event({
      category: "App details",
      action: "DA_APP_DETAILS_SWAP_TRAFFIC_CLICKED"
    }), c("swapTraffic");
  }, M = (k) => () => R({
    promoteAction: k,
    toastConfig: {
      title: "Traffic Swap Initiated",
      description: "Switching live traffic from blue to green deployment"
    }
  });
  if (x === "BLUE-GREEN") {
    const k = eI({
      phase: E,
      promoteFull: A,
      autoPromotionEnabled: T,
      renderRollbackButton: r,
      handleOpenSwapTrafficDialog: y
    }), D = E === "Paused" && T || E === "Progressing" && !A;
    return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(Gl, { ...k }),
      l === "swapTraffic" && /* @__PURE__ */ e.jsx(
        Eg,
        {
          appName: n,
          envName: a,
          handleClose: L,
          handleSwitchTraffic: M(D ? "promoteFull" : "promoteToNext"),
          isLoading: d,
          ...D ? {
            title: `Skip & Promote Full for ${a} on ${n}`,
            primaryButtonText: "Promote to Full"
          } : {}
        }
      )
    ] });
  }
  const { currentRolloutWeight: P, parsedSteps: U, currentSetWeight: G } = G_(
    C,
    b,
    E
  ), H = window._env_.FEATURE_CANARY_ROLLOUT_PROGRESS_ENABLE, oe = U[b]?.message || "", ae = H ? `Live for ${P}% users` : `Completed ${b} of ${U.length} steps`, re = () => {
    c("manageTraffic");
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      Gl,
      {
        title: "Canary Strategy",
        iconName: "ic-strategy-canary-color",
        ...S ? {
          renderActionButton: r,
          status: "Live for 100% users",
          currentRolloutWeight: 100
        } : {
          actionButtonConfig: {
            text: "Manage Traffic",
            onClick: re
          },
          status: G ? `Increasing to ${G}%` : ae,
          subTitle: G ? "In Progress" : oe,
          currentSetWeight: G,
          currentRolloutWeight: P
        }
      }
    ),
    l === "manageTraffic" && /* @__PURE__ */ e.jsx(
      G0,
      {
        appName: n,
        envName: a,
        parsedSteps: U,
        currentStepIndex: b,
        handleClose: L,
        isRolloutComplete: S,
        currentRolloutStatus: ae,
        handleDeploymentPromotion: R
      }
    )
  ] });
}, U0 = ({
  icon: t,
  message: s,
  statusColor: n,
  promoteFull: a,
  promoteToNext: r,
  triggeredState: o
}) => {
  const i = n === "O500", l = !!a, c = l ? o === "fullRollout" : o === "nextItem", d = o === "nextStep" || (l ? o === "nextItem" : o === "fullRollout");
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12", children: [
    /* @__PURE__ */ e.jsx("div", { className: `flex p-8 br-6 ${i ? "eo-2" : "border__secondary"} bg__modal--primary`, children: /* @__PURE__ */ e.jsx(W, { name: t, size: 20, color: n }) }),
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: `flexbox dc__content-space px-12 py-8 br-6 w-100 ${i ? "eo-2" : "border__secondary"} bg__modal--primary fs-13 fw-4 lh-1-5 cn-9`,
        children: [
          /* @__PURE__ */ e.jsxs("span", { className: "flex dc__gap-4", children: [
            /* @__PURE__ */ e.jsx("span", { children: s }),
            i && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              /* @__PURE__ */ e.jsx("span", { children: "•" }),
              /* @__PURE__ */ e.jsx("span", { className: "co-5", children: "In Progress" })
            ] })
          ] }),
          (!i && l || !!r) && /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: l ? "Rollout full" : "Rollout to next",
              text: l ? "Rollout to 100%" : "Trigger step",
              variant: w.text,
              size: O.medium,
              startIcon: /* @__PURE__ */ e.jsx(W, { name: l ? "ic-fast-forward" : "ic-play-outline", color: null }),
              onClick: l ? a : r,
              isLoading: c,
              disabled: d
            }
          )
        ]
      }
    )
  ] });
}, G0 = ({
  appName: t,
  envName: s,
  isRolloutComplete: n,
  handleClose: a,
  parsedSteps: r,
  currentStepIndex: o,
  currentRolloutStatus: i,
  handleDeploymentPromotion: l
}) => {
  const [c, d] = v(null), p = async () => {
    ct.event({
      category: "App Details Manage Traffic",
      action: "DA_APP_DETAILS_MANAGE_TRAFFIC_FULL_CLICKED"
    }), d("fullRollout"), await l({
      promoteAction: "promoteFull",
      toastConfig: { description: "Triggered Rollout to last step" }
    }), d(null);
  }, m = async () => {
    ct.event({
      category: "App Details Manage Traffic",
      action: "DA_APP_DETAILS_MANAGE_TRAFFIC_NEXT_CLICKED"
    }), await l({
      promoteAction: "promoteToNext",
      toastConfig: { description: "Triggered rollout to next step" }
    });
  }, u = async () => {
    d("nextItem"), await m(), d(null);
  }, f = async () => {
    d("nextStep"), await m(), d(null);
  }, _ = r.length, h = n ? _ : o;
  return /* @__PURE__ */ e.jsx($t, { position: "right", width: "800px", onClose: a, children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col h-100 bg__modal--primary", onClick: Le, children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__align-items-center px-20 py-12 border__primary--bottom", children: [
      /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4 fs-12 lh-1-5 fw-4 cn-7", children: [
          /* @__PURE__ */ e.jsx("span", { className: "dc__mxw-120 dc__truncate", children: t }),
          /* @__PURE__ */ e.jsx("span", { className: "cn-6", children: "/" }),
          /* @__PURE__ */ e.jsx("span", { children: s })
        ] }),
        /* @__PURE__ */ e.jsx("span", { className: "fs-16 fw-6 lh-1-5 cn-9", children: "Manage Canary Traffic" })
      ] }),
      /* @__PURE__ */ e.jsx(
        j,
        {
          dataTestId: "close-manage-traffic",
          icon: /* @__PURE__ */ e.jsx(W, { name: "ic-close-large", color: null }),
          style: B.negativeGrey,
          ariaLabel: "close manage traffic drawer",
          showAriaLabelInTippy: !1,
          size: O.xs,
          variant: w.borderLess,
          onClick: a
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-24 p-20 flex-grow-1 mh-0 dc__overflow-auto bg__modal--secondary", children: [
      /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: `${n ? "" : "dc__grid-half"} br-8 border__primary bg__modal--primary shadow__card--20`,
          children: [
            /* @__PURE__ */ e.jsxs("div", { className: "p-20 flexbox dc__content-space", children: [
              /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
                /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-1-5 cn-7", children: "Rollout Status" }),
                /* @__PURE__ */ e.jsx("span", { className: "fs-20 fw-6 lh-1-5 cn-9", children: i })
              ] }),
              /* @__PURE__ */ e.jsx(W, { name: "ic-users", color: "B500", size: 24 })
            ] }),
            !n && /* @__PURE__ */ e.jsxs("div", { className: "p-20 flexbox dc__content-space border__secondary--left", children: [
              /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
                /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-1-5 cn-7", children: "Canary Step in progress" }),
                /* @__PURE__ */ e.jsx("span", { className: "fs-20 fw-6 lh-1-5 cn-9", children: r[h].message })
              ] }),
              /* @__PURE__ */ e.jsx(W, { name: r[h].iconName, color: "O500", size: 24 })
            ] })
          ]
        }
      ),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16", children: [
        /* @__PURE__ */ e.jsxs("span", { className: "flexbox dc__gap-4 fs-13 fw-6 lh-1-5", children: [
          /* @__PURE__ */ e.jsx("span", { children: "Canary Steps" }),
          /* @__PURE__ */ e.jsx("span", { children: "•" }),
          /* @__PURE__ */ e.jsx("span", { children: `Completed ${h} of ${_}` })
        ] }),
        /* @__PURE__ */ e.jsx("div", { children: r.map(({ message: x, iconName: g, isFullRollout: E }, C) => {
          const b = ZT(C, h);
          return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx(
              U0,
              {
                icon: g,
                message: x,
                statusColor: b,
                triggeredState: c,
                ...C === h + 1 ? { promoteToNext: u } : {},
                ...E ? { promoteFull: p } : {}
              },
              `${x}-${C}`
            ),
            C !== _ - 1 && /* @__PURE__ */ e.jsx(
              "div",
              {
                className: `ml-18 h-16 border__primary${C < h ? "" : "--dashed"}--left`
              }
            )
          ] });
        }) })
      ] })
    ] }),
    " ",
    !n && h < _ - 1 && /* @__PURE__ */ e.jsx("div", { className: "px-20 py-16 flexbox dc__content-end border__primary--top", children: /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "rollout-to-next-step",
        text: "Trigger next step",
        startIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-play-outline", color: null }),
        onClick: f,
        isLoading: c === "nextStep",
        disabled: c === "nextItem" || c === "fullRollout"
      }
    ) })
  ] }) });
}, yG = ({ chartName: t, handleClose: s }) => {
  const { push: n } = Te(), a = () => {
    n(
      `${se.APPLICATION_MANAGEMENT_CONFIGURATIONS_DEPLOYMENT_CHARTS}/${t}/${Xs.HIBERNATION_PATCH}`
    );
  };
  return /* @__PURE__ */ e.jsx(
    zt,
    {
      variant: Ct.info,
      title: `Hibernation patch not available for ‘${t}’ chart`,
      subtitle: "Hibernation patch is applied on the deployment template to perform hibernation actions.",
      buttonConfig: {
        secondaryButtonConfig: {
          text: "Cancel",
          onClick: s
        },
        primaryButtonConfig: {
          text: "Configure patch",
          onClick: a
        }
      },
      handleClose: s,
      children: /* @__PURE__ */ e.jsx("span", { className: "fs-13", children: "Please update the hibernation patch and try again." })
    }
  );
}, nm = "Check vulnerabilities", LG = ({ handleShowVulnerabilityModal: t }) => /* @__PURE__ */ e.jsx(lt, { className: "default-tt", arrow: !1, content: nm, placement: "left", children: /* @__PURE__ */ e.jsx(
  "button",
  {
    type: "button",
    className: "dc__unset-button-styles",
    onClick: t,
    "data-testid": "open-vulnerability-modal-button",
    children: /* @__PURE__ */ e.jsxs("span", { className: "flex left h-32 cursor pl-12 pr-12 dc__hover-n50 dc__no-decor dc__gap-8", children: [
      /* @__PURE__ */ e.jsx(kN, { className: "icon-dim-16 dc__no-shrink" }),
      /* @__PURE__ */ e.jsx("span", { className: "cn-9 dc__ellipsis-right", children: nm })
    ] })
  }
) }), Wd = ({ modalState: t, setModalState: s, scanResult: n }) => {
  const a = FC({
    category: t.category,
    subCategory: t.subCategory
  }), r = UC({
    imageScan: !!n?.imageScan,
    codeScan: !!n?.codeScan,
    kubernetesManifest: !!n?.kubernetesManifest,
    imageScanLicenseRisks: !!n?.imageScan?.license,
    selectedId: a,
    scanResult: n
  }), o = () => {
    const l = {};
    return r.forEach((c) => {
      c.type === "heading" && (l[c.id] = !0, c.items?.forEach((d) => {
        if (d.type === "heading")
          throw new Error("Please implement dfs based handling for nested headings in security sidebar");
      }));
    }), l;
  }, i = (l) => {
    s({ ...BC(l.id), detailViewData: null });
  };
  return /* @__PURE__ */ e.jsx("div", { className: "px-8 py-12 w-240 dc__no-shrink", children: /* @__PURE__ */ e.jsx(
    GC,
    {
      nodes: r,
      defaultExpandedMap: o(),
      selectedId: a,
      onSelect: i
    }
  ) });
}, B0 = (t) => {
  const s = t?.vulnerabilities || [], n = $C(s);
  return {
    ...t || {},
    lastExecution: t?.executionTime && t.executionTime !== fs ? rd(t.executionTime).format(VC) : "",
    severityCount: {
      critical: t?.severityCount?.critical ?? 0,
      high: t?.severityCount?.high ?? 0,
      medium: t?.severityCount?.medium ?? 0,
      low: t?.severityCount?.low ?? 0,
      unknown: t?.severityCount?.unknown ?? 0
    },
    vulnerabilities: n.map((a) => ({
      name: a.cveName,
      severity: a.severity,
      package: a.package,
      version: a.currentVersion,
      fixedVersion: a.fixedVersion,
      policy: a.permission
    }))
  };
}, jG = async ({
  name: t,
  namespace: s,
  clusterId: n,
  group: a,
  version: r,
  kind: o,
  appId: i,
  appType: l,
  deploymentType: c,
  isAppDetailView: d
}) => {
  const p = {
    k8sRequest: {
      resourceIdentifier: {
        groupVersionKind: {
          Group: a || "",
          Version: r || "v1",
          Kind: o
        },
        namespace: s,
        name: t
      }
    },
    clusterId: n ? +n : 0
  }, m = d ? {
    ...p,
    appId: i,
    appType: l,
    deploymentType: c
  } : p, u = await we($.K8S_RESOURCE_SECURITY, m), f = u.result?.map((h) => ({
    ...h,
    scanResult: B0(h.scanResult)
  })) ?? [], _ = {
    ...YC(f),
    imageVulnerabilities: f
  };
  return u.result = HC(_), u;
}, OG = async ({ appId: t, envId: s, abortControllerRef: n }) => {
  const a = { appId: t, envId: s }, r = ye($.POLICY_CONSEQUENCES, a);
  return (await le(r, { abortControllerRef: n })).result;
}, $0 = ({ appId: t, envId: s, pcoId: n }) => we($.SWITCH_TRAFFIC, { appId: t, envId: s, pcoId: n }), Eg = ({
  appName: t,
  envName: s,
  title: n,
  isLoading: a,
  handleClose: r,
  handleSwitchTraffic: o,
  primaryButtonText: i
}) => /* @__PURE__ */ e.jsx(
  zt,
  {
    variant: Ct.custom,
    Icon: /* @__PURE__ */ e.jsx(FN, {}),
    title: n ?? `Swap live traffic for ‘${t}’ on ‘${s}’`,
    subtitle: "This will route the end user traffic to the application’s new deployment on this environment. Are you sure?",
    confirmationConfig: {
      confirmationKeyword: s,
      identifier: "swap-traffic-confirmation-input"
    },
    buttonConfig: {
      secondaryButtonConfig: {
        text: "Cancel",
        onClick: r
      },
      primaryButtonConfig: {
        text: i ?? "Swap traffic",
        onClick: o,
        isLoading: a
      }
    },
    handleClose: r
  }
), RG = ({ appId: t, envId: s, appName: n, envName: a, pcoId: r }) => {
  const [o, i] = v(!1), [l, c] = v(!1), [d, p] = v(!1), m = () => {
    i(!0);
  }, u = () => {
    i(!1);
  }, f = () => {
    p(!0), Z.showToast({
      variant: ee.success,
      title: "Traffic swap initiated",
      description: "Switching live traffic from blue to green deployment"
    }), u();
  }, _ = async () => {
    c(!0);
    try {
      await $0({ appId: t, envId: s, pcoId: r }), f();
    } catch (h) {
      V(h);
    } finally {
      c(!1);
    }
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    !d && /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "app-details-swap-traffic",
        size: O.medium,
        variant: w.secondary,
        text: "Swap traffic",
        startIcon: /* @__PURE__ */ e.jsx(Ti, {}),
        onClick: m,
        component: Re.button,
        style: B.default
      }
    ),
    o && !d && /* @__PURE__ */ e.jsx(
      Eg,
      {
        appName: n,
        envName: a,
        isLoading: l,
        handleClose: u,
        handleSwitchTraffic: _
      }
    )
  ] });
}, PG = ({ handleTemplateClick: t }) => {
  const { searchKey: s, handleSearch: n, clearFilters: a } = vs(), { isTemplateListLoading: r, templateList: o, templateListError: i, reloadTemplateList: l } = Eh({
    handleTemplateClick: t
  });
  return /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1 flexbox-col dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 pt-20 px-20", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space", children: [
        /* @__PURE__ */ e.jsx("h2", { className: "m-0 fs-15 lh-1-5 fw-6 cn-9", children: "Choose an application template" }),
        /* @__PURE__ */ e.jsx(
          j,
          {
            dataTestId: "create-app-modal-create-template-btn",
            component: Re.link,
            variant: w.text,
            text: "Create Template",
            linkProps: { to: se.APPLICATION_MANAGEMENT_TEMPLATES_DEVTRON_APP_CREATE, target: "_blank" },
            startIcon: /* @__PURE__ */ e.jsx(Xt, {})
          }
        )
      ] }),
      !i && !!o.length && /* @__PURE__ */ e.jsx(
        Wt,
        {
          dataTestId: "template-list-search",
          initialSearchText: s,
          size: O.medium,
          handleEnter: n,
          inputProps: {
            placeholder: "Search templates"
          }
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1 flexbox-col dc__gap-12 p-20 dc__overflow-auto", children: /* @__PURE__ */ e.jsx(
      Gd,
      {
        borderVariant: Vc.ROUNDED,
        list: o,
        searchKey: s,
        isLoading: r,
        error: i,
        reloadList: l,
        handleClearFilters: a,
        emptyStateConfig: {
          title: "Add your first app template",
          subTitle: va.FEATURE_DESCRIPTION
        }
      }
    ) })
  ] });
}, V0 = "Promote", Rn = {
  APPROVER_INFO_MESSAGE: "'Approver' role can be provided to users via",
  PERMISSIONS: "User Permissions.",
  NO_APPROVER_INFO_MESSAGE: "No users have 'Approver' permission for this application and environment. 'Approver' role can be provided to users via",
  APPROVER_GROUPS: {
    USER: "Users",
    TOKEN: "API Tokens"
  },
  getTotalApproversText: (t) => `${t} approver(s)`,
  getRequiredApproversText: (t) => `At least ${t} approval(s) are required.`
}, qd = "workflow/:workflowId/:useImageListType/:imageListTab", wG = ({ workflowId: t }) => {
  const s = Ss(), n = Kt(`${s.pathname}/${qd}`, {
    workflowId: t,
    imageListTab: Ae.REQUEST,
    useImageListType: ls.BULK_DEPLOY
  }), a = () => {
    ct.event({
      category: "devtron-apps-workflow",
      action: "deploy-to-button-clicked"
    });
  };
  return /* @__PURE__ */ e.jsx(
    wt,
    {
      to: n,
      onClick: a,
      className: "flexbox dc__gap-4 dc__align-items-start anchor",
      "data-testid": "bulk-deploy__link",
      children: /* @__PURE__ */ e.jsx("span", { className: "m-0 fs-13 fw-6 lh-20 flex", children: "Deploy to..." })
    }
  );
}, DG = ({
  pipelineIds: t,
  deploymentStrategy: s,
  setDeploymentStrategy: n,
  isBulkStrategyChange: a,
  possibleStrategyOptions: r,
  pipelineStrategiesLoading: o,
  pipelineStrategiesError: i,
  reloadPipelineStrategies: l
}) => {
  const [c, d, p, m] = ne(
    () => V_(t),
    [],
    !!a
  ), u = Q(() => {
    if (a) {
      const h = (d ?? []).flatMap(
        ({ strategies: x, error: g }) => g ? [] : x.map((E) => E.deploymentTemplate)
      );
      return [
        {
          label: "",
          options: [
            {
              label: Mn.DEFAULT,
              value: "DEFAULT",
              description: "Default strategy for selected deployments will be used",
              startIcon: /* @__PURE__ */ e.jsx(W, { name: El.DEFAULT, color: "N800" })
            }
          ]
        },
        {
          label: "",
          options: Array.from(new Set(h)).map(
            (x) => ({
              label: Mn[x] ?? x,
              value: x,
              startIcon: /* @__PURE__ */ e.jsx(
                W,
                {
                  name: El[x] ?? "ic-rocket-gear",
                  color: "N800"
                }
              )
            })
          )
        }
      ];
    }
    return [
      {
        label: "Deployment Strategy",
        options: (r ?? []).map(({ deploymentTemplate: h, default: x }) => ({
          label: `${Mn[h] ?? h} ${x ? " (Default)" : ""}`,
          value: h,
          startIcon: /* @__PURE__ */ e.jsx(
            W,
            {
              name: El[h] ?? "ic-rocket-gear",
              color: "N800"
            }
          )
        }))
      }
    ];
  }, [d, r]), f = (h) => {
    ct.event({
      category: "Deployment strategy selection",
      action: a ? "APP_GROUP_DEPLOY_CHANGED_DEPLOYMENT_STRATEGY" : "DA_DEPLOY_CHANGED_DEPLOYMENT_STRATEGY"
    }), n(h.value);
  };
  J(() => {
    if (!a && r?.length) {
      const h = r.find((x) => x.default)?.deploymentTemplate;
      h && n(h);
    }
  }, [r]);
  const _ = c || o;
  return /* @__PURE__ */ e.jsx(
    Ve,
    {
      inputId: "select-deployment-strategy",
      options: u,
      size: O.large,
      isLoading: _,
      isDisabled: _,
      placeholder: "Select strategy",
      optionListError: a ? p : i,
      reloadOptionList: a ? m : l,
      value: wc(u, s, null),
      onChange: f,
      menuSize: O.medium
    }
  );
}, MG = ({ isConfigured: t, isApprovalPendingForPromotion: s, workflowId: n }) => {
  const a = Ss();
  if (!t)
    return null;
  const r = Kt(`${a.pathname}/${qd}`, {
    workflowId: n,
    useImageListType: ls.IMAGE_PROMOTION,
    imageListTab: Ae.REQUEST
  });
  return /* @__PURE__ */ e.jsxs(wt, { to: r, className: "flexbox dc__gap-4 dc__align-items-start anchor", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-4", children: [
      /* @__PURE__ */ e.jsx(Zl, { className: "icon-dim-16 dc__no-shrink" }),
      /* @__PURE__ */ e.jsx("span", { className: "m-0 fs-13 fw-6 lh-20 flex", children: V0 })
    ] }),
    s && /* @__PURE__ */ e.jsx(r_, { rootClassName: "mt-4" })
  ] });
}, Y0 = ({
  environmentListResponse: t,
  shutterOptionTitle: s,
  handleEnvironmentChange: n
}) => {
  const { useImageListType: a, imageListTab: r } = Ue(), { environment: o } = _t({
    parseSearchParams: ma
  }), i = ZN(r, o, a), l = eT(
    t,
    r,
    s,
    a
  ), c = l.filter((d) => d.label).flatMap((d) => d.options).find((d) => d.value === o);
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__align-items-center", children: [
    i && /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-9 fs-13 fw-6 lh-20", children: i }),
    /* @__PURE__ */ e.jsx("div", { className: "w-200", children: /* @__PURE__ */ e.jsx(
      Ve,
      {
        inputId: "image-list-environment-selector",
        options: l,
        icon: /* @__PURE__ */ e.jsx(BN, {}),
        placeholder: qe.ENVIRONMENT_SELECTOR_PLACEHOLDER,
        value: c ?? l[0].options[0],
        onChange: n,
        size: O.medium
      }
    ) })
  ] });
}, H0 = ({ approverEmails: t }) => {
  const { users: s, apiTokens: n } = t.reduce(
    (o, i) => i.startsWith(Rc) ? (o.apiTokens.push(i.split(":")[1]), o) : {
      ...o,
      users: [...o.users, i]
    },
    { users: [], apiTokens: [] }
  ), a = () => /* @__PURE__ */ e.jsxs("div", { className: "fs-12 fw-4 bcv-1 cn-9 lh-20 pt-8 pb-8 pl-12 pr-12", children: [
    Rn.APPROVER_INFO_MESSAGE,
    " ",
    /* @__PURE__ */ e.jsx(wt, { to: Ee.AUTH_USERS, className: "fs-13 cb-5 lh-20 anchor", target: "_blank", rel: "noopener noreferrer", children: Rn.PERMISSIONS })
  ] }), r = (o, i) => /* @__PURE__ */ e.jsx("ol", { className: "pt-8 pl-12 pr-12 dc__list-style-none", children: o.sort((l, c) => Ce(l, c, Ut.ASC, !1)).map((l) => /* @__PURE__ */ e.jsxs("li", { className: "flex left mb-8 fs-13 fw-4 dc__ellipsis-right", children: [
    i ? /* @__PURE__ */ e.jsx($N, { className: "icon-dim-20 mr-8 dc__no-shrink" }) : sa(l, "dc__no-shrink"),
    l.approver ? l.approver : l
  ] }, l)) });
  return /* @__PURE__ */ e.jsx("div", { className: "h-100 dc__overflow-hidden dc__align-left ", children: /* @__PURE__ */ e.jsx("div", { className: "h-100 mxh-210 dc__overflow-auto", children: t.length > 0 ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    a(),
    s.length > 0 && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx("div", { className: "fs-13 fs-13 fw-6 cn-9 pt-12 pl-12", children: Rn.APPROVER_GROUPS.USER }),
      r(s)
    ] }),
    n.length > 0 && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-6 cn-9 mt-12 pl-12", children: Rn.APPROVER_GROUPS.TOKEN }),
      r(n, !0)
    ] })
  ] }) : /* @__PURE__ */ e.jsxs("div", { className: "fs-13 fw-4 cn-7 lh-20 pl-12 pr-12", children: [
    Rn.NO_APPROVER_INFO_MESSAGE,
    " ",
    /* @__PURE__ */ e.jsx(
      wt,
      {
        to: Ee.AUTH_USERS,
        className: "fs-13 cb-5 lh-20 anchor",
        target: "_blank",
        rel: "noopener noreferrer",
        children: Rn.PERMISSIONS
      }
    )
  ] }) }) });
}, K0 = ({ approverEmails: t = [], requiredApprovalCount: s }) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4 pb-12", children: [
  /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-9 fs-13 fw-4 lh-20", children: Rn.getRequiredApproversText(s) }),
  /* @__PURE__ */ e.jsx(
    Dt,
    {
      theme: Mt.white,
      className: "w-300 h-100",
      placement: "bottom",
      Icon: Xi,
      iconClass: "fcv-5",
      heading: Rn.getTotalApproversText(t.length),
      additionalContent: /* @__PURE__ */ e.jsx(H0, { approverEmails: t }),
      showCloseButton: !0,
      trigger: "click",
      interactive: !0,
      children: /* @__PURE__ */ e.jsx(
        "button",
        {
          type: "button",
          className: "p-0 dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus dc__underline cn-9 fs-13 fw-6 lh-20",
          "data-testid": "configured-approvers-info",
          children: Rn.getTotalApproversText(t.length)
        }
      )
    }
  )
] }), W0 = ({
  promotionRequestedBy: t,
  currentUserEmail: s,
  approvedUsersData: n,
  handleArtifactAction: a,
  artifactId: r,
  isLoading: o,
  promotionRequestId: i
}) => {
  const [l, c] = v(!1), d = () => {
    c(!0);
  }, p = () => {
    a({
      action: Ro.CANCEL,
      artifactId: r,
      promotionRequestId: i,
      successMessage: me.CANCEL_TOAST
    });
  }, m = () => {
    c(!1);
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "h-200 dc__overflow-auto flexbox-col p-12 dc__gap-12", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
      /* @__PURE__ */ e.jsx("h2", { className: "m-0 cn-9 fs-13 fw-6 lh-20", children: me.APPROVAL_REQUESTED_BY }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
          sa(t, "dc__no-shrink m-0-imp"),
          /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-20 m-0 ", children: t === s ? me.SELF_ACTION : t })
        ] }),
        !l && t === s && /* @__PURE__ */ e.jsx(
          "button",
          {
            type: "button",
            className: "p-0 cr-5 fs-13 fw-6 lh-20 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus dc__tab-focus",
            onClick: d,
            "data-testid": "open-cancel-approval-request-confirmation",
            children: me.CANCEL
          }
        )
      ] }),
      l && /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12", children: [
        /* @__PURE__ */ e.jsx("p", { className: "m-0 flexbox flex-grow-1 cn-9 fs-13 fw-4 lh-20", children: me.CANCEL_CONFIRMATION }),
        /* @__PURE__ */ e.jsx(
          "button",
          {
            type: "button",
            className: "cb-5 fs-13 fw-6 lh-20 dc__align-center dc__outline-none-imp dc__no-background dc__no-border dc__tab-focus",
            disabled: o,
            onClick: p,
            "data-testid": "confirm-cancel-approval-request",
            children: o ? /* @__PURE__ */ e.jsx(Je, {}) : me.YES
          }
        ),
        /* @__PURE__ */ e.jsx(
          "button",
          {
            type: "button",
            className: "cn-6 fs-13 fw-6 lh-20 dc__align-center dc__outline-none-imp dc__no-background dc__no-border dc__tab-focus",
            onClick: m,
            disabled: o,
            "data-testid": "cancel-approval-request",
            children: me.NO
          }
        )
      ] })
    ] }),
    n?.length > 0 ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
      /* @__PURE__ */ e.jsx("h2", { className: "m-0 cn-9 fs-13 fw-6 lh-20", children: me.APPROVED_BY }),
      /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-8", children: n.map((u) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__align-items-center", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__ellipsis-right", children: [
          sa(u.userEmail, "dc__no-shrink m-0-imp"),
          /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-20 m-0", children: u.userEmail === s ? me.SELF_ACTION : u.userEmail })
        ] }),
        /* @__PURE__ */ e.jsx(qs, { className: "icon-dim-16 scg-5 dc__no-shrink" })
      ] }, u.userEmail)) })
    ] }) : /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-20 cn-7", children: me.NO_APPROVAL })
  ] });
}, Oi = (t) => t?.reduce(
  (s, n) => (s[n.name] = n, s),
  {}
) ?? {}, Cg = async ({
  workflowId: t,
  artifactId: s,
  abortControllerRef: n
}) => {
  try {
    const {
      result: { ciSource: a, environments: r }
    } = await le(ye($.APP_ARTIFACT_PROMOTE_ENV_LIST, { workflowId: t, artifactId: s }), {
      abortControllerRef: n
    });
    return { ciSource: a, environments: Oi(r) };
  } catch (a) {
    throw Pe(a) || V(a), a;
  }
}, q0 = async ({
  workflowId: t,
  imagePromotionTab: s,
  appId: n,
  ciSource: a,
  environment: r,
  search: o,
  offset: i = ec,
  signal: l
}) => {
  try {
    const c = {
      ...dT({ imagePromotionTab: s, environment: r, ciSource: a }),
      appId: n,
      workflowId: t,
      pendingForCurrentUser: s === Ae.PENDING && !r,
      search: o,
      offset: i,
      size: kr
    }, d = await zr(
      Xr.IMAGE_PROMOTION,
      null,
      null,
      l,
      c
    ), p = d?.materials || [];
    return {
      ...d,
      materials: s === Ae.PENDING ? p.map((m) => ({
        ...m,
        isSelected: !1
      })) : p
    };
  } catch (c) {
    throw Pe(c) || V(c), c;
  }
}, z0 = async () => {
  try {
    const { result: t } = await Xc(), s = !!t?.is_default_configured, n = !!t?.isConfigured;
    return s || n;
  } catch (t) {
    throw V(t), t;
  }
}, bg = async ({
  environment: t,
  action: s,
  artifactId: n,
  appId: a,
  destinationObjectNames: r,
  ciSource: o,
  promotionRequestId: i,
  workflowId: l,
  imagePromotionTab: c
}) => {
  try {
    const d = {
      ...cT({ environment: t, ciSource: o, imagePromotionTab: c }),
      action: s,
      promotionRequestId: i,
      artifactId: n,
      appId: a,
      destinationObjectNames: r,
      workflowId: l
    }, { result: p } = await we($.APP_ARTIFACT_PROMOTE, d);
    return Oi(p);
  } catch (d) {
    throw V(d), d;
  }
}, X0 = async (t, s) => {
  try {
    const { result: n } = await le(
      ye($.APP_ARTIFACT_PROMOTE_ENV_APPROVAL_META_DATA, { artifactId: t, environmentName: s })
    );
    return n?.reduce((a, r) => (a[r.name] = r, a), {}) ?? {};
  } catch (n) {
    throw V(n), n;
  }
}, J0 = ({ title: t, subTitle: s, subtitleClassName: n }) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col pl-4", children: [
  /* @__PURE__ */ e.jsx("h4", { className: "m-0 cn-9 fs-13 fw-4 lh-20", children: t }),
  s && /* @__PURE__ */ e.jsx("p", { className: `m-0 cn-7 fs-12 fw-4 lh-18 dc__first-letter-capitalize ${n || ""}`, children: s })
] }), go = ({ isChecked: t, title: s, subTitle: n, isDisabled: a, onChange: r, subtitleClassName: o }) => /* @__PURE__ */ e.jsx("div", { className: "py-6 w-100", "data-testid": `${s}-check-container`, children: /* @__PURE__ */ e.jsx(
  $e,
  {
    name: s,
    onChange: r,
    isChecked: t,
    value: Fe.CHECKED,
    disabled: !!a,
    rootClassName: "m-0 w-100 dc__align-start",
    children: /* @__PURE__ */ e.jsx(J0, { title: s, subTitle: n, subtitleClassName: o })
  }
) }), Q0 = ({
  material: t,
  environmentName: s,
  handleArtifactAction: n,
  isLoadingAction: a
}) => {
  const [r, o, i, l] = ne(
    () => X0(+t.id, s),
    [t.id, t.isSelected],
    t.isSelected
  ), [c, d] = v({});
  J(() => {
    !r && o && d(aT(o));
  }, [r, o]);
  const p = (C) => {
    const { name: b } = C.target, N = { ...c };
    N[b] ? delete N[b] : N[b] = o[b], d(N);
  }, m = () => {
    const C = Object.keys(c);
    n({
      action: Ro.APPROVE,
      artifactId: +t.id,
      destinationObjectNames: C,
      promotionRequestId: t?.promotionApprovalMetadata?.approvalRequestId,
      successMessage: me.getApprovalSuccessMessage(C)
    });
  }, u = Object.keys(o || {}), f = Object.keys(c), _ = a || r, h = O_(_, f.length), x = (C) => /* @__PURE__ */ e.jsx(lt, { className: "default-tt", arrow: !1, content: h, children: /* @__PURE__ */ e.jsx("span", { children: C }) }), g = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col pl-16 pr-16 pt-20 dc__gap-16", children: [
    /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-200 h-16" }),
    /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-250 h-16" }),
    /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100px h-16" })
  ] }), E = (C) => !o[C].approvalAllowed && o[C].reason?.length > 0 ? o[C].reason[0] : null;
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__content-space h-100 mh-200 bg__primary", children: [
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1", children: /* @__PURE__ */ e.jsx(
      Ke,
      {
        isLoading: r,
        customLoader: g(),
        error: i,
        genericSectionErrorProps: {
          reload: l
        },
        children: /* @__PURE__ */ e.jsx("div", { className: "flexbox-col pt-12 pb-12 pl-16 pr-16 h-200 dc__overflow-auto", children: u?.map((C) => /* @__PURE__ */ e.jsx(
          go,
          {
            isChecked: !!c[C],
            isDisabled: !o[C].approvalAllowed || _,
            subTitle: E(C),
            title: C,
            onChange: p
          },
          C
        )) })
      }
    ) }),
    /* @__PURE__ */ e.jsx("div", { className: "dc__no-shrink flexbox dc__content-end dc__align-items-center pt-12 pb-12 pl-16 pr-16", children: /* @__PURE__ */ e.jsx(An, { condition: !!h, wrap: x, children: /* @__PURE__ */ e.jsx(
      "button",
      {
        type: "button",
        className: "h-32 cta flex success",
        disabled: !!h,
        onClick: m,
        "data-testid": "approve-promotion-request",
        children: _ ? /* @__PURE__ */ e.jsx(Je, {}) : me.APPROVE
      }
    ) }) })
  ] });
}, Z0 = ({ isLoadingAction: t, handleCancelApprovalRequest: s }) => /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__content-end pr-12 pb-12", children: /* @__PURE__ */ e.jsx(
  "button",
  {
    className: "cta flex h-32 delete",
    type: "button",
    disabled: t,
    onClick: s,
    "data-testid": "cancel-approval-request-text",
    children: t ? /* @__PURE__ */ e.jsx(Je, { fillColor: "var(--R500)" }) : me.CTA.CANCEL_REQUEST
  }
) }), am = ({
  material: t,
  environment: s,
  handleCurrentMaterialSelection: n,
  handleArtifactAction: a,
  isLoadingAction: r
}) => /* @__PURE__ */ e.jsx(
  Dt,
  {
    theme: Mt.white,
    className: "w-300 h-100 dc__align-left",
    iconClass: "fcv-5",
    heading: me.APPROVE_ARTIFACT_HEADING,
    placement: "bottom-end",
    additionalContent: (
      // Parsing empty string to null as environment is optional
      /* @__PURE__ */ e.jsx(
        Q0,
        {
          material: t,
          environmentName: s || null,
          handleArtifactAction: a,
          isLoadingAction: r
        }
      )
    ),
    showCloseButton: !0,
    trigger: "click",
    interactive: !0,
    children: /* @__PURE__ */ e.jsx(
      "button",
      {
        className: "p-0 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus dc__tab-focus",
        type: "button",
        onClick: n,
        "data-testid": "approve-artifact-button",
        children: me.CTA.APPROVE_FOR
      }
    )
  }
), rm = () => /* @__PURE__ */ e.jsx("span", { className: "cg-5 cursor-default", "data-testid": "approved-by-you", children: me.CTA.APPROVED_BY_YOU }), e1 = ({
  materialResponse: t,
  handleImageSelection: s,
  material: n,
  handleArtifactAction: a,
  isLoadingAction: r
}) => {
  const { useImageListType: o, imageListTab: i } = Ue(), { environment: l } = _t({
    parseSearchParams: ma
  }), { email: c } = yo(), { requestedUserId: d, imagePromotionApproverEmails: p } = t, m = i === Ae.PENDING && !l, u = p?.includes(c) || m, { promotionApprovalMetadata: f } = n, _ = f?.approvedUsersData?.some(
    (E) => E.userId === d
  ), h = f?.requestedUserData?.userId === d, x = () => {
    s(n.id);
  }, g = () => {
    a({
      action: Ro.CANCEL,
      artifactId: +n.id,
      promotionRequestId: f?.approvalRequestId,
      successMessage: me.CANCEL_TOAST
    });
  };
  return n.vulnerable && o === ls.IMAGE_PROMOTION ? /* @__PURE__ */ e.jsx(
    "span",
    {
      className: "material-history__scan-error",
      "data-testid": `cd-artifact-vulnerability-disabled-${n.id}`,
      children: me.CTA.SECURITY_ISSUES_FOUND
    }
  ) : i === Ae.REQUEST ? n.isSelected ? /* @__PURE__ */ e.jsx(W, { name: "ic-selected", color: "B500", size: 24 }) : /* @__PURE__ */ e.jsx(
    "button",
    {
      className: "p-0 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus dc__tab-focus",
      type: "button",
      onClick: x,
      "data-testid": `cd-artifact-select-${n.id}`,
      children: me.CTA.SELECT
    }
  ) : h ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12", children: [
    /* @__PURE__ */ e.jsx(
      Dt,
      {
        theme: Mt.white,
        className: "w-300 h-100 dc__align-left",
        placement: "auto",
        iconClass: "fcv-5",
        heading: me.CANCEL_REQUEST_OVERLAY.HEADING,
        infoText: me.CANCEL_REQUEST_OVERLAY.INFO_TEXT,
        additionalContent: /* @__PURE__ */ e.jsx(
          Z0,
          {
            isLoadingAction: r,
            handleCancelApprovalRequest: g
          }
        ),
        showCloseButton: !0,
        trigger: "click",
        interactive: !0,
        children: /* @__PURE__ */ e.jsxs(
          "button",
          {
            className: "p-0 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus dc__tab-focus cr-5",
            type: "button",
            "data-testid": "open-cancel-approval-request-confirmation",
            children: [
              /* @__PURE__ */ e.jsx(ua, { className: "icon-dim-16 fcr-5 scr-5 mr-4" }),
              me.CTA.CANCEL_REQUEST
            ]
          }
        )
      }
    ),
    u && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx("div", { className: "dc__border-right-n1" }),
      _ ? rm() : /* @__PURE__ */ e.jsx(
        am,
        {
          material: n,
          environment: l,
          handleCurrentMaterialSelection: x,
          handleArtifactAction: a,
          isLoadingAction: r
        }
      )
    ] })
  ] }) : _ ? rm() : u ? /* @__PURE__ */ e.jsx(
    am,
    {
      material: n,
      environment: l,
      handleCurrentMaterialSelection: x,
      handleArtifactAction: a,
      isLoadingAction: r
    }
  ) : /* @__PURE__ */ e.jsx("span", { className: "cn-5 cursor-default", "data-testid": "awaiting-approval", children: me.CTA.AWAITING_APPROVAL });
}, t1 = ({
  materialResponse: t,
  environmentId: s,
  getModuleInfo: n,
  isVirtualEnvironment: a,
  ciPipelineId: r,
  handleFetchMoreImages: o,
  isFetchingMoreImages: i,
  handleImageSelection: l,
  parentEnvironmentName: c,
  handleTabSwitch: d,
  ciSource: p,
  handleClearSearch: m,
  handleRefresh: u
}) => {
  const { searchKey: f, environment: _ } = _t({
    parseSearchParams: ma
  }), {
    appId: h,
    workflowId: x,
    useImageListType: g,
    imageListTab: E = Ae.REQUEST
  } = Ue(), { isSuperAdmin: C } = e_(), { email: b } = yo(), [N, I] = v(/* @__PURE__ */ new Map()), [T, A] = v(!1), [S, L] = v(!1), R = t?.materials ?? [], y = R.length < t?.totalCount, M = async () => {
    try {
      const { result: F } = await n(Xm.SECURITY);
      F?.status === KC.INSTALLED && A(!0);
    } catch (F) {
      V(F);
    }
  };
  J(() => {
    M();
  }, []);
  const P = async ({
    action: F,
    artifactId: q,
    destinationObjectNames: be,
    promotionRequestId: fe,
    successMessage: Ge
  }) => {
    try {
      L(!0), await bg({
        environment: _,
        action: F,
        artifactId: q,
        appId: +h,
        workflowId: +x,
        destinationObjectNames: be,
        ciSource: p,
        promotionRequestId: fe,
        imagePromotionTab: E
      }), u(), Z.showToast({
        variant: ee.success,
        description: Ge
      });
    } catch {
      Be();
    } finally {
      L(!1);
    }
  }, U = () => {
    d(Ae.REQUEST);
  }, G = (F) => {
    const q = new Map(N);
    q.set(F, !q.get(F)), I(q);
  }, H = (F) => ({
    isLatest: F.latest,
    isRunningOnParentCD: F.runningOnParentCd,
    artifactStatus: F.artifactStatus,
    environmentName: _ || null,
    parentEnvironmentName: c,
    stageType: WC.CD,
    showLatestTag: !1,
    isVirtualEnvironment: a,
    deployedOn: F.deployedOnEnvironments,
    targetPlatforms: F.targetPlatforms
  }), oe = (F) => ({
    ciPipelineId: r,
    artifactId: +F.id,
    imageComment: F.imageComment,
    imageReleaseTags: F.imageReleaseTags,
    appReleaseTagNames: t?.appReleaseTagNames,
    setAppReleaseTagNames: null,
    tagsEditable: t?.tagsEditable,
    setTagsEditable: null,
    toggleCardMode: G,
    hideHardDelete: t?.hideImageTaggingHardDelete,
    updateCurrentAppMaterial: null,
    isSuperAdmin: C,
    forceReInit: !0
  }), ae = (F) => {
    const { promotionApprovalMetadata: q } = F, be = `${q?.approvedUsersData?.length ?? 0}/${q?.policy?.approvalMetadata?.approverCount ?? 0} Approvals`;
    return _ ? /* @__PURE__ */ e.jsx(
      Dt,
      {
        theme: Mt.white,
        className: "w-300 h-100",
        placement: "top-start",
        Icon: lo,
        heading: be,
        additionalContent: /* @__PURE__ */ e.jsx(
          W0,
          {
            promotionRequestedBy: q?.requestedUserData?.userEmail,
            currentUserEmail: b,
            approvedUsersData: q?.approvedUsersData ?? [],
            handleArtifactAction: P,
            artifactId: +F.id,
            isLoading: S,
            promotionRequestId: q?.approvalRequestId
          }
        ),
        showCloseButton: !0,
        trigger: "click",
        interactive: !0,
        children: /* @__PURE__ */ e.jsxs(
          "button",
          {
            type: "button",
            className: "p-0 dc__gap-6 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus",
            "data-testid": "open-approval-checks-overlay",
            children: [
              /* @__PURE__ */ e.jsx(lo, { className: "icon-dim-16 scv-5 dc__no-shrink" }),
              /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-13 fw-4 lh-20", children: be })
            ]
          }
        )
      }
    ) : null;
  }, re = (F) => ({
    imagePath: F.imagePath,
    registryName: F.registryName,
    registryType: F.registryType,
    image: F.image,
    deployedTime: null,
    deployedBy: F.deployedBy,
    isRollbackTrigger: !1,
    excludedImagePathNode: null,
    approvalChecksNode: E === Ae.PENDING ? ae(F) : null
  }), k = () => /* @__PURE__ */ e.jsx(
    "button",
    {
      className: "cta secondary h-36 flex",
      type: "button",
      onClick: U,
      "data-testid": "view-other-requests",
      children: qe.VIEW_OTHER_REQUESTS
    }
  ), D = () => /* @__PURE__ */ e.jsx(
    "button",
    {
      className: "cta secondary h-36 flex",
      type: "button",
      onClick: m,
      "data-testid": "clear-filters",
      children: qe.CLEAR_FILTERS
    }
  );
  return R.length === 0 ? f ? /* @__PURE__ */ e.jsx(
    _e,
    {
      title: qe.EMPTY_STATES.NO_ARTIFACT_SEARCH.TITLE,
      subTitle: qe.EMPTY_STATES.NO_ARTIFACT_SEARCH.SUBTITLE,
      isButtonAvailable: !0,
      renderButton: D
    }
  ) : E === Ae.PENDING ? /* @__PURE__ */ e.jsx(
    _e,
    {
      title: _ ? qe.EMPTY_STATES[E].ENV.getTitle(_) : qe.EMPTY_STATES[E].SELF.TITLE,
      subTitle: _ ? qe.EMPTY_STATES[E].ENV.SUBTITLE : qe.EMPTY_STATES[E].SELF.SUBTITLE,
      image: S_,
      isButtonAvailable: !0,
      renderButton: k,
      contentClassName: "dc__align-center"
    }
  ) : /* @__PURE__ */ e.jsx(
    _e,
    {
      title: _ ? qe.EMPTY_STATES[E].ENV.getTitle(_) : qe.EMPTY_STATES[E].SOURCE.TITLE,
      subTitle: _ ? qe.EMPTY_STATES[E].ENV.getSubtitle(_, g) : qe.EMPTY_STATES[E].SOURCE.SUBTITLE,
      image: Ci,
      contentClassName: "dc__align-center"
    }
  ) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col pb-12", children: [
    E === Ae.PENDING && _ && /* @__PURE__ */ e.jsx(
      K0,
      {
        approverEmails: t.imagePromotionApproverEmails ?? [],
        requiredApprovalCount: R?.[0]?.promotionApprovalMetadata?.policy?.approvalMetadata?.approverCount ?? 1
      }
    ),
    R.map((F) => {
      const q = Jm(F.materialInfo), be = N.get(+F.id);
      return /* @__PURE__ */ e.jsx(
        Qm,
        {
          testIdLocator: String(F.index),
          cta: /* @__PURE__ */ e.jsx(
            e1,
            {
              materialResponse: t,
              handleImageSelection: l,
              material: F,
              handleArtifactAction: P,
              isLoadingAction: S
            },
            F.id
          ),
          sequentialCDCardTitleProps: H(F),
          artifactInfoProps: re(F),
          imageTagContainerProps: oe(F),
          children: F.materialInfo.length > 0 && !be && q && /* @__PURE__ */ e.jsx(
            Zm,
            {
              environmentId: s,
              isSecurityModuleInstalled: T,
              artifactId: +F.id,
              applicationId: +h,
              changesCard: /* @__PURE__ */ e.jsx(Yh, { materialInformationList: F.materialInfo }),
              isScanned: F.scanned,
              isScanEnabled: F.scanEnabled,
              SecurityModalSidebar: Wd
            }
          )
        },
        F.id
      );
    }),
    y && /* @__PURE__ */ e.jsx(Vh, { isLoading: i, handleFetchMoreData: o })
  ] });
}, Ng = ({
  loadingMaterials: t,
  materialsError: s,
  reloadMaterials: n,
  materialResponseState: a,
  setMaterialResponseState: r,
  getModuleInfo: o,
  isSearchActive: i,
  setIsSearchActive: l,
  environmentsError: c,
  loadingEnvironments: d,
  selectedWorkflow: p,
  environmentListResponse: m,
  reloadEnvironments: u,
  getMaterialsWrapper: f,
  handleRefresh: _,
  handleTabSwitch: h = Be,
  redeployActiveImagesConfig: x
}) => {
  const {
    searchKey: g,
    handleSearch: E,
    updateSearchParams: C,
    environment: b
  } = _t({
    parseSearchParams: ma
  }), { useImageListType: N, imageListTab: I = Ae.REQUEST } = Ue(), { isRedeployActiveImagesActive: T, setIsRedeployActiveImagesActive: A } = x ?? {}, [S, L] = v(!1);
  J(() => {
    g && !i && l(!0);
  }, [g]);
  const R = b ? !!m?.environments[b]?.isVirtualEnvironment : !1, y = sT(p, b), M = tT(I, p, m?.ciSource), P = (D) => {
    C(
      D.value === qe.ENVIRONMENT_SELECTOR_SHUTTER_VALUE[I] ? { environment: null } : { environment: D.value }
    );
  }, U = async () => {
    try {
      L(!0);
      const D = await f(a?.materials?.length);
      r({
        ...D,
        materials: [...a.materials, ...D.materials]
      });
    } catch (D) {
      V(D);
    } finally {
      L(!1);
    }
  }, G = () => {
    E("");
  }, H = () => {
    l(!0);
  }, oe = (D) => {
    const F = a?.materials.map((q) => q.id === D ? {
      ...q,
      isSelected: !0
    } : {
      ...q,
      isSelected: !1
    });
    r({
      ...a,
      materials: F
    });
  }, ae = () => t || Pe(s) ? /* @__PURE__ */ e.jsx(Su, { count: 4 }) : s ? /* @__PURE__ */ e.jsx(Xe, { code: s.code, reload: n }) : T ? /* @__PURE__ */ e.jsx(
    _e,
    {
      title: "Redeploy currently active image",
      subTitle: "Deploy the currently active image using the last saved configuration for the desired environments.",
      imageType: bs.Large,
      image: GN
    }
  ) : /* @__PURE__ */ e.jsx(
    t1,
    {
      materialResponse: a,
      parentEnvironmentName: y ? y.parentEnvironmentName : null,
      isVirtualEnvironment: R,
      ciPipelineId: m.ciSource?.id,
      getModuleInfo: o,
      handleFetchMoreImages: U,
      isFetchingMoreImages: S,
      handleImageSelection: oe,
      handleTabSwitch: h,
      ciSource: m.ciSource,
      handleClearSearch: G,
      handleRefresh: _
    }
  ), re = () => {
    A(!T);
  }, k = () => N === ls.IMAGE_PROMOTION && (!p || !p.artifactPromotionMetadata?.isConfigured) ? /* @__PURE__ */ e.jsx(
    _e,
    {
      title: qe.NOT_CONFIGURED_EMPTY_STATE.TITLE,
      subTitle: qe.NOT_CONFIGURED_EMPTY_STATE.SUB_TITLE
    }
  ) : d || Pe(c) ? /* @__PURE__ */ e.jsx(Su, { count: 4, areFiltersLoading: !0 }) : c ? /* @__PURE__ */ e.jsx(Xe, { code: c?.code, reload: u }) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col px-20 flex-grow-1", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__align-items-center dc__position-sticky dc__top-0 bg__tertiary dc__zi-1 py-12", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "dc__separated-flexbox h-32", children: [
        x && /* @__PURE__ */ e.jsx(
          $e,
          {
            value: Fe.CHECKED,
            isChecked: T,
            onChange: re,
            dataTestId: "bulk-trigger__redeploy-active-images",
            name: "redeploy-active-images",
            rootClassName: "m-0 dc__align-start",
            children: /* @__PURE__ */ e.jsx("h3", { className: "m-0 fs-13 lh-20 fw-6", children: "Redeploy active images" })
          }
        ),
        !T && /* @__PURE__ */ e.jsx(
          Y0,
          {
            environmentListResponse: m,
            shutterOptionTitle: M,
            handleEnvironmentChange: P
          }
        )
      ] }),
      !T && /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
        i ? /* @__PURE__ */ e.jsx(
          Wt,
          {
            initialSearchText: g ?? "",
            containerClassName: "dc__mxw-250 flex-grow-1",
            handleEnter: E,
            inputProps: {
              placeholder: qe.SEARCH_IMAGE_TAG_PLACEHOLDER,
              autoFocus: !0
            }
          }
        ) : /* @__PURE__ */ e.jsx(
          "button",
          {
            type: "button",
            className: "flex dc__align-center dc__outline-none-imp dc__no-background dc__no-border dc__tab-focus",
            onClick: H,
            "aria-label": qe.SHOW_SEARCH_BAR,
            "data-testid": "show-search-bar",
            children: /* @__PURE__ */ e.jsx(ad, { className: `icon-dim-18 ${i ? "" : "icon-color-n6"}` })
          }
        ),
        /* @__PURE__ */ e.jsx(
          "button",
          {
            className: "py-0 pl-0 pr-8 flex dc__outline-none-imp dc__no-background dc__no-border dc__tab-focus",
            onClick: _,
            type: "button",
            "aria-label": qe.REFRESH_LABEL,
            children: /* @__PURE__ */ e.jsx(A_, { className: "icon-dim-16 scn-6 cursor" })
          }
        )
      ] })
    ] }),
    ae()
  ] });
  return /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__overflow-auto flex-grow-1 image-list", children: k() });
}, s1 = (t, s) => t.reduce(
  (n, a) => {
    const r = a.feasibility.code === Nc.CanTrigger || a.feasibility.code === Nc.ExceptionUser, o = s.find(({ name: l }) => l === a.envName), i = {
      ...a,
      ...o,
      artifactId: a.artifactId ?? null,
      isSelected: !1
    };
    return r ? n.eligibleEnvironments.push(i) : n.inEligibleEnvironments.push(i), n;
  },
  { eligibleEnvironments: [], inEligibleEnvironments: [] }
), n1 = (t, s) => t ? t === s ? { value: Fe.CHECKED, isChecked: !0 } : { value: Fe.INTERMEDIATE, isChecked: !0 } : { value: Fe.CHECKED, isChecked: !1 }, om = (t, s) => {
  const n = s.toUpperCase();
  return t.filter((a) => a.name.toUpperCase().includes(n));
}, a1 = async ({
  environments: t,
  appId: s,
  artifactId: n,
  reDeployActiveImages: a,
  abortControllerRef: r
}) => {
  try {
    const { result: o } = await we(
      ye(Kt($.CD_PIPELINE_TRIGGER_FEASIBILITY, { appId: s }), {
        reDeployActiveImages: a
      }),
      t.map(({ pipelineId: i }) => ({
        ...n && !a ? { artifactId: n } : {},
        pipelineId: i
      })),
      { abortControllerRef: r }
    );
    return s1(o, t);
  } catch (o) {
    throw Pe(o) || V(o), o;
  }
}, r1 = async ({
  abortControllerRef: t,
  workflowId: s,
  environments: n
}) => {
  try {
    const {
      result: { ciSource: a, environments: r }
    } = await le(ye($.APP_ARTIFACT_PROMOTE_ENV_LIST, { workflowId: s }), {
      abortControllerRef: t
    }), o = Oi(n), i = r.filter((c) => !!o[c.name]).map((c) => ({ ...c, ...o[c.name] })), l = Oi(i);
    return { ciSource: a, environments: l };
  } catch (a) {
    throw Pe(a) || V(a), a;
  }
}, o1 = async ({
  pipelineId: t,
  signal: s,
  offset: n,
  search: a
}) => {
  try {
    const r = await zr(
      Xr.CD_MATERIALS,
      t,
      Sa.CD,
      s,
      {
        /**
         * NOTE: if an environment has a deployed image, then the any paginated request we make to the
         * genericCDMaterialsService, we will always get that actively deployed image. Therefore if the actively deployed image
         * is not contained in the pageSize, we will get that image as the (pageSize + 1)th image.
         *
         * Therefore the following check of offset > IMAGE_LIST_DEFAULT_SIZE
         */
        offset: n > kr ? n - 1 : n,
        search: a,
        size: kr
      }
    ), o = n > kr ? r.materials.filter((i) => !qC(i)) : r.materials;
    return {
      ...r,
      // NOTE: genericCDMaterialsService by default selects the first element
      // unless that image fails filter condition or has security vulnerability
      materials: o.map((i, l) => ({
        ...i,
        isSelected: n <= kr && l === 0
      }))
    };
  } catch (r) {
    throw Pe(r) || V(r), r;
  }
}, Tg = ({ environments: t = null }) => {
  const {
    appId: s,
    workflowId: n,
    imageListTab: a = Ae.REQUEST,
    useImageListType: r
  } = Ue(), { searchKey: o, environment: i } = _t({
    parseSearchParams: ma
  }), l = de(new AbortController()), c = de(new AbortController()), [d, p] = v(null), [m, u] = v(!1), [f, _, h, x] = ne(
    () => es(() => {
      switch (r) {
        case ls.IMAGE_PROMOTION:
          return Cg({
            workflowId: n,
            abortControllerRef: c
          });
        case ls.BULK_DEPLOY:
          return r1({
            workflowId: n,
            abortControllerRef: c,
            environments: t
          });
        default:
          return ka(`Invalid type ${r} found for use image list hook`), null;
      }
    }, c),
    [n]
  ), g = gm(
    (I) => es(() => r === ls.BULK_DEPLOY && i ? o1({
      pipelineId: _.environments[i].pipelineId,
      signal: l.current.signal,
      offset: I ?? ec,
      search: o
    }) : q0({
      workflowId: +n,
      imagePromotionTab: a,
      appId: +s,
      ciSource: _.ciSource,
      environment: i,
      search: o,
      offset: I ?? ec,
      signal: l.current.signal
    }), l),
    [a, n, s, o, i, _, r]
  ), [E, C, b, N] = ne(
    g,
    [n, a, s, _, i, o],
    !!_
  );
  return J(() => {
    !E && C && p(C);
  }, [E, C]), J(
    () => () => {
      l.current?.abort(), c.current?.abort();
    },
    []
  ), {
    loadingMaterials: E,
    materialsError: b,
    reloadMaterials: N,
    materialResponse: C,
    reloadEnvironments: x,
    environmentsError: h,
    loadingEnvironments: f,
    environmentListResponse: _,
    getMaterialsWrapper: g,
    materialResponseState: d,
    isSearchActive: m,
    setIsSearchActive: u,
    setMaterialResponseState: p
  };
}, i1 = ({
  handleDownload: t,
  ...s
}) => {
  const [n, a] = v(!1), [r, o] = v(!1), i = async (l) => {
    l?.stopPropagation(), o(!0), await dI({
      ...s,
      handleDownload: t
    }) || a(!0), o(!1);
  };
  return /* @__PURE__ */ e.jsx(
    j,
    {
      onClick: i,
      text: "Download",
      startIcon: r ? /* @__PURE__ */ e.jsx(Je, { size: 14 }) : /* @__PURE__ */ e.jsx(L_, {}),
      dataTestId: "download-manifest-virtual-env",
      disabled: r,
      variant: w.text,
      style: n ? B.neutral : B.default,
      size: O.xs
    }
  );
}, l1 = ({ title: t, handleClose: s }) => /* @__PURE__ */ e.jsxs("div", { className: "w-100 flexbox dc__align-items-center dc__content-space py-12 dc__border-bottom-n1 px-16", children: [
  /* @__PURE__ */ e.jsx("h2", { className: "cn-9 m-0 fs-14 fw-6 lh-20", children: t }),
  /* @__PURE__ */ e.jsx(
    j,
    {
      icon: /* @__PURE__ */ e.jsx(vt, {}),
      dataTestId: "rb-bulk-action__cross",
      component: Re.button,
      style: B.negativeGrey,
      size: O.xs,
      variant: w.borderLess,
      ariaLabel: `Close ${t} drawer`,
      onClick: s,
      showAriaLabelInTippy: !1
    }
  )
] }), c1 = ({
  handleCloseOverlay: t,
  selectedMaterial: s,
  environments: n,
  setTriggerCallbacks: a,
  isRedeployActiveImagesActive: r
}) => {
  const { appId: o } = Ue(), { handleDownload: i } = o_(), l = de(new AbortController()), [c, d, p, m, u] = ne(
    () => a1({
      environments: n,
      appId: +o,
      abortControllerRef: l,
      artifactId: r ? null : +s.id,
      reDeployActiveImages: r
    })
  );
  J(
    () => () => {
      l.current.abort();
    },
    []
  );
  const { searchKey: f, handleSearch: _ } = vs(), { eligibleEnvironments: h, inEligibleEnvironments: x } = Q(() => !f || !d ? d ?? { inEligibleEnvironments: [], eligibleEnvironments: [] } : {
    eligibleEnvironments: om(
      d.eligibleEnvironments,
      f
    ),
    inEligibleEnvironments: om(
      d.inEligibleEnvironments,
      f
    )
  }, [f, d]), g = h.reduce((L, R) => L + (R.isSelected ? 1 : 0), 0), E = !g, { isChecked: C, value: b } = n1(g, h.length), N = () => {
    _("");
  }, I = (L) => {
    const { name: R } = L.target;
    u((y) => ({
      ...y,
      eligibleEnvironments: y.eligibleEnvironments.map(
        (M) => M.name === R ? { ...M, isSelected: !M.isSelected } : M
      )
    }));
  }, T = () => {
    const L = b !== Fe.CHECKED || !C;
    u((R) => ({
      ...R,
      eligibleEnvironments: R.eligibleEnvironments.map((y) => ({
        ...y,
        isSelected: L
      }))
    }));
  }, A = () => {
    ct.event({
      category: "devtron-apps-workflow",
      action: "bulk-deploy-button-clicked"
    }), a(
      h.filter((L) => L.isSelected).map(({ name: L, pipelineId: R, envId: y, isVirtualEnvironment: M, artifactId: P }) => ({
        name: L,
        operation: async (U) => {
          const {
            result: { helmPackageName: G }
          } = await zC({
            pipelineId: R,
            appId: Number(o),
            ciArtifactId: P,
            stageType: Sa.CD,
            abortControllerRef: U,
            skipIfHibernated: !1
          });
          return M ? {
            appId: Number(o),
            envId: y,
            handleDownload: i,
            helmPackageName: G,
            cdWorkflowType: Sa.CD,
            showSuccessfulToast: !1
          } : null;
        },
        ...M ? {
          renderContentAtResultRowEnd: (U) => /* @__PURE__ */ e.jsx(
            i1,
            {
              ...U
            }
          )
        } : {}
      }))
    );
  }, S = () => c || Pe(p) ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col px-16 pt-8 dc__gap-16", children: [
    /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-200 h-16" }),
    /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-250 h-16" }),
    /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100px h-16" })
  ] }) : p ? /* @__PURE__ */ e.jsx(ps, { rootClassName: "flex-grow-1", reload: m }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: "w-100 flex px-16", children: /* @__PURE__ */ e.jsx(
      Wt,
      {
        containerClassName: "w-100 flex-grow-1",
        handleEnter: _,
        inputProps: {
          placeholder: me.SEARCH_ENVIRONMENT_PLACEHOLDER,
          autoFocus: !0
        },
        initialSearchText: f
      }
    ) }),
    f && x.length === 0 && h.length === 0 ? /* @__PURE__ */ e.jsx(
      ps,
      {
        title: me.REQUEST_PROMOTION_EMPTY_SEARCH.TITLE,
        subTitle: me.REQUEST_PROMOTION_EMPTY_SEARCH.SUB_TITLE,
        description: "",
        buttonText: me.REQUEST_PROMOTION_EMPTY_SEARCH.BUTTON_TEXT,
        reload: N,
        rootClassName: "flex-grow-1",
        useInfoIcon: !0
      }
    ) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col px-16 h-100 dc__overflow-auto", children: [
      !!h.length && /* @__PURE__ */ e.jsx("div", { className: "dc__position-sticky dc__left-0 dc__top-0 bg__primary dc__zi-1 py-6 w-100", children: /* @__PURE__ */ e.jsx(
        $e,
        {
          name: "select-all-eligible-environments",
          onChange: T,
          isChecked: C,
          value: b,
          rootClassName: "m-0 w-100 dc__align-start",
          children: /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-13 fw-6 lh-20 pl-4", children: "Select all eligible environments" })
        }
      ) }),
      h.map((L) => /* @__PURE__ */ e.jsx(
        go,
        {
          isChecked: !!L.isSelected,
          title: L.name,
          onChange: I,
          subTitle: L.feasibility.userMessage ?? "",
          subtitleClassName: "cy-7"
        },
        L.name
      )),
      !!(h.length && x.length) && /* @__PURE__ */ e.jsx("div", { className: "flex py-12", children: /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom-n1 w-100" }) }),
      x.length > 0 && /* @__PURE__ */ e.jsxs("div", { className: "flex column w-100", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 w-100 dc__align-items-center pb-8", children: [
          /* @__PURE__ */ e.jsx("div", { className: "flex p-2", children: /* @__PURE__ */ e.jsx(y_, { className: "fcr-5" }) }),
          /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-13 fw-6 lh-20", children: "Cannot deploy to environments" })
        ] }),
        x.map((L) => /* @__PURE__ */ e.jsx(
          go,
          {
            isChecked: L.isSelected,
            title: L.name,
            subTitle: L.feasibility.userMessage,
            subtitleClassName: "cr-5",
            isDisabled: !0,
            onChange: Be
          },
          L.name
        ))
      ] })
    ] })
  ] });
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "dc__position-abs flexbox-col dc__content-space w-400 h-365 bg__primary dc__bottom-16 dc__right-20 br-4 dc__border dc__box-shadow--overlay dc__zi-2",
      onClick: Le,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "w-100 h-100 flexbox-col dc__overflow-auto dc__gap-12", children: [
          /* @__PURE__ */ e.jsx(l1, { title: "Select environments", handleClose: t }),
          S()
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "py-12 px-16 flex dc__content-space dc__gap-12 dc__border-top-n1", children: [
          /* @__PURE__ */ e.jsx("div", { className: "flex dc__gap-8", children: g ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx(Or, { className: "dc__no-shrink icon-dim-20" }),
            /* @__PURE__ */ e.jsxs("span", { children: [
              "Trigger ",
              g,
              " deployment(s)"
            ] })
          ] }) : null }),
          /* @__PURE__ */ e.jsx(
            j,
            {
              startIcon: /* @__PURE__ */ e.jsx(dd, {}),
              text: "Deploy",
              variant: w.primary,
              size: O.medium,
              disabled: E,
              showTooltip: E,
              tooltipProps: { content: "Please select at least one environment" },
              dataTestId: "bulk-trigger__deploy",
              onClick: A
            }
          )
        ] })
      ]
    }
  );
}, d1 = ({ workflows: t, baseURL: s, getModuleInfo: n, appName: a, reloadWorkflowStatus: r }) => {
  const { push: o } = Te(), { workflowId: i } = Ue(), { environment: l, updateSearchParams: c } = _t({
    parseSearchParams: ma
  }), { searchKey: d } = _t(), { environments: p, selectedWorkflow: m } = Q(() => {
    const q = t.find((be) => be.id === i);
    return {
      selectedWorkflow: q,
      environments: q.nodes.reduce((be, fe) => (fe.type !== "CD" || be.push({
        envId: Number(fe.environmentId),
        pipelineId: Number(fe.id),
        name: fe.environmentName,
        isVirtualEnvironment: fe.isVirtualEnvironment ?? !1
      }), be), [])
    };
  }, [i]);
  J(() => {
    p && p.every(({ name: q }) => q !== l) && c({ environment: null });
  }, [l, p]);
  const {
    loadingMaterials: u,
    materialsError: f,
    reloadMaterials: _,
    reloadEnvironments: h,
    environmentsError: x,
    loadingEnvironments: g,
    environmentListResponse: E,
    getMaterialsWrapper: C,
    isSearchActive: b,
    setIsSearchActive: N,
    materialResponseState: I,
    setMaterialResponseState: T
  } = Tg({ environments: p }), A = (I?.materials ?? []).find((q) => q.isSelected), [S, L] = v(!1), [R, y] = v(null), [M, P] = v(!1), U = !A && !M, G = () => {
    o(s);
  }, H = () => {
    h(), d || N(!1);
  }, oe = (q) => {
    q.stopPropagation(), L(!0);
  }, ae = () => {
    L(!1);
  }, re = (q) => {
    q.stopPropagation(), L(!1);
  }, k = (q) => q.Pending || q.Progressing ? /* @__PURE__ */ e.jsx("span", { className: "dc__loading-dots", children: "Deploying" }) : `Image deployed on ${q.Completed} environment(s)`, D = `Deploy '${a}'`, F = S && (A || M);
  return R ? /* @__PURE__ */ e.jsx(
    So,
    {
      operations: R,
      handleReloadDataAfterBulkOperation: r,
      handleModalClose: G,
      getResultsChartSummaryText: k,
      textConfig: { prompt: Nn, resultsHeader: `Deploy '${a}'` },
      shouldSkipConfirmation: !0,
      disableTransition: !0
    }
  ) : /* @__PURE__ */ e.jsx($t, { onClose: G, width: "1024px", onEscape: G, position: "right", children: /* @__PURE__ */ e.jsxs("div", { className: "bg__primary flexbox-col dc__content-space h-100", onClick: re, children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 w-100 bg__tertiary dc__overflow-auto", children: [
      /* @__PURE__ */ e.jsxs("header", { className: "px-20 py-12 lh-24 flexbox dc__content-space dc__align-items-center dc__border-bottom bg__primary", children: [
        /* @__PURE__ */ e.jsx("span", { className: "fs-16 fw-6 dc__first-letter-capitalize", children: D.toLocaleLowerCase() }),
        /* @__PURE__ */ e.jsx(
          j,
          {
            icon: /* @__PURE__ */ e.jsx(As, {}),
            dataTestId: "rb-bulk-action__cross",
            component: Re.button,
            style: B.negativeGrey,
            variant: w.borderLess,
            size: O.xs,
            ariaLabel: `Close ${D} drawer`,
            onClick: G,
            showAriaLabelInTippy: !1
          }
        )
      ] }),
      /* @__PURE__ */ e.jsx(
        Ng,
        {
          loadingMaterials: u,
          materialsError: f,
          reloadMaterials: _,
          materialResponseState: I,
          setMaterialResponseState: T,
          getModuleInfo: n,
          isSearchActive: b,
          setIsSearchActive: N,
          reloadEnvironments: h,
          environmentsError: x,
          loadingEnvironments: g,
          environmentListResponse: E,
          selectedWorkflow: m,
          getMaterialsWrapper: C,
          handleRefresh: H,
          type: ls.BULK_DEPLOY,
          redeployActiveImagesConfig: {
            isRedeployActiveImagesActive: M,
            setIsRedeployActiveImagesActive: P
          }
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: `px-20 pt-15 pb-16 flexbox w-100 ${F ? "dc__content-start" : "dc__content-space"} dc__align-items-center dc__no-shrink dc__border-top h-68 bg__primary`,
        children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-8", children: [
            /* @__PURE__ */ e.jsx(qi, { className: "dc__no-shrink icon-dim-20" }),
            /* @__PURE__ */ e.jsx("h3", { className: "fs-13 fw-6 lh-20 cn-9 m-0", children: "Select environments to deploy image" })
          ] }),
          F ? /* @__PURE__ */ e.jsx(
            c1,
            {
              environments: p,
              handleCloseOverlay: ae,
              setTriggerCallbacks: y,
              selectedMaterial: A,
              isRedeployActiveImagesActive: M
            }
          ) : /* @__PURE__ */ e.jsx(
            j,
            {
              variant: w.primary,
              onClick: oe,
              disabled: U,
              isLoading: g,
              dataTestId: "open-bulk-trigger-overlay",
              size: O.large,
              text: "Select environments...",
              showTooltip: U,
              tooltipProps: { content: "Please select a material to deploy" }
            }
          )
        ]
      }
    )
  ] }) });
}, Bl = {
  INFO_TEXT: "Hotfix Deployment Policy enables direct deployments to specific environments (eg. production), bypassing intermediate environments (eg. staging).",
  HEADING: "Promote image",
  ARIA_LABEL: "Image Promotion Info"
}, p1 = () => /* @__PURE__ */ e.jsx(
  Dt,
  {
    theme: Mt.white,
    className: "w-300 h-100 dc__align-left",
    placement: "auto",
    Icon: cd,
    iconClass: "fcv-5",
    infoText: Bl.INFO_TEXT,
    heading: Bl.HEADING,
    documentationLink: "IMAGE_PROMOTION",
    showCloseButton: !0,
    trigger: "click",
    interactive: !0,
    openInNewTab: !0,
    children: /* @__PURE__ */ e.jsx(
      "button",
      {
        className: "p-0 h-20 dc__no-background dc__no-border dc__outline-none-imp",
        type: "button",
        "aria-label": Bl.ARIA_LABEL,
        children: /* @__PURE__ */ e.jsx(Ya, { className: "icon-dim-20" })
      }
    )
  }
), u1 = ({
  activeTab: t,
  currentTab: s,
  isApprovalPendingForPromotion: n,
  handleTabSwitch: a
}) => {
  const r = t === s, o = () => {
    r || a(s);
  };
  return /* @__PURE__ */ e.jsxs(
    "button",
    {
      className: `mr-16 dc__tab-focus pr-0 pl-0 pt-0 flexbox dc__gap-4 dc__no-border dc__no-background h-100 mb-neg-1 pb-6 ${r ? "cb-5 fs-13 fw-6 dc__border-bottom-2--b5" : "cn-9 fs-13 fw-4 dc__hover-color-b500"}`,
      onClick: o,
      type: "button",
      "data-testid": `image-promotion-tab-${s}`,
      children: [
        me.TABS_TEXT[s],
        n && s === Ae.PENDING && /* @__PURE__ */ e.jsx(r_, { rootClassName: "mt-4" })
      ]
    }
  );
}, m1 = ({
  activeTab: t,
  isApprovalPendingForPromotion: s,
  handleTabSwitch: n
}) => {
  const a = Object.values(Ae);
  return /* @__PURE__ */ e.jsx("div", { className: "w-100 flexbox dc__border-bottom pl-20 pr-20", children: a.map((r) => /* @__PURE__ */ e.jsx(
    u1,
    {
      activeTab: t,
      currentTab: r,
      isApprovalPendingForPromotion: s,
      handleTabSwitch: n
    },
    r
  )) });
}, _1 = ({ isNotificationConfigured: t }) => {
  const { imageListTab: s } = Ue();
  if (s === Ae.PENDING)
    return t && /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__gap-8 dc__ellipsis-right", children: me.NOTIFICATION_INFO.SUCCESS_TEXT });
  const n = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
    /* @__PURE__ */ e.jsx("h2", { className: "m-0 text__white fs-12 fw-6 lh-18", children: me.NOTIFICATION_INFO.NOT_CONFIGURED.TOOLTIP_HEADING }),
    /* @__PURE__ */ e.jsx("p", { className: "m-0 text__white fs-12 fw-4 lh-18", children: me.NOTIFICATION_INFO.NOT_CONFIGURED.TOOLTIP_CONTENT })
  ] }), a = () => t ? /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-9 fs-13 fw-4 lh-20 dc__ellipsis-right", children: me.NOTIFICATION_INFO.CONFIGURED.TEXT }) : /* @__PURE__ */ e.jsx(
    lt,
    {
      className: "default-tt w-200",
      content: n(),
      arrow: !1,
      placement: "left",
      children: /* @__PURE__ */ e.jsxs("p", { className: "m-0 cn-9 fs-13 fw-4 lh-20 dc__ellipsis-right", children: [
        /* @__PURE__ */ e.jsx(wt, { to: Ee.NOTIFIER_CONFIG, className: "m-0 anchor", target: "_blank", rel: "noopener noreferrer", children: me.NOTIFICATION_INFO.NOT_CONFIGURED.LINK_TEXT }),
        " ",
        me.NOTIFICATION_INFO.NOT_CONFIGURED.TEXT
      ] })
    }
  );
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__ellipsis-right", children: [
    /* @__PURE__ */ e.jsx(Or, { className: "icon-dim-20 dc__no-shrink" }),
    a()
  ] });
}, f1 = ({ title: t, handleClose: s }) => /* @__PURE__ */ e.jsxs("div", { className: "w-100 flexbox dc__align-items-center dc__content-space pt-12 pb-12 dc__border-bottom-n1 pl-16 pr-16", children: [
  /* @__PURE__ */ e.jsx("h2", { className: "cn-9 m-0 fs-14 fw-6 lh-20", children: t }),
  /* @__PURE__ */ e.jsx(
    "button",
    {
      type: "button",
      className: "p-0 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus",
      "aria-label": me.CLOSE_IMAGE_PROMOTION_OVERLAY,
      onClick: s,
      "data-testid": "close-request-promotion-overlay",
      children: /* @__PURE__ */ e.jsx(vt, { className: "icon-dim-20 fcn-6" })
    }
  )
] }), h1 = ({ name: t, status: s, message: n }) => {
  const a = rT(s);
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12 pt-6 pb-6", children: [
    /* @__PURE__ */ e.jsx("span", { className: "m-0 cn-9 dc__ellipsis-right fs-13 fw-4 lh-20 flex-grow-1 dc__mxw-178", children: t }),
    /* @__PURE__ */ e.jsxs("div", { className: "dc__gap-6 flexbox flex-grow-1 dc__mxw-178 dc__align-start", children: [
      a,
      /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-9 fs-13 fw-4 lh-20 dc__first-letter-capitalize", children: n })
    ] })
  ] });
}, g1 = ({
  handleClose: t,
  selectedMaterial: s,
  loadingIsNotificationConfigured: n,
  isNotificationConfigured: a,
  handleRefresh: r
}) => {
  const { appId: o, workflowId: i, imageListTab: l } = Ue(), c = de(new AbortController()), { environment: d } = _t({
    parseSearchParams: ma
  }), [p, m, u, f] = ne(
    () => Cg({
      workflowId: i,
      artifactId: s.id,
      abortControllerRef: c
    })
  ), [_, h] = v(!1), [x, g] = v(!1), [E, C] = v({}), [b, N] = v({}), [I, T] = v("");
  J(() => {
    !p && m && (C(nT(m.environments ?? {})), N(m.environments ?? {}));
  }, [p, m]);
  const A = (D) => {
    const F = D.toLowerCase(), fe = Object.keys(m?.environments ?? {}).filter(
      (Ge) => Ge.toLowerCase().includes(F)
    ).reduce(
      (Ge, xe) => (Ge[xe] = m?.environments?.[xe], Ge),
      {}
    );
    N(fe), T(D);
  }, S = () => {
    A("");
  }, L = (D) => {
    const { name: F } = D.target, q = { ...E };
    q[F] ? delete q[F] : q[F] = b[F], C(q);
  }, R = async () => {
    try {
      h(!0);
      const D = await bg({
        environment: d,
        action: Ro.PROMOTE,
        artifactId: +s.id,
        appId: +o,
        destinationObjectNames: Object.keys(E),
        ciSource: m?.ciSource,
        workflowId: +i,
        imagePromotionTab: l
      });
      g(!0), C(D), r();
    } catch {
      Be();
    } finally {
      h(!1);
    }
  }, y = Object.keys(E), M = Object.keys(b), { eligibleEnvironmentsNames: P, inEligibleEnvironmentsNames: U } = lT(
    b,
    M
  ), G = !n && y.length > 0, H = O_(
    _,
    y.length
  ), oe = x ? me.REQUEST_PROMOTION_HEADINGS.RESPONSE : me.REQUEST_PROMOTION_HEADINGS.REQUEST, ae = () => p || Pe(u) ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col pl-16 pr-16 pt-8 dc__gap-16", children: [
    /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-200 h-16" }),
    /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-250 h-16" }),
    /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100px h-16" })
  ] }) : u ? /* @__PURE__ */ e.jsx(ps, { reload: f }) : x ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: "pt-8 pb-8 pl-16 pr-16 flexbox dc__gap-12", children: me.IMAGE_PROMOTION_OVERLAY_RESPONSE_HEADINGS.map((D) => /* @__PURE__ */ e.jsx("h3", { className: "m-0 flexbox flex-grow-1 dc__mxw-178 cn-7 fs-12 fw-6 lh-18", children: D }, D)) }),
    /* @__PURE__ */ e.jsx("div", { className: "pl-16 pr-16 pb-12 flexbox-col dc__overflow-auto", children: y.map((D) => /* @__PURE__ */ e.jsx(
      h1,
      {
        name: D,
        status: E[D].promotionValidationState,
        message: E[D].promotionValidationMessage
      },
      D
    )) })
  ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: "w-100 flex pl-16 pr-16", children: /* @__PURE__ */ e.jsx(
      Wt,
      {
        containerClassName: "w-100 flex-grow-1",
        handleEnter: A,
        inputProps: {
          placeholder: me.SEARCH_ENVIRONMENT_PLACEHOLDER,
          autoFocus: !0
        },
        initialSearchText: I
      }
    ) }),
    I && M.length === 0 ? /* @__PURE__ */ e.jsx(
      ps,
      {
        title: me.REQUEST_PROMOTION_EMPTY_SEARCH.TITLE,
        subTitle: me.REQUEST_PROMOTION_EMPTY_SEARCH.SUB_TITLE,
        description: "",
        buttonText: me.REQUEST_PROMOTION_EMPTY_SEARCH.BUTTON_TEXT,
        reload: S,
        rootClassName: "flex-grow-1",
        useInfoIcon: !0
      }
    ) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col pl-16 pr-16 h-100 dc__overflow-auto", children: [
      P.map((D) => /* @__PURE__ */ e.jsx(
        go,
        {
          isChecked: !!E[D],
          title: D,
          subTitle: b[D].promotionValidationMessage,
          isDisabled: !b[D].promotionPossible || _,
          onChange: L
        },
        D
      )),
      U.length > 0 && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx("div", { className: "flex pt-12 pb-12", children: /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom-n1 w-100" }) }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex column w-100", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 w-100 dc__align-items-center pb-8", children: [
            /* @__PURE__ */ e.jsx("div", { className: "flex p-2", children: /* @__PURE__ */ e.jsx(y_, { className: "fcr-5" }) }),
            /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-13 fw-6 lh-20", children: me.PROHIBITED_ENVIRONMENT_LIST_HEADING })
          ] }),
          U.map((D) => /* @__PURE__ */ e.jsx(
            go,
            {
              isChecked: !!E[D],
              title: D,
              subTitle: b[D].promotionValidationMessage,
              subtitleClassName: "cr-5",
              isDisabled: !b[D].promotionPossible || _,
              onChange: Be
            },
            D
          ))
        ] })
      ] })
    ] })
  ] }), re = (D) => /* @__PURE__ */ e.jsx(lt, { className: "default-tt", arrow: !1, content: H, children: /* @__PURE__ */ e.jsx("span", { children: D }) }), k = () => x ? /* @__PURE__ */ e.jsx(
    "button",
    {
      type: "button",
      className: "flex h-36 cta dc__no-shrink",
      onClick: t,
      "data-testid": "close-request-promotion-modal",
      children: me.REQUEST_PROMOTION_CTA.RESPONSE
    }
  ) : /* @__PURE__ */ e.jsx(
    An,
    {
      condition: !!H,
      wrap: re,
      children: /* @__PURE__ */ e.jsx(
        "button",
        {
          type: "button",
          className: "flex h-36 cta dc__no-shrink",
          onClick: R,
          disabled: !!H,
          "data-testid": "request-promotion-cta",
          children: _ ? /* @__PURE__ */ e.jsx(Je, {}) : me.REQUEST_PROMOTION_CTA.REQUEST
        }
      )
    }
  );
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "dc__position-abs flexbox-col dc__content-space w-400 h-365 bg__primary dc__bottom-16 br-4 dc__border dc__box-shadow--overlay dc__zi-2",
      onClick: Le,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: `w-100 h-100 flexbox-col dc__overflow-auto ${x ? "" : "dc__gap-12"}`, children: [
          /* @__PURE__ */ e.jsx(f1, { title: oe, handleClose: t }),
          ae()
        ] }),
        /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: `pt-12 pb-12 pl-16 pr-16 flex ${G ? "dc__content-space" : "dc__content-end"} dc__gap-12 dc__border-top-n1`,
            children: [
              G && /* @__PURE__ */ e.jsx(_1, { isNotificationConfigured: a }),
              k()
            ]
          }
        )
      ]
    }
  );
}, x1 = ({ workflows: t, baseURL: s, getModuleInfo: n }) => {
  const a = Te(), { workflowId: r, imageListTab: o } = Ue(), { searchKey: i, clearFilters: l } = _t({
    parseSearchParams: ma
  }), [c, d, , p] = ne(z0), [m, u] = v(!1), {
    loadingMaterials: f,
    materialsError: _,
    reloadMaterials: h,
    materialResponse: x,
    reloadEnvironments: g,
    environmentsError: E,
    loadingEnvironments: C,
    environmentListResponse: b,
    getMaterialsWrapper: N,
    isSearchActive: I,
    setIsSearchActive: T,
    materialResponseState: A,
    setMaterialResponseState: S
  } = Tg({}), L = () => {
    a.push(s);
  }, R = (k) => {
    l(), T(!1), a.push({
      pathname: a.location.pathname.replace(o, k)
    });
  }, y = (k) => {
    k.stopPropagation(), u(!0);
  }, M = () => {
    u(!1);
  }, P = (k) => {
    k.stopPropagation(), u(!1);
  }, U = () => {
    g(), p(), i || T(!1);
  }, G = t.find((k) => k.id === r), H = (A?.materials ?? []).find((k) => k.isSelected), oe = A?.isApprovalPendingForPromotion ?? !!G?.artifactPromotionMetadata?.isApprovalPendingForPromotion, ae = iT(C, !!H), re = (k) => /* @__PURE__ */ e.jsx(lt, { className: "default-tt", arrow: !1, content: ae, children: /* @__PURE__ */ e.jsx("span", { children: k }) });
  return /* @__PURE__ */ e.jsx(cs, { className: "", close: L, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "bg__primary dc__position-fixed dc__right-0 dc__top-0 h-100 flexbox-col dc__content-space w-1024",
      onClick: P,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 w-100 bg__tertiary dc__overflow-auto", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col w-100 dc__no-shrink bg__primary", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__align-items-center pt-12 pb-12 pl-20 pr-20", children: [
              /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8", children: [
                /* @__PURE__ */ e.jsx("h2", { className: "m-0 cn-9 fs-16 fw-6 lh-24", children: `${me.HEADER} '${G?.name ?? ""}'` }),
                /* @__PURE__ */ e.jsx(p1, {})
              ] }),
              /* @__PURE__ */ e.jsx(
                "button",
                {
                  type: "button",
                  className: "p-0 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus h-20 w-20 dc__tab-focus",
                  onClick: L,
                  "aria-label": me.CLOSE_MODAL_LABEL,
                  "data-testid": "close-image-promotion-modal",
                  children: /* @__PURE__ */ e.jsx(vt, { className: "icon-dim-20 fcn-6" })
                }
              )
            ] }),
            /* @__PURE__ */ e.jsx(
              m1,
              {
                activeTab: o,
                isApprovalPendingForPromotion: oe,
                handleTabSwitch: R
              }
            )
          ] }),
          /* @__PURE__ */ e.jsx(
            Ng,
            {
              type: ls.IMAGE_PROMOTION,
              loadingMaterials: f,
              materialsError: _,
              reloadMaterials: h,
              materialResponse: x,
              materialResponseState: A,
              setMaterialResponseState: S,
              getModuleInfo: n,
              isSearchActive: I,
              setIsSearchActive: T,
              reloadIsNotificationConfigured: p,
              reloadEnvironments: g,
              environmentsError: E,
              loadingEnvironments: C,
              environmentListResponse: b,
              handleTabSwitch: R,
              selectedWorkflow: G,
              imagePromotionTab: o,
              getMaterialsWrapper: N,
              handleRefresh: U
            }
          )
        ] }),
        o === Ae.REQUEST && !_ && /* @__PURE__ */ e.jsx("div", { className: "px-20 pt-15 pb-16 flexbox w-100 dc__content-end dc__align-items-center dc__no-shrink dc__border-top h-68 bg__primary", children: !m || !H ? /* @__PURE__ */ e.jsx(
          An,
          {
            condition: !!ae,
            wrap: re,
            children: /* @__PURE__ */ e.jsxs(
              "button",
              {
                type: "button",
                className: "cta flex dc__gap-8 dc__no-text-transform h-36 dc__no-svg-fill",
                onClick: y,
                disabled: !!ae,
                "data-testid": "open-request-promotion-overlay",
                children: [
                  /* @__PURE__ */ e.jsx(dd, { className: "icon-dim-16 scn-0" }),
                  me.REQUEST_PROMOTION_CTA.OPEN_OVERLAY
                ]
              }
            )
          }
        ) : /* @__PURE__ */ e.jsx(
          g1,
          {
            selectedMaterial: H,
            handleClose: M,
            loadingIsNotificationConfigured: c,
            isNotificationConfigured: d,
            handleRefresh: U
          }
        ) })
      ]
    }
  ) });
}, kG = ({ onClick: t, dataTestId: s }) => /* @__PURE__ */ e.jsx(
  j,
  {
    dataTestId: `add-webhook-image-${s}`,
    variant: w.secondary,
    style: B.neutral,
    size: O.medium,
    text: "Add Image",
    onClick: t,
    fullWidth: !0
  }
), E1 = async (t, s) => {
  const n = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Credentials": "true",
      "api-token": Ym(Hm)
    },
    body: JSON.stringify(s),
    credentials: "include"
  }, a = await fetch(t, n), r = await a.json();
  if (r?.code !== Ns.OK)
    throw new Ua({ code: r.code, errors: r.errors });
  return a;
}, C1 = "Add image (External)", b1 = "You can use this to deploy a new image through this workflow", N1 = "object", T1 = ["dockerImage"], I1 = { dockerImage: { type: "string", title: "External Image", description: "Deploy an image from an external container registry. Ex: docker.io/username/repo:v1.0.0" }, digest: { type: "string", title: "Image Digest", description: "Image digest values are used to create immutable addresses for container images. Ex: sha256:a3d96b9a5b5a01da9c38446ef2807a2f3109492d792424674bca180edd33e3a2" }, ciProjectDetails: { type: "array", title: "Commit Details", description: "Add commit details with which this image was built", items: { type: "object", properties: { commitHash: { type: "string", title: "Commit Hash", description: "Add your commit hash" }, message: { type: "string", title: "Add your commit message", description: "Add your commit message if available" }, author: { type: "string", title: "Commit Author", description: "Add the author of this commit" }, commitTime: { type: "string", title: "Commit Time", description: "Add the commited timestamp" } } } } }, v1 = {
  title: C1,
  description: b1,
  type: N1,
  required: T1,
  properties: I1
}, FG = ({ onClose: t, getWebhookDetails: s }) => {
  const [n, a] = v({}), [r, o] = v(!1), i = de(null), [l, c, d, p] = ne(
    s,
    []
  ), m = (f) => {
    a(f.formData);
  }, u = async () => {
    if (!(!i.current?.validateForm || i.current.validateForm())) {
      Z.showToast({
        variant: ee.error,
        description: "Some required fields are missing"
      });
      return;
    }
    o(!0);
    try {
      await E1(c.result.webhookUrl, n), t(), Z.showToast({
        variant: ee.success,
        description: "Image is added"
      });
    } catch (_) {
      V(_);
    } finally {
      o(!1);
    }
  };
  return /* @__PURE__ */ e.jsx(cs, { onEscape: t, close: t, children: /* @__PURE__ */ e.jsxs("div", { className: "bg__primary w-600 mxh-600 dc__m-auto mt-40 flexbox-col br-8", onClick: Le, children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space border__secondary--bottom px-20 pt-16 pb-15", children: [
      /* @__PURE__ */ e.jsx("h2", { className: "m-0 fs-16 lh-20 fw-6", children: "Add image (External)" }),
      /* @__PURE__ */ e.jsx(
        j,
        {
          icon: /* @__PURE__ */ e.jsx(W, { name: "ic-close-small", color: null }),
          dataTestId: "webhook-add-image-modal-close",
          ariaLabel: "webhook-add-image-modal-close",
          variant: w.borderLess,
          style: B.negativeGrey,
          size: O.xs,
          showAriaLabelInTippy: !1,
          onClick: t
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs(
      Ke,
      {
        isLoading: l,
        error: d,
        errorScreenManagerProps: { code: d?.code, reload: p },
        customLoader: /* @__PURE__ */ e.jsx("div", { className: "mh-300 flex", children: /* @__PURE__ */ e.jsx(Je, { pageLoader: !0 }) }),
        children: [
          /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1 dc__overflow-auto", children: /* @__PURE__ */ e.jsx(
            la,
            {
              ref: i,
              schema: v1,
              formData: n,
              onChange: m,
              uiSchema: Fa,
              liveValidate: !0
            }
          ) }),
          /* @__PURE__ */ e.jsxs("div", { className: "flex right dc__gap-12 border__secondary--top px-20 pt-15 pb-16", children: [
            /* @__PURE__ */ e.jsx(
              j,
              {
                dataTestId: "webhook-add-image-modal-cancel",
                variant: w.secondary,
                style: B.neutral,
                size: O.medium,
                onClick: t,
                text: "Cancel"
              }
            ),
            /* @__PURE__ */ e.jsx(
              j,
              {
                dataTestId: "webhook-add-image-modal-save",
                size: O.medium,
                isLoading: r,
                disabled: l,
                onClick: u,
                text: "Add Image"
              }
            )
          ] })
        ]
      }
    )
  ] }) });
}, A1 = ({
  baseURL: t,
  workflows: s,
  getModuleInfo: n,
  appName: a,
  reloadWorkflowStatus: r
}) => {
  const { useImageListType: o } = Ue();
  return o === ls.BULK_DEPLOY ? /* @__PURE__ */ e.jsx(
    d1,
    {
      workflows: s,
      baseURL: t,
      getModuleInfo: n,
      appName: a,
      reloadWorkflowStatus: r
    }
  ) : /* @__PURE__ */ e.jsx(x1, { workflows: s, baseURL: t, getModuleInfo: n });
}, UG = ({ basePath: t, ...s }) => /* @__PURE__ */ e.jsx(Vt, { children: /* @__PURE__ */ e.jsx(ge, { path: `${t}/${qd}`, exact: !0, children: /* @__PURE__ */ e.jsx(A1, { ...s }) }) }), GG = ({ installedAppVersionHistoryId: t }) => {
  const [s, n, a, r] = ne(
    () => XC({ installedAppVersionHistoryId: t }),
    [t]
  );
  return s ? /* @__PURE__ */ e.jsx(Je, { pageLoader: !0 }) : a ? /* @__PURE__ */ e.jsx(Xe, { code: a.code, reload: r }) : n.result.scanned ? /* @__PURE__ */ e.jsx("div", { className: "p-20 h-100 bg__primary", children: /* @__PURE__ */ e.jsx(JC, { scanResult: n?.result, Sidebar: Wd }) }) : /* @__PURE__ */ e.jsx(
    _e,
    {
      SvgImage: VN,
      title: a_.CI_DETAILS_IMAGE_NOT_SCANNED.TITLE
    }
  );
}, S1 = ({
  appDetails: t,
  appId: s,
  envId: n
}) => t.appType === ei.DEVTRON_APP ? {
  appIdentifier: `${t.clusterId}|${s}|${n}`,
  appType: Vo.DEVTRON_APP
} : t.appType === ei.EXTERNAL_ARGO_APP ? { appIdentifier: `${t.clusterId}`, appType: Vo.EXTERNAL_ARGO_APP } : t.appType === ei.EXTERNAL_FLUX_APP ? {
  appIdentifier: `${t.clusterId}|${t.namespace}|${t.appName}|${t.fluxTemplateType === "Kustomization"}`,
  appType: Vo.EXTERNAL_FLUX_APP
} : {
  appIdentifier: `${t.clusterId}|${t.namespace}|${t.appName}`,
  appType: Vo.HELM_APP
}, y1 = (t, s) => t ? s || null : "Please enter a file path", L1 = ({
  handleClose: t,
  appDetails: s,
  isResourceBrowserView: n,
  isClusterTerminalView: a,
  containerName: r,
  clusterViewPodName: o
}) => {
  const {
    appId: i,
    envId: l,
    clusterId: c,
    namespace: d,
    podName: p,
    name: m
  } = Ue(), u = Gc(), [f, _] = v(""), [h, x] = v(""), { handleDownload: g, isDownloading: E } = o_(), C = () => {
    if (n) {
      const P = `${$.K8S_DOWNLOAD_POD_CONTENT}/${c}/${d}/${m}/${r}`;
      return ye(P, {
        path: f
      });
    }
    if (a) {
      const { namespace: P } = u.searchParams, U = `${$.K8S_DOWNLOAD_POD_CONTENT}/${c}/${P}/${o}/${r}`;
      return ye(U, {
        path: f
      });
    }
    const { appIdentifier: A, appType: S } = S1({ appDetails: s, appId: i, envId: l }), L = s.resourceTree?.nodes?.find((P) => P.name === p)?.namespace, R = s.appType === ei.EXTERNAL_ARGO_APP, y = `${$.K8S_DOWNLOAD_POD_CONTENT}/${A}/${L}/${p}/${r}`, M = {
      path: f,
      appType: S,
      ...R && { externalArgoApplicationName: s.appName }
    };
    return ye(y, M);
  }, b = (A) => A ? A[0] !== "/" ? (x("File path must start with /"), !1) : (x(""), !0) : (x("You must provide a valid file path."), !1), N = (A) => {
    const S = A.target.value;
    _(S), b(S);
  }, I = y1(f, h), T = async () => {
    if (I)
      return;
    const A = C();
    await g({ downloadUrl: A, showFilePreparingToast: !0 }), t();
  };
  return /* @__PURE__ */ e.jsx(wi, { className: "visible-modal__body", close: t, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "flexbox-col bg__primary w-500 dc__m-auto mt-40 dc__border-radius-8-imp dc__overflow-hidden",
      onClick: Le,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__content-space py-12 px-20 dc__border-bottom", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-12", children: [
            /* @__PURE__ */ e.jsx(L_, { className: "icon-dim-20 dc__no-shrink" }),
            /* @__PURE__ */ e.jsx("span", { className: "fs-16 fw-6 lh-24 dc__content-space", children: "Download file/folder" })
          ] }),
          /* @__PURE__ */ e.jsx(
            "button",
            {
              type: "button",
              className: "dc__transparent p-0-imp h-20",
              onClick: t,
              "aria-label": "close-button",
              children: /* @__PURE__ */ e.jsx(vt, { className: "icon-dim-20 dc__no-shrink" })
            }
          )
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "px-20 py-16 h-200", children: /* @__PURE__ */ e.jsx(
          yt,
          {
            name: "file-path",
            value: f,
            onChange: N,
            label: "File Path",
            required: !0,
            error: h,
            placeholder: "/home/dir/filename.txt",
            disabled: E,
            helperText: "Please provide absolute file path"
          }
        ) }),
        /* @__PURE__ */ e.jsxs("div", { className: "px-20 py-16 flexbox dc__align-item-center flex-justify-end dc__gap-12", children: [
          /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: "cancel-download",
              text: "Close",
              variant: w.secondary,
              style: B.neutral,
              onClick: t
            }
          ),
          /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: "download-content",
              text: "Download",
              isLoading: E,
              disabled: !!I,
              onClick: T,
              showTooltip: !!I,
              tooltipProps: {
                content: I
              }
            }
          ) })
        ] })
      ]
    }
  ) });
}, BG = (t) => {
  const [s, n] = v(!1), a = () => {
    n(!0), ct.event({
      category: "Terminal",
      action: "Download File"
    });
  }, r = () => {
    n(!1);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("span", { className: "dc__border-right h-16" }),
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "download-file-folder",
        onClick: a,
        text: "Download file/folder",
        variant: w.text,
        size: O.small,
        startIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-arrow-right", color: null, rotateBy: 90 })
      }
    ),
    s && /* @__PURE__ */ e.jsx(L1, { ...t, handleClose: r })
  ] });
}, j1 = ({
  ttl: t,
  isTrial: s,
  licenseStatus: n,
  isFreemium: a
}) => {
  if (a)
    return null;
  if (n === Ep.EXPIRED)
    return {
      message: "You’re using unlicensed version of Devtron",
      iconName: "ic-error",
      type: Wr.ERROR
    };
  const r = QC(t);
  return n === Ep.REMINDER_THRESHOLD_REACHED ? {
    message: `Your enterprise license expires in ${r}.`,
    iconName: "ic-warning",
    type: Wr.WARNING
  } : s ? {
    message: `Your trial license will expire in ${r}.`,
    iconName: "ic-calendar",
    type: Wr.INFORMATION
  } : null;
}, $G = () => {
  const { handleOpenLicenseInfoDialog: t, licenseData: s, setLicenseData: n } = Is(), [, a] = ne(Z_, []);
  if (J(() => {
    a && a.showLicenseData && n(a);
  }, [a]), !s || s.licenseStatusError)
    return null;
  const { ttl: r, licenseStatus: o, isTrial: i, isFreemium: l } = s, c = j1({ ttl: r, licenseStatus: o, isTrial: i, isFreemium: l });
  if (!c)
    return null;
  const d = () => {
    t(Jn.LICENSE);
  }, { message: p, type: m, iconName: u } = c;
  return { message: p, type: m, iconName: u, handleOpenLicenseDialog: d };
}, Ig = "draggable-ai-widget", O1 = "Do not ask any follow up questions.", R1 = async (t, s, n) => {
  const a = {
    clusterId: t.toString(),
    ask: `${s} ${O1} `
  };
  return (await we($.INTELLIGENCE, a, { signal: n })).result;
}, P1 = () => {
  const t = de(new AbortController()), { intelligenceConfig: s, setIntelligenceConfig: n } = Is(), [a, r] = v(""), o = Object.keys(s.metadata), i = a === "loading", l = a === "submitted", c = () => {
    n(null), t.current.abort();
  }, [d, p, m, u] = ne(
    () => es(
      () => R1(
        s.clusterId,
        s.prompt,
        t.current.signal
      ),
      t
    ),
    [s]
  ), f = d || Pe(m), _ = (b) => {
    r("loading"), ct.event({
      category: "AI Integration Feedback",
      action: `${s.analyticsCategory}_${b}`
    }), setTimeout(() => {
      r("submitted");
    }, 1e3);
  }, h = () => _("UPVOTE"), x = () => _("DOWNVOTE"), g = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "open-ai-integration-ticket",
        size: O.medium,
        component: Re.anchor,
        text: "Open Ticket",
        anchorProps: {
          href: eb
        }
      }
    ),
    /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "contact-support",
        component: Re.anchor,
        text: "Contact Support",
        anchorProps: {
          href: i_
        },
        variant: w.text
      }
    )
  ] }), E = () => m.code === Ns.UNPROCESSABLE_ENTITY ? /* @__PURE__ */ e.jsx(
    _e,
    {
      title: "AI Integration not configured",
      subTitle: "For AI-powered insights on this cluster, please follow this documentation or contact the Devtron team.",
      SvgImage: HN,
      imageType: bs.Medium,
      isButtonAvailable: !0,
      renderButton: g
    }
  ) : /* @__PURE__ */ e.jsx(
    Xe,
    {
      imageType: bs.Medium,
      code: m.code,
      reload: u
    }
  ), C = () => f ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
    /* @__PURE__ */ e.jsx("span", { className: "w-250 purple-shimmer-loading" }),
    /* @__PURE__ */ e.jsx("span", { className: "w-150 purple-shimmer-loading" }),
    /* @__PURE__ */ e.jsx("span", { className: "w-200 purple-shimmer-loading" }),
    /* @__PURE__ */ e.jsx("span", { className: "w-100px purple-shimmer-loading" })
  ] }) : /* @__PURE__ */ e.jsx(
    Cm,
    {
      markdown: p,
      className: "fs-13 fw-4 lh-20 cn-9 p-0 m-0 dc__no-border bg__overlay--primary dc__word-break dc__text-wrap dc__open-sans p-0-imp"
    }
  );
  return /* @__PURE__ */ e.jsx("div", { className: "events-ai-widget br-14 p-2", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col br-12 w-400 dc__h-fit-content bg__overlay--primary h-500", children: [
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: `${Ig} flexbox dc__content-space p-16 dc__align-items-center dc__grabbable dc__border-bottom`,
        children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__align-items-center", children: [
            /* @__PURE__ */ e.jsx(YN, { className: "icon-dim-20" }),
            /* @__PURE__ */ e.jsx("span", { className: "fs-14 cn-9 lh-20 fw-6", children: "AI Analysis" })
          ] }),
          /* @__PURE__ */ e.jsx(
            j,
            {
              ariaLabel: "events-ai-drawer-close",
              dataTestId: "events-ai-drawer-close",
              icon: /* @__PURE__ */ e.jsx(As, { className: ZC }),
              variant: w.borderLess,
              size: O.xs,
              style: B.negativeGrey,
              onClick: c,
              showAriaLabelInTippy: !1
            }
          )
        ]
      }
    ),
    !f && m ? E() : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsxs("div", { className: "p-16 flexbox-col dc__gap-16 dc__overflow-auto flex-grow-1", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-6 dc__align-items-center", children: [
            /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-6 lh-20", children: f ? "Analyzing" : "Summary" }),
            /* @__PURE__ */ e.jsx(W, { name: "ic-sparkle-ai-color", color: null })
          ] }),
          C()
        ] }),
        o.length && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom" }),
          /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-8 fs-13 fw-4 lh-20", children: o.map((b) => {
            const N = s.metadata[b];
            return N ? /* @__PURE__ */ e.jsxs("div", { className: "event-metadata", children: [
              /* @__PURE__ */ e.jsx("span", { className: "cn-7 dc__capitalize", children: b.replace(/([a-z])([A-Z])/g, "$1 $2") }),
              /* @__PURE__ */ e.jsx("span", { className: "cn-9 dc__word-break-all", children: N })
            ] }) : null;
          }) })
        ] })
      ] }),
      !(f || m) && /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: `${l ? "flex" : "flexbox dc__content-space dc__align-items-center"}  px-16 py-8 border__secondary--top`,
          children: [
            /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-1-5 cn-7", children: l ? "Thanks for your feedback!" : "Was this insight helpful?" }),
            !l && /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-4", children: [
              /* @__PURE__ */ e.jsx(
                j,
                {
                  dataTestId: "upvote-insight",
                  icon: /* @__PURE__ */ e.jsx(W, { name: "ic-thumb-up", color: null }),
                  ariaLabel: "helpful event",
                  showAriaLabelInTippy: !1,
                  variant: w.borderLess,
                  style: B.positive,
                  size: O.small,
                  onClick: h,
                  disabled: i
                }
              ),
              /* @__PURE__ */ e.jsx(
                j,
                {
                  dataTestId: "downvote-insight",
                  icon: /* @__PURE__ */ e.jsx(W, { name: "ic-thumb-down", color: null }),
                  ariaLabel: "not helpful event",
                  showAriaLabelInTippy: !1,
                  variant: w.borderLess,
                  style: B.negative,
                  size: O.small,
                  onClick: x,
                  disabled: i
                }
              )
            ] })
          ]
        }
      )
    ] })
  ] }) });
}, VG = ({ parentRef: t }) => /* @__PURE__ */ e.jsx(
  No,
  {
    parentRef: t,
    dragSelector: `.${Ig}`,
    positionVariant: To.SCREEN_BOTTOM_RIGHT,
    zIndex: 30,
    children: /* @__PURE__ */ e.jsx(P1, {})
  }
), YG = ({ intelligenceConfig: t, isIconButton: s = !1 }) => {
  const { setIntelligenceConfig: n } = Is(), a = (r) => {
    r?.stopPropagation(), n(t), ct.event({
      category: "Explain AI Button",
      action: `${t.analyticsCategory}_EXPLAIN`
    });
  };
  return /* @__PURE__ */ e.jsx("div", { className: "explain-ai-button", children: /* @__PURE__ */ e.jsx(
    j,
    {
      dataTestId: "ai-explain-button",
      size: O.medium,
      onClick: a,
      ...s ? {
        variant: w.borderLess,
        icon: /* @__PURE__ */ e.jsx(W, { name: "ic-sparkle-ai-color", color: null }),
        ariaLabel: "Explain with AI",
        style: B.neutral
      } : {
        text: "Explain",
        variant: w.text,
        startIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-sparkle-ai-color", color: null })
      }
    }
  ) });
}, w1 = [
  { label: "About", value: Jn.ABOUT },
  { label: "License", value: Jn.LICENSE }
], D1 = ({ handleUpdateLicenseClick: t, licenseData: s }) => {
  const { enterpriseName: n, licenseSuffix: a, expiryDate: r, isTrial: o, licenseStatus: i, ttl: l, isFreemium: c, licenseStatusError: d } = s, { appTheme: p } = tb();
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-20", children: [
    /* @__PURE__ */ e.jsx(
      sb,
      {
        enterpriseName: n,
        licenseSuffix: a,
        ttl: l,
        licenseStatus: i,
        isTrial: o,
        expiryDate: r,
        appTheme: p,
        isFreemium: c,
        licenseStatusError: d,
        isSaasInstance: s?.isSaasInstance
      }
    ),
    /* @__PURE__ */ e.jsx(nb, { fingerprint: s?.fingerprint, showHelpTooltip: !0 }),
    /* @__PURE__ */ e.jsx("div", { className: "border__secondary--bottom h-1" }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space", children: [
        /* @__PURE__ */ e.jsx("span", { className: "fs-13", children: "Have a new license?" }),
        /* @__PURE__ */ e.jsx(
          j,
          {
            dataTestId: "update-license",
            text: "Update license",
            variant: w.text,
            onClick: t
          }
        )
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space", children: [
        /* @__PURE__ */ e.jsx("span", { className: "fs-13", children: "Need help?" }),
        /* @__PURE__ */ e.jsx(
          j,
          {
            dataTestId: "contact-support",
            text: "Contact Support",
            variant: w.text,
            component: Re.anchor,
            anchorProps: {
              href: i_
            }
          }
        )
      ] })
    ] })
  ] });
}, M1 = ({
  dialogType: t,
  licenseData: s,
  handleChangeDialogType: n,
  handleUpdateLicenseClick: a,
  handleCloseLicenseInfoDialog: r,
  isLoading: o,
  licenseDataError: i,
  reloadLicenseData: l
}) => {
  const c = () => o ? /* @__PURE__ */ e.jsx(rb, { parentClasses: "flex h-200", classes: "icon-dim-48" }) : i ? /* @__PURE__ */ e.jsx(ps, { rootClassName: "h-200", reload: l }) : /* @__PURE__ */ e.jsx(D1, { licenseData: s, handleUpdateLicenseClick: a });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: "px-24 pt-24 pb-8", children: /* @__PURE__ */ e.jsx(
      Qs,
      {
        name: "about-devtron-segmented-control",
        segments: w1,
        value: t,
        onChange: n,
        fullWidth: !0
      }
    ) }),
    /* @__PURE__ */ e.jsx("div", { className: "p-24 mxh-500 dc__overflow-auto", children: t === Jn.ABOUT ? /* @__PURE__ */ e.jsx(ab, {}) : c() }),
    /* @__PURE__ */ e.jsx("div", { className: "flex px-24 py-20 dc__content-end", children: /* @__PURE__ */ e.jsx(
      j,
      {
        dataTestId: "license-info-okay",
        text: "Okay",
        size: O.medium,
        onClick: r
      }
    ) })
  ] });
}, HG = ({
  handleCloseLicenseInfoDialog: t,
  initialDialogType: s = Jn.ABOUT
}) => {
  const { setLicenseData: n } = Is(), [a, r] = v(s), o = (f) => {
    const _ = f.value;
    _ === Jn.LICENSE && ct.event({
      category: "about-devtron__license",
      action: "ABOUT_DEVTRON_LICENSE_TAB_CLICKED"
    }), r(_);
  }, i = () => {
    ct.event({
      category: "about-devtron__license",
      action: "ABOUT_DEVTRON_UPDATE_LICENSE_CLICKED"
    }), r(Jn.UPDATE);
  }, [l, c, d, p] = ne(Z_, []);
  J(() => {
    c && c.showLicenseData && n(c);
  }, [c]);
  const m = async () => {
    await p(), t();
  }, u = () => a === Jn.UPDATE ? /* @__PURE__ */ e.jsx(
    ob,
    {
      fingerprint: c.fingerprint,
      enterpriseName: c.enterpriseName,
      handleClose: t,
      handleLicenseActivateSuccess: m
    }
  ) : /* @__PURE__ */ e.jsx(
    M1,
    {
      dialogType: a,
      licenseData: c,
      handleChangeDialogType: o,
      handleUpdateLicenseClick: i,
      handleCloseLicenseInfoDialog: t,
      isLoading: l,
      licenseDataError: d,
      reloadLicenseData: p
    }
  );
  return /* @__PURE__ */ e.jsx(Mc, { onEscape: t, children: /* @__PURE__ */ e.jsx("div", { className: "flexbox-col w-400 br-12 bg__primary border__primary dc__m-auto mt-40", children: u() }) });
}, Ri = (t) => ({
  data: {
    categories: {
      value: t?.name || "",
      type: ut.TEXT,
      props: {
        placeholder: "Eg. staging"
      },
      disabled: !!t?.id,
      tooltip: t?.name ? {
        content: "Category name is unique and cannot be changed"
      } : null
    },
    description: {
      value: t?.description || "",
      type: ut.TEXT,
      props: {
        placeholder: "Enter description"
      }
    }
  },
  id: t?.id || Yt()
}), k1 = (t) => t?.length ? t.map(Ri) : [Ri()], F1 = (t) => (t || [])?.map((s) => ({
  label: s.name || "",
  value: s.id,
  description: s.description || ""
})), KG = (t) => ({
  category: t?.value ? {
    id: t.value,
    name: t.label
  } : {
    id: 0
  }
}), im = (t, s) => {
  const { categories: n, description: a } = t.data, r = n.value.trim(), o = a.value.trim();
  if (r) {
    const i = Tn(r);
    if (!i.isValid)
      return { isValid: !1, errorMessages: [i.message] };
    if (s?.filter(
      (c) => c.data.categories.value === t.data.categories.value && c.id !== t.id
    ).length)
      return { isValid: !1, errorMessages: ["Duplicate category name"] };
  } else if (o)
    return { isValid: !1, errorMessages: ["Category name is required"] };
  return { isValid: !0, errorMessages: [] };
}, lm = (t) => {
  const { description: s } = t.data, n = s.value.trim(), a = dn(n);
  return n && !a.isValid ? { isValid: !1, errorMessages: [a.message] } : { isValid: !0, errorMessages: [] };
}, vg = async () => {
  try {
    return (await le($.CLUSTER_CATEGORIES)).result?.categories || [];
  } catch (t) {
    throw V(t), t;
  }
}, U1 = async (t) => {
  try {
    const s = await we($.CLUSTER_CATEGORIES, t);
    return Z.showToast({
      variant: ee.success,
      description: "Category updated successfully"
    }), s.result;
  } catch (s) {
    throw V(s), s;
  }
}, G1 = async () => {
  const t = await vg();
  return k1(t);
}, WG = ({ selectedCategory: t, setSelectedCategory: s }) => {
  const [n, a, r, o] = ne(vg), i = (l) => {
    if (l?.value !== t?.value) {
      if (!l) {
        s(null);
        return;
      }
      s(l);
    }
  };
  return /* @__PURE__ */ e.jsx(
    Ve,
    {
      label: "Assign Category",
      inputId: "assign-category-menu-list",
      name: "assign-category-menu-list",
      classNamePrefix: "assign-category-menu-list",
      options: F1(a),
      onChange: i,
      value: t,
      size: O.medium,
      fullWidth: !0,
      isClearable: !!a?.length,
      isLoading: n,
      optionListError: r,
      reloadOptionList: o
    }
  );
}, B1 = [
  {
    label: "CATEGORIES",
    key: "categories",
    width: "250px"
  },
  {
    label: "DESCRIPTION",
    key: "description",
    width: "1fr"
  }
], $1 = () => {
  const { search: t } = Ss(), { searchKey: s, handleSearch: n, clearFilters: a } = vs(), [r, o, i, l, c] = ne(G1), [d, p] = v({}), [m, u] = v(!1), { push: f } = Te(), _ = s.toLowerCase(), h = o?.filter((R) => R.data.categories.value.toLowerCase().includes(_)), x = () => {
    f({ pathname: Ee.GLOBAL_CONFIG_CLUSTER, search: t });
  }, g = async () => {
    let R = !1;
    const y = structuredClone(d);
    if (o.forEach((U) => {
      const G = im(U, o), H = lm(U);
      y[U.id] = {
        categories: G,
        description: H
      }, (!G.isValid || !H.isValid) && (R = !0);
    }), p(y), R) {
      Z.showToast({
        variant: ee.error,
        description: "Please resolve errors and try again"
      });
      return;
    }
    const M = o.filter((U) => !!U.data.categories.value), P = M.length ? M.map((U) => ({
      id: +U.id,
      name: U.data.categories.value.trim(),
      description: U.data.description.value
    })) : [];
    u(!0);
    try {
      await U1({ categories: P }), x(), u(!1);
    } catch {
      u(!1);
    }
  }, E = (R, y, M) => {
    let P = null;
    const U = o.map((H) => H.id === R.id ? (P = {
      ...H,
      data: {
        ...H.data,
        [y]: {
          ...H.data[y],
          value: M
        }
      }
    }, P) : H), G = structuredClone(d);
    G[R.id] = {
      categories: im(P, U),
      description: lm(P)
    }, p(G), c(U);
  }, C = () => {
    const R = Ri();
    c([R, ...o]);
  }, b = (R) => {
    const y = o.filter(({ id: M }) => M !== R?.id);
    if (y.length === 0) {
      c([Ri()]);
      return;
    }
    c(y);
  }, N = () => /* @__PURE__ */ e.jsxs("header", { className: "px-20 py-12 lh-24 flexbox dc__content-space dc__align-items-center dc__border-bottom", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
      /* @__PURE__ */ e.jsx("h3", { className: "m-0 fs-16 fw-6 lh-1-43", children: "Cluster & Environment Categories" }),
      /* @__PURE__ */ e.jsx(
        ca,
        {
          heading: "Categories",
          infoText: "Create categories to organize your clusters and environments. Example: stage, qa, dev, etc.",
          iconClassName: "icon-dim-20 fcn-6"
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(
      j,
      {
        icon: /* @__PURE__ */ e.jsx(W, { name: "ic-close-large", color: null }),
        dataTestId: "close-create-cluster-modal-button",
        component: Re.button,
        style: B.negativeGrey,
        size: O.xs,
        variant: w.borderLess,
        ariaLabel: "Close new cluster drawer",
        onClick: x,
        showAriaLabelInTippy: !1
      }
    )
  ] }), I = () => !s && /* @__PURE__ */ e.jsx(
    j,
    {
      dataTestId: "add_categories_button",
      variant: w.secondary,
      component: Re.button,
      startIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-add", color: null }),
      size: O.medium,
      text: "Add Category",
      onClick: C
    }
  ), T = () => /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space px-20 py-12", children: [
    /* @__PURE__ */ e.jsx(
      Wt,
      {
        initialSearchText: s,
        containerClassName: "w-250",
        inputProps: {
          autoFocus: !0,
          placeholder: "Search categories"
        },
        handleEnter: n,
        dataTestId: "search-category-input"
      }
    ),
    I()
  ] }), A = () => /* @__PURE__ */ e.jsxs("div", { className: "flex right w-100 dc__gap-12 px-20 py-12 dc__border-top", children: [
    /* @__PURE__ */ e.jsx(
      j,
      {
        text: "Cancel",
        variant: w.secondary,
        style: B.neutral,
        dataTestId: "cancel-category-btn",
        onClick: x
      }
    ),
    /* @__PURE__ */ e.jsx(
      j,
      {
        text: o.length === 0 ? "Save" : "Update",
        dataTestId: "save-category-btn",
        isLoading: m,
        disabled: m,
        onClick: g,
        buttonProps: {
          type: "submit"
        }
      }
    )
  ] }), S = () => h.length ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto px-20 pb-12", children: /* @__PURE__ */ e.jsx(
      $i,
      {
        headers: B1,
        rows: h,
        onRowEdit: E,
        onRowDelete: b,
        onRowAdd: Be,
        isAdditionNotAllowed: !0,
        shouldAutoFocusOnMount: !0,
        cellError: d
      }
    ) }),
    A()
  ] }) : /* @__PURE__ */ e.jsx(qt, { handleClearFilters: a }), L = () => i ? /* @__PURE__ */ e.jsx(Xe, { code: i?.code, reload: l }) : r ? /* @__PURE__ */ e.jsx(Je, { pageLoader: !0 }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    T(),
    S()
  ] });
  return /* @__PURE__ */ e.jsx($t, { position: "right", width: "1024px", onEscape: x, onClose: x, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "bg__primary h-100 cn-9 w-100 flexbox-col dc__overflow-hidden p-0 create-cluster",
      onClick: Le,
      children: [
        N(),
        L()
      ]
    }
  ) });
}, qG = () => /* @__PURE__ */ e.jsx(ge, { path: Ee.GLOBAL_CONFIG_MANAGE_CATEGORIES, children: /* @__PURE__ */ e.jsx($1, {}) }), zG = ({ search: t }) => /* @__PURE__ */ e.jsx(
  j,
  {
    dataTestId: "manage_categories_button",
    linkProps: { to: { pathname: Ee.GLOBAL_CONFIG_MANAGE_CATEGORIES, search: t } },
    component: Re.link,
    startIcon: /* @__PURE__ */ e.jsx(W, { name: "ic-shapes", color: null }),
    size: O.medium,
    text: "Manage Categories",
    variant: w.secondary
  }
), V1 = {
  $schema: "http://json-schema.org/draft-07/schema#",
  type: "object",
  properties: {
    podGroups: {
      type: "array",
      title: "Pod Groups",
      description: "List of pod groups with their spread configuration",
      items: {
        type: "object",
        title: "Pod Group",
        properties: {
          name: {
            type: "string",
            title: "Pod Group Name",
            description: "Name of the pod group (can be any descriptive name)",
            minLength: 1
          },
          selector: {
            type: "object",
            title: "Pod Selector",
            description: "Label selector to identify pods in this group",
            additionalProperties: {
              type: "string"
            },
            minProperties: 1
          },
          baseValue: {
            type: "integer",
            title: "Base Value",
            description: "Base value for pod distribution calculation",
            minimum: 1,
            default: 1
          },
          onDemandWeight: {
            type: "integer",
            title: "On-Demand Weight (%)",
            description: "Percentage of pods to be placed on on-demand nodes",
            minimum: 0,
            maximum: 100,
            default: 80
          },
          spotWeight: {
            type: "integer",
            title: "Spot Weight (%)",
            description: "Percentage of pods to be placed on spot nodes",
            minimum: 0,
            maximum: 100,
            default: 20
          },
          onDemandNodeSelector: {
            type: "object",
            title: "On-Demand Node Selector",
            description: "Node selector for on-demand nodes",
            additionalProperties: {
              type: "string"
            }
          },
          spotNodeSelector: {
            type: "object",
            title: "Spot Node Selector",
            description: "Node selector for spot nodes",
            additionalProperties: {
              type: "string"
            }
          },
          onDemandTolerations: {
            type: "array",
            title: "On-Demand Tolerations",
            description: "Tolerations for on-demand nodes",
            items: {
              type: "object",
              title: "Toleration",
              properties: {
                key: {
                  type: "string",
                  title: "Key",
                  description: "Taint key to tolerate"
                },
                operator: {
                  type: "string",
                  title: "Operator",
                  description: "Operator for the toleration",
                  enum: ["Exists", "Equal"],
                  default: "Equal"
                },
                value: {
                  type: "string",
                  title: "Value",
                  description: "Value to match (when operator is Equal)"
                },
                effect: {
                  type: "string",
                  title: "Effect",
                  description: "Taint effect to tolerate",
                  enum: ["NoSchedule", "PreferNoSchedule", "NoExecute"],
                  default: "NoSchedule"
                }
              },
              required: ["key", "operator", "effect"],
              additionalProperties: !1
            }
          },
          spotTolerations: {
            type: "array",
            title: "Spot Tolerations",
            description: "Tolerations for spot nodes",
            items: {
              type: "object",
              title: "Toleration",
              properties: {
                key: {
                  type: "string",
                  title: "Key",
                  description: "Taint key to tolerate"
                },
                operator: {
                  type: "string",
                  title: "Operator",
                  description: "Operator for the toleration",
                  enum: ["Exists", "Equal"],
                  default: "Equal"
                },
                value: {
                  type: "string",
                  title: "Value",
                  description: "Value to match (when operator is Equal)"
                },
                effect: {
                  type: "string",
                  title: "Effect",
                  description: "Taint effect to tolerate",
                  enum: ["NoSchedule", "PreferNoSchedule", "NoExecute"],
                  default: "NoSchedule"
                }
              },
              required: ["key", "operator", "effect"],
              additionalProperties: !1
            }
          }
        },
        required: ["name", "selector", "baseValue", "onDemandWeight", "spotWeight"],
        additionalProperties: !1
      },
      minItems: 1
    }
  }
}, Ag = (t) => ({
  name: "pod-spread-webhook-config",
  namespace: "pod-spread-system",
  clusterId: +t,
  gvk: {
    Group: "",
    Kind: "ConfigMap",
    Version: "v1"
  }
}), Y1 = async (t, s) => {
  try {
    const n = Ag(t), r = (await Qi({
      ...n,
      abortControllerRef: s
    })).manifestResponse.manifest.data["config.yaml"];
    return r ? zs.parse(r) || {} : {};
  } catch {
    return {};
  }
}, H1 = async (t, s, n) => {
  const a = Ag(t), r = {
    apiVersion: "v1",
    kind: "ConfigMap",
    data: {
      "config.yaml": zs.stringify(s)
    },
    metadata: {
      name: a.name,
      namespace: a.namespace
    }
  };
  n ? await Zi({
    ...a,
    manifest: gt(r)
  }) : await xd({
    clusterId: +t,
    manifest: gt(r)
  }), Z.showToast({
    variant: ee.success,
    description: "Successfully applied pod spread configuration."
  });
}, XG = ({ clusterId: t, handleClose: s }) => {
  const n = de(null), a = de(new AbortController()), r = de(!1), o = async () => {
    const f = await Y1(t, a);
    return r.current = Object.keys(f || {}).length > 0, f;
  }, [i, l, , , c] = ne(
    o,
    [t],
    !!t
  ), [d, p] = v(!1);
  J(
    () => () => {
      a.current.abort();
    },
    []
  );
  const m = (f) => {
    c(f.formData);
  }, u = async () => {
    if (!(!n.current?.validateForm || n.current.validateForm())) {
      Z.showToast({
        variant: ee.error,
        description: "Validation failed for some input fields, please rectify and apply changes again."
      });
      return;
    }
    p(!0);
    try {
      await H1(t, l, r.current), p(!1), s();
    } catch (_) {
      V(_), p(!1);
    }
  };
  return /* @__PURE__ */ e.jsx($t, { position: "right", width: "1024px", onEscape: s, onClose: s, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "flexbox-col dc__content-space h-100 bg__modal--primary shadow__modal dc__overflow-auto",
      onClick: Le,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-auto flex-grow-1", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "px-20 py-12 flexbox dc__content-space dc__align-items-center border__primary--bottom", children: [
            /* @__PURE__ */ e.jsx("h2", { className: "m-0 fs-16 fw-6 lh-24 cn-9", children: "Apply Pod Spread" }),
            /* @__PURE__ */ e.jsx(
              j,
              {
                dataTestId: "header-close-button",
                ariaLabel: "Close",
                showAriaLabelInTippy: !1,
                onClick: s,
                variant: w.borderLess,
                style: B.negativeGrey,
                icon: /* @__PURE__ */ e.jsx(W, { name: "ic-close-large", color: null }),
                size: O.xs
              }
            )
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "flexbox flex-grow-1 dc__overflow-auto w-100", children: /* @__PURE__ */ e.jsx(
            Ke,
            {
              isLoading: i,
              progressingProps: {
                pageLoader: !0
              },
              children: /* @__PURE__ */ e.jsx(
                la,
                {
                  className: "w-100",
                  schema: V1,
                  formData: l,
                  onChange: m,
                  experimental_defaultFormStateBehavior: {
                    emptyObjectFields: "skipDefaults"
                  },
                  liveValidate: !0,
                  uiSchema: Fa,
                  ref: n
                }
              )
            }
          ) })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-end dc__gap-12 py-16 px-20 border__primary--top dc__no-shrink", children: [
          /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: "footer-cancel-button",
              variant: w.secondary,
              text: "Cancel",
              style: B.neutral,
              size: O.large,
              onClick: s
            }
          ),
          /* @__PURE__ */ e.jsx(
            j,
            {
              dataTestId: "footer-apply-button",
              variant: w.primary,
              size: O.large,
              text: "Apply Changes",
              disabled: i,
              isLoading: d,
              onClick: u
            }
          )
        ] })
      ]
    }
  ) });
};
var os = /* @__PURE__ */ ((t) => (t.KEY = "key", t.FORMAT = "format", t.VALUE = "value", t))(os || {}), ss = /* @__PURE__ */ ((t) => (t.ADD_ROW = "ADD_ROW", t.UPDATE_ROW = "UPDATE_ROW", t.DELETE_ROW = "DELETE_ROW", t.UPDATE_VALUE_COLUMN = "UPDATE_VALUE_COLUMN", t.UPLOAD_FILE_INFO = "UPLOAD_FILE_INFO", t))(ss || {});
const K1 = "Parameters (key:value) will be passed as environment variables", yc = [
  {
    key: os.KEY,
    label: "Key",
    width: "240px"
  },
  {
    key: os.FORMAT,
    label: "Type",
    width: "80px"
  },
  {
    key: os.VALUE,
    label: "Value",
    width: "1fr"
  }
], Pi = {
  KEY_REQUIRED: "Key is required",
  UNIQUE_KEY: "Keys must be unique"
}, cm = {
  VALUE_REQUIRED: "Value is required",
  VALUE_NOT_A_NUMBER: "Value is not a number"
}, Sg = ({ src: t, isPipelineVar: s, shouldShowInTooltip: n }) => /* @__PURE__ */ e.jsx(
  Ie,
  {
    alwaysShowTippyOnHover: s,
    content: /* @__PURE__ */ e.jsxs("div", { className: "fs-12 lh-18 flexbox-col dc__gap-2", children: [
      /* @__PURE__ */ e.jsx("p", { className: "m-0 fw-6", children: "Pipeline variable" }),
      /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "The variable value will be accessible across all tasks in this pipeline execution" })
    ] }),
    children: /* @__PURE__ */ e.jsx("div", { className: `h-100 flex top dc__no-shrink ${n ? "" : "py-8 pl-8"}`, children: /* @__PURE__ */ e.jsx(
      Bc,
      {
        imageProps: {
          src: typeof t == "string" ? t : "",
          className: "w-20 h-20 p-2",
          width: 20,
          height: 20,
          alt: "plugin-icon"
        },
        fallbackImage: t
      }
    ) })
  }
), W1 = ({
  stepType: t,
  pluginIcon: s,
  stepName: n,
  name: a,
  description: r
}) => /* @__PURE__ */ e.jsxs("div", { className: "fs-12 lh-18", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-6 px-10 py-8", children: [
    /* @__PURE__ */ e.jsx(Sg, { src: Xd(t, s), shouldShowInTooltip: !0 }),
    /* @__PURE__ */ e.jsx("p", { className: "m-0 fw-6", children: n })
  ] }),
  /* @__PURE__ */ e.jsx("div", { className: "w-100 h-1 bcn-6" }),
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-2 px-10 py-8", children: [
    /* @__PURE__ */ e.jsx("p", { className: "m-0 fw-6", children: a }),
    r && /* @__PURE__ */ e.jsx("p", { className: "m-0", children: r })
  ] })
] }), JG = (t) => ({
  runtimeParams: {
    runtimePluginVariables: t.filter(({ name: s }) => !!s).map(
      ({
        name: s,
        format: n,
        value: a,
        fileMountDir: r,
        fileReferenceId: o,
        variableStepScope: i,
        valueType: l,
        stepVariableId: c
      }) => ({
        variableStepScope: i,
        name: s.trim(),
        format: n,
        value: a.trim(),
        fileMountDir: r,
        fileReferenceId: o,
        valueType: l,
        stepVariableId: i !== Hs.GLOBAL ? c : null
      })
    )
  }
}), dm = () => Math.floor((/* @__PURE__ */ new Date()).valueOf() * Math.random()), q1 = ({
  format: t,
  defaultValue: s,
  valueConstraint: n,
  globalVariables: a,
  variableStepScope: r
}) => {
  const o = s ? [{ label: s, value: s }] : [], i = [], l = (n?.choices || []).map((p) => ({
    label: p,
    value: p
  }));
  t === En.BOOL && l.push(...cb), t === En.DATE && i.push(...db);
  const c = a.filter((p) => p.format === t);
  return r === Hs.GLOBAL || !o.length && !l.length && !i.length && !c.length ? [] : [
    {
      label: "Default value",
      options: o
    },
    {
      label: "Choices",
      options: l
    },
    {
      label: "Supported date formats",
      options: i
    },
    ...n?.blockCustomValue ? [] : [
      {
        label: "System variables",
        options: c
      }
    ]
  ];
}, zd = ({
  format: t,
  value: s,
  defaultValue: n,
  valueConstraint: a,
  valueType: r,
  globalVariables: o,
  variableStepScope: i
}) => {
  if (t === En.FILE)
    return {
      type: ut.FILE_UPLOAD,
      value: s,
      props: {
        fileTypes: a?.constraint?.fileProperty?.allowedExtensions || []
      }
    };
  const l = q1({
    defaultValue: n,
    format: t,
    valueConstraint: a,
    globalVariables: o,
    variableStepScope: i
  });
  if (l.length) {
    const c = r && r === Hs.GLOBAL;
    return {
      type: ut.SELECT_TEXT,
      value: s,
      props: {
        placeholder: "Enter value or variable",
        options: l,
        isCreatable: t !== En.BOOL && (!a?.choices?.length || !a.blockCustomValue),
        icon: s && c ? /* @__PURE__ */ e.jsx(lb, {}) : null
      }
    };
  }
  return {
    type: ut.TEXT,
    value: s,
    props: {
      placeholder: "Enter value or variable"
    }
  };
}, Xd = (t, s) => {
  switch (t) {
    case Cp.PLUGIN_REF:
      return s || /* @__PURE__ */ e.jsx(I_, { className: "icon-dim-20 p-2" });
    case Cp.INLINE:
      return /* @__PURE__ */ e.jsx(KN, { className: "icon-dim-20 p-2" });
    default:
      return /* @__PURE__ */ e.jsx(ed, { className: "icon-dim-20 p-2 scn-7" });
  }
}, Lc = (t, s) => ({
  data: {
    key: {
      value: "",
      type: ut.TEXT,
      props: {
        placeholder: "Enter key"
      }
    },
    format: {
      value: En.STRING,
      type: ut.TEXT,
      disabled: !0,
      props: {}
    },
    value: zd({
      format: En.STRING,
      value: "",
      defaultValue: "",
      valueConstraint: null,
      globalVariables: t,
      valueType: Hs.NEW,
      variableStepScope: Hs.GLOBAL
    })
  },
  id: s,
  customState: {
    valueType: Hs.NEW,
    fileReferenceId: null,
    pluginIcon: Xd(null, ""),
    valueConstraint: null,
    defaultValue: "",
    fileMountDir: "",
    variableStepScope: Hs.GLOBAL
  }
}), z1 = ({
  parameters: t,
  globalVariables: s
}) => t.length ? t.map(
  ({
    stepVariableId: n,
    name: a,
    description: r,
    isRequired: o,
    format: i,
    value: l,
    defaultValue: c,
    valueType: d,
    valueConstraint: p,
    fileReferenceId: m,
    fileMountDir: u,
    stepName: f,
    stepType: _,
    pluginIcon: h,
    variableStepScope: x
  }) => ({
    data: {
      key: {
        value: a,
        type: ut.TEXT,
        disabled: x !== Hs.GLOBAL,
        required: o,
        props: {
          placeholder: "Enter key"
        },
        tooltip: x !== Hs.GLOBAL ? {
          className: "no-content-padding",
          content: /* @__PURE__ */ e.jsx(
            W1,
            {
              name: a,
              stepName: f,
              stepType: _,
              description: r,
              pluginIcon: h
            }
          )
        } : null
      },
      format: {
        value: i,
        type: ut.TEXT,
        disabled: !0,
        props: {}
      },
      value: zd({
        format: i,
        value: l,
        defaultValue: c,
        valueConstraint: p,
        globalVariables: s,
        valueType: d,
        variableStepScope: x
      })
    },
    id: n,
    disableDelete: o,
    customState: {
      defaultValue: c,
      valueType: d ?? Hs.NEW,
      fileReferenceId: m,
      fileMountDir: u,
      pluginIcon: Xd(_, h),
      valueConstraint: p,
      variableStepScope: x
    }
  })
) : [Lc(s, 0)], X1 = ({
  runtimeParameters: t,
  runtimePluginVariables: s
}) => t.map(({ data: n, id: a, customState: r }) => {
  const o = s.find(({ stepVariableId: l }) => l === a);
  return {
    ...o,
    stepVariableId: o?.stepVariableId ?? +a,
    valueType: r.valueType,
    variableStepScope: r.variableStepScope,
    name: n.key.value,
    format: n.format.value,
    value: n.value.value,
    fileReferenceId: r.fileReferenceId
  };
}), yg = ({
  name: t,
  variableStepScope: s,
  format: n,
  stepName: a
}) => s ? `${t}-${n}-${s}-${a}` : `${t}-${n}`, J1 = (t, s, n) => t.reduce((r, o) => {
  const i = !o.data.key.disabled && (o.id === s ? n : o.data.key.value);
  return i && (r[i] = (r[i] || 0) + 1), r;
}, {}), pm = () => ({
  [os.KEY]: { isValid: !0, errorMessages: [] },
  [os.FORMAT]: { isValid: !0, errorMessages: [] },
  [os.VALUE]: { isValid: !0, errorMessages: [] }
}), um = ({
  rows: t,
  rowId: s,
  value: n,
  cellError: a
}) => {
  const r = a, o = J1(t, s, n);
  t.forEach(({ data: i, id: l }) => {
    const c = s === l ? n : i.key.value, d = r[l].key;
    d.isValid && o[c] > 1 ? r[l].key = {
      isValid: !1,
      errorMessages: [Pi.UNIQUE_KEY]
    } : o[c] < 2 && d.errorMessages[0] === Pi.UNIQUE_KEY && (r[l].key = {
      isValid: !0,
      errorMessages: []
    });
  });
}, Lg = ({
  runtimePluginVariable: t,
  key: s,
  keysFrequencyMap: n = {}
}) => {
  const { isRequired: a, name: r, value: o, format: i, variableStepScope: l, stepName: c } = t;
  if (s === os.KEY) {
    if (o && !r)
      return { isValid: !1, errorMessages: [Pi.KEY_REQUIRED] };
    if ((n[yg({ name: r, format: i, variableStepScope: l, stepName: c })] || 0) > 1)
      return { isValid: !1, errorMessages: [Pi.UNIQUE_KEY] };
  }
  if (s === os.VALUE) {
    if (a && !o)
      return {
        isValid: !1,
        errorMessages: [cm.VALUE_REQUIRED]
      };
    if (i === En.NUMBER && o && !ib.NUMBERS_WITH_SCOPE_VARIABLES.test(o))
      return {
        isValid: !1,
        errorMessages: [cm.VALUE_NOT_A_NUMBER]
      };
  }
  return { isValid: !0, errorMessages: [] };
}, QG = (t) => {
  const s = { isValid: !0, cellError: {} }, n = (t ?? []).reduce((r, o) => {
    const i = yg({
      name: o.name,
      format: o.format,
      variableStepScope: o.variableStepScope,
      stepName: o.stepName
    });
    return i && (r[i] = (r[i] || 0) + 1), r;
  }, {});
  let a = !0;
  return s.cellError = (t ?? []).reduce((r, o) => (r[o.stepVariableId] = yc.reduce((i, { key: l }) => {
    const c = Lg({
      runtimePluginVariable: o,
      key: l,
      keysFrequencyMap: n
    });
    return a = a && c.isValid, { ...i, [l]: c };
  }, {}), r), {}), s.isValid = a, s;
}, $l = ({
  key: t,
  row: { data: s },
  value: n
}) => {
  const a = n ?? s[t].value, r = s.key.required;
  return Lg({
    key: t,
    runtimePluginVariable: {
      isRequired: r,
      name: t === os.KEY ? a : s.key.value,
      value: t === os.VALUE ? a : s.value.value,
      format: s.format.value
    }
  });
}, mm = (t) => Object.values(t).reduce((s, n) => s && !Object.values(n).some((a) => !a.isValid), !0), ZG = ({
  appId: t,
  heading: s,
  parameters: n,
  handleChange: a,
  errorState: r = { cellError: {}, isValid: !0 },
  handleError: o,
  uploadFile: i,
  isCD: l = !1,
  hideHeading: c = !1
}) => {
  const { cellError: d } = r, p = de(new AbortController()), [m, u, f, _] = ne(
    () => es(() => pb({ appId: t, isCD: l, abortControllerRef: p }), p),
    [t, l]
  );
  J(
    () => () => {
      p.current.abort();
    },
    []
  );
  const h = Q(() => m ? [] : z1({
    parameters: n,
    globalVariables: u || []
  }), [m, u, n]);
  J(() => {
    const T = (n ?? []).reduce((A, S) => (A[S.stepVariableId] || (A[S.stepVariableId] = yc.reduce(
      (L, { key: R }) => ({ ...L, [R]: { isValid: !0, errorMessages: [] } }),
      {}
    )), A), d);
    (n ?? []).length || (T[0] = pm()), o?.({ isValid: mm(T), cellError: T });
  }, []);
  const x = (T) => {
    a(
      X1({
        runtimeParameters: T,
        runtimePluginVariables: n
      })
    );
  }, g = (T) => {
    const { actionType: A } = T;
    let S = h;
    const L = h.findIndex((M) => M.id === T.rowId), R = h[L], y = structuredClone(d);
    switch (A) {
      case ss.ADD_ROW:
        S = [Lc(u || [], T.rowId), ...S], y[T.rowId] = pm();
        break;
      case ss.UPDATE_ROW:
        if (R) {
          const { id: M } = R;
          y[M][T.headerKey] = $l({
            key: T.headerKey,
            value: T.actionValue,
            row: R
          }), T.headerKey === os.KEY && um({
            rows: h,
            cellError: y,
            rowId: T.rowId,
            value: T.actionValue
          }), R.data[T.headerKey].value = T.actionValue;
        }
        break;
      case ss.DELETE_ROW:
        if (S = S.filter((M) => M.id !== T.rowId), delete y[T.rowId], um({ rows: S, cellError: y }), S.length === 0) {
          const M = Lc(u || [], dm());
          S.push(M), y[M.id] = {};
        }
        break;
      case ss.UPDATE_VALUE_COLUMN:
        if (R) {
          const { id: M, data: P, customState: U } = R, H = T.actionValue.value && P.format.value === En.DATE ? mb(T.actionValue.selectedValue.value) : T.actionValue.value;
          y[M].value = $l({
            key: os.VALUE,
            value: H,
            row: R
          }), R.data.value = zd({
            format: P.format.value,
            globalVariables: u || [],
            value: H,
            defaultValue: U.defaultValue,
            valueConstraint: U.valueConstraint,
            valueType: T.actionValue.selectedValue?.variableType ?? Hs.NEW,
            variableStepScope: U.variableStepScope
          }), R.customState.valueType = T.actionValue.selectedValue?.variableType ?? Hs.NEW;
        }
        break;
      case ss.UPLOAD_FILE_INFO:
        if (R && R.data.value.type === ut.FILE_UPLOAD) {
          const { id: M } = R;
          y[M].value = $l({
            key: os.VALUE,
            value: T.actionValue.fileName,
            row: R
          }), R.data.value.value = T.actionValue.fileName, R.data.value.props.isLoading = T.actionValue.isLoading, R.customState.fileReferenceId = T.actionValue.fileReferenceId;
        }
        break;
    }
    A !== ss.ADD_ROW && A !== ss.DELETE_ROW && L > -1 && (S[L] = R), x(S), o?.({
      isValid: mm(y),
      cellError: y
    });
  }, E = () => {
    g({
      actionType: ss.ADD_ROW,
      rowId: dm()
    });
  }, C = async (T, A, S, { files: L, selectedValue: R }) => {
    if (A === os.VALUE && T.data.value.type === ut.SELECT_TEXT)
      g({
        actionType: ss.UPDATE_VALUE_COLUMN,
        rowId: T.id,
        actionValue: {
          value: S,
          selectedValue: R
        }
      });
    else if (A === os.VALUE && T.data.format.value === En.FILE) {
      if (g({
        actionType: ss.UPLOAD_FILE_INFO,
        rowId: T.id,
        actionValue: { fileReferenceId: null, isLoading: !1, fileName: S }
      }), L.length)
        try {
          g({
            actionType: ss.UPLOAD_FILE_INFO,
            rowId: T.id,
            actionValue: { fileReferenceId: null, isLoading: !0, fileName: S }
          });
          const { id: y } = await i({ file: L });
          g({
            actionType: ss.UPLOAD_FILE_INFO,
            rowId: T.id,
            actionValue: { fileReferenceId: y, isLoading: !1, fileName: S }
          });
        } catch {
          g({
            actionType: ss.UPLOAD_FILE_INFO,
            rowId: T.id,
            actionValue: { fileReferenceId: null, isLoading: !1, fileName: "" }
          });
        }
    } else
      g({
        actionType: ss.UPDATE_ROW,
        headerKey: A,
        rowId: T.id,
        actionValue: S
      });
  }, b = (T) => {
    g({ actionType: ss.DELETE_ROW, rowId: T.id });
  }, N = ({ customState: T, data: A }) => (
    // `isPipelineVar` - Indicates if the variable was added through the "Add" button.
    // Variables added this way will have editable keys, whereas variables from the API will have their keys disabled.
    /* @__PURE__ */ e.jsx(Sg, { isPipelineVar: !A.key.disabled, src: T.pluginIcon })
  ), I = (T) => T.data.format.value === En.FILE ? /* @__PURE__ */ e.jsx(ub, { fileMountDir: T.customState.fileMountDir }) : null;
  return m ? /* @__PURE__ */ e.jsx(Je, { size: 32 }) : f ? /* @__PURE__ */ e.jsx(Xe, { code: f.code, reload: _ }) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16", children: [
    !c && /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-4", children: [
      /* @__PURE__ */ e.jsx("h2", { className: "m-0 cn-9 fs-13 fw-6 lh-20", children: s || "Runtime Parameters" }),
      /* @__PURE__ */ e.jsx(Ie, { alwaysShowTippyOnHover: !0, content: K1, children: /* @__PURE__ */ e.jsx("div", { className: "icon-dim-20 flex dc__tab-focus", children: /* @__PURE__ */ e.jsx(Ya, { className: "icon-dim-20 dc__no-shrink" }) }) })
    ] }),
    /* @__PURE__ */ e.jsx(
      $i,
      {
        headers: yc,
        rows: h,
        onRowAdd: E,
        onRowDelete: b,
        onRowEdit: C,
        leadingCellIcon: {
          key: N
        },
        trailingCellIcon: {
          value: I
        },
        cellError: d
      }
    )
  ] });
}, eB = ({ tabs: t, initialTab: s, onChange: n }) => /* @__PURE__ */ e.jsx(Qs, { segments: t, value: s, onChange: n, name: "runtime-param-tabs", fullWidth: !0 }), tB = ({
  endTime: t,
  showClockIcon: s,
  reloadAfterTimeEnd: n,
  callbackAfterTimeEnd: a,
  rootClassName: r = "fs-12",
  isActive: o
}) => {
  const i = de(null), [l, c] = v(Mp(t));
  return J(
    () => (
      // Clean up function to clear the timeout when the component unmounts
      () => {
        i.current && clearTimeout(i.current);
      }
    ),
    []
  ), i.current = setTimeout(() => {
    c(Mp(t));
  }, 1e3), l ? /* @__PURE__ */ e.jsxs("div", { className: `${r} flex left dc__gap-4`, children: [
    /* @__PURE__ */ e.jsx("span", { children: o ? "Ends in" : "Starts in" }),
    /* @__PURE__ */ e.jsxs("span", { className: "flex fw-6", children: [
      s && /* @__PURE__ */ e.jsx(ld, { className: "mr-6 icon-dim-16 mw-16" }),
      /* @__PURE__ */ e.jsx("span", { children: l })
    ] })
  ] }) : o ? (n ? window.location.reload() : a && a(), null) : (i.current && clearTimeout(i.current), /* @__PURE__ */ e.jsx("span", { className: "fs-12 cn-9 fw-6", children: "Invalid Profile" }));
}, sB = ({ isManifestScanEnabled: t, handleToggleSecurityScan: s }) => {
  const n = () => /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsx("span", { className: "fw-6 lh-18", children: "Security scan" }),
    /* @__PURE__ */ e.jsxs("ul", { className: "m-0 pl-20", children: [
      /* @__PURE__ */ e.jsx("li", { children: "Scans image(s) in chart for vulnerabilities and license risks." }),
      /* @__PURE__ */ e.jsx("li", { children: "Scans generated Kubernetes manifests for misconfigurations and exposed secrets." })
    ] })
  ] }), a = () => /* @__PURE__ */ e.jsx(lt, { className: "default-tt", arrow: !1, placement: "top-end", content: n(), maxWidth: 200, children: /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20 dc__border-bottom-dashed--n3", children: "Security scan" }) });
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16", children: [
    /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom-n1" }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__align-items-center", children: [
      a(),
      /* @__PURE__ */ e.jsx(
        Gn,
        {
          name: "security-scan-toggle",
          ariaLabel: "Toggle security scan",
          onChange: s,
          isChecked: t
        }
      )
    ] })
  ] });
}, nB = ({ appId: t, stageType: s }) => {
  const n = () => /* @__PURE__ */ e.jsx(
    j,
    {
      dataTestId: "configure-mandatory-tags",
      component: Re.link,
      variant: w.secondary,
      style: B.default,
      text: "Configure mandatory tags",
      endIcon: /* @__PURE__ */ e.jsx(XN, {}),
      size: O.medium,
      linkProps: {
        to: `${se.APPLICATION_MANAGEMENT_APP}/${t}/${Ee.OVERVIEW}`
      }
    }
  );
  return /* @__PURE__ */ e.jsx(
    _e,
    {
      title: `${Jl(s)} trigger is blocked!`,
      subTitle: `Some mandatory tags are not configured for this application. Configure the tags to unblock ${Jl(s).toLowerCase()} trigger.`,
      SvgImage: JN,
      isButtonAvailable: !0,
      renderButton: n
    }
  );
}, aB = ({ stageType: t }) => {
  const s = Jl(t);
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4 dc__align-items-center", children: [
    /* @__PURE__ */ e.jsx(b_, { className: "icon-dim-12 dc__no-shrink" }),
    /* @__PURE__ */ e.jsxs("span", { className: "fs-12 fw-4 lh-16 cr-5", children: [
      s.substring(0, s.length - 4),
      " trigger is blocked!"
    ] })
  ] });
}, jg = async (t, s = !1) => await _b({
  path: "pipelineRBACViewSelectedTab",
  value: {
    pipelineRBACViewSelectedTab: t
  },
  shouldThrowError: s
}), rB = async (t) => {
  if (!t) {
    const s = window._env_.FEATURE_DEFAULT_AUTHENTICATED_VIEW_ENABLE ? Jr.ACCESS_ONLY : Jr.ALL_ENVIRONMENTS;
    await jg(s, !0);
    const n = await fb();
    if (!n)
      throw new Ua({
        code: Ns.NOT_FOUND,
        errors: []
      });
    return n;
  }
  return t;
}, Q1 = (t, s) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4 dc__align-items-center", children: [
  /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: t }),
  s && /* @__PURE__ */ e.jsx(Je, { size: 16 })
] }), oB = ({
  userPreferences: t,
  userPreferencesError: s,
  handleUpdatePipelineRBACViewSelectedTab: n
}) => {
  const { pipelineRBACViewSelectedTab: a } = t || {}, [r, o] = v(!1), i = [
    Jr.ALL_ENVIRONMENTS,
    Jr.ACCESS_ONLY
  ].map((d) => ({
    label: Q1(d, r && a !== d),
    value: d,
    tooltipProps: {
      content: d === Jr.ALL_ENVIRONMENTS ? "View all environments" : "View environments that I have access to"
    }
  })), l = () => s ? null : a, c = async (d) => {
    const p = d.value;
    if (a === p || r)
      return;
    o(!0);
    const m = await jg(p);
    o(!1), m && (n(p), window.location.reload());
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flex column left dc__gap-4 py-6 px-8", children: [
    /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-13 lh-1-5 fw-4 cn-9", children: "View environments" }),
    /* @__PURE__ */ e.jsx(
      Qs,
      {
        segments: i,
        value: l(),
        onChange: c,
        disabled: r,
        name: "Configure Pipeline RBAC",
        size: O.small
      }
    )
  ] });
};
function _m() {
  const [t, s, n] = ne(Q_), a = () => n ? null : t ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 mxh-210 bg__primary dc__no-border dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100 h-16" }),
    /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100 h-16" }),
    /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100 h-16" }),
    /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading w-100 h-16" })
  ] }) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__align-self-stretch", children: [
    /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-13 fw-6 lh-20 cn-9", children: "Possible filter criteria" }),
    s.map((o) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space", children: [
      /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-9 fs-13 fw-4 lh-20", children: o.label }),
      /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-5 fs-13 fw-4 lh-20", children: o.type })
    ] }, o.label))
  ] }), r = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col p-12 dc__gap-12 dc__align-self-stretch bg__primary", children: [
    /* @__PURE__ */ e.jsxs("p", { className: "cn-9 fs-13 fw-4 lh-20 m-0", children: [
      /* @__PURE__ */ e.jsx(
        $a,
        {
          docLinkKey: "CEL",
          text: "CEL expression",
          dataTestId: "learn-more-about-filters-link",
          openInNewTab: !0
        }
      ),
      " is used to define pass & fail filter conditions"
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "bcn-1 h-1 w-100" }),
    a()
  ] });
  return /* @__PURE__ */ e.jsx(ca, { heading: "Know more", additionalContent: r(), children: /* @__PURE__ */ e.jsxs(
    "button",
    {
      className: "h-20 fs-13 fw-4 lh-20 p-0 cb-5 dc__no-background dc__no-border dc__outline-none-imp flex dc__gap-4",
      type: "button",
      children: [
        /* @__PURE__ */ e.jsx(Ya, { className: "icon-dim-16 fcb-5" }),
        "Know more"
      ]
    }
  ) });
}
const Og = ({
  isFromBulkCD: t,
  resourceFilters: s,
  handleDisableFiltersView: n,
  // Only getting used to show header title
  envName: a,
  closeModal: r,
  showDisableFiltersButton: o = !0,
  deployedTime: i
}) => {
  const [l, c] = v(Vs.PASS), d = Q(() => {
    const h = [];
    return s && s.forEach((x) => {
      x.conditions.forEach((g) => {
        g.conditionType === l && h.push({ name: x.name, expression: g.expression });
      });
    }), h;
  }, [s, l]), p = (h) => {
    c(Number(h.value));
  }, m = (h) => /* @__PURE__ */ e.jsx("button", { type: "button", className: h, onClick: n, "aria-label": "Disable filters view", children: /* @__PURE__ */ e.jsx(QN, { className: "icon-dim-16 scn-6 m-0" }) }), u = () => t ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox p-16 bg__tertiary dc__content-space dc__align-self-stretch", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-12", children: [
      o && m(
        "bg__primary dc__outline-none-imp flex p-0 h-24 w-24 dc__border br-4 dc__hover-border-n300 dc__hover-n50"
      ),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
        /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-9 fs-14 fw-4 lh-24", children: gl.BULK_CD }),
        i && /* @__PURE__ */ e.jsxs("i", { className: "cn-6 fs-14 fw-4 lh-24", children: [
          "at the time image was deployed: ",
          i
        ] })
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(_m, {})
  ] }) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__align-items-center dc__align-self-stretch dc__border-bottom pt-12 pb-12 pl-20 pr-20 bg__primary", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__align-self-stretch dc__gap-16", children: [
      o && m("dc__no-background dc__no-border dc__outline-none-imp flex p-0"),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
        /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-9 fs-14 fw-4 lh-24", children: a ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          gl.CD,
          " ",
          /* @__PURE__ */ e.jsx("span", { className: "m-0 cn-9 fs-16 fw-7", children: a })
        ] }) : /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-9 fs-14 fw-4 lh-24", children: gl.BULK_CD }) }),
        i && /* @__PURE__ */ e.jsxs("i", { className: "cn-6 fs-13 fw-4 lh-24", children: [
          "at the time image was deployed: ",
          i
        ] })
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(
      "button",
      {
        type: "button",
        className: "dc__no-background dc__no-border dc__outline-none-imp flex p-0",
        onClick: r,
        "aria-label": "Close",
        children: /* @__PURE__ */ e.jsx(vt, { className: "icon-dim-20 fcn-6" })
      }
    )
  ] }), f = () => {
    switch (l) {
      case Vs.PASS:
        return "pass";
      case Vs.FAIL:
        return "fail";
      default:
        return "";
    }
  }, _ = () => d.length ? /* @__PURE__ */ e.jsx(e.Fragment, { children: d.map((h) => /* @__PURE__ */ e.jsx(wT, { name: h.name, expression: h.expression }, h.name)) }) : /* @__PURE__ */ e.jsx(qt, { title: `No ${f()} conditions are defined` });
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col h-100 dc__content-space", children: [
    u(),
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: `flexbox-col h-100 dc__align-self-stretch bg__tertiary ${t ? "pl-16 pr-16" : "pl-20 pr-20"}`,
        children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__content-space pt-14 pb-14 dc__align-self-stretch", children: [
            /* @__PURE__ */ e.jsx(
              Qs,
              {
                segments: PT,
                value: String(l),
                onChange: p,
                name: "applied-filters-segmented-control"
              }
            ),
            !t && /* @__PURE__ */ e.jsx(_m, {})
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "flexbox-col pt-0 pb-16 dc__gap-8 flex-grow-1 dc__align-self-stretch dc__overflow-auto", children: _() })
        ]
      }
    )
  ] });
}, iB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Og
}, Symbol.toStringTag, { value: "Module" }));
export {
  bI as $,
  yF as A,
  Xa as B,
  k0 as C,
  Ap as D,
  YG as E,
  Nc as F,
  oI as G,
  MF as H,
  LF as I,
  RR as J,
  iI as K,
  EF as L,
  PF as M,
  WF as N,
  GF as O,
  VF as P,
  $L as Q,
  $ as R,
  Wd as S,
  tB as T,
  Ee as U,
  BF as V,
  _h as W,
  YF as X,
  HF as Y,
  UF as Z,
  CI as _,
  cI as a,
  xF as a$,
  qF as a0,
  KF as a1,
  $F as a2,
  dF as a3,
  Qk as a4,
  iF as a5,
  cF as a6,
  oF as a7,
  e2 as a8,
  k_ as a9,
  mF as aA,
  vF as aB,
  AF as aC,
  _T as aD,
  pF as aE,
  uF as aF,
  SF as aG,
  KU as aH,
  bU as aI,
  n2 as aJ,
  r2 as aK,
  a2 as aL,
  WU as aM,
  Qi as aN,
  JF as aO,
  ww as aP,
  tg as aQ,
  eF as aR,
  hT as aS,
  RF as aT,
  wF as aU,
  ar as aV,
  DF as aW,
  fd as aX,
  hd as aY,
  Mp as aZ,
  kF as a_,
  ST as aa,
  AT as ab,
  BL as ac,
  QU as ad,
  yT as ae,
  LT as af,
  tc as ag,
  fj as ah,
  jT as ai,
  OT as aj,
  nF as ak,
  aF as al,
  rF as am,
  vT as an,
  mj as ao,
  s2 as ap,
  ZU as aq,
  lF as ar,
  ur as as,
  t2 as at,
  sF as au,
  z as av,
  Oe as aw,
  NI as ax,
  OF as ay,
  DT as az,
  WG as b,
  fG as b$,
  tF as b0,
  G2 as b1,
  $2 as b2,
  V2 as b3,
  Y2 as b4,
  c2 as b5,
  H2 as b6,
  bh as b7,
  rs as b8,
  n0 as b9,
  eG as bA,
  tG as bB,
  sG as bC,
  nG as bD,
  aG as bE,
  cG as bF,
  dG as bG,
  rG as bH,
  oG as bI,
  fi as bJ,
  y0 as bK,
  iG as bL,
  S0 as bM,
  tm as bN,
  lG as bO,
  L0 as bP,
  v0 as bQ,
  Kd as bR,
  fg as bS,
  uG as bT,
  mG as bU,
  _G as bV,
  EG as bW,
  CG as bX,
  hG as bY,
  gG as bZ,
  xG as b_,
  D_ as ba,
  bT as bb,
  NT as bc,
  vi as bd,
  qn as be,
  cg as bf,
  X2 as bg,
  J2 as bh,
  Q2 as bi,
  Z2 as bj,
  W2 as bk,
  z2 as bl,
  K2 as bm,
  a0 as bn,
  Vd as bo,
  bF as bp,
  NF as bq,
  sI as br,
  $_ as bs,
  TF as bt,
  rI as bu,
  IF as bv,
  iB as bw,
  B2 as bx,
  pG as by,
  gF as bz,
  fT as c,
  LU as c$,
  bG as c0,
  NG as c1,
  AG as c2,
  vG as c3,
  TG as c4,
  IG as c5,
  SG as c6,
  G0 as c7,
  Ed as c8,
  yG as c9,
  iU as cA,
  lU as cB,
  dU as cC,
  Ev as cD,
  CU as cE,
  NU as cF,
  TU as cG,
  IU as cH,
  vU as cI,
  AU as cJ,
  SU as cK,
  yU as cL,
  kU as cM,
  mU as cN,
  fU as cO,
  _U as cP,
  iv as cQ,
  hU as cR,
  uU as cS,
  gU as cT,
  pU as cU,
  xU as cV,
  rv as cW,
  af as cX,
  EU as cY,
  uo as cZ,
  Of as c_,
  LG as ca,
  jG as cb,
  OG as cc,
  RG as cd,
  Eg as ce,
  PG as cf,
  wG as cg,
  MG as ch,
  i1 as ci,
  kG as cj,
  FG as ck,
  UG as cl,
  DG as cm,
  dI as cn,
  V_ as co,
  FF as cp,
  QF as cq,
  ZF as cr,
  nU as cs,
  sU as ct,
  aU as cu,
  tU as cv,
  eU as cw,
  rU as cx,
  oU as cy,
  cU as cz,
  KG as d,
  Mw as d$,
  jU as d0,
  OU as d1,
  RU as d2,
  wU as d3,
  PU as d4,
  MU as d5,
  DU as d6,
  FU as d7,
  UU as d8,
  GU as d9,
  f2 as dA,
  x2 as dB,
  E2 as dC,
  C2 as dD,
  T2 as dE,
  FP as dF,
  Bu as dG,
  N2 as dH,
  eg as dI,
  VP as dJ,
  YP as dK,
  Vu as dL,
  Do as dM,
  Ma as dN,
  I2 as dO,
  S2 as dP,
  y2 as dQ,
  ng as dR,
  Rw as dS,
  L2 as dT,
  v2 as dU,
  Tw as dV,
  A2 as dW,
  j2 as dX,
  qh as dY,
  Hh as dZ,
  BR as d_,
  wy as da,
  BU as db,
  $U as dc,
  YU as dd,
  VU as de,
  HU as df,
  qU as dg,
  zU as dh,
  XU as di,
  JU as dj,
  i2 as dk,
  o2 as dl,
  l2 as dm,
  b2 as dn,
  P2 as dp,
  k2 as dq,
  F2 as dr,
  M2 as ds,
  GR as dt,
  rP as du,
  zh as dv,
  h2 as dw,
  g2 as dx,
  lP as dy,
  _2 as dz,
  jF as e,
  O2 as e0,
  R2 as e1,
  m2 as e2,
  $R as e3,
  VR as e4,
  ir as e5,
  YR as e6,
  yu as e7,
  HR as e8,
  Lu as e9,
  Q_ as eA,
  TI as eB,
  Z_ as eC,
  Zi as eD,
  xd as eE,
  gd as eF,
  J_ as eG,
  KR as ea,
  w2 as eb,
  D2 as ec,
  U2 as ed,
  _F as ee,
  fF as ef,
  hF as eg,
  GG as eh,
  BG as ei,
  $G as ej,
  VG as ek,
  HG as el,
  qG as em,
  zG as en,
  XG as eo,
  JG as ep,
  QG as eq,
  ZG as er,
  eB as es,
  sB as et,
  nB as eu,
  aB as ev,
  oB as ew,
  jg as ex,
  rB as ey,
  zF as ez,
  SR as f,
  q2 as g,
  Y as h,
  CF as i,
  Zk as j,
  d2 as k,
  Ji as l,
  u2 as m,
  Iu as n,
  Uh as o,
  yR as p,
  jR as q,
  p2 as r,
  FR as s,
  Vh as t,
  Yh as u,
  Su as v,
  XF as w,
  uT as x,
  M_ as y,
  Og as z
};
